/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 123);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(130);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(150)();
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(42);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(300);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(304);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(42);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(270);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(131);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translate__ = __webpack_require__(189);
/* unused harmony reexport translate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__I18n__ = __webpack_require__(84);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__I18n__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Interpolate__ = __webpack_require__(191);
/* unused harmony reexport Interpolate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Trans__ = __webpack_require__(192);
/* unused harmony reexport Trans */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__I18nextProvider__ = __webpack_require__(198);
/* unused harmony reexport I18nextProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loadNamespaces__ = __webpack_require__(199);
/* unused harmony reexport loadNamespaces */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context__ = __webpack_require__(53);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__context__["c"]; });
/* unused harmony reexport setDefaults */
/* unused harmony reexport getDefaults */
/* unused harmony reexport setI18n */
/* unused harmony reexport getI18n */








/***/ }),
/* 10 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 11 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.6' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(28);
var IE8_DOM_DEFINE = __webpack_require__(99);
var toPrimitive = __webpack_require__(56);
var dP = Object.defineProperty;

exports.f = __webpack_require__(13) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(29)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 14 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./H48010/Chassis_RAL/0001.png": 367,
	"./H48010/Chassis_RAL/0002.png": 368,
	"./H48010/Chassis_RAL/0003.png": 369,
	"./H48010/Chassis_RAL/0004.png": 370,
	"./H48010/Chassis_RAL/0005.png": 371,
	"./H48010/Chassis_RAL/0006.png": 372,
	"./H48010/Chassis_RAL/0007.png": 373,
	"./H48010/Chassis_RAL/0008.png": 374,
	"./H48010/Chassis_RAL/0009.png": 375,
	"./H48010/Chassis_RAL/0010.png": 376,
	"./H48010/Chassis_RAL/0011.png": 377,
	"./H48010/Chassis_RAL/0012.png": 378,
	"./H48010/Chassis_RAL/0013.png": 379,
	"./H48010/Chassis_RAL/0014.png": 380,
	"./H48010/Chassis_RAL/0015.png": 381,
	"./H48010/Chassis_RAL/0016.png": 382,
	"./H48010/Chassis_RAL/0017.png": 383,
	"./H48010/Chassis_RAL/0018.png": 384,
	"./H48010/Chassis_RAL/0019.png": 385,
	"./H48010/Chassis_RAL/0020.png": 386,
	"./H48010/Chassis_RAL/0021.png": 387,
	"./H48010/Chassis_RAL/0022.png": 388,
	"./H48010/Chassis_RAL/0023.png": 389,
	"./H48010/Chassis_RAL/0024.png": 390,
	"./H48010/Chassis_RAL/0025.png": 391,
	"./H48010/Chassis_RAL/0026.png": 392,
	"./H48010/Chassis_RAL/0027.png": 393,
	"./H48010/Chassis_RAL/0028.png": 394,
	"./H48010/Chassis_RAL/0029.png": 395,
	"./H48010/Chassis_RAL/0030.png": 396,
	"./H48010/Chassis_RAL/0031.png": 397,
	"./H48010/Chassis_RAL/0032.png": 398,
	"./H48010/Chassis_RAL/0033.png": 399,
	"./H48010/Chassis_RAL/0034.png": 400,
	"./H48010/Chassis_RAL/0035.png": 401,
	"./H48010/Chassis_RAL/0036.png": 402,
	"./H48010/Chassis_RAL/0037.png": 403,
	"./H48010/Chassis_RAL/0038.png": 404,
	"./H48010/Chassis_RAL/0039.png": 405,
	"./H48010/Chassis_RAL/0040.png": 406,
	"./H48010/Chassis_RAL/0041.png": 407,
	"./H48010/Chassis_RAL/0042.png": 408,
	"./H48010/Chassis_RAL/0043.png": 409,
	"./H48010/Chassis_RAL/0044.png": 410,
	"./H48010/Chassis_RAL/0045.png": 411,
	"./H48010/Chassis_RAL/0046.png": 412,
	"./H48010/Chassis_RAL/0047.png": 413,
	"./H48010/Chassis_RAL/0048.png": 414,
	"./H48010/RAL/0001.png": 415,
	"./H48010/RAL/0002.png": 416,
	"./H48010/RAL/0003.png": 417,
	"./H48010/RAL/0004.png": 418,
	"./H48010/RAL/0005.png": 419,
	"./H48010/RAL/0006.png": 420,
	"./H48010/RAL/0007.png": 421,
	"./H48010/RAL/0008.png": 422,
	"./H48010/RAL/0009.png": 423,
	"./H48010/RAL/0010.png": 424,
	"./H48010/RAL/0011.png": 425,
	"./H48010/RAL/0012.png": 426,
	"./H48010/RAL/0013.png": 427,
	"./H48010/RAL/0014.png": 428,
	"./H48010/RAL/0015.png": 429,
	"./H48010/RAL/0016.png": 430,
	"./H48010/RAL/0017.png": 431,
	"./H48010/RAL/0018.png": 432,
	"./H48010/RAL/0019.png": 433,
	"./H48010/RAL/0020.png": 434,
	"./H48010/RAL/0021.png": 435,
	"./H48010/RAL/0022.png": 436,
	"./H48010/RAL/0023.png": 437,
	"./H48010/RAL/0024.png": 438,
	"./H48010/RAL/0025.png": 439,
	"./H48010/RAL/0026.png": 440,
	"./H48010/RAL/0027.png": 441,
	"./H48010/RAL/0028.png": 442,
	"./H48010/RAL/0029.png": 443,
	"./H48010/RAL/0030.png": 444,
	"./H48010/RAL/0031.png": 445,
	"./H48010/RAL/0032.png": 446,
	"./H48010/RAL/0033.png": 447,
	"./H48010/RAL/0034.png": 448,
	"./H48010/RAL/0035.png": 449,
	"./H48010/RAL/0036.png": 450,
	"./H48010/RAL/0037.png": 451,
	"./H48010/RAL/0038.png": 452,
	"./H48010/RAL/0039.png": 453,
	"./H48010/RAL/0040.png": 454,
	"./H48010/RAL/0041.png": 455,
	"./H48010/RAL/0042.png": 456,
	"./H48010/RAL/0043.png": 457,
	"./H48010/RAL/0044.png": 458,
	"./H48010/RAL/0045.png": 459,
	"./H48010/RAL/0046.png": 460,
	"./H48010/RAL/0047.png": 461,
	"./H48010/RAL/0048.png": 462,
	"./H48011/Chassis_RAL/0001.png": 463,
	"./H48011/Chassis_RAL/0002.png": 464,
	"./H48011/Chassis_RAL/0003.png": 465,
	"./H48011/Chassis_RAL/0004.png": 466,
	"./H48011/Chassis_RAL/0005.png": 467,
	"./H48011/Chassis_RAL/0006.png": 468,
	"./H48011/Chassis_RAL/0007.png": 469,
	"./H48011/Chassis_RAL/0008.png": 470,
	"./H48011/Chassis_RAL/0009.png": 471,
	"./H48011/Chassis_RAL/0010.png": 472,
	"./H48011/Chassis_RAL/0011.png": 473,
	"./H48011/Chassis_RAL/0012.png": 474,
	"./H48011/Chassis_RAL/0013.png": 475,
	"./H48011/Chassis_RAL/0014.png": 476,
	"./H48011/Chassis_RAL/0015.png": 477,
	"./H48011/Chassis_RAL/0016.png": 478,
	"./H48011/Chassis_RAL/0017.png": 479,
	"./H48011/Chassis_RAL/0018.png": 480,
	"./H48011/Chassis_RAL/0019.png": 481,
	"./H48011/Chassis_RAL/0020.png": 482,
	"./H48011/Chassis_RAL/0021.png": 483,
	"./H48011/Chassis_RAL/0022.png": 484,
	"./H48011/Chassis_RAL/0023.png": 485,
	"./H48011/Chassis_RAL/0024.png": 486,
	"./H48011/Chassis_RAL/0025.png": 487,
	"./H48011/Chassis_RAL/0026.png": 488,
	"./H48011/Chassis_RAL/0027.png": 489,
	"./H48011/Chassis_RAL/0028.png": 490,
	"./H48011/Chassis_RAL/0029.png": 491,
	"./H48011/Chassis_RAL/0030.png": 492,
	"./H48011/Chassis_RAL/0031.png": 493,
	"./H48011/Chassis_RAL/0032.png": 494,
	"./H48011/Chassis_RAL/0033.png": 495,
	"./H48011/Chassis_RAL/0034.png": 496,
	"./H48011/Chassis_RAL/0035.png": 497,
	"./H48011/Chassis_RAL/0036.png": 498,
	"./H48011/Chassis_RAL/0037.png": 499,
	"./H48011/Chassis_RAL/0038.png": 500,
	"./H48011/Chassis_RAL/0039.png": 501,
	"./H48011/Chassis_RAL/0040.png": 502,
	"./H48011/Chassis_RAL/0041.png": 503,
	"./H48011/Chassis_RAL/0042.png": 504,
	"./H48011/Chassis_RAL/0043.png": 505,
	"./H48011/Chassis_RAL/0044.png": 506,
	"./H48011/Chassis_RAL/0045.png": 507,
	"./H48011/Chassis_RAL/0046.png": 508,
	"./H48011/Chassis_RAL/0047.png": 509,
	"./H48011/Chassis_RAL/0048.png": 510,
	"./H48011/RAL/0001.png": 511,
	"./H48011/RAL/0002.png": 512,
	"./H48011/RAL/0003.png": 513,
	"./H48011/RAL/0004.png": 514,
	"./H48011/RAL/0005.png": 515,
	"./H48011/RAL/0006.png": 516,
	"./H48011/RAL/0007.png": 517,
	"./H48011/RAL/0008.png": 518,
	"./H48011/RAL/0009.png": 519,
	"./H48011/RAL/0010.png": 520,
	"./H48011/RAL/0011.png": 521,
	"./H48011/RAL/0012.png": 522,
	"./H48011/RAL/0013.png": 523,
	"./H48011/RAL/0014.png": 524,
	"./H48011/RAL/0015.png": 525,
	"./H48011/RAL/0016.png": 526,
	"./H48011/RAL/0017.png": 527,
	"./H48011/RAL/0018.png": 528,
	"./H48011/RAL/0019.png": 529,
	"./H48011/RAL/0020.png": 530,
	"./H48011/RAL/0021.png": 531,
	"./H48011/RAL/0022.png": 532,
	"./H48011/RAL/0023.png": 533,
	"./H48011/RAL/0024.png": 534,
	"./H48011/RAL/0025.png": 535,
	"./H48011/RAL/0026.png": 536,
	"./H48011/RAL/0027.png": 537,
	"./H48011/RAL/0028.png": 538,
	"./H48011/RAL/0029.png": 539,
	"./H48011/RAL/0030.png": 540,
	"./H48011/RAL/0031.png": 541,
	"./H48011/RAL/0032.png": 542,
	"./H48011/RAL/0033.png": 543,
	"./H48011/RAL/0034.png": 544,
	"./H48011/RAL/0035.png": 545,
	"./H48011/RAL/0036.png": 546,
	"./H48011/RAL/0037.png": 547,
	"./H48011/RAL/0038.png": 548,
	"./H48011/RAL/0039.png": 549,
	"./H48011/RAL/0040.png": 550,
	"./H48011/RAL/0041.png": 551,
	"./H48011/RAL/0042.png": 552,
	"./H48011/RAL/0043.png": 553,
	"./H48011/RAL/0044.png": 554,
	"./H48011/RAL/0045.png": 555,
	"./H48011/RAL/0046.png": 556,
	"./H48011/RAL/0047.png": 557,
	"./H48011/RAL/0048.png": 558,
	"./H48012/Chassis_RAL/0001.png": 559,
	"./H48012/Chassis_RAL/0002.png": 560,
	"./H48012/Chassis_RAL/0003.png": 561,
	"./H48012/Chassis_RAL/0004.png": 562,
	"./H48012/Chassis_RAL/0005.png": 563,
	"./H48012/Chassis_RAL/0006.png": 564,
	"./H48012/Chassis_RAL/0007.png": 565,
	"./H48012/Chassis_RAL/0008.png": 566,
	"./H48012/Chassis_RAL/0009.png": 567,
	"./H48012/Chassis_RAL/0010.png": 568,
	"./H48012/Chassis_RAL/0011.png": 569,
	"./H48012/Chassis_RAL/0012.png": 570,
	"./H48012/Chassis_RAL/0013.png": 571,
	"./H48012/Chassis_RAL/0014.png": 572,
	"./H48012/Chassis_RAL/0015.png": 573,
	"./H48012/Chassis_RAL/0016.png": 574,
	"./H48012/Chassis_RAL/0017.png": 575,
	"./H48012/Chassis_RAL/0018.png": 576,
	"./H48012/Chassis_RAL/0019.png": 577,
	"./H48012/Chassis_RAL/0020.png": 578,
	"./H48012/Chassis_RAL/0021.png": 579,
	"./H48012/Chassis_RAL/0022.png": 580,
	"./H48012/Chassis_RAL/0023.png": 581,
	"./H48012/Chassis_RAL/0024.png": 582,
	"./H48012/Chassis_RAL/0025.png": 583,
	"./H48012/Chassis_RAL/0026.png": 584,
	"./H48012/Chassis_RAL/0027.png": 585,
	"./H48012/Chassis_RAL/0028.png": 586,
	"./H48012/Chassis_RAL/0029.png": 587,
	"./H48012/Chassis_RAL/0030.png": 588,
	"./H48012/Chassis_RAL/0031.png": 589,
	"./H48012/Chassis_RAL/0032.png": 590,
	"./H48012/Chassis_RAL/0033.png": 591,
	"./H48012/Chassis_RAL/0034.png": 592,
	"./H48012/Chassis_RAL/0035.png": 593,
	"./H48012/Chassis_RAL/0036.png": 594,
	"./H48012/Chassis_RAL/0037.png": 595,
	"./H48012/Chassis_RAL/0038.png": 596,
	"./H48012/Chassis_RAL/0039.png": 597,
	"./H48012/Chassis_RAL/0040.png": 598,
	"./H48012/Chassis_RAL/0041.png": 599,
	"./H48012/Chassis_RAL/0042.png": 600,
	"./H48012/Chassis_RAL/0043.png": 601,
	"./H48012/Chassis_RAL/0044.png": 602,
	"./H48012/Chassis_RAL/0045.png": 603,
	"./H48012/Chassis_RAL/0046.png": 604,
	"./H48012/Chassis_RAL/0047.png": 605,
	"./H48012/Chassis_RAL/0048.png": 606,
	"./H48012/RAL/0001.png": 607,
	"./H48012/RAL/0002.png": 608,
	"./H48012/RAL/0003.png": 609,
	"./H48012/RAL/0004.png": 610,
	"./H48012/RAL/0005.png": 611,
	"./H48012/RAL/0006.png": 612,
	"./H48012/RAL/0007.png": 613,
	"./H48012/RAL/0008.png": 614,
	"./H48012/RAL/0009.png": 615,
	"./H48012/RAL/0010.png": 616,
	"./H48012/RAL/0011.png": 617,
	"./H48012/RAL/0012.png": 618,
	"./H48012/RAL/0013.png": 619,
	"./H48012/RAL/0014.png": 620,
	"./H48012/RAL/0015.png": 621,
	"./H48012/RAL/0016.png": 622,
	"./H48012/RAL/0017.png": 623,
	"./H48012/RAL/0018.png": 624,
	"./H48012/RAL/0019.png": 625,
	"./H48012/RAL/0020.png": 626,
	"./H48012/RAL/0021.png": 627,
	"./H48012/RAL/0022.png": 628,
	"./H48012/RAL/0023.png": 629,
	"./H48012/RAL/0024.png": 630,
	"./H48012/RAL/0025.png": 631,
	"./H48012/RAL/0026.png": 632,
	"./H48012/RAL/0027.png": 633,
	"./H48012/RAL/0028.png": 634,
	"./H48012/RAL/0029.png": 635,
	"./H48012/RAL/0030.png": 636,
	"./H48012/RAL/0031.png": 637,
	"./H48012/RAL/0032.png": 638,
	"./H48012/RAL/0033.png": 639,
	"./H48012/RAL/0034.png": 640,
	"./H48012/RAL/0035.png": 641,
	"./H48012/RAL/0036.png": 642,
	"./H48012/RAL/0037.png": 643,
	"./H48012/RAL/0038.png": 644,
	"./H48012/RAL/0039.png": 645,
	"./H48012/RAL/0040.png": 646,
	"./H48012/RAL/0041.png": 647,
	"./H48012/RAL/0042.png": 648,
	"./H48012/RAL/0043.png": 649,
	"./H48012/RAL/0044.png": 650,
	"./H48012/RAL/0045.png": 651,
	"./H48012/RAL/0046.png": 652,
	"./H48012/RAL/0047.png": 653,
	"./H48012/RAL/0048.png": 654,
	"./H48013/Chassis_RAL/0001.png": 655,
	"./H48013/Chassis_RAL/0002.png": 656,
	"./H48013/Chassis_RAL/0003.png": 657,
	"./H48013/Chassis_RAL/0004.png": 658,
	"./H48013/Chassis_RAL/0005.png": 659,
	"./H48013/Chassis_RAL/0006.png": 660,
	"./H48013/Chassis_RAL/0007.png": 661,
	"./H48013/Chassis_RAL/0008.png": 662,
	"./H48013/Chassis_RAL/0009.png": 663,
	"./H48013/Chassis_RAL/0010.png": 664,
	"./H48013/Chassis_RAL/0011.png": 665,
	"./H48013/Chassis_RAL/0012.png": 666,
	"./H48013/Chassis_RAL/0013.png": 667,
	"./H48013/Chassis_RAL/0014.png": 668,
	"./H48013/Chassis_RAL/0015.png": 669,
	"./H48013/Chassis_RAL/0016.png": 670,
	"./H48013/Chassis_RAL/0017.png": 671,
	"./H48013/Chassis_RAL/0018.png": 672,
	"./H48013/Chassis_RAL/0019.png": 673,
	"./H48013/Chassis_RAL/0020.png": 674,
	"./H48013/Chassis_RAL/0021.png": 675,
	"./H48013/Chassis_RAL/0022.png": 676,
	"./H48013/Chassis_RAL/0023.png": 677,
	"./H48013/Chassis_RAL/0024.png": 678,
	"./H48013/Chassis_RAL/0025.png": 679,
	"./H48013/Chassis_RAL/0026.png": 680,
	"./H48013/Chassis_RAL/0027.png": 681,
	"./H48013/Chassis_RAL/0028.png": 682,
	"./H48013/Chassis_RAL/0029.png": 683,
	"./H48013/Chassis_RAL/0030.png": 684,
	"./H48013/Chassis_RAL/0031.png": 685,
	"./H48013/Chassis_RAL/0032.png": 686,
	"./H48013/Chassis_RAL/0033.png": 687,
	"./H48013/Chassis_RAL/0034.png": 688,
	"./H48013/Chassis_RAL/0035.png": 689,
	"./H48013/Chassis_RAL/0036.png": 690,
	"./H48013/Chassis_RAL/0037.png": 691,
	"./H48013/Chassis_RAL/0038.png": 692,
	"./H48013/Chassis_RAL/0039.png": 693,
	"./H48013/Chassis_RAL/0040.png": 694,
	"./H48013/Chassis_RAL/0041.png": 695,
	"./H48013/Chassis_RAL/0042.png": 696,
	"./H48013/Chassis_RAL/0043.png": 697,
	"./H48013/Chassis_RAL/0044.png": 698,
	"./H48013/Chassis_RAL/0045.png": 699,
	"./H48013/Chassis_RAL/0046.png": 700,
	"./H48013/Chassis_RAL/0047.png": 701,
	"./H48013/Chassis_RAL/0048.png": 702,
	"./H48013/RAL/0001.png": 703,
	"./H48013/RAL/0002.png": 704,
	"./H48013/RAL/0003.png": 705,
	"./H48013/RAL/0004.png": 706,
	"./H48013/RAL/0005.png": 707,
	"./H48013/RAL/0006.png": 708,
	"./H48013/RAL/0007.png": 709,
	"./H48013/RAL/0008.png": 710,
	"./H48013/RAL/0009.png": 711,
	"./H48013/RAL/0010.png": 712,
	"./H48013/RAL/0011.png": 713,
	"./H48013/RAL/0012.png": 714,
	"./H48013/RAL/0013.png": 715,
	"./H48013/RAL/0014.png": 716,
	"./H48013/RAL/0015.png": 717,
	"./H48013/RAL/0016.png": 718,
	"./H48013/RAL/0017.png": 719,
	"./H48013/RAL/0018.png": 720,
	"./H48013/RAL/0019.png": 721,
	"./H48013/RAL/0020.png": 722,
	"./H48013/RAL/0021.png": 723,
	"./H48013/RAL/0022.png": 724,
	"./H48013/RAL/0023.png": 725,
	"./H48013/RAL/0024.png": 726,
	"./H48013/RAL/0025.png": 727,
	"./H48013/RAL/0026.png": 728,
	"./H48013/RAL/0027.png": 729,
	"./H48013/RAL/0028.png": 730,
	"./H48013/RAL/0029.png": 731,
	"./H48013/RAL/0030.png": 732,
	"./H48013/RAL/0031.png": 733,
	"./H48013/RAL/0032.png": 734,
	"./H48013/RAL/0033.png": 735,
	"./H48013/RAL/0034.png": 736,
	"./H48013/RAL/0035.png": 737,
	"./H48013/RAL/0036.png": 738,
	"./H48013/RAL/0037.png": 739,
	"./H48013/RAL/0038.png": 740,
	"./H48013/RAL/0039.png": 741,
	"./H48013/RAL/0040.png": 742,
	"./H48013/RAL/0041.png": 743,
	"./H48013/RAL/0042.png": 744,
	"./H48013/RAL/0043.png": 745,
	"./H48013/RAL/0044.png": 746,
	"./H48013/RAL/0045.png": 747,
	"./H48013/RAL/0046.png": 748,
	"./H48013/RAL/0047.png": 749,
	"./H48013/RAL/0048.png": 750,
	"./H48103/Anodized/0001.png": 751,
	"./H48103/Chassis_RAL/0001.png": 752,
	"./H48103/Chassis_RAL/0002.png": 753,
	"./H48103/Chassis_RAL/0003.png": 754,
	"./H48103/Chassis_RAL/0004.png": 755,
	"./H48103/Chassis_RAL/0005.png": 756,
	"./H48103/Chassis_RAL/0006.png": 757,
	"./H48103/Chassis_RAL/0007.png": 758,
	"./H48103/Chassis_RAL/0008.png": 759,
	"./H48103/Chassis_RAL/0009.png": 760,
	"./H48103/Chassis_RAL/0010.png": 761,
	"./H48103/Chassis_RAL/0011.png": 762,
	"./H48103/Chassis_RAL/0012.png": 763,
	"./H48103/Chassis_RAL/0013.png": 764,
	"./H48103/Chassis_RAL/0014.png": 765,
	"./H48103/Chassis_RAL/0015.png": 766,
	"./H48103/Chassis_RAL/0016.png": 767,
	"./H48103/Chassis_RAL/0017.png": 768,
	"./H48103/Chassis_RAL/0018.png": 769,
	"./H48103/Chassis_RAL/0019.png": 770,
	"./H48103/Chassis_RAL/0020.png": 771,
	"./H48103/Chassis_RAL/0021.png": 772,
	"./H48103/Chassis_RAL/0022.png": 773,
	"./H48103/Chassis_RAL/0023.png": 774,
	"./H48103/Chassis_RAL/0024.png": 775,
	"./H48103/Chassis_RAL/0025.png": 776,
	"./H48103/Chassis_RAL/0026.png": 777,
	"./H48103/Chassis_RAL/0027.png": 778,
	"./H48103/Chassis_RAL/0028.png": 779,
	"./H48103/Chassis_RAL/0029.png": 780,
	"./H48103/Chassis_RAL/0030.png": 781,
	"./H48103/Chassis_RAL/0031.png": 782,
	"./H48103/Chassis_RAL/0032.png": 783,
	"./H48103/Chassis_RAL/0033.png": 784,
	"./H48103/Chassis_RAL/0034.png": 785,
	"./H48103/Chassis_RAL/0035.png": 786,
	"./H48103/Chassis_RAL/0036.png": 787,
	"./H48103/Chassis_RAL/0037.png": 788,
	"./H48103/Chassis_RAL/0038.png": 789,
	"./H48103/Chassis_RAL/0039.png": 790,
	"./H48103/Chassis_RAL/0040.png": 791,
	"./H48103/Chassis_RAL/0041.png": 792,
	"./H48103/Chassis_RAL/0042.png": 793,
	"./H48103/Chassis_RAL/0043.png": 794,
	"./H48103/Chassis_RAL/0044.png": 795,
	"./H48103/Chassis_RAL/0045.png": 796,
	"./H48103/Chassis_RAL/0046.png": 797,
	"./H48103/Chassis_RAL/0047.png": 798,
	"./H48103/Chassis_RAL/0048.png": 799,
	"./H48103/Customs/Customs_black/0001.png": 800,
	"./H48103/Customs/Customs_black/0002.png": 801,
	"./H48103/Customs/Customs_black/0003.png": 802,
	"./H48103/Customs/Customs_black/0004.png": 803,
	"./H48103/Customs/Customs_black/0005.png": 804,
	"./H48103/Customs/Customs_white/0001.png": 805,
	"./H48103/Customs/Customs_white/0002.png": 806,
	"./H48103/Customs/Customs_white/0003.png": 807,
	"./H48103/Customs/Customs_white/0004.png": 808,
	"./H48103/Customs/Customs_white/0005.png": 809,
	"./H48103/Decors/Decors_black/0001.png": 810,
	"./H48103/Decors/Decors_black/0002.png": 811,
	"./H48103/Decors/Decors_black/0003.png": 812,
	"./H48103/Decors/Decors_black/0004.png": 813,
	"./H48103/Decors/Decors_black/0005.png": 814,
	"./H48103/Decors/Decors_black/0006.png": 815,
	"./H48103/Decors/Decors_black/0007.png": 816,
	"./H48103/Decors/Decors_black/0008.png": 817,
	"./H48103/Decors/Decors_black/0009.png": 818,
	"./H48103/Decors/Decors_black/0010.png": 819,
	"./H48103/Decors/Decors_black/0011.png": 820,
	"./H48103/Decors/Decors_black/0012.png": 821,
	"./H48103/Decors/Decors_black/0013.png": 822,
	"./H48103/Decors/Decors_black/0014.png": 823,
	"./H48103/Decors/Decors_black/0015.png": 824,
	"./H48103/Decors/Decors_black/0016.png": 825,
	"./H48103/Decors/Decors_black/0017.png": 826,
	"./H48103/Decors/Decors_black/0018.png": 827,
	"./H48103/Decors/Decors_black/0019.png": 828,
	"./H48103/Decors/Decors_black/0020.png": 829,
	"./H48103/Decors/Decors_black/0021.png": 830,
	"./H48103/Decors/Decors_black/0022.png": 831,
	"./H48103/Decors/Decors_black/0023.png": 832,
	"./H48103/Decors/Decors_black/0024.png": 833,
	"./H48103/Decors/Decors_black/0025.png": 834,
	"./H48103/Decors/Decors_black/0026.png": 835,
	"./H48103/Decors/Decors_black/0027.png": 836,
	"./H48103/Decors/Decors_black/0028.png": 837,
	"./H48103/Decors/Decors_black/0029.png": 838,
	"./H48103/Decors/Decors_black/0030.png": 839,
	"./H48103/Decors/Decors_black/0031.png": 840,
	"./H48103/Decors/Decors_black/0032.png": 841,
	"./H48103/Decors/Decors_black/0033.png": 842,
	"./H48103/Decors/Decors_black/0034.png": 843,
	"./H48103/Decors/Decors_black/0035.png": 844,
	"./H48103/Decors/Decors_black/0036.png": 845,
	"./H48103/Decors/Decors_black/0037.png": 846,
	"./H48103/Decors/Decors_black/0038.png": 847,
	"./H48103/Decors/Decors_white/0001.png": 848,
	"./H48103/Decors/Decors_white/0002.png": 849,
	"./H48103/Decors/Decors_white/0003.png": 850,
	"./H48103/Decors/Decors_white/0004.png": 851,
	"./H48103/Decors/Decors_white/0005.png": 852,
	"./H48103/Decors/Decors_white/0006.png": 853,
	"./H48103/Decors/Decors_white/0007.png": 854,
	"./H48103/Decors/Decors_white/0008.png": 855,
	"./H48103/Decors/Decors_white/0009.png": 856,
	"./H48103/Decors/Decors_white/0010.png": 857,
	"./H48103/Decors/Decors_white/0011.png": 858,
	"./H48103/Decors/Decors_white/0012.png": 859,
	"./H48103/Decors/Decors_white/0013.png": 860,
	"./H48103/Decors/Decors_white/0014.png": 861,
	"./H48103/Decors/Decors_white/0015.png": 862,
	"./H48103/Decors/Decors_white/0016.png": 863,
	"./H48103/Decors/Decors_white/0017.png": 864,
	"./H48103/Decors/Decors_white/0018.png": 865,
	"./H48103/Decors/Decors_white/0019.png": 866,
	"./H48103/Decors/Decors_white/0020.png": 867,
	"./H48103/Decors/Decors_white/0021.png": 868,
	"./H48103/Decors/Decors_white/0022.png": 869,
	"./H48103/Decors/Decors_white/0023.png": 870,
	"./H48103/Decors/Decors_white/0024.png": 871,
	"./H48103/Decors/Decors_white/0025.png": 872,
	"./H48103/Decors/Decors_white/0026.png": 873,
	"./H48103/Decors/Decors_white/0027.png": 874,
	"./H48103/Decors/Decors_white/0028.png": 875,
	"./H48103/Decors/Decors_white/0029.png": 876,
	"./H48103/Decors/Decors_white/0030.png": 877,
	"./H48103/Decors/Decors_white/0031.png": 878,
	"./H48103/Decors/Decors_white/0032.png": 879,
	"./H48103/Decors/Decors_white/0033.png": 880,
	"./H48103/Decors/Decors_white/0034.png": 881,
	"./H48103/Decors/Decors_white/0035.png": 882,
	"./H48103/Decors/Decors_white/0036.png": 883,
	"./H48103/Decors/Decors_white/0037.png": 884,
	"./H48103/Decors/Decors_white/0038.png": 885,
	"./H48103/Decors_colored/C06_black/0001.png": 886,
	"./H48103/Decors_colored/C06_black/0002.png": 887,
	"./H48103/Decors_colored/C06_black/0003.png": 888,
	"./H48103/Decors_colored/C06_black/0004.png": 889,
	"./H48103/Decors_colored/C06_black/0005.png": 890,
	"./H48103/Decors_colored/C06_black/0006.png": 891,
	"./H48103/Decors_colored/C06_black/0007.png": 892,
	"./H48103/Decors_colored/C06_black/0008.png": 893,
	"./H48103/Decors_colored/C06_black/0009.png": 894,
	"./H48103/Decors_colored/C06_black/0010.png": 895,
	"./H48103/Decors_colored/C06_black/0011.png": 896,
	"./H48103/Decors_colored/C06_black/0012.png": 897,
	"./H48103/Decors_colored/C06_black/0013.png": 898,
	"./H48103/Decors_colored/C06_black/0014.png": 899,
	"./H48103/Decors_colored/C06_black/0015.png": 900,
	"./H48103/Decors_colored/C06_black/0016.png": 901,
	"./H48103/Decors_colored/C06_black/0017.png": 902,
	"./H48103/Decors_colored/C06_black/0018.png": 903,
	"./H48103/Decors_colored/C06_white/0001.png": 904,
	"./H48103/Decors_colored/C06_white/0002.png": 905,
	"./H48103/Decors_colored/C06_white/0003.png": 906,
	"./H48103/Decors_colored/C06_white/0004.png": 907,
	"./H48103/Decors_colored/C06_white/0005.png": 908,
	"./H48103/Decors_colored/C06_white/0006.png": 909,
	"./H48103/Decors_colored/C06_white/0007.png": 910,
	"./H48103/Decors_colored/C06_white/0008.png": 911,
	"./H48103/Decors_colored/C06_white/0009.png": 912,
	"./H48103/Decors_colored/C06_white/0010.png": 913,
	"./H48103/Decors_colored/C06_white/0011.png": 914,
	"./H48103/Decors_colored/C06_white/0012.png": 915,
	"./H48103/Decors_colored/C06_white/0013.png": 916,
	"./H48103/Decors_colored/C06_white/0014.png": 917,
	"./H48103/Decors_colored/C06_white/0015.png": 918,
	"./H48103/Decors_colored/C06_white/0016.png": 919,
	"./H48103/Decors_colored/C06_white/0017.png": 920,
	"./H48103/Decors_colored/C06_white/0018.png": 921,
	"./H48103/Decors_colored/C07_black/0001.png": 922,
	"./H48103/Decors_colored/C07_black/0002.png": 923,
	"./H48103/Decors_colored/C07_black/0003.png": 924,
	"./H48103/Decors_colored/C07_black/0004.png": 925,
	"./H48103/Decors_colored/C07_black/0005.png": 926,
	"./H48103/Decors_colored/C07_black/0006.png": 927,
	"./H48103/Decors_colored/C07_black/0007.png": 928,
	"./H48103/Decors_colored/C07_black/0008.png": 929,
	"./H48103/Decors_colored/C07_black/0009.png": 930,
	"./H48103/Decors_colored/C07_black/0010.png": 931,
	"./H48103/Decors_colored/C07_black/0011.png": 932,
	"./H48103/Decors_colored/C07_black/0012.png": 933,
	"./H48103/Decors_colored/C07_black/0013.png": 934,
	"./H48103/Decors_colored/C07_black/0014.png": 935,
	"./H48103/Decors_colored/C07_black/0015.png": 936,
	"./H48103/Decors_colored/C07_black/0016.png": 937,
	"./H48103/Decors_colored/C07_black/0017.png": 938,
	"./H48103/Decors_colored/C07_black/0018.png": 939,
	"./H48103/Decors_colored/C07_white/0001.png": 940,
	"./H48103/Decors_colored/C07_white/0002.png": 941,
	"./H48103/Decors_colored/C07_white/0003.png": 942,
	"./H48103/Decors_colored/C07_white/0004.png": 943,
	"./H48103/Decors_colored/C07_white/0005.png": 944,
	"./H48103/Decors_colored/C07_white/0006.png": 945,
	"./H48103/Decors_colored/C07_white/0007.png": 946,
	"./H48103/Decors_colored/C07_white/0008.png": 947,
	"./H48103/Decors_colored/C07_white/0009.png": 948,
	"./H48103/Decors_colored/C07_white/0010.png": 949,
	"./H48103/Decors_colored/C07_white/0011.png": 950,
	"./H48103/Decors_colored/C07_white/0012.png": 951,
	"./H48103/Decors_colored/C07_white/0013.png": 952,
	"./H48103/Decors_colored/C07_white/0014.png": 953,
	"./H48103/Decors_colored/C07_white/0015.png": 954,
	"./H48103/Decors_colored/C07_white/0016.png": 955,
	"./H48103/Decors_colored/C07_white/0017.png": 956,
	"./H48103/Decors_colored/C07_white/0018.png": 957,
	"./H48103/Decors_colored/G01_black/0001.png": 958,
	"./H48103/Decors_colored/G01_black/0002.png": 959,
	"./H48103/Decors_colored/G01_black/0003.png": 960,
	"./H48103/Decors_colored/G01_black/0004.png": 961,
	"./H48103/Decors_colored/G01_black/0005.png": 962,
	"./H48103/Decors_colored/G01_black/0006.png": 963,
	"./H48103/Decors_colored/G01_black/0007.png": 964,
	"./H48103/Decors_colored/G01_black/0008.png": 965,
	"./H48103/Decors_colored/G01_black/0009.png": 966,
	"./H48103/Decors_colored/G01_black/0010.png": 967,
	"./H48103/Decors_colored/G01_black/0011.png": 968,
	"./H48103/Decors_colored/G01_black/0012.png": 969,
	"./H48103/Decors_colored/G01_black/0013.png": 970,
	"./H48103/Decors_colored/G01_black/0014.png": 971,
	"./H48103/Decors_colored/G01_black/0015.png": 972,
	"./H48103/Decors_colored/G01_black/0016.png": 973,
	"./H48103/Decors_colored/G01_black/0017.png": 974,
	"./H48103/Decors_colored/G01_black/0018.png": 975,
	"./H48103/Decors_colored/G01_white/0001.png": 976,
	"./H48103/Decors_colored/G01_white/0002.png": 977,
	"./H48103/Decors_colored/G01_white/0003.png": 978,
	"./H48103/Decors_colored/G01_white/0004.png": 979,
	"./H48103/Decors_colored/G01_white/0005.png": 980,
	"./H48103/Decors_colored/G01_white/0006.png": 981,
	"./H48103/Decors_colored/G01_white/0007.png": 982,
	"./H48103/Decors_colored/G01_white/0008.png": 983,
	"./H48103/Decors_colored/G01_white/0009.png": 984,
	"./H48103/Decors_colored/G01_white/0010.png": 985,
	"./H48103/Decors_colored/G01_white/0011.png": 986,
	"./H48103/Decors_colored/G01_white/0012.png": 987,
	"./H48103/Decors_colored/G01_white/0013.png": 988,
	"./H48103/Decors_colored/G01_white/0014.png": 989,
	"./H48103/Decors_colored/G01_white/0015.png": 990,
	"./H48103/Decors_colored/G01_white/0016.png": 991,
	"./H48103/Decors_colored/G01_white/0017.png": 992,
	"./H48103/Decors_colored/G01_white/0018.png": 993,
	"./H48103/Decors_colored/G02_black/0001.png": 994,
	"./H48103/Decors_colored/G02_black/0002.png": 995,
	"./H48103/Decors_colored/G02_black/0003.png": 996,
	"./H48103/Decors_colored/G02_black/0004.png": 997,
	"./H48103/Decors_colored/G02_black/0005.png": 998,
	"./H48103/Decors_colored/G02_black/0006.png": 999,
	"./H48103/Decors_colored/G02_black/0007.png": 1000,
	"./H48103/Decors_colored/G02_black/0008.png": 1001,
	"./H48103/Decors_colored/G02_black/0009.png": 1002,
	"./H48103/Decors_colored/G02_black/0010.png": 1003,
	"./H48103/Decors_colored/G02_black/0011.png": 1004,
	"./H48103/Decors_colored/G02_black/0012.png": 1005,
	"./H48103/Decors_colored/G02_black/0013.png": 1006,
	"./H48103/Decors_colored/G02_black/0014.png": 1007,
	"./H48103/Decors_colored/G02_black/0015.png": 1008,
	"./H48103/Decors_colored/G02_black/0016.png": 1009,
	"./H48103/Decors_colored/G02_black/0017.png": 1010,
	"./H48103/Decors_colored/G02_black/0018.png": 1011,
	"./H48103/Decors_colored/G02_white/0001.png": 1012,
	"./H48103/Decors_colored/G02_white/0002.png": 1013,
	"./H48103/Decors_colored/G02_white/0003.png": 1014,
	"./H48103/Decors_colored/G02_white/0004.png": 1015,
	"./H48103/Decors_colored/G02_white/0005.png": 1016,
	"./H48103/Decors_colored/G02_white/0006.png": 1017,
	"./H48103/Decors_colored/G02_white/0007.png": 1018,
	"./H48103/Decors_colored/G02_white/0008.png": 1019,
	"./H48103/Decors_colored/G02_white/0009.png": 1020,
	"./H48103/Decors_colored/G02_white/0010.png": 1021,
	"./H48103/Decors_colored/G02_white/0011.png": 1022,
	"./H48103/Decors_colored/G02_white/0012.png": 1023,
	"./H48103/Decors_colored/G02_white/0013.png": 1024,
	"./H48103/Decors_colored/G02_white/0014.png": 1025,
	"./H48103/Decors_colored/G02_white/0015.png": 1026,
	"./H48103/Decors_colored/G02_white/0016.png": 1027,
	"./H48103/Decors_colored/G02_white/0017.png": 1028,
	"./H48103/Decors_colored/G02_white/0018.png": 1029,
	"./H48103/Decors_colored/G03_black/0001.png": 1030,
	"./H48103/Decors_colored/G03_black/0002.png": 1031,
	"./H48103/Decors_colored/G03_black/0003.png": 1032,
	"./H48103/Decors_colored/G03_black/0004.png": 1033,
	"./H48103/Decors_colored/G03_black/0005.png": 1034,
	"./H48103/Decors_colored/G03_black/0006.png": 1035,
	"./H48103/Decors_colored/G03_black/0007.png": 1036,
	"./H48103/Decors_colored/G03_black/0008.png": 1037,
	"./H48103/Decors_colored/G03_black/0009.png": 1038,
	"./H48103/Decors_colored/G03_black/0010.png": 1039,
	"./H48103/Decors_colored/G03_black/0011.png": 1040,
	"./H48103/Decors_colored/G03_black/0012.png": 1041,
	"./H48103/Decors_colored/G03_black/0013.png": 1042,
	"./H48103/Decors_colored/G03_black/0014.png": 1043,
	"./H48103/Decors_colored/G03_black/0015.png": 1044,
	"./H48103/Decors_colored/G03_black/0016.png": 1045,
	"./H48103/Decors_colored/G03_black/0017.png": 1046,
	"./H48103/Decors_colored/G03_black/0018.png": 1047,
	"./H48103/Decors_colored/G03_white/0001.png": 1048,
	"./H48103/Decors_colored/G03_white/0002.png": 1049,
	"./H48103/Decors_colored/G03_white/0003.png": 1050,
	"./H48103/Decors_colored/G03_white/0004.png": 1051,
	"./H48103/Decors_colored/G03_white/0005.png": 1052,
	"./H48103/Decors_colored/G03_white/0006.png": 1053,
	"./H48103/Decors_colored/G03_white/0007.png": 1054,
	"./H48103/Decors_colored/G03_white/0008.png": 1055,
	"./H48103/Decors_colored/G03_white/0009.png": 1056,
	"./H48103/Decors_colored/G03_white/0010.png": 1057,
	"./H48103/Decors_colored/G03_white/0011.png": 1058,
	"./H48103/Decors_colored/G03_white/0012.png": 1059,
	"./H48103/Decors_colored/G03_white/0013.png": 1060,
	"./H48103/Decors_colored/G03_white/0014.png": 1061,
	"./H48103/Decors_colored/G03_white/0015.png": 1062,
	"./H48103/Decors_colored/G03_white/0016.png": 1063,
	"./H48103/Decors_colored/G03_white/0017.png": 1064,
	"./H48103/Decors_colored/G03_white/0018.png": 1065,
	"./H48103/Decors_colored/G04_black/0001.png": 1066,
	"./H48103/Decors_colored/G04_black/0002.png": 1067,
	"./H48103/Decors_colored/G04_black/0003.png": 1068,
	"./H48103/Decors_colored/G04_black/0004.png": 1069,
	"./H48103/Decors_colored/G04_black/0005.png": 1070,
	"./H48103/Decors_colored/G04_black/0006.png": 1071,
	"./H48103/Decors_colored/G04_black/0007.png": 1072,
	"./H48103/Decors_colored/G04_black/0008.png": 1073,
	"./H48103/Decors_colored/G04_black/0009.png": 1074,
	"./H48103/Decors_colored/G04_black/0010.png": 1075,
	"./H48103/Decors_colored/G04_black/0011.png": 1076,
	"./H48103/Decors_colored/G04_black/0012.png": 1077,
	"./H48103/Decors_colored/G04_black/0013.png": 1078,
	"./H48103/Decors_colored/G04_black/0014.png": 1079,
	"./H48103/Decors_colored/G04_black/0015.png": 1080,
	"./H48103/Decors_colored/G04_black/0016.png": 1081,
	"./H48103/Decors_colored/G04_black/0017.png": 1082,
	"./H48103/Decors_colored/G04_black/0018.png": 1083,
	"./H48103/Decors_colored/G04_white/0001.png": 1084,
	"./H48103/Decors_colored/G04_white/0002.png": 1085,
	"./H48103/Decors_colored/G04_white/0003.png": 1086,
	"./H48103/Decors_colored/G04_white/0004.png": 1087,
	"./H48103/Decors_colored/G04_white/0005.png": 1088,
	"./H48103/Decors_colored/G04_white/0006.png": 1089,
	"./H48103/Decors_colored/G04_white/0007.png": 1090,
	"./H48103/Decors_colored/G04_white/0008.png": 1091,
	"./H48103/Decors_colored/G04_white/0009.png": 1092,
	"./H48103/Decors_colored/G04_white/0010.png": 1093,
	"./H48103/Decors_colored/G04_white/0011.png": 1094,
	"./H48103/Decors_colored/G04_white/0012.png": 1095,
	"./H48103/Decors_colored/G04_white/0013.png": 1096,
	"./H48103/Decors_colored/G04_white/0014.png": 1097,
	"./H48103/Decors_colored/G04_white/0015.png": 1098,
	"./H48103/Decors_colored/G04_white/0016.png": 1099,
	"./H48103/Decors_colored/G04_white/0017.png": 1100,
	"./H48103/Decors_colored/G04_white/0018.png": 1101,
	"./H48103/Decors_colored/G05_black/0001.png": 1102,
	"./H48103/Decors_colored/G05_black/0002.png": 1103,
	"./H48103/Decors_colored/G05_black/0003.png": 1104,
	"./H48103/Decors_colored/G05_black/0004.png": 1105,
	"./H48103/Decors_colored/G05_black/0005.png": 1106,
	"./H48103/Decors_colored/G05_black/0006.png": 1107,
	"./H48103/Decors_colored/G05_black/0007.png": 1108,
	"./H48103/Decors_colored/G05_black/0008.png": 1109,
	"./H48103/Decors_colored/G05_black/0009.png": 1110,
	"./H48103/Decors_colored/G05_black/0010.png": 1111,
	"./H48103/Decors_colored/G05_black/0011.png": 1112,
	"./H48103/Decors_colored/G05_black/0012.png": 1113,
	"./H48103/Decors_colored/G05_black/0013.png": 1114,
	"./H48103/Decors_colored/G05_black/0014.png": 1115,
	"./H48103/Decors_colored/G05_black/0015.png": 1116,
	"./H48103/Decors_colored/G05_black/0016.png": 1117,
	"./H48103/Decors_colored/G05_black/0017.png": 1118,
	"./H48103/Decors_colored/G05_black/0018.png": 1119,
	"./H48103/Decors_colored/G05_white/0001.png": 1120,
	"./H48103/Decors_colored/G05_white/0002.png": 1121,
	"./H48103/Decors_colored/G05_white/0003.png": 1122,
	"./H48103/Decors_colored/G05_white/0004.png": 1123,
	"./H48103/Decors_colored/G05_white/0005.png": 1124,
	"./H48103/Decors_colored/G05_white/0006.png": 1125,
	"./H48103/Decors_colored/G05_white/0007.png": 1126,
	"./H48103/Decors_colored/G05_white/0008.png": 1127,
	"./H48103/Decors_colored/G05_white/0009.png": 1128,
	"./H48103/Decors_colored/G05_white/0010.png": 1129,
	"./H48103/Decors_colored/G05_white/0011.png": 1130,
	"./H48103/Decors_colored/G05_white/0012.png": 1131,
	"./H48103/Decors_colored/G05_white/0013.png": 1132,
	"./H48103/Decors_colored/G05_white/0014.png": 1133,
	"./H48103/Decors_colored/G05_white/0015.png": 1134,
	"./H48103/Decors_colored/G05_white/0016.png": 1135,
	"./H48103/Decors_colored/G05_white/0017.png": 1136,
	"./H48103/Decors_colored/G05_white/0018.png": 1137,
	"./H48103/Decors_colored/G06_black/0001.png": 1138,
	"./H48103/Decors_colored/G06_black/0002.png": 1139,
	"./H48103/Decors_colored/G06_black/0003.png": 1140,
	"./H48103/Decors_colored/G06_black/0004.png": 1141,
	"./H48103/Decors_colored/G06_black/0005.png": 1142,
	"./H48103/Decors_colored/G06_black/0006.png": 1143,
	"./H48103/Decors_colored/G06_black/0007.png": 1144,
	"./H48103/Decors_colored/G06_black/0008.png": 1145,
	"./H48103/Decors_colored/G06_black/0009.png": 1146,
	"./H48103/Decors_colored/G06_black/0010.png": 1147,
	"./H48103/Decors_colored/G06_black/0011.png": 1148,
	"./H48103/Decors_colored/G06_black/0012.png": 1149,
	"./H48103/Decors_colored/G06_black/0013.png": 1150,
	"./H48103/Decors_colored/G06_black/0014.png": 1151,
	"./H48103/Decors_colored/G06_black/0015.png": 1152,
	"./H48103/Decors_colored/G06_black/0016.png": 1153,
	"./H48103/Decors_colored/G06_black/0017.png": 1154,
	"./H48103/Decors_colored/G06_black/0018.png": 1155,
	"./H48103/Decors_colored/G06_white/0001.png": 1156,
	"./H48103/Decors_colored/G06_white/0002.png": 1157,
	"./H48103/Decors_colored/G06_white/0003.png": 1158,
	"./H48103/Decors_colored/G06_white/0004.png": 1159,
	"./H48103/Decors_colored/G06_white/0005.png": 1160,
	"./H48103/Decors_colored/G06_white/0006.png": 1161,
	"./H48103/Decors_colored/G06_white/0007.png": 1162,
	"./H48103/Decors_colored/G06_white/0008.png": 1163,
	"./H48103/Decors_colored/G06_white/0009.png": 1164,
	"./H48103/Decors_colored/G06_white/0010.png": 1165,
	"./H48103/Decors_colored/G06_white/0011.png": 1166,
	"./H48103/Decors_colored/G06_white/0012.png": 1167,
	"./H48103/Decors_colored/G06_white/0013.png": 1168,
	"./H48103/Decors_colored/G06_white/0014.png": 1169,
	"./H48103/Decors_colored/G06_white/0015.png": 1170,
	"./H48103/Decors_colored/G06_white/0016.png": 1171,
	"./H48103/Decors_colored/G06_white/0017.png": 1172,
	"./H48103/Decors_colored/G06_white/0018.png": 1173,
	"./H48103/Decors_colored/G07_black/0001.png": 1174,
	"./H48103/Decors_colored/G07_black/0002.png": 1175,
	"./H48103/Decors_colored/G07_black/0003.png": 1176,
	"./H48103/Decors_colored/G07_black/0004.png": 1177,
	"./H48103/Decors_colored/G07_black/0005.png": 1178,
	"./H48103/Decors_colored/G07_black/0006.png": 1179,
	"./H48103/Decors_colored/G07_black/0007.png": 1180,
	"./H48103/Decors_colored/G07_black/0008.png": 1181,
	"./H48103/Decors_colored/G07_black/0009.png": 1182,
	"./H48103/Decors_colored/G07_black/0010.png": 1183,
	"./H48103/Decors_colored/G07_black/0011.png": 1184,
	"./H48103/Decors_colored/G07_black/0012.png": 1185,
	"./H48103/Decors_colored/G07_black/0013.png": 1186,
	"./H48103/Decors_colored/G07_black/0014.png": 1187,
	"./H48103/Decors_colored/G07_black/0015.png": 1188,
	"./H48103/Decors_colored/G07_black/0016.png": 1189,
	"./H48103/Decors_colored/G07_black/0017.png": 1190,
	"./H48103/Decors_colored/G07_black/0018.png": 1191,
	"./H48103/Decors_colored/G07_white/0001.png": 1192,
	"./H48103/Decors_colored/G07_white/0002.png": 1193,
	"./H48103/Decors_colored/G07_white/0003.png": 1194,
	"./H48103/Decors_colored/G07_white/0004.png": 1195,
	"./H48103/Decors_colored/G07_white/0005.png": 1196,
	"./H48103/Decors_colored/G07_white/0006.png": 1197,
	"./H48103/Decors_colored/G07_white/0007.png": 1198,
	"./H48103/Decors_colored/G07_white/0008.png": 1199,
	"./H48103/Decors_colored/G07_white/0009.png": 1200,
	"./H48103/Decors_colored/G07_white/0010.png": 1201,
	"./H48103/Decors_colored/G07_white/0011.png": 1202,
	"./H48103/Decors_colored/G07_white/0012.png": 1203,
	"./H48103/Decors_colored/G07_white/0013.png": 1204,
	"./H48103/Decors_colored/G07_white/0014.png": 1205,
	"./H48103/Decors_colored/G07_white/0015.png": 1206,
	"./H48103/Decors_colored/G07_white/0016.png": 1207,
	"./H48103/Decors_colored/G07_white/0017.png": 1208,
	"./H48103/Decors_colored/G07_white/0018.png": 1209,
	"./H48103/Decors_colored/G08_black/0001.png": 1210,
	"./H48103/Decors_colored/G08_black/0002.png": 1211,
	"./H48103/Decors_colored/G08_black/0003.png": 1212,
	"./H48103/Decors_colored/G08_black/0004.png": 1213,
	"./H48103/Decors_colored/G08_black/0005.png": 1214,
	"./H48103/Decors_colored/G08_black/0006.png": 1215,
	"./H48103/Decors_colored/G08_black/0007.png": 1216,
	"./H48103/Decors_colored/G08_black/0008.png": 1217,
	"./H48103/Decors_colored/G08_black/0009.png": 1218,
	"./H48103/Decors_colored/G08_black/0010.png": 1219,
	"./H48103/Decors_colored/G08_black/0011.png": 1220,
	"./H48103/Decors_colored/G08_black/0012.png": 1221,
	"./H48103/Decors_colored/G08_black/0013.png": 1222,
	"./H48103/Decors_colored/G08_black/0014.png": 1223,
	"./H48103/Decors_colored/G08_black/0015.png": 1224,
	"./H48103/Decors_colored/G08_black/0016.png": 1225,
	"./H48103/Decors_colored/G08_black/0017.png": 1226,
	"./H48103/Decors_colored/G08_black/0018.png": 1227,
	"./H48103/Decors_colored/G08_white/0001.png": 1228,
	"./H48103/Decors_colored/G08_white/0002.png": 1229,
	"./H48103/Decors_colored/G08_white/0003.png": 1230,
	"./H48103/Decors_colored/G08_white/0004.png": 1231,
	"./H48103/Decors_colored/G08_white/0005.png": 1232,
	"./H48103/Decors_colored/G08_white/0006.png": 1233,
	"./H48103/Decors_colored/G08_white/0007.png": 1234,
	"./H48103/Decors_colored/G08_white/0008.png": 1235,
	"./H48103/Decors_colored/G08_white/0009.png": 1236,
	"./H48103/Decors_colored/G08_white/0010.png": 1237,
	"./H48103/Decors_colored/G08_white/0011.png": 1238,
	"./H48103/Decors_colored/G08_white/0012.png": 1239,
	"./H48103/Decors_colored/G08_white/0013.png": 1240,
	"./H48103/Decors_colored/G08_white/0014.png": 1241,
	"./H48103/Decors_colored/G08_white/0015.png": 1242,
	"./H48103/Decors_colored/G08_white/0016.png": 1243,
	"./H48103/Decors_colored/G08_white/0017.png": 1244,
	"./H48103/Decors_colored/G08_white/0018.png": 1245,
	"./H48103/Decors_colored/G09_black/0001.png": 1246,
	"./H48103/Decors_colored/G09_black/0002.png": 1247,
	"./H48103/Decors_colored/G09_black/0003.png": 1248,
	"./H48103/Decors_colored/G09_black/0004.png": 1249,
	"./H48103/Decors_colored/G09_black/0005.png": 1250,
	"./H48103/Decors_colored/G09_black/0006.png": 1251,
	"./H48103/Decors_colored/G09_black/0007.png": 1252,
	"./H48103/Decors_colored/G09_black/0008.png": 1253,
	"./H48103/Decors_colored/G09_black/0009.png": 1254,
	"./H48103/Decors_colored/G09_black/0010.png": 1255,
	"./H48103/Decors_colored/G09_black/0011.png": 1256,
	"./H48103/Decors_colored/G09_black/0012.png": 1257,
	"./H48103/Decors_colored/G09_black/0013.png": 1258,
	"./H48103/Decors_colored/G09_black/0014.png": 1259,
	"./H48103/Decors_colored/G09_black/0015.png": 1260,
	"./H48103/Decors_colored/G09_black/0016.png": 1261,
	"./H48103/Decors_colored/G09_black/0017.png": 1262,
	"./H48103/Decors_colored/G09_black/0018.png": 1263,
	"./H48103/Decors_colored/G09_white/0001.png": 1264,
	"./H48103/Decors_colored/G09_white/0002.png": 1265,
	"./H48103/Decors_colored/G09_white/0003.png": 1266,
	"./H48103/Decors_colored/G09_white/0004.png": 1267,
	"./H48103/Decors_colored/G09_white/0005.png": 1268,
	"./H48103/Decors_colored/G09_white/0006.png": 1269,
	"./H48103/Decors_colored/G09_white/0007.png": 1270,
	"./H48103/Decors_colored/G09_white/0008.png": 1271,
	"./H48103/Decors_colored/G09_white/0009.png": 1272,
	"./H48103/Decors_colored/G09_white/0010.png": 1273,
	"./H48103/Decors_colored/G09_white/0011.png": 1274,
	"./H48103/Decors_colored/G09_white/0012.png": 1275,
	"./H48103/Decors_colored/G09_white/0013.png": 1276,
	"./H48103/Decors_colored/G09_white/0014.png": 1277,
	"./H48103/Decors_colored/G09_white/0015.png": 1278,
	"./H48103/Decors_colored/G09_white/0016.png": 1279,
	"./H48103/Decors_colored/G09_white/0017.png": 1280,
	"./H48103/Decors_colored/G09_white/0018.png": 1281,
	"./H48103/Decors_colored/G10_black/0001.png": 1282,
	"./H48103/Decors_colored/G10_black/0002.png": 1283,
	"./H48103/Decors_colored/G10_black/0003.png": 1284,
	"./H48103/Decors_colored/G10_black/0004.png": 1285,
	"./H48103/Decors_colored/G10_black/0005.png": 1286,
	"./H48103/Decors_colored/G10_black/0006.png": 1287,
	"./H48103/Decors_colored/G10_black/0007.png": 1288,
	"./H48103/Decors_colored/G10_black/0008.png": 1289,
	"./H48103/Decors_colored/G10_black/0009.png": 1290,
	"./H48103/Decors_colored/G10_black/0010.png": 1291,
	"./H48103/Decors_colored/G10_black/0011.png": 1292,
	"./H48103/Decors_colored/G10_black/0012.png": 1293,
	"./H48103/Decors_colored/G10_black/0013.png": 1294,
	"./H48103/Decors_colored/G10_black/0014.png": 1295,
	"./H48103/Decors_colored/G10_black/0015.png": 1296,
	"./H48103/Decors_colored/G10_black/0016.png": 1297,
	"./H48103/Decors_colored/G10_black/0017.png": 1298,
	"./H48103/Decors_colored/G10_black/0018.png": 1299,
	"./H48103/Decors_colored/G10_white/0001.png": 1300,
	"./H48103/Decors_colored/G10_white/0002.png": 1301,
	"./H48103/Decors_colored/G10_white/0003.png": 1302,
	"./H48103/Decors_colored/G10_white/0004.png": 1303,
	"./H48103/Decors_colored/G10_white/0005.png": 1304,
	"./H48103/Decors_colored/G10_white/0006.png": 1305,
	"./H48103/Decors_colored/G10_white/0007.png": 1306,
	"./H48103/Decors_colored/G10_white/0008.png": 1307,
	"./H48103/Decors_colored/G10_white/0009.png": 1308,
	"./H48103/Decors_colored/G10_white/0010.png": 1309,
	"./H48103/Decors_colored/G10_white/0011.png": 1310,
	"./H48103/Decors_colored/G10_white/0012.png": 1311,
	"./H48103/Decors_colored/G10_white/0013.png": 1312,
	"./H48103/Decors_colored/G10_white/0014.png": 1313,
	"./H48103/Decors_colored/G10_white/0015.png": 1314,
	"./H48103/Decors_colored/G10_white/0016.png": 1315,
	"./H48103/Decors_colored/G10_white/0017.png": 1316,
	"./H48103/Decors_colored/G10_white/0018.png": 1317,
	"./H48103/Decors_colored/N01_black/0001.png": 1318,
	"./H48103/Decors_colored/N01_black/0002.png": 1319,
	"./H48103/Decors_colored/N01_black/0003.png": 1320,
	"./H48103/Decors_colored/N01_black/0004.png": 1321,
	"./H48103/Decors_colored/N01_black/0005.png": 1322,
	"./H48103/Decors_colored/N01_black/0006.png": 1323,
	"./H48103/Decors_colored/N01_black/0007.png": 1324,
	"./H48103/Decors_colored/N01_black/0008.png": 1325,
	"./H48103/Decors_colored/N01_black/0009.png": 1326,
	"./H48103/Decors_colored/N01_black/0010.png": 1327,
	"./H48103/Decors_colored/N01_black/0011.png": 1328,
	"./H48103/Decors_colored/N01_black/0012.png": 1329,
	"./H48103/Decors_colored/N01_black/0013.png": 1330,
	"./H48103/Decors_colored/N01_black/0014.png": 1331,
	"./H48103/Decors_colored/N01_black/0015.png": 1332,
	"./H48103/Decors_colored/N01_black/0016.png": 1333,
	"./H48103/Decors_colored/N01_black/0017.png": 1334,
	"./H48103/Decors_colored/N01_black/0018.png": 1335,
	"./H48103/Decors_colored/N01_white/0001.png": 1336,
	"./H48103/Decors_colored/N01_white/0002.png": 1337,
	"./H48103/Decors_colored/N01_white/0003.png": 1338,
	"./H48103/Decors_colored/N01_white/0004.png": 1339,
	"./H48103/Decors_colored/N01_white/0005.png": 1340,
	"./H48103/Decors_colored/N01_white/0006.png": 1341,
	"./H48103/Decors_colored/N01_white/0007.png": 1342,
	"./H48103/Decors_colored/N01_white/0008.png": 1343,
	"./H48103/Decors_colored/N01_white/0009.png": 1344,
	"./H48103/Decors_colored/N01_white/0010.png": 1345,
	"./H48103/Decors_colored/N01_white/0011.png": 1346,
	"./H48103/Decors_colored/N01_white/0012.png": 1347,
	"./H48103/Decors_colored/N01_white/0013.png": 1348,
	"./H48103/Decors_colored/N01_white/0014.png": 1349,
	"./H48103/Decors_colored/N01_white/0015.png": 1350,
	"./H48103/Decors_colored/N01_white/0016.png": 1351,
	"./H48103/Decors_colored/N01_white/0017.png": 1352,
	"./H48103/Decors_colored/N01_white/0018.png": 1353,
	"./H48103/Decors_colored/N02_black/0001.png": 1354,
	"./H48103/Decors_colored/N02_black/0002.png": 1355,
	"./H48103/Decors_colored/N02_black/0003.png": 1356,
	"./H48103/Decors_colored/N02_black/0004.png": 1357,
	"./H48103/Decors_colored/N02_black/0005.png": 1358,
	"./H48103/Decors_colored/N02_black/0006.png": 1359,
	"./H48103/Decors_colored/N02_black/0007.png": 1360,
	"./H48103/Decors_colored/N02_black/0008.png": 1361,
	"./H48103/Decors_colored/N02_black/0009.png": 1362,
	"./H48103/Decors_colored/N02_black/0010.png": 1363,
	"./H48103/Decors_colored/N02_black/0011.png": 1364,
	"./H48103/Decors_colored/N02_black/0012.png": 1365,
	"./H48103/Decors_colored/N02_black/0013.png": 1366,
	"./H48103/Decors_colored/N02_black/0014.png": 1367,
	"./H48103/Decors_colored/N02_black/0015.png": 1368,
	"./H48103/Decors_colored/N02_black/0016.png": 1369,
	"./H48103/Decors_colored/N02_black/0017.png": 1370,
	"./H48103/Decors_colored/N02_black/0018.png": 1371,
	"./H48103/Decors_colored/N02_white/0001.png": 1372,
	"./H48103/Decors_colored/N02_white/0002.png": 1373,
	"./H48103/Decors_colored/N02_white/0003.png": 1374,
	"./H48103/Decors_colored/N02_white/0004.png": 1375,
	"./H48103/Decors_colored/N02_white/0005.png": 1376,
	"./H48103/Decors_colored/N02_white/0006.png": 1377,
	"./H48103/Decors_colored/N02_white/0007.png": 1378,
	"./H48103/Decors_colored/N02_white/0008.png": 1379,
	"./H48103/Decors_colored/N02_white/0009.png": 1380,
	"./H48103/Decors_colored/N02_white/0010.png": 1381,
	"./H48103/Decors_colored/N02_white/0011.png": 1382,
	"./H48103/Decors_colored/N02_white/0012.png": 1383,
	"./H48103/Decors_colored/N02_white/0013.png": 1384,
	"./H48103/Decors_colored/N02_white/0014.png": 1385,
	"./H48103/Decors_colored/N02_white/0015.png": 1386,
	"./H48103/Decors_colored/N02_white/0016.png": 1387,
	"./H48103/Decors_colored/N02_white/0017.png": 1388,
	"./H48103/Decors_colored/N02_white/0018.png": 1389,
	"./H48103/Decors_colored/N03_black/0001.png": 1390,
	"./H48103/Decors_colored/N03_black/0002.png": 1391,
	"./H48103/Decors_colored/N03_black/0003.png": 1392,
	"./H48103/Decors_colored/N03_black/0004.png": 1393,
	"./H48103/Decors_colored/N03_black/0005.png": 1394,
	"./H48103/Decors_colored/N03_black/0006.png": 1395,
	"./H48103/Decors_colored/N03_black/0007.png": 1396,
	"./H48103/Decors_colored/N03_black/0008.png": 1397,
	"./H48103/Decors_colored/N03_black/0009.png": 1398,
	"./H48103/Decors_colored/N03_black/0010.png": 1399,
	"./H48103/Decors_colored/N03_black/0011.png": 1400,
	"./H48103/Decors_colored/N03_black/0012.png": 1401,
	"./H48103/Decors_colored/N03_black/0013.png": 1402,
	"./H48103/Decors_colored/N03_black/0014.png": 1403,
	"./H48103/Decors_colored/N03_black/0015.png": 1404,
	"./H48103/Decors_colored/N03_black/0016.png": 1405,
	"./H48103/Decors_colored/N03_black/0017.png": 1406,
	"./H48103/Decors_colored/N03_black/0018.png": 1407,
	"./H48103/Decors_colored/N03_white/0001.png": 1408,
	"./H48103/Decors_colored/N03_white/0002.png": 1409,
	"./H48103/Decors_colored/N03_white/0003.png": 1410,
	"./H48103/Decors_colored/N03_white/0004.png": 1411,
	"./H48103/Decors_colored/N03_white/0005.png": 1412,
	"./H48103/Decors_colored/N03_white/0006.png": 1413,
	"./H48103/Decors_colored/N03_white/0007.png": 1414,
	"./H48103/Decors_colored/N03_white/0008.png": 1415,
	"./H48103/Decors_colored/N03_white/0009.png": 1416,
	"./H48103/Decors_colored/N03_white/0010.png": 1417,
	"./H48103/Decors_colored/N03_white/0011.png": 1418,
	"./H48103/Decors_colored/N03_white/0012.png": 1419,
	"./H48103/Decors_colored/N03_white/0013.png": 1420,
	"./H48103/Decors_colored/N03_white/0014.png": 1421,
	"./H48103/Decors_colored/N03_white/0015.png": 1422,
	"./H48103/Decors_colored/N03_white/0016.png": 1423,
	"./H48103/Decors_colored/N03_white/0017.png": 1424,
	"./H48103/Decors_colored/N03_white/0018.png": 1425,
	"./H48103/Decors_colored/N04_black/0001.png": 1426,
	"./H48103/Decors_colored/N04_black/0002.png": 1427,
	"./H48103/Decors_colored/N04_black/0003.png": 1428,
	"./H48103/Decors_colored/N04_black/0004.png": 1429,
	"./H48103/Decors_colored/N04_black/0005.png": 1430,
	"./H48103/Decors_colored/N04_black/0006.png": 1431,
	"./H48103/Decors_colored/N04_black/0007.png": 1432,
	"./H48103/Decors_colored/N04_black/0008.png": 1433,
	"./H48103/Decors_colored/N04_black/0009.png": 1434,
	"./H48103/Decors_colored/N04_black/0010.png": 1435,
	"./H48103/Decors_colored/N04_black/0011.png": 1436,
	"./H48103/Decors_colored/N04_black/0012.png": 1437,
	"./H48103/Decors_colored/N04_black/0013.png": 1438,
	"./H48103/Decors_colored/N04_black/0014.png": 1439,
	"./H48103/Decors_colored/N04_black/0015.png": 1440,
	"./H48103/Decors_colored/N04_black/0016.png": 1441,
	"./H48103/Decors_colored/N04_black/0017.png": 1442,
	"./H48103/Decors_colored/N04_black/0018.png": 1443,
	"./H48103/Decors_colored/N04_white/0001.png": 1444,
	"./H48103/Decors_colored/N04_white/0002.png": 1445,
	"./H48103/Decors_colored/N04_white/0003.png": 1446,
	"./H48103/Decors_colored/N04_white/0004.png": 1447,
	"./H48103/Decors_colored/N04_white/0005.png": 1448,
	"./H48103/Decors_colored/N04_white/0006.png": 1449,
	"./H48103/Decors_colored/N04_white/0007.png": 1450,
	"./H48103/Decors_colored/N04_white/0008.png": 1451,
	"./H48103/Decors_colored/N04_white/0009.png": 1452,
	"./H48103/Decors_colored/N04_white/0010.png": 1453,
	"./H48103/Decors_colored/N04_white/0011.png": 1454,
	"./H48103/Decors_colored/N04_white/0012.png": 1455,
	"./H48103/Decors_colored/N04_white/0013.png": 1456,
	"./H48103/Decors_colored/N04_white/0014.png": 1457,
	"./H48103/Decors_colored/N04_white/0015.png": 1458,
	"./H48103/Decors_colored/N04_white/0016.png": 1459,
	"./H48103/Decors_colored/N04_white/0017.png": 1460,
	"./H48103/Decors_colored/N04_white/0018.png": 1461,
	"./H48103/Decors_colored/N05_black/0001.png": 1462,
	"./H48103/Decors_colored/N05_black/0002.png": 1463,
	"./H48103/Decors_colored/N05_black/0003.png": 1464,
	"./H48103/Decors_colored/N05_black/0004.png": 1465,
	"./H48103/Decors_colored/N05_black/0005.png": 1466,
	"./H48103/Decors_colored/N05_black/0006.png": 1467,
	"./H48103/Decors_colored/N05_black/0007.png": 1468,
	"./H48103/Decors_colored/N05_black/0008.png": 1469,
	"./H48103/Decors_colored/N05_black/0009.png": 1470,
	"./H48103/Decors_colored/N05_black/0010.png": 1471,
	"./H48103/Decors_colored/N05_black/0011.png": 1472,
	"./H48103/Decors_colored/N05_black/0012.png": 1473,
	"./H48103/Decors_colored/N05_black/0013.png": 1474,
	"./H48103/Decors_colored/N05_black/0014.png": 1475,
	"./H48103/Decors_colored/N05_black/0015.png": 1476,
	"./H48103/Decors_colored/N05_black/0016.png": 1477,
	"./H48103/Decors_colored/N05_black/0017.png": 1478,
	"./H48103/Decors_colored/N05_black/0018.png": 1479,
	"./H48103/Decors_colored/N05_white/0001.png": 1480,
	"./H48103/Decors_colored/N05_white/0002.png": 1481,
	"./H48103/Decors_colored/N05_white/0003.png": 1482,
	"./H48103/Decors_colored/N05_white/0004.png": 1483,
	"./H48103/Decors_colored/N05_white/0005.png": 1484,
	"./H48103/Decors_colored/N05_white/0006.png": 1485,
	"./H48103/Decors_colored/N05_white/0007.png": 1486,
	"./H48103/Decors_colored/N05_white/0008.png": 1487,
	"./H48103/Decors_colored/N05_white/0009.png": 1488,
	"./H48103/Decors_colored/N05_white/0010.png": 1489,
	"./H48103/Decors_colored/N05_white/0011.png": 1490,
	"./H48103/Decors_colored/N05_white/0012.png": 1491,
	"./H48103/Decors_colored/N05_white/0013.png": 1492,
	"./H48103/Decors_colored/N05_white/0014.png": 1493,
	"./H48103/Decors_colored/N05_white/0015.png": 1494,
	"./H48103/Decors_colored/N05_white/0016.png": 1495,
	"./H48103/Decors_colored/N05_white/0017.png": 1496,
	"./H48103/Decors_colored/N05_white/0018.png": 1497,
	"./H48103/Decors_colored/N06_black/0001.png": 1498,
	"./H48103/Decors_colored/N06_black/0002.png": 1499,
	"./H48103/Decors_colored/N06_black/0003.png": 1500,
	"./H48103/Decors_colored/N06_black/0004.png": 1501,
	"./H48103/Decors_colored/N06_black/0005.png": 1502,
	"./H48103/Decors_colored/N06_black/0006.png": 1503,
	"./H48103/Decors_colored/N06_black/0007.png": 1504,
	"./H48103/Decors_colored/N06_black/0008.png": 1505,
	"./H48103/Decors_colored/N06_black/0009.png": 1506,
	"./H48103/Decors_colored/N06_black/0010.png": 1507,
	"./H48103/Decors_colored/N06_black/0011.png": 1508,
	"./H48103/Decors_colored/N06_black/0012.png": 1509,
	"./H48103/Decors_colored/N06_black/0013.png": 1510,
	"./H48103/Decors_colored/N06_black/0014.png": 1511,
	"./H48103/Decors_colored/N06_black/0015.png": 1512,
	"./H48103/Decors_colored/N06_black/0016.png": 1513,
	"./H48103/Decors_colored/N06_black/0017.png": 1514,
	"./H48103/Decors_colored/N06_black/0018.png": 1515,
	"./H48103/Decors_colored/N06_white/0001.png": 1516,
	"./H48103/Decors_colored/N06_white/0002.png": 1517,
	"./H48103/Decors_colored/N06_white/0003.png": 1518,
	"./H48103/Decors_colored/N06_white/0004.png": 1519,
	"./H48103/Decors_colored/N06_white/0005.png": 1520,
	"./H48103/Decors_colored/N06_white/0006.png": 1521,
	"./H48103/Decors_colored/N06_white/0007.png": 1522,
	"./H48103/Decors_colored/N06_white/0008.png": 1523,
	"./H48103/Decors_colored/N06_white/0009.png": 1524,
	"./H48103/Decors_colored/N06_white/0010.png": 1525,
	"./H48103/Decors_colored/N06_white/0011.png": 1526,
	"./H48103/Decors_colored/N06_white/0012.png": 1527,
	"./H48103/Decors_colored/N06_white/0013.png": 1528,
	"./H48103/Decors_colored/N06_white/0014.png": 1529,
	"./H48103/Decors_colored/N06_white/0015.png": 1530,
	"./H48103/Decors_colored/N06_white/0016.png": 1531,
	"./H48103/Decors_colored/N06_white/0017.png": 1532,
	"./H48103/Decors_colored/N06_white/0018.png": 1533,
	"./H48103/Decors_colored/N08_black/0001.png": 1534,
	"./H48103/Decors_colored/N08_black/0002.png": 1535,
	"./H48103/Decors_colored/N08_black/0003.png": 1536,
	"./H48103/Decors_colored/N08_black/0004.png": 1537,
	"./H48103/Decors_colored/N08_black/0005.png": 1538,
	"./H48103/Decors_colored/N08_black/0006.png": 1539,
	"./H48103/Decors_colored/N08_black/0007.png": 1540,
	"./H48103/Decors_colored/N08_black/0008.png": 1541,
	"./H48103/Decors_colored/N08_black/0009.png": 1542,
	"./H48103/Decors_colored/N08_black/0010.png": 1543,
	"./H48103/Decors_colored/N08_black/0011.png": 1544,
	"./H48103/Decors_colored/N08_black/0012.png": 1545,
	"./H48103/Decors_colored/N08_black/0013.png": 1546,
	"./H48103/Decors_colored/N08_black/0014.png": 1547,
	"./H48103/Decors_colored/N08_black/0015.png": 1548,
	"./H48103/Decors_colored/N08_black/0016.png": 1549,
	"./H48103/Decors_colored/N08_black/0017.png": 1550,
	"./H48103/Decors_colored/N08_black/0018.png": 1551,
	"./H48103/Decors_colored/N08_white/0001.png": 1552,
	"./H48103/Decors_colored/N08_white/0002.png": 1553,
	"./H48103/Decors_colored/N08_white/0003.png": 1554,
	"./H48103/Decors_colored/N08_white/0004.png": 1555,
	"./H48103/Decors_colored/N08_white/0005.png": 1556,
	"./H48103/Decors_colored/N08_white/0006.png": 1557,
	"./H48103/Decors_colored/N08_white/0007.png": 1558,
	"./H48103/Decors_colored/N08_white/0008.png": 1559,
	"./H48103/Decors_colored/N08_white/0009.png": 1560,
	"./H48103/Decors_colored/N08_white/0010.png": 1561,
	"./H48103/Decors_colored/N08_white/0011.png": 1562,
	"./H48103/Decors_colored/N08_white/0012.png": 1563,
	"./H48103/Decors_colored/N08_white/0013.png": 1564,
	"./H48103/Decors_colored/N08_white/0014.png": 1565,
	"./H48103/Decors_colored/N08_white/0015.png": 1566,
	"./H48103/Decors_colored/N08_white/0016.png": 1567,
	"./H48103/Decors_colored/N08_white/0017.png": 1568,
	"./H48103/Decors_colored/N08_white/0018.png": 1569,
	"./H48103/RAL/0001.png": 1570,
	"./H48103/RAL/0002.png": 1571,
	"./H48103/RAL/0003.png": 1572,
	"./H48103/RAL/0004.png": 1573,
	"./H48103/RAL/0005.png": 1574,
	"./H48103/RAL/0006.png": 1575,
	"./H48103/RAL/0007.png": 1576,
	"./H48103/RAL/0008.png": 1577,
	"./H48103/RAL/0009.png": 1578,
	"./H48103/RAL/0010.png": 1579,
	"./H48103/RAL/0011.png": 1580,
	"./H48103/RAL/0012.png": 1581,
	"./H48103/RAL/0013.png": 1582,
	"./H48103/RAL/0014.png": 1583,
	"./H48103/RAL/0015.png": 1584,
	"./H48103/RAL/0016.png": 1585,
	"./H48103/RAL/0017.png": 1586,
	"./H48103/RAL/0018.png": 1587,
	"./H48103/RAL/0019.png": 1588,
	"./H48103/RAL/0020.png": 1589,
	"./H48103/RAL/0021.png": 1590,
	"./H48103/RAL/0022.png": 1591,
	"./H48103/RAL/0023.png": 1592,
	"./H48103/RAL/0024.png": 1593,
	"./H48103/RAL/0025.png": 1594,
	"./H48103/RAL/0026.png": 1595,
	"./H48103/RAL/0027.png": 1596,
	"./H48103/RAL/0028.png": 1597,
	"./H48103/RAL/0029.png": 1598,
	"./H48103/RAL/0030.png": 1599,
	"./H48103/RAL/0031.png": 1600,
	"./H48103/RAL/0032.png": 1601,
	"./H48103/RAL/0033.png": 1602,
	"./H48103/RAL/0034.png": 1603,
	"./H48103/RAL/0035.png": 1604,
	"./H48103/RAL/0036.png": 1605,
	"./H48103/RAL/0037.png": 1606,
	"./H48103/RAL/0038.png": 1607,
	"./H48103/RAL/0039.png": 1608,
	"./H48103/RAL/0040.png": 1609,
	"./H48103/RAL/0041.png": 1610,
	"./H48103/RAL/0042.png": 1611,
	"./H48103/RAL/0043.png": 1612,
	"./H48103/RAL/0044.png": 1613,
	"./H48103/RAL/0045.png": 1614,
	"./H48103/RAL/0046.png": 1615,
	"./H48103/RAL/0047.png": 1616,
	"./H48103/RAL/0048.png": 1617,
	"./H48104/Anodized/0001.png": 1618,
	"./H48104/Chassis_RAL/0001.png": 1619,
	"./H48104/Chassis_RAL/0002.png": 1620,
	"./H48104/Chassis_RAL/0003.png": 1621,
	"./H48104/Chassis_RAL/0004.png": 1622,
	"./H48104/Chassis_RAL/0005.png": 1623,
	"./H48104/Chassis_RAL/0006.png": 1624,
	"./H48104/Chassis_RAL/0007.png": 1625,
	"./H48104/Chassis_RAL/0008.png": 1626,
	"./H48104/Chassis_RAL/0009.png": 1627,
	"./H48104/Chassis_RAL/0010.png": 1628,
	"./H48104/Chassis_RAL/0011.png": 1629,
	"./H48104/Chassis_RAL/0012.png": 1630,
	"./H48104/Chassis_RAL/0013.png": 1631,
	"./H48104/Chassis_RAL/0014.png": 1632,
	"./H48104/Chassis_RAL/0015.png": 1633,
	"./H48104/Chassis_RAL/0016.png": 1634,
	"./H48104/Chassis_RAL/0017.png": 1635,
	"./H48104/Chassis_RAL/0018.png": 1636,
	"./H48104/Chassis_RAL/0019.png": 1637,
	"./H48104/Chassis_RAL/0020.png": 1638,
	"./H48104/Chassis_RAL/0021.png": 1639,
	"./H48104/Chassis_RAL/0022.png": 1640,
	"./H48104/Chassis_RAL/0023.png": 1641,
	"./H48104/Chassis_RAL/0024.png": 1642,
	"./H48104/Chassis_RAL/0025.png": 1643,
	"./H48104/Chassis_RAL/0026.png": 1644,
	"./H48104/Chassis_RAL/0027.png": 1645,
	"./H48104/Chassis_RAL/0028.png": 1646,
	"./H48104/Chassis_RAL/0029.png": 1647,
	"./H48104/Chassis_RAL/0030.png": 1648,
	"./H48104/Chassis_RAL/0031.png": 1649,
	"./H48104/Chassis_RAL/0032.png": 1650,
	"./H48104/Chassis_RAL/0033.png": 1651,
	"./H48104/Chassis_RAL/0034.png": 1652,
	"./H48104/Chassis_RAL/0035.png": 1653,
	"./H48104/Chassis_RAL/0036.png": 1654,
	"./H48104/Chassis_RAL/0037.png": 1655,
	"./H48104/Chassis_RAL/0038.png": 1656,
	"./H48104/Chassis_RAL/0039.png": 1657,
	"./H48104/Chassis_RAL/0040.png": 1658,
	"./H48104/Chassis_RAL/0041.png": 1659,
	"./H48104/Chassis_RAL/0042.png": 1660,
	"./H48104/Chassis_RAL/0043.png": 1661,
	"./H48104/Chassis_RAL/0044.png": 1662,
	"./H48104/Chassis_RAL/0045.png": 1663,
	"./H48104/Chassis_RAL/0046.png": 1664,
	"./H48104/Chassis_RAL/0047.png": 1665,
	"./H48104/Chassis_RAL/0048.png": 1666,
	"./H48104/Customs/Customs_black/0001.png": 1667,
	"./H48104/Customs/Customs_black/0002.png": 1668,
	"./H48104/Customs/Customs_black/0003.png": 1669,
	"./H48104/Customs/Customs_black/0004.png": 1670,
	"./H48104/Customs/Customs_black/0005.png": 1671,
	"./H48104/Customs/Customs_white/0001.png": 1672,
	"./H48104/Customs/Customs_white/0002.png": 1673,
	"./H48104/Customs/Customs_white/0003.png": 1674,
	"./H48104/Customs/Customs_white/0004.png": 1675,
	"./H48104/Customs/Customs_white/0005.png": 1676,
	"./H48104/Decors/Decors_black/0001.png": 1677,
	"./H48104/Decors/Decors_black/0002.png": 1678,
	"./H48104/Decors/Decors_black/0003.png": 1679,
	"./H48104/Decors/Decors_black/0004.png": 1680,
	"./H48104/Decors/Decors_black/0005.png": 1681,
	"./H48104/Decors/Decors_black/0006.png": 1682,
	"./H48104/Decors/Decors_black/0007.png": 1683,
	"./H48104/Decors/Decors_black/0008.png": 1684,
	"./H48104/Decors/Decors_black/0009.png": 1685,
	"./H48104/Decors/Decors_black/0010.png": 1686,
	"./H48104/Decors/Decors_black/0011.png": 1687,
	"./H48104/Decors/Decors_black/0012.png": 1688,
	"./H48104/Decors/Decors_black/0013.png": 1689,
	"./H48104/Decors/Decors_black/0014.png": 1690,
	"./H48104/Decors/Decors_black/0015.png": 1691,
	"./H48104/Decors/Decors_black/0016.png": 1692,
	"./H48104/Decors/Decors_black/0017.png": 1693,
	"./H48104/Decors/Decors_black/0018.png": 1694,
	"./H48104/Decors/Decors_black/0019.png": 1695,
	"./H48104/Decors/Decors_black/0020.png": 1696,
	"./H48104/Decors/Decors_black/0021.png": 1697,
	"./H48104/Decors/Decors_black/0022.png": 1698,
	"./H48104/Decors/Decors_black/0023.png": 1699,
	"./H48104/Decors/Decors_black/0024.png": 1700,
	"./H48104/Decors/Decors_black/0025.png": 1701,
	"./H48104/Decors/Decors_black/0026.png": 1702,
	"./H48104/Decors/Decors_black/0027.png": 1703,
	"./H48104/Decors/Decors_black/0028.png": 1704,
	"./H48104/Decors/Decors_black/0029.png": 1705,
	"./H48104/Decors/Decors_black/0030.png": 1706,
	"./H48104/Decors/Decors_black/0031.png": 1707,
	"./H48104/Decors/Decors_black/0032.png": 1708,
	"./H48104/Decors/Decors_black/0033.png": 1709,
	"./H48104/Decors/Decors_black/0034.png": 1710,
	"./H48104/Decors/Decors_black/0035.png": 1711,
	"./H48104/Decors/Decors_black/0036.png": 1712,
	"./H48104/Decors/Decors_black/0037.png": 1713,
	"./H48104/Decors/Decors_black/0038.png": 1714,
	"./H48104/Decors/Decors_white/0001.png": 1715,
	"./H48104/Decors/Decors_white/0002.png": 1716,
	"./H48104/Decors/Decors_white/0003.png": 1717,
	"./H48104/Decors/Decors_white/0004.png": 1718,
	"./H48104/Decors/Decors_white/0005.png": 1719,
	"./H48104/Decors/Decors_white/0006.png": 1720,
	"./H48104/Decors/Decors_white/0007.png": 1721,
	"./H48104/Decors/Decors_white/0008.png": 1722,
	"./H48104/Decors/Decors_white/0009.png": 1723,
	"./H48104/Decors/Decors_white/0010.png": 1724,
	"./H48104/Decors/Decors_white/0011.png": 1725,
	"./H48104/Decors/Decors_white/0012.png": 1726,
	"./H48104/Decors/Decors_white/0013.png": 1727,
	"./H48104/Decors/Decors_white/0014.png": 1728,
	"./H48104/Decors/Decors_white/0015.png": 1729,
	"./H48104/Decors/Decors_white/0016.png": 1730,
	"./H48104/Decors/Decors_white/0017.png": 1731,
	"./H48104/Decors/Decors_white/0018.png": 1732,
	"./H48104/Decors/Decors_white/0019.png": 1733,
	"./H48104/Decors/Decors_white/0020.png": 1734,
	"./H48104/Decors/Decors_white/0021.png": 1735,
	"./H48104/Decors/Decors_white/0022.png": 1736,
	"./H48104/Decors/Decors_white/0023.png": 1737,
	"./H48104/Decors/Decors_white/0024.png": 1738,
	"./H48104/Decors/Decors_white/0025.png": 1739,
	"./H48104/Decors/Decors_white/0026.png": 1740,
	"./H48104/Decors/Decors_white/0027.png": 1741,
	"./H48104/Decors/Decors_white/0028.png": 1742,
	"./H48104/Decors/Decors_white/0029.png": 1743,
	"./H48104/Decors/Decors_white/0030.png": 1744,
	"./H48104/Decors/Decors_white/0031.png": 1745,
	"./H48104/Decors/Decors_white/0032.png": 1746,
	"./H48104/Decors/Decors_white/0033.png": 1747,
	"./H48104/Decors/Decors_white/0034.png": 1748,
	"./H48104/Decors/Decors_white/0035.png": 1749,
	"./H48104/Decors/Decors_white/0036.png": 1750,
	"./H48104/Decors/Decors_white/0037.png": 1751,
	"./H48104/Decors/Decors_white/0038.png": 1752,
	"./H48104/Decors_colored/C06_black/0001.png": 1753,
	"./H48104/Decors_colored/C06_black/0002.png": 1754,
	"./H48104/Decors_colored/C06_black/0003.png": 1755,
	"./H48104/Decors_colored/C06_black/0004.png": 1756,
	"./H48104/Decors_colored/C06_black/0005.png": 1757,
	"./H48104/Decors_colored/C06_black/0006.png": 1758,
	"./H48104/Decors_colored/C06_black/0007.png": 1759,
	"./H48104/Decors_colored/C06_black/0008.png": 1760,
	"./H48104/Decors_colored/C06_black/0009.png": 1761,
	"./H48104/Decors_colored/C06_black/0010.png": 1762,
	"./H48104/Decors_colored/C06_black/0011.png": 1763,
	"./H48104/Decors_colored/C06_black/0012.png": 1764,
	"./H48104/Decors_colored/C06_black/0013.png": 1765,
	"./H48104/Decors_colored/C06_black/0014.png": 1766,
	"./H48104/Decors_colored/C06_black/0015.png": 1767,
	"./H48104/Decors_colored/C06_black/0016.png": 1768,
	"./H48104/Decors_colored/C06_black/0017.png": 1769,
	"./H48104/Decors_colored/C06_black/0018.png": 1770,
	"./H48104/Decors_colored/C06_white/0001.png": 1771,
	"./H48104/Decors_colored/C06_white/0002.png": 1772,
	"./H48104/Decors_colored/C06_white/0003.png": 1773,
	"./H48104/Decors_colored/C06_white/0004.png": 1774,
	"./H48104/Decors_colored/C06_white/0005.png": 1775,
	"./H48104/Decors_colored/C06_white/0006.png": 1776,
	"./H48104/Decors_colored/C06_white/0007.png": 1777,
	"./H48104/Decors_colored/C06_white/0008.png": 1778,
	"./H48104/Decors_colored/C06_white/0009.png": 1779,
	"./H48104/Decors_colored/C06_white/0010.png": 1780,
	"./H48104/Decors_colored/C06_white/0011.png": 1781,
	"./H48104/Decors_colored/C06_white/0012.png": 1782,
	"./H48104/Decors_colored/C06_white/0013.png": 1783,
	"./H48104/Decors_colored/C06_white/0014.png": 1784,
	"./H48104/Decors_colored/C06_white/0015.png": 1785,
	"./H48104/Decors_colored/C06_white/0016.png": 1786,
	"./H48104/Decors_colored/C06_white/0017.png": 1787,
	"./H48104/Decors_colored/C06_white/0018.png": 1788,
	"./H48104/Decors_colored/C07_black/0001.png": 1789,
	"./H48104/Decors_colored/C07_black/0002.png": 1790,
	"./H48104/Decors_colored/C07_black/0003.png": 1791,
	"./H48104/Decors_colored/C07_black/0004.png": 1792,
	"./H48104/Decors_colored/C07_black/0005.png": 1793,
	"./H48104/Decors_colored/C07_black/0006.png": 1794,
	"./H48104/Decors_colored/C07_black/0007.png": 1795,
	"./H48104/Decors_colored/C07_black/0008.png": 1796,
	"./H48104/Decors_colored/C07_black/0009.png": 1797,
	"./H48104/Decors_colored/C07_black/0010.png": 1798,
	"./H48104/Decors_colored/C07_black/0011.png": 1799,
	"./H48104/Decors_colored/C07_black/0012.png": 1800,
	"./H48104/Decors_colored/C07_black/0013.png": 1801,
	"./H48104/Decors_colored/C07_black/0014.png": 1802,
	"./H48104/Decors_colored/C07_black/0015.png": 1803,
	"./H48104/Decors_colored/C07_black/0016.png": 1804,
	"./H48104/Decors_colored/C07_black/0017.png": 1805,
	"./H48104/Decors_colored/C07_black/0018.png": 1806,
	"./H48104/Decors_colored/C07_white/0001.png": 1807,
	"./H48104/Decors_colored/C07_white/0002.png": 1808,
	"./H48104/Decors_colored/C07_white/0003.png": 1809,
	"./H48104/Decors_colored/C07_white/0004.png": 1810,
	"./H48104/Decors_colored/C07_white/0005.png": 1811,
	"./H48104/Decors_colored/C07_white/0006.png": 1812,
	"./H48104/Decors_colored/C07_white/0007.png": 1813,
	"./H48104/Decors_colored/C07_white/0008.png": 1814,
	"./H48104/Decors_colored/C07_white/0009.png": 1815,
	"./H48104/Decors_colored/C07_white/0010.png": 1816,
	"./H48104/Decors_colored/C07_white/0011.png": 1817,
	"./H48104/Decors_colored/C07_white/0012.png": 1818,
	"./H48104/Decors_colored/C07_white/0013.png": 1819,
	"./H48104/Decors_colored/C07_white/0014.png": 1820,
	"./H48104/Decors_colored/C07_white/0015.png": 1821,
	"./H48104/Decors_colored/C07_white/0016.png": 1822,
	"./H48104/Decors_colored/C07_white/0017.png": 1823,
	"./H48104/Decors_colored/C07_white/0018.png": 1824,
	"./H48104/Decors_colored/G01_black/0001.png": 1825,
	"./H48104/Decors_colored/G01_black/0002.png": 1826,
	"./H48104/Decors_colored/G01_black/0003.png": 1827,
	"./H48104/Decors_colored/G01_black/0004.png": 1828,
	"./H48104/Decors_colored/G01_black/0005.png": 1829,
	"./H48104/Decors_colored/G01_black/0006.png": 1830,
	"./H48104/Decors_colored/G01_black/0007.png": 1831,
	"./H48104/Decors_colored/G01_black/0008.png": 1832,
	"./H48104/Decors_colored/G01_black/0009.png": 1833,
	"./H48104/Decors_colored/G01_black/0010.png": 1834,
	"./H48104/Decors_colored/G01_black/0011.png": 1835,
	"./H48104/Decors_colored/G01_black/0012.png": 1836,
	"./H48104/Decors_colored/G01_black/0013.png": 1837,
	"./H48104/Decors_colored/G01_black/0014.png": 1838,
	"./H48104/Decors_colored/G01_black/0015.png": 1839,
	"./H48104/Decors_colored/G01_black/0016.png": 1840,
	"./H48104/Decors_colored/G01_black/0017.png": 1841,
	"./H48104/Decors_colored/G01_black/0018.png": 1842,
	"./H48104/Decors_colored/G01_white/0001.png": 1843,
	"./H48104/Decors_colored/G01_white/0002.png": 1844,
	"./H48104/Decors_colored/G01_white/0003.png": 1845,
	"./H48104/Decors_colored/G01_white/0004.png": 1846,
	"./H48104/Decors_colored/G01_white/0005.png": 1847,
	"./H48104/Decors_colored/G01_white/0006.png": 1848,
	"./H48104/Decors_colored/G01_white/0007.png": 1849,
	"./H48104/Decors_colored/G01_white/0008.png": 1850,
	"./H48104/Decors_colored/G01_white/0009.png": 1851,
	"./H48104/Decors_colored/G01_white/0010.png": 1852,
	"./H48104/Decors_colored/G01_white/0011.png": 1853,
	"./H48104/Decors_colored/G01_white/0012.png": 1854,
	"./H48104/Decors_colored/G01_white/0013.png": 1855,
	"./H48104/Decors_colored/G01_white/0014.png": 1856,
	"./H48104/Decors_colored/G01_white/0015.png": 1857,
	"./H48104/Decors_colored/G01_white/0016.png": 1858,
	"./H48104/Decors_colored/G01_white/0017.png": 1859,
	"./H48104/Decors_colored/G01_white/0018.png": 1860,
	"./H48104/Decors_colored/G02_black/0001.png": 1861,
	"./H48104/Decors_colored/G02_black/0002.png": 1862,
	"./H48104/Decors_colored/G02_black/0003.png": 1863,
	"./H48104/Decors_colored/G02_black/0004.png": 1864,
	"./H48104/Decors_colored/G02_black/0005.png": 1865,
	"./H48104/Decors_colored/G02_black/0006.png": 1866,
	"./H48104/Decors_colored/G02_black/0007.png": 1867,
	"./H48104/Decors_colored/G02_black/0008.png": 1868,
	"./H48104/Decors_colored/G02_black/0009.png": 1869,
	"./H48104/Decors_colored/G02_black/0010.png": 1870,
	"./H48104/Decors_colored/G02_black/0011.png": 1871,
	"./H48104/Decors_colored/G02_black/0012.png": 1872,
	"./H48104/Decors_colored/G02_black/0013.png": 1873,
	"./H48104/Decors_colored/G02_black/0014.png": 1874,
	"./H48104/Decors_colored/G02_black/0015.png": 1875,
	"./H48104/Decors_colored/G02_black/0016.png": 1876,
	"./H48104/Decors_colored/G02_black/0017.png": 1877,
	"./H48104/Decors_colored/G02_black/0018.png": 1878,
	"./H48104/Decors_colored/G02_white/0001.png": 1879,
	"./H48104/Decors_colored/G02_white/0002.png": 1880,
	"./H48104/Decors_colored/G02_white/0003.png": 1881,
	"./H48104/Decors_colored/G02_white/0004.png": 1882,
	"./H48104/Decors_colored/G02_white/0005.png": 1883,
	"./H48104/Decors_colored/G02_white/0006.png": 1884,
	"./H48104/Decors_colored/G02_white/0007.png": 1885,
	"./H48104/Decors_colored/G02_white/0008.png": 1886,
	"./H48104/Decors_colored/G02_white/0009.png": 1887,
	"./H48104/Decors_colored/G02_white/0010.png": 1888,
	"./H48104/Decors_colored/G02_white/0011.png": 1889,
	"./H48104/Decors_colored/G02_white/0012.png": 1890,
	"./H48104/Decors_colored/G02_white/0013.png": 1891,
	"./H48104/Decors_colored/G02_white/0014.png": 1892,
	"./H48104/Decors_colored/G02_white/0015.png": 1893,
	"./H48104/Decors_colored/G02_white/0016.png": 1894,
	"./H48104/Decors_colored/G02_white/0017.png": 1895,
	"./H48104/Decors_colored/G02_white/0018.png": 1896,
	"./H48104/Decors_colored/G03_black/0001.png": 1897,
	"./H48104/Decors_colored/G03_black/0002.png": 1898,
	"./H48104/Decors_colored/G03_black/0003.png": 1899,
	"./H48104/Decors_colored/G03_black/0004.png": 1900,
	"./H48104/Decors_colored/G03_black/0005.png": 1901,
	"./H48104/Decors_colored/G03_black/0006.png": 1902,
	"./H48104/Decors_colored/G03_black/0007.png": 1903,
	"./H48104/Decors_colored/G03_black/0008.png": 1904,
	"./H48104/Decors_colored/G03_black/0009.png": 1905,
	"./H48104/Decors_colored/G03_black/0010.png": 1906,
	"./H48104/Decors_colored/G03_black/0011.png": 1907,
	"./H48104/Decors_colored/G03_black/0012.png": 1908,
	"./H48104/Decors_colored/G03_black/0013.png": 1909,
	"./H48104/Decors_colored/G03_black/0014.png": 1910,
	"./H48104/Decors_colored/G03_black/0015.png": 1911,
	"./H48104/Decors_colored/G03_black/0016.png": 1912,
	"./H48104/Decors_colored/G03_black/0017.png": 1913,
	"./H48104/Decors_colored/G03_black/0018.png": 1914,
	"./H48104/Decors_colored/G03_white/0001.png": 1915,
	"./H48104/Decors_colored/G03_white/0002.png": 1916,
	"./H48104/Decors_colored/G03_white/0003.png": 1917,
	"./H48104/Decors_colored/G03_white/0004.png": 1918,
	"./H48104/Decors_colored/G03_white/0005.png": 1919,
	"./H48104/Decors_colored/G03_white/0006.png": 1920,
	"./H48104/Decors_colored/G03_white/0007.png": 1921,
	"./H48104/Decors_colored/G03_white/0008.png": 1922,
	"./H48104/Decors_colored/G03_white/0009.png": 1923,
	"./H48104/Decors_colored/G03_white/0010.png": 1924,
	"./H48104/Decors_colored/G03_white/0011.png": 1925,
	"./H48104/Decors_colored/G03_white/0012.png": 1926,
	"./H48104/Decors_colored/G03_white/0013.png": 1927,
	"./H48104/Decors_colored/G03_white/0014.png": 1928,
	"./H48104/Decors_colored/G03_white/0015.png": 1929,
	"./H48104/Decors_colored/G03_white/0016.png": 1930,
	"./H48104/Decors_colored/G03_white/0017.png": 1931,
	"./H48104/Decors_colored/G03_white/0018.png": 1932,
	"./H48104/Decors_colored/G04_black/0001.png": 1933,
	"./H48104/Decors_colored/G04_black/0002.png": 1934,
	"./H48104/Decors_colored/G04_black/0003.png": 1935,
	"./H48104/Decors_colored/G04_black/0004.png": 1936,
	"./H48104/Decors_colored/G04_black/0005.png": 1937,
	"./H48104/Decors_colored/G04_black/0006.png": 1938,
	"./H48104/Decors_colored/G04_black/0007.png": 1939,
	"./H48104/Decors_colored/G04_black/0008.png": 1940,
	"./H48104/Decors_colored/G04_black/0009.png": 1941,
	"./H48104/Decors_colored/G04_black/0010.png": 1942,
	"./H48104/Decors_colored/G04_black/0011.png": 1943,
	"./H48104/Decors_colored/G04_black/0012.png": 1944,
	"./H48104/Decors_colored/G04_black/0013.png": 1945,
	"./H48104/Decors_colored/G04_black/0014.png": 1946,
	"./H48104/Decors_colored/G04_black/0015.png": 1947,
	"./H48104/Decors_colored/G04_black/0016.png": 1948,
	"./H48104/Decors_colored/G04_black/0017.png": 1949,
	"./H48104/Decors_colored/G04_black/0018.png": 1950,
	"./H48104/Decors_colored/G04_white/0001.png": 1951,
	"./H48104/Decors_colored/G04_white/0002.png": 1952,
	"./H48104/Decors_colored/G04_white/0003.png": 1953,
	"./H48104/Decors_colored/G04_white/0004.png": 1954,
	"./H48104/Decors_colored/G04_white/0005.png": 1955,
	"./H48104/Decors_colored/G04_white/0006.png": 1956,
	"./H48104/Decors_colored/G04_white/0007.png": 1957,
	"./H48104/Decors_colored/G04_white/0008.png": 1958,
	"./H48104/Decors_colored/G04_white/0009.png": 1959,
	"./H48104/Decors_colored/G04_white/0010.png": 1960,
	"./H48104/Decors_colored/G04_white/0011.png": 1961,
	"./H48104/Decors_colored/G04_white/0012.png": 1962,
	"./H48104/Decors_colored/G04_white/0013.png": 1963,
	"./H48104/Decors_colored/G04_white/0014.png": 1964,
	"./H48104/Decors_colored/G04_white/0015.png": 1965,
	"./H48104/Decors_colored/G04_white/0016.png": 1966,
	"./H48104/Decors_colored/G04_white/0017.png": 1967,
	"./H48104/Decors_colored/G04_white/0018.png": 1968,
	"./H48104/Decors_colored/G05_black/0001.png": 1969,
	"./H48104/Decors_colored/G05_black/0002.png": 1970,
	"./H48104/Decors_colored/G05_black/0003.png": 1971,
	"./H48104/Decors_colored/G05_black/0004.png": 1972,
	"./H48104/Decors_colored/G05_black/0005.png": 1973,
	"./H48104/Decors_colored/G05_black/0006.png": 1974,
	"./H48104/Decors_colored/G05_black/0007.png": 1975,
	"./H48104/Decors_colored/G05_black/0008.png": 1976,
	"./H48104/Decors_colored/G05_black/0009.png": 1977,
	"./H48104/Decors_colored/G05_black/0010.png": 1978,
	"./H48104/Decors_colored/G05_black/0011.png": 1979,
	"./H48104/Decors_colored/G05_black/0012.png": 1980,
	"./H48104/Decors_colored/G05_black/0013.png": 1981,
	"./H48104/Decors_colored/G05_black/0014.png": 1982,
	"./H48104/Decors_colored/G05_black/0015.png": 1983,
	"./H48104/Decors_colored/G05_black/0016.png": 1984,
	"./H48104/Decors_colored/G05_black/0017.png": 1985,
	"./H48104/Decors_colored/G05_black/0018.png": 1986,
	"./H48104/Decors_colored/G05_white/0001.png": 1987,
	"./H48104/Decors_colored/G05_white/0002.png": 1988,
	"./H48104/Decors_colored/G05_white/0003.png": 1989,
	"./H48104/Decors_colored/G05_white/0004.png": 1990,
	"./H48104/Decors_colored/G05_white/0005.png": 1991,
	"./H48104/Decors_colored/G05_white/0006.png": 1992,
	"./H48104/Decors_colored/G05_white/0007.png": 1993,
	"./H48104/Decors_colored/G05_white/0008.png": 1994,
	"./H48104/Decors_colored/G05_white/0009.png": 1995,
	"./H48104/Decors_colored/G05_white/0010.png": 1996,
	"./H48104/Decors_colored/G05_white/0011.png": 1997,
	"./H48104/Decors_colored/G05_white/0012.png": 1998,
	"./H48104/Decors_colored/G05_white/0013.png": 1999,
	"./H48104/Decors_colored/G05_white/0014.png": 2000,
	"./H48104/Decors_colored/G05_white/0015.png": 2001,
	"./H48104/Decors_colored/G05_white/0016.png": 2002,
	"./H48104/Decors_colored/G05_white/0017.png": 2003,
	"./H48104/Decors_colored/G05_white/0018.png": 2004,
	"./H48104/Decors_colored/G06_black/0001.png": 2005,
	"./H48104/Decors_colored/G06_black/0002.png": 2006,
	"./H48104/Decors_colored/G06_black/0003.png": 2007,
	"./H48104/Decors_colored/G06_black/0004.png": 2008,
	"./H48104/Decors_colored/G06_black/0005.png": 2009,
	"./H48104/Decors_colored/G06_black/0006.png": 2010,
	"./H48104/Decors_colored/G06_black/0007.png": 2011,
	"./H48104/Decors_colored/G06_black/0008.png": 2012,
	"./H48104/Decors_colored/G06_black/0009.png": 2013,
	"./H48104/Decors_colored/G06_black/0010.png": 2014,
	"./H48104/Decors_colored/G06_black/0011.png": 2015,
	"./H48104/Decors_colored/G06_black/0012.png": 2016,
	"./H48104/Decors_colored/G06_black/0013.png": 2017,
	"./H48104/Decors_colored/G06_black/0014.png": 2018,
	"./H48104/Decors_colored/G06_black/0015.png": 2019,
	"./H48104/Decors_colored/G06_black/0016.png": 2020,
	"./H48104/Decors_colored/G06_black/0017.png": 2021,
	"./H48104/Decors_colored/G06_black/0018.png": 2022,
	"./H48104/Decors_colored/G06_white/0001.png": 2023,
	"./H48104/Decors_colored/G06_white/0002.png": 2024,
	"./H48104/Decors_colored/G06_white/0003.png": 2025,
	"./H48104/Decors_colored/G06_white/0004.png": 2026,
	"./H48104/Decors_colored/G06_white/0005.png": 2027,
	"./H48104/Decors_colored/G06_white/0006.png": 2028,
	"./H48104/Decors_colored/G06_white/0007.png": 2029,
	"./H48104/Decors_colored/G06_white/0008.png": 2030,
	"./H48104/Decors_colored/G06_white/0009.png": 2031,
	"./H48104/Decors_colored/G06_white/0010.png": 2032,
	"./H48104/Decors_colored/G06_white/0011.png": 2033,
	"./H48104/Decors_colored/G06_white/0012.png": 2034,
	"./H48104/Decors_colored/G06_white/0013.png": 2035,
	"./H48104/Decors_colored/G06_white/0014.png": 2036,
	"./H48104/Decors_colored/G06_white/0015.png": 2037,
	"./H48104/Decors_colored/G06_white/0016.png": 2038,
	"./H48104/Decors_colored/G06_white/0017.png": 2039,
	"./H48104/Decors_colored/G06_white/0018.png": 2040,
	"./H48104/Decors_colored/G07_black/0001.png": 2041,
	"./H48104/Decors_colored/G07_black/0002.png": 2042,
	"./H48104/Decors_colored/G07_black/0003.png": 2043,
	"./H48104/Decors_colored/G07_black/0004.png": 2044,
	"./H48104/Decors_colored/G07_black/0005.png": 2045,
	"./H48104/Decors_colored/G07_black/0006.png": 2046,
	"./H48104/Decors_colored/G07_black/0007.png": 2047,
	"./H48104/Decors_colored/G07_black/0008.png": 2048,
	"./H48104/Decors_colored/G07_black/0009.png": 2049,
	"./H48104/Decors_colored/G07_black/0010.png": 2050,
	"./H48104/Decors_colored/G07_black/0011.png": 2051,
	"./H48104/Decors_colored/G07_black/0012.png": 2052,
	"./H48104/Decors_colored/G07_black/0013.png": 2053,
	"./H48104/Decors_colored/G07_black/0014.png": 2054,
	"./H48104/Decors_colored/G07_black/0015.png": 2055,
	"./H48104/Decors_colored/G07_black/0016.png": 2056,
	"./H48104/Decors_colored/G07_black/0017.png": 2057,
	"./H48104/Decors_colored/G07_black/0018.png": 2058,
	"./H48104/Decors_colored/G07_white/0001.png": 2059,
	"./H48104/Decors_colored/G07_white/0002.png": 2060,
	"./H48104/Decors_colored/G07_white/0003.png": 2061,
	"./H48104/Decors_colored/G07_white/0004.png": 2062,
	"./H48104/Decors_colored/G07_white/0005.png": 2063,
	"./H48104/Decors_colored/G07_white/0006.png": 2064,
	"./H48104/Decors_colored/G07_white/0007.png": 2065,
	"./H48104/Decors_colored/G07_white/0008.png": 2066,
	"./H48104/Decors_colored/G07_white/0009.png": 2067,
	"./H48104/Decors_colored/G07_white/0010.png": 2068,
	"./H48104/Decors_colored/G07_white/0011.png": 2069,
	"./H48104/Decors_colored/G07_white/0012.png": 2070,
	"./H48104/Decors_colored/G07_white/0013.png": 2071,
	"./H48104/Decors_colored/G07_white/0014.png": 2072,
	"./H48104/Decors_colored/G07_white/0015.png": 2073,
	"./H48104/Decors_colored/G07_white/0016.png": 2074,
	"./H48104/Decors_colored/G07_white/0017.png": 2075,
	"./H48104/Decors_colored/G07_white/0018.png": 2076,
	"./H48104/Decors_colored/G08_black/0001.png": 2077,
	"./H48104/Decors_colored/G08_black/0002.png": 2078,
	"./H48104/Decors_colored/G08_black/0003.png": 2079,
	"./H48104/Decors_colored/G08_black/0004.png": 2080,
	"./H48104/Decors_colored/G08_black/0005.png": 2081,
	"./H48104/Decors_colored/G08_black/0006.png": 2082,
	"./H48104/Decors_colored/G08_black/0007.png": 2083,
	"./H48104/Decors_colored/G08_black/0008.png": 2084,
	"./H48104/Decors_colored/G08_black/0009.png": 2085,
	"./H48104/Decors_colored/G08_black/0010.png": 2086,
	"./H48104/Decors_colored/G08_black/0011.png": 2087,
	"./H48104/Decors_colored/G08_black/0012.png": 2088,
	"./H48104/Decors_colored/G08_black/0013.png": 2089,
	"./H48104/Decors_colored/G08_black/0014.png": 2090,
	"./H48104/Decors_colored/G08_black/0015.png": 2091,
	"./H48104/Decors_colored/G08_black/0016.png": 2092,
	"./H48104/Decors_colored/G08_black/0017.png": 2093,
	"./H48104/Decors_colored/G08_black/0018.png": 2094,
	"./H48104/Decors_colored/G08_white/0001.png": 2095,
	"./H48104/Decors_colored/G08_white/0002.png": 2096,
	"./H48104/Decors_colored/G08_white/0003.png": 2097,
	"./H48104/Decors_colored/G08_white/0004.png": 2098,
	"./H48104/Decors_colored/G08_white/0005.png": 2099,
	"./H48104/Decors_colored/G08_white/0006.png": 2100,
	"./H48104/Decors_colored/G08_white/0007.png": 2101,
	"./H48104/Decors_colored/G08_white/0008.png": 2102,
	"./H48104/Decors_colored/G08_white/0009.png": 2103,
	"./H48104/Decors_colored/G08_white/0010.png": 2104,
	"./H48104/Decors_colored/G08_white/0011.png": 2105,
	"./H48104/Decors_colored/G08_white/0012.png": 2106,
	"./H48104/Decors_colored/G08_white/0013.png": 2107,
	"./H48104/Decors_colored/G08_white/0014.png": 2108,
	"./H48104/Decors_colored/G08_white/0015.png": 2109,
	"./H48104/Decors_colored/G08_white/0016.png": 2110,
	"./H48104/Decors_colored/G08_white/0017.png": 2111,
	"./H48104/Decors_colored/G08_white/0018.png": 2112,
	"./H48104/Decors_colored/G09_black/0001.png": 2113,
	"./H48104/Decors_colored/G09_black/0002.png": 2114,
	"./H48104/Decors_colored/G09_black/0003.png": 2115,
	"./H48104/Decors_colored/G09_black/0004.png": 2116,
	"./H48104/Decors_colored/G09_black/0005.png": 2117,
	"./H48104/Decors_colored/G09_black/0006.png": 2118,
	"./H48104/Decors_colored/G09_black/0007.png": 2119,
	"./H48104/Decors_colored/G09_black/0008.png": 2120,
	"./H48104/Decors_colored/G09_black/0009.png": 2121,
	"./H48104/Decors_colored/G09_black/0010.png": 2122,
	"./H48104/Decors_colored/G09_black/0011.png": 2123,
	"./H48104/Decors_colored/G09_black/0012.png": 2124,
	"./H48104/Decors_colored/G09_black/0013.png": 2125,
	"./H48104/Decors_colored/G09_black/0014.png": 2126,
	"./H48104/Decors_colored/G09_black/0015.png": 2127,
	"./H48104/Decors_colored/G09_black/0016.png": 2128,
	"./H48104/Decors_colored/G09_black/0017.png": 2129,
	"./H48104/Decors_colored/G09_black/0018.png": 2130,
	"./H48104/Decors_colored/G09_white/0001.png": 2131,
	"./H48104/Decors_colored/G09_white/0002.png": 2132,
	"./H48104/Decors_colored/G09_white/0003.png": 2133,
	"./H48104/Decors_colored/G09_white/0004.png": 2134,
	"./H48104/Decors_colored/G09_white/0005.png": 2135,
	"./H48104/Decors_colored/G09_white/0006.png": 2136,
	"./H48104/Decors_colored/G09_white/0007.png": 2137,
	"./H48104/Decors_colored/G09_white/0008.png": 2138,
	"./H48104/Decors_colored/G09_white/0009.png": 2139,
	"./H48104/Decors_colored/G09_white/0010.png": 2140,
	"./H48104/Decors_colored/G09_white/0011.png": 2141,
	"./H48104/Decors_colored/G09_white/0012.png": 2142,
	"./H48104/Decors_colored/G09_white/0013.png": 2143,
	"./H48104/Decors_colored/G09_white/0014.png": 2144,
	"./H48104/Decors_colored/G09_white/0015.png": 2145,
	"./H48104/Decors_colored/G09_white/0016.png": 2146,
	"./H48104/Decors_colored/G09_white/0017.png": 2147,
	"./H48104/Decors_colored/G09_white/0018.png": 2148,
	"./H48104/Decors_colored/G10_black/0001.png": 2149,
	"./H48104/Decors_colored/G10_black/0002.png": 2150,
	"./H48104/Decors_colored/G10_black/0003.png": 2151,
	"./H48104/Decors_colored/G10_black/0004.png": 2152,
	"./H48104/Decors_colored/G10_black/0005.png": 2153,
	"./H48104/Decors_colored/G10_black/0006.png": 2154,
	"./H48104/Decors_colored/G10_black/0007.png": 2155,
	"./H48104/Decors_colored/G10_black/0008.png": 2156,
	"./H48104/Decors_colored/G10_black/0009.png": 2157,
	"./H48104/Decors_colored/G10_black/0010.png": 2158,
	"./H48104/Decors_colored/G10_black/0011.png": 2159,
	"./H48104/Decors_colored/G10_black/0012.png": 2160,
	"./H48104/Decors_colored/G10_black/0013.png": 2161,
	"./H48104/Decors_colored/G10_black/0014.png": 2162,
	"./H48104/Decors_colored/G10_black/0015.png": 2163,
	"./H48104/Decors_colored/G10_black/0016.png": 2164,
	"./H48104/Decors_colored/G10_black/0017.png": 2165,
	"./H48104/Decors_colored/G10_black/0018.png": 2166,
	"./H48104/Decors_colored/G10_white/0001.png": 2167,
	"./H48104/Decors_colored/G10_white/0002.png": 2168,
	"./H48104/Decors_colored/G10_white/0003.png": 2169,
	"./H48104/Decors_colored/G10_white/0004.png": 2170,
	"./H48104/Decors_colored/G10_white/0005.png": 2171,
	"./H48104/Decors_colored/G10_white/0006.png": 2172,
	"./H48104/Decors_colored/G10_white/0007.png": 2173,
	"./H48104/Decors_colored/G10_white/0008.png": 2174,
	"./H48104/Decors_colored/G10_white/0009.png": 2175,
	"./H48104/Decors_colored/G10_white/0010.png": 2176,
	"./H48104/Decors_colored/G10_white/0011.png": 2177,
	"./H48104/Decors_colored/G10_white/0012.png": 2178,
	"./H48104/Decors_colored/G10_white/0013.png": 2179,
	"./H48104/Decors_colored/G10_white/0014.png": 2180,
	"./H48104/Decors_colored/G10_white/0015.png": 2181,
	"./H48104/Decors_colored/G10_white/0016.png": 2182,
	"./H48104/Decors_colored/G10_white/0017.png": 2183,
	"./H48104/Decors_colored/G10_white/0018.png": 2184,
	"./H48104/Decors_colored/N01_black/0001.png": 2185,
	"./H48104/Decors_colored/N01_black/0002.png": 2186,
	"./H48104/Decors_colored/N01_black/0003.png": 2187,
	"./H48104/Decors_colored/N01_black/0004.png": 2188,
	"./H48104/Decors_colored/N01_black/0005.png": 2189,
	"./H48104/Decors_colored/N01_black/0006.png": 2190,
	"./H48104/Decors_colored/N01_black/0007.png": 2191,
	"./H48104/Decors_colored/N01_black/0008.png": 2192,
	"./H48104/Decors_colored/N01_black/0009.png": 2193,
	"./H48104/Decors_colored/N01_black/0010.png": 2194,
	"./H48104/Decors_colored/N01_black/0011.png": 2195,
	"./H48104/Decors_colored/N01_black/0012.png": 2196,
	"./H48104/Decors_colored/N01_black/0013.png": 2197,
	"./H48104/Decors_colored/N01_black/0014.png": 2198,
	"./H48104/Decors_colored/N01_black/0015.png": 2199,
	"./H48104/Decors_colored/N01_black/0016.png": 2200,
	"./H48104/Decors_colored/N01_black/0017.png": 2201,
	"./H48104/Decors_colored/N01_black/0018.png": 2202,
	"./H48104/Decors_colored/N01_white/0001.png": 2203,
	"./H48104/Decors_colored/N01_white/0002.png": 2204,
	"./H48104/Decors_colored/N01_white/0003.png": 2205,
	"./H48104/Decors_colored/N01_white/0004.png": 2206,
	"./H48104/Decors_colored/N01_white/0005.png": 2207,
	"./H48104/Decors_colored/N01_white/0006.png": 2208,
	"./H48104/Decors_colored/N01_white/0007.png": 2209,
	"./H48104/Decors_colored/N01_white/0008.png": 2210,
	"./H48104/Decors_colored/N01_white/0009.png": 2211,
	"./H48104/Decors_colored/N01_white/0010.png": 2212,
	"./H48104/Decors_colored/N01_white/0011.png": 2213,
	"./H48104/Decors_colored/N01_white/0012.png": 2214,
	"./H48104/Decors_colored/N01_white/0013.png": 2215,
	"./H48104/Decors_colored/N01_white/0014.png": 2216,
	"./H48104/Decors_colored/N01_white/0015.png": 2217,
	"./H48104/Decors_colored/N01_white/0016.png": 2218,
	"./H48104/Decors_colored/N01_white/0017.png": 2219,
	"./H48104/Decors_colored/N01_white/0018.png": 2220,
	"./H48104/Decors_colored/N02_black/0001.png": 2221,
	"./H48104/Decors_colored/N02_black/0002.png": 2222,
	"./H48104/Decors_colored/N02_black/0003.png": 2223,
	"./H48104/Decors_colored/N02_black/0004.png": 2224,
	"./H48104/Decors_colored/N02_black/0005.png": 2225,
	"./H48104/Decors_colored/N02_black/0006.png": 2226,
	"./H48104/Decors_colored/N02_black/0007.png": 2227,
	"./H48104/Decors_colored/N02_black/0008.png": 2228,
	"./H48104/Decors_colored/N02_black/0009.png": 2229,
	"./H48104/Decors_colored/N02_black/0010.png": 2230,
	"./H48104/Decors_colored/N02_black/0011.png": 2231,
	"./H48104/Decors_colored/N02_black/0012.png": 2232,
	"./H48104/Decors_colored/N02_black/0013.png": 2233,
	"./H48104/Decors_colored/N02_black/0014.png": 2234,
	"./H48104/Decors_colored/N02_black/0015.png": 2235,
	"./H48104/Decors_colored/N02_black/0016.png": 2236,
	"./H48104/Decors_colored/N02_black/0017.png": 2237,
	"./H48104/Decors_colored/N02_black/0018.png": 2238,
	"./H48104/Decors_colored/N02_white/0001.png": 2239,
	"./H48104/Decors_colored/N02_white/0002.png": 2240,
	"./H48104/Decors_colored/N02_white/0003.png": 2241,
	"./H48104/Decors_colored/N02_white/0004.png": 2242,
	"./H48104/Decors_colored/N02_white/0005.png": 2243,
	"./H48104/Decors_colored/N02_white/0006.png": 2244,
	"./H48104/Decors_colored/N02_white/0007.png": 2245,
	"./H48104/Decors_colored/N02_white/0008.png": 2246,
	"./H48104/Decors_colored/N02_white/0009.png": 2247,
	"./H48104/Decors_colored/N02_white/0010.png": 2248,
	"./H48104/Decors_colored/N02_white/0011.png": 2249,
	"./H48104/Decors_colored/N02_white/0012.png": 2250,
	"./H48104/Decors_colored/N02_white/0013.png": 2251,
	"./H48104/Decors_colored/N02_white/0014.png": 2252,
	"./H48104/Decors_colored/N02_white/0015.png": 2253,
	"./H48104/Decors_colored/N02_white/0016.png": 2254,
	"./H48104/Decors_colored/N02_white/0017.png": 2255,
	"./H48104/Decors_colored/N02_white/0018.png": 2256,
	"./H48104/Decors_colored/N03_black/0001.png": 2257,
	"./H48104/Decors_colored/N03_black/0002.png": 2258,
	"./H48104/Decors_colored/N03_black/0003.png": 2259,
	"./H48104/Decors_colored/N03_black/0004.png": 2260,
	"./H48104/Decors_colored/N03_black/0005.png": 2261,
	"./H48104/Decors_colored/N03_black/0006.png": 2262,
	"./H48104/Decors_colored/N03_black/0007.png": 2263,
	"./H48104/Decors_colored/N03_black/0008.png": 2264,
	"./H48104/Decors_colored/N03_black/0009.png": 2265,
	"./H48104/Decors_colored/N03_black/0010.png": 2266,
	"./H48104/Decors_colored/N03_black/0011.png": 2267,
	"./H48104/Decors_colored/N03_black/0012.png": 2268,
	"./H48104/Decors_colored/N03_black/0013.png": 2269,
	"./H48104/Decors_colored/N03_black/0014.png": 2270,
	"./H48104/Decors_colored/N03_black/0015.png": 2271,
	"./H48104/Decors_colored/N03_black/0016.png": 2272,
	"./H48104/Decors_colored/N03_black/0017.png": 2273,
	"./H48104/Decors_colored/N03_black/0018.png": 2274,
	"./H48104/Decors_colored/N03_white/0001.png": 2275,
	"./H48104/Decors_colored/N03_white/0002.png": 2276,
	"./H48104/Decors_colored/N03_white/0003.png": 2277,
	"./H48104/Decors_colored/N03_white/0004.png": 2278,
	"./H48104/Decors_colored/N03_white/0005.png": 2279,
	"./H48104/Decors_colored/N03_white/0006.png": 2280,
	"./H48104/Decors_colored/N03_white/0007.png": 2281,
	"./H48104/Decors_colored/N03_white/0008.png": 2282,
	"./H48104/Decors_colored/N03_white/0009.png": 2283,
	"./H48104/Decors_colored/N03_white/0010.png": 2284,
	"./H48104/Decors_colored/N03_white/0011.png": 2285,
	"./H48104/Decors_colored/N03_white/0012.png": 2286,
	"./H48104/Decors_colored/N03_white/0013.png": 2287,
	"./H48104/Decors_colored/N03_white/0014.png": 2288,
	"./H48104/Decors_colored/N03_white/0015.png": 2289,
	"./H48104/Decors_colored/N03_white/0016.png": 2290,
	"./H48104/Decors_colored/N03_white/0017.png": 2291,
	"./H48104/Decors_colored/N03_white/0018.png": 2292,
	"./H48104/Decors_colored/N04_black/0001.png": 2293,
	"./H48104/Decors_colored/N04_black/0002.png": 2294,
	"./H48104/Decors_colored/N04_black/0003.png": 2295,
	"./H48104/Decors_colored/N04_black/0004.png": 2296,
	"./H48104/Decors_colored/N04_black/0005.png": 2297,
	"./H48104/Decors_colored/N04_black/0006.png": 2298,
	"./H48104/Decors_colored/N04_black/0007.png": 2299,
	"./H48104/Decors_colored/N04_black/0008.png": 2300,
	"./H48104/Decors_colored/N04_black/0009.png": 2301,
	"./H48104/Decors_colored/N04_black/0010.png": 2302,
	"./H48104/Decors_colored/N04_black/0011.png": 2303,
	"./H48104/Decors_colored/N04_black/0012.png": 2304,
	"./H48104/Decors_colored/N04_black/0013.png": 2305,
	"./H48104/Decors_colored/N04_black/0014.png": 2306,
	"./H48104/Decors_colored/N04_black/0015.png": 2307,
	"./H48104/Decors_colored/N04_black/0016.png": 2308,
	"./H48104/Decors_colored/N04_black/0017.png": 2309,
	"./H48104/Decors_colored/N04_black/0018.png": 2310,
	"./H48104/Decors_colored/N04_white/0001.png": 2311,
	"./H48104/Decors_colored/N04_white/0002.png": 2312,
	"./H48104/Decors_colored/N04_white/0003.png": 2313,
	"./H48104/Decors_colored/N04_white/0004.png": 2314,
	"./H48104/Decors_colored/N04_white/0005.png": 2315,
	"./H48104/Decors_colored/N04_white/0006.png": 2316,
	"./H48104/Decors_colored/N04_white/0007.png": 2317,
	"./H48104/Decors_colored/N04_white/0008.png": 2318,
	"./H48104/Decors_colored/N04_white/0009.png": 2319,
	"./H48104/Decors_colored/N04_white/0010.png": 2320,
	"./H48104/Decors_colored/N04_white/0011.png": 2321,
	"./H48104/Decors_colored/N04_white/0012.png": 2322,
	"./H48104/Decors_colored/N04_white/0013.png": 2323,
	"./H48104/Decors_colored/N04_white/0014.png": 2324,
	"./H48104/Decors_colored/N04_white/0015.png": 2325,
	"./H48104/Decors_colored/N04_white/0016.png": 2326,
	"./H48104/Decors_colored/N04_white/0017.png": 2327,
	"./H48104/Decors_colored/N04_white/0018.png": 2328,
	"./H48104/Decors_colored/N05_black/0001.png": 2329,
	"./H48104/Decors_colored/N05_black/0002.png": 2330,
	"./H48104/Decors_colored/N05_black/0003.png": 2331,
	"./H48104/Decors_colored/N05_black/0004.png": 2332,
	"./H48104/Decors_colored/N05_black/0005.png": 2333,
	"./H48104/Decors_colored/N05_black/0006.png": 2334,
	"./H48104/Decors_colored/N05_black/0007.png": 2335,
	"./H48104/Decors_colored/N05_black/0008.png": 2336,
	"./H48104/Decors_colored/N05_black/0009.png": 2337,
	"./H48104/Decors_colored/N05_black/0010.png": 2338,
	"./H48104/Decors_colored/N05_black/0011.png": 2339,
	"./H48104/Decors_colored/N05_black/0012.png": 2340,
	"./H48104/Decors_colored/N05_black/0013.png": 2341,
	"./H48104/Decors_colored/N05_black/0014.png": 2342,
	"./H48104/Decors_colored/N05_black/0015.png": 2343,
	"./H48104/Decors_colored/N05_black/0016.png": 2344,
	"./H48104/Decors_colored/N05_black/0017.png": 2345,
	"./H48104/Decors_colored/N05_black/0018.png": 2346,
	"./H48104/Decors_colored/N05_white/0001.png": 2347,
	"./H48104/Decors_colored/N05_white/0002.png": 2348,
	"./H48104/Decors_colored/N05_white/0003.png": 2349,
	"./H48104/Decors_colored/N05_white/0004.png": 2350,
	"./H48104/Decors_colored/N05_white/0005.png": 2351,
	"./H48104/Decors_colored/N05_white/0006.png": 2352,
	"./H48104/Decors_colored/N05_white/0007.png": 2353,
	"./H48104/Decors_colored/N05_white/0008.png": 2354,
	"./H48104/Decors_colored/N05_white/0009.png": 2355,
	"./H48104/Decors_colored/N05_white/0010.png": 2356,
	"./H48104/Decors_colored/N05_white/0011.png": 2357,
	"./H48104/Decors_colored/N05_white/0012.png": 2358,
	"./H48104/Decors_colored/N05_white/0013.png": 2359,
	"./H48104/Decors_colored/N05_white/0014.png": 2360,
	"./H48104/Decors_colored/N05_white/0015.png": 2361,
	"./H48104/Decors_colored/N05_white/0016.png": 2362,
	"./H48104/Decors_colored/N05_white/0017.png": 2363,
	"./H48104/Decors_colored/N05_white/0018.png": 2364,
	"./H48104/Decors_colored/N06_black/0001.png": 2365,
	"./H48104/Decors_colored/N06_black/0002.png": 2366,
	"./H48104/Decors_colored/N06_black/0003.png": 2367,
	"./H48104/Decors_colored/N06_black/0004.png": 2368,
	"./H48104/Decors_colored/N06_black/0005.png": 2369,
	"./H48104/Decors_colored/N06_black/0006.png": 2370,
	"./H48104/Decors_colored/N06_black/0007.png": 2371,
	"./H48104/Decors_colored/N06_black/0008.png": 2372,
	"./H48104/Decors_colored/N06_black/0009.png": 2373,
	"./H48104/Decors_colored/N06_black/0010.png": 2374,
	"./H48104/Decors_colored/N06_black/0011.png": 2375,
	"./H48104/Decors_colored/N06_black/0012.png": 2376,
	"./H48104/Decors_colored/N06_black/0013.png": 2377,
	"./H48104/Decors_colored/N06_black/0014.png": 2378,
	"./H48104/Decors_colored/N06_black/0015.png": 2379,
	"./H48104/Decors_colored/N06_black/0016.png": 2380,
	"./H48104/Decors_colored/N06_black/0017.png": 2381,
	"./H48104/Decors_colored/N06_black/0018.png": 2382,
	"./H48104/Decors_colored/N06_white/0001.png": 2383,
	"./H48104/Decors_colored/N06_white/0002.png": 2384,
	"./H48104/Decors_colored/N06_white/0003.png": 2385,
	"./H48104/Decors_colored/N06_white/0004.png": 2386,
	"./H48104/Decors_colored/N06_white/0005.png": 2387,
	"./H48104/Decors_colored/N06_white/0006.png": 2388,
	"./H48104/Decors_colored/N06_white/0007.png": 2389,
	"./H48104/Decors_colored/N06_white/0008.png": 2390,
	"./H48104/Decors_colored/N06_white/0009.png": 2391,
	"./H48104/Decors_colored/N06_white/0010.png": 2392,
	"./H48104/Decors_colored/N06_white/0011.png": 2393,
	"./H48104/Decors_colored/N06_white/0012.png": 2394,
	"./H48104/Decors_colored/N06_white/0013.png": 2395,
	"./H48104/Decors_colored/N06_white/0014.png": 2396,
	"./H48104/Decors_colored/N06_white/0015.png": 2397,
	"./H48104/Decors_colored/N06_white/0016.png": 2398,
	"./H48104/Decors_colored/N06_white/0017.png": 2399,
	"./H48104/Decors_colored/N06_white/0018.png": 2400,
	"./H48104/Decors_colored/N08_black/0001.png": 2401,
	"./H48104/Decors_colored/N08_black/0002.png": 2402,
	"./H48104/Decors_colored/N08_black/0003.png": 2403,
	"./H48104/Decors_colored/N08_black/0004.png": 2404,
	"./H48104/Decors_colored/N08_black/0005.png": 2405,
	"./H48104/Decors_colored/N08_black/0006.png": 2406,
	"./H48104/Decors_colored/N08_black/0007.png": 2407,
	"./H48104/Decors_colored/N08_black/0008.png": 2408,
	"./H48104/Decors_colored/N08_black/0009.png": 2409,
	"./H48104/Decors_colored/N08_black/0010.png": 2410,
	"./H48104/Decors_colored/N08_black/0011.png": 2411,
	"./H48104/Decors_colored/N08_black/0012.png": 2412,
	"./H48104/Decors_colored/N08_black/0013.png": 2413,
	"./H48104/Decors_colored/N08_black/0014.png": 2414,
	"./H48104/Decors_colored/N08_black/0015.png": 2415,
	"./H48104/Decors_colored/N08_black/0016.png": 2416,
	"./H48104/Decors_colored/N08_black/0017.png": 2417,
	"./H48104/Decors_colored/N08_black/0018.png": 2418,
	"./H48104/Decors_colored/N08_white/0001.png": 2419,
	"./H48104/Decors_colored/N08_white/0002.png": 2420,
	"./H48104/Decors_colored/N08_white/0003.png": 2421,
	"./H48104/Decors_colored/N08_white/0004.png": 2422,
	"./H48104/Decors_colored/N08_white/0005.png": 2423,
	"./H48104/Decors_colored/N08_white/0006.png": 2424,
	"./H48104/Decors_colored/N08_white/0007.png": 2425,
	"./H48104/Decors_colored/N08_white/0008.png": 2426,
	"./H48104/Decors_colored/N08_white/0009.png": 2427,
	"./H48104/Decors_colored/N08_white/0010.png": 2428,
	"./H48104/Decors_colored/N08_white/0011.png": 2429,
	"./H48104/Decors_colored/N08_white/0012.png": 2430,
	"./H48104/Decors_colored/N08_white/0013.png": 2431,
	"./H48104/Decors_colored/N08_white/0014.png": 2432,
	"./H48104/Decors_colored/N08_white/0015.png": 2433,
	"./H48104/Decors_colored/N08_white/0016.png": 2434,
	"./H48104/Decors_colored/N08_white/0017.png": 2435,
	"./H48104/Decors_colored/N08_white/0018.png": 2436,
	"./H48104/RAL/0001.png": 2437,
	"./H48104/RAL/0002.png": 2438,
	"./H48104/RAL/0003.png": 2439,
	"./H48104/RAL/0004.png": 2440,
	"./H48104/RAL/0005.png": 2441,
	"./H48104/RAL/0006.png": 2442,
	"./H48104/RAL/0007.png": 2443,
	"./H48104/RAL/0008.png": 2444,
	"./H48104/RAL/0009.png": 2445,
	"./H48104/RAL/0010.png": 2446,
	"./H48104/RAL/0011.png": 2447,
	"./H48104/RAL/0012.png": 2448,
	"./H48104/RAL/0013.png": 2449,
	"./H48104/RAL/0014.png": 2450,
	"./H48104/RAL/0015.png": 2451,
	"./H48104/RAL/0016.png": 2452,
	"./H48104/RAL/0017.png": 2453,
	"./H48104/RAL/0018.png": 2454,
	"./H48104/RAL/0019.png": 2455,
	"./H48104/RAL/0020.png": 2456,
	"./H48104/RAL/0021.png": 2457,
	"./H48104/RAL/0022.png": 2458,
	"./H48104/RAL/0023.png": 2459,
	"./H48104/RAL/0024.png": 2460,
	"./H48104/RAL/0025.png": 2461,
	"./H48104/RAL/0026.png": 2462,
	"./H48104/RAL/0027.png": 2463,
	"./H48104/RAL/0028.png": 2464,
	"./H48104/RAL/0029.png": 2465,
	"./H48104/RAL/0030.png": 2466,
	"./H48104/RAL/0031.png": 2467,
	"./H48104/RAL/0032.png": 2468,
	"./H48104/RAL/0033.png": 2469,
	"./H48104/RAL/0034.png": 2470,
	"./H48104/RAL/0035.png": 2471,
	"./H48104/RAL/0036.png": 2472,
	"./H48104/RAL/0037.png": 2473,
	"./H48104/RAL/0038.png": 2474,
	"./H48104/RAL/0039.png": 2475,
	"./H48104/RAL/0040.png": 2476,
	"./H48104/RAL/0041.png": 2477,
	"./H48104/RAL/0042.png": 2478,
	"./H48104/RAL/0043.png": 2479,
	"./H48104/RAL/0044.png": 2480,
	"./H48104/RAL/0045.png": 2481,
	"./H48104/RAL/0046.png": 2482,
	"./H48104/RAL/0047.png": 2483,
	"./H48104/RAL/0048.png": 2484,
	"./H48106/Anodized/0001.png": 2485,
	"./H48106/Chassis_RAL/0001.png": 2486,
	"./H48106/Chassis_RAL/0002.png": 2487,
	"./H48106/Chassis_RAL/0003.png": 2488,
	"./H48106/Chassis_RAL/0004.png": 2489,
	"./H48106/Chassis_RAL/0005.png": 2490,
	"./H48106/Chassis_RAL/0006.png": 2491,
	"./H48106/Chassis_RAL/0007.png": 2492,
	"./H48106/Chassis_RAL/0008.png": 2493,
	"./H48106/Chassis_RAL/0009.png": 2494,
	"./H48106/Chassis_RAL/0010.png": 2495,
	"./H48106/Chassis_RAL/0011.png": 2496,
	"./H48106/Chassis_RAL/0012.png": 2497,
	"./H48106/Chassis_RAL/0013.png": 2498,
	"./H48106/Chassis_RAL/0014.png": 2499,
	"./H48106/Chassis_RAL/0015.png": 2500,
	"./H48106/Chassis_RAL/0016.png": 2501,
	"./H48106/Chassis_RAL/0017.png": 2502,
	"./H48106/Chassis_RAL/0018.png": 2503,
	"./H48106/Chassis_RAL/0019.png": 2504,
	"./H48106/Chassis_RAL/0020.png": 2505,
	"./H48106/Chassis_RAL/0021.png": 2506,
	"./H48106/Chassis_RAL/0022.png": 2507,
	"./H48106/Chassis_RAL/0023.png": 2508,
	"./H48106/Chassis_RAL/0024.png": 2509,
	"./H48106/Chassis_RAL/0025.png": 2510,
	"./H48106/Chassis_RAL/0026.png": 2511,
	"./H48106/Chassis_RAL/0027.png": 2512,
	"./H48106/Chassis_RAL/0028.png": 2513,
	"./H48106/Chassis_RAL/0029.png": 2514,
	"./H48106/Chassis_RAL/0030.png": 2515,
	"./H48106/Chassis_RAL/0031.png": 2516,
	"./H48106/Chassis_RAL/0032.png": 2517,
	"./H48106/Chassis_RAL/0033.png": 2518,
	"./H48106/Chassis_RAL/0034.png": 2519,
	"./H48106/Chassis_RAL/0035.png": 2520,
	"./H48106/Chassis_RAL/0036.png": 2521,
	"./H48106/Chassis_RAL/0037.png": 2522,
	"./H48106/Chassis_RAL/0038.png": 2523,
	"./H48106/Chassis_RAL/0039.png": 2524,
	"./H48106/Chassis_RAL/0040.png": 2525,
	"./H48106/Chassis_RAL/0041.png": 2526,
	"./H48106/Chassis_RAL/0042.png": 2527,
	"./H48106/Chassis_RAL/0043.png": 2528,
	"./H48106/Chassis_RAL/0044.png": 2529,
	"./H48106/Chassis_RAL/0045.png": 2530,
	"./H48106/Chassis_RAL/0046.png": 2531,
	"./H48106/Chassis_RAL/0047.png": 2532,
	"./H48106/Chassis_RAL/0048.png": 2533,
	"./H48106/RAL/0001.png": 2534,
	"./H48106/RAL/0002.png": 2535,
	"./H48106/RAL/0003.png": 2536,
	"./H48106/RAL/0004.png": 2537,
	"./H48106/RAL/0005.png": 2538,
	"./H48106/RAL/0006.png": 2539,
	"./H48106/RAL/0007.png": 2540,
	"./H48106/RAL/0008.png": 2541,
	"./H48106/RAL/0009.png": 2542,
	"./H48106/RAL/0010.png": 2543,
	"./H48106/RAL/0011.png": 2544,
	"./H48106/RAL/0012.png": 2545,
	"./H48106/RAL/0013.png": 2546,
	"./H48106/RAL/0014.png": 2547,
	"./H48106/RAL/0015.png": 2548,
	"./H48106/RAL/0016.png": 2549,
	"./H48106/RAL/0017.png": 2550,
	"./H48106/RAL/0018.png": 2551,
	"./H48106/RAL/0019.png": 2552,
	"./H48106/RAL/0020.png": 2553,
	"./H48106/RAL/0021.png": 2554,
	"./H48106/RAL/0022.png": 2555,
	"./H48106/RAL/0023.png": 2556,
	"./H48106/RAL/0024.png": 2557,
	"./H48106/RAL/0025.png": 2558,
	"./H48106/RAL/0026.png": 2559,
	"./H48106/RAL/0027.png": 2560,
	"./H48106/RAL/0028.png": 2561,
	"./H48106/RAL/0029.png": 2562,
	"./H48106/RAL/0030.png": 2563,
	"./H48106/RAL/0031.png": 2564,
	"./H48106/RAL/0032.png": 2565,
	"./H48106/RAL/0033.png": 2566,
	"./H48106/RAL/0034.png": 2567,
	"./H48106/RAL/0035.png": 2568,
	"./H48106/RAL/0036.png": 2569,
	"./H48106/RAL/0037.png": 2570,
	"./H48106/RAL/0038.png": 2571,
	"./H48106/RAL/0039.png": 2572,
	"./H48106/RAL/0040.png": 2573,
	"./H48106/RAL/0041.png": 2574,
	"./H48106/RAL/0042.png": 2575,
	"./H48106/RAL/0043.png": 2576,
	"./H48106/RAL/0044.png": 2577,
	"./H48106/RAL/0045.png": 2578,
	"./H48106/RAL/0046.png": 2579,
	"./H48106/RAL/0047.png": 2580,
	"./H48106/RAL/0048.png": 2581,
	"./H48107/Anodized/0001.png": 2582,
	"./H48107/Chassis_RAL/0001.png": 2583,
	"./H48107/Chassis_RAL/0002.png": 2584,
	"./H48107/Chassis_RAL/0003.png": 2585,
	"./H48107/Chassis_RAL/0004.png": 2586,
	"./H48107/Chassis_RAL/0005.png": 2587,
	"./H48107/Chassis_RAL/0006.png": 2588,
	"./H48107/Chassis_RAL/0007.png": 2589,
	"./H48107/Chassis_RAL/0008.png": 2590,
	"./H48107/Chassis_RAL/0009.png": 2591,
	"./H48107/Chassis_RAL/0010.png": 2592,
	"./H48107/Chassis_RAL/0011.png": 2593,
	"./H48107/Chassis_RAL/0012.png": 2594,
	"./H48107/Chassis_RAL/0013.png": 2595,
	"./H48107/Chassis_RAL/0014.png": 2596,
	"./H48107/Chassis_RAL/0015.png": 2597,
	"./H48107/Chassis_RAL/0016.png": 2598,
	"./H48107/Chassis_RAL/0017.png": 2599,
	"./H48107/Chassis_RAL/0018.png": 2600,
	"./H48107/Chassis_RAL/0019.png": 2601,
	"./H48107/Chassis_RAL/0020.png": 2602,
	"./H48107/Chassis_RAL/0021.png": 2603,
	"./H48107/Chassis_RAL/0022.png": 2604,
	"./H48107/Chassis_RAL/0023.png": 2605,
	"./H48107/Chassis_RAL/0024.png": 2606,
	"./H48107/Chassis_RAL/0025.png": 2607,
	"./H48107/Chassis_RAL/0026.png": 2608,
	"./H48107/Chassis_RAL/0027.png": 2609,
	"./H48107/Chassis_RAL/0028.png": 2610,
	"./H48107/Chassis_RAL/0029.png": 2611,
	"./H48107/Chassis_RAL/0030.png": 2612,
	"./H48107/Chassis_RAL/0031.png": 2613,
	"./H48107/Chassis_RAL/0032.png": 2614,
	"./H48107/Chassis_RAL/0033.png": 2615,
	"./H48107/Chassis_RAL/0034.png": 2616,
	"./H48107/Chassis_RAL/0035.png": 2617,
	"./H48107/Chassis_RAL/0036.png": 2618,
	"./H48107/Chassis_RAL/0037.png": 2619,
	"./H48107/Chassis_RAL/0038.png": 2620,
	"./H48107/Chassis_RAL/0039.png": 2621,
	"./H48107/Chassis_RAL/0040.png": 2622,
	"./H48107/Chassis_RAL/0041.png": 2623,
	"./H48107/Chassis_RAL/0042.png": 2624,
	"./H48107/Chassis_RAL/0043.png": 2625,
	"./H48107/Chassis_RAL/0044.png": 2626,
	"./H48107/Chassis_RAL/0045.png": 2627,
	"./H48107/Chassis_RAL/0046.png": 2628,
	"./H48107/Chassis_RAL/0047.png": 2629,
	"./H48107/Chassis_RAL/0048.png": 2630,
	"./H48107/RAL/0001.png": 2631,
	"./H48107/RAL/0002.png": 2632,
	"./H48107/RAL/0003.png": 2633,
	"./H48107/RAL/0004.png": 2634,
	"./H48107/RAL/0005.png": 2635,
	"./H48107/RAL/0006.png": 2636,
	"./H48107/RAL/0007.png": 2637,
	"./H48107/RAL/0008.png": 2638,
	"./H48107/RAL/0009.png": 2639,
	"./H48107/RAL/0010.png": 2640,
	"./H48107/RAL/0011.png": 2641,
	"./H48107/RAL/0012.png": 2642,
	"./H48107/RAL/0013.png": 2643,
	"./H48107/RAL/0014.png": 2644,
	"./H48107/RAL/0015.png": 2645,
	"./H48107/RAL/0016.png": 2646,
	"./H48107/RAL/0017.png": 2647,
	"./H48107/RAL/0018.png": 2648,
	"./H48107/RAL/0019.png": 2649,
	"./H48107/RAL/0020.png": 2650,
	"./H48107/RAL/0021.png": 2651,
	"./H48107/RAL/0022.png": 2652,
	"./H48107/RAL/0023.png": 2653,
	"./H48107/RAL/0024.png": 2654,
	"./H48107/RAL/0025.png": 2655,
	"./H48107/RAL/0026.png": 2656,
	"./H48107/RAL/0027.png": 2657,
	"./H48107/RAL/0028.png": 2658,
	"./H48107/RAL/0029.png": 2659,
	"./H48107/RAL/0030.png": 2660,
	"./H48107/RAL/0031.png": 2661,
	"./H48107/RAL/0032.png": 2662,
	"./H48107/RAL/0033.png": 2663,
	"./H48107/RAL/0034.png": 2664,
	"./H48107/RAL/0035.png": 2665,
	"./H48107/RAL/0036.png": 2666,
	"./H48107/RAL/0037.png": 2667,
	"./H48107/RAL/0038.png": 2668,
	"./H48107/RAL/0039.png": 2669,
	"./H48107/RAL/0040.png": 2670,
	"./H48107/RAL/0041.png": 2671,
	"./H48107/RAL/0042.png": 2672,
	"./H48107/RAL/0043.png": 2673,
	"./H48107/RAL/0044.png": 2674,
	"./H48107/RAL/0045.png": 2675,
	"./H48107/RAL/0046.png": 2676,
	"./H48107/RAL/0047.png": 2677,
	"./H48107/RAL/0048.png": 2678
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var assign = make_assign()
var create = make_create()
var trim = make_trim()
var Global = (typeof window !== 'undefined' ? window : global)

module.exports = {
	assign: assign,
	create: create,
	trim: trim,
	bind: bind,
	slice: slice,
	each: each,
	map: map,
	pluck: pluck,
	isList: isList,
	isFunction: isFunction,
	isObject: isObject,
	Global: Global
}

function make_assign() {
	if (Object.assign) {
		return Object.assign
	} else {
		return function shimAssign(obj, props1, props2, etc) {
			for (var i = 1; i < arguments.length; i++) {
				each(Object(arguments[i]), function(val, key) {
					obj[key] = val
				})
			}			
			return obj
		}
	}
}

function make_create() {
	if (Object.create) {
		return function create(obj, assignProps1, assignProps2, etc) {
			var assignArgsList = slice(arguments, 1)
			return assign.apply(this, [Object.create(obj)].concat(assignArgsList))
		}
	} else {
		function F() {} // eslint-disable-line no-inner-declarations
		return function create(obj, assignProps1, assignProps2, etc) {
			var assignArgsList = slice(arguments, 1)
			F.prototype = obj
			return assign.apply(this, [new F()].concat(assignArgsList))
		}
	}
}

function make_trim() {
	if (String.prototype.trim) {
		return function trim(str) {
			return String.prototype.trim.call(str)
		}
	} else {
		return function trim(str) {
			return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '')
		}
	}
}

function bind(obj, fn) {
	return function() {
		return fn.apply(obj, Array.prototype.slice.call(arguments, 0))
	}
}

function slice(arr, index) {
	return Array.prototype.slice.call(arr, index || 0)
}

function each(obj, fn) {
	pluck(obj, function(val, key) {
		fn(val, key)
		return false
	})
}

function map(obj, fn) {
	var res = (isList(obj) ? [] : {})
	pluck(obj, function(v, k) {
		res[k] = fn(v, k)
		return false
	})
	return res
}

function pluck(obj, fn) {
	if (isList(obj)) {
		for (var i=0; i<obj.length; i++) {
			if (fn(obj[i], i)) {
				return obj[i]
			}
		}
	} else {
		for (var key in obj) {
			if (obj.hasOwnProperty(key)) {
				if (fn(obj[key], key)) {
					return obj[key]
				}
			}
		}
	}
}

function isList(val) {
	return (val != null && typeof val != 'function' && typeof val.length == 'number')
}

function isFunction(val) {
	return val && {}.toString.call(val) === '[object Function]'
}

function isObject(val) {
	return val && {}.toString.call(val) === '[object Object]'
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73)))

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var consoleLogger = {
  type: 'logger',

  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    var _console;

    /* eslint no-console: 0 */
    if (console && console[type]) (_console = console)[type].apply(_console, _toConsumableArray(args));
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Logger);

    this.init(concreteLogger, options);
  }

  Logger.prototype.init = function init(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    this.prefix = options.prefix || 'i18next:';
    this.logger = concreteLogger || consoleLogger;
    this.options = options;
    this.debug = options.debug;
  };

  Logger.prototype.setDebug = function setDebug(bool) {
    this.debug = bool;
  };

  Logger.prototype.log = function log() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return this.forward(args, 'log', '', true);
  };

  Logger.prototype.warn = function warn() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return this.forward(args, 'warn', '', true);
  };

  Logger.prototype.error = function error() {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return this.forward(args, 'error', '');
  };

  Logger.prototype.deprecate = function deprecate() {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
  };

  Logger.prototype.forward = function forward(args, lvl, prefix, debugOnly) {
    if (debugOnly && !this.debug) return null;
    if (typeof args[0] === 'string') args[0] = '' + prefix + this.prefix + ' ' + args[0];
    return this.logger[lvl](args);
  };

  Logger.prototype.create = function create(moduleName) {
    return new Logger(this.logger, _extends({ prefix: this.prefix + ':' + moduleName + ':' }, this.options));
  };

  return Logger;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Logger());

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var core = __webpack_require__(11);
var ctx = __webpack_require__(98);
var hide = __webpack_require__(19);
var has = __webpack_require__(14);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(12);
var createDesc = __webpack_require__(37);
module.exports = __webpack_require__(13) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(102);
var defined = __webpack_require__(57);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(60)('wks');
var uid = __webpack_require__(40);
var Symbol = __webpack_require__(10).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__propertyUtils__ = __webpack_require__(323);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;

var getComputedStyleX = void 0;

// https://stackoverflow.com/a/3485654/3040605
function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line
  elem.style.display = originalStyle;
}

function css(el, name, v) {
  var value = v;
  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = value + 'px';
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyleX(el, name);
}

function getClientPosition(elem) {
  var box = void 0;
  var x = void 0;
  var y = void 0;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top;

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;

  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}

function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }
  if (node.nodeType === 9) {
    return node;
  }
  return node.ownerDocument;
}

function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);

  // https://github.com/kissyteam/kissy/issues/61
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;

    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}

if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }
  return option.useCssBottom ? 'bottom' : dir;
}

function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
}

// 设置 elem 相对 elem.ownerDocument 的坐标
function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }
  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);

  if (horizontalProperty !== 'left') {
    presetH = 999;
  }

  if (verticalProperty !== 'top') {
    presetV = 999;
  }
  var originalTransition = '';
  var originalOffset = getOffset(elem);
  if ('left' in offset || 'top' in offset) {
    originalTransition = Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["c" /* getTransitionProperty */])(elem) || '';
    Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["e" /* setTransitionProperty */])(elem, 'none');
  }
  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = presetH + 'px';
  }
  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = presetV + 'px';
  }
  // force relayout
  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};
  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];
      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }
  css(elem, originalStyle);
  // force relayout
  forceRelayout(elem);
  if ('left' in offset || 'top' in offset) {
    Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["e" /* setTransitionProperty */])(elem, originalTransition);
  }
  var ret = {};
  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);
      var _off = offset[_key] - originalOffset[_key];
      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }
  css(elem, ret);
}

function setTransform(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["b" /* getTransformXY */])(elem);
  var resultXY = { x: originalXY.x, y: originalXY.y };
  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }
  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["d" /* setTransformXY */])(elem, resultXY);
}

function setOffset(elem, offset, option) {
  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && Object(__WEBPACK_IMPORTED_MODULE_0__propertyUtils__["a" /* getTransformName */])() in document.body.style) {
    setTransform(elem, offset, option);
  } else {
    setLeftTop(elem, offset, option);
  }
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name = void 0;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop = void 0;
  var j = void 0;
  var i = void 0;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;
        if (prop === 'border') {
          cssProp = '' + prop + which[i] + 'Width';
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}

var domUtils = {};

each(['Width', 'Height'], function (name) {
  domUtils['doc' + name] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement['scroll' + name],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body['scroll' + name], domUtils['viewport' + name](d));
  };

  domUtils['viewport' + name] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = 'client' + name;
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, ex) {
  var extra = ex;
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem, computedStyle);
  var cssBoxValue = 0;
  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
    }
    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }
    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle));
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var val = void 0;
  var elem = args[0];
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils['outer' + first] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, v) {
    var val = v;
    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }
  return to;
}

var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },

  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },

  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i = void 0;
    var ret = {};
    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },

  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};

    for (var _len2 = arguments.length, args = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
      args[_key3] = arguments[_key3];
    }

    for (var i = 0; i < args.length; i++) {
      utils.mix(ret, args[i]);
    }
    return ret;
  },

  viewportWidth: 0,
  viewportHeight: 0
};

mix(utils, domUtils);

/* harmony default export */ __webpack_exports__["a"] = (utils);

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var engine = __webpack_require__(139)

var storages = __webpack_require__(140)
var plugins = [__webpack_require__(147)]

module.exports = engine.createStore(storages, plugins)


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(149);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(153);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(78);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(155);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(158);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(161);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(163);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(79);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(49);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(169);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(171);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(173);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(174);
/* unused harmony reexport withRouter */



























/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(27);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["default"])(a.state, b.state);
};

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_i18next__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n_en__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_fr__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_nl__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_de__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_cn__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_it__ = __webpack_require__(258);
__WEBPACK_IMPORTED_MODULE_0_i18next__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["b" /* reactI18nextModule */]).init({fallbackLng:'en',interpolation:{excapeValue:false},// Not needed for react
react:{wait:false,bindI18n:'languageChanged loaded',bindStore:'added removed',nsMode:'default'},resources:{en:__WEBPACK_IMPORTED_MODULE_2__i18n_en__["a" /* default */],fr:__WEBPACK_IMPORTED_MODULE_3__i18n_fr__["a" /* default */],nl:__WEBPACK_IMPORTED_MODULE_4__i18n_nl__["a" /* default */],de:__WEBPACK_IMPORTED_MODULE_5__i18n_de__["a" /* default */],cn:__WEBPACK_IMPORTED_MODULE_6__i18n_cn__["a" /* default */],it:__WEBPACK_IMPORTED_MODULE_7__i18n_it__["a" /* default */]}});/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_i18next__["a" /* default */]);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.observers = {};
  }

  EventEmitter.prototype.on = function on(events, listener) {
    var _this = this;

    events.split(' ').forEach(function (event) {
      _this.observers[event] = _this.observers[event] || [];
      _this.observers[event].push(listener);
    });
  };

  EventEmitter.prototype.off = function off(event, listener) {
    var _this2 = this;

    if (!this.observers[event]) {
      return;
    }

    this.observers[event].forEach(function () {
      if (!listener) {
        delete _this2.observers[event];
      } else {
        var index = _this2.observers[event].indexOf(listener);
        if (index > -1) {
          _this2.observers[event].splice(index, 1);
        }
      }
    });
  };

  EventEmitter.prototype.emit = function emit(event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (this.observers[event]) {
      var cloned = [].concat(this.observers[event]);
      cloned.forEach(function (observer) {
        observer.apply(undefined, args);
      });
    }

    if (this.observers['*']) {
      var _cloned = [].concat(this.observers['*']);
      _cloned.forEach(function (observer) {
        observer.apply(observer, [event].concat(args));
      });
    }
  };

  return EventEmitter;
}();

/* harmony default export */ __webpack_exports__["a"] = (EventEmitter);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = makeString;
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["h"] = setPath;
/* harmony export (immutable) */ __webpack_exports__["f"] = pushPath;
/* harmony export (immutable) */ __webpack_exports__["d"] = getPath;
/* harmony export (immutable) */ __webpack_exports__["b"] = deepExtend;
/* harmony export (immutable) */ __webpack_exports__["g"] = regexEscape;
/* harmony export (immutable) */ __webpack_exports__["c"] = escape;
function makeString(object) {
  if (object == null) return '';
  /* eslint prefer-template: 0 */
  return '' + object;
}

function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};

    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    object = object[key];
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}

function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}

function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}

function deepExtend(target, source, overwrite) {
  /* eslint no-restricted-syntax: 0 */
  for (var prop in source) {
    if (prop in target) {
      // If we reached a leaf string in target or source then replace with source or skip depending on the 'overwrite' switch
      if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
        if (overwrite) target[prop] = source[prop];
      } else {
        deepExtend(target[prop], source[prop], overwrite);
      }
    } else {
      target[prop] = source[prop];
    }
  }
  return target;
}

function regexEscape(str) {
  /* eslint no-useless-escape: 0 */
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

/* eslint-disable */
var _entityMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': '&quot;',
  "'": '&#39;',
  "/": '&#x2F;'
};
/* eslint-enable */

function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = [{"continent":"Europe","countries":[{"id":"fr","name":"France","lang":"fr","colorSet":1},{"id":"be_fr","name":"Belgium (fr)","lang":"fr","colorSet":2},{"id":"be_nl","name":"Belgium (nl)","lang":"nl","colorSet":2},{"id":"nl","name":"Netherlands","lang":"nl","colorSet":2},{"id":"it","name":"Italy","lang":"it","colorSet":4}]},{"continent":"Asia","countries":[{"id":"cn","name":"China","lang":"cn","colorSet":1},{"id":"in","name":"India","lang":"en","colorSet":3}]}]

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(101);
var enumBugKeys = __webpack_require__(61);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 40 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(278);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(290);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(113);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(75);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(76);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(2);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(50);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = setDefaults;
/* harmony export (immutable) */ __webpack_exports__["a"] = getDefaults;
/* harmony export (immutable) */ __webpack_exports__["e"] = setI18n;
/* harmony export (immutable) */ __webpack_exports__["b"] = getI18n;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reactI18nextModule; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var defaultOptions = {
  wait: false,
  withRef: false,
  bindI18n: 'languageChanged loaded',
  bindStore: 'added removed',
  translateFuncName: 't',
  nsMode: 'default',
  usePureComponent: false
};

var i18n = void 0;

function setDefaults(options) {
  defaultOptions = _extends({}, defaultOptions, options);
}

function getDefaults() {
  return defaultOptions;
}

function setI18n(instance) {
  i18n = instance;
}

function getI18n() {
  return i18n;
}

var reactI18nextModule = {
  type: '3rdParty',

  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_aluk_svg__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_aluk_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_aluk_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_novae_black_png__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_novae_black_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_novae_black_png__);
var AluKHeader=function AluKHeader(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'App-logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__assets_images_aluk_svg___default.a,alt:'AluK'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{id:'novae-logo',src:__WEBPACK_IMPORTED_MODULE_2__assets_images_novae_black_png___default.a,alt:'NOVAE - Quadra \u2022 Rondo'}));};/* harmony default export */ __webpack_exports__["a"] = (AluKHeader);

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./1.json": 261,
	"./2.json": 262,
	"./3.json": 263,
	"./4.json": 264
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(20);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 57 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 58 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(60)('keys');
var uid = __webpack_require__(40);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(11);
var global = __webpack_require__(10);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(39) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 61 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 62 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(28);
var dPs = __webpack_require__(283);
var enumBugKeys = __webpack_require__(61);
var IE_PROTO = __webpack_require__(59)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(100)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(284).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(12).f;
var has = __webpack_require__(14);
var TAG = __webpack_require__(22)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(22);


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var core = __webpack_require__(11);
var LIBRARY = __webpack_require__(39);
var wksExt = __webpack_require__(66);
var defineProperty = __webpack_require__(12).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListenerWrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function addEventListenerWrap(target, eventType, cb) {
  /* eslint camelcase: 2 */
  var callback = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates ? function run(e) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates(cb, e);
  } : cb;
  return __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default()(target, eventType, callback);
}

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);








var Handle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Handle, _React$Component);

  function Handle() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Handle);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Handle.prototype.focus = function focus() {
    this.handle.focus();
  };

  Handle.prototype.blur = function blur() {
    this.handle.blur();
  };

  Handle.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        className = _props.className,
        vertical = _props.vertical,
        offset = _props.offset,
        style = _props.style,
        disabled = _props.disabled,
        min = _props.min,
        max = _props.max,
        value = _props.value,
        tabIndex = _props.tabIndex,
        restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'vertical', 'offset', 'style', 'disabled', 'min', 'max', 'value', 'tabIndex']);

    var postionStyle = vertical ? { bottom: offset + '%' } : { left: offset + '%' };
    var elStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, postionStyle);
    var ariaProps = {};
    if (value !== undefined) {
      ariaProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, ariaProps, {
        'aria-valuemin': min,
        'aria-valuemax': max,
        'aria-valuenow': value,
        'aria-disabled': !!disabled
      });
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      ref: function ref(node) {
        return _this2.handle = node;
      },
      role: 'slider',
      tabIndex: tabIndex || 0
    }, ariaProps, restProps, {
      className: className,
      style: elStyle
    }));
  };

  return Handle;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Handle);


Handle.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  vertical: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  offset: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  min: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  value: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  tabIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number
};

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = isEventFromHandle;
/* harmony export (immutable) */ __webpack_exports__["i"] = isValueOutOfRange;
/* harmony export (immutable) */ __webpack_exports__["h"] = isNotTouchEvent;
/* unused harmony export getClosestPoint */
/* unused harmony export getPrecision */
/* harmony export (immutable) */ __webpack_exports__["e"] = getMousePosition;
/* harmony export (immutable) */ __webpack_exports__["f"] = getTouchPosition;
/* harmony export (immutable) */ __webpack_exports__["c"] = getHandleCenterPosition;
/* harmony export (immutable) */ __webpack_exports__["a"] = ensureValueInRange;
/* harmony export (immutable) */ __webpack_exports__["b"] = ensureValuePrecision;
/* harmony export (immutable) */ __webpack_exports__["j"] = pauseEvent;
/* harmony export (immutable) */ __webpack_exports__["d"] = getKeyboardValueMutator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rc_util_es_KeyCode__ = __webpack_require__(312);



function isEventFromHandle(e, handles) {
  return Object.keys(handles).some(function (key) {
    return e.target === Object(__WEBPACK_IMPORTED_MODULE_0_react_dom__["findDOMNode"])(handles[key]);
  });
}

function isValueOutOfRange(value, _ref) {
  var min = _ref.min,
      max = _ref.max;

  return value < min || value > max;
}

function isNotTouchEvent(e) {
  return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
}

function getClosestPoint(val, _ref2) {
  var marks = _ref2.marks,
      step = _ref2.step,
      min = _ref2.min;

  var points = Object.keys(marks).map(parseFloat);
  if (step !== null) {
    var closestStep = Math.round((val - min) / step) * step + min;
    points.push(closestStep);
  }
  var diffs = points.map(function (point) {
    return Math.abs(val - point);
  });
  return points[diffs.indexOf(Math.min.apply(Math, diffs))];
}

function getPrecision(step) {
  var stepString = step.toString();
  var precision = 0;
  if (stepString.indexOf('.') >= 0) {
    precision = stepString.length - stepString.indexOf('.') - 1;
  }
  return precision;
}

function getMousePosition(vertical, e) {
  return vertical ? e.clientY : e.pageX;
}

function getTouchPosition(vertical, e) {
  return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}

function getHandleCenterPosition(vertical, handle) {
  var coords = handle.getBoundingClientRect();
  return vertical ? coords.top + coords.height * 0.5 : coords.left + coords.width * 0.5;
}

function ensureValueInRange(val, _ref3) {
  var max = _ref3.max,
      min = _ref3.min;

  if (val <= min) {
    return min;
  }
  if (val >= max) {
    return max;
  }
  return val;
}

function ensureValuePrecision(val, props) {
  var step = props.step;

  var closestPoint = getClosestPoint(val, props);
  return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
}

function pauseEvent(e) {
  e.stopPropagation();
  e.preventDefault();
}

function getKeyboardValueMutator(e) {
  switch (e.keyCode) {
    case __WEBPACK_IMPORTED_MODULE_1_rc_util_es_KeyCode__["a" /* default */].UP:
    case __WEBPACK_IMPORTED_MODULE_1_rc_util_es_KeyCode__["a" /* default */].RIGHT:
      return function (value, props) {
        return value + props.step;
      };

    case __WEBPACK_IMPORTED_MODULE_1_rc_util_es_KeyCode__["a" /* default */].DOWN:
    case __WEBPACK_IMPORTED_MODULE_1_rc_util_es_KeyCode__["a" /* default */].LEFT:
      return function (value, props) {
        return value - props.step;
      };

    case __WEBPACK_IMPORTED_MODULE_1_rc_util_es_KeyCode__["a" /* default */].END:
      return function (value, props) {
        return props.max;
      };
    case __WEBPACK_IMPORTED_MODULE_1_rc_util_es_KeyCode__["a" /* default */].HOME:
      return function (value, props) {
        return props.min;
      };
    case __WEBPACK_IMPORTED_MODULE_1_rc_util_es_KeyCode__["a" /* default */].PAGE_UP:
      return function (value, props) {
        return value + props.step * 2;
      };
    case __WEBPACK_IMPORTED_MODULE_1_rc_util_es_KeyCode__["a" /* default */].PAGE_DOWN:
      return function (value, props) {
        return value - props.step * 2;
      };

    default:
      return undefined;
  }
}

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Root reference for iframes.
 */

var root;
if (typeof window !== 'undefined') { // Browser window
  root = window;
} else if (typeof self !== 'undefined') { // Web Worker
  root = self;
} else { // Other environments
  console.warn("Using browser-only version of superagent in non-browser environment");
  root = this;
}

var Emitter = __webpack_require__(345);
var RequestBase = __webpack_require__(346);
var isObject = __webpack_require__(118);
var ResponseBase = __webpack_require__(347);
var Agent = __webpack_require__(349);

/**
 * Noop.
 */

function noop(){};

/**
 * Expose `request`.
 */

var request = exports = module.exports = function(method, url) {
  // callback
  if ('function' == typeof url) {
    return new exports.Request('GET', method).end(url);
  }

  // url first
  if (1 == arguments.length) {
    return new exports.Request('GET', method);
  }

  return new exports.Request(method, url);
}

exports.Request = Request;

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest
      && (!root.location || 'file:' != root.location.protocol
          || !root.ActiveXObject)) {
    return new XMLHttpRequest;
  } else {
    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
  }
  throw Error("Browser-only version of superagent could not find XHR");
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim
  ? function(s) { return s.trim(); }
  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    pushEncodedKeyValuePair(pairs, key, obj[key]);
  }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, val) {
  if (val != null) {
    if (Array.isArray(val)) {
      val.forEach(function(v) {
        pushEncodedKeyValuePair(pairs, key, v);
      });
    } else if (isObject(val)) {
      for(var subkey in val) {
        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
      }
    } else {
      pairs.push(encodeURIComponent(key)
        + '=' + encodeURIComponent(val));
    }
  } else if (val === null) {
    pairs.push(encodeURIComponent(key));
  }
}

/**
 * Expose serialization method.
 */

request.serializeObject = serialize;

/**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair;
  var pos;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');
    if (pos == -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] =
        decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'text/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

request.serialize = {
  'application/x-www-form-urlencoded': serialize,
  'application/json': JSON.stringify
};

/**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    if (index === -1) { // could be empty line, just skip it
      continue;
    }
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  // should match /json or +json
  // but not /json-seq
  return /[\/+]json($|[^-\w])/.test(mime);
}

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req) {
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
     ? this.xhr.responseText
     : null;
  this.statusText = this.req.xhr.statusText;
  var status = this.xhr.status;
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
    status = 204;
  }
  this._setStatusProperties(status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this._setHeaderProperties(this.header);

  if (null === this.text && req._responseType) {
    this.body = this.xhr.response;
  } else {
    this.body = this.req.method != 'HEAD'
      ? this._parseBody(this.text ? this.text : this.xhr.response)
      : null;
  }
}

ResponseBase(Response.prototype);

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function(str) {
  var parse = request.parse[this.type];
  if (this.req._parser) {
    return this.req._parser(this, str);
  }
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && str && (str.length || str instanceof Object)
    ? parse(str)
    : null;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function(){
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', function(){
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch(e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      // issue #675: return the raw response if the response parsing fails
      if (self.xhr) {
        // ie9 doesn't have 'response' property
        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
        // issue #876: return the http status code if the response parsing fails
        err.status = self.xhr.status ? self.xhr.status : null;
        err.statusCode = err.status; // backwards-compat only
      } else {
        err.rawResponse = null;
        err.status = null;
      }

      return self.callback(err);
    }

    self.emit('response', res);

    var new_err;
    try {
      if (!self._isResponseOK(res)) {
        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
      }
    } catch(custom_err) {
      new_err = custom_err; // ok() callback can throw
    }

    // #1000 don't catch errors from the callback to avoid double calling it
    if (new_err) {
      new_err.original = err;
      new_err.response = res;
      new_err.status = res.status;
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}

/**
 * Mixin `Emitter` and `RequestBase`.
 */

Emitter(Request.prototype);
RequestBase(Request.prototype);

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function(type){
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function(type){
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function(user, pass, options){
  if (1 === arguments.length) pass = '';
  if (typeof pass === 'object' && pass !== null) { // pass is optional and can be replaced with options
    options = pass;
    pass = '';
  }
  if (!options) {
    options = {
      type: 'function' === typeof btoa ? 'basic' : 'auto',
    };
  }

  var encoder = function(string) {
    if ('function' === typeof btoa) {
      return btoa(string);
    }
    throw new Error('Cannot use basic auth, btoa is not a function');
  };

  return this._auth(user, pass, options, encoder);
};

/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.query = function(val){
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function(field, file, options){
  if (file) {
    if (this._data) {
      throw Error("superagent can't mix .send() and .attach()");
    }

    this._getFormData().append(field, file, options || file.name);
  }
  return this;
};

Request.prototype._getFormData = function(){
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function(err, res){
  if (this._shouldRetry(err, res)) {
    return this._retry();
  }

  var fn = this._callback;
  this.clearTimeout();

  if (err) {
    if (this._maxRetries) err.retries = this._retries - 1;
    this.emit('error', err);
  }

  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function(){
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;

  err.status = this.status;
  err.method = this.method;
  err.url = this.url;

  this.callback(err);
};

// This only warns, because the request is still likely to work
Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
  console.warn("This is not supported in browser version of superagent");
  return this;
};

// This throws, because it can't send/receive data as expected
Request.prototype.pipe = Request.prototype.write = function(){
  throw Error("Streaming is not supported in browser version of superagent");
};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */
Request.prototype._isHost = function _isHost(obj) {
  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
}

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function(fn){
  if (this._endCalled) {
    console.warn("Warning: .end() was called twice. This is not supported in superagent");
  }
  this._endCalled = true;

  // store callback
  this._callback = fn || noop;

  // querystring
  this._finalizeQueryString();

  return this._end();
};

Request.prototype._end = function() {
  var self = this;
  var xhr = (this.xhr = request.getXHR());
  var data = this._formData || this._data;

  this._setTimeouts();

  // state change
  xhr.onreadystatechange = function(){
    var readyState = xhr.readyState;
    if (readyState >= 2 && self._responseTimeoutTimer) {
      clearTimeout(self._responseTimeoutTimer);
    }
    if (4 != readyState) {
      return;
    }

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status;
    try { status = xhr.status } catch(e) { status = 0; }

    if (!status) {
      if (self.timedout || self._aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function(direction, e) {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    e.direction = direction;
    self.emit('progress', e);
  };
  if (this.hasListeners('progress')) {
    try {
      xhr.onprogress = handleProgress.bind(null, 'download');
      if (xhr.upload) {
        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
      }
    } catch(e) {
      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }

  // initiate request
  try {
    if (this.username && this.password) {
      xhr.open(this.method, this.url, true, this.username, this.password);
    } else {
      xhr.open(this.method, this.url, true);
    }
  } catch (err) {
    // see #1149
    return this.callback(err);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];
    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) {
      serialize = request.serialize['application/json'];
    }
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;

    if (this.header.hasOwnProperty(field))
      xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data !== 'undefined' ? data : null);
  return this;
};

request.agent = function() {
  return new Agent();
};

["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function(method) {
  Agent.prototype[method.toLowerCase()] = function(url, fn) {
    var req = new request.Request(method, url);
    this._setDefaults(req);
    if (fn) {
      req.end(fn);
    }
    return req;
  };
});

Agent.prototype.del = Agent.prototype['delete'];

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function(url, data, fn) {
  var req = request('GET', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.head = function(url, data, fn) {
  var req = request('HEAD', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.options = function(url, data, fn) {
  var req = request('OPTIONS', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

function del(url, data, fn) {
  var req = request('DELETE', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
}

request['del'] = del;
request['delete'] = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function(url, data, fn) {
  var req = request('PATCH', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.post = function(url, data, fn) {
  var req = request('POST', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.put = function(url, data, fn) {
  var req = request('PUT', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(126);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 73 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(80);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(51);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, 'You should not use <Route> or withRouter() outside a <Router>');

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.hoistNonReactStatics = factory());
}(this, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button_css__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Button_css__);
var Button=function Button(_ref){var className=_ref.className,value=_ref.value,onClick=_ref.onClick,children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:['configurator-button',className].join(' '),onClick:onClick,onTouchEnd:onClick,value:value},children);};/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context__ = __webpack_require__(53);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var removedIsInitialSSR = false;

var I18n = function (_Component) {
  _inherits(I18n, _Component);

  function I18n(props, context) {
    _classCallCheck(this, I18n);

    var _this = _possibleConstructorReturn(this, (I18n.__proto__ || Object.getPrototypeOf(I18n)).call(this, props, context));

    _this.i18n = props.i18n || context.i18n || Object(__WEBPACK_IMPORTED_MODULE_2__context__["b" /* getI18n */])();
    _this.namespaces = props.ns || _this.i18n.options && _this.i18n.options.defaultNS;
    if (typeof _this.namespaces === 'string') _this.namespaces = [_this.namespaces];

    var i18nOptions = _this.i18n && _this.i18n.options && _this.i18n.options.react || {};
    _this.options = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2__context__["a" /* getDefaults */])(), i18nOptions, props);

    // nextjs SSR: getting data from next.js or other ssr stack
    if (props.initialI18nStore) {
      _this.i18n.services.resourceStore.data = props.initialI18nStore;
      _this.options.wait = false; // we got all passed down already
    }
    if (props.initialLanguage) {
      _this.i18n.changeLanguage(props.initialLanguage);
    }

    // provider SSR: data was set in provider and ssr flag was set
    if (_this.i18n.options && _this.i18n.options.isInitialSSR) {
      _this.options.wait = false;
    }

    var language = _this.i18n.languages && _this.i18n.languages[0];
    var ready = !!language && _this.namespaces.every(function (ns) {
      return _this.i18n.hasResourceBundle(language, ns);
    });

    _this.state = {
      i18nLoadedAt: null,
      ready: ready
    };

    _this.t = _this.getI18nTranslate();

    _this.onI18nChanged = _this.onI18nChanged.bind(_this);
    _this.getI18nTranslate = _this.getI18nTranslate.bind(_this);
    return _this;
  }

  _createClass(I18n, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        t: this.t,
        i18n: this.i18n
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var bind = function bind() {
        if (_this2.options.bindI18n && _this2.i18n) _this2.i18n.on(_this2.options.bindI18n, _this2.onI18nChanged);
        if (_this2.options.bindStore && _this2.i18n.store) _this2.i18n.store.on(_this2.options.bindStore, _this2.onI18nChanged);
      };

      this.mounted = true;
      this.i18n.loadNamespaces(this.namespaces, function () {
        var ready = function ready() {
          if (_this2.mounted && !_this2.state.ready) _this2.setState({ ready: true });
          if (_this2.options.wait && _this2.mounted) bind();
        };

        if (_this2.i18n.isInitialized) {
          ready();
        } else {
          var initialized = function initialized() {
            // due to emitter removing issue in i18next we need to delay remove
            setTimeout(function () {
              _this2.i18n.off('initialized', initialized);
            }, 1000);
            ready();
          };

          _this2.i18n.on('initialized', initialized);
        }
      });

      if (!this.options.wait) bind();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this3 = this;

      this.mounted = false;
      if (this.onI18nChanged) {
        if (this.options.bindI18n) {
          var p = this.options.bindI18n.split(' ');
          p.forEach(function (f) {
            return _this3.i18n.off(f, _this3.onI18nChanged);
          });
        }
        if (this.options.bindStore) {
          var _p = this.options.bindStore.split(' ');
          _p.forEach(function (f) {
            return _this3.i18n.store && _this3.i18n.store.off(f, _this3.onI18nChanged);
          });
        }
      }
    }
  }, {
    key: 'onI18nChanged',
    value: function onI18nChanged() {
      if (!this.mounted) return;

      this.t = this.getI18nTranslate();
      this.setState({ i18nLoadedAt: new Date() }); // rerender
    }
  }, {
    key: 'getI18nTranslate',
    value: function getI18nTranslate() {
      return this.i18n.getFixedT(null, this.options.nsMode === 'fallback' ? this.namespaces : this.namespaces[0]);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var children = this.props.children;
      var ready = this.state.ready;


      if (!ready && this.options.wait) return null;

      // remove ssr flag set by provider - first render was done from now on wait if set to wait
      if (this.i18n.options && this.i18n.options.isInitialSSR && !removedIsInitialSSR) {
        removedIsInitialSSR = true;
        setTimeout(function () {
          delete _this4.i18n.options.isInitialSSR;
        }, 100);
      }

      return children(this.t, {
        i18n: this.i18n,
        t: this.t,
        ready: ready
      });
    }
  }]);

  return I18n;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (I18n);


I18n.contextTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

I18n.childContextTypes = {
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTransformedLabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var getTransformedLabel=function getTransformedLabel(material){var color=material.color,ornament=material.ornament;var label=void 0;switch(material.color_type){case'ral':label='RAL '+color.split(' ')[0];break;case'anodized':label=color.split('_')[1];label=label[0].toUpperCase()+label.substring(1);break;case'decor':label=ornament;break;default:break;}return label;};var ColorPicker=function ColorPicker(_ref){var colors=_ref.colors,activeLayer=_ref.activeLayer,hideLabel=_ref.hideLabel,className=_ref.className,onClick=_ref.onClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:className},colors.map(function(color){var classes=['configurator-color-picker','aluk-activable'];if(color.image_file===activeLayer){classes.push('active');}if(color.declinable)classes.push('declinable');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{key:color.image_file+color.customDesign,className:classes.join(' '),style:color.css,onClick:onClick,value:JSON.stringify(color)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,!hideLabel&&getTransformedLabel(color)));}));};/* harmony default export */ __webpack_exports__["a"] = (ColorPicker);

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/H48010.d91d7a3c.png";

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/H48011.b7b9b5ac.png";

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/H48012.cf749e9a.png";

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/H48013.43401b09.png";

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/H48103.21da8061.png";

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/H48104.464af88b.png";

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/H48106.172aa059.png";

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/H48107.e2c0dd0e.png";

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_i18n__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_regions_json__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_regions_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config_regions_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AluKHeader__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HandlePicker_css__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HandlePicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__HandlePicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Configurator_css__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Configurator_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Configurator_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HandlePicker=function(_Component){_inherits(HandlePicker,_Component);function HandlePicker(props){_classCallCheck(this,HandlePicker);// Init from parent
var _this=_possibleConstructorReturn(this,(HandlePicker.__proto__||Object.getPrototypeOf(HandlePicker)).call(this,props));_this.handles=props.handles;_this.region=props.region;// Or standalone call (first step before configurator)
if(typeof props.match!=='undefined'){// Init i18n
var region=props.match.params.region;_this.region=region;var lang=void 0;__WEBPACK_IMPORTED_MODULE_5__config_regions_json___default.a.forEach(function(continent){var r=continent.countries.find(function(c){return c.id===region;});if(typeof r!=='undefined'){lang=r.lang;_this.handles=__webpack_require__(55)("./"+r.colorSet+'.json');}});__WEBPACK_IMPORTED_MODULE_3__config_i18n__["a" /* default */].changeLanguage(lang);}_this.state={handle:null,frame:__WEBPACK_IMPORTED_MODULE_4_store___default.a.get('backgroundFrame')||0};return _this;}_createClass(HandlePicker,[{key:'setFrameColor',value:function setFrameColor(frame){var _this2=this;this.setState({frame:frame},function(){__WEBPACK_IMPORTED_MODULE_4_store___default.a.set('backgroundFrame',frame);if(typeof _this2.props.onUpdate==='function'){_this2.props.onUpdate();}});}},{key:'render',value:function render(){var _this3=this;var handleComps=[];this.handles.forEach(function(h,i){var thumb=__webpack_require__(265)("./"+h.handle+'.png');var classes=['aluk-activable'];if(_this3.props.handle===h.handle)classes.push('active');// I know that's horrible
if(['H48103','H48104'].includes(h.handle))classes.push('declinable');handleComps.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:h.handle,className:classes.join(' ')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/'+_this3.region+'/'+h.handle,className:'configurator-handle-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:thumb,alt:h.handle}))));});var frameClasses=['configurator-frames'];var frameComps=[];// Getting the first element as every handle has the same color collection
// ... for now :')
this.handles[0].backgroundFrames.forEach(function(f,i){var classes=['aluk-activable','configurator-color-picker'];if(_this3.state.frame===i){classes.push('active');}frameComps.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{key:i,className:classes.join(' '),onClick:function onClick(){return _this3.setFrameColor(i);},style:{background:f.css}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'RAL '+f.ral)));});return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AluKHeader__["a" /* default */],{key:'aluk-header'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["a" /* I18n */],{key:'aluk-step2'},function(t,_ref){var i18n=_ref.i18n;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'configurator-handles-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:frameClasses.join(' ')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,t('configurator.chooseFrameColor')),frameComps),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'configurator-handles'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,t('configurator.chooseHandle')),handleComps));})];}}]);return HandlePicker;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (HandlePicker);

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

  processors: {},

  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });

    return value;
  }
});

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/novae-black.0941d346.png";

/***/ }),
/* 97 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(273);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(13) && !__webpack_require__(29)(function () {
  return Object.defineProperty(__webpack_require__(100)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var document = __webpack_require__(10).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(14);
var toIObject = __webpack_require__(21);
var arrayIndexOf = __webpack_require__(275)(false);
var IE_PROTO = __webpack_require__(59)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(103);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 103 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(57);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(39);
var $export = __webpack_require__(18);
var redefine = __webpack_require__(106);
var hide = __webpack_require__(19);
var Iterators = __webpack_require__(63);
var $iterCreate = __webpack_require__(282);
var setToStringTag = __webpack_require__(65);
var getPrototypeOf = __webpack_require__(285);
var ITERATOR = __webpack_require__(22)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(19);


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(101);
var hiddenKeys = __webpack_require__(61).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(41);
var createDesc = __webpack_require__(37);
var toIObject = __webpack_require__(21);
var toPrimitive = __webpack_require__(56);
var has = __webpack_require__(14);
var IE8_DOM_DEFINE = __webpack_require__(99);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(13) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);

/* eslint-disable react/prop-types */


var Track = function Track(props) {
  var className = props.className,
      included = props.included,
      vertical = props.vertical,
      offset = props.offset,
      length = props.length,
      style = props.style;


  var positonStyle = vertical ? {
    bottom: offset + '%',
    height: length + '%'
  } : {
    left: offset + '%',
    width: length + '%'
  };

  var elStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, positonStyle);
  return included ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: className, style: elStyle }) : null;
};

/* harmony default export */ __webpack_exports__["a"] = (Track);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSlider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_addEventListener__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Steps__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Marks__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Handle__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(70);















function noop() {}

function createSlider(Component) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ComponentEnhancer, _Component);

    function ComponentEnhancer(props) {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ComponentEnhancer);

      var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));

      _this.onMouseDown = function (e) {
        if (e.button !== 0) {
          return;
        }

        var isVertical = _this.props.vertical;
        var position = __WEBPACK_IMPORTED_MODULE_13__utils__["e" /* getMousePosition */](isVertical, e);
        if (!__WEBPACK_IMPORTED_MODULE_13__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = __WEBPACK_IMPORTED_MODULE_13__utils__["c" /* getHandleCenterPosition */](isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }
        _this.removeDocumentEvents();
        _this.onStart(position);
        _this.addDocumentMouseEvents();
        __WEBPACK_IMPORTED_MODULE_13__utils__["j" /* pauseEvent */](e);
      };

      _this.onTouchStart = function (e) {
        if (__WEBPACK_IMPORTED_MODULE_13__utils__["h" /* isNotTouchEvent */](e)) return;

        var isVertical = _this.props.vertical;
        var position = __WEBPACK_IMPORTED_MODULE_13__utils__["f" /* getTouchPosition */](isVertical, e);
        if (!__WEBPACK_IMPORTED_MODULE_13__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = __WEBPACK_IMPORTED_MODULE_13__utils__["c" /* getHandleCenterPosition */](isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }
        _this.onStart(position);
        _this.addDocumentTouchEvents();
        __WEBPACK_IMPORTED_MODULE_13__utils__["j" /* pauseEvent */](e);
      };

      _this.onFocus = function (e) {
        var _this$props = _this.props,
            onFocus = _this$props.onFocus,
            vertical = _this$props.vertical;

        if (__WEBPACK_IMPORTED_MODULE_13__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs)) {
          var handlePosition = __WEBPACK_IMPORTED_MODULE_13__utils__["c" /* getHandleCenterPosition */](vertical, e.target);
          _this.dragOffset = 0;
          _this.onStart(handlePosition);
          __WEBPACK_IMPORTED_MODULE_13__utils__["j" /* pauseEvent */](e);
          if (onFocus) {
            onFocus(e);
          }
        }
      };

      _this.onBlur = function (e) {
        var onBlur = _this.props.onBlur;

        _this.onEnd(e);
        if (onBlur) {
          onBlur(e);
        }
      };

      _this.onMouseMove = function (e) {
        if (!_this.sliderRef) {
          _this.onEnd();
          return;
        }
        var position = __WEBPACK_IMPORTED_MODULE_13__utils__["e" /* getMousePosition */](_this.props.vertical, e);
        _this.onMove(e, position - _this.dragOffset);
      };

      _this.onTouchMove = function (e) {
        if (__WEBPACK_IMPORTED_MODULE_13__utils__["h" /* isNotTouchEvent */](e) || !_this.sliderRef) {
          _this.onEnd();
          return;
        }

        var position = __WEBPACK_IMPORTED_MODULE_13__utils__["f" /* getTouchPosition */](_this.props.vertical, e);
        _this.onMove(e, position - _this.dragOffset);
      };

      _this.onKeyDown = function (e) {
        if (_this.sliderRef && __WEBPACK_IMPORTED_MODULE_13__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs)) {
          _this.onKeyboard(e);
        }
      };

      _this.saveSlider = function (slider) {
        _this.sliderRef = slider;
      };

      if (false) {
        var step = props.step,
            max = props.max,
            min = props.min;

        warning(step && Math.floor(step) === step ? (max - min) % step === 0 : true, 'Slider[max] - Slider[min] (%s) should be a multiple of Slider[step] (%s)', max - min, step);
      }
      _this.handlesRefs = {};
      return _this;
    }

    ComponentEnhancer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (_Component.prototype.componentWillUnmount) _Component.prototype.componentWillUnmount.call(this);
      this.removeDocumentEvents();
    };

    ComponentEnhancer.prototype.componentDidMount = function componentDidMount() {
      // Snapshot testing cannot handle refs, so be sure to null-check this.
      this.document = this.sliderRef && this.sliderRef.ownerDocument;
    };

    ComponentEnhancer.prototype.addDocumentTouchEvents = function addDocumentTouchEvents() {
      // just work for Chrome iOS Safari and Android Browser
      this.onTouchMoveListener = Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'touchmove', this.onTouchMove);
      this.onTouchUpListener = Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'touchend', this.onEnd);
    };

    ComponentEnhancer.prototype.addDocumentMouseEvents = function addDocumentMouseEvents() {
      this.onMouseMoveListener = Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'mousemove', this.onMouseMove);
      this.onMouseUpListener = Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'mouseup', this.onEnd);
    };

    ComponentEnhancer.prototype.removeDocumentEvents = function removeDocumentEvents() {
      /* eslint-disable no-unused-expressions */
      this.onTouchMoveListener && this.onTouchMoveListener.remove();
      this.onTouchUpListener && this.onTouchUpListener.remove();

      this.onMouseMoveListener && this.onMouseMoveListener.remove();
      this.onMouseUpListener && this.onMouseUpListener.remove();
      /* eslint-enable no-unused-expressions */
    };

    ComponentEnhancer.prototype.focus = function focus() {
      if (!this.props.disabled) {
        this.handlesRefs[0].focus();
      }
    };

    ComponentEnhancer.prototype.blur = function blur() {
      if (!this.props.disabled) {
        this.handlesRefs[0].blur();
      }
    };

    ComponentEnhancer.prototype.getSliderStart = function getSliderStart() {
      var slider = this.sliderRef;
      var rect = slider.getBoundingClientRect();

      return this.props.vertical ? rect.top : rect.left;
    };

    ComponentEnhancer.prototype.getSliderLength = function getSliderLength() {
      var slider = this.sliderRef;
      if (!slider) {
        return 0;
      }

      var coords = slider.getBoundingClientRect();
      return this.props.vertical ? coords.height : coords.width;
    };

    ComponentEnhancer.prototype.calcValue = function calcValue(offset) {
      var _props = this.props,
          vertical = _props.vertical,
          min = _props.min,
          max = _props.max;

      var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
      var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
      return value;
    };

    ComponentEnhancer.prototype.calcValueByPos = function calcValueByPos(position) {
      var pixelOffset = position - this.getSliderStart();
      var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
      return nextValue;
    };

    ComponentEnhancer.prototype.calcOffset = function calcOffset(value) {
      var _props2 = this.props,
          min = _props2.min,
          max = _props2.max;

      var ratio = (value - min) / (max - min);
      return ratio * 100;
    };

    ComponentEnhancer.prototype.saveHandle = function saveHandle(index, handle) {
      this.handlesRefs[index] = handle;
    };

    ComponentEnhancer.prototype.render = function render() {
      var _classNames;

      var _props3 = this.props,
          prefixCls = _props3.prefixCls,
          className = _props3.className,
          marks = _props3.marks,
          dots = _props3.dots,
          step = _props3.step,
          included = _props3.included,
          disabled = _props3.disabled,
          vertical = _props3.vertical,
          min = _props3.min,
          max = _props3.max,
          children = _props3.children,
          maximumTrackStyle = _props3.maximumTrackStyle,
          style = _props3.style,
          railStyle = _props3.railStyle,
          dotStyle = _props3.dotStyle,
          activeDotStyle = _props3.activeDotStyle;

      var _Component$prototype$ = _Component.prototype.render.call(this),
          tracks = _Component$prototype$.tracks,
          handles = _Component$prototype$.handles;

      var sliderClassName = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(prefixCls, (_classNames = {}, _classNames[prefixCls + '-with-marks'] = Object.keys(marks).length, _classNames[prefixCls + '-disabled'] = disabled, _classNames[prefixCls + '-vertical'] = vertical, _classNames[className] = className, _classNames));
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        {
          ref: this.saveSlider,
          className: sliderClassName,
          onTouchStart: disabled ? noop : this.onTouchStart,
          onMouseDown: disabled ? noop : this.onMouseDown,
          onKeyDown: disabled ? noop : this.onKeyDown,
          onFocus: disabled ? noop : this.onFocus,
          onBlur: disabled ? noop : this.onBlur,
          style: style
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', {
          className: prefixCls + '-rail',
          style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, maximumTrackStyle, railStyle)
        }),
        tracks,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Steps__["a" /* default */], {
          prefixCls: prefixCls,
          vertical: vertical,
          marks: marks,
          dots: dots,
          step: step,
          included: included,
          lowerBound: this.getLowerBound(),
          upperBound: this.getUpperBound(),
          max: max,
          min: min,
          dotStyle: dotStyle,
          activeDotStyle: activeDotStyle
        }),
        handles,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Marks__["a" /* default */], {
          className: prefixCls + '-mark',
          vertical: vertical,
          marks: marks,
          included: included,
          lowerBound: this.getLowerBound(),
          upperBound: this.getUpperBound(),
          max: max,
          min: min
        }),
        children
      );
    };

    return ComponentEnhancer;
  }(Component), _class.displayName = 'ComponentEnhancer(' + Component.displayName + ')', _class.propTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Component.propTypes, {
    min: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
    max: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
    step: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
    marks: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
    included: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    onBeforeChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onAfterChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    handle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    dots: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    vertical: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
    minimumTrackStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, // just for compatibility, will be deperecate
    maximumTrackStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, // just for compatibility, will be deperecate
    handleStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object)]),
    trackStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object)]),
    railStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
    dotStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
    activeDotStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
    autoFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    onFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onBlur: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  }), _class.defaultProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Component.defaultProps, {
    prefixCls: 'rc-slider',
    className: '',
    min: 0,
    max: 100,
    step: 1,
    marks: {},
    handle: function handle(_ref) {
      var index = _ref.index,
          restProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['index']);

      delete restProps.dragging;
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Handle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, restProps, { key: index }));
    },

    onBeforeChange: noop,
    onChange: noop,
    onAfterChange: noop,
    included: true,
    disabled: false,
    dots: false,
    vertical: false,
    trackStyle: [{}],
    handleStyle: [{}],
    railStyle: {},
    dotStyle: {},
    activeDotStyle: {}
  }), _temp;
}

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports = function shallowEqual(objA, objB, compare, compareContext) {

    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

    if(ret !== void 0) {
        return !!ret;
    }

    if(objA === objB) {
        return true;
    }

    if(typeof objA !== 'object' || !objA ||
       typeof objB !== 'object' || !objB) {
        return false;
    }

    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);

    if(keysA.length !== keysB.length) {
        return false;
    }

    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++) {

        var key = keysA[idx];

        if(!bHasOwnProperty(key)) {
            return false;
        }

        var valueA = objA[key];
        var valueB = objB[key];

        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

        if(ret === false ||
           ret === void 0 && valueA !== valueB) {
            return false;
        }

    }

    return true;

};


/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(23);


/**
 * 得到会导致元素显示不全的祖先元素
 */

function getOffsetParent(element) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(element) || element.nodeType === 9) {
    return null;
  }
  // ie 这个也不是完全可行
  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法
  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(element);
  var body = doc.body;
  var parent = void 0;
  var positionStyle = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';

  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : element.parentNode;
  }

  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
    positionStyle = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(parent, 'position');
    if (positionStyle !== 'static') {
      return parent;
    }
  }
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (getOffsetParent);

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(333), __esModule: true };

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var LazyRenderBox = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LazyRenderBox, _Component);

  function LazyRenderBox() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return nextProps.hiddenClassName || nextProps.visible;
  };

  LazyRenderBox.prototype.render = function render() {
    var _props = this.props,
        hiddenClassName = _props.hiddenClassName,
        visible = _props.visible,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['hiddenClassName', 'visible']);

    if (hiddenClassName || __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.count(props.children) > 1) {
      if (!visible && hiddenClassName) {
        props.className += ' ' + hiddenClassName;
      }
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', props);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(props.children);
  };

  return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

LazyRenderBox.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAlignFromPlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = getPopupClassNameFromAlign;
/* harmony export (immutable) */ __webpack_exports__["c"] = saveRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function isPointsEq(a1, a2) {
  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, baseAlign, align);
}

function getPopupClassNameFromAlign(builtinPlacements, prefixCls, align) {
  var points = align.points;
  for (var placement in builtinPlacements) {
    if (builtinPlacements.hasOwnProperty(placement)) {
      if (isPointsEq(builtinPlacements[placement].points, points)) {
        return prefixCls + '-placement-' + placement;
      }
    }
  }
  return '';
}

function saveRef(name, component) {
  this[name] = component;
}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return null !== obj && 'object' === typeof obj;
}

module.exports = isObject;


/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = {"apiURL":"http://localhost:8080"}

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = {"uploadRoute":"/upload","perspectiveRoute":"/perspective","sendEmailRoute":"/send"}

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/H48104-guides.7c785dca.png";

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(124);
module.exports = __webpack_require__(129);


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(125).enable();
  window.Promise = __webpack_require__(127);
}

// fetch() polyfill for making API calls.
__webpack_require__(128);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(31);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(72);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73)))

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(72);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 128 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_i18n__ = __webpack_require__(33);
// import registerServiceWorker from './registerServiceWorker'
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],null),document.getElementById('root'));// registerServiceWorker()

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(31),n=__webpack_require__(45),p=__webpack_require__(74),q=__webpack_require__(46),r="function"===typeof Symbol&&Symbol["for"],t=r?Symbol["for"]("react.element"):60103,u=r?Symbol["for"]("react.portal"):60106,v=r?Symbol["for"]("react.fragment"):60107,w=r?Symbol["for"]("react.strict_mode"):60108,x=r?Symbol["for"]("react.provider"):60109,y=r?Symbol["for"]("react.context"):60110,z=r?Symbol["for"]("react.async_mode"):60111,A=r?Symbol["for"]("react.forward_ref"):
60112,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b=arguments.length-1,e="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};
function E(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?C("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}var H=G.prototype=new F;
H.constructor=G;m(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J=Object.prototype.hasOwnProperty,K={key:!0,ref:!0,__self:!0,__source:!0};
function L(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var k=Array(f),l=0;l<f;l++)k[l]=arguments[l+2];d.children=k}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:I.current}}
function M(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var N=/\/+/g,O=[];function P(a,b,e,c){if(O.length){var d=O.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function Q(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>O.length&&O.push(a)}
function R(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+S(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+S(d,h);g+=R(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+S(d,h++),g+=R(d,f,e,c);else"object"===d&&(e=""+a,C("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function S(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function T(a,b){a.func.call(a.context,b,a.count++)}
function U(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,e,q.thatReturnsArgument):null!=a&&(M(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(N,"$\x26/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function V(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(N,"$\x26/")+"/");b=P(b,g,c,d);null==a||R(a,"",U,b);Q(b)}
var W={Children:{map:function(a,b,e){if(null==a)return a;var c=[];V(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=P(null,null,b,e);null==a||R(a,"",T,b);Q(b)},count:function(a){return null==a?0:R(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];V(a,b,null,q.thatReturnsArgument);return b},only:function(a){M(a)?void 0:C("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:y,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_changedBits:0,Provider:null,Consumer:null};a.Provider={$$typeof:x,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:A,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:z,createElement:L,cloneElement:function(a,b,e){null===a||void 0===a?C("267",a):void 0;var c=void 0,d=m({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=I.current);void 0!==b.key&&(g=""+b.key);var k=void 0;a.type&&a.type.defaultProps&&
(k=a.type.defaultProps);for(c in b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==k?k[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){k=Array(c);for(var l=0;l<c;l++)k[l]=arguments[l+2];d.children=k}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=L.bind(null,a);b.type=a;return b},isValidElement:M,version:"16.3.2",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:I,assign:m}},X=Object.freeze({default:W}),
Y=X&&W||X;module.exports=Y["default"]?Y["default"]:Y;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var ba=__webpack_require__(45),ea=__webpack_require__(0),m=__webpack_require__(132),A=__webpack_require__(31),C=__webpack_require__(46),fa=__webpack_require__(133),ha=__webpack_require__(134),ja=__webpack_require__(135),ka=__webpack_require__(74);
function D(a){for(var b=arguments.length-1,c="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ea?void 0:D("227");
function ma(a,b,c,d,e,f,h,g,k){this._hasCaughtError=!1;this._caughtError=null;var v=Array.prototype.slice.call(arguments,3);try{b.apply(c,v)}catch(l){this._caughtError=l,this._hasCaughtError=!0}}
var E={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,h,g,k){ma.apply(E,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,h,g,k){E.invokeGuardedCallback.apply(this,arguments);if(E.hasCaughtError()){var v=E.clearCaughtError();E._hasRethrowError||(E._hasRethrowError=!0,E._rethrowError=v)}},rethrowCaughtError:function(){return na.apply(E,arguments)},hasCaughtError:function(){return E._hasCaughtError},clearCaughtError:function(){if(E._hasCaughtError){var a=
E._caughtError;E._caughtError=null;E._hasCaughtError=!1;return a}D("198")}};function na(){if(E._hasRethrowError){var a=E._rethrowError;E._rethrowError=null;E._hasRethrowError=!1;throw a;}}var oa=null,pa={};
function qa(){if(oa)for(var a in pa){var b=pa[a],c=oa.indexOf(a);-1<c?void 0:D("96",a);if(!ra[c]){b.extractEvents?void 0:D("97",a);ra[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],h=b,g=d;sa.hasOwnProperty(g)?D("99",g):void 0;sa[g]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ta(k[e],h,g);e=!0}else f.registrationName?(ta(f.registrationName,h,g),e=!0):e=!1;e?void 0:D("98",d,a)}}}}
function ta(a,b,c){ua[a]?D("100",a):void 0;ua[a]=b;va[a]=b.eventTypes[c].dependencies}var ra=[],sa={},ua={},va={};function wa(a){oa?D("101"):void 0;oa=Array.prototype.slice.call(a);qa()}function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];pa.hasOwnProperty(c)&&pa[c]===d||(pa[c]?D("102",c):void 0,pa[c]=d,b=!0)}b&&qa()}
var Ca=Object.freeze({plugins:ra,eventNameDispatchConfigs:sa,registrationNameModules:ua,registrationNameDependencies:va,possibleRegistrationNames:null,injectEventPluginOrder:wa,injectEventPluginsByName:xa}),Da=null,Ea=null,Fa=null;function Ga(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Fa(d);E.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Ha(a,b){null==b?D("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ia(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ja=null;
function Ka(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Ga(a,b,c[e],d[e]);else c&&Ga(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function La(a){return Ka(a,!0)}function Ma(a){return Ka(a,!1)}var Na={injectEventPluginOrder:wa,injectEventPluginsByName:xa};
function Oa(a,b){var c=a.stateNode;if(!c)return null;var d=Da(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?D("231",b,typeof c):void 0;
return c}function Pa(a,b){null!==a&&(Ja=Ha(Ja,a));a=Ja;Ja=null;a&&(b?Ia(a,La):Ia(a,Ma),Ja?D("95"):void 0,E.rethrowCaughtError())}function Qa(a,b,c,d){for(var e=null,f=0;f<ra.length;f++){var h=ra[f];h&&(h=h.extractEvents(a,b,c,d))&&(e=Ha(e,h))}Pa(e,!1)}var Ra=Object.freeze({injection:Na,getListener:Oa,runEventsInBatch:Pa,runExtractedEventsInBatch:Qa}),Sa=Math.random().toString(36).slice(2),F="__reactInternalInstance$"+Sa,Ta="__reactEventHandlers$"+Sa;
function Ua(a){if(a[F])return a[F];for(;!a[F];)if(a.parentNode)a=a.parentNode;else return null;a=a[F];return 5===a.tag||6===a.tag?a:null}function Va(a){if(5===a.tag||6===a.tag)return a.stateNode;D("33")}function Xa(a){return a[Ta]||null}var bb=Object.freeze({precacheFiberNode:function(a,b){b[F]=a},getClosestInstanceFromNode:Ua,getInstanceFromNode:function(a){a=a[F];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Va,getFiberCurrentPropsFromNode:Xa,updateFiberProps:function(a,b){a[Ta]=b}});
function L(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function cb(a,b,c){for(var d=[];a;)d.push(a),a=L(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function db(a,b,c){if(b=Oa(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Ha(c._dispatchListeners,b),c._dispatchInstances=Ha(c._dispatchInstances,a)}function eb(a){a&&a.dispatchConfig.phasedRegistrationNames&&cb(a._targetInst,db,a)}
function fb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?L(b):null;cb(b,db,a)}}function gb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Oa(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Ha(c._dispatchListeners,b),c._dispatchInstances=Ha(c._dispatchInstances,a))}function hb(a){a&&a.dispatchConfig.registrationName&&gb(a._targetInst,null,a)}function ib(a){Ia(a,eb)}
function jb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,h=0,g=e;g;g=L(g))h++;g=0;for(var k=f;k;k=L(k))g++;for(;0<h-g;)e=L(e),h--;for(;0<g-h;)f=L(f),g--;for(;h--;){if(e===f||e===f.alternate)break a;e=L(e);f=L(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){h=c.alternate;if(null!==h&&h===f)break;e.push(c);c=L(c)}for(c=[];d&&d!==f;){h=d.alternate;if(null!==h&&h===f)break;c.push(d);d=L(d)}for(d=0;d<e.length;d++)gb(e[d],"bubbled",a);for(a=c.length;0<a--;)gb(c[a],"captured",b)}
var kb=Object.freeze({accumulateTwoPhaseDispatches:ib,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ia(a,fb)},accumulateEnterLeaveDispatches:jb,accumulateDirectDispatches:function(a){Ia(a,hb)}}),lb=null;function mb(){!lb&&m.canUseDOM&&(lb="textContent"in document.documentElement?"textContent":"innerText");return lb}var M={_root:null,_startText:null,_fallbackText:null};
function nb(){if(M._fallbackText)return M._fallbackText;var a,b=M._startText,c=b.length,d,e=ob(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var h=c-a;for(d=1;d<=h&&b[c-d]===e[f-d];d++);M._fallbackText=e.slice(a,1<d?1-d:void 0);return M._fallbackText}function ob(){return"value"in M._root?M._root.value:M._root[mb()]}
var pb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),qb={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function N(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
A(N.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<pb.length;a++)this[pb[a]]=null}});N.Interface=qb;N.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;A(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=A({},d.Interface,a);c.extend=d.extend;rb(c);return c};rb(N);
function sb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function tb(a){a instanceof this?void 0:D("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function rb(a){a.eventPool=[];a.getPooled=sb;a.release=tb}var ub=N.extend({data:null}),vb=N.extend({data:null}),wb=[9,13,27,32],xb=m.canUseDOM&&"CompositionEvent"in window,yb=null;m.canUseDOM&&"documentMode"in document&&(yb=document.documentMode);
var zb=m.canUseDOM&&"TextEvent"in window&&!yb,Ab=m.canUseDOM&&(!xb||yb&&8<yb&&11>=yb),Bb=String.fromCharCode(32),Kb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},Lb=!1;
function Mb(a,b){switch(a){case "topKeyUp":return-1!==wb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function Nb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Ob=!1;function Pb(a,b){switch(a){case "topCompositionEnd":return Nb(b);case "topKeyPress":if(32!==b.which)return null;Lb=!0;return Bb;case "topTextInput":return a=b.data,a===Bb&&Lb?null:a;default:return null}}
function Qb(a,b){if(Ob)return"topCompositionEnd"===a||!xb&&Mb(a,b)?(a=nb(),M._root=null,M._startText=null,M._fallbackText=null,Ob=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return Ab?null:b.data;default:return null}}
var Rb={eventTypes:Kb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(xb)b:{switch(a){case "topCompositionStart":e=Kb.compositionStart;break b;case "topCompositionEnd":e=Kb.compositionEnd;break b;case "topCompositionUpdate":e=Kb.compositionUpdate;break b}e=void 0}else Ob?Mb(a,c)&&(e=Kb.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(e=Kb.compositionStart);e?(Ab&&(Ob||e!==Kb.compositionStart?e===Kb.compositionEnd&&Ob&&(f=nb()):(M._root=d,M._startText=ob(),Ob=!0)),e=ub.getPooled(e,
b,c,d),f?e.data=f:(f=Nb(c),null!==f&&(e.data=f)),ib(e),f=e):f=null;(a=zb?Pb(a,c):Qb(a,c))?(b=vb.getPooled(Kb.beforeInput,b,c,d),b.data=a,ib(b)):b=null;return null===f?b:null===b?f:[f,b]}},Sb=null,Tb={injectFiberControlledHostComponent:function(a){Sb=a}},Ub=null,Vb=null;function Wb(a){if(a=Ea(a)){Sb&&"function"===typeof Sb.restoreControlledState?void 0:D("194");var b=Da(a.stateNode);Sb.restoreControlledState(a.stateNode,a.type,b)}}function Xb(a){Ub?Vb?Vb.push(a):Vb=[a]:Ub=a}
function Yb(){return null!==Ub||null!==Vb}function Zb(){if(Ub){var a=Ub,b=Vb;Vb=Ub=null;Wb(a);if(b)for(a=0;a<b.length;a++)Wb(b[a])}}var $b=Object.freeze({injection:Tb,enqueueStateRestore:Xb,needsStateRestore:Yb,restoreStateIfNeeded:Zb});function ac(a,b){return a(b)}function bc(a,b,c){return a(b,c)}function cc(){}var dc=!1;function ec(a,b){if(dc)return a(b);dc=!0;try{return ac(a,b)}finally{dc=!1,Yb()&&(cc(),Zb())}}
var fc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function gc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!fc[a.type]:"textarea"===b?!0:!1}function hc(a){a=a.target||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function ic(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function jc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function kc(a){var b=jc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),Object.defineProperty(a,b,{enumerable:c.enumerable}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function lc(a){a._valueTracker||(a._valueTracker=kc(a))}function mc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=jc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var nc=ea.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,O="function"===typeof Symbol&&Symbol["for"],oc=O?Symbol["for"]("react.element"):60103,pc=O?Symbol["for"]("react.call"):60104,qc=O?Symbol["for"]("react.return"):60105,rc=O?Symbol["for"]("react.portal"):60106,sc=O?Symbol["for"]("react.fragment"):60107,tc=O?Symbol["for"]("react.strict_mode"):60108,uc=O?Symbol["for"]("react.provider"):60109,vc=O?Symbol["for"]("react.context"):60110,wc=O?Symbol["for"]("react.async_mode"):60111,
xc=O?Symbol["for"]("react.forward_ref"):60112,yc="function"===typeof Symbol&&Symbol.iterator;function zc(a){if(null===a||"undefined"===typeof a)return null;a=yc&&a[yc]||a["@@iterator"];return"function"===typeof a?a:null}
function Ac(a){a=a.type;if("function"===typeof a)return a.displayName||a.name;if("string"===typeof a)return a;switch(a){case sc:return"ReactFragment";case rc:return"ReactPortal";case pc:return"ReactCall";case qc:return"ReactReturn"}if("object"===typeof a&&null!==a)switch(a.$$typeof){case xc:return a=a.render.displayName||a.render.name||"",""!==a?"ForwardRef("+a+")":"ForwardRef"}return null}
function Bc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=Ac(a);var f=null;c&&(f=Ac(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a["return"]}while(a);return b}
var Cc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Dc={},Ec={};function Fc(a){if(Ec.hasOwnProperty(a))return!0;if(Dc.hasOwnProperty(a))return!1;if(Cc.test(a))return Ec[a]=!0;Dc[a]=!0;return!1}
function Gc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Hc(a,b,c,d){if(null===b||"undefined"===typeof b||Gc(a,b,c,d))return!0;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
function U(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var V={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){V[a]=new U(a,0,!1,a,null)});
[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];V[b]=new U(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){V[a]=new U(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){V[a]=new U(a,2,!1,a,null)});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){V[a]=new U(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){V[a]=new U(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){V[a]=new U(a,4,!1,a.toLowerCase(),null)});
["cols","rows","size","span"].forEach(function(a){V[a]=new U(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){V[a]=new U(a,5,!1,a.toLowerCase(),null)});var Sc=/[\-:]([a-z])/g;function Tc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Sc,
Tc);V[b]=new U(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Sc,Tc);V[b]=new U(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Sc,Tc);V[b]=new U(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});V.tabIndex=new U("tabIndex",1,!1,"tabindex",null);
function Uc(a,b,c,d){var e=V.hasOwnProperty(b)?V[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Hc(b,c,e,d)&&(c=null),d||null===e?Fc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Vc(a,b){var c=b.checked;return A({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Xc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Yc(a,b){b=b.checked;null!=b&&Uc(a,"checked",b,!1)}
function Zc(a,b){Yc(a,b);var c=Xc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?$c(a,b.type,c):b.hasOwnProperty("defaultValue")&&$c(a,b.type,Xc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function ad(a,b){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue"))""===a.value&&(a.value=""+a._wrapperState.initialValue),a.defaultValue=""+a._wrapperState.initialValue;b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function $c(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Xc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var bd={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};function cd(a,b,c){a=N.getPooled(bd.change,a,b,c);a.type="change";Xb(c);ib(a);return a}var dd=null,ed=null;function fd(a){Pa(a,!1)}
function gd(a){var b=Va(a);if(mc(b))return a}function hd(a,b){if("topChange"===a)return b}var id=!1;m.canUseDOM&&(id=ic("input")&&(!document.documentMode||9<document.documentMode));function jd(){dd&&(dd.detachEvent("onpropertychange",kd),ed=dd=null)}function kd(a){"value"===a.propertyName&&gd(ed)&&(a=cd(ed,a,hc(a)),ec(fd,a))}function ld(a,b,c){"topFocus"===a?(jd(),dd=b,ed=c,dd.attachEvent("onpropertychange",kd)):"topBlur"===a&&jd()}
function md(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return gd(ed)}function nd(a,b){if("topClick"===a)return gd(b)}function od(a,b){if("topInput"===a||"topChange"===a)return gd(b)}
var pd={eventTypes:bd,_isInputEventSupported:id,extractEvents:function(a,b,c,d){var e=b?Va(b):window,f=void 0,h=void 0,g=e.nodeName&&e.nodeName.toLowerCase();"select"===g||"input"===g&&"file"===e.type?f=hd:gc(e)?id?f=od:(f=md,h=ld):(g=e.nodeName)&&"input"===g.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=nd);if(f&&(f=f(a,b)))return cd(f,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&$c(e,"number",e.value)}},qd=N.extend({view:null,
detail:null}),rd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function sd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=rd[a])?!!b[a]:!1}function td(){return sd}
var ud=qd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:td,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),vd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},wd={eventTypes:vd,extractEvents:function(a,
b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?Ua(b):null):a=null;if(a===b)return null;var f=null==a?e:Va(a);e=null==b?e:Va(b);var h=ud.getPooled(vd.mouseLeave,a,c,d);h.type="mouseleave";h.target=f;h.relatedTarget=e;c=ud.getPooled(vd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=
f;jb(h,c,a,b);return[h,c]}};function xd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function yd(a){return(a=a._reactInternalFiber)?2===xd(a):!1}function zd(a){2!==xd(a)?D("188"):void 0}
function Ad(a){var b=a.alternate;if(!b)return b=xd(a),3===b?D("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var h=e.child;h;){if(h===c)return zd(e),a;if(h===d)return zd(e),b;h=h.sibling}D("188")}if(c["return"]!==d["return"])c=e,d=f;else{h=!1;for(var g=e.child;g;){if(g===c){h=!0;c=e;d=f;break}if(g===d){h=!0;d=e;c=f;break}g=g.sibling}if(!h){for(g=f.child;g;){if(g===c){h=!0;c=f;d=e;break}if(g===d){h=!0;d=f;c=e;break}g=g.sibling}h?
void 0:D("189")}}c.alternate!==d?D("190"):void 0}3!==c.tag?D("188"):void 0;return c.stateNode.current===c?a:b}function Bd(a){a=Ad(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function Cd(a){a=Ad(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var Dd=N.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Ed=N.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Fd=qd.extend({relatedTarget:null});
function Gd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var Hd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Id={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Jd=qd.extend({key:function(a){if(a.key){var b=Hd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Gd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Id[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:td,charCode:function(a){return"keypress"===
a.type?Gd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?Gd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Kd=ud.extend({dataTransfer:null}),Ld=qd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:td}),Md=N.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),Nd=ud.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Od={},Pd={};function Qd(a,b){var c=a[0].toUpperCase()+a.slice(1),d="on"+c;c="top"+c;b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Od[a]=b;Pd[c]=b}
"blur cancel click close contextMenu copy cut doubleClick dragEnd dragStart drop focus input invalid keyDown keyPress keyUp mouseDown mouseUp paste pause play rateChange reset seeked submit touchCancel touchEnd touchStart volumeChange".split(" ").forEach(function(a){Qd(a,!0)});
"abort animationEnd animationIteration animationStart canPlay canPlayThrough drag dragEnter dragExit dragLeave dragOver durationChange emptied encrypted ended error load loadedData loadedMetadata loadStart mouseMove mouseOut mouseOver playing progress scroll seeking stalled suspend timeUpdate toggle touchMove transitionEnd waiting wheel".split(" ").forEach(function(a){Qd(a,!1)});
var Rd={eventTypes:Od,isInteractiveTopLevelEventType:function(a){a=Pd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Pd[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Gd(c))return null;case "topKeyDown":case "topKeyUp":a=Jd;break;case "topBlur":case "topFocus":a=Fd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=
ud;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=Kd;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=Ld;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Dd;break;case "topTransitionEnd":a=Md;break;case "topScroll":a=qd;break;case "topWheel":a=Nd;break;case "topCopy":case "topCut":case "topPaste":a=Ed;break;default:a=
N}b=a.getPooled(e,b,c,d);ib(b);return b}},Sd=Rd.isInteractiveTopLevelEventType,Td=[];function Ud(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Ua(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Qa(a.topLevelType,b,a.nativeEvent,hc(a.nativeEvent))}var Vd=!0;function Wd(a){Vd=!!a}
function W(a,b,c){if(!c)return null;a=(Sd(a)?Xd:Yd).bind(null,a);c.addEventListener(b,a,!1)}function Zd(a,b,c){if(!c)return null;a=(Sd(a)?Xd:Yd).bind(null,a);c.addEventListener(b,a,!0)}function Xd(a,b){bc(Yd,a,b)}
function Yd(a,b){if(Vd){var c=hc(b);c=Ua(c);null!==c&&"number"===typeof c.tag&&2!==xd(c)&&(c=null);if(Td.length){var d=Td.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{ec(Ud,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Td.length&&Td.push(a)}}}
var $d=Object.freeze({get _enabled(){return Vd},setEnabled:Wd,isEnabled:function(){return Vd},trapBubbledEvent:W,trapCapturedEvent:Zd,dispatchEvent:Yd});function ae(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var be={animationend:ae("Animation","AnimationEnd"),animationiteration:ae("Animation","AnimationIteration"),animationstart:ae("Animation","AnimationStart"),transitionend:ae("Transition","TransitionEnd")},ce={},de={};m.canUseDOM&&(de=document.createElement("div").style,"AnimationEvent"in window||(delete be.animationend.animation,delete be.animationiteration.animation,delete be.animationstart.animation),"TransitionEvent"in window||delete be.transitionend.transition);
function ee(a){if(ce[a])return ce[a];if(!be[a])return a;var b=be[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in de)return ce[a]=b[c];return a}
var fe={topAnimationEnd:ee("animationend"),topAnimationIteration:ee("animationiteration"),topAnimationStart:ee("animationstart"),topBlur:"blur",topCancel:"cancel",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",
topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoad:"load",topLoadStart:"loadstart",topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topScroll:"scroll",topSelectionChange:"selectionchange",topTextInput:"textInput",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:ee("transitionend"),topWheel:"wheel"},ge={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",
topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",topWaiting:"waiting"},he={},ie=0,je="_reactListenersID"+(""+Math.random()).slice(2);function ke(a){Object.prototype.hasOwnProperty.call(a,je)||(a[je]=ie++,he[a[je]]={});return he[a[je]]}function le(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function me(a,b){var c=le(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=le(c)}}function ne(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var oe=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,pe={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},qe=null,re=null,se=null,te=!1;
function ue(a,b){if(te||null==qe||qe!==fa())return null;var c=qe;"selectionStart"in c&&ne(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return se&&ha(se,c)?null:(se=c,a=N.getPooled(pe.select,re,a,b),a.type="select",a.target=qe,ib(a),a)}
var ve={eventTypes:pe,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=ke(e);f=va.onSelect;for(var h=0;h<f.length;h++){var g=f[h];if(!e.hasOwnProperty(g)||!e[g]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Va(b):window;switch(a){case "topFocus":if(gc(e)||"true"===e.contentEditable)qe=e,re=b,se=null;break;case "topBlur":se=re=qe=null;break;case "topMouseDown":te=!0;break;case "topContextMenu":case "topMouseUp":return te=!1,ue(c,d);case "topSelectionChange":if(oe)break;
case "topKeyDown":case "topKeyUp":return ue(c,d)}return null}};Na.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));Da=bb.getFiberCurrentPropsFromNode;Ea=bb.getInstanceFromNode;Fa=bb.getNodeFromInstance;Na.injectEventPluginsByName({SimpleEventPlugin:Rd,EnterLeaveEventPlugin:wd,ChangeEventPlugin:pd,SelectEventPlugin:ve,BeforeInputEventPlugin:Rb});
function xe(a,b,c,d){this.tag=a;this.key=c;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function ze(a,b,c){var d=a.alternate;null===d?(d=new xe(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function Ae(a,b,c){var d=a.type,e=a.key;a=a.props;var f=void 0;if("function"===typeof d)f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case sc:return Be(a.children,b,c,e);case wc:f=11;b|=3;break;case tc:f=11;b|=2;break;case pc:f=7;break;case qc:f=9;break;default:if("object"===typeof d&&null!==d)switch(d.$$typeof){case uc:f=13;break;case vc:f=12;break;case xc:f=14;break;default:if("number"===typeof d.tag)return b=d,b.pendingProps=a,b.expirationTime=c,
b;D("130",null==d?d:typeof d,"")}else D("130",null==d?d:typeof d,"")}b=new xe(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Be(a,b,c,d){a=new xe(10,a,d,b);a.expirationTime=c;return a}function Ce(a,b,c){a=new xe(6,a,null,b);a.expirationTime=c;return a}function De(a,b,c){b=new xe(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var Ee=null,Fe=null;
function Ge(a){return function(b){try{return a(b)}catch(c){}}}function He(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Ee=Ge(function(a){return b.onCommitFiberRoot(c,a)});Fe=Ge(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Ie(a){"function"===typeof Ee&&Ee(a)}function Je(a){"function"===typeof Fe&&Fe(a)}new Set;
function Ke(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1,capturedValues:null}}function Le(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}var Me=void 0,Ne=void 0;
function Oe(a){Me=Ne=null;var b=a.alternate,c=a.updateQueue;null===c&&(c=a.updateQueue=Ke(null));null!==b?(a=b.updateQueue,null===a&&(a=b.updateQueue=Ke(null))):a=null;Me=c;Ne=a!==c?a:null}function Pe(a,b){Oe(a);a=Me;var c=Ne;null===c?Le(a,b):null===a.last||null===c.last?(Le(a,b),Le(c,b)):(Le(a,b),c.last=b)}function Qe(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Re(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,capturedValues:c.capturedValues,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var h=!0,g=c.first,k=!1;null!==g;){var v=g.expirationTime;if(v>f){var l=c.expirationTime;if(0===l||l>v)c.expirationTime=v;k||(k=!0,c.baseState=a)}else{k||
(c.first=g.next,null===c.first&&(c.last=null));if(g.isReplace)a=Qe(g,d,a,e),h=!0;else if(v=Qe(g,d,a,e))a=h?A({},a,v):A(a,v),h=!1;g.isForced&&(c.hasForceUpdate=!0);null!==g.callback&&(v=c.callbackList,null===v&&(v=c.callbackList=[]),v.push(g));null!==g.capturedValue&&(v=c.capturedValues,null===v?c.capturedValues=[g.capturedValue]:v.push(g.capturedValue))}g=g.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||null!==c.capturedValues||(b.updateQueue=null);k||(c.baseState=a);
return a}function Se(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?D("191",e):void 0;e.call(b)}}
function Te(a,b,c,d,e){function f(a,b,c,d,e,f){if(null===b||null!==a.updateQueue&&a.updateQueue.hasForceUpdate)return!0;var n=a.stateNode;a=a.type;return"function"===typeof n.shouldComponentUpdate?n.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ha(b,c)||!ha(d,e):!0}function h(a,b){b.updater=r;a.stateNode=b;b._reactInternalFiber=a}function g(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&
b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&r.enqueueReplaceState(b,b.state,null)}function k(a,b,c,d){a=a.type;if("function"===typeof a.getDerivedStateFromProps)return a.getDerivedStateFromProps.call(null,c,d)}var v=a.cacheContext,l=a.getMaskedContext,p=a.getUnmaskedContext,z=a.isContextConsumer,B=a.hasContextChanged,r={isMounted:yd,enqueueSetState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Pe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!1,isForced:!1,
capturedValue:null,next:null});b(a,f)},enqueueReplaceState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Pe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!0,isForced:!1,capturedValue:null,next:null});b(a,f)},enqueueForceUpdate:function(a,d){a=a._reactInternalFiber;d=void 0===d?null:d;var e=c(a);Pe(a,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,capturedValue:null,next:null});b(a,e)}};return{adoptClassInstance:h,callGetDerivedStateFromProps:k,
constructClassInstance:function(a,b){var c=a.type,d=p(a),e=z(a),f=e?l(a,d):ka;c=new c(b,f);var n=null!==c.state&&void 0!==c.state?c.state:null;h(a,c);a.memoizedState=n;b=k(a,c,b,n);null!==b&&void 0!==b&&(a.memoizedState=A({},a.memoizedState,b));e&&v(a,d,f);return c},mountClassInstance:function(a,b){var c=a.type,d=a.alternate,e=a.stateNode,f=a.pendingProps,n=p(a);e.props=f;e.state=a.memoizedState;e.refs=ka;e.context=l(a,n);"function"===typeof c.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||
"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||(c=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),c!==e.state&&r.enqueueReplaceState(e,e.state,null),c=a.updateQueue,null!==c&&(e.state=Re(d,a,c,e,f,b)));"function"===typeof e.componentDidMount&&(a.effectTag|=4)},resumeMountClassInstance:function(a,b){var c=a.type,n=a.stateNode;n.props=a.memoizedProps;n.state=
a.memoizedState;var h=a.memoizedProps,r=a.pendingProps,z=n.context,q=p(a);q=l(a,q);(c="function"===typeof c.getDerivedStateFromProps||"function"===typeof n.getSnapshotBeforeUpdate)||"function"!==typeof n.UNSAFE_componentWillReceiveProps&&"function"!==typeof n.componentWillReceiveProps||(h!==r||z!==q)&&g(a,n,r,q);z=a.memoizedState;b=null!==a.updateQueue?Re(null,a,a.updateQueue,n,r,b):z;var u=void 0;h!==r&&(u=k(a,n,r,b));if(null!==u&&void 0!==u){b=null===b||void 0===b?u:A({},b,u);var t=a.updateQueue;
null!==t&&(t.baseState=A({},t.baseState,u))}if(!(h!==r||z!==b||B()||null!==a.updateQueue&&a.updateQueue.hasForceUpdate))return"function"===typeof n.componentDidMount&&(a.effectTag|=4),!1;(h=f(a,h,r,z,b,q))?(c||"function"!==typeof n.UNSAFE_componentWillMount&&"function"!==typeof n.componentWillMount||("function"===typeof n.componentWillMount&&n.componentWillMount(),"function"===typeof n.UNSAFE_componentWillMount&&n.UNSAFE_componentWillMount()),"function"===typeof n.componentDidMount&&(a.effectTag|=
4)):("function"===typeof n.componentDidMount&&(a.effectTag|=4),d(a,r),e(a,b));n.props=r;n.state=b;n.context=q;return h},updateClassInstance:function(a,b,c){var n=b.type,x=b.stateNode;x.props=b.memoizedProps;x.state=b.memoizedState;var h=b.memoizedProps,r=b.pendingProps,q=x.context,u=p(b);u=l(b,u);(n="function"===typeof n.getDerivedStateFromProps||"function"===typeof x.getSnapshotBeforeUpdate)||"function"!==typeof x.UNSAFE_componentWillReceiveProps&&"function"!==typeof x.componentWillReceiveProps||
(h!==r||q!==u)&&g(b,x,r,u);q=b.memoizedState;c=null!==b.updateQueue?Re(a,b,b.updateQueue,x,r,c):q;var t=void 0;h!==r&&(t=k(b,x,r,c));if(null!==t&&void 0!==t){c=null===c||void 0===c?t:A({},c,t);var y=b.updateQueue;null!==y&&(y.baseState=A({},y.baseState,t))}if(!(h!==r||q!==c||B()||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&
q===a.memoizedState||(b.effectTag|=2048),!1;(t=f(b,h,r,q,c,u))?(n||"function"!==typeof x.UNSAFE_componentWillUpdate&&"function"!==typeof x.componentWillUpdate||("function"===typeof x.componentWillUpdate&&x.componentWillUpdate(r,c,u),"function"===typeof x.UNSAFE_componentWillUpdate&&x.UNSAFE_componentWillUpdate(r,c,u)),"function"===typeof x.componentDidUpdate&&(b.effectTag|=4),"function"===typeof x.getSnapshotBeforeUpdate&&(b.effectTag|=2048)):("function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&
q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=2048),d(b,r),e(b,c));x.props=r;x.state=c;x.context=u;return t}}}var Ue=Array.isArray;
function Ve(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?D("110"):void 0,d=c.stateNode);d?void 0:D("147",a);var e=""+a;if(null!==b&&null!==b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ka?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?D("148"):void 0;c._owner?void 0:D("254",a)}return a}
function We(a,b){"textarea"!==a.type&&D("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Xe(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ze(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function h(b){a&&null===b.alternate&&(b.effectTag=2);return b}function g(a,b,c,d){if(null===b||6!==b.tag)return b=Ce(c,a.mode,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ve(a,b,c),d["return"]=a,d;d=Ae(c,a.mode,d);d.ref=Ve(a,b,c);d["return"]=a;return d}function v(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
De(c,a.mode,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function l(a,b,c,d,f){if(null===b||10!==b.tag)return b=Be(c,a.mode,d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Ce(""+b,a.mode,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case oc:return c=Ae(b,a.mode,c),c.ref=Ve(a,null,b),c["return"]=a,c;case rc:return b=De(b,a.mode,c),b["return"]=a,b}if(Ue(b)||zc(b))return b=Be(b,
a.mode,c,null),b["return"]=a,b;We(a,b)}return null}function z(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:g(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case oc:return c.key===e?c.type===sc?l(a,b,c.props.children,d,e):k(a,b,c,d):null;case rc:return c.key===e?v(a,b,c,d):null}if(Ue(c)||zc(c))return null!==e?null:l(a,b,c,d,null);We(a,c)}return null}function B(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||
null,g(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case oc:return a=a.get(null===d.key?c:d.key)||null,d.type===sc?l(b,a,d.props.children,e,d.key):k(b,a,d,e);case rc:return a=a.get(null===d.key?c:d.key)||null,v(b,a,d,e)}if(Ue(d)||zc(d))return a=a.get(c)||null,l(b,a,d,e,null);We(b,d)}return null}function r(e,l,g,h){for(var r=null,k=null,q=l,u=l=0,t=null;null!==q&&u<g.length;u++){q.index>u?(t=q,q=null):t=q.sibling;var n=z(e,q,g[u],h);if(null===n){null===q&&(q=t);break}a&&q&&null===
n.alternate&&b(e,q);l=f(n,l,u);null===k?r=n:k.sibling=n;k=n;q=t}if(u===g.length)return c(e,q),r;if(null===q){for(;u<g.length;u++)if(q=p(e,g[u],h))l=f(q,l,u),null===k?r=q:k.sibling=q,k=q;return r}for(q=d(e,q);u<g.length;u++)if(t=B(q,e,u,g[u],h)){if(a&&null!==t.alternate)q["delete"](null===t.key?u:t.key);l=f(t,l,u);null===k?r=t:k.sibling=t;k=t}a&&q.forEach(function(a){return b(e,a)});return r}function Q(e,l,g,h){var r=zc(g);"function"!==typeof r?D("150"):void 0;g=r.call(g);null==g?D("151"):void 0;for(var k=
r=null,q=l,u=l=0,t=null,n=g.next();null!==q&&!n.done;u++,n=g.next()){q.index>u?(t=q,q=null):t=q.sibling;var H=z(e,q,n.value,h);if(null===H){q||(q=t);break}a&&q&&null===H.alternate&&b(e,q);l=f(H,l,u);null===k?r=H:k.sibling=H;k=H;q=t}if(n.done)return c(e,q),r;if(null===q){for(;!n.done;u++,n=g.next())n=p(e,n.value,h),null!==n&&(l=f(n,l,u),null===k?r=n:k.sibling=n,k=n);return r}for(q=d(e,q);!n.done;u++,n=g.next())if(n=B(q,e,u,n.value,h),null!==n){if(a&&null!==n.alternate)q["delete"](null===n.key?u:n.key);
l=f(n,l,u);null===k?r=n:k.sibling=n;k=n}a&&q.forEach(function(a){return b(e,a)});return r}return function(a,d,f,l){"object"===typeof f&&null!==f&&f.type===sc&&null===f.key&&(f=f.props.children);var g="object"===typeof f&&null!==f;if(g)switch(f.$$typeof){case oc:a:{var k=f.key;for(g=d;null!==g;){if(g.key===k)if(10===g.tag?f.type===sc:g.type===f.type){c(a,g.sibling);d=e(g,f.type===sc?f.props.children:f.props,l);d.ref=Ve(a,g,f);d["return"]=a;a=d;break a}else{c(a,g);break}else b(a,g);g=g.sibling}f.type===
sc?(d=Be(f.props.children,a.mode,l,f.key),d["return"]=a,a=d):(l=Ae(f,a.mode,l),l.ref=Ve(a,d,f),l["return"]=a,a=l)}return h(a);case rc:a:{for(g=f.key;null!==d;){if(d.key===g)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],l);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=De(f,a.mode,l);d["return"]=a;a=d}return h(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&
6===d.tag?(c(a,d.sibling),d=e(d,f,l),d["return"]=a,a=d):(c(a,d),d=Ce(f,a.mode,l),d["return"]=a,a=d),h(a);if(Ue(f))return r(a,d,f,l);if(zc(f))return Q(a,d,f,l);g&&We(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:l=a.type,D("152",l.displayName||l.name||"Component")}return c(a,d)}}var Ye=Xe(!0),Ze=Xe(!1);
function $e(a,b,c,d,e,f,h){function g(a,b,c){k(a,b,c,b.expirationTime)}function k(a,b,c,d){b.child=null===a?Ze(b,null,c,d):Ye(b,a.child,c,d)}function v(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function l(a,b,c,d,e,f){v(a,b);if(!c&&!e)return d&&y(b,!1),r(a,b);c=b.stateNode;nc.current=b;var l=e?null:c.render();b.effectTag|=1;e&&(k(a,b,null,f),b.child=null);k(a,b,l,f);b.memoizedState=c.state;b.memoizedProps=c.props;d&&y(b,!0);return b.child}function p(a){var b=a.stateNode;
b.pendingContext?t(a,b.pendingContext,b.pendingContext!==b.context):b.context&&t(a,b.context,!1);Y(a,b.containerInfo)}function z(a,b,c,d){var e=a.child;for(null!==e&&(e["return"]=a);null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var l=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==l&&(0===l.expirationTime||l.expirationTime>d)&&(l.expirationTime=d);else if(null!==l&&(0===l.expirationTime||l.expirationTime>d))l.expirationTime=
d;else break;f=f["return"]}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=e.child}if(null!==f)f["return"]=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){f=e;break}f=f["return"]}e=f}}function B(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps;if(!q()&&f===e)return b.stateNode=0,G(b),r(a,b);var l=e.value;b.memoizedProps=e;if(null===f)l=1073741823;else if(f.value===e.value){if(f.children===e.children)return b.stateNode=0,G(b),
r(a,b);l=0}else{var h=f.value;if(h===l&&(0!==h||1/h===1/l)||h!==h&&l!==l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b);l=0}else if(l="function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,l):1073741823,l|=0,0===l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b)}else z(b,d,l,c)}b.stateNode=l;G(b);g(a,b,e.children);return b.child}function r(a,b){null!==a&&b.child!==a.child?D("153"):void 0;if(null!==b.child){a=b.child;var c=ze(a,a.pendingProps,a.expirationTime);
b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ze(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}var Q=a.shouldSetTextContent,n=a.shouldDeprioritizeSubtree,x=b.pushHostContext,Y=b.pushHostContainer,G=d.pushProvider,R=c.getMaskedContext,S=c.getUnmaskedContext,q=c.hasContextChanged,u=c.pushContextProvider,t=c.pushTopLevelContextObject,y=c.invalidateContextProvider,H=e.enterHydrationState,Wa=e.resetHydrationState,Cb=e.tryToClaimNextHydratableInstance;
a=Te(c,f,h,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var Jc=a.adoptClassInstance,Kc=a.callGetDerivedStateFromProps,Lc=a.constructClassInstance,Db=a.mountClassInstance,Mc=a.resumeMountClassInstance,Eb=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:p(b);break;case 2:u(b);break;case 4:Y(b,b.stateNode.containerInfo);break;case 13:G(b)}return null}switch(b.tag){case 0:null!==a?D("155"):void 0;var d=b.type,
e=b.pendingProps,f=S(b);f=R(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,"function"===typeof f.getDerivedStateFromProps&&(e=Kc(b,d,e,b.memoizedState),null!==e&&void 0!==e&&(b.memoizedState=A({},b.memoizedState,e))),e=u(b),Jc(b,d),Db(b,c),a=l(a,b,!0,e,!1,c)):(b.tag=1,g(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,q()||
b.memoizedProps!==c?(d=S(b),d=R(b,d),e=e(c,d),b.effectTag|=1,g(a,b,e),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 2:e=u(b);null===a?null===b.stateNode?(Lc(b,b.pendingProps),Db(b,c),d=!0):d=Mc(b,c):d=Eb(a,b,c);f=!1;var h=b.updateQueue;null!==h&&null!==h.capturedValues&&(f=d=!0);return l(a,b,d,e,f,c);case 3:a:if(p(b),d=b.updateQueue,null!==d){f=b.memoizedState;e=Re(a,b,d,null,null,c);b.memoizedState=e;d=b.updateQueue;if(null!==d&&null!==d.capturedValues)d=null;else if(f===e){Wa();a=r(a,b);break a}else d=
e.element;f=b.stateNode;(null===a||null===a.child)&&f.hydrate&&H(b)?(b.effectTag|=2,b.child=Ze(b,null,d,c)):(Wa(),g(a,b,d));b.memoizedState=e;a=b.child}else Wa(),a=r(a,b);return a;case 5:a:{x(b);null===a&&Cb(b);e=b.type;h=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!q()&&h===d){if(h=b.mode&1&&n(e,d))b.expirationTime=1073741823;if(!h||1073741823!==c){a=r(a,b);break a}}h=d.children;Q(e,d)?h=null:f&&Q(e,f)&&(b.effectTag|=16);v(a,b);1073741823!==c&&b.mode&1&&n(e,d)?(b.expirationTime=
1073741823,b.memoizedProps=d,a=null):(g(a,b,h),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Cb(b),b.memoizedProps=b.pendingProps,null;case 8:b.tag=7;case 7:return e=b.pendingProps,q()||b.memoizedProps!==e||(e=b.memoizedProps),d=e.children,b.stateNode=null===a?Ze(b,b.stateNode,d,c):Ye(b,a.stateNode,d,c),b.memoizedProps=e,b.stateNode;case 9:return null;case 4:return Y(b,b.stateNode.containerInfo),e=b.pendingProps,q()||b.memoizedProps!==e?(null===a?b.child=Ye(b,null,e,c):g(a,b,e),b.memoizedProps=
e,a=b.child):a=r(a,b),a;case 14:return c=b.type.render,c=c(b.pendingProps,b.ref),g(a,b,c),b.memoizedProps=c,b.child;case 10:return c=b.pendingProps,q()||b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 11:return c=b.pendingProps.children,q()||null!==c&&b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 13:return B(a,b,c);case 12:a:{d=b.type;f=b.pendingProps;h=b.memoizedProps;e=d._currentValue;var t=d._changedBits;if(q()||0!==t||h!==f){b.memoizedProps=
f;var k=f.unstable_observedBits;if(void 0===k||null===k)k=1073741823;b.stateNode=k;if(0!==(t&k))z(b,d,t,c);else if(h===f){a=r(a,b);break a}c=f.children;c=c(e);g(a,b,c);a=b.child}else a=r(a,b)}return a;default:D("156")}}}}
function af(a,b,c,d,e){function f(a){a.effectTag|=4}var h=a.createInstance,g=a.createTextInstance,k=a.appendInitialChild,v=a.finalizeInitialChildren,l=a.prepareUpdate,p=a.persistence,z=b.getRootHostContainer,B=b.popHostContext,r=b.getHostContext,Q=b.popHostContainer,n=c.popContextProvider,x=c.popTopLevelContextObject,Y=d.popProvider,G=e.prepareToHydrateHostInstance,R=e.prepareToHydrateHostTextInstance,S=e.popHydrationState,q=void 0,u=void 0,t=void 0;a.mutation?(q=function(){},u=function(a,b,c){(b.updateQueue=
c)&&f(b)},t=function(a,b,c,d){c!==d&&f(b)}):p?D("235"):D("236");return{completeWork:function(a,b,c){var d=b.pendingProps;switch(b.tag){case 1:return null;case 2:return n(b),a=b.stateNode,d=b.updateQueue,null!==d&&null!==d.capturedValues&&(b.effectTag&=-65,"function"===typeof a.componentDidCatch?b.effectTag|=256:d.capturedValues=null),null;case 3:Q(b);x(b);d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)S(b),b.effectTag&=-3;q(b);a=b.updateQueue;
null!==a&&null!==a.capturedValues&&(b.effectTag|=256);return null;case 5:B(b);c=z();var e=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,H=b.stateNode,y=r();H=l(H,e,p,d,c,y);u(a,b,H,e,p,d,c,y);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!d)return null===b.stateNode?D("166"):void 0,null;a=r();if(S(b))G(b,c,a)&&f(b);else{p=h(e,d,c,a,b);a:for(y=b.child;null!==y;){if(5===y.tag||6===y.tag)k(p,y.stateNode);else if(4!==y.tag&&null!==y.child){y.child["return"]=y;y=y.child;continue}if(y===b)break;
for(;null===y.sibling;){if(null===y["return"]||y["return"]===b)break a;y=y["return"]}y.sibling["return"]=y["return"];y=y.sibling}v(p,e,d,c,a)&&f(b);b.stateNode=p}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)t(a,b,a.memoizedProps,d);else{if("string"!==typeof d)return null===b.stateNode?D("166"):void 0,null;a=z();c=r();S(b)?R(b)&&f(b):b.stateNode=g(d,a,c,b)}return null;case 7:(d=b.memoizedProps)?void 0:D("165");b.tag=8;e=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==
p;){if(5===p.tag||6===p.tag||4===p.tag)D("247");else if(9===p.tag)e.push(p.pendingProps.value);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=d.handler;d=p(d.props,e);b.child=Ye(b,null!==a?a.child:null,d,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 14:return null;case 10:return null;case 11:return null;case 4:return Q(b),q(b),null;
case 13:return Y(b),null;case 12:return null;case 0:D("167");default:D("156")}}}}
function bf(a,b,c,d,e){var f=a.popHostContainer,h=a.popHostContext,g=b.popContextProvider,k=b.popTopLevelContextObject,v=c.popProvider;return{throwException:function(a,b,c){b.effectTag|=512;b.firstEffect=b.lastEffect=null;b={value:c,source:b,stack:Bc(b)};do{switch(a.tag){case 3:Oe(a);a.updateQueue.capturedValues=[b];a.effectTag|=1024;return;case 2:if(c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&!e(c)){Oe(a);c=a.updateQueue;var d=c.capturedValues;null===d?
c.capturedValues=[b]:d.push(b);a.effectTag|=1024;return}}a=a["return"]}while(null!==a)},unwindWork:function(a){switch(a.tag){case 2:g(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return f(a),k(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return h(a),null;case 4:return f(a),null;case 13:return v(a),null;default:return null}},unwindInterruptedWork:function(a){switch(a.tag){case 2:g(a);break;case 3:f(a);k(a);break;case 5:h(a);break;case 4:f(a);break;case 13:v(a)}}}}
function cf(a,b){var c=b.source;null===b.stack&&Bc(c);null!==c&&Ac(c);b=b.value;null!==a&&2===a.tag&&Ac(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}
function df(a,b,c,d,e){function f(a){var c=a.ref;if(null!==c)if("function"===typeof c)try{c(null)}catch(t){b(a,t)}else c.current=null}function h(a){"function"===typeof Je&&Je(a);switch(a.tag){case 2:f(a);var c=a.stateNode;if("function"===typeof c.componentWillUnmount)try{c.props=a.memoizedProps,c.state=a.memoizedState,c.componentWillUnmount()}catch(t){b(a,t)}break;case 5:f(a);break;case 7:g(a.stateNode);break;case 4:p&&v(a)}}function g(a){for(var b=a;;)if(h(b),null===b.child||p&&4===b.tag){if(b===
a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function k(a){return 5===a.tag||3===a.tag||4===a.tag}function v(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?D("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c["return"]}c=!0}if(5===
b.tag||6===b.tag)g(b),e?S(d,b.stateNode):R(d,b.stateNode);else if(4===b.tag?d=b.stateNode.containerInfo:h(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var l=a.getPublicInstance,p=a.mutation;a=a.persistence;p||(a?D("235"):D("236"));var z=p.commitMount,B=p.commitUpdate,r=p.resetTextContent,Q=p.commitTextUpdate,n=p.appendChild,
x=p.appendChildToContainer,Y=p.insertBefore,G=p.insertInContainerBefore,R=p.removeChild,S=p.removeChildFromContainer;return{commitBeforeMutationLifeCycles:function(a,b){switch(b.tag){case 2:if(b.effectTag&2048&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;a.props=b.memoizedProps;a.state=b.memoizedState;b=a.getSnapshotBeforeUpdate(c,d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:break;default:D("163")}},commitResetTextContent:function(a){r(a.stateNode)},
commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(k(b)){var c=b;break a}b=b["return"]}D("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:D("161")}c.effectTag&16&&(r(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||k(c["return"])){c=null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==
c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?G(b,e.stateNode,c):Y(b,e.stateNode,c):d?x(b,e.stateNode):n(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){v(a);
a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&B(c,f,e,a,d,b)}break;case 6:null===b.stateNode?D("162"):void 0;c=b.memoizedProps;Q(b.stateNode,null!==a?a.memoizedProps:c,c);break;case 3:break;default:D("163")}},commitLifeCycles:function(a,b,c){switch(c.tag){case 2:a=
c.stateNode;if(c.effectTag&4)if(null===b)a.props=c.memoizedProps,a.state=c.memoizedState,a.componentDidMount();else{var d=b.memoizedProps;b=b.memoizedState;a.props=c.memoizedProps;a.state=c.memoizedState;a.componentDidUpdate(d,b,a.__reactInternalSnapshotBeforeUpdate)}c=c.updateQueue;null!==c&&Se(c,a);break;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=l(c.child.stateNode);break;case 2:a=c.child.stateNode}Se(b,a)}break;case 5:a=c.stateNode;null===b&&c.effectTag&
4&&z(a,c.type,c.memoizedProps,c);break;case 6:break;case 4:break;default:D("163")}},commitErrorLogging:function(a,b){switch(a.tag){case 2:var c=a.type;b=a.stateNode;var d=a.updateQueue;null===d||null===d.capturedValues?D("264"):void 0;var f=d.capturedValues;d.capturedValues=null;"function"!==typeof c.getDerivedStateFromCatch&&e(b);b.props=a.memoizedProps;b.state=a.memoizedState;for(c=0;c<f.length;c++){d=f[c];var l=d.value,g=d.stack;cf(a,d);b.componentDidCatch(l,{componentStack:null!==g?g:""})}break;
case 3:c=a.updateQueue;null===c||null===c.capturedValues?D("264"):void 0;f=c.capturedValues;c.capturedValues=null;for(c=0;c<f.length;c++)d=f[c],cf(a,d),b(d.value);break;default:D("265")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:a=l(c);break;default:a=c}"function"===typeof b?b(a):b.current=a}},commitDetachRef:function(a){a=a.ref;null!==a&&("function"===typeof a?a(null):a.current=null)}}}var ef={};
function ff(a,b){function c(a){a===ef?D("174"):void 0;return a}var d=a.getChildHostContext,e=a.getRootHostContext;a=b.createCursor;var f=b.push,h=b.pop,g=a(ef),k=a(ef),v=a(ef);return{getHostContext:function(){return c(g.current)},getRootHostContainer:function(){return c(v.current)},popHostContainer:function(a){h(g,a);h(k,a);h(v,a)},popHostContext:function(a){k.current===a&&(h(g,a),h(k,a))},pushHostContainer:function(a,b){f(v,b,a);f(k,a,a);f(g,ef,a);b=e(b);h(g,a);f(g,b,a)},pushHostContext:function(a){var b=
c(v.current),e=c(g.current);b=d(e,a.type,b);e!==b&&(f(k,a,a),f(g,b,a))}}}
function gf(a){function b(a,b){var c=new xe(5,null,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=h(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];p=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){D("175")},prepareToHydrateHostTextInstance:function(){D("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,h=a.canHydrateTextInstance,g=a.getNextHydratableSibling,k=a.getFirstHydratableChild,v=a.hydrateInstance,l=a.hydrateTextInstance,p=null,z=null,B=!1;return{enterHydrationState:function(a){z=
k(a.stateNode.containerInfo);p=a;return B=!0},resetHydrationState:function(){z=p=null;B=!1},tryToClaimNextHydratableInstance:function(a){if(B){var d=z;if(d){if(!c(a,d)){d=g(d);if(!d||!c(a,d)){a.effectTag|=2;B=!1;p=a;return}b(p,z)}p=a;z=k(d)}else a.effectTag|=2,B=!1,p=a}},prepareToHydrateHostInstance:function(a,b,c){b=v(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return l(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
p)return!1;if(!B)return d(a),B=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=z;c;)b(a,c),c=g(c);d(a);z=p?g(a.stateNode):null;return!0}}}
function hf(a){function b(a,b,c){a=a.stateNode;a.__reactInternalMemoizedUnmaskedChildContext=b;a.__reactInternalMemoizedMaskedChildContext=c}function c(a){return 2===a.tag&&null!=a.type.childContextTypes}function d(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:D("108",Ac(a)||"Unknown",e);return A({},b,c)}var e=a.createCursor,f=a.push,h=a.pop,g=e(ka),k=e(!1),v=ka;return{getUnmaskedContext:function(a){return c(a)?
v:g.current},cacheContext:b,getMaskedContext:function(a,c){var d=a.type.contextTypes;if(!d)return ka;var e=a.stateNode;if(e&&e.__reactInternalMemoizedUnmaskedChildContext===c)return e.__reactInternalMemoizedMaskedChildContext;var f={},g;for(g in d)f[g]=c[g];e&&b(a,c,f);return f},hasContextChanged:function(){return k.current},isContextConsumer:function(a){return 2===a.tag&&null!=a.type.contextTypes},isContextProvider:c,popContextProvider:function(a){c(a)&&(h(k,a),h(g,a))},popTopLevelContextObject:function(a){h(k,
a);h(g,a)},pushTopLevelContextObject:function(a,b,c){null!=g.cursor?D("168"):void 0;f(g,b,a);f(k,c,a)},processChildContext:d,pushContextProvider:function(a){if(!c(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ka;v=g.current;f(g,b,a);f(k,k.current,a);return!0},invalidateContextProvider:function(a,b){var c=a.stateNode;c?void 0:D("169");if(b){var e=d(a,v);c.__reactInternalMemoizedMergedChildContext=e;h(k,a);h(g,a);f(g,e,a)}else h(k,a);f(k,b,a)},findCurrentUnmaskedContext:function(a){for(2!==
xd(a)||2!==a.tag?D("170"):void 0;3!==a.tag;){if(c(a))return a.stateNode.__reactInternalMemoizedMergedChildContext;(a=a["return"])?void 0:D("171")}return a.stateNode.context}}}
function jf(a){var b=a.createCursor,c=a.push,d=a.pop,e=b(null),f=b(null),h=b(0);return{pushProvider:function(a){var b=a.type._context;c(h,b._changedBits,a);c(f,b._currentValue,a);c(e,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode},popProvider:function(a){var b=h.current,c=f.current;d(e,a);d(f,a);d(h,a);a=a.type._context;a._currentValue=c;a._changedBits=b}}}
function kf(){var a=[],b=-1;return{createCursor:function(a){return{current:a}},isEmpty:function(){return-1===b},pop:function(c){0>b||(c.current=a[b],a[b]=null,b--)},push:function(c,d){b++;a[b]=c.current;c.current=d},checkThatStackIsEmpty:function(){},resetStackAfterFatalErrorInDev:function(){}}}
function lf(a){function b(){if(null!==I)for(var a=I["return"];null!==a;)Lc(a),a=a["return"];Ya=null;Z=0;I=null;Nc=!1}function c(a){return null!==ya&&ya.has(a)}function d(a){for(;;){var b=a.alternate,c=a["return"],d=a.sibling;if(0===(a.effectTag&512)){b=Cb(b,a,Z);var e=a;if(1073741823===Z||1073741823!==e.expirationTime){b:switch(e.tag){case 3:case 2:var f=e.updateQueue;f=null===f?0:f.expirationTime;break b;default:f=0}for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=
g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{Nc=!0;break}}else{a=Kc(a);if(null!==a)return a.effectTag&=2559,a;null!==c&&(c.firstEffect=c.lastEffect=
null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}function e(a){var b=Wa(a.alternate,a,Z);null===b&&(b=d(a));nc.current=null;return b}function f(a,c,f){ca?D("243"):void 0;ca=!0;if(c!==Z||a!==Ya||null===I)b(),Ya=a,Z=c,I=ze(Ya.current,null,Z),a.pendingCommitExpirationTime=0;var g=!1;do{try{if(f)for(;null!==I&&!S();)I=e(I);else for(;null!==I;)I=e(I)}catch(Oc){if(null===I){g=!0;q(Oc);break}f=I;var h=f["return"];if(null===h){g=!0;q(Oc);break}Jc(h,f,Oc);I=d(f)}break}while(1);
ca=!1;if(g||null!==I)return null;if(Nc)return a.pendingCommitExpirationTime=c,a.current.alternate;D("262")}function h(a,b,c,d){a={value:c,source:a,stack:Bc(a)};Pe(b,{expirationTime:d,partialState:null,callback:null,isReplace:!1,isForced:!1,capturedValue:a,next:null});v(b,d)}function g(a,b){a:{ca&&!Za?D("263"):void 0;for(var d=a["return"];null!==d;){switch(d.tag){case 2:var e=d.stateNode;if("function"===typeof d.type.getDerivedStateFromCatch||"function"===typeof e.componentDidCatch&&!c(e)){h(a,d,b,
1);a=void 0;break a}break;case 3:h(a,d,b,1);a=void 0;break a}d=d["return"]}3===a.tag&&h(a,a,b,1);a=void 0}return a}function k(a){a=0!==ia?ia:ca?Za?1:Z:a.mode&1?za?10*(((l()+15)/10|0)+1):25*(((l()+500)/25|0)+1):1;za&&(0===da||a>da)&&(da=a);return a}function v(a,c){a:{for(;null!==a;){if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>c)&&(a.alternate.expirationTime=c);if(null===a["return"])if(3===a.tag){var d=
a.stateNode;!ca&&0!==Z&&c<Z&&b();ca&&!Za&&Ya===d||B(d,c);Fb>xg&&D("185")}else{c=void 0;break a}a=a["return"]}c=void 0}return c}function l(){ye=Ic()-Pc;return yg=(ye/10|0)+2}function p(a,b,c,d,e){var f=ia;ia=1;try{return a(b,c,d,e)}finally{ia=f}}function z(a){if(0!==Gb){if(a>Gb)return;mg(Qc)}var b=Ic()-Pc;Gb=a;Qc=lg(Q,{timeout:10*(a-2)-b})}function B(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===K?(la=K=a,a.nextScheduledRoot=a):(K=K.nextScheduledRoot=a,K.nextScheduledRoot=la);
else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}T||(J?Hb&&(aa=a,P=1,G(a,1,!1)):1===b?n():z(b))}function r(){var a=0,b=null;if(null!==K)for(var c=K,d=la;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===K?D("244"):void 0;if(d===d.nextScheduledRoot){la=K=d.nextScheduledRoot=null;break}else if(d===la)la=e=d.nextScheduledRoot,K.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===K){K=c;K.nextScheduledRoot=la;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=
d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===K)break;c=d;d=d.nextScheduledRoot}}c=aa;null!==c&&c===b&&1===a?Fb++:Fb=0;aa=b;P=a}function Q(a){x(0,!0,a)}function n(){x(1,!1,null)}function x(a,b,c){$a=c;r();if(b)for(;null!==aa&&0!==P&&(0===a||a>=P)&&(!Ib||l()>=P);)G(aa,P,!Ib),r();else for(;null!==aa&&0!==P&&(0===a||a>=P);)G(aa,P,!1),r();null!==$a&&(Gb=0,Qc=-1);0!==P&&z(P);$a=null;Ib=!1;Y()}function Y(){Fb=0;if(null!==Aa){var a=Aa;Aa=null;for(var b=
0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(wg){Ba||(Ba=!0,Jb=wg)}}}if(Ba)throw a=Jb,Jb=null,Ba=!1,a;}function G(a,b,c){T?D("245"):void 0;T=!0;c?(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!0),null!==c&&(S()?a.finishedWork=c:R(a,c,b)))):(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!1),null!==c&&R(a,c,b)));T=!1}function R(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Aa?Aa=[d]:Aa.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=
0;return}a.finishedWork=null;Za=ca=!0;c=b.stateNode;c.current===b?D("177"):void 0;d=c.pendingCommitExpirationTime;0===d?D("261"):void 0;c.pendingCommitExpirationTime=0;var e=l();nc.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var f=b.firstEffect}else f=b;else f=b.firstEffect;zg(c.containerInfo);for(w=f;null!==w;){var h=!1,k=void 0;try{for(;null!==w;)w.effectTag&2048&&Db(w.alternate,w),w=w.nextEffect}catch(ab){h=!0,k=ab}h&&(null===w?D("178"):void 0,g(w,k),null!==
w&&(w=w.nextEffect))}for(w=f;null!==w;){h=!1;k=void 0;try{for(;null!==w;){var p=w.effectTag;p&16&&Mc(w);if(p&128){var n=w.alternate;null!==n&&kg(n)}switch(p&14){case 2:Eb(w);w.effectTag&=-3;break;case 6:Eb(w);w.effectTag&=-3;we(w.alternate,w);break;case 4:we(w.alternate,w);break;case 8:gg(w)}w=w.nextEffect}}catch(ab){h=!0,k=ab}h&&(null===w?D("178"):void 0,g(w,k),null!==w&&(w=w.nextEffect))}Ag(c.containerInfo);c.current=b;for(w=f;null!==w;){p=!1;n=void 0;try{for(f=c,h=e,k=d;null!==w;){var r=w.effectTag;
r&36&&hg(f,w.alternate,w,h,k);r&256&&ig(w,q);r&128&&jg(w);var t=w.nextEffect;w.nextEffect=null;w=t}}catch(ab){p=!0,n=ab}p&&(null===w?D("178"):void 0,g(w,n),null!==w&&(w=w.nextEffect))}ca=Za=!1;"function"===typeof Ie&&Ie(b.stateNode);b=c.current.expirationTime;0===b&&(ya=null);a.remainingExpirationTime=b}function S(){return null===$a||$a.timeRemaining()>Bg?!1:Ib=!0}function q(a){null===aa?D("246"):void 0;aa.remainingExpirationTime=0;Ba||(Ba=!0,Jb=a)}var u=kf(),t=ff(a,u),y=hf(u);u=jf(u);var H=gf(a),
Wa=$e(a,t,y,u,H,v,k).beginWork,Cb=af(a,t,y,u,H).completeWork;t=bf(t,y,u,v,c);var Jc=t.throwException,Kc=t.unwindWork,Lc=t.unwindInterruptedWork;t=df(a,g,v,k,function(a){null===ya?ya=new Set([a]):ya.add(a)},l);var Db=t.commitBeforeMutationLifeCycles,Mc=t.commitResetTextContent,Eb=t.commitPlacement,gg=t.commitDeletion,we=t.commitWork,hg=t.commitLifeCycles,ig=t.commitErrorLogging,jg=t.commitAttachRef,kg=t.commitDetachRef,Ic=a.now,lg=a.scheduleDeferredCallback,mg=a.cancelDeferredCallback,zg=a.prepareForCommit,
Ag=a.resetAfterCommit,Pc=Ic(),yg=2,ye=Pc,Rc=0,ia=0,ca=!1,I=null,Ya=null,Z=0,w=null,Za=!1,Nc=!1,ya=null,la=null,K=null,Gb=0,Qc=-1,T=!1,aa=null,P=0,da=0,Ib=!1,Ba=!1,Jb=null,$a=null,J=!1,Hb=!1,za=!1,Aa=null,xg=1E3,Fb=0,Bg=1;return{recalculateCurrentTime:l,computeExpirationForFiber:k,scheduleWork:v,requestWork:B,flushRoot:function(a,b){T?D("253"):void 0;aa=a;P=b;G(a,b,!1);n();Y()},batchedUpdates:function(a,b){var c=J;J=!0;try{return a(b)}finally{(J=c)||T||n()}},unbatchedUpdates:function(a,b){if(J&&!Hb){Hb=
!0;try{return a(b)}finally{Hb=!1}}return a(b)},flushSync:function(a,b){T?D("187"):void 0;var c=J;J=!0;try{return p(a,b)}finally{J=c,n()}},flushControlled:function(a){var b=J;J=!0;try{p(a)}finally{(J=b)||T||x(1,!1,null)}},deferredUpdates:function(a){var b=ia;ia=25*(((l()+500)/25|0)+1);try{return a()}finally{ia=b}},syncUpdates:p,interactiveUpdates:function(a,b,c){if(za)return a(b,c);J||T||0===da||(x(da,!1,null),da=0);var d=za,e=J;J=za=!0;try{return a(b,c)}finally{za=d,(J=e)||T||n()}},flushInteractiveUpdates:function(){T||
0===da||(x(da,!1,null),da=0)},computeUniqueAsyncExpiration:function(){var a=25*(((l()+500)/25|0)+1);a<=Rc&&(a=Rc+1);return Rc=a},legacyContext:y}}
function mf(a){function b(a,b,c,d,e,h){d=b.current;if(c){c=c._reactInternalFiber;var l=g(c);c=k(c)?v(c,l):l}else c=ka;null===b.context?b.context=c:b.pendingContext=c;b=h;Pe(d,{expirationTime:e,partialState:{element:a},callback:void 0===b?null:b,isReplace:!1,isForced:!1,capturedValue:null,next:null});f(d,e);return e}var c=a.getPublicInstance;a=lf(a);var d=a.recalculateCurrentTime,e=a.computeExpirationForFiber,f=a.scheduleWork,h=a.legacyContext,g=h.findCurrentUnmaskedContext,k=h.isContextProvider,v=
h.processChildContext;return{createContainer:function(a,b,c){b=new xe(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a},updateContainer:function(a,c,f,h){var g=c.current,k=d();g=e(g);return b(a,c,f,k,g,h)},updateContainerAtExpirationTime:function(a,c,e,f,g){var h=d();return b(a,c,e,h,f,g)},flushRoot:a.flushRoot,
requestWork:a.requestWork,computeUniqueAsyncExpiration:a.computeUniqueAsyncExpiration,batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,syncUpdates:a.syncUpdates,interactiveUpdates:a.interactiveUpdates,flushInteractiveUpdates:a.flushInteractiveUpdates,flushControlled:a.flushControlled,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},
findHostInstance:function(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?D("188"):D("268",Object.keys(a)));a=Bd(b);return null===a?null:a.stateNode},findHostInstanceWithNoPortals:function(a){a=Cd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var b=a.findFiberByHostInstance;return He(A({},a,{findHostInstanceByFiber:function(a){a=Bd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}}}
var nf=Object.freeze({default:mf}),of=nf&&mf||nf,pf=of["default"]?of["default"]:of;function qf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:rc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var rf="object"===typeof performance&&"function"===typeof performance.now,sf=void 0;sf=rf?function(){return performance.now()}:function(){return Date.now()};var tf=void 0,uf=void 0;
if(m.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var vf=null,wf=!1,xf=-1,yf=!1,zf=0,Af=33,Bf=33,Cf=void 0;Cf=rf?{didTimeout:!1,timeRemaining:function(){var a=zf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=zf-Date.now();return 0<a?a:0}};var Df="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Df){wf=!1;a=sf();if(0>=zf-a)if(-1!==
xf&&xf<=a)Cf.didTimeout=!0;else{yf||(yf=!0,requestAnimationFrame(Ef));return}else Cf.didTimeout=!1;xf=-1;a=vf;vf=null;null!==a&&a(Cf)}},!1);var Ef=function(a){yf=!1;var b=a-zf+Bf;b<Bf&&Af<Bf?(8>b&&(b=8),Bf=b<Af?Af:b):Af=b;zf=a+Bf;wf||(wf=!0,window.postMessage(Df,"*"))};tf=function(a,b){vf=a;null!=b&&"number"===typeof b.timeout&&(xf=sf()+b.timeout);yf||(yf=!0,requestAnimationFrame(Ef));return 0};uf=function(){vf=null;wf=!1;xf=-1}}else tf=window.requestIdleCallback,uf=window.cancelIdleCallback;else tf=
function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity},didTimeout:!1})})},uf=function(a){clearTimeout(a)};function Ff(a){var b="";ea.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function Gf(a,b){a=A({children:void 0},b);if(b=Ff(b.children))a.children=b;return a}
function Hf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function If(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Jf(a,b){null!=b.dangerouslySetInnerHTML?D("91"):void 0;return A({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Kf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?D("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:D("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Lf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Mf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Nf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Of(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Pf(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Of(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Qf=void 0,Rf=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Nf.svg||"innerHTML"in a)a.innerHTML=b;else{Qf=Qf||document.createElement("div");Qf.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=Qf.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Sf(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Tf={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Uf=["Webkit","ms","Moz","O"];Object.keys(Tf).forEach(function(a){Uf.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Tf[b]=Tf[a]})});
function Vf(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Tf.hasOwnProperty(e)&&Tf[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Wf=A({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Xf(a,b,c){b&&(Wf[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?D("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?D("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:D("61")),null!=b.style&&"object"!==typeof b.style?D("62",c()):void 0)}
function Yf(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Zf=C.thatReturns("");
function $f(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=ke(a);b=va[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?Zd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(Zd("topFocus","focus",a),Zd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(ic("cancel",!0)&&Zd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(ic("close",!0)&&Zd("topClose","close",a),c.topClose=!0):fe.hasOwnProperty(e)&&W(e,fe[e],a),c[e]=!0)}}
function ag(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Nf.html&&(d=Of(a));d===Nf.html?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function bg(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function cg(a,b,c,d){var e=Yf(b,c);switch(b){case "iframe":case "object":W("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in ge)ge.hasOwnProperty(f)&&W(f,ge[f],a);f=c;break;case "source":W("topError","error",a);f=c;break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);f=c;break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);f=c;break;case "details":W("topToggle","toggle",a);f=c;break;case "input":Wc(a,c);f=Vc(a,c);W("topInvalid",
"invalid",a);$f(d,"onChange");break;case "option":f=Gf(a,c);break;case "select":If(a,c);f=A({},c,{value:void 0});W("topInvalid","invalid",a);$f(d,"onChange");break;case "textarea":Kf(a,c);f=Jf(a,c);W("topInvalid","invalid",a);$f(d,"onChange");break;default:f=c}Xf(b,f,Zf);var h=f,g;for(g in h)if(h.hasOwnProperty(g)){var k=h[g];"style"===g?Vf(a,k,Zf):"dangerouslySetInnerHTML"===g?(k=k?k.__html:void 0,null!=k&&Rf(a,k)):"children"===g?"string"===typeof k?("textarea"!==b||""!==k)&&Sf(a,k):"number"===typeof k&&
Sf(a,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(ua.hasOwnProperty(g)?null!=k&&$f(d,g):null!=k&&Uc(a,g,k,e))}switch(b){case "input":lc(a);ad(a,c);break;case "textarea":lc(a);Mf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Hf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Hf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=C)}}
function dg(a,b,c,d,e){var f=null;switch(b){case "input":c=Vc(a,c);d=Vc(a,d);f=[];break;case "option":c=Gf(a,c);d=Gf(a,d);f=[];break;case "select":c=A({},c,{value:void 0});d=A({},d,{value:void 0});f=[];break;case "textarea":c=Jf(a,c);d=Jf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}Xf(b,d,Zf);b=a=void 0;var h=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var g=c[a];for(b in g)g.hasOwnProperty(b)&&(h||
(h={}),h[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ua.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];g=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==g&&(null!=k||null!=g))if("style"===a)if(g){for(b in g)!g.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(h||(h={}),h[b]="");for(b in k)k.hasOwnProperty(b)&&g[b]!==k[b]&&(h||(h={}),h[b]=k[b])}else h||(f||(f=[]),f.push(a,h)),
h=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,g=g?g.__html:void 0,null!=k&&g!==k&&(f=f||[]).push(a,""+k)):"children"===a?g===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ua.hasOwnProperty(a)?(null!=k&&$f(e,a),f||g===k||(f=[])):(f=f||[]).push(a,k))}h&&(f=f||[]).push("style",h);return f}
function eg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Yc(a,e);Yf(c,d);d=Yf(c,e);for(var f=0;f<b.length;f+=2){var h=b[f],g=b[f+1];"style"===h?Vf(a,g,Zf):"dangerouslySetInnerHTML"===h?Rf(a,g):"children"===h?Sf(a,g):Uc(a,h,g,d)}switch(c){case "input":Zc(a,e);break;case "textarea":Lf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Hf(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
Hf(a,!!e.multiple,e.defaultValue,!0):Hf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function fg(a,b,c,d,e){switch(b){case "iframe":case "object":W("topLoad","load",a);break;case "video":case "audio":for(var f in ge)ge.hasOwnProperty(f)&&W(f,ge[f],a);break;case "source":W("topError","error",a);break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);break;case "details":W("topToggle","toggle",a);break;case "input":Wc(a,c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "select":If(a,
c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "textarea":Kf(a,c),W("topInvalid","invalid",a),$f(e,"onChange")}Xf(b,c,Zf);d=null;for(var h in c)c.hasOwnProperty(h)&&(f=c[h],"children"===h?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):ua.hasOwnProperty(h)&&null!=f&&$f(e,h));switch(b){case "input":lc(a);ad(a,c);break;case "textarea":lc(a);Mf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function ng(a,b){return a.nodeValue!==b}
var og=Object.freeze({createElement:ag,createTextNode:bg,setInitialProperties:cg,diffProperties:dg,updateProperties:eg,diffHydratedProperties:fg,diffHydratedText:ng,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Zc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Xa(d);e?void 0:D("90");mc(d);Zc(d,e)}}}break;case "textarea":Lf(a,c);break;case "select":b=c.value,null!=b&&Hf(a,!!c.multiple,b,!1)}}});Tb.injectFiberControlledHostComponent(og);var pg=null,qg=null;
function rg(a){this._expirationTime=X.computeUniqueAsyncExpiration();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}rg.prototype.render=function(a){this._defer?void 0:D("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new sg;X.updateContainerAtExpirationTime(a,b,null,c,d._onCommit);return d};
rg.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
rg.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:D("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?D("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;X.flushRoot(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};rg.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function sg(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}sg.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
sg.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?D("191",c):void 0;c()}}};function tg(a,b,c){this._internalRoot=X.createContainer(a,b,c)}tg.prototype.render=function(a,b){var c=this._internalRoot,d=new sg;b=void 0===b?null:b;null!==b&&d.then(b);X.updateContainer(a,c,null,d._onCommit);return d};
tg.prototype.unmount=function(a){var b=this._internalRoot,c=new sg;a=void 0===a?null:a;null!==a&&c.then(a);X.updateContainer(null,b,null,c._onCommit);return c};tg.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new sg;c=void 0===c?null:c;null!==c&&e.then(c);X.updateContainer(b,d,a,e._onCommit);return e};
tg.prototype.createBatch=function(){var a=new rg(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function ug(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function vg(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
var X=pf({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:Pf(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=Pf(a,b)}return a},getChildHostContext:function(a,b){return Pf(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){pg=Vd;var a=fa();if(ne(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(B){b=null;break a}var f=0,h=-1,g=-1,k=0,v=0,l=a,p=null;b:for(;;){for(var z;;){l!==b||0!==d&&3!==l.nodeType||(h=f+d);l!==e||0!==c&&3!==l.nodeType||(g=f+c);3===l.nodeType&&(f+=l.nodeValue.length);if(null===(z=l.firstChild))break;p=l;l=z}for(;;){if(l===a)break b;p===b&&++k===d&&(h=f);p===e&&++v===c&&(g=f);if(null!==(z=l.nextSibling))break;l=p;p=l.parentNode}l=z}b=-1===h||-1===g?null:
{start:h,end:g}}else b=null}b=b||{start:0,end:0}}else b=null;qg={focusedElem:a,selectionRange:b};Wd(!1)},resetAfterCommit:function(){var a=qg,b=fa(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&ja(document.documentElement,c)){if(ne(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[mb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=me(c,a);var f=me(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var h=document.createRange();h.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(h),b.extend(f.node,f.offset)):(h.setEnd(f.node,f.offset),b.addRange(h))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,
a.element.scrollTop=a.top}qg=null;Wd(pg);pg=null},createInstance:function(a,b,c,d,e){a=ag(a,b,c,d);a[F]=e;a[Ta]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){cg(a,b,c,d);return vg(b,c)},prepareUpdate:function(a,b,c,d,e){return dg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===
typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=bg(a,b);a[F]=d;return a},now:sf,mutation:{commitMount:function(a,b,c){vg(b,c)&&a.focus()},commitUpdate:function(a,b,c,d,e){a[Ta]=e;eg(a,b,c,d,e)},resetTextContent:function(a){Sf(a,"")},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},
insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=
a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[F]=f;a[Ta]=c;return fg(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[F]=c;return ng(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},
didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:tf,cancelDeferredCallback:uf}),Cg=X;ac=Cg.batchedUpdates;bc=Cg.interactiveUpdates;cc=Cg.flushInteractiveUpdates;
function Dg(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new tg(a,!1,b)}
function Eg(a,b,c,d,e){ug(c)?void 0:D("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var h=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);h.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Dg(c,d);if("function"===typeof e){var g=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);g.call(a)}}X.unbatchedUpdates(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return X.getPublicRootInstance(f._internalRoot)}
function Fg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;ug(b)?void 0:D("200");return qf(a,b,null,c)}
var Gg={createPortal:Fg,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:X.findHostInstance(a)},hydrate:function(a,b,c){return Eg(null,a,b,!0,c)},render:function(a,b,c){return Eg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?D("38"):void 0;return Eg(a,b,c,!1,d)},unmountComponentAtNode:function(a){ug(a)?void 0:D("40");return a._reactRootContainer?(X.unbatchedUpdates(function(){Eg(null,null,a,!1,function(){a._reactRootContainer=
null})}),!0):!1},unstable_createPortal:function(){return Fg.apply(void 0,arguments)},unstable_batchedUpdates:X.batchedUpdates,unstable_deferredUpdates:X.deferredUpdates,flushSync:X.flushSync,unstable_flushControlled:X.flushControlled,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ra,EventPluginRegistry:Ca,EventPropagators:kb,ReactControlledComponent:$b,ReactDOMComponentTree:bb,ReactDOMEventListener:$d},unstable_createRoot:function(a,b){return new tg(a,!0,null!=b&&!0===b.hydrate)}};
X.injectIntoDevTools({findFiberByHostInstance:Ua,bundleType:0,version:"16.3.2",rendererPackageName:"react-dom"});var Hg=Object.freeze({default:Gg}),Ig=Hg&&Gg||Hg;module.exports=Ig["default"]?Ig["default"]:Ig;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(136);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(137);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Configurator__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_RegionPicker__ = __webpack_require__(2679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Video__ = __webpack_require__(2682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_HandlePicker__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App_css__ = __webpack_require__(2684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__App_css__);
// Init store
__WEBPACK_IMPORTED_MODULE_1_store___default.a.set('visualize',{});var routerBasename='/';// if (process.env.NODE_ENV === 'production') {
//   routerBasename = '/aluk/configurator/'
// }
var App=function App(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* BrowserRouter */],{basename:routerBasename},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{exact:true,path:'/',component:__WEBPACK_IMPORTED_MODULE_4__components_RegionPicker__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{exact:true,path:'/:region',component:__WEBPACK_IMPORTED_MODULE_5__components_Video__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{exact:true,path:'/:region/novae',component:__WEBPACK_IMPORTED_MODULE_6__components_HandlePicker__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{exact:true,path:'/:region/:handle',component:__WEBPACK_IMPORTED_MODULE_3__components_Configurator__["a" /* default */]}))));};/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(16)
var slice = util.slice
var pluck = util.pluck
var each = util.each
var bind = util.bind
var create = util.create
var isList = util.isList
var isFunction = util.isFunction
var isObject = util.isObject

module.exports = {
	createStore: createStore
}

var storeAPI = {
	version: '2.0.12',
	enabled: false,
	
	// get returns the value of the given key. If that value
	// is undefined, it returns optionalDefaultValue instead.
	get: function(key, optionalDefaultValue) {
		var data = this.storage.read(this._namespacePrefix + key)
		return this._deserialize(data, optionalDefaultValue)
	},

	// set will store the given value at key and returns value.
	// Calling set with value === undefined is equivalent to calling remove.
	set: function(key, value) {
		if (value === undefined) {
			return this.remove(key)
		}
		this.storage.write(this._namespacePrefix + key, this._serialize(value))
		return value
	},

	// remove deletes the key and value stored at the given key.
	remove: function(key) {
		this.storage.remove(this._namespacePrefix + key)
	},

	// each will call the given callback once for each key-value pair
	// in this store.
	each: function(callback) {
		var self = this
		this.storage.each(function(val, namespacedKey) {
			callback.call(self, self._deserialize(val), (namespacedKey || '').replace(self._namespaceRegexp, ''))
		})
	},

	// clearAll will remove all the stored key-value pairs in this store.
	clearAll: function() {
		this.storage.clearAll()
	},

	// additional functionality that can't live in plugins
	// ---------------------------------------------------

	// hasNamespace returns true if this store instance has the given namespace.
	hasNamespace: function(namespace) {
		return (this._namespacePrefix == '__storejs_'+namespace+'_')
	},

	// createStore creates a store.js instance with the first
	// functioning storage in the list of storage candidates,
	// and applies the the given mixins to the instance.
	createStore: function() {
		return createStore.apply(this, arguments)
	},
	
	addPlugin: function(plugin) {
		this._addPlugin(plugin)
	},
	
	namespace: function(namespace) {
		return createStore(this.storage, this.plugins, namespace)
	}
}

function _warn() {
	var _console = (typeof console == 'undefined' ? null : console)
	if (!_console) { return }
	var fn = (_console.warn ? _console.warn : _console.log)
	fn.apply(_console, arguments)
}

function createStore(storages, plugins, namespace) {
	if (!namespace) {
		namespace = ''
	}
	if (storages && !isList(storages)) {
		storages = [storages]
	}
	if (plugins && !isList(plugins)) {
		plugins = [plugins]
	}

	var namespacePrefix = (namespace ? '__storejs_'+namespace+'_' : '')
	var namespaceRegexp = (namespace ? new RegExp('^'+namespacePrefix) : null)
	var legalNamespaces = /^[a-zA-Z0-9_\-]*$/ // alpha-numeric + underscore and dash
	if (!legalNamespaces.test(namespace)) {
		throw new Error('store.js namespaces can only have alphanumerics + underscores and dashes')
	}
	
	var _privateStoreProps = {
		_namespacePrefix: namespacePrefix,
		_namespaceRegexp: namespaceRegexp,

		_testStorage: function(storage) {
			try {
				var testStr = '__storejs__test__'
				storage.write(testStr, testStr)
				var ok = (storage.read(testStr) === testStr)
				storage.remove(testStr)
				return ok
			} catch(e) {
				return false
			}
		},

		_assignPluginFnProp: function(pluginFnProp, propName) {
			var oldFn = this[propName]
			this[propName] = function pluginFn() {
				var args = slice(arguments, 0)
				var self = this

				// super_fn calls the old function which was overwritten by
				// this mixin.
				function super_fn() {
					if (!oldFn) { return }
					each(arguments, function(arg, i) {
						args[i] = arg
					})
					return oldFn.apply(self, args)
				}

				// Give mixing function access to super_fn by prefixing all mixin function
				// arguments with super_fn.
				var newFnArgs = [super_fn].concat(args)

				return pluginFnProp.apply(self, newFnArgs)
			}
		},

		_serialize: function(obj) {
			return JSON.stringify(obj)
		},

		_deserialize: function(strVal, defaultVal) {
			if (!strVal) { return defaultVal }
			// It is possible that a raw string value has been previously stored
			// in a storage without using store.js, meaning it will be a raw
			// string value instead of a JSON serialized string. By defaulting
			// to the raw string value in case of a JSON parse error, we allow
			// for past stored values to be forwards-compatible with store.js
			var val = ''
			try { val = JSON.parse(strVal) }
			catch(e) { val = strVal }

			return (val !== undefined ? val : defaultVal)
		},
		
		_addStorage: function(storage) {
			if (this.enabled) { return }
			if (this._testStorage(storage)) {
				this.storage = storage
				this.enabled = true
			}
		},

		_addPlugin: function(plugin) {
			var self = this

			// If the plugin is an array, then add all plugins in the array.
			// This allows for a plugin to depend on other plugins.
			if (isList(plugin)) {
				each(plugin, function(plugin) {
					self._addPlugin(plugin)
				})
				return
			}

			// Keep track of all plugins we've seen so far, so that we
			// don't add any of them twice.
			var seenPlugin = pluck(this.plugins, function(seenPlugin) {
				return (plugin === seenPlugin)
			})
			if (seenPlugin) {
				return
			}
			this.plugins.push(plugin)

			// Check that the plugin is properly formed
			if (!isFunction(plugin)) {
				throw new Error('Plugins must be function values that return objects')
			}

			var pluginProperties = plugin.call(this)
			if (!isObject(pluginProperties)) {
				throw new Error('Plugins must return an object of function properties')
			}

			// Add the plugin function properties to this store instance.
			each(pluginProperties, function(pluginFnProp, propName) {
				if (!isFunction(pluginFnProp)) {
					throw new Error('Bad plugin property: '+propName+' from plugin '+plugin.name+'. Plugins should only return functions.')
				}
				self._assignPluginFnProp(pluginFnProp, propName)
			})
		},
		
		// Put deprecated properties in the private API, so as to not expose it to accidential
		// discovery through inspection of the store object.
		
		// Deprecated: addStorage
		addStorage: function(storage) {
			_warn('store.addStorage(storage) is deprecated. Use createStore([storages])')
			this._addStorage(storage)
		}
	}

	var store = create(_privateStoreProps, storeAPI, {
		plugins: []
	})
	store.raw = {}
	each(store, function(prop, propName) {
		if (isFunction(prop)) {
			store.raw[propName] = bind(store, prop)			
		}
	})
	each(storages, function(storage) {
		store._addStorage(storage)
	})
	each(plugins, function(plugin) {
		store._addPlugin(plugin)
	})
	return store
}


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = [
	// Listed in order of usage preference
	__webpack_require__(141),
	__webpack_require__(142),
	__webpack_require__(143),
	__webpack_require__(144),
	__webpack_require__(145),
	__webpack_require__(146)
]


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(16)
var Global = util.Global

module.exports = {
	name: 'localStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

function localStorage() {
	return Global.localStorage
}

function read(key) {
	return localStorage().getItem(key)
}

function write(key, data) {
	return localStorage().setItem(key, data)
}

function each(fn) {
	for (var i = localStorage().length - 1; i >= 0; i--) {
		var key = localStorage().key(i)
		fn(read(key), key)
	}
}

function remove(key) {
	return localStorage().removeItem(key)
}

function clearAll() {
	return localStorage().clear()
}


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// oldFF-globalStorage provides storage for Firefox
// versions 6 and 7, where no localStorage, etc
// is available.

var util = __webpack_require__(16)
var Global = util.Global

module.exports = {
	name: 'oldFF-globalStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

var globalStorage = Global.globalStorage

function read(key) {
	return globalStorage[key]
}

function write(key, data) {
	globalStorage[key] = data
}

function each(fn) {
	for (var i = globalStorage.length - 1; i >= 0; i--) {
		var key = globalStorage.key(i)
		fn(globalStorage[key], key)
	}
}

function remove(key) {
	return globalStorage.removeItem(key)
}

function clearAll() {
	each(function(key, _) {
		delete globalStorage[key]
	})
}


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

// oldIE-userDataStorage provides storage for Internet Explorer
// versions 6 and 7, where no localStorage, sessionStorage, etc
// is available.

var util = __webpack_require__(16)
var Global = util.Global

module.exports = {
	name: 'oldIE-userDataStorage',
	write: write,
	read: read,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

var storageName = 'storejs'
var doc = Global.document
var _withStorageEl = _makeIEStorageElFunction()
var disable = (Global.navigator ? Global.navigator.userAgent : '').match(/ (MSIE 8|MSIE 9|MSIE 10)\./) // MSIE 9.x, MSIE 10.x

function write(unfixedKey, data) {
	if (disable) { return }
	var fixedKey = fixKey(unfixedKey)
	_withStorageEl(function(storageEl) {
		storageEl.setAttribute(fixedKey, data)
		storageEl.save(storageName)
	})
}

function read(unfixedKey) {
	if (disable) { return }
	var fixedKey = fixKey(unfixedKey)
	var res = null
	_withStorageEl(function(storageEl) {
		res = storageEl.getAttribute(fixedKey)
	})
	return res
}

function each(callback) {
	_withStorageEl(function(storageEl) {
		var attributes = storageEl.XMLDocument.documentElement.attributes
		for (var i=attributes.length-1; i>=0; i--) {
			var attr = attributes[i]
			callback(storageEl.getAttribute(attr.name), attr.name)
		}
	})
}

function remove(unfixedKey) {
	var fixedKey = fixKey(unfixedKey)
	_withStorageEl(function(storageEl) {
		storageEl.removeAttribute(fixedKey)
		storageEl.save(storageName)
	})
}

function clearAll() {
	_withStorageEl(function(storageEl) {
		var attributes = storageEl.XMLDocument.documentElement.attributes
		storageEl.load(storageName)
		for (var i=attributes.length-1; i>=0; i--) {
			storageEl.removeAttribute(attributes[i].name)
		}
		storageEl.save(storageName)
	})
}

// Helpers
//////////

// In IE7, keys cannot start with a digit or contain certain chars.
// See https://github.com/marcuswestin/store.js/issues/40
// See https://github.com/marcuswestin/store.js/issues/83
var forbiddenCharsRegex = new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]", "g")
function fixKey(key) {
	return key.replace(/^\d/, '___$&').replace(forbiddenCharsRegex, '___')
}

function _makeIEStorageElFunction() {
	if (!doc || !doc.documentElement || !doc.documentElement.addBehavior) {
		return null
	}
	var scriptTag = 'script',
		storageOwner,
		storageContainer,
		storageEl

	// Since #userData storage applies only to specific paths, we need to
	// somehow link our data to a specific path.  We choose /favicon.ico
	// as a pretty safe option, since all browsers already make a request to
	// this URL anyway and being a 404 will not hurt us here.  We wrap an
	// iframe pointing to the favicon in an ActiveXObject(htmlfile) object
	// (see: http://msdn.microsoft.com/en-us/library/aa752574(v=VS.85).aspx)
	// since the iframe access rules appear to allow direct access and
	// manipulation of the document element, even for a 404 page.  This
	// document can be used instead of the current document (which would
	// have been limited to the current path) to perform #userData storage.
	try {
		/* global ActiveXObject */
		storageContainer = new ActiveXObject('htmlfile')
		storageContainer.open()
		storageContainer.write('<'+scriptTag+'>document.w=window</'+scriptTag+'><iframe src="/favicon.ico"></iframe>')
		storageContainer.close()
		storageOwner = storageContainer.w.frames[0].document
		storageEl = storageOwner.createElement('div')
	} catch(e) {
		// somehow ActiveXObject instantiation failed (perhaps some special
		// security settings or otherwse), fall back to per-path storage
		storageEl = doc.createElement('div')
		storageOwner = doc.body
	}

	return function(storeFunction) {
		var args = [].slice.call(arguments, 0)
		args.unshift(storageEl)
		// See http://msdn.microsoft.com/en-us/library/ms531081(v=VS.85).aspx
		// and http://msdn.microsoft.com/en-us/library/ms531424(v=VS.85).aspx
		storageOwner.appendChild(storageEl)
		storageEl.addBehavior('#default#userData')
		storageEl.load(storageName)
		storeFunction.apply(this, args)
		storageOwner.removeChild(storageEl)
		return
	}
}


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

// cookieStorage is useful Safari private browser mode, where localStorage
// doesn't work but cookies do. This implementation is adopted from
// https://developer.mozilla.org/en-US/docs/Web/API/Storage/LocalStorage

var util = __webpack_require__(16)
var Global = util.Global
var trim = util.trim

module.exports = {
	name: 'cookieStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

var doc = Global.document

function read(key) {
	if (!key || !_has(key)) { return null }
	var regexpStr = "(?:^|.*;\\s*)" +
		escape(key).replace(/[\-\.\+\*]/g, "\\$&") +
		"\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*"
	return unescape(doc.cookie.replace(new RegExp(regexpStr), "$1"))
}

function each(callback) {
	var cookies = doc.cookie.split(/; ?/g)
	for (var i = cookies.length - 1; i >= 0; i--) {
		if (!trim(cookies[i])) {
			continue
		}
		var kvp = cookies[i].split('=')
		var key = unescape(kvp[0])
		var val = unescape(kvp[1])
		callback(val, key)
	}
}

function write(key, data) {
	if(!key) { return }
	doc.cookie = escape(key) + "=" + escape(data) + "; expires=Tue, 19 Jan 2038 03:14:07 GMT; path=/"
}

function remove(key) {
	if (!key || !_has(key)) {
		return
	}
	doc.cookie = escape(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/"
}

function clearAll() {
	each(function(_, key) {
		remove(key)
	})
}

function _has(key) {
	return (new RegExp("(?:^|;\\s*)" + escape(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(doc.cookie)
}


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(16)
var Global = util.Global

module.exports = {
	name: 'sessionStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll
}

function sessionStorage() {
	return Global.sessionStorage
}

function read(key) {
	return sessionStorage().getItem(key)
}

function write(key, data) {
	return sessionStorage().setItem(key, data)
}

function each(fn) {
	for (var i = sessionStorage().length - 1; i >= 0; i--) {
		var key = sessionStorage().key(i)
		fn(read(key), key)
	}
}

function remove(key) {
	return sessionStorage().removeItem(key)
}

function clearAll() {
	return sessionStorage().clear()
}


/***/ }),
/* 146 */
/***/ (function(module, exports) {

// memoryStorage is a useful last fallback to ensure that the store
// is functions (meaning store.get(), store.set(), etc will all function).
// However, stored values will not persist when the browser navigates to
// a new page or reloads the current page.

module.exports = {
	name: 'memoryStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

var memoryStorage = {}

function read(key) {
	return memoryStorage[key]
}

function write(key, data) {
	memoryStorage[key] = data
}

function each(callback) {
	for (var key in memoryStorage) {
		if (memoryStorage.hasOwnProperty(key)) {
			callback(memoryStorage[key], key)
		}
	}
}

function remove(key) {
	delete memoryStorage[key]
}

function clearAll(key) {
	memoryStorage = {}
}


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = json2Plugin

function json2Plugin() {
	__webpack_require__(148)
	return {}
}


/***/ }),
/* 148 */
/***/ (function(module, exports) {

/* eslint-disable */

//  json2.js
//  2016-10-28
//  Public Domain.
//  NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
//  See http://www.JSON.org/js.html
//  This code should be minified before deployment.
//  See http://javascript.crockford.com/jsmin.html

//  USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
//  NOT CONTROL.

//  This file creates a global JSON object containing two methods: stringify
//  and parse. This file provides the ES5 JSON capability to ES3 systems.
//  If a project might run on IE8 or earlier, then this file should be included.
//  This file does nothing on ES5 systems.

//      JSON.stringify(value, replacer, space)
//          value       any JavaScript value, usually an object or array.
//          replacer    an optional parameter that determines how object
//                      values are stringified for objects. It can be a
//                      function or an array of strings.
//          space       an optional parameter that specifies the indentation
//                      of nested structures. If it is omitted, the text will
//                      be packed without extra whitespace. If it is a number,
//                      it will specify the number of spaces to indent at each
//                      level. If it is a string (such as "\t" or "&nbsp;"),
//                      it contains the characters used to indent at each level.
//          This method produces a JSON text from a JavaScript value.
//          When an object value is found, if the object contains a toJSON
//          method, its toJSON method will be called and the result will be
//          stringified. A toJSON method does not serialize: it returns the
//          value represented by the name/value pair that should be serialized,
//          or undefined if nothing should be serialized. The toJSON method
//          will be passed the key associated with the value, and this will be
//          bound to the value.

//          For example, this would serialize Dates as ISO strings.

//              Date.prototype.toJSON = function (key) {
//                  function f(n) {
//                      // Format integers to have at least two digits.
//                      return (n < 10)
//                          ? "0" + n
//                          : n;
//                  }
//                  return this.getUTCFullYear()   + "-" +
//                       f(this.getUTCMonth() + 1) + "-" +
//                       f(this.getUTCDate())      + "T" +
//                       f(this.getUTCHours())     + ":" +
//                       f(this.getUTCMinutes())   + ":" +
//                       f(this.getUTCSeconds())   + "Z";
//              };

//          You can provide an optional replacer method. It will be passed the
//          key and value of each member, with this bound to the containing
//          object. The value that is returned from your method will be
//          serialized. If your method returns undefined, then the member will
//          be excluded from the serialization.

//          If the replacer parameter is an array of strings, then it will be
//          used to select the members to be serialized. It filters the results
//          such that only members with keys listed in the replacer array are
//          stringified.

//          Values that do not have JSON representations, such as undefined or
//          functions, will not be serialized. Such values in objects will be
//          dropped; in arrays they will be replaced with null. You can use
//          a replacer function to replace those with JSON values.

//          JSON.stringify(undefined) returns undefined.

//          The optional space parameter produces a stringification of the
//          value that is filled with line breaks and indentation to make it
//          easier to read.

//          If the space parameter is a non-empty string, then that string will
//          be used for indentation. If the space parameter is a number, then
//          the indentation will be that many spaces.

//          Example:

//          text = JSON.stringify(["e", {pluribus: "unum"}]);
//          // text is '["e",{"pluribus":"unum"}]'

//          text = JSON.stringify(["e", {pluribus: "unum"}], null, "\t");
//          // text is '[\n\t"e",\n\t{\n\t\t"pluribus": "unum"\n\t}\n]'

//          text = JSON.stringify([new Date()], function (key, value) {
//              return this[key] instanceof Date
//                  ? "Date(" + this[key] + ")"
//                  : value;
//          });
//          // text is '["Date(---current time---)"]'

//      JSON.parse(text, reviver)
//          This method parses a JSON text to produce an object or array.
//          It can throw a SyntaxError exception.

//          The optional reviver parameter is a function that can filter and
//          transform the results. It receives each of the keys and values,
//          and its return value is used instead of the original value.
//          If it returns what it received, then the structure is not modified.
//          If it returns undefined then the member is deleted.

//          Example:

//          // Parse the text. Values that look like ISO date strings will
//          // be converted to Date objects.

//          myData = JSON.parse(text, function (key, value) {
//              var a;
//              if (typeof value === "string") {
//                  a =
//   /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
//                  if (a) {
//                      return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
//                          +a[5], +a[6]));
//                  }
//              }
//              return value;
//          });

//          myData = JSON.parse('["Date(09/09/2001)"]', function (key, value) {
//              var d;
//              if (typeof value === "string" &&
//                      value.slice(0, 5) === "Date(" &&
//                      value.slice(-1) === ")") {
//                  d = new Date(value.slice(5, -1));
//                  if (d) {
//                      return d;
//                  }
//              }
//              return value;
//          });

//  This is a reference implementation. You are free to copy, modify, or
//  redistribute.

/*jslint
    eval, for, this
*/

/*property
    JSON, apply, call, charCodeAt, getUTCDate, getUTCFullYear, getUTCHours,
    getUTCMinutes, getUTCMonth, getUTCSeconds, hasOwnProperty, join,
    lastIndex, length, parse, prototype, push, replace, slice, stringify,
    test, toJSON, toString, valueOf
*/


// Create a JSON object only if one does not already exist. We create the
// methods in a closure to avoid creating global variables.

if (typeof JSON !== "object") {
    JSON = {};
}

(function () {
    "use strict";

    var rx_one = /^[\],:{}\s]*$/;
    var rx_two = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
    var rx_three = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
    var rx_four = /(?:^|:|,)(?:\s*\[)+/g;
    var rx_escapable = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
    var rx_dangerous = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;

    function f(n) {
        // Format integers to have at least two digits.
        return n < 10
            ? "0" + n
            : n;
    }

    function this_value() {
        return this.valueOf();
    }

    if (typeof Date.prototype.toJSON !== "function") {

        Date.prototype.toJSON = function () {

            return isFinite(this.valueOf())
                ? this.getUTCFullYear() + "-" +
                        f(this.getUTCMonth() + 1) + "-" +
                        f(this.getUTCDate()) + "T" +
                        f(this.getUTCHours()) + ":" +
                        f(this.getUTCMinutes()) + ":" +
                        f(this.getUTCSeconds()) + "Z"
                : null;
        };

        Boolean.prototype.toJSON = this_value;
        Number.prototype.toJSON = this_value;
        String.prototype.toJSON = this_value;
    }

    var gap;
    var indent;
    var meta;
    var rep;


    function quote(string) {

// If the string contains no control characters, no quote characters, and no
// backslash characters, then we can safely slap some quotes around it.
// Otherwise we must also replace the offending characters with safe escape
// sequences.

        rx_escapable.lastIndex = 0;
        return rx_escapable.test(string)
            ? "\"" + string.replace(rx_escapable, function (a) {
                var c = meta[a];
                return typeof c === "string"
                    ? c
                    : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
            }) + "\""
            : "\"" + string + "\"";
    }


    function str(key, holder) {

// Produce a string from holder[key].

        var i;          // The loop counter.
        var k;          // The member key.
        var v;          // The member value.
        var length;
        var mind = gap;
        var partial;
        var value = holder[key];

// If the value has a toJSON method, call it to obtain a replacement value.

        if (value && typeof value === "object" &&
                typeof value.toJSON === "function") {
            value = value.toJSON(key);
        }

// If we were called with a replacer function, then call the replacer to
// obtain a replacement value.

        if (typeof rep === "function") {
            value = rep.call(holder, key, value);
        }

// What happens next depends on the value's type.

        switch (typeof value) {
        case "string":
            return quote(value);

        case "number":

// JSON numbers must be finite. Encode non-finite numbers as null.

            return isFinite(value)
                ? String(value)
                : "null";

        case "boolean":
        case "null":

// If the value is a boolean or null, convert it to a string. Note:
// typeof null does not produce "null". The case is included here in
// the remote chance that this gets fixed someday.

            return String(value);

// If the type is "object", we might be dealing with an object or an array or
// null.

        case "object":

// Due to a specification blunder in ECMAScript, typeof null is "object",
// so watch out for that case.

            if (!value) {
                return "null";
            }

// Make an array to hold the partial results of stringifying this object value.

            gap += indent;
            partial = [];

// Is the value an array?

            if (Object.prototype.toString.apply(value) === "[object Array]") {

// The value is an array. Stringify every element. Use null as a placeholder
// for non-JSON values.

                length = value.length;
                for (i = 0; i < length; i += 1) {
                    partial[i] = str(i, value) || "null";
                }

// Join all of the elements together, separated with commas, and wrap them in
// brackets.

                v = partial.length === 0
                    ? "[]"
                    : gap
                        ? "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]"
                        : "[" + partial.join(",") + "]";
                gap = mind;
                return v;
            }

// If the replacer is an array, use it to select the members to be stringified.

            if (rep && typeof rep === "object") {
                length = rep.length;
                for (i = 0; i < length; i += 1) {
                    if (typeof rep[i] === "string") {
                        k = rep[i];
                        v = str(k, value);
                        if (v) {
                            partial.push(quote(k) + (
                                gap
                                    ? ": "
                                    : ":"
                            ) + v);
                        }
                    }
                }
            } else {

// Otherwise, iterate through all of the keys in the object.

                for (k in value) {
                    if (Object.prototype.hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) {
                            partial.push(quote(k) + (
                                gap
                                    ? ": "
                                    : ":"
                            ) + v);
                        }
                    }
                }
            }

// Join all of the member texts together, separated with commas,
// and wrap them in braces.

            v = partial.length === 0
                ? "{}"
                : gap
                    ? "{\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "}"
                    : "{" + partial.join(",") + "}";
            gap = mind;
            return v;
        }
    }

// If the JSON object does not yet have a stringify method, give it one.

    if (typeof JSON.stringify !== "function") {
        meta = {    // table of character substitutions
            "\b": "\\b",
            "\t": "\\t",
            "\n": "\\n",
            "\f": "\\f",
            "\r": "\\r",
            "\"": "\\\"",
            "\\": "\\\\"
        };
        JSON.stringify = function (value, replacer, space) {

// The stringify method takes a value and an optional replacer, and an optional
// space parameter, and returns a JSON text. The replacer can be a function
// that can replace values, or an array of strings that will select the keys.
// A default replacer method can be provided. Use of the space parameter can
// produce text that is more easily readable.

            var i;
            gap = "";
            indent = "";

// If the space parameter is a number, make an indent string containing that
// many spaces.

            if (typeof space === "number") {
                for (i = 0; i < space; i += 1) {
                    indent += " ";
                }

// If the space parameter is a string, it will be used as the indent string.

            } else if (typeof space === "string") {
                indent = space;
            }

// If there is a replacer, it must be a function or an array.
// Otherwise, throw an error.

            rep = replacer;
            if (replacer && typeof replacer !== "function" &&
                    (typeof replacer !== "object" ||
                    typeof replacer.length !== "number")) {
                throw new Error("JSON.stringify");
            }

// Make a fake root object containing our value under the key of "".
// Return the result of stringifying the value.

            return str("", {"": value});
        };
    }


// If the JSON object does not yet have a parse method, give it one.

    if (typeof JSON.parse !== "function") {
        JSON.parse = function (text, reviver) {

// The parse method takes a text and an optional reviver function, and returns
// a JavaScript value if the text is a valid JSON text.

            var j;

            function walk(holder, key) {

// The walk method is used to recursively walk the resulting structure so
// that modifications can be made.

                var k;
                var v;
                var value = holder[key];
                if (value && typeof value === "object") {
                    for (k in value) {
                        if (Object.prototype.hasOwnProperty.call(value, k)) {
                            v = walk(value, k);
                            if (v !== undefined) {
                                value[k] = v;
                            } else {
                                delete value[k];
                            }
                        }
                    }
                }
                return reviver.call(holder, key, value);
            }


// Parsing happens in four stages. In the first stage, we replace certain
// Unicode characters with escape sequences. JavaScript handles many characters
// incorrectly, either silently deleting them, or treating them as line endings.

            text = String(text);
            rx_dangerous.lastIndex = 0;
            if (rx_dangerous.test(text)) {
                text = text.replace(rx_dangerous, function (a) {
                    return "\\u" +
                            ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
                });
            }

// In the second stage, we run the text against regular expressions that look
// for non-JSON patterns. We are especially concerned with "()" and "new"
// because they can cause invocation, and "=" because it can cause mutation.
// But just to be safe, we want to reject all unexpected forms.

// We split the second stage into 4 regexp operations in order to work around
// crippling inefficiencies in IE's and Safari's regexp engines. First we
// replace the JSON backslash pairs with "@" (a non-JSON character). Second, we
// replace all simple value tokens with "]" characters. Third, we delete all
// open brackets that follow a colon or comma or that begin the text. Finally,
// we look to see that the remaining characters are only whitespace or "]" or
// "," or ":" or "{" or "}". If that is so, then the text is safe for eval.

            if (
                rx_one.test(
                    text
                        .replace(rx_two, "@")
                        .replace(rx_three, "]")
                        .replace(rx_four, "")
                )
            ) {

// In the third stage we use the eval function to compile the text into a
// JavaScript structure. The "{" operator is subject to a syntactic ambiguity
// in JavaScript: it can begin a block or an object literal. We wrap the text
// in parens to eliminate the ambiguity.

                j = eval("(" + text + ")");

// In the optional fourth stage, we recursively walk the new structure, passing
// each name/value pair to a reviver function for possible transformation.

                return (typeof reviver === "function")
                    ? walk({"": j}, "")
                    : j;
            }

// If the text is not JSON parseable, then a SyntaxError is thrown.

            throw new SyntaxError("JSON.parse");
        };
    }
}());

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(49);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(46);
var invariant = __webpack_require__(45);
var ReactPropTypesSecret = __webpack_require__(151);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(2);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(8);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(47);

var _PathUtils = __webpack_require__(26);

var _createTransitionManager = __webpack_require__(48);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(77);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(49);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(2);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(8);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(47);

var _PathUtils = __webpack_require__(26);

var _createTransitionManager = __webpack_require__(48);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(77);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(156);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(50);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(2);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(26);

var _LocationUtils = __webpack_require__(47);

var _createTransitionManager = __webpack_require__(48);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(78);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  ariaCurrent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['page', 'step', 'location', 'true'])
};

NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(160)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(162);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Prompt> outside a <Router>');

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(164);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(165);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Redirect> outside a <Router>');

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
      return;
    }

    this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(166);
/* unused harmony reexport createBrowserHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(167);
/* unused harmony reexport createHashHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(168);
/* unused harmony reexport createMemoryHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(32);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(27);
/* unused harmony reexport parsePath */
/* unused harmony reexport createPath */










/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(81);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createBrowserHistory);

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(81);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createHashHistory);

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(52);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createMemoryHistory);

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(170);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(50);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(172);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(51);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Switch> outside a <Router>');
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          sensitive = _element$props.sensitive,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(51);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(175);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(80);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_react_visualize_Core__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SideBar__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ColorMenu__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ColorPicker__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__HandlePicker__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__HandleEditor__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Form__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_i18next__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config_i18n__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config_regions_json__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config_regions_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__config_regions_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config_env_json__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config_env_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__config_env_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__config_params_json__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__config_params_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__config_params_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Configurator_css__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Configurator_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__Configurator_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_background_background_jpg__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_images_background_background_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_images_background_background_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_novae_black_png__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_images_novae_black_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_images_novae_black_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Store.remove('customDesigns')
var Configurator=function(_Component){_inherits(Configurator,_Component);function Configurator(props){_classCallCheck(this,Configurator);var _this=_possibleConstructorReturn(this,(Configurator.__proto__||Object.getPrototypeOf(Configurator)).call(this,props));_this.loading=false;_this.canvas={width:1920,height:1200};_this.handles=[];// Init i18n
var _props$match$params=props.match.params,region=_props$match$params.region,handle=_props$match$params.handle;_this.region=region;var _regions$find$countri=__WEBPACK_IMPORTED_MODULE_13__config_regions_json___default.a.find(function(_ref){var countries=_ref.countries;return countries.find(function(_ref2){var id=_ref2.id;return id===region;});}).countries.find(function(_ref3){var id=_ref3.id;return id===region;}),lang=_regions$find$countri.lang,colorSet=_regions$find$countri.colorSet;_this.handles=__webpack_require__(55)("./"+colorSet+'.json');__WEBPACK_IMPORTED_MODULE_12__config_i18n__["a" /* default */].changeLanguage(lang);var currentHandle=_this.handles.find(function(h){return h.handle===handle;});_this.colorSet=currentHandle.colors;// this.preloadAssets(handle)
if(undefined===currentHandle.backgroundFrames[__WEBPACK_IMPORTED_MODULE_1_store___default.a.get('backgroundFrame')]){__WEBPACK_IMPORTED_MODULE_1_store___default.a.set('backgroundFrame',0);}var backgroundFrame=currentHandle.backgroundFrames[__WEBPACK_IMPORTED_MODULE_1_store___default.a.get('backgroundFrame')].image_file;// Init Configurator
_this.state={handle:handle,color:_this.colorSet[0],backgroundFrame:backgroundFrame,handleEditor:false,displayForm:false};_this.config={image:null,handle:handle,type:_this.colorSet[0].color_type,coords:null,canvas:null,preview:null,data:{model:handle,color:_this.colorSet[0],email:null,// Going to be set by the form
lang:lang}};_this.updateHandle=_this.updateHandle.bind(_this);_this.updateColorType=_this.updateColorType.bind(_this);_this.updateColor=_this.updateColor.bind(_this);_this.updateFrame=_this.updateFrame.bind(_this);_this.addColors=_this.addColors.bind(_this);return _this;}_createClass(Configurator,[{key:'componentWillUpdate',value:function componentWillUpdate(props){var _this2=this;// Browsing through handles by props (routed updates)
if(props.match.params.handle!==this.state.handle){this.updateHandle({value:props.match.params.handle});}// Updating custom designs if needed
var customDesigns=__WEBPACK_IMPORTED_MODULE_1_store___default.a.get('customDesigns')||[];customDesigns.forEach(function(design){if(!_this2.colorSet.find(function(c){return c.ornament===design.key;})&&design.handle===props.match.params.handle){_this2.colorSet.push({image_file:props.match.params.handle+'/RAL/0011.png',color:'black',color_css:'#000',color_type:'custom',ornament:design.key,ornament_category:null,ornament_color:null,ornament_css:null,css:{backgroundColor:'#333',backgroundImage:'url(\''+design.dataURL+'\')',backgroundSize:'cover',backgroundPosition:'center'},declinable:false,customDesign:design.dataURL});_this2.colorSet.push({image_file:props.match.params.handle+'/RAL/0010.png',color:'white',color_css:'#fff',color_type:'custom',ornament:design.key,ornament_category:null,ornament_color:null,ornament_css:null,css:{backgroundColor:'#333',backgroundImage:'url(\''+design.dataURL+'\')',backgroundSize:'cover',backgroundPosition:'center'},declinable:false,customDesign:design.dataURL});}});}},{key:'preloadAssets',value:function preloadAssets(handle){var visualize=Object.assign({layers:[]},__WEBPACK_IMPORTED_MODULE_1_store___default.a.get('visualize'));// let j
// Flush handles from store
visualize.layers=[];// handle.colors.forEach((c, i) => {
//   visualize.layers.push({
//     type: 'img',
//     id: i,
//     asset: require('../assets/images/handles/' + c.image_file)
//   })
//   j = i
// })
// handle.backgroundFrames.forEach((bgf, i) => {
//   visualize.layers.push({
//     type: 'img',
//     id: i + j,
//     asset: require('../assets/images/handles/' + bgf)
//   })
// })
__WEBPACK_IMPORTED_MODULE_1_store___default.a.set('visualize',visualize);}},{key:'goBack',value:function goBack(){this.setState({goBack:true});}},{key:'setLoading',value:function setLoading(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;this.loading=state;}},{key:'preloadLayers',value:function preloadLayers(assets,callback){var _this3=this;var counter=0;this.setLoading();assets.forEach(function(a){var img=new window.Image();img.onload=function(){counter++;if(counter===assets.length){_this3.setLoading(false);callback();}};img.onerror=function(){return _this3.setLoading(false);};img.src=a;});}},{key:'updateHandle',value:function updateHandle(target){var _this4=this;var handle=this.handles.find(function(h){return h.handle===target.value;});var frame=handle.backgroundFrames[__WEBPACK_IMPORTED_MODULE_1_store___default.a.get('backgroundFrame')].image_file;var prevColor=this.state.color;// Update the color set
this.colorSet=handle.colors;var newColor=this.colorSet.find(function(c){return c.color_type===prevColor.color_type&&c.color===prevColor.color&&c.ornament===prevColor.ornament&&c.ornament_color===prevColor.ornament_color;})||handle.colors[0];// this.preloadAssets(handle)
this.preloadLayers([__webpack_require__(15)("./"+frame),__webpack_require__(15)("./"+newColor.image_file)],function(){return _this4.setState({handle:target.value,color:newColor,backgroundFrame:frame});});}},{key:'updateFrame',value:function updateFrame(){var _this5=this;var frame=this.handles.find(function(h){return h.handle===_this5.state.handle;}).backgroundFrames[__WEBPACK_IMPORTED_MODULE_1_store___default.a.get('backgroundFrame')].image_file;this.preloadLayers([__webpack_require__(15)("./"+frame)],function(){return _this5.setState({backgroundFrame:frame});});}},{key:'updateColorType',value:function updateColorType(event){var _this6=this;// Select first available color for this handle
var defaultColor=this.handles.find(function(h){return h.handle===_this6.state.handle;}).colors.find(function(c){return event.target.value==='decor'?c.ornament_color==='13':c.color_type===event.target.value;})||{};this.preloadLayers([__webpack_require__(15)("./"+defaultColor.image_file)],function(){return _this6.setState({color:defaultColor});});}},{key:'addColors',value:function addColors(){var _this7=this;var colors=this.handles.find(function(h){return h.handle===_this7.state.handle;}).colors;for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}args.forEach(function(color){if(!colors.find(function(c){return c.customDesign===color.customDesign&&c.color===color.color;})){colors.push(color);}// lol this condition makes no sens to read but actually makes sense
// If the base color (black or white) is the current one, set it
if(_this7.state.color.color===color.color){_this7.updateColor({target:{value:JSON.stringify(color)}});}});}},{key:'updateColor',value:function updateColor(event){var _this8=this;var target=event.currentTarget?event.currentTarget:event.target;var color=JSON.parse(target.value);this.preloadLayers([__webpack_require__(15)("./"+color.image_file)],function(){return _this8.setState({color:color});});}},{key:'getHandleColors',value:function getHandleColors(){var _this9=this;return this.handles.find(function(h){return h.handle===_this9.state.handle;}).colors;}},{key:'getHandlePropSet',value:function getHandlePropSet(prop){// Fetches a set of unique values in JSON data
// e.g. prop = color_type returns ['ral', 'anodized', 'decor']
// for the H48103 handle
return[].concat(_toConsumableArray(new Set(this.getHandleColors().map(function(c){return c[prop];}))));}},{key:'buildOrnamentColors',value:function buildOrnamentColors(){var _this10=this;return this.getHandleColors().filter(function(color){return color.ornament===_this10.state.color.ornament&&color.color===_this10.state.color.color&&color.ornament_color!==null;}).map(function(color){return Object.assign(color,{css:{background:color.ornament_css}});});}},{key:'displayForm',value:function displayForm(){var _this11=this;var customDesigns=__WEBPACK_IMPORTED_MODULE_1_store___default.a.get('customDesigns')||[];var currentCustom=customDesigns.find(function(design){return design.key===_this11.state.color.ornament;})||{key:null,handle:this.state.handle,dataURL:null,originalFile:'',coords:{x:0,y:0,w:0,h:0,rotation:0,scale:1},canvas:{w:0,h:0}// Store config as it will be sent to the back-end
};this.config={image:currentCustom.originalFile,handle:this.state.handle,type:this.state.color.color_type,coords:currentCustom.coords,canvas:currentCustom.canvas,preview:__WEBPACK_IMPORTED_MODULE_3__lib_react_visualize_Core__["b" /* Viewport */].renderCanvas(),data:{model:this.state.handle,color:this.state.color,email:null,// Going to be set by the form
lang:__WEBPACK_IMPORTED_MODULE_12__config_i18n__["a" /* default */].language}};this.setState({displayForm:true});}},{key:'render',value:function render(){var _this12=this;// I'll be Back
if(this.state.goBack===true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */],{to:'/'+this.region});}var imageFile=__webpack_require__(15)("./"+this.state.color.image_file);var backgroundFrame=__webpack_require__(15)("./"+this.state.backgroundFrame);var colors=this.getHandleColors().filter(function(c){return c.color_type===_this12.state.color.color_type;});var ornamentColorPickerClasses=['configurator-ornament-colors'];// TODO this is crappy
// if (this.state.color.declinable || this.state.color.ornament_color !== null) {
ornamentColorPickerClasses.push('open');// }
// Layers
var layers=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__lib_react_visualize_Core__["a" /* Layer */],{type:'img',asset:__WEBPACK_IMPORTED_MODULE_17__assets_images_background_background_jpg___default.a,key:'vp-background'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__lib_react_visualize_Core__["a" /* Layer */],{type:'img',asset:backgroundFrame,key:'vp-frame'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__lib_react_visualize_Core__["a" /* Layer */],{type:'img',asset:imageFile,key:'vp-handle'})];if(this.state.color.customDesign){layers.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__lib_react_visualize_Core__["a" /* Layer */],{type:'img',asset:this.state.color.customDesign,key:'vp-custom'}));}// Stored config
var config=this.config.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_i18next__["a" /* I18n */],null,function(t,_ref4){var i18n=_ref4.i18n;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__lib_react_visualize_Core__["c" /* Visualize */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__lib_react_visualize_Core__["b" /* Viewport */],{width:_this12.canvas.width,height:_this12.canvas.height},layers)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SideBar__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:_this12.goBack.bind(_this12),className:'go-back'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'material-icons'},'arrow_back')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__HandlePicker__["a" /* default */],{region:_this12.props.match.params.region,handles:_this12.handles,handle:_this12.state.handle,onUpdate:_this12.updateFrame}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'configurator-button-group'},_this12.getHandlePropSet('color_type').map(function(colorType){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Button__["a" /* default */],{key:colorType,className:_this12.state.color.color_type===colorType&&'active',onClick:_this12.updateColorType,value:colorType},t('configurator.colorType.'+colorType));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ColorMenu__["a" /* default */],{colors:colors,color:_this12.state.color,onClick:_this12.updateColor,customize:function customize(){return _this12.setState({handleEditor:true});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ColorPicker__["a" /* default */],{className:ornamentColorPickerClasses.join(' '),activeLayer:_this12.state.color.image_file,colors:_this12.buildOrnamentColors(),color:_this12.state.color,onClick:_this12.updateColor,hideLabel:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'aluk-novae-logo',src:__WEBPACK_IMPORTED_MODULE_18__assets_images_novae_black_png___default.a,alt:'Novae'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:_this12.displayForm.bind(_this12),className:'configurator-red-button configurator-sendconfig'},t('configurator.sendConfig')),_this12.state.displayForm?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Form__["a" /* default */],{sendTo:__WEBPACK_IMPORTED_MODULE_14__config_env_json___default.a.apiURL+__WEBPACK_IMPORTED_MODULE_15__config_params_json___default.a.sendEmailRoute,config:_this12.config,close:function close(){return _this12.setState({displayForm:false});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,t('configurator.form.myConfig')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__lib_react_visualize_Core__["b" /* Viewport */].renderCanvas(),className:'form-preview',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'configurator-summary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label'},t('configurator.form.model')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'value'},config.model)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label'},t('configurator.form.color')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'value'},config.color.color_type==='decor'||config.color.color_type==='custom'?config.color.color:Object(__WEBPACK_IMPORTED_MODULE_7__ColorPicker__["b" /* getTransformedLabel */])(config.color))),config.color.ornament!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label',key:'summary-ornament-l'},t('configurator.form.ornament')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'value',key:'summary-ornament-v'},config.color.color_type!=='custom'?config.color.ornament:t('configurator.form.custom'))):null,config.color.ornament_color!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'label',key:'summary-ornament-l'},t('configurator.form.ornament_color')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'value',key:'summary-ornament-v'},config.color.ornament_color)):null)):null,_this12.state.handleEditor?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__HandleEditor__["a" /* default */],{handle:_this12.state.handle,addColors:_this12.addColors,perspHandler:__WEBPACK_IMPORTED_MODULE_14__config_env_json___default.a.apiURL+__WEBPACK_IMPORTED_MODULE_15__config_params_json___default.a.perspectiveRoute,close:function close(){return _this12.setState({handleEditor:false});}}):null);});}}]);return Configurator;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Configurator);

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Core_Visualize__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Core_Viewport__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Core_Layer__ = __webpack_require__(184);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Core_Visualize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Core_Viewport__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Core_Layer__["a"]; });


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loader__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Visualize_css__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Visualize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Visualize_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Visualize=function(_Component){_inherits(Visualize,_Component);function Visualize(){_classCallCheck(this,Visualize);return _possibleConstructorReturn(this,(Visualize.__proto__||Object.getPrototypeOf(Visualize)).apply(this,arguments));}_createClass(Visualize,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'visualize'},this.props.assetCollection?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Loader__["a" /* default */],{manifest:this.props.assetCollection}):null,this.props.children);}}]);return Visualize;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Visualize);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preload_js__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preload_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_preload_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Loader_css__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Loader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Loader_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Loader=function(_Component){_inherits(Loader,_Component);function Loader(props){_classCallCheck(this,Loader);var _this=_possibleConstructorReturn(this,(Loader.__proto__||Object.getPrototypeOf(Loader)).call(this,props));_this.state={pct:0};return _this;}_createClass(Loader,[{key:'preloadAssets',value:function preloadAssets(){var _this2=this;var visualize=__WEBPACK_IMPORTED_MODULE_1_store___default.a.get('visualize');if(Array.isArray(visualize.layers)&&visualize.layers.length){var queue=new __WEBPACK_IMPORTED_MODULE_2_preload_js___default.a.LoadQueue();var manifest=[];visualize.layers.forEach(function(element){switch(element.type){case'img':manifest.push({id:element.id,src:element.asset});break;default:break;}});if(manifest.length>0){queue.on('complete',function(){return _this2.setState({pct:100});});queue.on('error',function(event){return console.log('Loading Error',event);});queue.on('progress',function(event){_this2.setState({pct:Math.round(event.loaded*100)});});queue.loadManifest(manifest);}else{this.setState({pct:100});}}}},{key:'componentDidMount',value:function componentDidMount(){this.preloadAssets();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.manifest!==nextProps.manifest){this.setState({pct:0},this.preloadAssets);}}},{key:'render',value:function render(){console.log(this.state);var radius=3.125;var circumference=2*radius*Math.PI;if(this.state.pct===100){return null;// Bye bye loader !
}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'visualize-loader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader-percent','data-pct':this.state.pct})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{className:'loader-inner',width:'7.5em',height:'7.5em',version:'1.1',xmlns:'http://www.w3.org/2000/svg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{className:'loader-bar',r:radius+'em',cx:'3.75em',cy:'3.75em',strokeDasharray:circumference+'em',strokeDashoffset:circumference-circumference*this.state.pct/100+'em'})));}}]);return Loader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),
/* 180 */
/***/ (function(module, exports) {

/*!
* @license PreloadJS
* Visit http://createjs.com/ for documentation, updates and examples.
*
* Copyright (c) 2011-2013 gskinner.com, inc.
*
* Distributed under the terms of the MIT license.
* http://www.opensource.org/licenses/mit-license.html
*
* This notice shall be included in all copies or substantial portions of the Software.
*/
window.createjs=window.createjs||{},function(){"use strict";var a=createjs.PreloadJS=createjs.PreloadJS||{};a.version="0.4.1",a.buildDate="Thu, 12 Dec 2013 23:33:38 GMT"}(),function(){"use strict";var a=function(a,b,c){this.initialize(a,b,c)},b=a.prototype;b.type=null,b.target=null,b.currentTarget=null,b.eventPhase=0,b.bubbles=!1,b.cancelable=!1,b.timeStamp=0,b.defaultPrevented=!1,b.propagationStopped=!1,b.immediatePropagationStopped=!1,b.removed=!1,b.initialize=function(a,b,c){this.type=a,this.bubbles=b,this.cancelable=c,this.timeStamp=(new Date).getTime()},b.preventDefault=function(){this.defaultPrevented=!0},b.stopPropagation=function(){this.propagationStopped=!0},b.stopImmediatePropagation=function(){this.immediatePropagationStopped=this.propagationStopped=!0},b.remove=function(){this.removed=!0},b.clone=function(){return new a(this.type,this.bubbles,this.cancelable)},b.toString=function(){return"[Event (type="+this.type+")]"},createjs.Event=a}(),function(){"use strict";var a=function(){},b=a.prototype;a.initialize=function(a){a.addEventListener=b.addEventListener,a.on=b.on,a.removeEventListener=a.off=b.removeEventListener,a.removeAllEventListeners=b.removeAllEventListeners,a.hasEventListener=b.hasEventListener,a.dispatchEvent=b.dispatchEvent,a._dispatchEvent=b._dispatchEvent,a.willTrigger=b.willTrigger},b._listeners=null,b._captureListeners=null,b.initialize=function(){},b.addEventListener=function(a,b,c){var d;d=c?this._captureListeners=this._captureListeners||{}:this._listeners=this._listeners||{};var e=d[a];return e&&this.removeEventListener(a,b,c),e=d[a],e?e.push(b):d[a]=[b],b},b.on=function(a,b,c,d,e,f){return b.handleEvent&&(c=c||b,b=b.handleEvent),c=c||this,this.addEventListener(a,function(a){b.call(c,a,e),d&&a.remove()},f)},b.removeEventListener=function(a,b,c){var d=c?this._captureListeners:this._listeners;if(d){var e=d[a];if(e)for(var f=0,g=e.length;g>f;f++)if(e[f]==b){1==g?delete d[a]:e.splice(f,1);break}}},b.off=b.removeEventListener,b.removeAllEventListeners=function(a){a?(this._listeners&&delete this._listeners[a],this._captureListeners&&delete this._captureListeners[a]):this._listeners=this._captureListeners=null},b.dispatchEvent=function(a,b){if("string"==typeof a){var c=this._listeners;if(!c||!c[a])return!1;a=new createjs.Event(a)}if(a.target=b||this,a.bubbles&&this.parent){for(var d=this,e=[d];d.parent;)e.push(d=d.parent);var f,g=e.length;for(f=g-1;f>=0&&!a.propagationStopped;f--)e[f]._dispatchEvent(a,1+(0==f));for(f=1;g>f&&!a.propagationStopped;f++)e[f]._dispatchEvent(a,3)}else this._dispatchEvent(a,2);return a.defaultPrevented},b.hasEventListener=function(a){var b=this._listeners,c=this._captureListeners;return!!(b&&b[a]||c&&c[a])},b.willTrigger=function(a){for(var b=this;b;){if(b.hasEventListener(a))return!0;b=b.parent}return!1},b.toString=function(){return"[EventDispatcher]"},b._dispatchEvent=function(a,b){var c,d=1==b?this._captureListeners:this._listeners;if(a&&d){var e=d[a.type];if(!e||!(c=e.length))return;a.currentTarget=this,a.eventPhase=b,a.removed=!1,e=e.slice();for(var f=0;c>f&&!a.immediatePropagationStopped;f++){var g=e[f];g.handleEvent?g.handleEvent(a):g(a),a.removed&&(this.off(a.type,g,1==b),a.removed=!1)}}},createjs.EventDispatcher=a}(),function(){"use strict";createjs.indexOf=function(a,b){for(var c=0,d=a.length;d>c;c++)if(b===a[c])return c;return-1}}(),function(){"use strict";createjs.proxy=function(a,b){var c=Array.prototype.slice.call(arguments,2);return function(){return a.apply(b,Array.prototype.slice.call(arguments,0).concat(c))}}}(),function(){"use strict";var a=function(){this.init()};a.prototype=new createjs.EventDispatcher;var b=a.prototype,c=a;c.FILE_PATTERN=/^(?:(\w+:)\/{2}(\w+(?:\.\w+)*\/?)|(.{0,2}\/{1}))?([/.]*?(?:[^?]+)?\/)?((?:[^/?]+)\.(\w+))(?:\?(\S+)?)?$/,c.PATH_PATTERN=/^(?:(\w+:)\/{2})|(.{0,2}\/{1})?([/.]*?(?:[^?]+)?\/?)?$/,b.loaded=!1,b.canceled=!1,b.progress=0,b._item=null,b.getItem=function(){return this._item},b.init=function(){},b.load=function(){},b.close=function(){},b._sendLoadStart=function(){this._isCanceled()||this.dispatchEvent("loadstart")},b._sendProgress=function(a){if(!this._isCanceled()){var b=null;"number"==typeof a?(this.progress=a,b=new createjs.Event("progress"),b.loaded=this.progress,b.total=1):(b=a,this.progress=a.loaded/a.total,(isNaN(this.progress)||1/0==this.progress)&&(this.progress=0)),b.progress=this.progress,this.hasEventListener("progress")&&this.dispatchEvent(b)}},b._sendComplete=function(){this._isCanceled()||this.dispatchEvent("complete")},b._sendError=function(a){!this._isCanceled()&&this.hasEventListener("error")&&(null==a&&(a=new createjs.Event("error")),this.dispatchEvent(a))},b._isCanceled=function(){return null==window.createjs||this.canceled?!0:!1},b._parseURI=function(a){return a?a.match(c.FILE_PATTERN):null},b._parsePath=function(a){return a?a.match(c.PATH_PATTERN):null},b._formatQueryString=function(a,b){if(null==a)throw new Error("You must specify data.");var c=[];for(var d in a)c.push(d+"="+escape(a[d]));return b&&(c=c.concat(b)),c.join("&")},b.buildPath=function(a,b){if(null==b)return a;var c=[],d=a.indexOf("?");if(-1!=d){var e=a.slice(d+1);c=c.concat(e.split("&"))}return-1!=d?a.slice(0,d)+"?"+this._formatQueryString(b,c):a+"?"+this._formatQueryString(b,c)},b._isCrossDomain=function(a){var b=document.createElement("a");b.href=a.src;var c=document.createElement("a");c.href=location.href;var d=""!=b.hostname&&(b.port!=c.port||b.protocol!=c.protocol||b.hostname!=c.hostname);return d},b._isLocal=function(a){var b=document.createElement("a");return b.href=a.src,""==b.hostname&&"file:"==b.protocol},b.toString=function(){return"[PreloadJS AbstractLoader]"},createjs.AbstractLoader=a}(),function(){"use strict";var a=function(a,b,c){this.init(a,b,c)},b=a.prototype=new createjs.AbstractLoader,c=a;c.loadTimeout=8e3,c.LOAD_TIMEOUT=0,c.BINARY="binary",c.CSS="css",c.IMAGE="image",c.JAVASCRIPT="javascript",c.JSON="json",c.JSONP="jsonp",c.MANIFEST="manifest",c.SOUND="sound",c.SVG="svg",c.TEXT="text",c.XML="xml",c.POST="POST",c.GET="GET",b._basePath=null,b._crossOrigin="",b.useXHR=!0,b.stopOnError=!1,b.maintainScriptOrder=!0,b.next=null,b._typeCallbacks=null,b._extensionCallbacks=null,b._loadStartWasDispatched=!1,b._maxConnections=1,b._currentlyLoadingScript=null,b._currentLoads=null,b._loadQueue=null,b._loadQueueBackup=null,b._loadItemsById=null,b._loadItemsBySrc=null,b._loadedResults=null,b._loadedRawResults=null,b._numItems=0,b._numItemsLoaded=0,b._scriptOrder=null,b._loadedScripts=null,b.init=function(a,b,c){this._numItems=this._numItemsLoaded=0,this._paused=!1,this._loadStartWasDispatched=!1,this._currentLoads=[],this._loadQueue=[],this._loadQueueBackup=[],this._scriptOrder=[],this._loadedScripts=[],this._loadItemsById={},this._loadItemsBySrc={},this._loadedResults={},this._loadedRawResults={},this._typeCallbacks={},this._extensionCallbacks={},this._basePath=b,this.setUseXHR(a),this._crossOrigin=c===!0?"Anonymous":c===!1||null==c?"":c},b.setUseXHR=function(a){return this.useXHR=0!=a&&null!=window.XMLHttpRequest,this.useXHR},b.removeAll=function(){this.remove()},b.remove=function(a){var b=null;if(!a||a instanceof Array){if(a)b=a;else if(arguments.length>0)return}else b=[a];var c=!1;if(b){for(;b.length;){var d=b.pop(),e=this.getResult(d);for(f=this._loadQueue.length-1;f>=0;f--)if(g=this._loadQueue[f].getItem(),g.id==d||g.src==d){this._loadQueue.splice(f,1)[0].cancel();break}for(f=this._loadQueueBackup.length-1;f>=0;f--)if(g=this._loadQueueBackup[f].getItem(),g.id==d||g.src==d){this._loadQueueBackup.splice(f,1)[0].cancel();break}if(e)delete this._loadItemsById[e.id],delete this._loadItemsBySrc[e.src],this._disposeItem(e);else for(var f=this._currentLoads.length-1;f>=0;f--){var g=this._currentLoads[f].getItem();if(g.id==d||g.src==d){this._currentLoads.splice(f,1)[0].cancel(),c=!0;break}}}c&&this._loadNext()}else{this.close();for(var h in this._loadItemsById)this._disposeItem(this._loadItemsById[h]);this.init(this.useXHR)}},b.reset=function(){this.close();for(var a in this._loadItemsById)this._disposeItem(this._loadItemsById[a]);for(var b=[],c=0,d=this._loadQueueBackup.length;d>c;c++)b.push(this._loadQueueBackup[c].getItem());this.loadManifest(b,!1)},c.isBinary=function(a){switch(a){case createjs.LoadQueue.IMAGE:case createjs.LoadQueue.BINARY:return!0;default:return!1}},c.isText=function(a){switch(a){case createjs.LoadQueue.TEXT:case createjs.LoadQueue.JSON:case createjs.LoadQueue.MANIFEST:case createjs.LoadQueue.XML:case createjs.LoadQueue.HTML:case createjs.LoadQueue.CSS:case createjs.LoadQueue.SVG:case createjs.LoadQueue.JAVASCRIPT:return!0;default:return!1}},b.installPlugin=function(a){if(null!=a&&null!=a.getPreloadHandlers){var b=a.getPreloadHandlers();if(b.scope=a,null!=b.types)for(var c=0,d=b.types.length;d>c;c++)this._typeCallbacks[b.types[c]]=b;if(null!=b.extensions)for(c=0,d=b.extensions.length;d>c;c++)this._extensionCallbacks[b.extensions[c]]=b}},b.setMaxConnections=function(a){this._maxConnections=a,!this._paused&&this._loadQueue.length>0&&this._loadNext()},b.loadFile=function(a,b,c){if(null==a){var d=new createjs.Event("error");return d.text="PRELOAD_NO_FILE",this._sendError(d),void 0}this._addItem(a,null,c),b!==!1?this.setPaused(!1):this.setPaused(!0)},b.loadManifest=function(a,b,d){var e=null,f=null;if(a instanceof Array){if(0==a.length){var g=new createjs.Event("error");return g.text="PRELOAD_MANIFEST_EMPTY",this._sendError(g),void 0}e=a}else if("string"==typeof a)e=[{src:a,type:c.MANIFEST}];else{if("object"!=typeof a){var g=new createjs.Event("error");return g.text="PRELOAD_MANIFEST_NULL",this._sendError(g),void 0}if(void 0!==a.src){if(null==a.type)a.type=c.MANIFEST;else if(a.type!=c.MANIFEST){var g=new createjs.Event("error");g.text="PRELOAD_MANIFEST_ERROR",this._sendError(g)}e=[a]}else void 0!==a.manifest&&(e=a.manifest,f=a.path)}for(var h=0,i=e.length;i>h;h++)this._addItem(e[h],f,d);b!==!1?this.setPaused(!1):this.setPaused(!0)},b.load=function(){this.setPaused(!1)},b.getItem=function(a){return this._loadItemsById[a]||this._loadItemsBySrc[a]},b.getResult=function(a,b){var c=this._loadItemsById[a]||this._loadItemsBySrc[a];if(null==c)return null;var d=c.id;return b&&this._loadedRawResults[d]?this._loadedRawResults[d]:this._loadedResults[d]},b.setPaused=function(a){this._paused=a,this._paused||this._loadNext()},b.close=function(){for(;this._currentLoads.length;)this._currentLoads.pop().cancel();this._scriptOrder.length=0,this._loadedScripts.length=0,this.loadStartWasDispatched=!1},b._addItem=function(a,b,c){var d=this._createLoadItem(a,b,c);if(null!=d){var e=this._createLoader(d);null!=e&&(this._loadQueue.push(e),this._loadQueueBackup.push(e),this._numItems++,this._updateProgress(),this.maintainScriptOrder&&d.type==createjs.LoadQueue.JAVASCRIPT&&e instanceof createjs.XHRLoader&&(this._scriptOrder.push(d),this._loadedScripts.push(null)))}},b._createLoadItem=function(a,b,c){var d=null;switch(typeof a){case"string":d={src:a};break;case"object":d=window.HTMLAudioElement&&a instanceof window.HTMLAudioElement?{tag:a,src:d.tag.src,type:createjs.LoadQueue.SOUND}:a;break;default:return null}var e=this._parseURI(d.src);null!=e&&(d.ext=e[6]),null==d.type&&(d.type=this._getTypeByExtension(d.ext));var f="",g=c||this._basePath,h=d.src;if(e&&null==e[1]&&null==e[3])if(b){f=b;var i=this._parsePath(b);h=b+h,null!=g&&i&&null==i[1]&&null==i[2]&&(f=g+f)}else null!=g&&(f=g);if(d.src=f+d.src,d.path=f,(d.type==createjs.LoadQueue.JSON||d.type==createjs.LoadQueue.MANIFEST)&&(d._loadAsJSONP=null!=d.callback),d.type==createjs.LoadQueue.JSONP&&null==d.callback)throw new Error("callback is required for loading JSONP requests.");(void 0===d.tag||null===d.tag)&&(d.tag=this._createTag(d)),(void 0===d.id||null===d.id||""===d.id)&&(d.id=h);var j=this._typeCallbacks[d.type]||this._extensionCallbacks[d.ext];if(j){var k=j.callback.call(j.scope,d.src,d.type,d.id,d.data,f,this);if(k===!1)return null;k===!0||(null!=k.src&&(d.src=k.src),null!=k.id&&(d.id=k.id),null!=k.tag&&(d.tag=k.tag),null!=k.completeHandler&&(d.completeHandler=k.completeHandler),k.type&&(d.type=k.type),e=this._parseURI(d.src),null!=e&&null!=e[6]&&(d.ext=e[6].toLowerCase()))}return this._loadItemsById[d.id]=d,this._loadItemsBySrc[d.src]=d,d},b._createLoader=function(a){var b=this.useXHR;switch(a.type){case createjs.LoadQueue.JSON:case createjs.LoadQueue.MANIFEST:b=!a._loadAsJSONP;break;case createjs.LoadQueue.XML:case createjs.LoadQueue.TEXT:b=!0;break;case createjs.LoadQueue.SOUND:case createjs.LoadQueue.JSONP:b=!1;break;case null:return null}return b?new createjs.XHRLoader(a,this._crossOrigin):new createjs.TagLoader(a)},b._loadNext=function(){if(!this._paused){this._loadStartWasDispatched||(this._sendLoadStart(),this._loadStartWasDispatched=!0),this._numItems==this._numItemsLoaded?(this.loaded=!0,this._sendComplete(),this.next&&this.next.load&&this.next.load()):this.loaded=!1;for(var a=0;a<this._loadQueue.length&&!(this._currentLoads.length>=this._maxConnections);a++){var b=this._loadQueue[a];if(this.maintainScriptOrder&&b instanceof createjs.TagLoader&&b.getItem().type==createjs.LoadQueue.JAVASCRIPT){if(this._currentlyLoadingScript)continue;this._currentlyLoadingScript=!0}this._loadQueue.splice(a,1),a--,this._loadItem(b)}}},b._loadItem=function(a){a.on("progress",this._handleProgress,this),a.on("complete",this._handleFileComplete,this),a.on("error",this._handleFileError,this),this._currentLoads.push(a),this._sendFileStart(a.getItem()),a.load()},b._handleFileError=function(a){var b=a.target;this._numItemsLoaded++,this._updateProgress();var c=new createjs.Event("error");c.text="FILE_LOAD_ERROR",c.item=b.getItem(),this._sendError(c),this.stopOnError||(this._removeLoadItem(b),this._loadNext())},b._handleFileComplete=function(a){var b=a.target,c=b.getItem();if(this._loadedResults[c.id]=b.getResult(),b instanceof createjs.XHRLoader&&(this._loadedRawResults[c.id]=b.getResult(!0)),this._removeLoadItem(b),this.maintainScriptOrder&&c.type==createjs.LoadQueue.JAVASCRIPT){if(!(b instanceof createjs.TagLoader))return this._loadedScripts[createjs.indexOf(this._scriptOrder,c)]=c,this._checkScriptLoadOrder(b),void 0;this._currentlyLoadingScript=!1}if(delete c._loadAsJSONP,c.type==createjs.LoadQueue.MANIFEST){var d=b.getResult();null!=d&&void 0!==d.manifest&&this.loadManifest(d,!0)}this._processFinishedLoad(c,b)},b._processFinishedLoad=function(a,b){this._numItemsLoaded++,this._updateProgress(),this._sendFileComplete(a,b),this._loadNext()},b._checkScriptLoadOrder=function(){for(var a=this._loadedScripts.length,b=0;a>b;b++){var c=this._loadedScripts[b];if(null===c)break;if(c!==!0){var d=this._loadedResults[c.id];(document.body||document.getElementsByTagName("body")[0]).appendChild(d),this._processFinishedLoad(c),this._loadedScripts[b]=!0}}},b._removeLoadItem=function(a){for(var b=this._currentLoads.length,c=0;b>c;c++)if(this._currentLoads[c]==a){this._currentLoads.splice(c,1);break}},b._handleProgress=function(a){var b=a.target;this._sendFileProgress(b.getItem(),b.progress),this._updateProgress()},b._updateProgress=function(){var a=this._numItemsLoaded/this._numItems,b=this._numItems-this._numItemsLoaded;if(b>0){for(var c=0,d=0,e=this._currentLoads.length;e>d;d++)c+=this._currentLoads[d].progress;a+=c/b*(b/this._numItems)}this._sendProgress(a)},b._disposeItem=function(a){delete this._loadedResults[a.id],delete this._loadedRawResults[a.id],delete this._loadItemsById[a.id],delete this._loadItemsBySrc[a.src]},b._createTag=function(a){var b=null;switch(a.type){case createjs.LoadQueue.IMAGE:return b=document.createElement("img"),""==this._crossOrigin||this._isLocal(a)||(b.crossOrigin=this._crossOrigin),b;case createjs.LoadQueue.SOUND:return b=document.createElement("audio"),b.autoplay=!1,b;case createjs.LoadQueue.JSON:case createjs.LoadQueue.JSONP:case createjs.LoadQueue.JAVASCRIPT:case createjs.LoadQueue.MANIFEST:return b=document.createElement("script"),b.type="text/javascript",b;case createjs.LoadQueue.CSS:return b=this.useXHR?document.createElement("style"):document.createElement("link"),b.rel="stylesheet",b.type="text/css",b;case createjs.LoadQueue.SVG:return this.useXHR?b=document.createElement("svg"):(b=document.createElement("object"),b.type="image/svg+xml"),b}return null},b._getTypeByExtension=function(a){if(null==a)return createjs.LoadQueue.TEXT;switch(a.toLowerCase()){case"jpeg":case"jpg":case"gif":case"png":case"webp":case"bmp":return createjs.LoadQueue.IMAGE;case"ogg":case"mp3":case"wav":return createjs.LoadQueue.SOUND;case"json":return createjs.LoadQueue.JSON;case"xml":return createjs.LoadQueue.XML;case"css":return createjs.LoadQueue.CSS;case"js":return createjs.LoadQueue.JAVASCRIPT;case"svg":return createjs.LoadQueue.SVG;default:return createjs.LoadQueue.TEXT}},b._sendFileProgress=function(a,b){if(this._isCanceled())return this._cleanUp(),void 0;if(this.hasEventListener("fileprogress")){var c=new createjs.Event("fileprogress");c.progress=b,c.loaded=b,c.total=1,c.item=a,this.dispatchEvent(c)}},b._sendFileComplete=function(a,b){if(!this._isCanceled()){var c=new createjs.Event("fileload");c.loader=b,c.item=a,c.result=this._loadedResults[a.id],c.rawResult=this._loadedRawResults[a.id],a.completeHandler&&a.completeHandler(c),this.hasEventListener("fileload")&&this.dispatchEvent(c)}},b._sendFileStart=function(a){var b=new createjs.Event("filestart");b.item=a,this.hasEventListener("filestart")&&this.dispatchEvent(b)},b.toString=function(){return"[PreloadJS LoadQueue]"},createjs.LoadQueue=a;var d=function(){};d.init=function(){var a=navigator.userAgent;d.isFirefox=a.indexOf("Firefox")>-1,d.isOpera=null!=window.opera,d.isChrome=a.indexOf("Chrome")>-1,d.isIOS=a.indexOf("iPod")>-1||a.indexOf("iPhone")>-1||a.indexOf("iPad")>-1},d.init(),createjs.LoadQueue.BrowserDetect=d}(),function(){"use strict";var a=function(a){this.init(a)},b=a.prototype=new createjs.AbstractLoader;b._loadTimeout=null,b._tagCompleteProxy=null,b._isAudio=!1,b._tag=null,b._jsonResult=null,b.init=function(a){this._item=a,this._tag=a.tag,this._isAudio=window.HTMLAudioElement&&a.tag instanceof window.HTMLAudioElement,this._tagCompleteProxy=createjs.proxy(this._handleLoad,this)},b.getResult=function(){return this._item.type==createjs.LoadQueue.JSONP||this._item.type==createjs.LoadQueue.MANIFEST?this._jsonResult:this._tag},b.cancel=function(){this.canceled=!0,this._clean()},b.load=function(){var a=this._item,b=this._tag;clearTimeout(this._loadTimeout);var c=createjs.LoadQueue.LOAD_TIMEOUT;0==c&&(c=createjs.LoadQueue.loadTimeout),this._loadTimeout=setTimeout(createjs.proxy(this._handleTimeout,this),c),this._isAudio&&(b.src=null,b.preload="auto"),b.onerror=createjs.proxy(this._handleError,this),this._isAudio?(b.onstalled=createjs.proxy(this._handleStalled,this),b.addEventListener("canplaythrough",this._tagCompleteProxy,!1)):(b.onload=createjs.proxy(this._handleLoad,this),b.onreadystatechange=createjs.proxy(this._handleReadyStateChange,this));var d=this.buildPath(a.src,a.values);switch(a.type){case createjs.LoadQueue.CSS:b.href=d;break;case createjs.LoadQueue.SVG:b.data=d;break;default:b.src=d}if(a.type==createjs.LoadQueue.JSONP||a.type==createjs.LoadQueue.JSON||a.type==createjs.LoadQueue.MANIFEST){if(null==a.callback)throw new Error("callback is required for loading JSONP requests.");if(null!=window[a.callback])throw new Error('JSONP callback "'+a.callback+'" already exists on window. You need to specify a different callback. Or re-name the current one.');window[a.callback]=createjs.proxy(this._handleJSONPLoad,this)}(a.type==createjs.LoadQueue.SVG||a.type==createjs.LoadQueue.JSONP||a.type==createjs.LoadQueue.JSON||a.type==createjs.LoadQueue.MANIFEST||a.type==createjs.LoadQueue.JAVASCRIPT||a.type==createjs.LoadQueue.CSS)&&(this._startTagVisibility=b.style.visibility,b.style.visibility="hidden",(document.body||document.getElementsByTagName("body")[0]).appendChild(b)),null!=b.load&&b.load()},b._handleJSONPLoad=function(a){this._jsonResult=a},b._handleTimeout=function(){this._clean();var a=new createjs.Event("error");a.text="PRELOAD_TIMEOUT",this._sendError(a)},b._handleStalled=function(){},b._handleError=function(){this._clean();var a=new createjs.Event("error");this._sendError(a)},b._handleReadyStateChange=function(){clearTimeout(this._loadTimeout);var a=this.getItem().tag;("loaded"==a.readyState||"complete"==a.readyState)&&this._handleLoad()},b._handleLoad=function(){if(!this._isCanceled()){var a=this.getItem(),b=a.tag;if(!(this.loaded||this._isAudio&&4!==b.readyState)){switch(this.loaded=!0,a.type){case createjs.LoadQueue.SVG:case createjs.LoadQueue.JSON:case createjs.LoadQueue.JSONP:case createjs.LoadQueue.MANIFEST:case createjs.LoadQueue.CSS:b.style.visibility=this._startTagVisibility,(document.body||document.getElementsByTagName("body")[0]).removeChild(b)}this._clean(),this._sendComplete()}}},b._clean=function(){clearTimeout(this._loadTimeout);var a=this.getItem(),b=a.tag;null!=b&&(b.onload=null,b.removeEventListener&&b.removeEventListener("canplaythrough",this._tagCompleteProxy,!1),b.onstalled=null,b.onprogress=null,b.onerror=null,null!=b.parentNode&&a.type==createjs.LoadQueue.SVG&&a.type==createjs.LoadQueue.JSON&&a.type==createjs.LoadQueue.MANIFEST&&a.type==createjs.LoadQueue.CSS&&a.type==createjs.LoadQueue.JSONP&&b.parentNode.removeChild(b));var a=this.getItem();(a.type==createjs.LoadQueue.JSONP||a.type==createjs.LoadQueue.MANIFEST)&&(window[a.callback]=null)},b.toString=function(){return"[PreloadJS TagLoader]"},createjs.TagLoader=a}(),function(){"use strict";var a=function(a,b){this.init(a,b)},b=a.prototype=new createjs.AbstractLoader;b._request=null,b._loadTimeout=null,b._xhrLevel=1,b._response=null,b._rawResponse=null,b._crossOrigin="",b.init=function(a,b){this._item=a,this._crossOrigin=b,!this._createXHR(a)},b.getResult=function(a){return a&&this._rawResponse?this._rawResponse:this._response},b.cancel=function(){this.canceled=!0,this._clean(),this._request.abort()},b.load=function(){if(null==this._request)return this._handleError(),void 0;if(this._request.onloadstart=createjs.proxy(this._handleLoadStart,this),this._request.onprogress=createjs.proxy(this._handleProgress,this),this._request.onabort=createjs.proxy(this._handleAbort,this),this._request.onerror=createjs.proxy(this._handleError,this),this._request.ontimeout=createjs.proxy(this._handleTimeout,this),1==this._xhrLevel){var a=createjs.LoadQueue.LOAD_TIMEOUT;if(0==a)a=createjs.LoadQueue.loadTimeout;else try{console.warn("LoadQueue.LOAD_TIMEOUT has been deprecated in favor of LoadQueue.loadTimeout")}catch(b){}this._loadTimeout=setTimeout(createjs.proxy(this._handleTimeout,this),a)}this._request.onload=createjs.proxy(this._handleLoad,this),this._request.onreadystatechange=createjs.proxy(this._handleReadyStateChange,this);try{this._item.values&&this._item.method!=createjs.LoadQueue.GET?this._item.method==createjs.LoadQueue.POST&&this._request.send(this._formatQueryString(this._item.values)):this._request.send()}catch(c){var d=new createjs.Event("error");d.error=c,this._sendError(d)}},b.getAllResponseHeaders=function(){return this._request.getAllResponseHeaders instanceof Function?this._request.getAllResponseHeaders():null},b.getResponseHeader=function(a){return this._request.getResponseHeader instanceof Function?this._request.getResponseHeader(a):null},b._handleProgress=function(a){if(a&&!(a.loaded>0&&0==a.total)){var b=new createjs.Event("progress");b.loaded=a.loaded,b.total=a.total,this._sendProgress(b)}},b._handleLoadStart=function(){clearTimeout(this._loadTimeout),this._sendLoadStart()},b._handleAbort=function(){this._clean();var a=new createjs.Event("error");a.text="XHR_ABORTED",this._sendError(a)},b._handleError=function(){this._clean();var a=new createjs.Event("error");this._sendError(a)},b._handleReadyStateChange=function(){4==this._request.readyState&&this._handleLoad()},b._handleLoad=function(){if(!this.loaded){if(this.loaded=!0,!this._checkError())return this._handleError(),void 0;this._response=this._getResponse(),this._clean();var a=this._generateTag();a&&this._sendComplete()}},b._handleTimeout=function(a){this._clean();var b=new createjs.Event("error");b.text="PRELOAD_TIMEOUT",this._sendError(a)},b._checkError=function(){var a=parseInt(this._request.status);switch(a){case 404:case 0:return!1}return!0},b._getResponse=function(){if(null!=this._response)return this._response;if(null!=this._request.response)return this._request.response;try{if(null!=this._request.responseText)return this._request.responseText}catch(a){}try{if(null!=this._request.responseXML)return this._request.responseXML}catch(a){}return null},b._createXHR=function(a){var b=this._isCrossDomain(a),c=null;if(b&&window.XDomainRequest)c=new XDomainRequest;else if(window.XMLHttpRequest)c=new XMLHttpRequest;else try{c=new ActiveXObject("Msxml2.XMLHTTP.6.0")}catch(d){try{c=new ActiveXObject("Msxml2.XMLHTTP.3.0")}catch(d){try{c=new ActiveXObject("Msxml2.XMLHTTP")}catch(d){return!1}}}createjs.LoadQueue.isText(a.type)&&c.overrideMimeType&&c.overrideMimeType("text/plain; charset=utf-8"),this._xhrLevel="string"==typeof c.responseType?2:1;var e=null;return e=a.method==createjs.LoadQueue.GET?this.buildPath(a.src,a.values):a.src,c.open(a.method||createjs.LoadQueue.GET,e,!0),b&&c instanceof XMLHttpRequest&&1==this._xhrLevel&&c.setRequestHeader("Origin",location.origin),a.values&&a.method==createjs.LoadQueue.POST&&c.setRequestHeader("Content-Type","application/x-www-form-urlencoded"),createjs.LoadQueue.isBinary(a.type)&&(c.responseType="arraybuffer"),this._request=c,!0},b._clean=function(){clearTimeout(this._loadTimeout);var a=this._request;a.onloadstart=null,a.onprogress=null,a.onabort=null,a.onerror=null,a.onload=null,a.ontimeout=null,a.onloadend=null,a.onreadystatechange=null},b._generateTag=function(){var a=this._item.type,b=this._item.tag;switch(a){case createjs.LoadQueue.IMAGE:return b.onload=createjs.proxy(this._handleTagReady,this),""!=this._crossOrigin&&(b.crossOrigin="Anonymous"),b.src=this.buildPath(this._item.src,this._item.values),this._rawResponse=this._response,this._response=b,!1;case createjs.LoadQueue.JAVASCRIPT:return b=document.createElement("script"),b.text=this._response,this._rawResponse=this._response,this._response=b,!0;case createjs.LoadQueue.CSS:var c=document.getElementsByTagName("head")[0];if(c.appendChild(b),b.styleSheet)b.styleSheet.cssText=this._response;else{var d=document.createTextNode(this._response);b.appendChild(d)}return this._rawResponse=this._response,this._response=b,!0;case createjs.LoadQueue.XML:var e=this._parseXML(this._response,"text/xml");return this._rawResponse=this._response,this._response=e,!0;case createjs.LoadQueue.SVG:var e=this._parseXML(this._response,"image/svg+xml");return this._rawResponse=this._response,null!=e.documentElement?(b.appendChild(e.documentElement),this._response=b):this._response=e,!0;case createjs.LoadQueue.JSON:case createjs.LoadQueue.MANIFEST:var f={};try{f=JSON.parse(this._response)}catch(g){f=g}return this._rawResponse=this._response,this._response=f,!0}return!0},b._parseXML=function(a,b){var c=null;try{if(window.DOMParser){var d=new DOMParser;c=d.parseFromString(a,b)}else c=new ActiveXObject("Microsoft.XMLDOM"),c.async=!1,c.loadXML(a)}catch(e){}return c},b._handleTagReady=function(){this._sendComplete()},b.toString=function(){return"[PreloadJS XHRLoader]"},createjs.XHRLoader=a}(),"object"!=typeof JSON&&(JSON={}),function(){"use strict";function f(a){return 10>a?"0"+a:a}function quote(a){return escapable.lastIndex=0,escapable.test(a)?'"'+a.replace(escapable,function(a){var b=meta[a];return"string"==typeof b?b:"\\u"+("0000"+a.charCodeAt(0).toString(16)).slice(-4)})+'"':'"'+a+'"'}function str(a,b){var c,d,e,f,g,h=gap,i=b[a];switch(i&&"object"==typeof i&&"function"==typeof i.toJSON&&(i=i.toJSON(a)),"function"==typeof rep&&(i=rep.call(b,a,i)),typeof i){case"string":return quote(i);case"number":return isFinite(i)?String(i):"null";case"boolean":case"null":return String(i);case"object":if(!i)return"null";if(gap+=indent,g=[],"[object Array]"===Object.prototype.toString.apply(i)){for(f=i.length,c=0;f>c;c+=1)g[c]=str(c,i)||"null";return e=0===g.length?"[]":gap?"[\n"+gap+g.join(",\n"+gap)+"\n"+h+"]":"["+g.join(",")+"]",gap=h,e}if(rep&&"object"==typeof rep)for(f=rep.length,c=0;f>c;c+=1)"string"==typeof rep[c]&&(d=rep[c],e=str(d,i),e&&g.push(quote(d)+(gap?": ":":")+e));else for(d in i)Object.prototype.hasOwnProperty.call(i,d)&&(e=str(d,i),e&&g.push(quote(d)+(gap?": ":":")+e));return e=0===g.length?"{}":gap?"{\n"+gap+g.join(",\n"+gap)+"\n"+h+"}":"{"+g.join(",")+"}",gap=h,e}}"function"!=typeof Date.prototype.toJSON&&(Date.prototype.toJSON=function(){return isFinite(this.valueOf())?this.getUTCFullYear()+"-"+f(this.getUTCMonth()+1)+"-"+f(this.getUTCDate())+"T"+f(this.getUTCHours())+":"+f(this.getUTCMinutes())+":"+f(this.getUTCSeconds())+"Z":null},String.prototype.toJSON=Number.prototype.toJSON=Boolean.prototype.toJSON=function(){return this.valueOf()});var cx=/[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,escapable=/[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,gap,indent,meta={"\b":"\\b","	":"\\t","\n":"\\n","\f":"\\f","\r":"\\r",'"':'\\"',"\\":"\\\\"},rep;"function"!=typeof JSON.stringify&&(JSON.stringify=function(a,b,c){var d;if(gap="",indent="","number"==typeof c)for(d=0;c>d;d+=1)indent+=" ";else"string"==typeof c&&(indent=c);if(rep=b,b&&"function"!=typeof b&&("object"!=typeof b||"number"!=typeof b.length))throw new Error("JSON.stringify");return str("",{"":a})}),"function"!=typeof JSON.parse&&(JSON.parse=function(text,reviver){function walk(a,b){var c,d,e=a[b];if(e&&"object"==typeof e)for(c in e)Object.prototype.hasOwnProperty.call(e,c)&&(d=walk(e,c),void 0!==d?e[c]=d:delete e[c]);return reviver.call(a,b,e)}var j;if(text=String(text),cx.lastIndex=0,cx.test(text)&&(text=text.replace(cx,function(a){return"\\u"+("0000"+a.charCodeAt(0).toString(16)).slice(-4)})),/^[\],:{}\s]*$/.test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,"@").replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,"]").replace(/(?:^|:|,)(?:\s*\[)+/g,"")))return j=eval("("+text+")"),"function"==typeof reviver?walk({"":j},""):j;throw new SyntaxError("JSON.parse")})}();module.exports=window.createjs;


/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Viewport=function(_Component){_inherits(Viewport,_Component);function Viewport(props){_classCallCheck(this,Viewport);var _this=_possibleConstructorReturn(this,(Viewport.__proto__||Object.getPrototypeOf(Viewport)).call(this,props));_this.loading=false;_this.init(props);return _this;}_createClass(Viewport,[{key:'resetLayers',value:function resetLayers(){this.layers=[];}},{key:'setLoading',value:function setLoading(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;this.loading=state;}},{key:'preloadLayers',value:function preloadLayers(assets,callback){var _this2=this;var counter=0;this.setLoading();this.resetLayers();assets.forEach(function(a){var img=new window.Image();img.onload=function(){counter++;if(counter===assets.length){_this2.setLoading(false);callback();}};img.onerror=function(){return _this2.setLoading(false);};img.src=a;_this2.layers.push(img);});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(props){this.init(props);}},{key:'init',value:function init(props){var layers=props.children.filter(function(layer){return layer!==null;}).map(function(layer){return layer.props.asset;});this.preloadLayers(layers,this.drawCanvas.bind(this));}},{key:'drawCanvas',value:function drawCanvas(){var _this3=this;var viewport=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.refs.visualizeViewport);var ctx=viewport.getContext('2d');// Delete everything before drawing again
ctx.clearRect(0,0,this.props.width,this.props.height);this.layers.forEach(function(layer){ctx.drawImage(layer,0,0,_this3.props.width,_this3.props.height);});}},{key:'render',value:function render(){// let css = {}
// let classes = ['visualize-viewport']
//
// if (typeof this.props.dimensions === 'object') {
//   const dimensions = Object.assign({
//     width: 720,
//     height: 480,
//     unit: 'px'
//   }, this.props.dimensions)
//   css.width = dimensions.width + dimensions.unit
//   css.height = dimensions.height + dimensions.unit
// } else {
//   classes.push('visualize-viewport-full-scale')
// }
//
// // Adding aspect ratio to the viewport
// let aspectRatio = 100 // default 100% is a square
// if (typeof this.props.aspectRatio !== 'undefined') {
//   switch (typeof this.props.aspectRatio) {
//     case 'number' :
//       aspectRatio = this.props.aspectRatio
//       break
//     case 'string' :
//       const ratio = this.props.aspectRatio.match(/([0-9]+)[:/-]([0-9]+)/)
//       aspectRatio = ratio[2] / ratio[1] * 100
//       break
//     default :
//       break
//   }
//   // css.width = ((aspectRatio >= 100) ? aspectRatio : 100) + 'vw'
//   // css.height = ((aspectRatio < 100) ? aspectRatio : 100) + 'vw'
//   css.paddingTop = aspectRatio + '%'
// }
return(// <div className={classes.join(' ')} style={css}>
//   {this.props.children}
// </div>
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'visualize-viewport'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas',{id:'visualizeViewport',ref:'visualizeViewport',className:'visualize-viewport',width:this.props.width,height:this.props.height}),this.props.children.filter(function(child){return child!==null;}).filter(function(child){return child.type==='img';})));}}],[{key:'renderCanvas',value:function renderCanvas(){return document.getElementById('visualizeViewport').toDataURL();}}]);return Viewport;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Viewport.propTypes={children:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node};/* harmony default export */ __webpack_exports__["a"] = (Viewport);

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Store from 'store'
var Layer=function(_Component){_inherits(Layer,_Component);function Layer(){_classCallCheck(this,Layer);return _possibleConstructorReturn(this,(Layer.__proto__||Object.getPrototypeOf(Layer)).apply(this,arguments));}_createClass(Layer,[{key:'render',value:function render(){var style={zIndex:this.props.zIndex||'0'};switch(this.props.type){case'img':style.backgroundImage='url('+this.props.asset+')';break;case'placeholder':default:style.backgroundImage='url(http://via.placeholder.com/1280x720?'+'text='+this.props.asset.replace(' ','+')+')';break;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:style,className:'visualize-layer'},this.props.children);}}]);return Layer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Layer);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SideBar_css__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SideBar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SideBar_css__);
// import SimpleScrollbar from '../lib/simple-scrollbar/simple-scrollbar'
// import '../lib/simple-scrollbar/simple-scrollbar.css'
var SideBar=function SideBar(_ref){var className=_ref.className,children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:['configurator-sidebar',className].join(' ')},children);};/* harmony default export */ __webpack_exports__["a"] = (SideBar);

/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ColorPicker__ = __webpack_require__(85);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ColorMenu=function(_Component){_inherits(ColorMenu,_Component);function ColorMenu(props){_classCallCheck(this,ColorMenu);var _this=_possibleConstructorReturn(this,(ColorMenu.__proto__||Object.getPrototypeOf(ColorMenu)).call(this,props));_this.state={ornamentBackground:'black'};_this.setOrnamentBg=_this.setOrnamentBg.bind(_this);return _this;}_createClass(ColorMenu,[{key:'setOrnamentBg',value:function setOrnamentBg(event){var _this2=this;var ornamentBg=event.target.value;this.setState({ornamentBackground:ornamentBg},// Simulate a click to update the handle
function(){return _this2.props.onClick({target:{value:JSON.stringify(_this2.props.colors.find(function(c){return c.ornament===_this2.props.color.ornament&&c.ornament_color===_this2.props.color.ornament_color&&c.color===ornamentBg;}))}});});}},{key:'render',value:function render(){var _this3=this;var colorComps=[];var ornamentBackgroundSelector=void 0;switch(this.props.colors[0].color_type){case'decor':case'custom':// First of all : black or white ?
ornamentBackgroundSelector=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["a" /* I18n */],{key:'ornamentBgSelector'},function(t,_ref){var i18n=_ref.i18n;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'configurator-button-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Button__["a" /* default */],{className:_this3.state.ornamentBackground==='black'?'active':'',onClick:_this3.setOrnamentBg,value:'black'},t('configurator.color.black')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Button__["a" /* default */],{className:_this3.state.ornamentBackground==='white'?'active':'',onClick:_this3.setOrnamentBg,value:'white'},t('configurator.color.white')));});// Then the colors
Array.from(new Set(this.props.colors.map(function(col){return col.ornament_category;}))).forEach(function(category){// Category title
if(_this3.props.colors[0].color_type==='decor'){colorComps.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{key:category},category));}// Actual colors (without declinable versions)
colorComps.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ColorPicker__["a" /* default */],{key:category+'-picker',colors:_this3.props.colors.filter(function(col){return col.ornament_category===category&&col.ornament_color===null&&col.color===_this3.state.ornamentBackground;}).map(function(col){if(typeof col.customDesign==='undefined'){// Getting ornament texture for each ornament
var asset=__webpack_require__(200)("./"+_this3.props.colors[0].color_type+'s/'+col.ornament+'.png');col.css={backgroundColor:'#333',backgroundImage:'url(\''+asset+'\')',backgroundSize:'cover'// If ornament is declinable
};col.declinable=false;if(_this3.props.colors.find(function(c,i){return c.ornament===col.ornament&&c.ornament_color!==null;})){col.declinable=true;col.image_file=_this3.props.colors.find(function(c){return c.ornament===col.ornament&&c.ornament_color==='13'&&c.color===col.color;}).image_file;}}return col;}),activeLayer:_this3.props.color.image_file,onClick:_this3.props.onClick,hideLabel:_this3.props.colors[0].color_type==='custom'}));});// And the upload button
if(this.props.colors[0].color_type==='custom'){colorComps.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["a" /* I18n */],{key:'ornamentBgSelector'},function(t,_ref2){var i18n=_ref2.i18n;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'configurator-red-button',onClick:_this3.props.customize},t('configurator.createYourOwnButton'));}));}break;default:colorComps.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ColorPicker__["a" /* default */],{key:'single-color-picker',colors:this.props.colors.map(function(col){col.css={background:col.color_css};return col;}),activeLayer:this.props.color.image_file,onClick:this.props.onClick}));break;}return[ornamentBackgroundSelector,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'configurator-colors',key:'confColors'},colorComps)];}}]);return ColorMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ColorMenu);

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shallowEqual__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__I18n__ = __webpack_require__(84);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








function getDisplayName(component) {
  return component.displayName || component.name || 'Component';
}

function translate(namespaceArg) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


  return function Wrapper(WrappedComponent) {
    var Translate = function (_Component) {
      _inherits(Translate, _Component);

      function Translate(props, context) {
        _classCallCheck(this, Translate);

        var _this = _possibleConstructorReturn(this, (Translate.__proto__ || Object.getPrototypeOf(Translate)).call(this, props, context));

        _this.i18n = props.i18n || options.i18n || context.i18n || Object(__WEBPACK_IMPORTED_MODULE_4__context__["b" /* getI18n */])();
        _this.namespaces = typeof namespaceArg === 'function' ? namespaceArg(props) : namespaceArg || _this.i18n.options && _this.i18n.options.defaultNS;
        if (typeof _this.namespaces === 'string') _this.namespaces = [_this.namespaces];

        var i18nOptions = _this.i18n && _this.i18n.options && _this.i18n.options.react || {};
        _this.options = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_4__context__["a" /* getDefaults */])(), i18nOptions, options);

        _this.getWrappedInstance = _this.getWrappedInstance.bind(_this);
        return _this;
      }

      _createClass(Translate, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
          if (!this.options.usePureComponent) {
            return true;
          }

          return !Object(__WEBPACK_IMPORTED_MODULE_3__shallowEqual__["a" /* default */])(this.props, nextProps);
        }
      }, {
        key: 'getWrappedInstance',
        value: function getWrappedInstance() {
          if (!this.options.withRef) {
            // eslint-disable-next-line no-console
            console.error('To access the wrapped instance, you need to specify ' + '{ withRef: true } as the second argument of the translate() call.');
          }

          /* eslint react/no-string-refs: 1 */
          return this.wrappedInstance;
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          var extraProps = {};

          if (this.options.withRef) {
            extraProps.ref = function (c) {
              _this2.wrappedInstance = c;
            };
          }

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__I18n__["a" /* default */], _extends({ ns: this.namespaces }, this.options, this.props, { i18n: this.i18n }), function (t, _ref) {
            var ready = _ref.ready,
                context = _objectWithoutProperties(_ref, ['ready']);

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({
              tReady: ready
            }, _this2.props, extraProps, context));
          });
        }
      }]);

      return Translate;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Translate.WrappedComponent = WrappedComponent;

    Translate.contextTypes = {
      i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
    };

    Translate.displayName = 'Translate(' + getDisplayName(WrappedComponent) + ')';

    Translate.namespaces = namespaceArg;

    return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(Translate, WrappedComponent);
  };
}

translate.setDefaults = __WEBPACK_IMPORTED_MODULE_4__context__["d" /* setDefaults */];

translate.setI18n = __WEBPACK_IMPORTED_MODULE_4__context__["e" /* setI18n */];

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule shallowEqual
 * @typechecks
 * 
 */

/* eslint-disable no-self-compare */

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  }
  // Step 6.a: NaN == NaN
  return x !== x && y !== y;
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Interpolate = function (_Component) {
  _inherits(Interpolate, _Component);

  function Interpolate(props, context) {
    _classCallCheck(this, Interpolate);

    var _this = _possibleConstructorReturn(this, (Interpolate.__proto__ || Object.getPrototypeOf(Interpolate)).call(this, props, context));

    _this.i18n = props.i18n || context.i18n;
    _this.t = props.t || context.t;
    return _this;
  }

  _createClass(Interpolate, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var parent = this.props.parent || 'span';
      var REGEXP = this.props.regexp || this.i18n.services.interpolator.regexp;
      var _props = this.props,
          className = _props.className,
          style = _props.style;

      // Set to true if you want to use raw HTML in translation values
      // See https://github.com/i18next/react-i18next/issues/189

      var useDangerouslySetInnerHTML = this.props.useDangerouslySetInnerHTML || false;
      var dangerouslySetInnerHTMLPartElement = this.props.dangerouslySetInnerHTMLPartElement || 'span';

      var tOpts = _extends({}, this.props.options, { interpolation: { prefix: '#$?', suffix: '?$#' } });
      var format = this.t(this.props.i18nKey, tOpts);

      if (!format || typeof format !== 'string') return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('noscript', null);

      var children = [];

      var handleFormat = function handleFormat(key, props) {
        if (key.indexOf(_this2.i18n.options.interpolation.formatSeparator) < 0) {
          if (props[key] === undefined) _this2.i18n.services.logger.warn('interpolator: missed to pass in variable ' + key + ' for interpolating ' + format);
          return props[key];
        }

        var p = key.split(_this2.i18n.options.interpolation.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this2.i18n.options.interpolation.formatSeparator).trim();

        if (props[k] === undefined) _this2.i18n.services.logger.warn('interpolator: missed to pass in variable ' + k + ' for interpolating ' + format);
        return _this2.i18n.options.interpolation.format(props[k], f, _this2.i18n.language);
      };

      format.split(REGEXP).reduce(function (memo, match, index) {
        var child = void 0;

        if (index % 2 === 0) {
          if (match.length === 0) return memo;
          if (useDangerouslySetInnerHTML) {
            child = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(dangerouslySetInnerHTMLPartElement, { dangerouslySetInnerHTML: { __html: match } });
          } else {
            child = match;
          }
        } else {
          child = handleFormat(match, _this2.props);
        }

        memo.push(child);
        return memo;
      }, children);

      var additionalProps = {};
      if (this.i18n.options.react && this.i18n.options.react.exposeNamespace) {
        var ns = typeof this.t.ns === 'string' ? this.t.ns : this.t.ns[0];
        if (this.props.i18nKey && this.i18n.options.nsSeparator && this.props.i18nKey.indexOf(this.i18n.options.nsSeparator) > -1) {
          var parts = this.props.i18nKey.split(this.i18n.options.nsSeparator);
          ns = parts[0];
        }
        if (this.t.ns) additionalProps['data-i18next-options'] = JSON.stringify({ ns: ns });
      }

      if (className) additionalProps.className = className;
      if (style) additionalProps.style = style;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement.apply(this, [parent, additionalProps].concat(children));
    }
  }]);

  return Interpolate;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Interpolate.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

Interpolate.defaultProps = {
  className: ''
};

Interpolate.contextTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* unused harmony default export */ var _unused_webpack_default_export = (Interpolate);

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html_parse_stringify2__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html_parse_stringify2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_html_parse_stringify2__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





function hasChildren(node) {
  return node && (node.children || node.props && node.props.children);
}

function getChildren(node) {
  return node && node.children ? node.children : node.props && node.props.children;
}

function nodesToString(mem, children, index) {
  if (!children) return '';
  if (Object.prototype.toString.call(children) !== '[object Array]') children = [children];

  children.forEach(function (child, i) {
    // const isElement = React.isValidElement(child);
    // const elementKey = `${index !== 0 ? index + '-' : ''}${i}:${typeof child.type === 'function' ? child.type.name : child.type || 'var'}`;
    var elementKey = '' + i;

    if (typeof child === 'string') {
      mem = '' + mem + child;
    } else if (hasChildren(child)) {
      mem = mem + '<' + elementKey + '>' + nodesToString('', getChildren(child), i + 1) + '</' + elementKey + '>';
    } else if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      mem = mem + '<' + elementKey + '></' + elementKey + '>';
    } else if ((typeof child === 'undefined' ? 'undefined' : _typeof(child)) === 'object') {
      var clone = _extends({}, child);
      var format = clone.format;
      delete clone.format;

      var keys = Object.keys(clone);
      if (format && keys.length === 1) {
        mem = mem + '<' + elementKey + '>{{' + keys[0] + ', ' + format + '}}</' + elementKey + '>';
      } else if (keys.length === 1) {
        mem = mem + '<' + elementKey + '>{{' + keys[0] + '}}</' + elementKey + '>';
      } else if (console && console.warn) {
        // not a valid interpolation object (can only contain one value plus format)
        console.warn('react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.', child);
      }
    } else if (console && console.warn) {
      console.warn('react-i18next: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.', child);
    }
  });

  return mem;
}

function renderNodes(children, targetString, i18n) {
  if (targetString === "") return [];
  if (!children) return [targetString];

  // parse ast from string with additional wrapper tag
  // -> avoids issues in parser removing prepending text nodes
  var ast = __WEBPACK_IMPORTED_MODULE_2_html_parse_stringify2___default.a.parse('<0>' + targetString + '</0>');

  function mapAST(reactNodes, astNodes) {
    if (Object.prototype.toString.call(reactNodes) !== '[object Array]') reactNodes = [reactNodes];
    if (Object.prototype.toString.call(astNodes) !== '[object Array]') astNodes = [astNodes];

    return astNodes.reduce(function (mem, node, i) {
      if (node.type === 'tag') {
        var child = reactNodes[parseInt(node.name, 10)] || {};
        var isElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child);

        if (typeof child === 'string') {
          mem.push(child);
        } else if (hasChildren(child)) {
          var inner = mapAST(getChildren(child), node.children);
          if (child.dummy) child.children = inner; // needed on preact!
          mem.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, _extends({}, child.props, { key: i }), inner));
        } else if ((typeof child === 'undefined' ? 'undefined' : _typeof(child)) === 'object' && !isElement) {
          var interpolated = i18n.services.interpolator.interpolate(node.children[0].content, child, i18n.language);
          mem.push(interpolated);
        } else {
          mem.push(child);
        }
      } else if (node.type === 'text') {
        mem.push(node.content);
      }
      return mem;
    }, []);
  }

  // call mapAST with having react nodes nested into additional node like
  // we did for the string ast from translation
  // return the children of that extra node to get expected result
  var result = mapAST([{ dummy: true, children: children }], ast);
  return getChildren(result[0]);
}

var Trans = function (_React$Component) {
  _inherits(Trans, _React$Component);

  function Trans() {
    _classCallCheck(this, Trans);

    return _possibleConstructorReturn(this, (Trans.__proto__ || Object.getPrototypeOf(Trans)).apply(this, arguments));
  }

  _createClass(Trans, [{
    key: 'render',
    value: function render() {
      var contextAndProps = _extends({ i18n: this.context.i18n, t: this.context.t }, this.props);

      var children = contextAndProps.children,
          count = contextAndProps.count,
          parent = contextAndProps.parent,
          i18nKey = contextAndProps.i18nKey,
          tOptions = contextAndProps.tOptions,
          namespace = contextAndProps.ns,
          i18n = contextAndProps.i18n,
          tFromContextAndProps = contextAndProps.t,
          additionalProps = _objectWithoutProperties(contextAndProps, ['children', 'count', 'parent', 'i18nKey', 'tOptions', 'ns', 'i18n', 't']);

      var t = tFromContextAndProps || i18n.t.bind(i18n);

      var reactI18nextOptions = i18n.options && i18n.options.react || {};
      var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;

      var defaultValue = nodesToString('', children, 0);
      var hashTransKey = reactI18nextOptions.hashTransKey;
      var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
      var translation = key ? t(key, _extends({}, tOptions, { interpolation: { prefix: '#$?', suffix: '?$#' }, defaultValue: defaultValue, count: count, ns: namespace })) : defaultValue;

      if (reactI18nextOptions.exposeNamespace) {
        var ns = typeof t.ns === 'string' ? t.ns : t.ns[0];
        if (i18nKey && i18n.options && i18n.options.nsSeparator && i18nKey.indexOf(i18n.options.nsSeparator) > -1) {
          var parts = i18nKey.split(i18n.options.nsSeparator);
          ns = parts[0];
        }
        if (t.ns) additionalProps['data-i18next-options'] = JSON.stringify({ ns: ns });
      }

      if (!useAsParent) return renderNodes(children, translation, i18n);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(useAsParent, additionalProps, renderNodes(children, translation, i18n));
    }
  }]);

  return Trans;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Trans);


Trans.propTypes = {
  count: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  parent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  i18nKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

// Trans.defaultProps = {
//   parent: 'div'
// };

Trans.contextTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  t: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
    parse: __webpack_require__(194),
    stringify: __webpack_require__(197)
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

/*jshint -W030 */
var tagRE = /(?:<!--[\S\s]*?-->|<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>)/g;
var parseTag = __webpack_require__(195);
// re-used obj for quick lookups of components
var empty = Object.create ? Object.create(null) : {};
// common logic for pushing a child node onto a list
function pushTextNode(list, html, level, start, ignoreWhitespace) {
    // calculate correct end of the content slice in case there's
    // no tag after the text node.
    var end = html.indexOf('<', start);
    var content = html.slice(start, end === -1 ? undefined : end);
    // if a node is nothing but whitespace, collapse it as the spec states:
    // https://www.w3.org/TR/html4/struct/text.html#h-9.1
    if (/^\s*$/.test(content)) {
        content = ' ';
    }
    // don't add whitespace-only text nodes if they would be trailing text nodes
    // or if they would be leading whitespace-only text nodes:
    //  * end > -1 indicates this is not a trailing text node
    //  * leading node is when level is -1 and list has length 0
    if ((!ignoreWhitespace && end > -1 && level + list.length >= 0) || content !== ' ') {
        list.push({
            type: 'text',
            content: content
        });
    }
}

module.exports = function parse(html, options) {
    options || (options = {});
    options.components || (options.components = empty);
    var result = [];
    var current;
    var level = -1;
    var arr = [];
    var byTag = {};
    var inComponent = false;

    html.replace(tagRE, function (tag, index) {
        if (inComponent) {
            if (tag !== ('</' + current.name + '>')) {
                return;
            } else {
                inComponent = false;
            }
        }

        var isOpen = tag.charAt(1) !== '/';
        var isComment = tag.indexOf('<!--') === 0;
        var start = index + tag.length;
        var nextChar = html.charAt(start);
        var parent;

        if (isOpen && !isComment) {
            level++;

            current = parseTag(tag);
            if (current.type === 'tag' && options.components[current.name]) {
                current.type = 'component';
                inComponent = true;
            }

            if (!current.voidElement && !inComponent && nextChar && nextChar !== '<') {
                pushTextNode(current.children, html, level, start, options.ignoreWhitespace);
            }

            byTag[current.tagName] = current;

            // if we're at root, push new base node
            if (level === 0) {
                result.push(current);
            }

            parent = arr[level - 1];

            if (parent) {
                parent.children.push(current);
            }

            arr[level] = current;
        }

        if (isComment || !isOpen || current.voidElement) {
            if (!isComment) {
                level--;
            }
            if (!inComponent && nextChar !== '<' && nextChar) {
                // trailing text node
                // if we're at the root, push a base text node. otherwise add as
                // a child to the current node.
                parent = level === -1 ? result : arr[level].children;
                pushTextNode(parent, html, level, start, options.ignoreWhitespace);
            }
        }
    });

    // If the "html" passed isn't actually html, add it as a text node.
    if (!result.length && html.length) {
        pushTextNode(result, html, 0, 0, options.ignoreWhitespace);
    }

    return result;
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var attrRE = /([\w-]+)|=|(['"])([.\s\S]*?)\2/g;
var voidElements = __webpack_require__(196);

module.exports = function (tag) {
    var i = 0;
    var key;
    var expectingValueAfterEquals = true;
    var res = {
        type: 'tag',
        name: '',
        voidElement: false,
        attrs: {},
        children: []
    };

    tag.replace(attrRE, function (match) {
        if (match === '=') {
            expectingValueAfterEquals = true;
            i++;
            return;
        }

        if (!expectingValueAfterEquals) {
            if (key) {
                res.attrs[key] = key; // boolean attribute
            }
            key=match;
        } else {
            if (i === 0) {
                if (voidElements[match] || tag.charAt(tag.length - 2) === '/') {
                    res.voidElement = true;
                }
                res.name = match;
            } else {
                res.attrs[key] = match.replace(/^['"]|['"]$/g, '');
                key=undefined;
            }
        }
        i++;
        expectingValueAfterEquals = false;
    });

    return res;
};


/***/ }),
/* 196 */
/***/ (function(module, exports) {

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */

module.exports = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "keygen": true,
  "link": true,
  "menuitem": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};


/***/ }),
/* 197 */
/***/ (function(module, exports) {

function attrString(attrs) {
    var buff = [];
    for (var key in attrs) {
        buff.push(key + '="' + attrs[key] + '"');
    }
    if (!buff.length) {
        return '';
    }
    return ' ' + buff.join(' ');
}

function stringify(buff, doc) {
    switch (doc.type) {
    case 'text':
        return buff + doc.content;
    case 'tag':
        buff += '<' + doc.name + (doc.attrs ? attrString(doc.attrs) : '') + (doc.voidElement ? '/>' : '>');
        if (doc.voidElement) {
            return buff;
        }
        return buff + doc.children.reduce(stringify, '') + '</' + doc.name + '>';
    }
}

module.exports = function (doc) {
    return doc.reduce(function (token, rootEl) {
        return token + stringify('', rootEl);
    }, '');
};


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var I18nextProvider = function (_Component) {
  _inherits(I18nextProvider, _Component);

  function I18nextProvider(props, context) {
    _classCallCheck(this, I18nextProvider);

    var _this = _possibleConstructorReturn(this, (I18nextProvider.__proto__ || Object.getPrototypeOf(I18nextProvider)).call(this, props, context));

    _this.i18n = props.i18n;
    if (props.initialI18nStore) {
      _this.i18n.services.resourceStore.data = props.initialI18nStore;
      _this.i18n.options.isInitialSSR = true; // if set will be deleted on first render in translate hoc
    }
    if (props.initialLanguage) {
      _this.i18n.changeLanguage(props.initialLanguage);
    }
    return _this;
  }

  _createClass(I18nextProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { i18n: this.i18n };
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.i18n !== nextProps.i18n) {
        throw new Error('[react-i18next][I18nextProvider]does not support changing the i18n object.');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(children);
    }
  }]);

  return I18nextProvider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

I18nextProvider.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
};

I18nextProvider.childContextTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

/* unused harmony default export */ var _unused_webpack_default_export = (I18nextProvider);

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// shim object entries
if (!Object.entries) Object.entries = function (obj) {
  var ownProps = Object.keys(obj),
      i = ownProps.length,
      resArray = new Array(i); // preallocate the Array
  while (i--) {
    resArray[i] = [ownProps[i], obj[ownProps[i]]];
  }return resArray;
};

// Borrowed from https://github.com/Rezonans/redux-async-connect/blob/master/modules/ReduxAsyncConnect.js#L16
function eachComponents(components, iterator) {
  for (var i = 0, l = components.length; i < l; i++) {
    // eslint-disable-line id-length
    if (_typeof(components[i]) === 'object') {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = Object.entries(components[i])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          iterator(value, i, key);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } else {
      iterator(components[i], i);
    }
  }
}

function filterAndFlattenComponents(components) {
  var flattened = [];
  eachComponents(components, function (Component) {
    if (Component && Component.namespaces) {

      Component.namespaces.forEach(function (namespace) {
        if (flattened.indexOf(namespace) === -1) {
          flattened.push(namespace);
        }
      });
    }
  });
  return flattened;
}

function loadNamespaces(_ref) {
  var components = _ref.components,
      i18n = _ref.i18n;

  var allNamespaces = filterAndFlattenComponents(components);

  return new Promise(function (resolve) {
    i18n.loadNamespaces(allNamespaces, resolve);
  });
}

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./customs/C01.png": 201,
	"./customs/C02.png": 202,
	"./customs/C03.png": 203,
	"./customs/C04.png": 204,
	"./customs/C05.png": 205,
	"./decors/C01.png": 206,
	"./decors/C02.png": 207,
	"./decors/C03.png": 208,
	"./decors/C04.png": 209,
	"./decors/C05.png": 210,
	"./decors/C06.png": 211,
	"./decors/C07.png": 212,
	"./decors/C08.png": 213,
	"./decors/G01.png": 214,
	"./decors/G02.png": 215,
	"./decors/G03.png": 216,
	"./decors/G04.png": 217,
	"./decors/G05.png": 218,
	"./decors/G06.png": 219,
	"./decors/G07.png": 220,
	"./decors/G08.png": 221,
	"./decors/G09.png": 222,
	"./decors/G10.png": 223,
	"./decors/G11.png": 224,
	"./decors/M01.png": 225,
	"./decors/M02.png": 226,
	"./decors/M03.png": 227,
	"./decors/M04.png": 228,
	"./decors/M05.png": 229,
	"./decors/M06.png": 230,
	"./decors/M07.png": 231,
	"./decors/M08.png": 232,
	"./decors/M09.png": 233,
	"./decors/M10.png": 234,
	"./decors/M11.png": 235,
	"./decors/N01.png": 236,
	"./decors/N02.png": 237,
	"./decors/N03.png": 238,
	"./decors/N04.png": 239,
	"./decors/N05.png": 240,
	"./decors/N06.png": 241,
	"./decors/N07.png": 242,
	"./decors/N08.png": 243,
	"./handles/H48010.png": 86,
	"./handles/H48011.png": 87,
	"./handles/H48012.png": 88,
	"./handles/H48013.png": 89,
	"./handles/H48103.png": 90,
	"./handles/H48104.png": 91,
	"./handles/H48106.png": 92,
	"./handles/H48107.png": 93
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 200;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/C01.c8a2b2bb.png";

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/C02.56917f14.png";

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/C03.58673f9f.png";

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/C04.c67d47a2.png";

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/C05.96ceb38d.png";

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/C01.74012e85.png";

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/C02.00613dbe.png";

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/C03.4874d6d5.png";

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/C04.dd15b820.png";

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/C05.5d3d6856.png";

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/C06.41763310.png";

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/C07.7a3490ed.png";

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/C08.38e7a4df.png";

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/G01.e3838a34.png";

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/G02.733cb728.png";

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/G03.33e95a67.png";

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/G04.a39c75b1.png";

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/G05.b6989f46.png";

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/G06.6082391e.png";

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/G07.0bb6088d.png";

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/G08.b2420940.png";

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/G09.a941dfe2.png";

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/G10.430bc60e.png";

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/G11.73e08988.png";

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/M01.9e014a85.png";

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/M02.ddded354.png";

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/M03.f24234ab.png";

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/M04.93e39d94.png";

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/M05.009afbeb.png";

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/M06.0f9edabf.png";

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/M07.b7201c74.png";

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/M08.5848f197.png";

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/M09.e9991633.png";

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/M10.42303b4f.png";

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/M11.8a3cf021.png";

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/N01.c389ec33.png";

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/N02.0ee9fcc3.png";

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/N03.0d9b2d6a.png";

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/N04.aa02175d.png";

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/N05.d72c2e6b.png";

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/N06.e627c530.png";

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/N07.d43a899a.png";

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/N08.1aad4045.png";

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export changeLanguage */
/* unused harmony export cloneInstance */
/* unused harmony export createInstance */
/* unused harmony export dir */
/* unused harmony export exists */
/* unused harmony export getFixedT */
/* unused harmony export init */
/* unused harmony export loadLanguages */
/* unused harmony export loadNamespaces */
/* unused harmony export loadResources */
/* unused harmony export off */
/* unused harmony export on */
/* unused harmony export setDefaultNamespace */
/* unused harmony export t */
/* unused harmony export use */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18next_js__ = __webpack_require__(245);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);

var changeLanguage = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].changeLanguage.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var cloneInstance = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].cloneInstance.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var createInstance = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].createInstance.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var dir = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].dir.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var exists = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].exists.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var getFixedT = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].getFixedT.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var init = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].init.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadLanguages = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadLanguages.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadNamespaces = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadNamespaces.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var loadResources = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].loadResources.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var off = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].off.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var on = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].on.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var setDefaultNamespace = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].setDefaultNamespace.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var t = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].t.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);
var use = __WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */].use.bind(__WEBPACK_IMPORTED_MODULE_0__i18next_js__["a" /* default */]);

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResourceStore_js__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Translator_js__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LanguageUtils_js__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PluralResolver_js__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Interpolator_js__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BackendConnector_js__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__defaults_js__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__postProcessor_js__ = __webpack_require__(95);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }












function noop() {}

var I18n = function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);

  function I18n() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    _classCallCheck(this, I18n);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.options = Object(__WEBPACK_IMPORTED_MODULE_8__defaults_js__["b" /* transformOptions */])(options);
    _this.services = {};
    _this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */];
    _this.modules = { external: [] };

    if (callback && !_this.isInitialized && !options.isClone) {
      var _ret;

      // https://github.com/i18next/i18next/issues/879
      if (!_this.options.initImmediate) return _ret = _this.init(options, callback), _possibleConstructorReturn(_this, _ret);
      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }
    return _this;
  }

  I18n.prototype.init = function init() {
    var _this2 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    this.options = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_8__defaults_js__["a" /* get */])(), this.options, Object(__WEBPACK_IMPORTED_MODULE_8__defaults_js__["b" /* transformOptions */])(options));

    this.format = this.options.interpolation.format;
    if (!callback) callback = noop;

    function createClassOnDemand(ClassOrObject) {
      if (!ClassOrObject) return null;
      if (typeof ClassOrObject === 'function') return new ClassOrObject();
      return ClassOrObject;
    }

    // init services
    if (!this.options.isClone) {
      if (this.modules.logger) {
        __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].init(createClassOnDemand(this.modules.logger), this.options);
      } else {
        __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].init(null, this.options);
      }

      var lu = new __WEBPACK_IMPORTED_MODULE_4__LanguageUtils_js__["a" /* default */](this.options);
      this.store = new __WEBPACK_IMPORTED_MODULE_2__ResourceStore_js__["a" /* default */](this.options.resources, this.options);

      var s = this.services;
      s.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */];
      s.resourceStore = this.store;
      s.languageUtils = lu;
      s.pluralResolver = new __WEBPACK_IMPORTED_MODULE_5__PluralResolver_js__["a" /* default */](lu, { prepend: this.options.pluralSeparator, compatibilityJSON: this.options.compatibilityJSON, simplifyPluralSuffix: this.options.simplifyPluralSuffix });
      s.interpolator = new __WEBPACK_IMPORTED_MODULE_6__Interpolator_js__["a" /* default */](this.options);

      s.backendConnector = new __WEBPACK_IMPORTED_MODULE_7__BackendConnector_js__["a" /* default */](createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
      // pipe events from backendConnector
      s.backendConnector.on('*', function (event) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      if (this.modules.languageDetector) {
        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
        s.languageDetector.init(s, this.options.detection, this.options);
      }

      if (this.modules.i18nFormat) {
        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
        if (s.i18nFormat.init) s.i18nFormat.init(this);
      }

      this.translator = new __WEBPACK_IMPORTED_MODULE_3__Translator_js__["a" /* default */](this.services, this.options);
      // pipe events from translator
      this.translator.on('*', function (event) {
        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      this.modules.external.forEach(function (m) {
        if (m.init) m.init(_this2);
      });
    }

    // append api
    var storeApi = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle'];
    storeApi.forEach(function (fcName) {
      _this2[fcName] = function () {
        var _store;

        return (_store = _this2.store)[fcName].apply(_store, arguments);
      };
    });

    var load = function load() {
      _this2.changeLanguage(_this2.options.lng, function (err, t) {
        _this2.isInitialized = true;
        _this2.logger.log('initialized', _this2.options);
        _this2.emit('initialized', _this2.options);

        callback(err, t);
      });
    };

    if (this.options.resources || !this.options.initImmediate) {
      load();
    } else {
      setTimeout(load, 0);
    }

    return this;
  };

  /* eslint consistent-return: 0 */


  I18n.prototype.loadResources = function loadResources() {
    var _this3 = this;

    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

    if (!this.options.resources) {
      if (this.language && this.language.toLowerCase() === 'cimode') return callback(); // avoid loading resources for cimode

      var toLoad = [];

      var append = function append(lng) {
        if (!lng) return;
        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
        lngs.forEach(function (l) {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };

      if (!this.language) {
        // at least load fallbacks in this case
        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        fallbacks.forEach(function (l) {
          return append(l);
        });
      } else {
        append(this.language);
      }

      if (this.options.preload) {
        this.options.preload.forEach(function (l) {
          return append(l);
        });
      }

      this.services.backendConnector.load(toLoad, this.options.ns, callback);
    } else {
      callback(null);
    }
  };

  I18n.prototype.reloadResources = function reloadResources(lngs, ns) {
    if (!lngs) lngs = this.languages;
    if (!ns) ns = this.options.ns;
    this.services.backendConnector.reload(lngs, ns);
  };

  I18n.prototype.use = function use(module) {
    if (module.type === 'backend') {
      this.modules.backend = module;
    }

    if (module.type === 'logger' || module.log && module.warn && module.error) {
      this.modules.logger = module;
    }

    if (module.type === 'languageDetector') {
      this.modules.languageDetector = module;
    }

    if (module.type === 'i18nFormat') {
      this.modules.i18nFormat = module;
    }

    if (module.type === 'postProcessor') {
      __WEBPACK_IMPORTED_MODULE_9__postProcessor_js__["a" /* default */].addPostProcessor(module);
    }

    if (module.type === '3rdParty') {
      this.modules.external.push(module);
    }

    return this;
  };

  I18n.prototype.changeLanguage = function changeLanguage(lng, callback) {
    var _this4 = this;

    var done = function done(err, l) {
      _this4.translator.changeLanguage(l);

      if (l) {
        _this4.emit('languageChanged', l);
        _this4.logger.log('languageChanged', l);
      }

      if (callback) callback(err, function () {
        return _this4.t.apply(_this4, arguments);
      });
    };

    var setLng = function setLng(l) {
      if (l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        if (!_this4.translator.language) _this4.translator.changeLanguage(l);

        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
      }

      _this4.loadResources(function (err) {
        done(err, l);
      });
    };

    if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
      setLng(this.services.languageDetector.detect());
    } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
      this.services.languageDetector.detect(setLng);
    } else {
      setLng(lng);
    }
  };

  I18n.prototype.getFixedT = function getFixedT(lng, ns) {
    var _this5 = this;

    var fixedT = function fixedT(key, opts) {
      for (var _len3 = arguments.length, rest = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        rest[_key3 - 2] = arguments[_key3];
      }

      var options = _extends({}, opts);
      if ((typeof opts === 'undefined' ? 'undefined' : _typeof(opts)) !== 'object') {
        options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
      }

      options.lng = options.lng || fixedT.lng;
      options.lngs = options.lngs || fixedT.lngs;
      options.ns = options.ns || fixedT.ns;
      return _this5.t(key, options);
    };
    if (typeof lng === 'string') {
      fixedT.lng = lng;
    } else {
      fixedT.lngs = lng;
    }
    fixedT.ns = ns;
    return fixedT;
  };

  I18n.prototype.t = function t() {
    var _translator;

    return this.translator && (_translator = this.translator).translate.apply(_translator, arguments);
  };

  I18n.prototype.exists = function exists() {
    var _translator2;

    return this.translator && (_translator2 = this.translator).exists.apply(_translator2, arguments);
  };

  I18n.prototype.setDefaultNamespace = function setDefaultNamespace(ns) {
    this.options.defaultNS = ns;
  };

  I18n.prototype.loadNamespaces = function loadNamespaces(ns, callback) {
    var _this6 = this;

    if (!this.options.ns) return callback && callback();
    if (typeof ns === 'string') ns = [ns];

    ns.forEach(function (n) {
      if (_this6.options.ns.indexOf(n) < 0) _this6.options.ns.push(n);
    });

    this.loadResources(callback);
  };

  I18n.prototype.loadLanguages = function loadLanguages(lngs, callback) {
    if (typeof lngs === 'string') lngs = [lngs];
    var preloaded = this.options.preload || [];

    var newLngs = lngs.filter(function (lng) {
      return preloaded.indexOf(lng) < 0;
    });
    // Exit early if all given languages are already preloaded
    if (!newLngs.length) return callback();

    this.options.preload = preloaded.concat(newLngs);
    this.loadResources(callback);
  };

  I18n.prototype.dir = function dir(lng) {
    if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
    if (!lng) return 'rtl';

    var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];

    return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
  };

  /* eslint class-methods-use-this: 0 */


  I18n.prototype.createInstance = function createInstance() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    return new I18n(options, callback);
  };

  I18n.prototype.cloneInstance = function cloneInstance() {
    var _this7 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

    var mergedOptions = _extends({}, this.options, options, { isClone: true });
    var clone = new I18n(mergedOptions);
    var membersToCopy = ['store', 'services', 'language'];
    membersToCopy.forEach(function (m) {
      clone[m] = _this7[m];
    });
    clone.translator = new __WEBPACK_IMPORTED_MODULE_3__Translator_js__["a" /* default */](clone.services, clone.options);
    clone.translator.on('*', function (event) {
      for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      clone.emit.apply(clone, [event].concat(args));
    });
    clone.init(mergedOptions, callback);
    clone.translator.options = clone.options; // sync options

    return clone;
  };

  return I18n;
}(__WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new I18n());

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventEmitter_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_js__ = __webpack_require__(35);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }




var ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);

  function ResourceStore(data) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { ns: ['translation'], defaultNS: 'translation' };

    _classCallCheck(this, ResourceStore);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.data = data || {};
    _this.options = options;
    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }
    return _this;
  }

  ResourceStore.prototype.addNamespaces = function addNamespaces(ns) {
    if (this.options.ns.indexOf(ns) < 0) {
      this.options.ns.push(ns);
    }
  };

  ResourceStore.prototype.removeNamespaces = function removeNamespaces(ns) {
    var index = this.options.ns.indexOf(ns);
    if (index > -1) {
      this.options.ns.splice(index, 1);
    }
  };

  ResourceStore.prototype.getResource = function getResource(lng, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

    var path = [lng, ns];
    if (key && typeof key !== 'string') path = path.concat(key);
    if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
    }

    return __WEBPACK_IMPORTED_MODULE_1__utils_js__["d" /* getPath */](this.data, path);
  };

  ResourceStore.prototype.addResource = function addResource(lng, ns, key, value) {
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { silent: false };

    var keySeparator = this.options.keySeparator;
    if (keySeparator === undefined) keySeparator = '.';

    var path = [lng, ns];
    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      value = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    __WEBPACK_IMPORTED_MODULE_1__utils_js__["h" /* setPath */](this.data, path, value);

    if (!options.silent) this.emit('added', lng, ns, key, value);
  };

  ResourceStore.prototype.addResources = function addResources(lng, ns, resources) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { silent: false };

    /* eslint no-restricted-syntax: 0 */
    for (var m in resources) {
      if (typeof resources[m] === 'string') this.addResource(lng, ns, m, resources[m], { silent: true });
    }
    if (!options.silent) this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.addResourceBundle = function addResourceBundle(lng, ns, resources, deep, overwrite) {
    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : { silent: false };

    var path = [lng, ns];
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      deep = resources;
      resources = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    var pack = __WEBPACK_IMPORTED_MODULE_1__utils_js__["d" /* getPath */](this.data, path) || {};

    if (deep) {
      __WEBPACK_IMPORTED_MODULE_1__utils_js__["b" /* deepExtend */](pack, resources, overwrite);
    } else {
      pack = _extends({}, pack, resources);
    }

    __WEBPACK_IMPORTED_MODULE_1__utils_js__["h" /* setPath */](this.data, path, pack);

    if (!options.silent) this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.removeResourceBundle = function removeResourceBundle(lng, ns) {
    if (this.hasResourceBundle(lng, ns)) {
      delete this.data[lng][ns];
    }
    this.removeNamespaces(ns);

    this.emit('removed', lng, ns);
  };

  ResourceStore.prototype.hasResourceBundle = function hasResourceBundle(lng, ns) {
    return this.getResource(lng, ns) !== undefined;
  };

  ResourceStore.prototype.getResourceBundle = function getResourceBundle(lng, ns) {
    if (!ns) ns = this.options.defaultNS;

    // COMPATIBILITY: remove extend in v2.1.0
    if (this.options.compatibilityAPI === 'v1') return _extends({}, this.getResource(lng, ns));

    return this.getResource(lng, ns);
  };

  ResourceStore.prototype.toJSON = function toJSON() {
    return this.data;
  };

  return ResourceStore;
}(__WEBPACK_IMPORTED_MODULE_0__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ResourceStore);

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__postProcessor_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_js__ = __webpack_require__(35);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }






var Translator = function (_EventEmitter) {
  _inherits(Translator, _EventEmitter);

  function Translator(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Translator);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    __WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* copy */](['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat'], services, _this);

    _this.options = options;
    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('translator');
    return _this;
  }

  Translator.prototype.changeLanguage = function changeLanguage(lng) {
    if (lng) this.language = lng;
  };

  Translator.prototype.exists = function exists(key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { interpolation: {} };

    var resolved = this.resolve(key, options);
    return resolved && resolved.res !== undefined;
  };

  Translator.prototype.extractFromKey = function extractFromKey(key, options) {
    var nsSeparator = options.nsSeparator || this.options.nsSeparator;
    if (nsSeparator === undefined) nsSeparator = ':';

    var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

    var namespaces = options.ns || this.options.defaultNS;
    if (nsSeparator && key.indexOf(nsSeparator) > -1) {
      var parts = key.split(nsSeparator);
      if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
      key = parts.join(keySeparator);
    }
    if (typeof namespaces === 'string') namespaces = [namespaces];

    return {
      key: key,
      namespaces: namespaces
    };
  };

  Translator.prototype.translate = function translate(keys, options) {
    var _this2 = this;

    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object' && this.options.overloadTranslationOptionHandler) {
      /* eslint prefer-rest-params: 0 */
      options = this.options.overloadTranslationOptionHandler(arguments);
    }
    if (!options) options = {};

    // non valid keys handling
    if (keys === undefined || keys === null || keys === '') return '';
    if (typeof keys === 'number') keys = String(keys);
    if (typeof keys === 'string') keys = [keys];

    // separators
    var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

    // get namespace(s)

    var _extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
        key = _extractFromKey.key,
        namespaces = _extractFromKey.namespaces;

    var namespace = namespaces[namespaces.length - 1];

    // return key on CIMode
    var lng = options.lng || this.language;
    var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (lng && lng.toLowerCase() === 'cimode') {
      if (appendNamespaceToCIMode) {
        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
        return namespace + nsSeparator + key;
      }

      return key;
    }

    // resolve from store
    var resolved = this.resolve(keys, options);
    var res = resolved && resolved.res;
    var resUsedKey = resolved && resolved.usedKey || key;

    var resType = Object.prototype.toString.apply(res);
    var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
    var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;

    // object
    var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
    if (res && handleAsObject && noObject.indexOf(resType) < 0 && !(joinArrays && resType === '[object Array]')) {
      if (!options.returnObjects && !this.options.returnObjects) {
        this.logger.warn('accessing an object - but returnObjects options is not enabled!');
        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : 'key \'' + key + ' (' + this.language + ')\' returned an object instead of string.';
      }

      // if we got a separator we loop over children - else we just return object as is
      // as having it set to false means no hierarchy so no lookup for nested values
      if (keySeparator) {
        var copy = resType === '[object Array]' ? [] : {}; // apply child translation on a copy

        /* eslint no-restricted-syntax: 0 */
        for (var m in res) {
          if (Object.prototype.hasOwnProperty.call(res, m)) {
            var deepKey = '' + resUsedKey + keySeparator + m;
            copy[m] = this.translate(deepKey, _extends({}, options, { joinArrays: false, ns: namespaces }));
            if (copy[m] === deepKey) copy[m] = res[m]; // if nothing found use orginal value as fallback
          }
        }
        res = copy;
      }
    } else if (joinArrays && resType === '[object Array]') {
      // array special treatment
      res = res.join(joinArrays);
      if (res) res = this.extendTranslation(res, keys, options);
    } else {
      // string, empty or null
      var usedDefault = false;
      var usedKey = false;

      // fallback value
      if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
        usedDefault = true;
        res = options.defaultValue;
      }
      if (!this.isValidLookup(res)) {
        usedKey = true;
        res = key;
      }

      // save missing
      var updateMissing = options.defaultValue && options.defaultValue !== res && this.options.updateMissing;
      if (usedKey || usedDefault || updateMissing) {
        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? options.defaultValue : res);

        var lngs = [];
        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
          for (var i = 0; i < fallbackLngs.length; i++) {
            lngs.push(fallbackLngs[i]);
          }
        } else if (this.options.saveMissingTo === 'all') {
          lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
        } else {
          lngs.push(options.lng || this.language);
        }

        var send = function send(l, k) {
          if (_this2.options.missingKeyHandler) {
            _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
          } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
            _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
          }
          _this2.emit('missingKey', l, namespace, k, res);
        };

        if (this.options.saveMissing) {
          if (this.options.saveMissingPlurals && options.count) {
            lngs.forEach(function (l) {
              var plurals = _this2.pluralResolver.getPluralFormsOfKey(l, key);

              plurals.forEach(function (p) {
                return send([l], p);
              });
            });
          } else {
            send(lngs, key);
          }
        }
      }

      // extend
      res = this.extendTranslation(res, keys, options, resolved);

      // append namespace if still key
      if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = namespace + ':' + key;

      // parseMissingKeyHandler
      if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
    }

    // return
    return res;
  };

  Translator.prototype.extendTranslation = function extendTranslation(res, key, options, resolved) {
    var _this3 = this;

    if (this.i18nFormat && this.i18nFormat.parse) {
      res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey);
    } else if (!options.skipInterpolation) {
      // i18next.parsing
      if (options.interpolation) this.interpolator.init(_extends({}, options, { interpolation: _extends({}, this.options.interpolation, options.interpolation) }));

      // interpolate
      var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
      if (this.options.interpolation.defaultVariables) data = _extends({}, this.options.interpolation.defaultVariables, data);
      res = this.interpolator.interpolate(res, data, options.lng || this.language);

      // nesting
      if (options.nest !== false) res = this.interpolator.nest(res, function () {
        return _this3.translate.apply(_this3, arguments);
      }, options);

      if (options.interpolation) this.interpolator.reset();
    }

    // post process
    var postProcess = options.postProcess || this.options.postProcess;
    var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

    if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
      res = __WEBPACK_IMPORTED_MODULE_2__postProcessor_js__["a" /* default */].handle(postProcessorNames, res, key, options, this);
    }

    return res;
  };

  Translator.prototype.resolve = function resolve(keys) {
    var _this4 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var found = void 0;
    var usedKey = void 0;
    var usedLng = void 0;
    var usedNS = void 0;

    if (typeof keys === 'string') keys = [keys];

    // forEach possible key
    keys.forEach(function (k) {
      if (_this4.isValidLookup(found)) return;
      var extracted = _this4.extractFromKey(k, options);
      var key = extracted.key;
      usedKey = key;
      var namespaces = extracted.namespaces;
      if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);

      var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
      var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';

      var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language);

      namespaces.forEach(function (ns) {
        if (_this4.isValidLookup(found)) return;
        usedNS = ns;

        codes.forEach(function (code) {
          if (_this4.isValidLookup(found)) return;
          usedLng = code;

          var finalKey = key;
          var finalKeys = [finalKey];

          if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
            _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
          } else {
            var pluralSuffix = void 0;
            if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);

            // fallback for plural if context not found
            if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);

            // get key for context if needed
            if (needsContextHandling) finalKeys.push(finalKey += '' + _this4.options.contextSeparator + options.context);

            // get key for plural if needed
            if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
          }

          // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only
          var possibleKey = void 0;
          /* eslint no-cond-assign: 0 */
          while (possibleKey = finalKeys.pop()) {
            if (!_this4.isValidLookup(found)) {
              found = _this4.getResource(code, ns, possibleKey, options);
            }
          }
        });
      });
    });

    return { res: found, usedKey: usedKey, usedLng: usedLng, usedNS: usedNS };
  };

  Translator.prototype.isValidLookup = function isValidLookup(res) {
    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
  };

  Translator.prototype.getResource = function getResource(code, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    return this.resourceStore.getResource(code, ns, key, options);
  };

  return Translator;
}(__WEBPACK_IMPORTED_MODULE_1__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Translator);

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(17);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck(this, LanguageUtil);

    this.options = options;

    this.whitelist = this.options.whitelist || false;
    this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('languageUtils');
  }

  LanguageUtil.prototype.getScriptPartFromCode = function getScriptPartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return null;

    var p = code.split('-');
    if (p.length === 2) return null;
    p.pop();
    return this.formatLanguageCode(p.join('-'));
  };

  LanguageUtil.prototype.getLanguagePartFromCode = function getLanguagePartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return code;

    var p = code.split('-');
    return this.formatLanguageCode(p[0]);
  };

  LanguageUtil.prototype.formatLanguageCode = function formatLanguageCode(code) {
    // http://www.iana.org/assignments/language-tags/language-tags.xhtml
    if (typeof code === 'string' && code.indexOf('-') > -1) {
      var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
      var p = code.split('-');

      if (this.options.lowerCaseLng) {
        p = p.map(function (part) {
          return part.toLowerCase();
        });
      } else if (p.length === 2) {
        p[0] = p[0].toLowerCase();
        p[1] = p[1].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
      } else if (p.length === 3) {
        p[0] = p[0].toLowerCase();

        // if lenght 2 guess it's a country
        if (p[1].length === 2) p[1] = p[1].toUpperCase();
        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
      }

      return p.join('-');
    }

    return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
  };

  LanguageUtil.prototype.isWhitelisted = function isWhitelisted(code) {
    if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist) {
      code = this.getLanguagePartFromCode(code);
    }
    return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1;
  };

  LanguageUtil.prototype.getFallbackCodes = function getFallbackCodes(fallbacks, code) {
    if (!fallbacks) return [];
    if (typeof fallbacks === 'string') fallbacks = [fallbacks];
    if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;

    if (!code) return fallbacks.default || [];

    // asume we have an object defining fallbacks
    var found = fallbacks[code];
    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
    if (!found) found = fallbacks[this.formatLanguageCode(code)];
    if (!found) found = fallbacks.default;

    return found || [];
  };

  LanguageUtil.prototype.toResolveHierarchy = function toResolveHierarchy(code, fallbackCode) {
    var _this = this;

    var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);

    var codes = [];
    var addCode = function addCode(c) {
      if (!c) return;
      if (_this.isWhitelisted(c)) {
        codes.push(c);
      } else {
        _this.logger.warn('rejecting non-whitelisted language code: ' + c);
      }
    };

    if (typeof code === 'string' && code.indexOf('-') > -1) {
      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
    } else if (typeof code === 'string') {
      addCode(this.formatLanguageCode(code));
    }

    fallbackCodes.forEach(function (fc) {
      if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
    });

    return codes;
  };

  return LanguageUtil;
}();

/* harmony default export */ __webpack_exports__["a"] = (LanguageUtil);

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger_js__ = __webpack_require__(17);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



// definition http://translate.sourceforge.net/wiki/l10n/pluralforms
/* eslint-disable */
var sets = [{ lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'ti', 'tr', 'uz', 'wa'], nr: [1, 2], fc: 1 }, { lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'he', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'], nr: [1, 2], fc: 2 }, { lngs: ['ay', 'bo', 'cgg', 'fa', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'], nr: [1], fc: 3 }, { lngs: ['be', 'bs', 'dz', 'hr', 'ru', 'sr', 'uk'], nr: [1, 2, 5], fc: 4 }, { lngs: ['ar'], nr: [0, 1, 2, 3, 11, 100], fc: 5 }, { lngs: ['cs', 'sk'], nr: [1, 2, 5], fc: 6 }, { lngs: ['csb', 'pl'], nr: [1, 2, 5], fc: 7 }, { lngs: ['cy'], nr: [1, 2, 3, 8], fc: 8 }, { lngs: ['fr'], nr: [1, 2], fc: 9 }, { lngs: ['ga'], nr: [1, 2, 3, 7, 11], fc: 10 }, { lngs: ['gd'], nr: [1, 2, 3, 20], fc: 11 }, { lngs: ['is'], nr: [1, 2], fc: 12 }, { lngs: ['jv'], nr: [0, 1], fc: 13 }, { lngs: ['kw'], nr: [1, 2, 3, 4], fc: 14 }, { lngs: ['lt'], nr: [1, 2, 10], fc: 15 }, { lngs: ['lv'], nr: [1, 2, 0], fc: 16 }, { lngs: ['mk'], nr: [1, 2], fc: 17 }, { lngs: ['mnk'], nr: [0, 1, 2], fc: 18 }, { lngs: ['mt'], nr: [1, 2, 11, 20], fc: 19 }, { lngs: ['or'], nr: [2, 1], fc: 2 }, { lngs: ['ro'], nr: [1, 2, 20], fc: 20 }, { lngs: ['sl'], nr: [5, 1, 2, 3], fc: 21 }];

var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  }
};
/* eslint-enable */

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;

    this.logger = __WEBPACK_IMPORTED_MODULE_0__logger_js__["a" /* default */].create('pluralResolver');

    this.rules = createRules();
  }

  PluralResolver.prototype.addRule = function addRule(lng, obj) {
    this.rules[lng] = obj;
  };

  PluralResolver.prototype.getRule = function getRule(code) {
    return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
  };

  PluralResolver.prototype.needsPlural = function needsPlural(code) {
    var rule = this.getRule(code);

    return rule && rule.numbers.length > 1;
  };

  PluralResolver.prototype.getPluralFormsOfKey = function getPluralFormsOfKey(code, key) {
    var _this = this;

    var ret = [];

    var rule = this.getRule(code);

    if (!rule) return ret;

    rule.numbers.forEach(function (n) {
      var suffix = _this.getSuffix(code, n);
      ret.push('' + key + suffix);
    });

    return ret;
  };

  PluralResolver.prototype.getSuffix = function getSuffix(code, count) {
    var _this2 = this;

    var rule = this.getRule(code);

    if (rule) {
      // if (rule.numbers.length === 1) return ''; // only singular

      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];

      // special treatment for lngs only having singular and plural
      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }

      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };

      // COMPATIBILITY JSON
      // v1
      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return '_plural_' + suffix.toString();
        return returnSuffix();
      } else if ( /* v2 */this.options.compatibilityJSON === 'v2' || rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      } else if ( /* v3 - gettext index */rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }
      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }

    this.logger.warn('no plural rule found for: ' + code);
    return '';
  };

  return PluralResolver;
}();

/* harmony default export */ __webpack_exports__["a"] = (PluralResolver);

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger_js__ = __webpack_require__(17);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Interpolator);

    this.logger = __WEBPACK_IMPORTED_MODULE_1__logger_js__["a" /* default */].create('interpolator');

    this.init(options, true);
  }

  /* eslint no-param-reassign: 0 */


  Interpolator.prototype.init = function init() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var reset = arguments[1];

    if (reset) {
      this.options = options;
      this.format = options.interpolation && options.interpolation.format || function (value) {
        return value;
      };
      this.escape = options.interpolation && options.interpolation.escape || __WEBPACK_IMPORTED_MODULE_0__utils_js__["c" /* escape */];
    }
    if (!options.interpolation) options.interpolation = { escapeValue: true };

    var iOpts = options.interpolation;

    this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;

    this.prefix = iOpts.prefix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.prefix) : iOpts.prefixEscaped || '{{';
    this.suffix = iOpts.suffix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.suffix) : iOpts.suffixEscaped || '}}';

    this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';

    this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
    this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';

    this.nestingPrefix = iOpts.nestingPrefix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */]('$t(');
    this.nestingSuffix = iOpts.nestingSuffix ? __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || __WEBPACK_IMPORTED_MODULE_0__utils_js__["g" /* regexEscape */](')');

    this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;

    // the regexp
    this.resetRegExp();
  };

  Interpolator.prototype.reset = function reset() {
    if (this.options) this.init(this.options);
  };

  Interpolator.prototype.resetRegExp = function resetRegExp() {
    // the regexp
    var regexpStr = this.prefix + '(.+?)' + this.suffix;
    this.regexp = new RegExp(regexpStr, 'g');

    var regexpUnescapeStr = '' + this.prefix + this.unescapePrefix + '(.+?)' + this.unescapeSuffix + this.suffix;
    this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');

    var nestingRegexpStr = this.nestingPrefix + '(.+?)' + this.nestingSuffix;
    this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
  };

  Interpolator.prototype.interpolate = function interpolate(str, data, lng) {
    var _this = this;

    var match = void 0;
    var value = void 0;
    var replaces = void 0;

    function regexSafe(val) {
      return val.replace(/\$/g, '$$$$');
    }

    var handleFormat = function handleFormat(key) {
      if (key.indexOf(_this.formatSeparator) < 0) return __WEBPACK_IMPORTED_MODULE_0__utils_js__["d" /* getPath */](data, key);

      var p = key.split(_this.formatSeparator);
      var k = p.shift().trim();
      var f = p.join(_this.formatSeparator).trim();

      return _this.format(__WEBPACK_IMPORTED_MODULE_0__utils_js__["d" /* getPath */](data, k), f, lng);
    };

    this.resetRegExp();

    replaces = 0;
    // unescape if has unescapePrefix/Suffix
    /* eslint no-cond-assign: 0 */
    while (match = this.regexpUnescape.exec(str)) {
      value = handleFormat(match[1].trim());
      str = str.replace(match[0], value);
      this.regexpUnescape.lastIndex = 0;
      replaces++;
      if (replaces >= this.maxReplaces) {
        break;
      }
    }

    replaces = 0;
    // regular escape on demand
    while (match = this.regexp.exec(str)) {
      value = handleFormat(match[1].trim());
      if (value === undefined) {
        if (typeof this.options.missingInterpolationHandler === 'function') {
          var temp = this.options.missingInterpolationHandler(str, match);
          value = typeof temp === 'string' ? temp : '';
        } else {
          this.logger.warn('missed to pass in variable ' + match[1] + ' for interpolating ' + str);
          value = '';
        }
      } else if (typeof value !== 'string') {
        value = __WEBPACK_IMPORTED_MODULE_0__utils_js__["e" /* makeString */](value);
      }
      value = this.escapeValue ? regexSafe(this.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
      replaces++;
      if (replaces >= this.maxReplaces) {
        break;
      }
    }
    return str;
  };

  Interpolator.prototype.nest = function nest(str, fc) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var match = void 0;
    var value = void 0;

    var clonedOptions = _extends({}, options);
    clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup

    // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"
    function handleHasOptions(key, inheritedOptions) {
      if (key.indexOf(',') < 0) return key;

      var p = key.split(',');
      key = p.shift();
      var optionsString = p.join(',');
      optionsString = this.interpolate(optionsString, clonedOptions);
      optionsString = optionsString.replace(/'/g, '"');

      try {
        clonedOptions = JSON.parse(optionsString);

        if (inheritedOptions) clonedOptions = _extends({}, inheritedOptions, clonedOptions);
      } catch (e) {
        this.logger.error('failed parsing options string in nesting for key ' + key, e);
      }

      return key;
    }

    // regular escape on demand
    while (match = this.nestingRegexp.exec(str)) {
      value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);

      // is only the nesting key (key1 = '$(key2)') return the value without stringify
      if (value && match[0] === str && typeof value !== 'string') return value;

      // no string to include or empty
      if (typeof value !== 'string') value = __WEBPACK_IMPORTED_MODULE_0__utils_js__["e" /* makeString */](value);
      if (!value) {
        this.logger.warn('missed to resolve ' + match[1] + ' for nesting ' + str);
        value = '';
      }
      // Nested keys should not be escaped by default #854
      // value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  };

  return Interpolator;
}();

/* harmony default export */ __webpack_exports__["a"] = (Interpolator);

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventEmitter_js__ = __webpack_require__(34);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }





function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Connector);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.backend = backend;
    _this.store = store;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = __WEBPACK_IMPORTED_MODULE_1__logger_js__["a" /* default */].create('backendConnector');

    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }
    return _this;
  }

  Connector.prototype.queueLoad = function queueLoad(languages, namespaces, callback) {
    var _this2 = this;

    // find what needs to be loaded
    var toLoad = [];
    var pending = [];
    var toLoadLanguages = [];
    var toLoadNamespaces = [];

    languages.forEach(function (lng) {
      var hasAllNamespaces = true;

      namespaces.forEach(function (ns) {
        var name = lng + '|' + ns;

        if (_this2.store.hasResourceBundle(lng, ns)) {
          _this2.state[name] = 2; // loaded
        } else if (_this2.state[name] < 0) {
          // nothing to do for err
        } else if (_this2.state[name] === 1) {
          if (pending.indexOf(name) < 0) pending.push(name);
        } else {
          _this2.state[name] = 1; // pending

          hasAllNamespaces = false;

          if (pending.indexOf(name) < 0) pending.push(name);
          if (toLoad.indexOf(name) < 0) toLoad.push(name);
          if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
        }
      });

      if (!hasAllNamespaces) toLoadLanguages.push(lng);
    });

    if (toLoad.length || pending.length) {
      this.queue.push({
        pending: pending,
        loaded: {},
        errors: [],
        callback: callback
      });
    }

    return {
      toLoad: toLoad,
      pending: pending,
      toLoadLanguages: toLoadLanguages,
      toLoadNamespaces: toLoadNamespaces
    };
  };

  Connector.prototype.loaded = function loaded(name, err, data) {
    var _this3 = this;

    var _name$split = name.split('|'),
        _name$split2 = _slicedToArray(_name$split, 2),
        lng = _name$split2[0],
        ns = _name$split2[1];

    if (err) this.emit('failedLoading', lng, ns, err);

    if (data) {
      this.store.addResourceBundle(lng, ns, data);
    }

    // set loaded
    this.state[name] = err ? -1 : 2;

    // callback if ready
    this.queue.forEach(function (q) {
      __WEBPACK_IMPORTED_MODULE_0__utils_js__["f" /* pushPath */](q.loaded, [lng], ns);
      remove(q.pending, name);

      if (err) q.errors.push(err);

      if (q.pending.length === 0 && !q.done) {
        _this3.emit('loaded', q.loaded);
        /* eslint no-param-reassign: 0 */
        q.done = true;
        if (q.errors.length) {
          q.callback(q.errors);
        } else {
          q.callback();
        }
      }
    });

    // remove done load requests
    this.queue = this.queue.filter(function (q) {
      return !q.done;
    });
  };

  Connector.prototype.read = function read(lng, ns, fcName) {
    var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    var _this4 = this;

    var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 250;
    var callback = arguments[5];

    if (!lng.length) return callback(null, {}); // noting to load

    return this.backend[fcName](lng, ns, function (err, data) {
      if (err && data /* = retryFlag */ && tried < 5) {
        setTimeout(function () {
          _this4.read.call(_this4, lng, ns, fcName, tried + 1, wait * 2, callback);
        }, wait);
        return;
      }
      callback(err, data);
    });
  };

  /* eslint consistent-return: 0 */


  Connector.prototype.load = function load(languages, namespaces, callback) {
    var _this5 = this;

    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
      return callback && callback();
    }

    if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    var toLoad = this.queueLoad(languages, namespaces, callback);
    if (!toLoad.toLoad.length) {
      if (!toLoad.pending.length) callback(); // nothing to load and no pendings...callback now
      return null; // pendings will trigger callback
    }

    toLoad.toLoad.forEach(function (name) {
      _this5.loadOne(name);
    });
  };

  Connector.prototype.reload = function reload(languages, namespaces) {
    var _this6 = this;

    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
    }

    if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    languages.forEach(function (l) {
      namespaces.forEach(function (n) {
        _this6.loadOne(l + '|' + n, 're');
      });
    });
  };

  Connector.prototype.loadOne = function loadOne(name) {
    var _this7 = this;

    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    var _name$split3 = name.split('|'),
        _name$split4 = _slicedToArray(_name$split3, 2),
        lng = _name$split4[0],
        ns = _name$split4[1];

    this.read(lng, ns, 'read', null, null, function (err, data) {
      if (err) _this7.logger.warn(prefix + 'loading namespace ' + ns + ' for language ' + lng + ' failed', err);
      if (!err && data) _this7.logger.log(prefix + 'loaded namespace ' + ns + ' for language ' + lng, data);

      _this7.loaded(name, err, data);
    });
  };

  Connector.prototype.saveMissing = function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

    if (this.backend && this.backend.create) {
      this.backend.create(languages, namespace, key, fallbackValue, null /* unused callback */, _extends({}, options, { isUpdate: isUpdate }));
    }

    // write to store to avoid resending
    if (!languages || !languages[0]) return;
    this.store.addResource(languages[0], namespace, key, fallbackValue);
  };

  return Connector;
}(__WEBPACK_IMPORTED_MODULE_2__EventEmitter_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Connector);

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return get; });
/* harmony export (immutable) */ __webpack_exports__["b"] = transformOptions;

function get() {
  return {
    debug: false,
    initImmediate: true,

    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false, // string or array of namespaces

    whitelist: false, // array with whitelisted languages
    nonExplicitWhitelist: false,
    load: 'all', // | currentOnly | languageOnly
    preload: false, // array with preload languages

    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',

    saveMissing: false, // enable to send missing values
    updateMissing: false, // enable to update default values if different from translated value (only useful on initial development, or when keeping code as source of truth)
    saveMissingTo: 'fallback', // 'current' || 'all'
    saveMissingPlurals: true, // will save all forms not only singular key
    missingKeyHandler: false, // function(lng, ns, key, fallbackValue) -> override if prefer on handling
    missingInterpolationHandler: false, // function(str, match)

    postProcess: false, // string or array of postProcessor names
    returnNull: true, // allows null value as valid translation
    returnEmptyString: true, // allows empty string value as valid translation
    returnObjects: false,
    joinArrays: false, // or string to join array
    returnedObjectHandler: function returnedObjectHandler() {}, // function(key, value, options) triggered if key returns object but returnObjects is set to false
    parseMissingKeyHandler: false, // function(key) parsed a key that was not found in t() before returning
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (args[1]) ret.defaultValue = args[1];
      if (args[2]) ret.tDescription = args[2];
      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      // prefixEscaped: '{{',
      // suffixEscaped: '}}',
      // unescapeSuffix: '',
      unescapePrefix: '-',

      nestingPrefix: '$t(',
      nestingSuffix: ')',
      // nestingPrefixEscaped: '$t(',
      // nestingSuffixEscaped: ')',
      // defaultVariables: undefined // object that can have values to interpolate on - extends passed in interpolation data
      maxReplaces: 1000 // max replaces to prevent endless loop
    }
  };
}

/* eslint no-param-reassign: 0 */
function transformOptions(options) {
  // create namespace object if namespace is passed in as string
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  // extend whitelist with cimode
  if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
    options.whitelist = options.whitelist.concat(['cimode']);
  }

  return options;
}

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({translation:{regionPicker:{chooseArea:'Choose your area'},configurator:{configureNow:'Configure my handle !',chooseFrameColor:'Choose your frame color bellow',chooseHandle:'Choose your prefered handle bellow',createYourOwnButton:'Create your own design',createYourOwn:'Upload your design',sendConfig:'Save this handle',colorType:{ral:'Lacquered',anodized:'Anodized',decor:'Decorative',custom:'Custom'},color:{black:'Black',white:'White'},form:{myConfig:'Save my custom handle',send:'Send!',success:'Your configuration has been successfully sent by e-mail!',error:'An error occurred while sending you an e-mail!',model:'Handle model',color:'Color',ornament:'Decor',ornament_color:'Decor\'s color',custom:'Custom decor'}}}});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({translation:{regionPicker:{chooseArea:'Choisissez votre région'},configurator:{configureNow:'Configurer ma poignée !',chooseFrameColor:'Choisissez la couleur de votre châssis',chooseHandle:'Choisissez le modèle que vous souhaitez configurer',createYourOwnButton:'Créer ma poignée personnalisée',createYourOwn:'Téléchargez un fichier',sendConfig:'Sauvegarder cette poignée',colorType:{ral:'Laqué',anodized:'Anodisé',decor:'Décoratif',custom:'Personnalisé'},color:{black:'Noir',white:'Blanc'},form:{myConfig:'Sauvegarder ma poignée personnalisée',send:'Envoyer !',success:'Votre configuration vous a été envoyée par e-mail avec succès !',error:'Une erreur est survenue lors de l\'envoi de votre e-mail !',model:'Modèle de poignée',color:'Couleur',ornament:'Décors',ornament_color:'Couleur du décors',custom:'Poignée personnalisée'}}}});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({translation:{regionPicker:{chooseArea:'Kies uw gebied'},configurator:{configureNow:'Configureer mijn handgreep !',chooseFrameColor:'Kies hieronder uw framekleur',chooseHandle:'Kies hieronder de gewenste handgreep',createYourOwnButton:'Maak uw eigen ontwerp',createYourOwn:'Upload uw ontwerp',sendConfig:'Bewaar uw ontwerp',colorType:{ral:'Gelakt',anodized:'Geanodiseerd',decor:'Decoratief',custom:'Gepersonnaliseerd'},color:{black:'Zwart',white:'Wit'},form:{myConfig:'Bewaar uw gepersonaliseerde handgreep',send:'Verstuur!',success:'Uw design is succesvol verstuurd per e-mail!',error:'Er is een fout opgetreden tijdens het verzenden van de e-mail!',model:'Handgreep model',color:'Kleur',ornament:'Decor',ornament_color:'Kleuren decor',custom:'Gepersonaliseerd decor'}}}});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({translation:{regionPicker:{chooseArea:'Choisissez votre région'},configurator:{chooseFrameColor:'Choisissez la couleur de votre châssis',chooseHandle:'Choisissez le modèle que vous souhaitez configurer',createYourOwnButton:'Créer ma poignée personnalisée',createYourOwn:'Téléchargez un fichier',sendConfig:'Sauvegarder cette poignée',colorType:{ral:'Laqué',anodized:'Anodisé',decor:'Décoratif',custom:'Personnalisé'},color:{black:'Noir',white:'Blanc'},form:{myConfig:'Sauvegarder ma poignée personnalisée',send:'Envoyer !',success:'Votre configuration vous a été envoyée par e-mail avec succès !',error:'Une erreur est survenue lors de l\'envoi de votre e-mail !',model:'Handle model',color:'Color',ornament:'Ornament',ornament_color:'Ornament color',custom:'Custom ornament'}}}});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({translation:{regionPicker:{chooseArea:'请选择您的地区'},configurator:{configureNow:'Configure my handle !',chooseFrameColor:'请选择您的边框颜色',chooseHandle:'请选择您想要配置的样式',createYourOwnButton:'定制我的把手',createYourOwn:'下载文件',sendConfig:'保存这个执手',colorType:{ral:'喷漆',anodized:'阳极氧化',decor:'装饰性的',custom:'定制化'},color:{black:'黑色',white:'白色'},form:{myConfig:'保存你的定制执手',send:'发送！',success:'你的配置已经成功通过邮件发送',error:'邮件发送时发生错误',model:'执手模型',color:'颜色',ornament:'装饰',ornament_color:'装饰的色系',custom:'自定义装饰'}}}});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({translation:{regionPicker:{chooseArea:'Scegli il tuo Paese'},configurator:{configureNow:'Configura la mia maniglia!',chooseFrameColor:'Scegli il color della finestra',chooseHandle:'Scegli il modello di maniglia da configurare',createYourOwnButton:'Crea la mia maniglia personalizzata',createYourOwn:'Carica il file',sendConfig:'Salva questa maniglia',colorType:{ral:'Verniciata',anodized:'Anodizzata',decor:'Decorata',custom:'Personalizzata'},color:{black:'Nero',white:'Bianco'},form:{myConfig:'Salva la mia maniglia personalizzata',send:'Invia!',success:'La tua configurazione è stata inviata via email con successo!',error:'Attenzione! L\'invio dell\'email non è andato a buon fine!',model:'Codice maniglia',color:'Colore',ornament:'Decoro',ornament_color:'Colore del decoro',custom:'Immagine personalizzata'}}}});

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aluk.a913ff90.svg";

/***/ }),
/* 260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports = [{"handle":"H48103","colors":[{"image_file":"H48103/RAL/0001.png","color":"9010B white","color_css":"#fff","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0002.png","color":"7035S light_grey","color_css":"#dad9d8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0003.png","color":"9006S silver_grey","color_css":"#a7abb5","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0004.png","color":"7016S antracite","color_css":"#272e38","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0005.png","color":"7016G antracite","color_css":"#293133","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0006.png","color":"7022S umbra_grey","color_css":"#332f2C","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0007.png","color":"9005G jet_black","color_css":"#030303","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0008.png","color":"1247G brown","color_css":"#1a140f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0009.png","color":"1015S light_ivory","color_css":"#f2e8c6","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0010.png","color":"9016S white","color_css":"#f9fdfe","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0011.png","color":"9005S jet_black","color_css":"#000","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0012.png","color":"N2100","color_css":"#1b1919","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/Anodized/0001.png","color":"anodic_anod","color_css":"#cbc6c2","color_type":"anodized","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N01_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N01_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N01_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N01_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N01_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N01_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N01_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N01_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N01_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N01_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N01_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N01_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N01_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N01_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N01_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N01_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N01_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N01_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N02_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N02_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N02_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N02_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N02_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N02_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N02_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N02_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N02_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N02_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N02_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N02_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N02_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N02_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N02_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N02_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N02_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N02_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N03_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N03_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N03_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N03_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N03_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N03_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N03_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N03_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N03_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N03_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N03_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N03_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N03_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N03_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N03_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N03_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N03_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N03_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0031.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N04_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N04_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N04_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N04_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N04_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N04_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N04_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N04_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N04_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N04_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N04_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N04_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N04_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N04_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N04_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N04_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N04_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N04_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0026.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N05_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N05_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N05_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N05_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N05_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N05_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N05_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N05_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N05_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N05_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N05_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N05_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N05_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N05_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N05_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N05_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N05_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N05_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0028.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N06_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N06_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N06_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N06_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N06_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N06_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N06_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N06_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N06_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N06_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N06_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N06_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N06_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N06_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N06_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N06_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N06_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N06_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0025.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N07","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0027.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N08_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N08_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N08_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N08_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N08_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N08_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N08_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N08_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N08_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N08_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N08_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N08_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N08_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N08_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N08_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N08_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N08_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N08_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0035.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/C06_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/C06_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/C06_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/C06_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/C06_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/C06_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/C06_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/C06_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/C06_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/C06_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/C06_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/C06_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/C06_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/C06_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/C06_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/C06_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/C06_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/C06_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0036.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/C07_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/C07_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/C07_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/C07_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/C07_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/C07_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/C07_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/C07_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/C07_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/C07_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/C07_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/C07_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/C07_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/C07_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/C07_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/C07_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/C07_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/C07_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0037.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C08","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G01_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G01_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G01_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G01_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G01_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G01_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G01_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G01_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G01_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G01_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G01_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G01_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G01_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G01_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G01_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G01_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G01_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G01_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G02_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G02_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G02_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G02_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G02_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G02_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G02_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G02_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G02_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G02_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G02_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G02_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G02_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G02_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G02_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G02_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G02_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G02_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G03_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G03_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G03_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G03_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G03_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G03_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G03_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G03_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G03_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G03_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G03_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G03_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G03_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G03_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G03_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G03_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G03_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G03_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G04_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G04_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G04_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G04_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G04_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G04_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G04_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G04_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G04_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G04_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G04_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G04_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G04_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G04_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G04_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G04_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G04_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G04_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G05_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G05_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G05_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G05_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G05_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G05_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G05_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G05_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G05_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G05_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G05_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G05_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G05_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G05_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G05_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G05_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G05_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G05_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G06_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G06_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G06_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G06_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G06_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G06_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G06_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G06_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G06_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G06_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G06_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G06_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G06_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G06_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G06_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G06_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G06_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G06_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G07_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G07_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G07_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G07_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G07_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G07_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G07_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G07_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G07_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G07_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G07_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G07_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G07_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G07_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G07_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G07_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G07_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G07_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0032.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G08_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G08_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G08_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G08_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G08_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G08_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G08_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G08_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G08_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G08_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G08_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G08_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G08_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G08_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G08_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G08_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G08_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G08_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0033.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G09_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G09_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G09_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G09_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G09_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G09_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G09_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G09_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G09_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G09_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G09_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G09_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G09_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G09_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G09_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G09_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G09_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G09_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0034.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G10_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G10_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G10_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G10_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G10_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G10_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G10_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G10_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G10_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G10_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G10_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G10_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G10_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G10_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G10_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G10_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G10_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G10_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0038.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G11","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M01","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M02","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M03","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0019.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M04","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0020.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M05","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0021.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M06","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0022.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M07","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0023.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M08","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0024.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M09","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0029.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M10","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0030.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M11","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N01_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N01_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N01_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N01_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N01_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N01_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N01_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N01_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N01_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N01_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N01_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N01_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N01_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N01_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N01_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N01_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N01_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N01_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N02_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N02_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N02_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N02_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N02_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N02_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N02_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N02_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N02_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N02_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N02_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N02_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N02_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N02_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N02_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N02_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N02_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N02_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N03_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N03_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N03_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N03_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N03_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N03_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N03_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N03_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N03_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N03_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N03_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N03_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N03_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N03_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N03_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N03_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N03_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N03_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0031.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N04_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N04_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N04_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N04_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N04_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N04_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N04_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N04_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N04_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N04_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N04_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N04_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N04_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N04_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N04_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N04_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N04_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N04_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0026.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N05_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N05_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N05_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N05_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N05_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N05_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N05_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N05_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N05_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N05_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N05_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N05_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N05_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N05_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N05_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N05_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N05_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N05_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0028.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N06_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N06_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N06_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N06_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N06_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N06_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N06_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N06_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N06_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N06_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N06_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N06_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N06_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N06_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N06_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N06_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N06_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N06_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0025.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N07","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0027.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N08_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N08_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N08_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N08_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N08_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N08_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N08_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N08_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N08_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N08_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N08_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N08_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N08_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N08_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N08_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N08_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N08_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N08_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0035.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/C06_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/C06_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/C06_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/C06_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/C06_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/C06_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/C06_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/C06_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/C06_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/C06_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/C06_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/C06_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/C06_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/C06_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/C06_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/C06_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/C06_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/C06_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0036.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/C07_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/C07_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/C07_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/C07_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/C07_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/C07_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/C07_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/C07_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/C07_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/C07_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/C07_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/C07_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/C07_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/C07_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/C07_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/C07_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/C07_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/C07_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0037.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C08","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G01_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G01_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G01_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G01_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G01_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G01_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G01_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G01_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G01_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G01_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G01_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G01_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G01_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G01_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G01_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G01_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G01_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G01_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G02_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G02_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G02_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G02_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G02_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G02_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G02_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G02_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G02_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G02_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G02_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G02_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G02_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G02_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G02_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G02_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G02_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G02_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G03_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G03_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G03_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G03_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G03_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G03_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G03_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G03_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G03_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G03_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G03_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G03_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G03_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G03_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G03_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G03_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G03_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G03_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G04_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G04_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G04_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G04_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G04_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G04_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G04_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G04_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G04_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G04_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G04_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G04_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G04_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G04_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G04_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G04_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G04_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G04_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G05_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G05_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G05_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G05_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G05_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G05_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G05_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G05_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G05_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G05_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G05_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G05_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G05_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G05_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G05_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G05_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G05_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G05_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G06_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G06_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G06_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G06_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G06_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G06_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G06_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G06_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G06_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G06_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G06_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G06_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G06_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G06_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G06_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G06_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G06_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G06_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G07_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G07_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G07_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G07_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G07_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G07_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G07_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G07_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G07_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G07_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G07_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G07_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G07_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G07_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G07_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G07_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G07_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G07_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0032.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G08_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G08_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G08_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G08_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G08_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G08_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G08_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G08_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G08_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G08_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G08_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G08_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G08_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G08_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G08_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G08_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G08_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G08_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0033.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G09_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G09_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G09_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G09_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G09_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G09_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G09_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G09_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G09_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G09_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G09_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G09_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G09_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G09_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G09_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G09_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G09_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G09_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0034.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G10_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G10_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G10_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G10_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G10_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G10_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G10_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G10_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G10_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G10_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G10_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G10_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G10_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G10_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G10_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G10_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G10_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G10_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0038.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G11","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M01","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M02","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M03","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0019.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M04","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0020.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M05","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0021.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M06","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0022.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M07","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0023.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M08","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0024.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M09","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0029.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M10","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0030.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M11","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_black/0001.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_black/0002.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_black/0003.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_black/0004.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_black/0005.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_white/0001.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_white/0002.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_white/0003.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_white/0004.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_white/0005.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48103/Chassis_RAL/0001.png","css":"#fff","ral":"9010B"},{"image_file":"H48103/Chassis_RAL/0002.png","css":"#dad9d8","ral":"7035S"},{"image_file":"H48103/Chassis_RAL/0003.png","css":"#a7abb5","ral":"9006S"},{"image_file":"H48103/Chassis_RAL/0004.png","css":"#272e38","ral":"7016S"},{"image_file":"H48103/Chassis_RAL/0005.png","css":"#293133","ral":"7016G"},{"image_file":"H48103/Chassis_RAL/0006.png","css":"#332f2C","ral":"7022S"},{"image_file":"H48103/Chassis_RAL/0007.png","css":"#030303","ral":"9005G"},{"image_file":"H48103/Chassis_RAL/0008.png","css":"#1a140f","ral":"1247G"},{"image_file":"H48103/Chassis_RAL/0009.png","css":"#f2e8c6","ral":"1015S"},{"image_file":"H48103/Chassis_RAL/0010.png","css":"#f9fdfe","ral":"9016S"},{"image_file":"H48103/Chassis_RAL/0011.png","css":"#000","ral":"9005S"},{"image_file":"H48103/Chassis_RAL/0012.png","css":"#1b1919","ral":"N2100"}]},{"handle":"H48106","colors":[{"image_file":"H48106/RAL/0001.png","color":"9010B white","color_css":"#fff","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0002.png","color":"7035S light_grey","color_css":"#dad9d8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0003.png","color":"9006S silver_grey","color_css":"#a7abb5","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0004.png","color":"7016S antracite","color_css":"#272e38","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0005.png","color":"7016G antracite","color_css":"#293133","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0006.png","color":"7022S umbra_grey","color_css":"#332f2C","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0007.png","color":"9005G jet_black","color_css":"#030303","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0008.png","color":"1247G brown","color_css":"#1a140f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0009.png","color":"1015S light_ivory","color_css":"#f2e8c6","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0010.png","color":"9016S white","color_css":"#f9fdfe","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0011.png","color":"9005S jet_black","color_css":"#000","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0012.png","color":"N2100","color_css":"#1b1919","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/Anodized/0001.png","color":"anodic_anod","color_css":"#cbc6c2","color_type":"anodized","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48106/Chassis_RAL/0001.png","css":"#fff","ral":"9010B"},{"image_file":"H48106/Chassis_RAL/0002.png","css":"#dad9d8","ral":"7035S"},{"image_file":"H48106/Chassis_RAL/0003.png","css":"#a7abb5","ral":"9006S"},{"image_file":"H48106/Chassis_RAL/0004.png","css":"#272e38","ral":"7016S"},{"image_file":"H48106/Chassis_RAL/0005.png","css":"#293133","ral":"7016G"},{"image_file":"H48106/Chassis_RAL/0006.png","css":"#332f2C","ral":"7022S"},{"image_file":"H48106/Chassis_RAL/0007.png","css":"#030303","ral":"9005G"},{"image_file":"H48106/Chassis_RAL/0008.png","css":"#1a140f","ral":"1247G"},{"image_file":"H48106/Chassis_RAL/0009.png","css":"#f2e8c6","ral":"1015S"},{"image_file":"H48106/Chassis_RAL/0010.png","css":"#f9fdfe","ral":"9016S"},{"image_file":"H48106/Chassis_RAL/0011.png","css":"#000","ral":"9005S"},{"image_file":"H48106/Chassis_RAL/0012.png","css":"#1b1919","ral":"N2100"}]},{"handle":"H48010","colors":[{"image_file":"H48010/RAL/0001.png","color":"9010B white","color_css":"#fff","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0002.png","color":"7035S light_grey","color_css":"#dad9d8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0003.png","color":"9006S silver_grey","color_css":"#a7abb5","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0004.png","color":"7016S antracite","color_css":"#272e38","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0005.png","color":"7016G antracite","color_css":"#293133","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0006.png","color":"7022S umbra_grey","color_css":"#332f2C","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0007.png","color":"9005G jet_black","color_css":"#030303","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0008.png","color":"1247G brown","color_css":"#1a140f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0009.png","color":"1015S light_ivory","color_css":"#f2e8c6","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0010.png","color":"9016S white","color_css":"#f9fdfe","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0011.png","color":"9005S jet_black","color_css":"#000","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0012.png","color":"N2100","color_css":"#1b1919","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48010/Chassis_RAL/0001.png","css":"#fff","ral":"9010B"},{"image_file":"H48010/Chassis_RAL/0002.png","css":"#dad9d8","ral":"7035S"},{"image_file":"H48010/Chassis_RAL/0003.png","css":"#a7abb5","ral":"9006S"},{"image_file":"H48010/Chassis_RAL/0004.png","css":"#272e38","ral":"7016S"},{"image_file":"H48010/Chassis_RAL/0005.png","css":"#293133","ral":"7016G"},{"image_file":"H48010/Chassis_RAL/0006.png","css":"#332f2C","ral":"7022S"},{"image_file":"H48010/Chassis_RAL/0007.png","css":"#030303","ral":"9005G"},{"image_file":"H48010/Chassis_RAL/0008.png","css":"#1a140f","ral":"1247G"},{"image_file":"H48010/Chassis_RAL/0009.png","css":"#f2e8c6","ral":"1015S"},{"image_file":"H48010/Chassis_RAL/0010.png","css":"#f9fdfe","ral":"9016S"},{"image_file":"H48010/Chassis_RAL/0011.png","css":"#000","ral":"9005S"},{"image_file":"H48010/Chassis_RAL/0012.png","css":"#1b1919","ral":"N2100"}]},{"handle":"H48012","colors":[{"image_file":"H48012/RAL/0001.png","color":"9010B white","color_css":"#fff","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0002.png","color":"7035S light_grey","color_css":"#dad9d8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0003.png","color":"9006S silver_grey","color_css":"#a7abb5","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0004.png","color":"7016S antracite","color_css":"#272e38","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0005.png","color":"7016G antracite","color_css":"#293133","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0006.png","color":"7022S umbra_grey","color_css":"#332f2C","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0007.png","color":"9005G jet_black","color_css":"#030303","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0008.png","color":"1247G brown","color_css":"#1a140f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0009.png","color":"1015S light_ivory","color_css":"#f2e8c6","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0010.png","color":"9016S white","color_css":"#f9fdfe","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0011.png","color":"9005S jet_black","color_css":"#000","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0012.png","color":"N2100","color_css":"#1b1919","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48012/Chassis_RAL/0001.png","css":"#fff","ral":"9010B"},{"image_file":"H48012/Chassis_RAL/0002.png","css":"#dad9d8","ral":"7035S"},{"image_file":"H48012/Chassis_RAL/0003.png","css":"#a7abb5","ral":"9006S"},{"image_file":"H48012/Chassis_RAL/0004.png","css":"#272e38","ral":"7016S"},{"image_file":"H48012/Chassis_RAL/0005.png","css":"#293133","ral":"7016G"},{"image_file":"H48012/Chassis_RAL/0006.png","css":"#332f2C","ral":"7022S"},{"image_file":"H48012/Chassis_RAL/0007.png","css":"#030303","ral":"9005G"},{"image_file":"H48012/Chassis_RAL/0008.png","css":"#1a140f","ral":"1247G"},{"image_file":"H48012/Chassis_RAL/0009.png","css":"#f2e8c6","ral":"1015S"},{"image_file":"H48012/Chassis_RAL/0010.png","css":"#f9fdfe","ral":"9016S"},{"image_file":"H48012/Chassis_RAL/0011.png","css":"#000","ral":"9005S"},{"image_file":"H48012/Chassis_RAL/0012.png","css":"#1b1919","ral":"N2100"}]},{"handle":"H48104","colors":[{"image_file":"H48104/RAL/0001.png","color":"9010B white","color_css":"#fff","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0002.png","color":"7035S light_grey","color_css":"#dad9d8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0003.png","color":"9006S silver_grey","color_css":"#a7abb5","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0004.png","color":"7016S antracite","color_css":"#272e38","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0005.png","color":"7016G antracite","color_css":"#293133","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0006.png","color":"7022S umbra_grey","color_css":"#332f2C","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0007.png","color":"9005G jet_black","color_css":"#030303","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0008.png","color":"1247G brown","color_css":"#1a140f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0009.png","color":"1015S light_ivory","color_css":"#f2e8c6","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0010.png","color":"9016S white","color_css":"#f9fdfe","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0011.png","color":"9005S jet_black","color_css":"#000","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0012.png","color":"N2100","color_css":"#1b1919","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/Anodized/0001.png","color":"anodic_anod","color_css":"#cbc6c2","color_type":"anodized","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N01_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N01_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N01_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N01_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N01_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N01_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N01_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N01_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N01_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N01_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N01_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N01_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N01_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N01_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N01_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N01_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N01_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N01_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N02_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N02_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N02_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N02_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N02_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N02_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N02_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N02_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N02_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N02_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N02_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N02_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N02_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N02_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N02_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N02_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N02_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N02_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N03_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N03_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N03_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N03_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N03_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N03_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N03_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N03_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N03_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N03_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N03_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N03_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N03_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N03_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N03_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N03_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N03_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N03_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0031.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N04_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N04_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N04_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N04_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N04_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N04_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N04_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N04_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N04_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N04_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N04_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N04_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N04_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N04_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N04_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N04_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N04_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N04_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0026.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N05_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N05_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N05_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N05_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N05_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N05_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N05_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N05_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N05_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N05_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N05_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N05_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N05_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N05_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N05_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N05_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N05_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N05_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0028.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N06_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N06_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N06_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N06_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N06_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N06_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N06_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N06_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N06_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N06_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N06_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N06_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N06_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N06_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N06_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N06_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N06_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N06_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0025.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N07","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0027.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N08_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N08_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N08_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N08_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N08_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N08_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N08_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N08_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N08_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N08_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N08_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N08_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N08_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N08_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N08_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N08_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N08_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N08_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0035.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/C06_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/C06_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/C06_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/C06_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/C06_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/C06_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/C06_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/C06_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/C06_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/C06_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/C06_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/C06_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/C06_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/C06_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/C06_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/C06_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/C06_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/C06_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0036.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/C07_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/C07_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/C07_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/C07_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/C07_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/C07_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/C07_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/C07_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/C07_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/C07_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/C07_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/C07_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/C07_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/C07_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/C07_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/C07_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/C07_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/C07_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0037.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C08","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G01_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G01_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G01_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G01_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G01_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G01_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G01_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G01_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G01_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G01_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G01_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G01_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G01_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G01_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G01_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G01_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G01_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G01_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G02_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G02_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G02_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G02_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G02_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G02_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G02_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G02_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G02_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G02_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G02_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G02_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G02_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G02_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G02_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G02_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G02_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G02_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G03_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G03_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G03_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G03_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G03_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G03_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G03_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G03_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G03_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G03_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G03_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G03_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G03_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G03_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G03_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G03_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G03_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G03_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G04_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G04_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G04_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G04_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G04_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G04_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G04_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G04_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G04_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G04_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G04_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G04_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G04_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G04_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G04_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G04_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G04_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G04_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G05_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G05_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G05_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G05_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G05_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G05_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G05_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G05_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G05_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G05_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G05_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G05_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G05_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G05_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G05_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G05_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G05_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G05_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G06_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G06_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G06_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G06_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G06_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G06_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G06_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G06_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G06_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G06_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G06_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G06_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G06_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G06_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G06_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G06_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G06_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G06_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G07_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G07_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G07_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G07_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G07_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G07_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G07_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G07_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G07_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G07_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G07_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G07_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G07_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G07_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G07_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G07_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G07_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G07_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0032.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G08_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G08_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G08_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G08_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G08_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G08_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G08_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G08_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G08_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G08_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G08_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G08_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G08_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G08_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G08_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G08_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G08_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G08_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0033.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G09_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G09_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G09_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G09_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G09_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G09_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G09_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G09_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G09_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G09_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G09_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G09_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G09_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G09_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G09_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G09_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G09_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G09_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0034.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G10_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G10_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G10_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G10_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G10_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G10_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G10_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G10_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G10_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G10_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G10_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G10_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G10_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G10_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G10_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G10_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G10_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G10_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0038.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G11","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M01","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M02","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M03","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0019.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M04","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0020.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M05","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0021.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M06","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0022.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M07","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0023.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M08","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0024.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M09","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0029.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M10","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0030.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M11","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N01_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N01_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N01_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N01_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N01_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N01_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N01_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N01_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N01_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N01_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N01_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N01_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N01_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N01_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N01_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N01_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N01_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N01_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N02_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N02_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N02_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N02_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N02_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N02_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N02_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N02_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N02_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N02_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N02_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N02_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N02_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N02_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N02_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N02_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N02_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N02_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N03_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N03_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N03_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N03_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N03_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N03_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N03_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N03_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N03_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N03_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N03_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N03_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N03_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N03_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N03_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N03_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N03_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N03_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0031.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N04_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N04_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N04_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N04_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N04_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N04_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N04_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N04_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N04_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N04_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N04_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N04_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N04_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N04_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N04_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N04_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N04_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N04_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0026.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N05_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N05_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N05_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N05_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N05_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N05_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N05_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N05_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N05_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N05_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N05_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N05_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N05_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N05_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N05_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N05_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N05_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N05_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0028.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N06_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N06_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N06_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N06_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N06_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N06_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N06_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N06_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N06_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N06_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N06_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N06_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N06_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N06_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N06_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N06_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N06_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N06_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0025.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N07","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0027.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N08_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N08_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N08_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N08_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N08_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N08_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N08_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N08_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N08_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N08_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N08_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N08_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N08_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N08_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N08_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N08_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N08_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N08_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0035.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/C06_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/C06_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/C06_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/C06_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/C06_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/C06_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/C06_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/C06_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/C06_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/C06_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/C06_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/C06_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/C06_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/C06_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/C06_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/C06_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/C06_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/C06_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0036.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/C07_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/C07_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/C07_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/C07_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/C07_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/C07_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/C07_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/C07_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/C07_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/C07_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/C07_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/C07_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/C07_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/C07_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/C07_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/C07_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/C07_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/C07_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0037.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C08","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G01_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G01_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G01_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G01_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G01_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G01_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G01_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G01_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G01_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G01_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G01_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G01_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G01_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G01_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G01_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G01_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G01_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G01_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G02_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G02_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G02_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G02_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G02_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G02_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G02_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G02_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G02_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G02_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G02_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G02_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G02_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G02_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G02_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G02_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G02_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G02_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G03_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G03_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G03_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G03_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G03_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G03_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G03_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G03_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G03_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G03_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G03_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G03_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G03_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G03_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G03_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G03_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G03_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G03_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G04_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G04_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G04_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G04_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G04_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G04_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G04_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G04_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G04_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G04_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G04_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G04_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G04_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G04_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G04_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G04_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G04_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G04_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G05_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G05_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G05_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G05_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G05_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G05_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G05_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G05_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G05_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G05_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G05_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G05_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G05_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G05_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G05_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G05_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G05_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G05_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G06_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G06_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G06_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G06_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G06_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G06_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G06_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G06_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G06_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G06_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G06_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G06_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G06_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G06_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G06_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G06_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G06_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G06_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G07_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G07_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G07_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G07_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G07_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G07_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G07_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G07_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G07_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G07_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G07_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G07_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G07_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G07_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G07_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G07_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G07_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G07_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0032.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G08_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G08_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G08_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G08_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G08_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G08_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G08_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G08_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G08_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G08_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G08_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G08_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G08_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G08_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G08_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G08_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G08_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G08_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0033.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G09_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G09_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G09_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G09_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G09_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G09_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G09_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G09_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G09_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G09_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G09_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G09_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G09_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G09_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G09_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G09_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G09_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G09_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0034.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G10_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G10_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G10_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G10_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G10_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G10_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G10_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G10_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G10_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G10_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G10_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G10_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G10_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G10_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G10_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G10_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G10_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G10_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0038.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G11","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M01","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M02","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M03","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0019.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M04","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0020.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M05","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0021.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M06","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0022.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M07","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0023.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M08","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0024.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M09","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0029.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M10","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0030.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M11","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_black/0001.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_black/0002.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_black/0003.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_black/0004.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_black/0005.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_white/0001.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_white/0002.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_white/0003.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_white/0004.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_white/0005.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48104/Chassis_RAL/0001.png","css":"#fff","ral":"9010B"},{"image_file":"H48104/Chassis_RAL/0002.png","css":"#dad9d8","ral":"7035S"},{"image_file":"H48104/Chassis_RAL/0003.png","css":"#a7abb5","ral":"9006S"},{"image_file":"H48104/Chassis_RAL/0004.png","css":"#272e38","ral":"7016S"},{"image_file":"H48104/Chassis_RAL/0005.png","css":"#293133","ral":"7016G"},{"image_file":"H48104/Chassis_RAL/0006.png","css":"#332f2C","ral":"7022S"},{"image_file":"H48104/Chassis_RAL/0007.png","css":"#030303","ral":"9005G"},{"image_file":"H48104/Chassis_RAL/0008.png","css":"#1a140f","ral":"1247G"},{"image_file":"H48104/Chassis_RAL/0009.png","css":"#f2e8c6","ral":"1015S"},{"image_file":"H48104/Chassis_RAL/0010.png","css":"#f9fdfe","ral":"9016S"},{"image_file":"H48104/Chassis_RAL/0011.png","css":"#000","ral":"9005S"},{"image_file":"H48104/Chassis_RAL/0012.png","css":"#1b1919","ral":"N2100"}]},{"handle":"H48107","colors":[{"image_file":"H48107/RAL/0001.png","color":"9010B white","color_css":"#fff","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0002.png","color":"7035S light_grey","color_css":"#dad9d8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0003.png","color":"9006S silver_grey","color_css":"#a7abb5","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0004.png","color":"7016S antracite","color_css":"#272e38","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0005.png","color":"7016G antracite","color_css":"#293133","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0006.png","color":"7022S umbra_grey","color_css":"#332f2C","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0007.png","color":"9005G jet_black","color_css":"#030303","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0008.png","color":"1247G brown","color_css":"#1a140f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0009.png","color":"1015S light_ivory","color_css":"#f2e8c6","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0010.png","color":"9016S white","color_css":"#f9fdfe","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0011.png","color":"9005S jet_black","color_css":"#000","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0012.png","color":"N2100","color_css":"#1b1919","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/Anodized/0001.png","color":"anodic_anod","color_css":"#cbc6c2","color_type":"anodized","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48107/Chassis_RAL/0001.png","css":"#fff","ral":"9010B"},{"image_file":"H48107/Chassis_RAL/0002.png","css":"#dad9d8","ral":"7035S"},{"image_file":"H48107/Chassis_RAL/0003.png","css":"#a7abb5","ral":"9006S"},{"image_file":"H48107/Chassis_RAL/0004.png","css":"#272e38","ral":"7016S"},{"image_file":"H48107/Chassis_RAL/0005.png","css":"#293133","ral":"7016G"},{"image_file":"H48107/Chassis_RAL/0006.png","css":"#332f2C","ral":"7022S"},{"image_file":"H48107/Chassis_RAL/0007.png","css":"#030303","ral":"9005G"},{"image_file":"H48107/Chassis_RAL/0008.png","css":"#1a140f","ral":"1247G"},{"image_file":"H48107/Chassis_RAL/0009.png","css":"#f2e8c6","ral":"1015S"},{"image_file":"H48107/Chassis_RAL/0010.png","css":"#f9fdfe","ral":"9016S"},{"image_file":"H48107/Chassis_RAL/0011.png","css":"#000","ral":"9005S"},{"image_file":"H48107/Chassis_RAL/0012.png","css":"#1b1919","ral":"N2100"}]},{"handle":"H48011","colors":[{"image_file":"H48011/RAL/0001.png","color":"9010B white","color_css":"#fff","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0002.png","color":"7035S light_grey","color_css":"#dad9d8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0003.png","color":"9006S silver_grey","color_css":"#a7abb5","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0004.png","color":"7016S antracite","color_css":"#272e38","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0005.png","color":"7016G antracite","color_css":"#293133","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0006.png","color":"7022S umbra_grey","color_css":"#332f2C","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0007.png","color":"9005G jet_black","color_css":"#030303","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0008.png","color":"1247G brown","color_css":"#1a140f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0009.png","color":"1015S light_ivory","color_css":"#f2e8c6","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0010.png","color":"9016S white","color_css":"#f9fdfe","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0011.png","color":"9005S jet_black","color_css":"#000","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0012.png","color":"N2100","color_css":"#1b1919","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48011/Chassis_RAL/0001.png","css":"#fff","ral":"9010B"},{"image_file":"H48011/Chassis_RAL/0002.png","css":"#dad9d8","ral":"7035S"},{"image_file":"H48011/Chassis_RAL/0003.png","css":"#a7abb5","ral":"9006S"},{"image_file":"H48011/Chassis_RAL/0004.png","css":"#272e38","ral":"7016S"},{"image_file":"H48011/Chassis_RAL/0005.png","css":"#293133","ral":"7016G"},{"image_file":"H48011/Chassis_RAL/0006.png","css":"#332f2C","ral":"7022S"},{"image_file":"H48011/Chassis_RAL/0007.png","css":"#030303","ral":"9005G"},{"image_file":"H48011/Chassis_RAL/0008.png","css":"#1a140f","ral":"1247G"},{"image_file":"H48011/Chassis_RAL/0009.png","css":"#f2e8c6","ral":"1015S"},{"image_file":"H48011/Chassis_RAL/0010.png","css":"#f9fdfe","ral":"9016S"},{"image_file":"H48011/Chassis_RAL/0011.png","css":"#000","ral":"9005S"},{"image_file":"H48011/Chassis_RAL/0012.png","css":"#1b1919","ral":"N2100"}]},{"handle":"H48013","colors":[{"image_file":"H48013/RAL/0001.png","color":"9010B white","color_css":"#fff","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0002.png","color":"7035S light_grey","color_css":"#dad9d8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0003.png","color":"9006S silver_grey","color_css":"#a7abb5","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0004.png","color":"7016S antracite","color_css":"#272e38","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0005.png","color":"7016G antracite","color_css":"#293133","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0006.png","color":"7022S umbra_grey","color_css":"#332f2C","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0007.png","color":"9005G jet_black","color_css":"#030303","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0008.png","color":"1247G brown","color_css":"#1a140f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0009.png","color":"1015S light_ivory","color_css":"#f2e8c6","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0010.png","color":"9016S white","color_css":"#f9fdfe","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0011.png","color":"9005S jet_black","color_css":"#000","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0012.png","color":"N2100","color_css":"#1b1919","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48013/Chassis_RAL/0001.png","css":"#fff","ral":"9010B"},{"image_file":"H48013/Chassis_RAL/0002.png","css":"#dad9d8","ral":"7035S"},{"image_file":"H48013/Chassis_RAL/0003.png","css":"#a7abb5","ral":"9006S"},{"image_file":"H48013/Chassis_RAL/0004.png","css":"#272e38","ral":"7016S"},{"image_file":"H48013/Chassis_RAL/0005.png","css":"#293133","ral":"7016G"},{"image_file":"H48013/Chassis_RAL/0006.png","css":"#332f2C","ral":"7022S"},{"image_file":"H48013/Chassis_RAL/0007.png","css":"#030303","ral":"9005G"},{"image_file":"H48013/Chassis_RAL/0008.png","css":"#1a140f","ral":"1247G"},{"image_file":"H48013/Chassis_RAL/0009.png","css":"#f2e8c6","ral":"1015S"},{"image_file":"H48013/Chassis_RAL/0010.png","css":"#f9fdfe","ral":"9016S"},{"image_file":"H48013/Chassis_RAL/0011.png","css":"#000","ral":"9005S"},{"image_file":"H48013/Chassis_RAL/0012.png","css":"#1b1919","ral":"N2100"}]}]

/***/ }),
/* 262 */
/***/ (function(module, exports) {

module.exports = [{"handle":"H48103","colors":[{"image_file":"H48103/RAL/0013.png","color":"7016M NEW HIGHWAY","color_css":"#303a3f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0014.png","color":"7016S Pencil Grey","color_css":"#303a3f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0015.png","color":"7021S","color_css":"#2d3132","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0016.png","color":"7039S","color_css":"#736d60","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0017.png","color":"7044S","color_css":"#c6c4b4","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0018.png","color":"8019SM","color_css":"#40312e","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0019.png","color":"9005CTX","color_css":"#1a1b1a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0020.png","color":"9007SM","color_css":"#87888a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0021.png","color":"9010S","color_css":"#f9f8f2","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0022.png","color":"9010X","color_css":"#f9f8f2","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0023.png","color":"9016M","color_css":"#f7faf9","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/Anodized/0001.png","color":"anodic_anod","color_css":"#cbc6c2","color_type":"anodized","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N01_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N01_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N01_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N01_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N01_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N01_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N01_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N01_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N01_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N01_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N01_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N01_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N01_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N01_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N01_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N01_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N01_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N01_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N02_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N02_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N02_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N02_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N02_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N02_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N02_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N02_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N02_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N02_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N02_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N02_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N02_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N02_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N02_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N02_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N02_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N02_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N03_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N03_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N03_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N03_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N03_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N03_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N03_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N03_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N03_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N03_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N03_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N03_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N03_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N03_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N03_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N03_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N03_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N03_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0031.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N04_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N04_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N04_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N04_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N04_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N04_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N04_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N04_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N04_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N04_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N04_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N04_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N04_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N04_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N04_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N04_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N04_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N04_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0026.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N05_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N05_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N05_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N05_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N05_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N05_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N05_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N05_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N05_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N05_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N05_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N05_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N05_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N05_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N05_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N05_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N05_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N05_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0028.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N06_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N06_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N06_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N06_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N06_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N06_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N06_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N06_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N06_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N06_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N06_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N06_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N06_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N06_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N06_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N06_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N06_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N06_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0025.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N07","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0027.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N08_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N08_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N08_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N08_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N08_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N08_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N08_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N08_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N08_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N08_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N08_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N08_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N08_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N08_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N08_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N08_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N08_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N08_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0035.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/C06_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/C06_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/C06_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/C06_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/C06_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/C06_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/C06_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/C06_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/C06_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/C06_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/C06_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/C06_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/C06_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/C06_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/C06_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/C06_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/C06_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/C06_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0036.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/C07_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/C07_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/C07_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/C07_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/C07_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/C07_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/C07_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/C07_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/C07_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/C07_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/C07_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/C07_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/C07_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/C07_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/C07_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/C07_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/C07_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/C07_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0037.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C08","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G01_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G01_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G01_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G01_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G01_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G01_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G01_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G01_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G01_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G01_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G01_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G01_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G01_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G01_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G01_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G01_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G01_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G01_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G02_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G02_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G02_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G02_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G02_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G02_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G02_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G02_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G02_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G02_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G02_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G02_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G02_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G02_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G02_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G02_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G02_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G02_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G03_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G03_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G03_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G03_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G03_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G03_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G03_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G03_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G03_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G03_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G03_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G03_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G03_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G03_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G03_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G03_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G03_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G03_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G04_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G04_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G04_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G04_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G04_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G04_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G04_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G04_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G04_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G04_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G04_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G04_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G04_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G04_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G04_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G04_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G04_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G04_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G05_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G05_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G05_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G05_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G05_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G05_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G05_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G05_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G05_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G05_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G05_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G05_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G05_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G05_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G05_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G05_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G05_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G05_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G06_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G06_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G06_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G06_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G06_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G06_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G06_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G06_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G06_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G06_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G06_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G06_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G06_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G06_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G06_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G06_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G06_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G06_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G07_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G07_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G07_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G07_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G07_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G07_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G07_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G07_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G07_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G07_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G07_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G07_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G07_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G07_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G07_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G07_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G07_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G07_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0032.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G08_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G08_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G08_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G08_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G08_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G08_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G08_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G08_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G08_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G08_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G08_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G08_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G08_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G08_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G08_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G08_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G08_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G08_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0033.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G09_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G09_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G09_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G09_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G09_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G09_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G09_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G09_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G09_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G09_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G09_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G09_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G09_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G09_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G09_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G09_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G09_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G09_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0034.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G10_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G10_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G10_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G10_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G10_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G10_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G10_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G10_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G10_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G10_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G10_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G10_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G10_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G10_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G10_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G10_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G10_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G10_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0038.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G11","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M01","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M02","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M03","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0019.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M04","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0020.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M05","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0021.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M06","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0022.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M07","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0023.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M08","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0024.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M09","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0029.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M10","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0030.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M11","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N01_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N01_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N01_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N01_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N01_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N01_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N01_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N01_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N01_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N01_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N01_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N01_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N01_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N01_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N01_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N01_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N01_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N01_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N02_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N02_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N02_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N02_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N02_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N02_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N02_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N02_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N02_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N02_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N02_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N02_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N02_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N02_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N02_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N02_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N02_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N02_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N03_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N03_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N03_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N03_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N03_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N03_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N03_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N03_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N03_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N03_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N03_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N03_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N03_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N03_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N03_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N03_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N03_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N03_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0031.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N04_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N04_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N04_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N04_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N04_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N04_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N04_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N04_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N04_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N04_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N04_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N04_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N04_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N04_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N04_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N04_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N04_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N04_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0026.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N05_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N05_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N05_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N05_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N05_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N05_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N05_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N05_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N05_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N05_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N05_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N05_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N05_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N05_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N05_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N05_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N05_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N05_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0028.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N06_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N06_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N06_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N06_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N06_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N06_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N06_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N06_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N06_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N06_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N06_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N06_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N06_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N06_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N06_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N06_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N06_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N06_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0025.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N07","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0027.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N08_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N08_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N08_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N08_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N08_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N08_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N08_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N08_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N08_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N08_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N08_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N08_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N08_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N08_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N08_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N08_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N08_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N08_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0035.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/C06_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/C06_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/C06_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/C06_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/C06_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/C06_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/C06_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/C06_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/C06_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/C06_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/C06_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/C06_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/C06_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/C06_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/C06_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/C06_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/C06_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/C06_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0036.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/C07_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/C07_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/C07_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/C07_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/C07_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/C07_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/C07_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/C07_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/C07_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/C07_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/C07_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/C07_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/C07_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/C07_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/C07_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/C07_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/C07_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/C07_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0037.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C08","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G01_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G01_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G01_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G01_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G01_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G01_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G01_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G01_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G01_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G01_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G01_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G01_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G01_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G01_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G01_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G01_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G01_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G01_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G02_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G02_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G02_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G02_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G02_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G02_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G02_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G02_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G02_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G02_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G02_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G02_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G02_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G02_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G02_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G02_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G02_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G02_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G03_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G03_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G03_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G03_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G03_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G03_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G03_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G03_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G03_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G03_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G03_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G03_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G03_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G03_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G03_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G03_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G03_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G03_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G04_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G04_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G04_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G04_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G04_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G04_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G04_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G04_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G04_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G04_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G04_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G04_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G04_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G04_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G04_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G04_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G04_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G04_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G05_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G05_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G05_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G05_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G05_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G05_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G05_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G05_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G05_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G05_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G05_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G05_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G05_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G05_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G05_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G05_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G05_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G05_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G06_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G06_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G06_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G06_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G06_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G06_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G06_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G06_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G06_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G06_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G06_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G06_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G06_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G06_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G06_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G06_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G06_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G06_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G07_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G07_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G07_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G07_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G07_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G07_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G07_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G07_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G07_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G07_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G07_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G07_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G07_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G07_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G07_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G07_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G07_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G07_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0032.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G08_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G08_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G08_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G08_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G08_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G08_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G08_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G08_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G08_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G08_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G08_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G08_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G08_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G08_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G08_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G08_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G08_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G08_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0033.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G09_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G09_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G09_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G09_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G09_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G09_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G09_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G09_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G09_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G09_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G09_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G09_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G09_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G09_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G09_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G09_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G09_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G09_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0034.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G10_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G10_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G10_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G10_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G10_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G10_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G10_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G10_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G10_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G10_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G10_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G10_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G10_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G10_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G10_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G10_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G10_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G10_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0038.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G11","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M01","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M02","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M03","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0019.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M04","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0020.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M05","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0021.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M06","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0022.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M07","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0023.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M08","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0024.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M09","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0029.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M10","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0030.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M11","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_black/0001.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_black/0002.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_black/0003.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_black/0004.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_black/0005.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_white/0001.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_white/0002.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_white/0003.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_white/0004.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_white/0005.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48103/Chassis_RAL/0013.png","css":"#303a3f","ral":"7016M"},{"image_file":"H48103/Chassis_RAL/0014.png","css":"#303a3f","ral":"7016S"},{"image_file":"H48103/Chassis_RAL/0015.png","css":"#2d3132","ral":"7021S"},{"image_file":"H48103/Chassis_RAL/0016.png","css":"#736d60","ral":"7039S"},{"image_file":"H48103/Chassis_RAL/0017.png","css":"#c6c4b4","ral":"7044S"},{"image_file":"H48103/Chassis_RAL/0018.png","css":"#40312e","ral":"8019SM"},{"image_file":"H48103/Chassis_RAL/0019.png","css":"#1a1b1a","ral":"9005CTX"},{"image_file":"H48103/Chassis_RAL/0020.png","css":"#87888a","ral":"9007SM"},{"image_file":"H48103/Chassis_RAL/0021.png","css":"#f9f8f2","ral":"9010S"},{"image_file":"H48103/Chassis_RAL/0022.png","css":"#f9f8f2","ral":"9010X"},{"image_file":"H48103/Chassis_RAL/0023.png","css":"#f7faf9","ral":"9016M"}]},{"handle":"H48106","colors":[{"image_file":"H48106/RAL/0013.png","color":"7016M NEW HIGHWAY","color_css":"#303a3f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0014.png","color":"7016S Pencil Grey","color_css":"#303a3f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0015.png","color":"7021S","color_css":"#2d3132","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0016.png","color":"7039S","color_css":"#736d60","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0017.png","color":"7044S","color_css":"#c6c4b4","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0018.png","color":"8019SM","color_css":"#40312e","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0019.png","color":"9005CTX","color_css":"#1a1b1a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0020.png","color":"9007SM","color_css":"#87888a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0021.png","color":"9010S","color_css":"#f9f8f2","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0022.png","color":"9010X","color_css":"#f9f8f2","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0023.png","color":"9016M","color_css":"#f7faf9","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/Anodized/0001.png","color":"anodic_anod","color_css":"#cbc6c2","color_type":"anodized","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48106/Chassis_RAL/0013.png","css":"#303a3f","ral":"7016M"},{"image_file":"H48106/Chassis_RAL/0014.png","css":"#303a3f","ral":"7016S"},{"image_file":"H48106/Chassis_RAL/0015.png","css":"#2d3132","ral":"7021S"},{"image_file":"H48106/Chassis_RAL/0016.png","css":"#736d60","ral":"7039S"},{"image_file":"H48106/Chassis_RAL/0017.png","css":"#c6c4b4","ral":"7044S"},{"image_file":"H48106/Chassis_RAL/0018.png","css":"#40312e","ral":"8019SM"},{"image_file":"H48106/Chassis_RAL/0019.png","css":"#1a1b1a","ral":"9005CTX"},{"image_file":"H48106/Chassis_RAL/0020.png","css":"#87888a","ral":"9007SM"},{"image_file":"H48106/Chassis_RAL/0021.png","css":"#f9f8f2","ral":"9010S"},{"image_file":"H48106/Chassis_RAL/0022.png","css":"#f9f8f2","ral":"9010X"},{"image_file":"H48106/Chassis_RAL/0023.png","css":"#f7faf9","ral":"9016M"}]},{"handle":"H48010","colors":[{"image_file":"H48010/RAL/0013.png","color":"7016M NEW HIGHWAY","color_css":"#303a3f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0014.png","color":"7016S Pencil Grey","color_css":"#303a3f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0015.png","color":"7021S","color_css":"#2d3132","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0016.png","color":"7039S","color_css":"#736d60","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0017.png","color":"7044S","color_css":"#c6c4b4","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0018.png","color":"8019SM","color_css":"#40312e","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0019.png","color":"9005CTX","color_css":"#1a1b1a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0020.png","color":"9007SM","color_css":"#87888a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0021.png","color":"9010S","color_css":"#f9f8f2","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0022.png","color":"9010X","color_css":"#f9f8f2","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0023.png","color":"9016M","color_css":"#f7faf9","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48010/Chassis_RAL/0013.png","css":"#303a3f","ral":"7016M"},{"image_file":"H48010/Chassis_RAL/0014.png","css":"#303a3f","ral":"7016S"},{"image_file":"H48010/Chassis_RAL/0015.png","css":"#2d3132","ral":"7021S"},{"image_file":"H48010/Chassis_RAL/0016.png","css":"#736d60","ral":"7039S"},{"image_file":"H48010/Chassis_RAL/0017.png","css":"#c6c4b4","ral":"7044S"},{"image_file":"H48010/Chassis_RAL/0018.png","css":"#40312e","ral":"8019SM"},{"image_file":"H48010/Chassis_RAL/0019.png","css":"#1a1b1a","ral":"9005CTX"},{"image_file":"H48010/Chassis_RAL/0020.png","css":"#87888a","ral":"9007SM"},{"image_file":"H48010/Chassis_RAL/0021.png","css":"#f9f8f2","ral":"9010S"},{"image_file":"H48010/Chassis_RAL/0022.png","css":"#f9f8f2","ral":"9010X"},{"image_file":"H48010/Chassis_RAL/0023.png","css":"#f7faf9","ral":"9016M"}]},{"handle":"H48012","colors":[{"image_file":"H48012/RAL/0013.png","color":"7016M NEW HIGHWAY","color_css":"#303a3f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0014.png","color":"7016S Pencil Grey","color_css":"#303a3f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0015.png","color":"7021S","color_css":"#2d3132","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0016.png","color":"7039S","color_css":"#736d60","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0017.png","color":"7044S","color_css":"#c6c4b4","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0018.png","color":"8019SM","color_css":"#40312e","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0019.png","color":"9005CTX","color_css":"#1a1b1a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0020.png","color":"9007SM","color_css":"#87888a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0021.png","color":"9010S","color_css":"#f9f8f2","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0022.png","color":"9010X","color_css":"#f9f8f2","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0023.png","color":"9016M","color_css":"#f7faf9","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48012/Chassis_RAL/0013.png","css":"#303a3f","ral":"7016M"},{"image_file":"H48012/Chassis_RAL/0014.png","css":"#303a3f","ral":"7016S"},{"image_file":"H48012/Chassis_RAL/0015.png","css":"#2d3132","ral":"7021S"},{"image_file":"H48012/Chassis_RAL/0016.png","css":"#736d60","ral":"7039S"},{"image_file":"H48012/Chassis_RAL/0017.png","css":"#c6c4b4","ral":"7044S"},{"image_file":"H48012/Chassis_RAL/0018.png","css":"#40312e","ral":"8019SM"},{"image_file":"H48012/Chassis_RAL/0019.png","css":"#1a1b1a","ral":"9005CTX"},{"image_file":"H48012/Chassis_RAL/0020.png","css":"#87888a","ral":"9007SM"},{"image_file":"H48012/Chassis_RAL/0021.png","css":"#f9f8f2","ral":"9010S"},{"image_file":"H48012/Chassis_RAL/0022.png","css":"#f9f8f2","ral":"9010X"},{"image_file":"H48012/Chassis_RAL/0023.png","css":"#f7faf9","ral":"9016M"}]},{"handle":"H48104","colors":[{"image_file":"H48104/RAL/0013.png","color":"7016M NEW HIGHWAY","color_css":"#303a3f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0014.png","color":"7016S Pencil Grey","color_css":"#303a3f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0015.png","color":"7021S","color_css":"#2d3132","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0016.png","color":"7039S","color_css":"#736d60","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0017.png","color":"7044S","color_css":"#c6c4b4","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0018.png","color":"8019SM","color_css":"#40312e","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0019.png","color":"9005CTX","color_css":"#1a1b1a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0020.png","color":"9007SM","color_css":"#87888a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0021.png","color":"9010S","color_css":"#f9f8f2","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0022.png","color":"9010X","color_css":"#f9f8f2","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0023.png","color":"9016M","color_css":"#f7faf9","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/Anodized/0001.png","color":"anodic_anod","color_css":"#cbc6c2","color_type":"anodized","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N01_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N01_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N01_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N01_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N01_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N01_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N01_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N01_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N01_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N01_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N01_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N01_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N01_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N01_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N01_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N01_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N01_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N01_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N02_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N02_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N02_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N02_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N02_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N02_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N02_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N02_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N02_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N02_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N02_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N02_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N02_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N02_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N02_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N02_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N02_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N02_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N03_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N03_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N03_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N03_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N03_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N03_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N03_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N03_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N03_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N03_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N03_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N03_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N03_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N03_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N03_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N03_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N03_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N03_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0031.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N04_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N04_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N04_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N04_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N04_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N04_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N04_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N04_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N04_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N04_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N04_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N04_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N04_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N04_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N04_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N04_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N04_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N04_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0026.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N05_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N05_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N05_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N05_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N05_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N05_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N05_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N05_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N05_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N05_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N05_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N05_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N05_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N05_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N05_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N05_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N05_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N05_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0028.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N06_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N06_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N06_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N06_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N06_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N06_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N06_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N06_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N06_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N06_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N06_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N06_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N06_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N06_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N06_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N06_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N06_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N06_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0025.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N07","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0027.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N08_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N08_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N08_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N08_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N08_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N08_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N08_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N08_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N08_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N08_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N08_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N08_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N08_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N08_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N08_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N08_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N08_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N08_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0035.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/C06_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/C06_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/C06_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/C06_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/C06_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/C06_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/C06_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/C06_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/C06_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/C06_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/C06_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/C06_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/C06_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/C06_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/C06_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/C06_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/C06_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/C06_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0036.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/C07_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/C07_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/C07_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/C07_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/C07_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/C07_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/C07_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/C07_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/C07_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/C07_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/C07_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/C07_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/C07_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/C07_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/C07_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/C07_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/C07_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/C07_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0037.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C08","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G01_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G01_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G01_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G01_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G01_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G01_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G01_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G01_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G01_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G01_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G01_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G01_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G01_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G01_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G01_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G01_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G01_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G01_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G02_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G02_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G02_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G02_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G02_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G02_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G02_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G02_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G02_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G02_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G02_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G02_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G02_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G02_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G02_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G02_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G02_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G02_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G03_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G03_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G03_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G03_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G03_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G03_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G03_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G03_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G03_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G03_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G03_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G03_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G03_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G03_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G03_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G03_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G03_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G03_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G04_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G04_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G04_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G04_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G04_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G04_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G04_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G04_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G04_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G04_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G04_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G04_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G04_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G04_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G04_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G04_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G04_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G04_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G05_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G05_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G05_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G05_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G05_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G05_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G05_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G05_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G05_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G05_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G05_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G05_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G05_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G05_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G05_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G05_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G05_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G05_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G06_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G06_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G06_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G06_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G06_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G06_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G06_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G06_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G06_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G06_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G06_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G06_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G06_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G06_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G06_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G06_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G06_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G06_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G07_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G07_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G07_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G07_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G07_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G07_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G07_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G07_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G07_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G07_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G07_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G07_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G07_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G07_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G07_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G07_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G07_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G07_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0032.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G08_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G08_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G08_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G08_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G08_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G08_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G08_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G08_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G08_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G08_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G08_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G08_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G08_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G08_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G08_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G08_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G08_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G08_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0033.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G09_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G09_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G09_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G09_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G09_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G09_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G09_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G09_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G09_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G09_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G09_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G09_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G09_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G09_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G09_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G09_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G09_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G09_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0034.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G10_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G10_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G10_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G10_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G10_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G10_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G10_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G10_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G10_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G10_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G10_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G10_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G10_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G10_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G10_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G10_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G10_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G10_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0038.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G11","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M01","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M02","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M03","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0019.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M04","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0020.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M05","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0021.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M06","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0022.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M07","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0023.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M08","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0024.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M09","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0029.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M10","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0030.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M11","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N01_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N01_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N01_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N01_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N01_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N01_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N01_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N01_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N01_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N01_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N01_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N01_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N01_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N01_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N01_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N01_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N01_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N01_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N02_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N02_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N02_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N02_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N02_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N02_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N02_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N02_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N02_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N02_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N02_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N02_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N02_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N02_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N02_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N02_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N02_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N02_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N03_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N03_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N03_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N03_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N03_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N03_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N03_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N03_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N03_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N03_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N03_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N03_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N03_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N03_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N03_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N03_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N03_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N03_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0031.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N04_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N04_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N04_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N04_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N04_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N04_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N04_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N04_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N04_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N04_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N04_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N04_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N04_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N04_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N04_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N04_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N04_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N04_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0026.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N05_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N05_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N05_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N05_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N05_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N05_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N05_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N05_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N05_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N05_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N05_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N05_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N05_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N05_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N05_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N05_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N05_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N05_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0028.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N06_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N06_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N06_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N06_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N06_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N06_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N06_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N06_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N06_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N06_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N06_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N06_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N06_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N06_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N06_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N06_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N06_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N06_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0025.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N07","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0027.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N08_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N08_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N08_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N08_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N08_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N08_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N08_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N08_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N08_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N08_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N08_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N08_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N08_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N08_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N08_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N08_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N08_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N08_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0035.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/C06_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/C06_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/C06_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/C06_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/C06_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/C06_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/C06_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/C06_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/C06_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/C06_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/C06_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/C06_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/C06_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/C06_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/C06_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/C06_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/C06_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/C06_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0036.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/C07_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/C07_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/C07_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/C07_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/C07_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/C07_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/C07_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/C07_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/C07_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/C07_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/C07_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/C07_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/C07_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/C07_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/C07_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/C07_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/C07_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/C07_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0037.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C08","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G01_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G01_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G01_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G01_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G01_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G01_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G01_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G01_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G01_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G01_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G01_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G01_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G01_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G01_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G01_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G01_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G01_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G01_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G02_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G02_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G02_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G02_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G02_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G02_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G02_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G02_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G02_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G02_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G02_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G02_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G02_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G02_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G02_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G02_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G02_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G02_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G03_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G03_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G03_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G03_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G03_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G03_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G03_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G03_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G03_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G03_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G03_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G03_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G03_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G03_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G03_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G03_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G03_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G03_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G04_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G04_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G04_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G04_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G04_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G04_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G04_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G04_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G04_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G04_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G04_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G04_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G04_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G04_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G04_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G04_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G04_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G04_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G05_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G05_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G05_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G05_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G05_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G05_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G05_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G05_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G05_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G05_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G05_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G05_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G05_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G05_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G05_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G05_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G05_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G05_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G06_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G06_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G06_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G06_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G06_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G06_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G06_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G06_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G06_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G06_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G06_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G06_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G06_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G06_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G06_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G06_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G06_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G06_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G07_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G07_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G07_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G07_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G07_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G07_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G07_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G07_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G07_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G07_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G07_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G07_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G07_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G07_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G07_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G07_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G07_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G07_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0032.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G08_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G08_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G08_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G08_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G08_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G08_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G08_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G08_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G08_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G08_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G08_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G08_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G08_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G08_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G08_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G08_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G08_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G08_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0033.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G09_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G09_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G09_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G09_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G09_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G09_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G09_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G09_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G09_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G09_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G09_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G09_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G09_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G09_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G09_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G09_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G09_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G09_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0034.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G10_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G10_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G10_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G10_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G10_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G10_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G10_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G10_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G10_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G10_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G10_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G10_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G10_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G10_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G10_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G10_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G10_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G10_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0038.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G11","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M01","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M02","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M03","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0019.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M04","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0020.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M05","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0021.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M06","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0022.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M07","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0023.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M08","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0024.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M09","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0029.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M10","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0030.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M11","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_black/0001.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_black/0002.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_black/0003.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_black/0004.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_black/0005.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_white/0001.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_white/0002.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_white/0003.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_white/0004.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_white/0005.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48104/Chassis_RAL/0013.png","css":"#303a3f","ral":"7016M"},{"image_file":"H48104/Chassis_RAL/0014.png","css":"#303a3f","ral":"7016S"},{"image_file":"H48104/Chassis_RAL/0015.png","css":"#2d3132","ral":"7021S"},{"image_file":"H48104/Chassis_RAL/0016.png","css":"#736d60","ral":"7039S"},{"image_file":"H48104/Chassis_RAL/0017.png","css":"#c6c4b4","ral":"7044S"},{"image_file":"H48104/Chassis_RAL/0018.png","css":"#40312e","ral":"8019SM"},{"image_file":"H48104/Chassis_RAL/0019.png","css":"#1a1b1a","ral":"9005CTX"},{"image_file":"H48104/Chassis_RAL/0020.png","css":"#87888a","ral":"9007SM"},{"image_file":"H48104/Chassis_RAL/0021.png","css":"#f9f8f2","ral":"9010S"},{"image_file":"H48104/Chassis_RAL/0022.png","css":"#f9f8f2","ral":"9010X"},{"image_file":"H48104/Chassis_RAL/0023.png","css":"#f7faf9","ral":"9016M"}]},{"handle":"H48107","colors":[{"image_file":"H48107/RAL/0013.png","color":"7016M NEW HIGHWAY","color_css":"#303a3f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0014.png","color":"7016S Pencil Grey","color_css":"#303a3f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0015.png","color":"7021S","color_css":"#2d3132","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0016.png","color":"7039S","color_css":"#736d60","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0017.png","color":"7044S","color_css":"#c6c4b4","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0018.png","color":"8019SM","color_css":"#40312e","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0019.png","color":"9005CTX","color_css":"#1a1b1a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0020.png","color":"9007SM","color_css":"#87888a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0021.png","color":"9010S","color_css":"#f9f8f2","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0022.png","color":"9010X","color_css":"#f9f8f2","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0023.png","color":"9016M","color_css":"#f7faf9","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/Anodized/0001.png","color":"anodic_anod","color_css":"#cbc6c2","color_type":"anodized","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48107/Chassis_RAL/0013.png","css":"#303a3f","ral":"7016M"},{"image_file":"H48107/Chassis_RAL/0014.png","css":"#303a3f","ral":"7016S"},{"image_file":"H48107/Chassis_RAL/0015.png","css":"#2d3132","ral":"7021S"},{"image_file":"H48107/Chassis_RAL/0016.png","css":"#736d60","ral":"7039S"},{"image_file":"H48107/Chassis_RAL/0017.png","css":"#c6c4b4","ral":"7044S"},{"image_file":"H48107/Chassis_RAL/0018.png","css":"#40312e","ral":"8019SM"},{"image_file":"H48107/Chassis_RAL/0019.png","css":"#1a1b1a","ral":"9005CTX"},{"image_file":"H48107/Chassis_RAL/0020.png","css":"#87888a","ral":"9007SM"},{"image_file":"H48107/Chassis_RAL/0021.png","css":"#f9f8f2","ral":"9010S"},{"image_file":"H48107/Chassis_RAL/0022.png","css":"#f9f8f2","ral":"9010X"},{"image_file":"H48107/Chassis_RAL/0023.png","css":"#f7faf9","ral":"9016M"}]},{"handle":"H48011","colors":[{"image_file":"H48011/RAL/0013.png","color":"7016M NEW HIGHWAY","color_css":"#303a3f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0014.png","color":"7016S Pencil Grey","color_css":"#303a3f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0015.png","color":"7021S","color_css":"#2d3132","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0016.png","color":"7039S","color_css":"#736d60","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0017.png","color":"7044S","color_css":"#c6c4b4","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0018.png","color":"8019SM","color_css":"#40312e","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0019.png","color":"9005CTX","color_css":"#1a1b1a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0020.png","color":"9007SM","color_css":"#87888a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0021.png","color":"9010S","color_css":"#f9f8f2","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0022.png","color":"9010X","color_css":"#f9f8f2","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0023.png","color":"9016M","color_css":"#f7faf9","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48011/Chassis_RAL/0013.png","css":"#303a3f","ral":"7016M"},{"image_file":"H48011/Chassis_RAL/0014.png","css":"#303a3f","ral":"7016S"},{"image_file":"H48011/Chassis_RAL/0015.png","css":"#2d3132","ral":"7021S"},{"image_file":"H48011/Chassis_RAL/0016.png","css":"#736d60","ral":"7039S"},{"image_file":"H48011/Chassis_RAL/0017.png","css":"#c6c4b4","ral":"7044S"},{"image_file":"H48011/Chassis_RAL/0018.png","css":"#40312e","ral":"8019SM"},{"image_file":"H48011/Chassis_RAL/0019.png","css":"#1a1b1a","ral":"9005CTX"},{"image_file":"H48011/Chassis_RAL/0020.png","css":"#87888a","ral":"9007SM"},{"image_file":"H48011/Chassis_RAL/0021.png","css":"#f9f8f2","ral":"9010S"},{"image_file":"H48011/Chassis_RAL/0022.png","css":"#f9f8f2","ral":"9010X"},{"image_file":"H48011/Chassis_RAL/0023.png","css":"#f7faf9","ral":"9016M"}]},{"handle":"H48013","colors":[{"image_file":"H48013/RAL/0013.png","color":"7016M NEW HIGHWAY","color_css":"#303a3f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0014.png","color":"7016S Pencil Grey","color_css":"#303a3f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0015.png","color":"7021S","color_css":"#2d3132","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0016.png","color":"7039S","color_css":"#736d60","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0017.png","color":"7044S","color_css":"#c6c4b4","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0018.png","color":"8019SM","color_css":"#40312e","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0019.png","color":"9005CTX","color_css":"#1a1b1a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0020.png","color":"9007SM","color_css":"#87888a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0021.png","color":"9010S","color_css":"#f9f8f2","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0022.png","color":"9010X","color_css":"#f9f8f2","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0023.png","color":"9016M","color_css":"#f7faf9","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48013/Chassis_RAL/0013.png","css":"#303a3f","ral":"7016M"},{"image_file":"H48013/Chassis_RAL/0014.png","css":"#303a3f","ral":"7016S"},{"image_file":"H48013/Chassis_RAL/0015.png","css":"#2d3132","ral":"7021S"},{"image_file":"H48013/Chassis_RAL/0016.png","css":"#736d60","ral":"7039S"},{"image_file":"H48013/Chassis_RAL/0017.png","css":"#c6c4b4","ral":"7044S"},{"image_file":"H48013/Chassis_RAL/0018.png","css":"#40312e","ral":"8019SM"},{"image_file":"H48013/Chassis_RAL/0019.png","css":"#1a1b1a","ral":"9005CTX"},{"image_file":"H48013/Chassis_RAL/0020.png","css":"#87888a","ral":"9007SM"},{"image_file":"H48013/Chassis_RAL/0021.png","css":"#f9f8f2","ral":"9010S"},{"image_file":"H48013/Chassis_RAL/0022.png","css":"#f9f8f2","ral":"9010X"},{"image_file":"H48013/Chassis_RAL/0023.png","css":"#f7faf9","ral":"9016M"}]}]

/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports = [{"handle":"H48103","colors":[{"image_file":"H48103/RAL/0013.png","color":"7016M NEW HIGHWAY","color_css":"#303a3f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0023.png","color":"9016M","color_css":"#f7faf9","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0024.png","color":"7015M","color_css":"#535257","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0025.png","color":"7040M","color_css":"#9ea1a8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0026.png","color":"7035M","color_css":"#cdcec9","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0027.png","color":"7046M","color_css":"#7e858b","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0028.png","color":"8003M","color_css":"#7d4725","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0029.png","color":"8016M","color_css":"#573229","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0030.png","color":"9005M","color_css":"#161a17","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0031.png","color":"9006M","color_css":"#a1a5a4","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0032.png","color":"9007M","color_css":"#898683","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0033.png","color":"9010M","color_css":"#fffaf0","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/Anodized/0001.png","color":"anodic_anod","color_css":"#cbc6c2","color_type":"anodized","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N01_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N01_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N01_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N01_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N01_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N01_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N01_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N01_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N01_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N01_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N01_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N01_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N01_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N01_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N01_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N01_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N01_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N01_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N02_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N02_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N02_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N02_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N02_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N02_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N02_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N02_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N02_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N02_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N02_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N02_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N02_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N02_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N02_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N02_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N02_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N02_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N03_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N03_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N03_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N03_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N03_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N03_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N03_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N03_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N03_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N03_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N03_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N03_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N03_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N03_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N03_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N03_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N03_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N03_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0031.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N04_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N04_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N04_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N04_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N04_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N04_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N04_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N04_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N04_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N04_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N04_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N04_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N04_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N04_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N04_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N04_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N04_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N04_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0026.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N05_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N05_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N05_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N05_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N05_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N05_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N05_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N05_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N05_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N05_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N05_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N05_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N05_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N05_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N05_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N05_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N05_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N05_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0028.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N06_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N06_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N06_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N06_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N06_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N06_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N06_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N06_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N06_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N06_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N06_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N06_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N06_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N06_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N06_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N06_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N06_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N06_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0025.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N07","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0027.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N08_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N08_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N08_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N08_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N08_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N08_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N08_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N08_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N08_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N08_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N08_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N08_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N08_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N08_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N08_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N08_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N08_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N08_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0035.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/C06_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/C06_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/C06_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/C06_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/C06_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/C06_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/C06_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/C06_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/C06_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/C06_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/C06_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/C06_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/C06_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/C06_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/C06_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/C06_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/C06_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/C06_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0036.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/C07_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/C07_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/C07_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/C07_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/C07_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/C07_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/C07_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/C07_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/C07_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/C07_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/C07_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/C07_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/C07_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/C07_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/C07_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/C07_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/C07_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/C07_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0037.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C08","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G01_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G01_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G01_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G01_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G01_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G01_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G01_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G01_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G01_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G01_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G01_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G01_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G01_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G01_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G01_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G01_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G01_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G01_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G02_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G02_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G02_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G02_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G02_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G02_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G02_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G02_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G02_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G02_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G02_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G02_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G02_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G02_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G02_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G02_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G02_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G02_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G03_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G03_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G03_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G03_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G03_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G03_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G03_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G03_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G03_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G03_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G03_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G03_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G03_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G03_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G03_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G03_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G03_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G03_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G04_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G04_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G04_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G04_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G04_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G04_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G04_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G04_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G04_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G04_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G04_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G04_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G04_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G04_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G04_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G04_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G04_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G04_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G05_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G05_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G05_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G05_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G05_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G05_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G05_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G05_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G05_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G05_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G05_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G05_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G05_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G05_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G05_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G05_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G05_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G05_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G06_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G06_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G06_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G06_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G06_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G06_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G06_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G06_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G06_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G06_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G06_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G06_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G06_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G06_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G06_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G06_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G06_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G06_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G07_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G07_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G07_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G07_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G07_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G07_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G07_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G07_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G07_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G07_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G07_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G07_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G07_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G07_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G07_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G07_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G07_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G07_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0032.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G08_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G08_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G08_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G08_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G08_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G08_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G08_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G08_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G08_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G08_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G08_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G08_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G08_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G08_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G08_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G08_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G08_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G08_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0033.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G09_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G09_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G09_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G09_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G09_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G09_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G09_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G09_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G09_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G09_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G09_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G09_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G09_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G09_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G09_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G09_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G09_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G09_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0034.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G10_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G10_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G10_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G10_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G10_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G10_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G10_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G10_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G10_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G10_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G10_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G10_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G10_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G10_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G10_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G10_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G10_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G10_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0038.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G11","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M01","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M02","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M03","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0019.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M04","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0020.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M05","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0021.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M06","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0022.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M07","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0023.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M08","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0024.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M09","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0029.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M10","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0030.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M11","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N01_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N01_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N01_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N01_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N01_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N01_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N01_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N01_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N01_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N01_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N01_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N01_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N01_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N01_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N01_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N01_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N01_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N01_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N02_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N02_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N02_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N02_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N02_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N02_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N02_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N02_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N02_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N02_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N02_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N02_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N02_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N02_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N02_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N02_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N02_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N02_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N03_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N03_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N03_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N03_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N03_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N03_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N03_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N03_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N03_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N03_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N03_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N03_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N03_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N03_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N03_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N03_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N03_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N03_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0031.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N04_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N04_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N04_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N04_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N04_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N04_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N04_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N04_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N04_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N04_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N04_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N04_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N04_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N04_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N04_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N04_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N04_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N04_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0026.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N05_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N05_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N05_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N05_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N05_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N05_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N05_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N05_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N05_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N05_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N05_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N05_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N05_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N05_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N05_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N05_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N05_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N05_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0028.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N06_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N06_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N06_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N06_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N06_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N06_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N06_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N06_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N06_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N06_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N06_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N06_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N06_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N06_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N06_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N06_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N06_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N06_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0025.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N07","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0027.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N08_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N08_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N08_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N08_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N08_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N08_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N08_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N08_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N08_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N08_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N08_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N08_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N08_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N08_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N08_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N08_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N08_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N08_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0035.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/C06_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/C06_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/C06_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/C06_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/C06_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/C06_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/C06_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/C06_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/C06_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/C06_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/C06_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/C06_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/C06_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/C06_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/C06_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/C06_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/C06_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/C06_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0036.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/C07_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/C07_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/C07_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/C07_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/C07_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/C07_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/C07_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/C07_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/C07_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/C07_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/C07_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/C07_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/C07_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/C07_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/C07_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/C07_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/C07_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/C07_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0037.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C08","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G01_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G01_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G01_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G01_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G01_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G01_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G01_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G01_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G01_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G01_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G01_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G01_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G01_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G01_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G01_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G01_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G01_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G01_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G02_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G02_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G02_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G02_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G02_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G02_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G02_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G02_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G02_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G02_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G02_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G02_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G02_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G02_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G02_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G02_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G02_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G02_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G03_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G03_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G03_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G03_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G03_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G03_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G03_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G03_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G03_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G03_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G03_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G03_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G03_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G03_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G03_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G03_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G03_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G03_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G04_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G04_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G04_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G04_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G04_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G04_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G04_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G04_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G04_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G04_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G04_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G04_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G04_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G04_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G04_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G04_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G04_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G04_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G05_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G05_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G05_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G05_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G05_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G05_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G05_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G05_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G05_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G05_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G05_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G05_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G05_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G05_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G05_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G05_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G05_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G05_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G06_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G06_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G06_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G06_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G06_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G06_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G06_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G06_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G06_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G06_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G06_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G06_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G06_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G06_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G06_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G06_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G06_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G06_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G07_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G07_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G07_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G07_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G07_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G07_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G07_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G07_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G07_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G07_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G07_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G07_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G07_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G07_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G07_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G07_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G07_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G07_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0032.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G08_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G08_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G08_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G08_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G08_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G08_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G08_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G08_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G08_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G08_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G08_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G08_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G08_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G08_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G08_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G08_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G08_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G08_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0033.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G09_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G09_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G09_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G09_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G09_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G09_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G09_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G09_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G09_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G09_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G09_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G09_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G09_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G09_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G09_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G09_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G09_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G09_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0034.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G10_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G10_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G10_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G10_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G10_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G10_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G10_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G10_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G10_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G10_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G10_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G10_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G10_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G10_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G10_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G10_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G10_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G10_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0038.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G11","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M01","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M02","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M03","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0019.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M04","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0020.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M05","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0021.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M06","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0022.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M07","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0023.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M08","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0024.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M09","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0029.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M10","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0030.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M11","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_black/0001.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_black/0002.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_black/0003.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_black/0004.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_black/0005.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_white/0001.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_white/0002.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_white/0003.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_white/0004.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_white/0005.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48103/Chassis_RAL/0013.png","css":"#303a3f","ral":"7016M"},{"image_file":"H48103/Chassis_RAL/0023.png","css":"#f7faf9","ral":"9016M"},{"image_file":"H48103/Chassis_RAL/0024.png","css":"#535257","ral":"7015M"},{"image_file":"H48103/Chassis_RAL/0025.png","css":"#9ea1a8","ral":"7040M"},{"image_file":"H48103/Chassis_RAL/0026.png","css":"#cdcec9","ral":"7035M"},{"image_file":"H48103/Chassis_RAL/0027.png","css":"#7e858b","ral":"7046M"},{"image_file":"H48103/Chassis_RAL/0028.png","css":"#7d4725","ral":"8003M"},{"image_file":"H48103/Chassis_RAL/0029.png","css":"#573229","ral":"8016M"},{"image_file":"H48103/Chassis_RAL/0030.png","css":"#161a17","ral":"9005M"},{"image_file":"H48103/Chassis_RAL/0031.png","css":"#a1a5a4","ral":"9006M"},{"image_file":"H48103/Chassis_RAL/0032.png","css":"#898683","ral":"9007M"},{"image_file":"H48103/Chassis_RAL/0033.png","css":"#fffaf0","ral":"9010M"}]},{"handle":"H48106","colors":[{"image_file":"H48106/RAL/0013.png","color":"7016M NEW HIGHWAY","color_css":"#303a3f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0023.png","color":"9016M","color_css":"#f7faf9","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0024.png","color":"7015M","color_css":"#535257","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0025.png","color":"7040M","color_css":"#9ea1a8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0026.png","color":"7035M","color_css":"#cdcec9","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0027.png","color":"7046M","color_css":"#7e858b","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0028.png","color":"8003M","color_css":"#7d4725","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0029.png","color":"8016M","color_css":"#573229","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0030.png","color":"9005M","color_css":"#161a17","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0031.png","color":"9006M","color_css":"#a1a5a4","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0032.png","color":"9007M","color_css":"#898683","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0033.png","color":"9010M","color_css":"#fffaf0","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/Anodized/0001.png","color":"anodic_anod","color_css":"#cbc6c2","color_type":"anodized","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48106/Chassis_RAL/0013.png","css":"#303a3f","ral":"7016M"},{"image_file":"H48106/Chassis_RAL/0023.png","css":"#f7faf9","ral":"9016M"},{"image_file":"H48106/Chassis_RAL/0024.png","css":"#535257","ral":"7015M"},{"image_file":"H48106/Chassis_RAL/0025.png","css":"#9ea1a8","ral":"7040M"},{"image_file":"H48106/Chassis_RAL/0026.png","css":"#cdcec9","ral":"7035M"},{"image_file":"H48106/Chassis_RAL/0027.png","css":"#7e858b","ral":"7046M"},{"image_file":"H48106/Chassis_RAL/0028.png","css":"#7d4725","ral":"8003M"},{"image_file":"H48106/Chassis_RAL/0029.png","css":"#573229","ral":"8016M"},{"image_file":"H48106/Chassis_RAL/0030.png","css":"#161a17","ral":"9005M"},{"image_file":"H48106/Chassis_RAL/0031.png","css":"#a1a5a4","ral":"9006M"},{"image_file":"H48106/Chassis_RAL/0032.png","css":"#898683","ral":"9007M"},{"image_file":"H48106/Chassis_RAL/0033.png","css":"#fffaf0","ral":"9010M"}]},{"handle":"H48010","colors":[{"image_file":"H48010/RAL/0013.png","color":"7016M NEW HIGHWAY","color_css":"#303a3f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0023.png","color":"9016M","color_css":"#f7faf9","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0024.png","color":"7015M","color_css":"#535257","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0025.png","color":"7040M","color_css":"#9ea1a8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0026.png","color":"7035M","color_css":"#cdcec9","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0027.png","color":"7046M","color_css":"#7e858b","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0028.png","color":"8003M","color_css":"#7d4725","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0029.png","color":"8016M","color_css":"#573229","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0030.png","color":"9005M","color_css":"#161a17","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0031.png","color":"9006M","color_css":"#a1a5a4","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0032.png","color":"9007M","color_css":"#898683","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0033.png","color":"9010M","color_css":"#fffaf0","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48010/Chassis_RAL/0013.png","css":"#303a3f","ral":"7016M"},{"image_file":"H48010/Chassis_RAL/0023.png","css":"#f7faf9","ral":"9016M"},{"image_file":"H48010/Chassis_RAL/0024.png","css":"#535257","ral":"7015M"},{"image_file":"H48010/Chassis_RAL/0025.png","css":"#9ea1a8","ral":"7040M"},{"image_file":"H48010/Chassis_RAL/0026.png","css":"#cdcec9","ral":"7035M"},{"image_file":"H48010/Chassis_RAL/0027.png","css":"#7e858b","ral":"7046M"},{"image_file":"H48010/Chassis_RAL/0028.png","css":"#7d4725","ral":"8003M"},{"image_file":"H48010/Chassis_RAL/0029.png","css":"#573229","ral":"8016M"},{"image_file":"H48010/Chassis_RAL/0030.png","css":"#161a17","ral":"9005M"},{"image_file":"H48010/Chassis_RAL/0031.png","css":"#a1a5a4","ral":"9006M"},{"image_file":"H48010/Chassis_RAL/0032.png","css":"#898683","ral":"9007M"},{"image_file":"H48010/Chassis_RAL/0033.png","css":"#fffaf0","ral":"9010M"}]},{"handle":"H48012","colors":[{"image_file":"H48012/RAL/0013.png","color":"7016M NEW HIGHWAY","color_css":"#303a3f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0023.png","color":"9016M","color_css":"#f7faf9","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0024.png","color":"7015M","color_css":"#535257","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0025.png","color":"7040M","color_css":"#9ea1a8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0026.png","color":"7035M","color_css":"#cdcec9","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0027.png","color":"7046M","color_css":"#7e858b","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0028.png","color":"8003M","color_css":"#7d4725","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0029.png","color":"8016M","color_css":"#573229","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0030.png","color":"9005M","color_css":"#161a17","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0031.png","color":"9006M","color_css":"#a1a5a4","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0032.png","color":"9007M","color_css":"#898683","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0033.png","color":"9010M","color_css":"#fffaf0","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48012/Chassis_RAL/0013.png","css":"#303a3f","ral":"7016M"},{"image_file":"H48012/Chassis_RAL/0023.png","css":"#f7faf9","ral":"9016M"},{"image_file":"H48012/Chassis_RAL/0024.png","css":"#535257","ral":"7015M"},{"image_file":"H48012/Chassis_RAL/0025.png","css":"#9ea1a8","ral":"7040M"},{"image_file":"H48012/Chassis_RAL/0026.png","css":"#cdcec9","ral":"7035M"},{"image_file":"H48012/Chassis_RAL/0027.png","css":"#7e858b","ral":"7046M"},{"image_file":"H48012/Chassis_RAL/0028.png","css":"#7d4725","ral":"8003M"},{"image_file":"H48012/Chassis_RAL/0029.png","css":"#573229","ral":"8016M"},{"image_file":"H48012/Chassis_RAL/0030.png","css":"#161a17","ral":"9005M"},{"image_file":"H48012/Chassis_RAL/0031.png","css":"#a1a5a4","ral":"9006M"},{"image_file":"H48012/Chassis_RAL/0032.png","css":"#898683","ral":"9007M"},{"image_file":"H48012/Chassis_RAL/0033.png","css":"#fffaf0","ral":"9010M"}]},{"handle":"H48104","colors":[{"image_file":"H48104/RAL/0013.png","color":"7016M NEW HIGHWAY","color_css":"#303a3f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0023.png","color":"9016M","color_css":"#f7faf9","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0024.png","color":"7015M","color_css":"#535257","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0025.png","color":"7040M","color_css":"#9ea1a8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0026.png","color":"7035M","color_css":"#cdcec9","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0027.png","color":"7046M","color_css":"#7e858b","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0028.png","color":"8003M","color_css":"#7d4725","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0029.png","color":"8016M","color_css":"#573229","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0030.png","color":"9005M","color_css":"#161a17","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0031.png","color":"9006M","color_css":"#a1a5a4","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0032.png","color":"9007M","color_css":"#898683","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0033.png","color":"9010M","color_css":"#fffaf0","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/Anodized/0001.png","color":"anodic_anod","color_css":"#cbc6c2","color_type":"anodized","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N01_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N01_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N01_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N01_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N01_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N01_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N01_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N01_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N01_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N01_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N01_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N01_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N01_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N01_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N01_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N01_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N01_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N01_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N02_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N02_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N02_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N02_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N02_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N02_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N02_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N02_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N02_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N02_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N02_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N02_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N02_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N02_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N02_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N02_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N02_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N02_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N03_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N03_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N03_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N03_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N03_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N03_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N03_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N03_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N03_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N03_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N03_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N03_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N03_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N03_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N03_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N03_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N03_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N03_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0031.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N04_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N04_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N04_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N04_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N04_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N04_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N04_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N04_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N04_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N04_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N04_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N04_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N04_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N04_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N04_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N04_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N04_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N04_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0026.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N05_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N05_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N05_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N05_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N05_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N05_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N05_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N05_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N05_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N05_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N05_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N05_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N05_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N05_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N05_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N05_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N05_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N05_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0028.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N06_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N06_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N06_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N06_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N06_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N06_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N06_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N06_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N06_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N06_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N06_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N06_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N06_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N06_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N06_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N06_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N06_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N06_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0025.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N07","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0027.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N08_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N08_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N08_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N08_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N08_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N08_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N08_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N08_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N08_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N08_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N08_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N08_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N08_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N08_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N08_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N08_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N08_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N08_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0035.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/C06_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/C06_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/C06_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/C06_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/C06_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/C06_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/C06_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/C06_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/C06_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/C06_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/C06_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/C06_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/C06_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/C06_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/C06_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/C06_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/C06_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/C06_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0036.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/C07_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/C07_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/C07_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/C07_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/C07_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/C07_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/C07_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/C07_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/C07_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/C07_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/C07_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/C07_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/C07_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/C07_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/C07_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/C07_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/C07_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/C07_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0037.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C08","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G01_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G01_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G01_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G01_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G01_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G01_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G01_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G01_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G01_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G01_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G01_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G01_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G01_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G01_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G01_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G01_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G01_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G01_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G02_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G02_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G02_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G02_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G02_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G02_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G02_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G02_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G02_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G02_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G02_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G02_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G02_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G02_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G02_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G02_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G02_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G02_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G03_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G03_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G03_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G03_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G03_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G03_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G03_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G03_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G03_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G03_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G03_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G03_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G03_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G03_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G03_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G03_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G03_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G03_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G04_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G04_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G04_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G04_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G04_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G04_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G04_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G04_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G04_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G04_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G04_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G04_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G04_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G04_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G04_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G04_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G04_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G04_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G05_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G05_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G05_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G05_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G05_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G05_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G05_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G05_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G05_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G05_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G05_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G05_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G05_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G05_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G05_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G05_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G05_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G05_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G06_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G06_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G06_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G06_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G06_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G06_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G06_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G06_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G06_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G06_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G06_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G06_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G06_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G06_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G06_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G06_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G06_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G06_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G07_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G07_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G07_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G07_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G07_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G07_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G07_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G07_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G07_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G07_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G07_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G07_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G07_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G07_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G07_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G07_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G07_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G07_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0032.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G08_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G08_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G08_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G08_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G08_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G08_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G08_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G08_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G08_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G08_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G08_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G08_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G08_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G08_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G08_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G08_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G08_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G08_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0033.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G09_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G09_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G09_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G09_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G09_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G09_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G09_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G09_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G09_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G09_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G09_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G09_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G09_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G09_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G09_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G09_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G09_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G09_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0034.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G10_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G10_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G10_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G10_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G10_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G10_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G10_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G10_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G10_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G10_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G10_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G10_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G10_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G10_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G10_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G10_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G10_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G10_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0038.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G11","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M01","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M02","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M03","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0019.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M04","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0020.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M05","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0021.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M06","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0022.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M07","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0023.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M08","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0024.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M09","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0029.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M10","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0030.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M11","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N01_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N01_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N01_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N01_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N01_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N01_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N01_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N01_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N01_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N01_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N01_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N01_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N01_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N01_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N01_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N01_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N01_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N01_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N02_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N02_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N02_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N02_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N02_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N02_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N02_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N02_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N02_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N02_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N02_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N02_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N02_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N02_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N02_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N02_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N02_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N02_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N03_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N03_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N03_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N03_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N03_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N03_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N03_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N03_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N03_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N03_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N03_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N03_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N03_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N03_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N03_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N03_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N03_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N03_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0031.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N04_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N04_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N04_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N04_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N04_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N04_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N04_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N04_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N04_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N04_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N04_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N04_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N04_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N04_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N04_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N04_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N04_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N04_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0026.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N05_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N05_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N05_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N05_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N05_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N05_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N05_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N05_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N05_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N05_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N05_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N05_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N05_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N05_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N05_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N05_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N05_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N05_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0028.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N06_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N06_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N06_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N06_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N06_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N06_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N06_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N06_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N06_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N06_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N06_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N06_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N06_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N06_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N06_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N06_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N06_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N06_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0025.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N07","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0027.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N08_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N08_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N08_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N08_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N08_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N08_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N08_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N08_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N08_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N08_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N08_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N08_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N08_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N08_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N08_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N08_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N08_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N08_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0035.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/C06_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/C06_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/C06_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/C06_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/C06_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/C06_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/C06_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/C06_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/C06_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/C06_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/C06_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/C06_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/C06_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/C06_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/C06_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/C06_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/C06_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/C06_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0036.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/C07_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/C07_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/C07_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/C07_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/C07_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/C07_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/C07_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/C07_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/C07_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/C07_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/C07_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/C07_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/C07_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/C07_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/C07_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/C07_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/C07_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/C07_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0037.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C08","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G01_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G01_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G01_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G01_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G01_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G01_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G01_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G01_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G01_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G01_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G01_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G01_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G01_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G01_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G01_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G01_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G01_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G01_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G02_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G02_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G02_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G02_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G02_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G02_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G02_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G02_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G02_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G02_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G02_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G02_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G02_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G02_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G02_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G02_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G02_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G02_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G03_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G03_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G03_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G03_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G03_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G03_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G03_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G03_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G03_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G03_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G03_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G03_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G03_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G03_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G03_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G03_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G03_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G03_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G04_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G04_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G04_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G04_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G04_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G04_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G04_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G04_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G04_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G04_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G04_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G04_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G04_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G04_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G04_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G04_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G04_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G04_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G05_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G05_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G05_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G05_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G05_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G05_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G05_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G05_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G05_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G05_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G05_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G05_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G05_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G05_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G05_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G05_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G05_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G05_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G06_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G06_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G06_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G06_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G06_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G06_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G06_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G06_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G06_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G06_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G06_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G06_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G06_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G06_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G06_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G06_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G06_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G06_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G07_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G07_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G07_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G07_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G07_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G07_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G07_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G07_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G07_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G07_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G07_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G07_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G07_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G07_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G07_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G07_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G07_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G07_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0032.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G08_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G08_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G08_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G08_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G08_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G08_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G08_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G08_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G08_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G08_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G08_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G08_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G08_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G08_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G08_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G08_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G08_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G08_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0033.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G09_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G09_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G09_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G09_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G09_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G09_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G09_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G09_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G09_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G09_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G09_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G09_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G09_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G09_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G09_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G09_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G09_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G09_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0034.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G10_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G10_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G10_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G10_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G10_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G10_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G10_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G10_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G10_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G10_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G10_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G10_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G10_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G10_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G10_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G10_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G10_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G10_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0038.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G11","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M01","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M02","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M03","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0019.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M04","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0020.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M05","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0021.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M06","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0022.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M07","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0023.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M08","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0024.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M09","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0029.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M10","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0030.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M11","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_black/0001.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_black/0002.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_black/0003.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_black/0004.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_black/0005.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_white/0001.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_white/0002.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_white/0003.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_white/0004.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_white/0005.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48104/Chassis_RAL/0013.png","css":"#303a3f","ral":"7016M"},{"image_file":"H48104/Chassis_RAL/0023.png","css":"#f7faf9","ral":"9016M"},{"image_file":"H48104/Chassis_RAL/0024.png","css":"#535257","ral":"7015M"},{"image_file":"H48104/Chassis_RAL/0025.png","css":"#9ea1a8","ral":"7040M"},{"image_file":"H48104/Chassis_RAL/0026.png","css":"#cdcec9","ral":"7035M"},{"image_file":"H48104/Chassis_RAL/0027.png","css":"#7e858b","ral":"7046M"},{"image_file":"H48104/Chassis_RAL/0028.png","css":"#7d4725","ral":"8003M"},{"image_file":"H48104/Chassis_RAL/0029.png","css":"#573229","ral":"8016M"},{"image_file":"H48104/Chassis_RAL/0030.png","css":"#161a17","ral":"9005M"},{"image_file":"H48104/Chassis_RAL/0031.png","css":"#a1a5a4","ral":"9006M"},{"image_file":"H48104/Chassis_RAL/0032.png","css":"#898683","ral":"9007M"},{"image_file":"H48104/Chassis_RAL/0033.png","css":"#fffaf0","ral":"9010M"}]},{"handle":"H48107","colors":[{"image_file":"H48107/RAL/0013.png","color":"7016M NEW HIGHWAY","color_css":"#303a3f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0023.png","color":"9016M","color_css":"#f7faf9","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0024.png","color":"7015M","color_css":"#535257","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0025.png","color":"7040M","color_css":"#9ea1a8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0026.png","color":"7035M","color_css":"#cdcec9","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0027.png","color":"7046M","color_css":"#7e858b","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0028.png","color":"8003M","color_css":"#7d4725","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0029.png","color":"8016M","color_css":"#573229","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0030.png","color":"9005M","color_css":"#161a17","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0031.png","color":"9006M","color_css":"#a1a5a4","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0032.png","color":"9007M","color_css":"#898683","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0033.png","color":"9010M","color_css":"#fffaf0","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/Anodized/0001.png","color":"anodic_anod","color_css":"#cbc6c2","color_type":"anodized","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48107/Chassis_RAL/0013.png","css":"#303a3f","ral":"7016M"},{"image_file":"H48107/Chassis_RAL/0023.png","css":"#f7faf9","ral":"9016M"},{"image_file":"H48107/Chassis_RAL/0024.png","css":"#535257","ral":"7015M"},{"image_file":"H48107/Chassis_RAL/0025.png","css":"#9ea1a8","ral":"7040M"},{"image_file":"H48107/Chassis_RAL/0026.png","css":"#cdcec9","ral":"7035M"},{"image_file":"H48107/Chassis_RAL/0027.png","css":"#7e858b","ral":"7046M"},{"image_file":"H48107/Chassis_RAL/0028.png","css":"#7d4725","ral":"8003M"},{"image_file":"H48107/Chassis_RAL/0029.png","css":"#573229","ral":"8016M"},{"image_file":"H48107/Chassis_RAL/0030.png","css":"#161a17","ral":"9005M"},{"image_file":"H48107/Chassis_RAL/0031.png","css":"#a1a5a4","ral":"9006M"},{"image_file":"H48107/Chassis_RAL/0032.png","css":"#898683","ral":"9007M"},{"image_file":"H48107/Chassis_RAL/0033.png","css":"#fffaf0","ral":"9010M"}]},{"handle":"H48011","colors":[{"image_file":"H48011/RAL/0013.png","color":"7016M NEW HIGHWAY","color_css":"#303a3f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0023.png","color":"9016M","color_css":"#f7faf9","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0024.png","color":"7015M","color_css":"#535257","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0025.png","color":"7040M","color_css":"#9ea1a8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0026.png","color":"7035M","color_css":"#cdcec9","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0027.png","color":"7046M","color_css":"#7e858b","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0028.png","color":"8003M","color_css":"#7d4725","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0029.png","color":"8016M","color_css":"#573229","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0030.png","color":"9005M","color_css":"#161a17","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0031.png","color":"9006M","color_css":"#a1a5a4","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0032.png","color":"9007M","color_css":"#898683","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0033.png","color":"9010M","color_css":"#fffaf0","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48011/Chassis_RAL/0013.png","css":"#303a3f","ral":"7016M"},{"image_file":"H48011/Chassis_RAL/0023.png","css":"#f7faf9","ral":"9016M"},{"image_file":"H48011/Chassis_RAL/0024.png","css":"#535257","ral":"7015M"},{"image_file":"H48011/Chassis_RAL/0025.png","css":"#9ea1a8","ral":"7040M"},{"image_file":"H48011/Chassis_RAL/0026.png","css":"#cdcec9","ral":"7035M"},{"image_file":"H48011/Chassis_RAL/0027.png","css":"#7e858b","ral":"7046M"},{"image_file":"H48011/Chassis_RAL/0028.png","css":"#7d4725","ral":"8003M"},{"image_file":"H48011/Chassis_RAL/0029.png","css":"#573229","ral":"8016M"},{"image_file":"H48011/Chassis_RAL/0030.png","css":"#161a17","ral":"9005M"},{"image_file":"H48011/Chassis_RAL/0031.png","css":"#a1a5a4","ral":"9006M"},{"image_file":"H48011/Chassis_RAL/0032.png","css":"#898683","ral":"9007M"},{"image_file":"H48011/Chassis_RAL/0033.png","css":"#fffaf0","ral":"9010M"}]},{"handle":"H48013","colors":[{"image_file":"H48013/RAL/0013.png","color":"7016M NEW HIGHWAY","color_css":"#303a3f","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0023.png","color":"9016M","color_css":"#f7faf9","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0024.png","color":"7015M","color_css":"#535257","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0025.png","color":"7040M","color_css":"#9ea1a8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0026.png","color":"7035M","color_css":"#cdcec9","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0027.png","color":"7046M","color_css":"#7e858b","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0028.png","color":"8003M","color_css":"#7d4725","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0029.png","color":"8016M","color_css":"#573229","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0030.png","color":"9005M","color_css":"#161a17","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0031.png","color":"9006M","color_css":"#a1a5a4","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0032.png","color":"9007M","color_css":"#898683","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0033.png","color":"9010M","color_css":"#fffaf0","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48013/Chassis_RAL/0013.png","css":"#303a3f","ral":"7016M"},{"image_file":"H48013/Chassis_RAL/0023.png","css":"#f7faf9","ral":"9016M"},{"image_file":"H48013/Chassis_RAL/0024.png","css":"#535257","ral":"7015M"},{"image_file":"H48013/Chassis_RAL/0025.png","css":"#9ea1a8","ral":"7040M"},{"image_file":"H48013/Chassis_RAL/0026.png","css":"#cdcec9","ral":"7035M"},{"image_file":"H48013/Chassis_RAL/0027.png","css":"#7e858b","ral":"7046M"},{"image_file":"H48013/Chassis_RAL/0028.png","css":"#7d4725","ral":"8003M"},{"image_file":"H48013/Chassis_RAL/0029.png","css":"#573229","ral":"8016M"},{"image_file":"H48013/Chassis_RAL/0030.png","css":"#161a17","ral":"9005M"},{"image_file":"H48013/Chassis_RAL/0031.png","css":"#a1a5a4","ral":"9006M"},{"image_file":"H48013/Chassis_RAL/0032.png","css":"#898683","ral":"9007M"},{"image_file":"H48013/Chassis_RAL/0033.png","css":"#fffaf0","ral":"9010M"}]}]

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports = [{"handle":"H48103","colors":[{"image_file":"H48103/RAL/0001.png","color":"9010B white","color_css":"#fff","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0002.png","color":"7035S light_grey","color_css":"#dad9d8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0004.png","color":"7016S antracite","color_css":"#272e38","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0009.png","color":"1015S light_ivory","color_css":"#f2e8c6","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0011.png","color":"9005S jet_black","color_css":"#000","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0018.png","color":"8019SM","color_css":"#40312e","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0020.png","color":"9007SM","color_css":"#87888a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0034.png","color":"1013 AVORIO LUCIDO","color_css":"#dbd6bf","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0035.png","color":"9002 BIANCO LUCIDO","color_css":"#cdcbbb","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0036.png","color":"5010 BLU LUCIDO","color_css":"#004f7c","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0037.png","color":"7001 GRIGIO LUCIDO","color_css":"#9e9f98","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0038.png","color":"7040 GRIGIO LUCIDO","color_css":"#a2a3a0","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0039.png","color":"7037 GRIGIO LUCIDO","color_css":"#848074","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0040.png","color":"1019 BEIGE OPACO","color_css":"#b1a07a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0041.png","color":"8011 MARRONE LUCIDO","color_css":"#502b0a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0042.png","color":"3003 ROSSO LUCIDO","color_css":"#80020b","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0043.png","color":"3005 ROSSO LUCIDO","color_css":"#35070c","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0044.png","color":"6021 VERDE OPACO","color_css":"#96b583","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0045.png","color":"6005 VERDE LUCIDO","color_css":"#002811","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0046.png","color":"Brass - R1","color_css":"#f0bb69","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0047.png","color":"Glossy Titanium - T2","color_css":"#b8b8b8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/RAL/0048.png","color":"Titanium mat - T1","color_css":"#b8b8b8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/Anodized/0001.png","color":"anodic_anod","color_css":"#cbc6c2","color_type":"anodized","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N01_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N01_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N01_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N01_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N01_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N01_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N01_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N01_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N01_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N01_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N01_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N01_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N01_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N01_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N01_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N01_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N01_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N01_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N02_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N02_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N02_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N02_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N02_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N02_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N02_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N02_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N02_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N02_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N02_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N02_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N02_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N02_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N02_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N02_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N02_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N02_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N03_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N03_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N03_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N03_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N03_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N03_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N03_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N03_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N03_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N03_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N03_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N03_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N03_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N03_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N03_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N03_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N03_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N03_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0031.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N04_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N04_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N04_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N04_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N04_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N04_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N04_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N04_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N04_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N04_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N04_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N04_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N04_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N04_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N04_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N04_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N04_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N04_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0026.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N05_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N05_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N05_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N05_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N05_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N05_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N05_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N05_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N05_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N05_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N05_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N05_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N05_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N05_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N05_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N05_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N05_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N05_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0028.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N06_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N06_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N06_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N06_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N06_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N06_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N06_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N06_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N06_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N06_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N06_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N06_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N06_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N06_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N06_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N06_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N06_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N06_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0025.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N07","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0027.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N08_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N08_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N08_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N08_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N08_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N08_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N08_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N08_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N08_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N08_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N08_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N08_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N08_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N08_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N08_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N08_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N08_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N08_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0035.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/C06_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/C06_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/C06_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/C06_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/C06_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/C06_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/C06_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/C06_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/C06_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/C06_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/C06_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/C06_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/C06_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/C06_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/C06_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/C06_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/C06_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/C06_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0036.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/C07_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/C07_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/C07_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/C07_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/C07_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/C07_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/C07_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/C07_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/C07_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/C07_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/C07_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/C07_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/C07_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/C07_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/C07_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/C07_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/C07_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/C07_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0037.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C08","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G01_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G01_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G01_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G01_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G01_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G01_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G01_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G01_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G01_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G01_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G01_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G01_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G01_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G01_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G01_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G01_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G01_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G01_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G02_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G02_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G02_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G02_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G02_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G02_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G02_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G02_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G02_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G02_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G02_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G02_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G02_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G02_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G02_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G02_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G02_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G02_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G03_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G03_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G03_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G03_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G03_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G03_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G03_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G03_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G03_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G03_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G03_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G03_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G03_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G03_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G03_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G03_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G03_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G03_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G04_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G04_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G04_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G04_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G04_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G04_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G04_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G04_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G04_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G04_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G04_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G04_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G04_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G04_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G04_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G04_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G04_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G04_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G05_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G05_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G05_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G05_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G05_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G05_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G05_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G05_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G05_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G05_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G05_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G05_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G05_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G05_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G05_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G05_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G05_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G05_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G06_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G06_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G06_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G06_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G06_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G06_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G06_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G06_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G06_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G06_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G06_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G06_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G06_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G06_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G06_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G06_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G06_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G06_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G07_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G07_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G07_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G07_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G07_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G07_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G07_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G07_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G07_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G07_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G07_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G07_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G07_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G07_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G07_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G07_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G07_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G07_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0032.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G08_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G08_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G08_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G08_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G08_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G08_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G08_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G08_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G08_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G08_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G08_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G08_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G08_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G08_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G08_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G08_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G08_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G08_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0033.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G09_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G09_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G09_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G09_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G09_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G09_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G09_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G09_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G09_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G09_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G09_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G09_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G09_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G09_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G09_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G09_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G09_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G09_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0034.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G10_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G10_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G10_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G10_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G10_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G10_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G10_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G10_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G10_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G10_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G10_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G10_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G10_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G10_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G10_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G10_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G10_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G10_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_black/0038.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G11","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M01","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M02","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M03","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0019.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M04","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0020.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M05","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0021.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M06","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0022.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M07","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0023.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M08","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0024.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M09","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0029.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M10","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_black/0030.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M11","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N01_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N01_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N01_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N01_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N01_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N01_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N01_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N01_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N01_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N01_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N01_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N01_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N01_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N01_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N01_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N01_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N01_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N01_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N02_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N02_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N02_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N02_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N02_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N02_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N02_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N02_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N02_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N02_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N02_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N02_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N02_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N02_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N02_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N02_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N02_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N02_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N03_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N03_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N03_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N03_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N03_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N03_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N03_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N03_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N03_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N03_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N03_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N03_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N03_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N03_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N03_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N03_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N03_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N03_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0031.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N04_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N04_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N04_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N04_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N04_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N04_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N04_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N04_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N04_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N04_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N04_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N04_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N04_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N04_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N04_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N04_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N04_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N04_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0026.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N05_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N05_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N05_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N05_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N05_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N05_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N05_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N05_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N05_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N05_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N05_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N05_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N05_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N05_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N05_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N05_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N05_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N05_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0028.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N06_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N06_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N06_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N06_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N06_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N06_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N06_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N06_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N06_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N06_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N06_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N06_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N06_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N06_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N06_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N06_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N06_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N06_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0025.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N07","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0027.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/N08_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/N08_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/N08_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/N08_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/N08_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/N08_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/N08_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/N08_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/N08_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/N08_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/N08_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/N08_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/N08_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/N08_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/N08_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/N08_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/N08_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/N08_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0035.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/C06_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/C06_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/C06_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/C06_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/C06_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/C06_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/C06_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/C06_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/C06_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/C06_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/C06_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/C06_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/C06_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/C06_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/C06_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/C06_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/C06_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/C06_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0036.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/C07_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/C07_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/C07_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/C07_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/C07_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/C07_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/C07_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/C07_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/C07_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/C07_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/C07_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/C07_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/C07_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/C07_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/C07_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/C07_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/C07_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/C07_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0037.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C08","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G01_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G01_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G01_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G01_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G01_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G01_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G01_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G01_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G01_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G01_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G01_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G01_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G01_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G01_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G01_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G01_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G01_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G01_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G02_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G02_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G02_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G02_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G02_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G02_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G02_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G02_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G02_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G02_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G02_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G02_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G02_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G02_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G02_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G02_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G02_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G02_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G03_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G03_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G03_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G03_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G03_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G03_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G03_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G03_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G03_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G03_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G03_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G03_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G03_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G03_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G03_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G03_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G03_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G03_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G04_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G04_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G04_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G04_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G04_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G04_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G04_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G04_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G04_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G04_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G04_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G04_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G04_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G04_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G04_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G04_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G04_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G04_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G05_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G05_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G05_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G05_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G05_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G05_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G05_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G05_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G05_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G05_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G05_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G05_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G05_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G05_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G05_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G05_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G05_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G05_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G06_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G06_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G06_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G06_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G06_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G06_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G06_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G06_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G06_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G06_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G06_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G06_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G06_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G06_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G06_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G06_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G06_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G06_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G07_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G07_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G07_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G07_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G07_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G07_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G07_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G07_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G07_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G07_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G07_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G07_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G07_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G07_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G07_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G07_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G07_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G07_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0032.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G08_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G08_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G08_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G08_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G08_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G08_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G08_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G08_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G08_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G08_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G08_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G08_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G08_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G08_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G08_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G08_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G08_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G08_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0033.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G09_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G09_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G09_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G09_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G09_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G09_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G09_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G09_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G09_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G09_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G09_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G09_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G09_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G09_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G09_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G09_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G09_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G09_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0034.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors_colored/G10_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48103/Decors_colored/G10_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48103/Decors_colored/G10_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48103/Decors_colored/G10_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48103/Decors_colored/G10_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48103/Decors_colored/G10_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48103/Decors_colored/G10_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48103/Decors_colored/G10_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48103/Decors_colored/G10_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48103/Decors_colored/G10_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48103/Decors_colored/G10_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48103/Decors_colored/G10_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48103/Decors_colored/G10_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48103/Decors_colored/G10_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48103/Decors_colored/G10_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48103/Decors_colored/G10_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48103/Decors_colored/G10_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48103/Decors_colored/G10_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48103/Decors/Decors_white/0038.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G11","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M01","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M02","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M03","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0019.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M04","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0020.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M05","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0021.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M06","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0022.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M07","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0023.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M08","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0024.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M09","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0029.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M10","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Decors/Decors_white/0030.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M11","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_black/0001.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_black/0002.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_black/0003.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_black/0004.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_black/0005.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_white/0001.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_white/0002.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_white/0003.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_white/0004.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48103/Customs/Customs_white/0005.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48103/Chassis_RAL/0001.png","css":"#fff","ral":"9010B"},{"image_file":"H48103/Chassis_RAL/0002.png","css":"#dad9d8","ral":"7035S"},{"image_file":"H48103/Chassis_RAL/0004.png","css":"#272e38","ral":"7016S"},{"image_file":"H48103/Chassis_RAL/0009.png","css":"#f2e8c6","ral":"1015S"},{"image_file":"H48103/Chassis_RAL/0011.png","css":"#000","ral":"9005S"},{"image_file":"H48103/Chassis_RAL/0018.png","css":"#40312e","ral":"8019SM"},{"image_file":"H48103/Chassis_RAL/0020.png","css":"#87888a","ral":"9007SM"},{"image_file":"H48103/Chassis_RAL/0034.png","css":"#dbd6bf","ral":"1013 AVORIO LUCIDO"},{"image_file":"H48103/Chassis_RAL/0035.png","css":"#cdcbbb","ral":"9002 BIANCO LUCIDO"},{"image_file":"H48103/Chassis_RAL/0036.png","css":"#004f7c","ral":"5010 BLU LUCIDO"},{"image_file":"H48103/Chassis_RAL/0037.png","css":"#9e9f98","ral":"7001 GRIGIO LUCIDO"},{"image_file":"H48103/Chassis_RAL/0038.png","css":"#a2a3a0","ral":"7040 GRIGIO LUCIDO"},{"image_file":"H48103/Chassis_RAL/0039.png","css":"#848074","ral":"7037 GRIGIO LUCIDO"},{"image_file":"H48103/Chassis_RAL/0040.png","css":"#b1a07a","ral":"1019 BEIGE OPACO"},{"image_file":"H48103/Chassis_RAL/0041.png","css":"#502b0a","ral":"8011 MARRONE LUCIDO"},{"image_file":"H48103/Chassis_RAL/0042.png","css":"#80020b","ral":"3003 ROSSO LUCIDO"},{"image_file":"H48103/Chassis_RAL/0043.png","css":"#35070c","ral":"3005 ROSSO LUCIDO"},{"image_file":"H48103/Chassis_RAL/0044.png","css":"#96b583","ral":"6021 VERDE OPACO"},{"image_file":"H48103/Chassis_RAL/0045.png","css":"#002811","ral":"6005 VERDE LUCIDO"},{"image_file":"H48103/Chassis_RAL/0046.png","css":"#f0bb69","ral":"Brass - R1"},{"image_file":"H48103/Chassis_RAL/0047.png","css":"#b8b8b8","ral":"Glossy Titanium - T2"},{"image_file":"H48103/Chassis_RAL/0048.png","css":"#b8b8b8","ral":"Titanium mat - T1"}]},{"handle":"H48106","colors":[{"image_file":"H48106/RAL/0001.png","color":"9010B white","color_css":"#fff","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0002.png","color":"7035S light_grey","color_css":"#dad9d8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0004.png","color":"7016S antracite","color_css":"#272e38","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0009.png","color":"1015S light_ivory","color_css":"#f2e8c6","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0011.png","color":"9005S jet_black","color_css":"#000","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0018.png","color":"8019SM","color_css":"#40312e","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0020.png","color":"9007SM","color_css":"#87888a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0034.png","color":"1013 AVORIO LUCIDO","color_css":"#dbd6bf","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0035.png","color":"9002 BIANCO LUCIDO","color_css":"#cdcbbb","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0036.png","color":"5010 BLU LUCIDO","color_css":"#004f7c","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0037.png","color":"7001 GRIGIO LUCIDO","color_css":"#9e9f98","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0038.png","color":"7040 GRIGIO LUCIDO","color_css":"#a2a3a0","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0039.png","color":"7037 GRIGIO LUCIDO","color_css":"#848074","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0040.png","color":"1019 BEIGE OPACO","color_css":"#b1a07a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0041.png","color":"8011 MARRONE LUCIDO","color_css":"#502b0a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0042.png","color":"3003 ROSSO LUCIDO","color_css":"#80020b","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0043.png","color":"3005 ROSSO LUCIDO","color_css":"#35070c","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0044.png","color":"6021 VERDE OPACO","color_css":"#96b583","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0045.png","color":"6005 VERDE LUCIDO","color_css":"#002811","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0046.png","color":"Brass - R1","color_css":"#f0bb69","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0047.png","color":"Glossy Titanium - T2","color_css":"#b8b8b8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/RAL/0048.png","color":"Titanium mat - T1","color_css":"#b8b8b8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48106/Anodized/0001.png","color":"anodic_anod","color_css":"#cbc6c2","color_type":"anodized","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48106/Chassis_RAL/0001.png","css":"#fff","ral":"9010B"},{"image_file":"H48106/Chassis_RAL/0002.png","css":"#dad9d8","ral":"7035S"},{"image_file":"H48106/Chassis_RAL/0004.png","css":"#272e38","ral":"7016S"},{"image_file":"H48106/Chassis_RAL/0009.png","css":"#f2e8c6","ral":"1015S"},{"image_file":"H48106/Chassis_RAL/0011.png","css":"#000","ral":"9005S"},{"image_file":"H48106/Chassis_RAL/0018.png","css":"#40312e","ral":"8019SM"},{"image_file":"H48106/Chassis_RAL/0020.png","css":"#87888a","ral":"9007SM"},{"image_file":"H48106/Chassis_RAL/0034.png","css":"#dbd6bf","ral":"1013 AVORIO LUCIDO"},{"image_file":"H48106/Chassis_RAL/0035.png","css":"#cdcbbb","ral":"9002 BIANCO LUCIDO"},{"image_file":"H48106/Chassis_RAL/0036.png","css":"#004f7c","ral":"5010 BLU LUCIDO"},{"image_file":"H48106/Chassis_RAL/0037.png","css":"#9e9f98","ral":"7001 GRIGIO LUCIDO"},{"image_file":"H48106/Chassis_RAL/0038.png","css":"#a2a3a0","ral":"7040 GRIGIO LUCIDO"},{"image_file":"H48106/Chassis_RAL/0039.png","css":"#848074","ral":"7037 GRIGIO LUCIDO"},{"image_file":"H48106/Chassis_RAL/0040.png","css":"#b1a07a","ral":"1019 BEIGE OPACO"},{"image_file":"H48106/Chassis_RAL/0041.png","css":"#502b0a","ral":"8011 MARRONE LUCIDO"},{"image_file":"H48106/Chassis_RAL/0042.png","css":"#80020b","ral":"3003 ROSSO LUCIDO"},{"image_file":"H48106/Chassis_RAL/0043.png","css":"#35070c","ral":"3005 ROSSO LUCIDO"},{"image_file":"H48106/Chassis_RAL/0044.png","css":"#96b583","ral":"6021 VERDE OPACO"},{"image_file":"H48106/Chassis_RAL/0045.png","css":"#002811","ral":"6005 VERDE LUCIDO"},{"image_file":"H48106/Chassis_RAL/0046.png","css":"#f0bb69","ral":"Brass - R1"},{"image_file":"H48106/Chassis_RAL/0047.png","css":"#b8b8b8","ral":"Glossy Titanium - T2"},{"image_file":"H48106/Chassis_RAL/0048.png","css":"#b8b8b8","ral":"Titanium mat - T1"}]},{"handle":"H48010","colors":[{"image_file":"H48010/RAL/0001.png","color":"9010B white","color_css":"#fff","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0002.png","color":"7035S light_grey","color_css":"#dad9d8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0004.png","color":"7016S antracite","color_css":"#272e38","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0009.png","color":"1015S light_ivory","color_css":"#f2e8c6","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0011.png","color":"9005S jet_black","color_css":"#000","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0018.png","color":"8019SM","color_css":"#40312e","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0020.png","color":"9007SM","color_css":"#87888a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0034.png","color":"1013 AVORIO LUCIDO","color_css":"#dbd6bf","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0035.png","color":"9002 BIANCO LUCIDO","color_css":"#cdcbbb","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0036.png","color":"5010 BLU LUCIDO","color_css":"#004f7c","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0037.png","color":"7001 GRIGIO LUCIDO","color_css":"#9e9f98","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0038.png","color":"7040 GRIGIO LUCIDO","color_css":"#a2a3a0","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0039.png","color":"7037 GRIGIO LUCIDO","color_css":"#848074","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0040.png","color":"1019 BEIGE OPACO","color_css":"#b1a07a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0041.png","color":"8011 MARRONE LUCIDO","color_css":"#502b0a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0042.png","color":"3003 ROSSO LUCIDO","color_css":"#80020b","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0043.png","color":"3005 ROSSO LUCIDO","color_css":"#35070c","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0044.png","color":"6021 VERDE OPACO","color_css":"#96b583","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0045.png","color":"6005 VERDE LUCIDO","color_css":"#002811","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0046.png","color":"Brass - R1","color_css":"#f0bb69","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0047.png","color":"Glossy Titanium - T2","color_css":"#b8b8b8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48010/RAL/0048.png","color":"Titanium mat - T1","color_css":"#b8b8b8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48010/Chassis_RAL/0001.png","css":"#fff","ral":"9010B"},{"image_file":"H48010/Chassis_RAL/0002.png","css":"#dad9d8","ral":"7035S"},{"image_file":"H48010/Chassis_RAL/0004.png","css":"#272e38","ral":"7016S"},{"image_file":"H48010/Chassis_RAL/0009.png","css":"#f2e8c6","ral":"1015S"},{"image_file":"H48010/Chassis_RAL/0011.png","css":"#000","ral":"9005S"},{"image_file":"H48010/Chassis_RAL/0018.png","css":"#40312e","ral":"8019SM"},{"image_file":"H48010/Chassis_RAL/0020.png","css":"#87888a","ral":"9007SM"},{"image_file":"H48010/Chassis_RAL/0034.png","css":"#dbd6bf","ral":"1013 AVORIO LUCIDO"},{"image_file":"H48010/Chassis_RAL/0035.png","css":"#cdcbbb","ral":"9002 BIANCO LUCIDO"},{"image_file":"H48010/Chassis_RAL/0036.png","css":"#004f7c","ral":"5010 BLU LUCIDO"},{"image_file":"H48010/Chassis_RAL/0037.png","css":"#9e9f98","ral":"7001 GRIGIO LUCIDO"},{"image_file":"H48010/Chassis_RAL/0038.png","css":"#a2a3a0","ral":"7040 GRIGIO LUCIDO"},{"image_file":"H48010/Chassis_RAL/0039.png","css":"#848074","ral":"7037 GRIGIO LUCIDO"},{"image_file":"H48010/Chassis_RAL/0040.png","css":"#b1a07a","ral":"1019 BEIGE OPACO"},{"image_file":"H48010/Chassis_RAL/0041.png","css":"#502b0a","ral":"8011 MARRONE LUCIDO"},{"image_file":"H48010/Chassis_RAL/0042.png","css":"#80020b","ral":"3003 ROSSO LUCIDO"},{"image_file":"H48010/Chassis_RAL/0043.png","css":"#35070c","ral":"3005 ROSSO LUCIDO"},{"image_file":"H48010/Chassis_RAL/0044.png","css":"#96b583","ral":"6021 VERDE OPACO"},{"image_file":"H48010/Chassis_RAL/0045.png","css":"#002811","ral":"6005 VERDE LUCIDO"},{"image_file":"H48010/Chassis_RAL/0046.png","css":"#f0bb69","ral":"Brass - R1"},{"image_file":"H48010/Chassis_RAL/0047.png","css":"#b8b8b8","ral":"Glossy Titanium - T2"},{"image_file":"H48010/Chassis_RAL/0048.png","css":"#b8b8b8","ral":"Titanium mat - T1"}]},{"handle":"H48012","colors":[{"image_file":"H48012/RAL/0001.png","color":"9010B white","color_css":"#fff","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0002.png","color":"7035S light_grey","color_css":"#dad9d8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0004.png","color":"7016S antracite","color_css":"#272e38","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0009.png","color":"1015S light_ivory","color_css":"#f2e8c6","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0011.png","color":"9005S jet_black","color_css":"#000","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0018.png","color":"8019SM","color_css":"#40312e","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0020.png","color":"9007SM","color_css":"#87888a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0034.png","color":"1013 AVORIO LUCIDO","color_css":"#dbd6bf","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0035.png","color":"9002 BIANCO LUCIDO","color_css":"#cdcbbb","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0036.png","color":"5010 BLU LUCIDO","color_css":"#004f7c","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0037.png","color":"7001 GRIGIO LUCIDO","color_css":"#9e9f98","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0038.png","color":"7040 GRIGIO LUCIDO","color_css":"#a2a3a0","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0039.png","color":"7037 GRIGIO LUCIDO","color_css":"#848074","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0040.png","color":"1019 BEIGE OPACO","color_css":"#b1a07a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0041.png","color":"8011 MARRONE LUCIDO","color_css":"#502b0a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0042.png","color":"3003 ROSSO LUCIDO","color_css":"#80020b","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0043.png","color":"3005 ROSSO LUCIDO","color_css":"#35070c","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0044.png","color":"6021 VERDE OPACO","color_css":"#96b583","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0045.png","color":"6005 VERDE LUCIDO","color_css":"#002811","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0046.png","color":"Brass - R1","color_css":"#f0bb69","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0047.png","color":"Glossy Titanium - T2","color_css":"#b8b8b8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48012/RAL/0048.png","color":"Titanium mat - T1","color_css":"#b8b8b8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48012/Chassis_RAL/0001.png","css":"#fff","ral":"9010B"},{"image_file":"H48012/Chassis_RAL/0002.png","css":"#dad9d8","ral":"7035S"},{"image_file":"H48012/Chassis_RAL/0004.png","css":"#272e38","ral":"7016S"},{"image_file":"H48012/Chassis_RAL/0009.png","css":"#f2e8c6","ral":"1015S"},{"image_file":"H48012/Chassis_RAL/0011.png","css":"#000","ral":"9005S"},{"image_file":"H48012/Chassis_RAL/0018.png","css":"#40312e","ral":"8019SM"},{"image_file":"H48012/Chassis_RAL/0020.png","css":"#87888a","ral":"9007SM"},{"image_file":"H48012/Chassis_RAL/0034.png","css":"#dbd6bf","ral":"1013 AVORIO LUCIDO"},{"image_file":"H48012/Chassis_RAL/0035.png","css":"#cdcbbb","ral":"9002 BIANCO LUCIDO"},{"image_file":"H48012/Chassis_RAL/0036.png","css":"#004f7c","ral":"5010 BLU LUCIDO"},{"image_file":"H48012/Chassis_RAL/0037.png","css":"#9e9f98","ral":"7001 GRIGIO LUCIDO"},{"image_file":"H48012/Chassis_RAL/0038.png","css":"#a2a3a0","ral":"7040 GRIGIO LUCIDO"},{"image_file":"H48012/Chassis_RAL/0039.png","css":"#848074","ral":"7037 GRIGIO LUCIDO"},{"image_file":"H48012/Chassis_RAL/0040.png","css":"#b1a07a","ral":"1019 BEIGE OPACO"},{"image_file":"H48012/Chassis_RAL/0041.png","css":"#502b0a","ral":"8011 MARRONE LUCIDO"},{"image_file":"H48012/Chassis_RAL/0042.png","css":"#80020b","ral":"3003 ROSSO LUCIDO"},{"image_file":"H48012/Chassis_RAL/0043.png","css":"#35070c","ral":"3005 ROSSO LUCIDO"},{"image_file":"H48012/Chassis_RAL/0044.png","css":"#96b583","ral":"6021 VERDE OPACO"},{"image_file":"H48012/Chassis_RAL/0045.png","css":"#002811","ral":"6005 VERDE LUCIDO"},{"image_file":"H48012/Chassis_RAL/0046.png","css":"#f0bb69","ral":"Brass - R1"},{"image_file":"H48012/Chassis_RAL/0047.png","css":"#b8b8b8","ral":"Glossy Titanium - T2"},{"image_file":"H48012/Chassis_RAL/0048.png","css":"#b8b8b8","ral":"Titanium mat - T1"}]},{"handle":"H48104","colors":[{"image_file":"H48104/RAL/0001.png","color":"9010B white","color_css":"#fff","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0002.png","color":"7035S light_grey","color_css":"#dad9d8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0004.png","color":"7016S antracite","color_css":"#272e38","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0009.png","color":"1015S light_ivory","color_css":"#f2e8c6","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0011.png","color":"9005S jet_black","color_css":"#000","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0018.png","color":"8019SM","color_css":"#40312e","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0020.png","color":"9007SM","color_css":"#87888a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0034.png","color":"1013 AVORIO LUCIDO","color_css":"#dbd6bf","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0035.png","color":"9002 BIANCO LUCIDO","color_css":"#cdcbbb","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0036.png","color":"5010 BLU LUCIDO","color_css":"#004f7c","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0037.png","color":"7001 GRIGIO LUCIDO","color_css":"#9e9f98","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0038.png","color":"7040 GRIGIO LUCIDO","color_css":"#a2a3a0","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0039.png","color":"7037 GRIGIO LUCIDO","color_css":"#848074","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0040.png","color":"1019 BEIGE OPACO","color_css":"#b1a07a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0041.png","color":"8011 MARRONE LUCIDO","color_css":"#502b0a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0042.png","color":"3003 ROSSO LUCIDO","color_css":"#80020b","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0043.png","color":"3005 ROSSO LUCIDO","color_css":"#35070c","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0044.png","color":"6021 VERDE OPACO","color_css":"#96b583","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0045.png","color":"6005 VERDE LUCIDO","color_css":"#002811","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0046.png","color":"Brass - R1","color_css":"#f0bb69","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0047.png","color":"Glossy Titanium - T2","color_css":"#b8b8b8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/RAL/0048.png","color":"Titanium mat - T1","color_css":"#b8b8b8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/Anodized/0001.png","color":"anodic_anod","color_css":"#cbc6c2","color_type":"anodized","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N01_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N01_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N01_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N01_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N01_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N01_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N01_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N01_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N01_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N01_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N01_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N01_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N01_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N01_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N01_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N01_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N01_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N01_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N02_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N02_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N02_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N02_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N02_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N02_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N02_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N02_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N02_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N02_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N02_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N02_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N02_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N02_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N02_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N02_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N02_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N02_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N03_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N03_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N03_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N03_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N03_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N03_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N03_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N03_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N03_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N03_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N03_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N03_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N03_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N03_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N03_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N03_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N03_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N03_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0031.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N04_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N04_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N04_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N04_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N04_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N04_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N04_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N04_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N04_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N04_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N04_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N04_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N04_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N04_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N04_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N04_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N04_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N04_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0026.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N05_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N05_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N05_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N05_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N05_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N05_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N05_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N05_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N05_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N05_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N05_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N05_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N05_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N05_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N05_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N05_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N05_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N05_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0028.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N06_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N06_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N06_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N06_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N06_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N06_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N06_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N06_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N06_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N06_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N06_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N06_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N06_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N06_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N06_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N06_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N06_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N06_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0025.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N07","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0027.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N08_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N08_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N08_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N08_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N08_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N08_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N08_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N08_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N08_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N08_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N08_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N08_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N08_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N08_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N08_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N08_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N08_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N08_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0035.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/C06_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/C06_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/C06_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/C06_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/C06_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/C06_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/C06_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/C06_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/C06_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/C06_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/C06_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/C06_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/C06_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/C06_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/C06_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/C06_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/C06_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/C06_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0036.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/C07_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/C07_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/C07_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/C07_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/C07_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/C07_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/C07_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/C07_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/C07_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/C07_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/C07_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/C07_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/C07_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/C07_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/C07_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/C07_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/C07_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/C07_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0037.png","color":"black","color_css":"#000","color_type":"decor","ornament":"C08","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G01_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G01_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G01_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G01_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G01_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G01_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G01_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G01_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G01_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G01_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G01_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G01_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G01_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G01_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G01_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G01_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G01_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G01_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G02_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G02_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G02_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G02_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G02_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G02_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G02_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G02_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G02_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G02_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G02_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G02_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G02_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G02_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G02_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G02_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G02_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G02_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G03_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G03_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G03_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G03_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G03_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G03_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G03_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G03_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G03_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G03_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G03_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G03_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G03_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G03_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G03_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G03_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G03_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G03_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G04_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G04_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G04_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G04_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G04_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G04_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G04_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G04_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G04_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G04_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G04_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G04_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G04_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G04_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G04_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G04_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G04_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G04_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G05_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G05_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G05_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G05_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G05_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G05_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G05_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G05_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G05_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G05_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G05_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G05_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G05_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G05_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G05_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G05_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G05_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G05_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G06_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G06_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G06_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G06_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G06_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G06_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G06_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G06_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G06_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G06_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G06_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G06_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G06_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G06_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G06_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G06_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G06_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G06_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G07_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G07_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G07_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G07_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G07_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G07_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G07_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G07_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G07_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G07_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G07_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G07_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G07_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G07_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G07_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G07_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G07_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G07_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0032.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G08_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G08_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G08_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G08_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G08_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G08_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G08_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G08_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G08_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G08_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G08_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G08_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G08_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G08_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G08_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G08_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G08_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G08_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0033.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G09_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G09_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G09_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G09_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G09_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G09_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G09_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G09_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G09_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G09_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G09_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G09_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G09_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G09_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G09_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G09_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G09_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G09_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0034.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G10_black/0001.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G10_black/0002.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G10_black/0003.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G10_black/0004.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G10_black/0005.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G10_black/0006.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G10_black/0007.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G10_black/0008.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G10_black/0009.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G10_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G10_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G10_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G10_black/0013.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G10_black/0014.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G10_black/0015.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G10_black/0016.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G10_black/0017.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G10_black/0018.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_black/0038.png","color":"black","color_css":"#000","color_type":"decor","ornament":"G11","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0010.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M01","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0011.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M02","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0012.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M03","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0019.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M04","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0020.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M05","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0021.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M06","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0022.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M07","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0023.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M08","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0024.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M09","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0029.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M10","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_black/0030.png","color":"black","color_css":"#000","color_type":"decor","ornament":"M11","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N01_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N01_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N01_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N01_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N01_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N01_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N01_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N01_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N01_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N01_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N01_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N01_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N01_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N01_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N01_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N01_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N01_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N01_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N01","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N02_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N02_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N02_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N02_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N02_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N02_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N02_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N02_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N02_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N02_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N02_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N02_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N02_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N02_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N02_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N02_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N02_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N02_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N02","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N03_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N03_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N03_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N03_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N03_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N03_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N03_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N03_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N03_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N03_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N03_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N03_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N03_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N03_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N03_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N03_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N03_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N03_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N03","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0031.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N04_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N04_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N04_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N04_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N04_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N04_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N04_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N04_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N04_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N04_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N04_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N04_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N04_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N04_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N04_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N04_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N04_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N04_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N04","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0026.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N05_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N05_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N05_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N05_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N05_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N05_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N05_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N05_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N05_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N05_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N05_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N05_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N05_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N05_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N05_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N05_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N05_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N05_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N05","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0028.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N06_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N06_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N06_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N06_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N06_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N06_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N06_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N06_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N06_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N06_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N06_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N06_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N06_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N06_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N06_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N06_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N06_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N06_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N06","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0025.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N07","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0027.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/N08_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/N08_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/N08_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/N08_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/N08_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/N08_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/N08_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/N08_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/N08_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/N08_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/N08_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/N08_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/N08_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/N08_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/N08_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/N08_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/N08_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/N08_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"N08","ornament_category":"Nature","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0035.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/C06_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/C06_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/C06_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/C06_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/C06_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/C06_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/C06_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/C06_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/C06_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/C06_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/C06_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/C06_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/C06_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/C06_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/C06_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/C06_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/C06_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/C06_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C06","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0036.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/C07_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/C07_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/C07_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/C07_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/C07_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/C07_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/C07_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/C07_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/C07_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/C07_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/C07_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/C07_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/C07_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/C07_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/C07_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/C07_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/C07_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/C07_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C07","ornament_category":"Classic","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0037.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"C08","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G01_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G01_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G01_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G01_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G01_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G01_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G01_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G01_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G01_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G01_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G01_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G01_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G01_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G01_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G01_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G01_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G01_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G01_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G01","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G02_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G02_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G02_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G02_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G02_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G02_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G02_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G02_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G02_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G02_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G02_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G02_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G02_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G02_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G02_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G02_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G02_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G02_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G02","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G03_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G03_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G03_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G03_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G03_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G03_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G03_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G03_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G03_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G03_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G03_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G03_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G03_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G03_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G03_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G03_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G03_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G03_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G03","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G04_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G04_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G04_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G04_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G04_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G04_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G04_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G04_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G04_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G04_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G04_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G04_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G04_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G04_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G04_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G04_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G04_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G04_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G04","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G05_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G05_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G05_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G05_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G05_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G05_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G05_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G05_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G05_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G05_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G05_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G05_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G05_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G05_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G05_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G05_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G05_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G05_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G05","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G06_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G06_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G06_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G06_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G06_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G06_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G06_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G06_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G06_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G06_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G06_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G06_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G06_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G06_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G06_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G06_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G06_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G06_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G06","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G07_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G07_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G07_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G07_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G07_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G07_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G07_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G07_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G07_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G07_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G07_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G07_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G07_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G07_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G07_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G07_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G07_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G07_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G07","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0032.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G08_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G08_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G08_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G08_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G08_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G08_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G08_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G08_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G08_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G08_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G08_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G08_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G08_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G08_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G08_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G08_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G08_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G08_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G08","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0033.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G09_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G09_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G09_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G09_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G09_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G09_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G09_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G09_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G09_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G09_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G09_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G09_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G09_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G09_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G09_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G09_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G09_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G09_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G09","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0034.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors_colored/G10_white/0001.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"01","ornament_css":"#9a1630"},{"image_file":"H48104/Decors_colored/G10_white/0002.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"02","ornament_css":"#954f4c"},{"image_file":"H48104/Decors_colored/G10_white/0003.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"03","ornament_css":"#dd4121"},{"image_file":"H48104/Decors_colored/G10_white/0004.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"04","ornament_css":"#f9e03c"},{"image_file":"H48104/Decors_colored/G10_white/0005.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"05","ornament_css":"#e2e75b"},{"image_file":"H48104/Decors_colored/G10_white/0006.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"06","ornament_css":"#86af4a"},{"image_file":"H48104/Decors_colored/G10_white/0007.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"07","ornament_css":"#0083a9"},{"image_file":"H48104/Decors_colored/G10_white/0008.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"08","ornament_css":"#90a7cf"},{"image_file":"H48104/Decors_colored/G10_white/0009.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"09","ornament_css":"#005394"},{"image_file":"H48104/Decors_colored/G10_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"10","ornament_css":"#9e2b6a"},{"image_file":"H48104/Decors_colored/G10_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"11","ornament_css":"#ac5e98"},{"image_file":"H48104/Decors_colored/G10_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"12","ornament_css":"#e9cdd0"},{"image_file":"H48104/Decors_colored/G10_white/0013.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"13","ornament_css":"#adb1b4"},{"image_file":"H48104/Decors_colored/G10_white/0014.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"14","ornament_css":"#25282a"},{"image_file":"H48104/Decors_colored/G10_white/0015.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"15","ornament_css":"#d6cfc7"},{"image_file":"H48104/Decors_colored/G10_white/0016.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"16","ornament_css":"#ae9382"},{"image_file":"H48104/Decors_colored/G10_white/0017.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"17","ornament_css":"#776a5f"},{"image_file":"H48104/Decors_colored/G10_white/0018.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G10","ornament_category":"Geometry","ornament_color":"18","ornament_css":"#cda786"},{"image_file":"H48104/Decors/Decors_white/0038.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"G11","ornament_category":"Geometry","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0010.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M01","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0011.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M02","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0012.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M03","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0019.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M04","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0020.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M05","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0021.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M06","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0022.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M07","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0023.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M08","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0024.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M09","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0029.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M10","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Decors/Decors_white/0030.png","color":"white","color_css":"#fff","color_type":"decor","ornament":"M11","ornament_category":"Material","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_black/0001.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_black/0002.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_black/0003.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_black/0004.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_black/0005.png","color":"black","color_css":"#000","color_type":"custom","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_white/0001.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C01","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_white/0002.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C02","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_white/0003.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C03","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_white/0004.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C04","ornament_category":"Classic","ornament_color":null,"ornament_css":null},{"image_file":"H48104/Customs/Customs_white/0005.png","color":"white","color_css":"#fff","color_type":"custom","ornament":"C05","ornament_category":"Classic","ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48104/Chassis_RAL/0001.png","css":"#fff","ral":"9010B"},{"image_file":"H48104/Chassis_RAL/0002.png","css":"#dad9d8","ral":"7035S"},{"image_file":"H48104/Chassis_RAL/0004.png","css":"#272e38","ral":"7016S"},{"image_file":"H48104/Chassis_RAL/0009.png","css":"#f2e8c6","ral":"1015S"},{"image_file":"H48104/Chassis_RAL/0011.png","css":"#000","ral":"9005S"},{"image_file":"H48104/Chassis_RAL/0018.png","css":"#40312e","ral":"8019SM"},{"image_file":"H48104/Chassis_RAL/0020.png","css":"#87888a","ral":"9007SM"},{"image_file":"H48104/Chassis_RAL/0034.png","css":"#dbd6bf","ral":"1013 AVORIO LUCIDO"},{"image_file":"H48104/Chassis_RAL/0035.png","css":"#cdcbbb","ral":"9002 BIANCO LUCIDO"},{"image_file":"H48104/Chassis_RAL/0036.png","css":"#004f7c","ral":"5010 BLU LUCIDO"},{"image_file":"H48104/Chassis_RAL/0037.png","css":"#9e9f98","ral":"7001 GRIGIO LUCIDO"},{"image_file":"H48104/Chassis_RAL/0038.png","css":"#a2a3a0","ral":"7040 GRIGIO LUCIDO"},{"image_file":"H48104/Chassis_RAL/0039.png","css":"#848074","ral":"7037 GRIGIO LUCIDO"},{"image_file":"H48104/Chassis_RAL/0040.png","css":"#b1a07a","ral":"1019 BEIGE OPACO"},{"image_file":"H48104/Chassis_RAL/0041.png","css":"#502b0a","ral":"8011 MARRONE LUCIDO"},{"image_file":"H48104/Chassis_RAL/0042.png","css":"#80020b","ral":"3003 ROSSO LUCIDO"},{"image_file":"H48104/Chassis_RAL/0043.png","css":"#35070c","ral":"3005 ROSSO LUCIDO"},{"image_file":"H48104/Chassis_RAL/0044.png","css":"#96b583","ral":"6021 VERDE OPACO"},{"image_file":"H48104/Chassis_RAL/0045.png","css":"#002811","ral":"6005 VERDE LUCIDO"},{"image_file":"H48104/Chassis_RAL/0046.png","css":"#f0bb69","ral":"Brass - R1"},{"image_file":"H48104/Chassis_RAL/0047.png","css":"#b8b8b8","ral":"Glossy Titanium - T2"},{"image_file":"H48104/Chassis_RAL/0048.png","css":"#b8b8b8","ral":"Titanium mat - T1"}]},{"handle":"H48107","colors":[{"image_file":"H48107/RAL/0001.png","color":"9010B white","color_css":"#fff","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0002.png","color":"7035S light_grey","color_css":"#dad9d8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0004.png","color":"7016S antracite","color_css":"#272e38","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0009.png","color":"1015S light_ivory","color_css":"#f2e8c6","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0011.png","color":"9005S jet_black","color_css":"#000","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0018.png","color":"8019SM","color_css":"#40312e","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0020.png","color":"9007SM","color_css":"#87888a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0034.png","color":"1013 AVORIO LUCIDO","color_css":"#dbd6bf","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0035.png","color":"9002 BIANCO LUCIDO","color_css":"#cdcbbb","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0036.png","color":"5010 BLU LUCIDO","color_css":"#004f7c","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0037.png","color":"7001 GRIGIO LUCIDO","color_css":"#9e9f98","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0038.png","color":"7040 GRIGIO LUCIDO","color_css":"#a2a3a0","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0039.png","color":"7037 GRIGIO LUCIDO","color_css":"#848074","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0040.png","color":"1019 BEIGE OPACO","color_css":"#b1a07a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0041.png","color":"8011 MARRONE LUCIDO","color_css":"#502b0a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0042.png","color":"3003 ROSSO LUCIDO","color_css":"#80020b","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0043.png","color":"3005 ROSSO LUCIDO","color_css":"#35070c","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0044.png","color":"6021 VERDE OPACO","color_css":"#96b583","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0045.png","color":"6005 VERDE LUCIDO","color_css":"#002811","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0046.png","color":"Brass - R1","color_css":"#f0bb69","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0047.png","color":"Glossy Titanium - T2","color_css":"#b8b8b8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/RAL/0048.png","color":"Titanium mat - T1","color_css":"#b8b8b8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48107/Anodized/0001.png","color":"anodic_anod","color_css":"#cbc6c2","color_type":"anodized","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48107/Chassis_RAL/0001.png","css":"#fff","ral":"9010B"},{"image_file":"H48107/Chassis_RAL/0002.png","css":"#dad9d8","ral":"7035S"},{"image_file":"H48107/Chassis_RAL/0004.png","css":"#272e38","ral":"7016S"},{"image_file":"H48107/Chassis_RAL/0009.png","css":"#f2e8c6","ral":"1015S"},{"image_file":"H48107/Chassis_RAL/0011.png","css":"#000","ral":"9005S"},{"image_file":"H48107/Chassis_RAL/0018.png","css":"#40312e","ral":"8019SM"},{"image_file":"H48107/Chassis_RAL/0020.png","css":"#87888a","ral":"9007SM"},{"image_file":"H48107/Chassis_RAL/0034.png","css":"#dbd6bf","ral":"1013 AVORIO LUCIDO"},{"image_file":"H48107/Chassis_RAL/0035.png","css":"#cdcbbb","ral":"9002 BIANCO LUCIDO"},{"image_file":"H48107/Chassis_RAL/0036.png","css":"#004f7c","ral":"5010 BLU LUCIDO"},{"image_file":"H48107/Chassis_RAL/0037.png","css":"#9e9f98","ral":"7001 GRIGIO LUCIDO"},{"image_file":"H48107/Chassis_RAL/0038.png","css":"#a2a3a0","ral":"7040 GRIGIO LUCIDO"},{"image_file":"H48107/Chassis_RAL/0039.png","css":"#848074","ral":"7037 GRIGIO LUCIDO"},{"image_file":"H48107/Chassis_RAL/0040.png","css":"#b1a07a","ral":"1019 BEIGE OPACO"},{"image_file":"H48107/Chassis_RAL/0041.png","css":"#502b0a","ral":"8011 MARRONE LUCIDO"},{"image_file":"H48107/Chassis_RAL/0042.png","css":"#80020b","ral":"3003 ROSSO LUCIDO"},{"image_file":"H48107/Chassis_RAL/0043.png","css":"#35070c","ral":"3005 ROSSO LUCIDO"},{"image_file":"H48107/Chassis_RAL/0044.png","css":"#96b583","ral":"6021 VERDE OPACO"},{"image_file":"H48107/Chassis_RAL/0045.png","css":"#002811","ral":"6005 VERDE LUCIDO"},{"image_file":"H48107/Chassis_RAL/0046.png","css":"#f0bb69","ral":"Brass - R1"},{"image_file":"H48107/Chassis_RAL/0047.png","css":"#b8b8b8","ral":"Glossy Titanium - T2"},{"image_file":"H48107/Chassis_RAL/0048.png","css":"#b8b8b8","ral":"Titanium mat - T1"}]},{"handle":"H48011","colors":[{"image_file":"H48011/RAL/0001.png","color":"9010B white","color_css":"#fff","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0002.png","color":"7035S light_grey","color_css":"#dad9d8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0004.png","color":"7016S antracite","color_css":"#272e38","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0009.png","color":"1015S light_ivory","color_css":"#f2e8c6","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0011.png","color":"9005S jet_black","color_css":"#000","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0018.png","color":"8019SM","color_css":"#40312e","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0020.png","color":"9007SM","color_css":"#87888a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0034.png","color":"1013 AVORIO LUCIDO","color_css":"#dbd6bf","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0035.png","color":"9002 BIANCO LUCIDO","color_css":"#cdcbbb","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0036.png","color":"5010 BLU LUCIDO","color_css":"#004f7c","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0037.png","color":"7001 GRIGIO LUCIDO","color_css":"#9e9f98","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0038.png","color":"7040 GRIGIO LUCIDO","color_css":"#a2a3a0","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0039.png","color":"7037 GRIGIO LUCIDO","color_css":"#848074","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0040.png","color":"1019 BEIGE OPACO","color_css":"#b1a07a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0041.png","color":"8011 MARRONE LUCIDO","color_css":"#502b0a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0042.png","color":"3003 ROSSO LUCIDO","color_css":"#80020b","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0043.png","color":"3005 ROSSO LUCIDO","color_css":"#35070c","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0044.png","color":"6021 VERDE OPACO","color_css":"#96b583","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0045.png","color":"6005 VERDE LUCIDO","color_css":"#002811","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0046.png","color":"Brass - R1","color_css":"#f0bb69","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0047.png","color":"Glossy Titanium - T2","color_css":"#b8b8b8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48011/RAL/0048.png","color":"Titanium mat - T1","color_css":"#b8b8b8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48011/Chassis_RAL/0001.png","css":"#fff","ral":"9010B"},{"image_file":"H48011/Chassis_RAL/0002.png","css":"#dad9d8","ral":"7035S"},{"image_file":"H48011/Chassis_RAL/0004.png","css":"#272e38","ral":"7016S"},{"image_file":"H48011/Chassis_RAL/0009.png","css":"#f2e8c6","ral":"1015S"},{"image_file":"H48011/Chassis_RAL/0011.png","css":"#000","ral":"9005S"},{"image_file":"H48011/Chassis_RAL/0018.png","css":"#40312e","ral":"8019SM"},{"image_file":"H48011/Chassis_RAL/0020.png","css":"#87888a","ral":"9007SM"},{"image_file":"H48011/Chassis_RAL/0034.png","css":"#dbd6bf","ral":"1013 AVORIO LUCIDO"},{"image_file":"H48011/Chassis_RAL/0035.png","css":"#cdcbbb","ral":"9002 BIANCO LUCIDO"},{"image_file":"H48011/Chassis_RAL/0036.png","css":"#004f7c","ral":"5010 BLU LUCIDO"},{"image_file":"H48011/Chassis_RAL/0037.png","css":"#9e9f98","ral":"7001 GRIGIO LUCIDO"},{"image_file":"H48011/Chassis_RAL/0038.png","css":"#a2a3a0","ral":"7040 GRIGIO LUCIDO"},{"image_file":"H48011/Chassis_RAL/0039.png","css":"#848074","ral":"7037 GRIGIO LUCIDO"},{"image_file":"H48011/Chassis_RAL/0040.png","css":"#b1a07a","ral":"1019 BEIGE OPACO"},{"image_file":"H48011/Chassis_RAL/0041.png","css":"#502b0a","ral":"8011 MARRONE LUCIDO"},{"image_file":"H48011/Chassis_RAL/0042.png","css":"#80020b","ral":"3003 ROSSO LUCIDO"},{"image_file":"H48011/Chassis_RAL/0043.png","css":"#35070c","ral":"3005 ROSSO LUCIDO"},{"image_file":"H48011/Chassis_RAL/0044.png","css":"#96b583","ral":"6021 VERDE OPACO"},{"image_file":"H48011/Chassis_RAL/0045.png","css":"#002811","ral":"6005 VERDE LUCIDO"},{"image_file":"H48011/Chassis_RAL/0046.png","css":"#f0bb69","ral":"Brass - R1"},{"image_file":"H48011/Chassis_RAL/0047.png","css":"#b8b8b8","ral":"Glossy Titanium - T2"},{"image_file":"H48011/Chassis_RAL/0048.png","css":"#b8b8b8","ral":"Titanium mat - T1"}]},{"handle":"H48013","colors":[{"image_file":"H48013/RAL/0001.png","color":"9010B white","color_css":"#fff","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0002.png","color":"7035S light_grey","color_css":"#dad9d8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0004.png","color":"7016S antracite","color_css":"#272e38","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0009.png","color":"1015S light_ivory","color_css":"#f2e8c6","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0011.png","color":"9005S jet_black","color_css":"#000","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0018.png","color":"8019SM","color_css":"#40312e","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0020.png","color":"9007SM","color_css":"#87888a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0034.png","color":"1013 AVORIO LUCIDO","color_css":"#dbd6bf","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0035.png","color":"9002 BIANCO LUCIDO","color_css":"#cdcbbb","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0036.png","color":"5010 BLU LUCIDO","color_css":"#004f7c","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0037.png","color":"7001 GRIGIO LUCIDO","color_css":"#9e9f98","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0038.png","color":"7040 GRIGIO LUCIDO","color_css":"#a2a3a0","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0039.png","color":"7037 GRIGIO LUCIDO","color_css":"#848074","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0040.png","color":"1019 BEIGE OPACO","color_css":"#b1a07a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0041.png","color":"8011 MARRONE LUCIDO","color_css":"#502b0a","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0042.png","color":"3003 ROSSO LUCIDO","color_css":"#80020b","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0043.png","color":"3005 ROSSO LUCIDO","color_css":"#35070c","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0044.png","color":"6021 VERDE OPACO","color_css":"#96b583","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0045.png","color":"6005 VERDE LUCIDO","color_css":"#002811","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0046.png","color":"Brass - R1","color_css":"#f0bb69","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0047.png","color":"Glossy Titanium - T2","color_css":"#b8b8b8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null},{"image_file":"H48013/RAL/0048.png","color":"Titanium mat - T1","color_css":"#b8b8b8","color_type":"ral","ornament":null,"ornament_category":null,"ornament_color":null,"ornament_css":null}],"backgroundFrames":[{"image_file":"H48013/Chassis_RAL/0001.png","css":"#fff","ral":"9010B"},{"image_file":"H48013/Chassis_RAL/0002.png","css":"#dad9d8","ral":"7035S"},{"image_file":"H48013/Chassis_RAL/0004.png","css":"#272e38","ral":"7016S"},{"image_file":"H48013/Chassis_RAL/0009.png","css":"#f2e8c6","ral":"1015S"},{"image_file":"H48013/Chassis_RAL/0011.png","css":"#000","ral":"9005S"},{"image_file":"H48013/Chassis_RAL/0018.png","css":"#40312e","ral":"8019SM"},{"image_file":"H48013/Chassis_RAL/0020.png","css":"#87888a","ral":"9007SM"},{"image_file":"H48013/Chassis_RAL/0034.png","css":"#dbd6bf","ral":"1013 AVORIO LUCIDO"},{"image_file":"H48013/Chassis_RAL/0035.png","css":"#cdcbbb","ral":"9002 BIANCO LUCIDO"},{"image_file":"H48013/Chassis_RAL/0036.png","css":"#004f7c","ral":"5010 BLU LUCIDO"},{"image_file":"H48013/Chassis_RAL/0037.png","css":"#9e9f98","ral":"7001 GRIGIO LUCIDO"},{"image_file":"H48013/Chassis_RAL/0038.png","css":"#a2a3a0","ral":"7040 GRIGIO LUCIDO"},{"image_file":"H48013/Chassis_RAL/0039.png","css":"#848074","ral":"7037 GRIGIO LUCIDO"},{"image_file":"H48013/Chassis_RAL/0040.png","css":"#b1a07a","ral":"1019 BEIGE OPACO"},{"image_file":"H48013/Chassis_RAL/0041.png","css":"#502b0a","ral":"8011 MARRONE LUCIDO"},{"image_file":"H48013/Chassis_RAL/0042.png","css":"#80020b","ral":"3003 ROSSO LUCIDO"},{"image_file":"H48013/Chassis_RAL/0043.png","css":"#35070c","ral":"3005 ROSSO LUCIDO"},{"image_file":"H48013/Chassis_RAL/0044.png","css":"#96b583","ral":"6021 VERDE OPACO"},{"image_file":"H48013/Chassis_RAL/0045.png","css":"#002811","ral":"6005 VERDE LUCIDO"},{"image_file":"H48013/Chassis_RAL/0046.png","css":"#f0bb69","ral":"Brass - R1"},{"image_file":"H48013/Chassis_RAL/0047.png","css":"#b8b8b8","ral":"Glossy Titanium - T2"},{"image_file":"H48013/Chassis_RAL/0048.png","css":"#b8b8b8","ral":"Titanium mat - T1"}]}]

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./H48010.png": 86,
	"./H48011.png": 87,
	"./H48012.png": 88,
	"./H48013.png": 89,
	"./H48103.png": 90,
	"./H48104.png": 91,
	"./H48106.png": 92,
	"./H48107.png": 93
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 265;

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_interactjs__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_interactjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_interactjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_slider__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_superagent__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_slider_assets_index_css__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_slider_assets_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rc_slider_assets_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Uploader__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__HandleEditor_css__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__HandleEditor_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__HandleEditor_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_env_json__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_env_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__config_env_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_params_json__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_params_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__config_params_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HandleEditor=function(_Component){_inherits(HandleEditor,_Component);function HandleEditor(props){_classCallCheck(this,HandleEditor);var _this=_possibleConstructorReturn(this,(HandleEditor.__proto__||Object.getPrototypeOf(HandleEditor)).call(this,props));_this.loadedCounter=0;_this.loadedAt=2;_this.key=new Date().valueOf();_this.canvas={w:827,h:2067};_this.state={gotFile:false};_this.coords={x:0,y:0,w:0,h:0,rotation:0,scale:1};_this.checkLoaded=_this.checkLoaded.bind(_this);_this.drawCanvas=_this.drawCanvas.bind(_this);_this.uploadedFile=_this.createLayer();_this.alphaMask=_this.createLayer();_this.guidesMask=_this.createLayer();return _this;}_createClass(HandleEditor,[{key:'createLayer',value:function createLayer(){var img=new window.Image();img.onload=this.checkLoaded;img.setAttribute('crossOrigin','anonymous');return img;}},{key:'checkLoaded',value:function checkLoaded(){this.loadedCounter++;if(this.loadedCounter===this.loadedAt){// create the invisible dragger (Boo Boo)
__WEBPACK_IMPORTED_MODULE_2_interactjs___default()('#editor').draggable({inertia:true,onmove:this.dragImage.bind(this)});var x=this.canvas.w/2-this.uploadedFile.width/2;var y=this.canvas.h/2-this.uploadedFile.height/2;this.setImageCoords(x,y);this.setImageSize(this.uploadedFile.width,this.uploadedFile.height);this.drawCanvas();}}},{key:'setImageCoords',value:function setImageCoords(x,y){this.coords.x=x;this.coords.y=y;}},{key:'setImageSize',value:function setImageSize(w,h){this.coords.w=w;this.coords.h=h;}},{key:'setImageRotation',value:function setImageRotation(rotation){this.coords.rotation=rotation;}},{key:'setScale',value:function setScale(scale){this.coords.scale=scale;}},{key:'dragImage',value:function dragImage(event){var x=this.coords.x*this.coords.scale+event.dx;var y=this.coords.y*this.coords.scale+event.dy;this.setImageCoords(x/this.coords.scale,y/this.coords.scale);this.drawCanvas();}},{key:'getImageCenter',value:function getImageCenter(){return{x:this.coords.x-this.coords.w/2,w:this.coords.y-this.coords.h/2};}},{key:'resizeImage',value:function resizeImage(value){var ratio=(value-25)*4/100;this.setScale(ratio+1);this.drawCanvas();}},{key:'rotateImage',value:function rotateImage(value){var degrees=(value-50)/5*9;this.setImageRotation(degrees);this.drawCanvas();}},{key:'drawCheckeredBackground',value:function drawCheckeredBackground(){// WIP
var editor=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.refs.editor);var ctx=editor.getContext('2d');// for (var i = 0; i < nRow; ++i) {
//   for (var j = 0, col = nCol / 2; j < col; ++j) {
//     ctx.rect(2 * j * w + (i % 2 ? 0 : w), i * h, w, h)
//   }
// }
ctx.fill();}},{key:'drawCanvas',value:function drawCanvas(){var toImage=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var editor=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.refs.editor);var ctx=editor.getContext('2d');// const radian = Math.PI / 180
// Delete everything before drawing again
ctx.clearRect(0,0,this.canvas.w,this.canvas.h);ctx.save();// draw the mask
ctx.globalCompositeOperation='source-over';if(!toImage){ctx.beginPath();ctx.rect(0,0,this.canvas.w,this.canvas.h);ctx.fillStyle='rgba(0, 0, 0, 0.2)';ctx.fill();}ctx.drawImage(this.alphaMask,0,0,this.canvas.w,this.canvas.h);// draw the uploaded file
ctx.globalCompositeOperation='source-in';if(this.uploadedFile.src){ctx.translate(this.canvas.w/2,this.canvas.h/2);ctx.scale(this.coords.scale,this.coords.scale);ctx.translate(this.canvas.w/2*-1,this.canvas.h/2*-1);ctx.drawImage(this.uploadedFile,this.coords.x,this.coords.y);}else{ctx.beginPath();ctx.rect(0,0,this.canvas.w,this.canvas.h);ctx.fillStyle='rgb(200, 200, 200)';ctx.fill();}ctx.restore();if(toImage){var customDesigns=__WEBPACK_IMPORTED_MODULE_4_store___default.a.get('customDesigns')||[];customDesigns.push({key:this.key,handle:this.props.handle,dataURL:editor.toDataURL(),originalFile:this.uploadedFile.src,coords:this.coords,canvas:this.canvas});__WEBPACK_IMPORTED_MODULE_4_store___default.a.set('customDesigns',customDesigns);}// add guides
ctx.globalCompositeOperation='source-over';ctx.drawImage(this.guidesMask,0,0,this.canvas.w,this.canvas.h);}},{key:'onUpload',value:function onUpload(res){this.loadedAt=3;this.uploadedFile.src=res;this.setState({gotFile:true});}},{key:'getPerspectiveView',value:function getPerspectiveView(callback){var _this2=this;var req=__WEBPACK_IMPORTED_MODULE_5_superagent___default.a.post(this.props.perspHandler);var dataURL=__WEBPACK_IMPORTED_MODULE_4_store___default.a.get('customDesigns').find(function(d){return d.key===_this2.key;}).dataURL;req.set('Content-Type','application/json');req.set('Accept','application/json');req.send(JSON.stringify({model:this.props.handle,image:dataURL}));req.end(function(err,res){if(err){console.error(err);_this2.setState({success:false});}var response=JSON.parse(res.text);if(response.code===200){callback(response.data);}});}},{key:'saveCanvas',value:function saveCanvas(){var _this3=this;this.drawCanvas(true);var customDesigns=__WEBPACK_IMPORTED_MODULE_4_store___default.a.get('customDesigns');var dataURL=customDesigns.find(function(d){return d.key===_this3.key;}).dataURL;this.getPerspectiveView(function(image){// super @UGLY Doing the job 2 times... (here and in the Configurator)
_this3.props.addColors({image_file:_this3.props.handle+'/RAL/0011.png',color:'black',color_css:'#000',color_type:'custom',ornament:_this3.key,ornament_category:null,ornament_color:null,ornament_css:null,css:{backgroundColor:'#333',backgroundImage:'url(\''+dataURL+'\')',backgroundSize:'cover',backgroundPosition:'center'},declinable:false,customDesign:image.dataURL},{image_file:_this3.props.handle+'/RAL/0010.png',color:'white',color_css:'#fff',color_type:'custom',ornament:_this3.key,ornament_category:null,ornament_color:null,ornament_css:null,css:{backgroundColor:'#333',backgroundImage:'url(\''+dataURL+'\')',backgroundSize:'cover',backgroundPosition:'center'},declinable:false,customDesign:image.dataURL});// Save this in the store
customDesigns.find(function(d){return d.key===_this3.key;}).dataURL=image.dataURL;__WEBPACK_IMPORTED_MODULE_4_store___default.a.set('customDesigns',customDesigns);// And close the editor
_this3.props.close();});}},{key:'componentDidMount',value:function componentDidMount(){var wrapper=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.refs.wrapper);if(wrapper!==null){this.canvas.w=wrapper.clientHeight*0.4;this.canvas.h=wrapper.clientHeight;// Then update actual canvas
var editor=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.refs.editor);editor.width=this.canvas.w;editor.height=this.canvas.h;}this.alphaMask.src=__webpack_require__(358)("./"+this.props.handle+'.png');this.guidesMask.src=__webpack_require__(361)("./"+this.props.handle+'-guides.png');// @WARNING remove this thing (meant for dev purposes)
// this.uploadedFile.src = 'https://i.imgur.com/TsSG637.jpg'
}},{key:'render',value:function render(){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'configurator-overlay',onClick:this.props.close,key:'editor-overlay'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'configurator-editor configurator-modal',ref:'wrapper',key:'editor-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'configurator-controls'},!this.state.gotFile?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Uploader__["a" /* default */],{className:'configurator-red-button',uploadHandler:__WEBPACK_IMPORTED_MODULE_9__config_env_json___default.a.apiURL+__WEBPACK_IMPORTED_MODULE_10__config_params_json___default.a.uploadRoute,onUpload:this.onUpload.bind(this)}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'configurator-red-button',onClick:this.props.close},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'material-icons'},'close'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas',{id:'editor',ref:'editor',width:this.canvas.w,height:this.canvas.h}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'editor-right-controls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'material-icons resize-icon'},'transform'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_rc_slider__["a" /* default */],{vertical:true,defaultValue:25,onChange:this.resizeImage.bind(this),disabled:!this.state.gotFile})),this.uploadedFile.src?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'configurator-red-button configurator-save-button',onClick:this.saveCanvas.bind(this)},'Save'):null)];}}]);return HandleEditor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (HandleEditor);

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var require;var require;/**
 * interact.js v1.3.4
 *
 * Copyright (c) 2012-2018 Taye Adeyemi <dev@taye.me>
 * Released under the MIT License.
 * https://raw.github.com/taye/interact.js/master/LICENSE
 */
(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.interact = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

/*
 * In a (windowless) server environment this file exports a factory function
 * that takes the window to use.
 *
 *     var interact = require('interact.js')(windowObject);
 *
 * See https://github.com/taye/interact.js/issues/187
 */
if (typeof window === 'undefined') {
  module.exports = function (window) {
    require('./src/utils/window').init(window);

    return require('./src/index');
  };
} else {
  module.exports = require('./src/index');
}

},{"./src/index":19,"./src/utils/window":52}],2:[function(require,module,exports){
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var extend = require('./utils/extend.js');

function fireUntilImmediateStopped(event, listeners) {
  for (var _i = 0; _i < listeners.length; _i++) {
    var _ref;

    _ref = listeners[_i];
    var listener = _ref;

    if (event.immediatePropagationStopped) {
      break;
    }

    listener(event);
  }
}

var Eventable = function () {
  function Eventable(options) {
    _classCallCheck(this, Eventable);

    this.options = extend({}, options || {});
  }

  Eventable.prototype.fire = function fire(event) {
    var listeners = void 0;
    var onEvent = 'on' + event.type;
    var global = this.global;

    // Interactable#on() listeners
    if (listeners = this[event.type]) {
      fireUntilImmediateStopped(event, listeners);
    }

    // interactable.onevent listener
    if (this[onEvent]) {
      this[onEvent](event);
    }

    // interact.on() listeners
    if (!event.propagationStopped && global && (listeners = global[event.type])) {
      fireUntilImmediateStopped(event, listeners);
    }
  };

  Eventable.prototype.on = function on(eventType, listener) {
    // if this type of event was never bound
    if (this[eventType]) {
      this[eventType].push(listener);
    } else {
      this[eventType] = [listener];
    }
  };

  Eventable.prototype.off = function off(eventType, listener) {
    // if it is an action event type
    var eventList = this[eventType];
    var index = eventList ? eventList.indexOf(listener) : -1;

    if (index !== -1) {
      eventList.splice(index, 1);
    }

    if (eventList && eventList.length === 0 || !listener) {
      this[eventType] = undefined;
    }
  };

  return Eventable;
}();

module.exports = Eventable;

},{"./utils/extend.js":41}],3:[function(require,module,exports){
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var extend = require('./utils/extend');
var getOriginXY = require('./utils/getOriginXY');
var defaults = require('./defaultOptions');
var signals = require('./utils/Signals').new();

var InteractEvent = function () {
  /** */
  function InteractEvent(interaction, event, action, phase, element, related) {
    var preEnd = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;

    _classCallCheck(this, InteractEvent);

    var target = interaction.target;
    var deltaSource = (target && target.options || defaults).deltaSource;
    var origin = getOriginXY(target, element, action);
    var starting = phase === 'start';
    var ending = phase === 'end';
    var coords = starting ? interaction.startCoords : interaction.curCoords;
    var prevEvent = interaction.prevEvent;

    element = element || interaction.element;

    var page = extend({}, coords.page);
    var client = extend({}, coords.client);

    page.x -= origin.x;
    page.y -= origin.y;

    client.x -= origin.x;
    client.y -= origin.y;

    this.ctrlKey = event.ctrlKey;
    this.altKey = event.altKey;
    this.shiftKey = event.shiftKey;
    this.metaKey = event.metaKey;
    this.button = event.button;
    this.buttons = event.buttons;
    this.target = element;
    this.currentTarget = element;
    this.relatedTarget = related || null;
    this.preEnd = preEnd;
    this.type = action + (phase || '');
    this.interaction = interaction;
    this.interactable = target;

    this.t0 = starting ? interaction.downTimes[interaction.downTimes.length - 1] : prevEvent.t0;

    var signalArg = {
      interaction: interaction,
      event: event,
      action: action,
      phase: phase,
      element: element,
      related: related,
      page: page,
      client: client,
      coords: coords,
      starting: starting,
      ending: ending,
      deltaSource: deltaSource,
      iEvent: this
    };

    signals.fire('set-xy', signalArg);

    if (ending) {
      // use previous coords when ending
      this.pageX = prevEvent.pageX;
      this.pageY = prevEvent.pageY;
      this.clientX = prevEvent.clientX;
      this.clientY = prevEvent.clientY;
    } else {
      this.pageX = page.x;
      this.pageY = page.y;
      this.clientX = client.x;
      this.clientY = client.y;
    }

    this.x0 = interaction.startCoords.page.x - origin.x;
    this.y0 = interaction.startCoords.page.y - origin.y;
    this.clientX0 = interaction.startCoords.client.x - origin.x;
    this.clientY0 = interaction.startCoords.client.y - origin.y;

    signals.fire('set-delta', signalArg);

    this.timeStamp = coords.timeStamp;
    this.dt = interaction.pointerDelta.timeStamp;
    this.duration = this.timeStamp - this.t0;

    // speed and velocity in pixels per second
    this.speed = interaction.pointerDelta[deltaSource].speed;
    this.velocityX = interaction.pointerDelta[deltaSource].vx;
    this.velocityY = interaction.pointerDelta[deltaSource].vy;

    this.swipe = ending || phase === 'inertiastart' ? this.getSwipe() : null;

    signals.fire('new', signalArg);
  }

  InteractEvent.prototype.getSwipe = function getSwipe() {
    var interaction = this.interaction;

    if (interaction.prevEvent.speed < 600 || this.timeStamp - interaction.prevEvent.timeStamp > 150) {
      return null;
    }

    var angle = 180 * Math.atan2(interaction.prevEvent.velocityY, interaction.prevEvent.velocityX) / Math.PI;
    var overlap = 22.5;

    if (angle < 0) {
      angle += 360;
    }

    var left = 135 - overlap <= angle && angle < 225 + overlap;
    var up = 225 - overlap <= angle && angle < 315 + overlap;

    var right = !left && (315 - overlap <= angle || angle < 45 + overlap);
    var down = !up && 45 - overlap <= angle && angle < 135 + overlap;

    return {
      up: up,
      down: down,
      left: left,
      right: right,
      angle: angle,
      speed: interaction.prevEvent.speed,
      velocity: {
        x: interaction.prevEvent.velocityX,
        y: interaction.prevEvent.velocityY
      }
    };
  };

  InteractEvent.prototype.preventDefault = function preventDefault() {};

  /** */


  InteractEvent.prototype.stopImmediatePropagation = function stopImmediatePropagation() {
    this.immediatePropagationStopped = this.propagationStopped = true;
  };

  /** */


  InteractEvent.prototype.stopPropagation = function stopPropagation() {
    this.propagationStopped = true;
  };

  return InteractEvent;
}();

signals.on('set-delta', function (_ref) {
  var iEvent = _ref.iEvent,
      interaction = _ref.interaction,
      starting = _ref.starting,
      deltaSource = _ref.deltaSource;

  var prevEvent = starting ? iEvent : interaction.prevEvent;

  if (deltaSource === 'client') {
    iEvent.dx = iEvent.clientX - prevEvent.clientX;
    iEvent.dy = iEvent.clientY - prevEvent.clientY;
  } else {
    iEvent.dx = iEvent.pageX - prevEvent.pageX;
    iEvent.dy = iEvent.pageY - prevEvent.pageY;
  }
});

InteractEvent.signals = signals;

module.exports = InteractEvent;

},{"./defaultOptions":18,"./utils/Signals":34,"./utils/extend":41,"./utils/getOriginXY":42}],4:[function(require,module,exports){
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var clone = require('./utils/clone');
var is = require('./utils/is');
var events = require('./utils/events');
var extend = require('./utils/extend');
var actions = require('./actions/base');
var scope = require('./scope');
var Eventable = require('./Eventable');
var defaults = require('./defaultOptions');
var signals = require('./utils/Signals').new();

var _require = require('./utils/domUtils'),
    getElementRect = _require.getElementRect,
    nodeContains = _require.nodeContains,
    trySelector = _require.trySelector,
    matchesSelector = _require.matchesSelector;

var _require2 = require('./utils/window'),
    getWindow = _require2.getWindow;

var _require3 = require('./utils/arr'),
    contains = _require3.contains;

var _require4 = require('./utils/browser'),
    wheelEvent = _require4.wheelEvent;

// all set interactables


scope.interactables = [];

var Interactable = function () {
  /** */
  function Interactable(target, options) {
    _classCallCheck(this, Interactable);

    options = options || {};

    this.target = target;
    this.events = new Eventable();
    this._context = options.context || scope.document;
    this._win = getWindow(trySelector(target) ? this._context : target);
    this._doc = this._win.document;

    signals.fire('new', {
      target: target,
      options: options,
      interactable: this,
      win: this._win
    });

    scope.addDocument(this._doc, this._win);

    scope.interactables.push(this);

    this.set(options);
  }

  Interactable.prototype.setOnEvents = function setOnEvents(action, phases) {
    var onAction = 'on' + action;

    if (is.function(phases.onstart)) {
      this.events[onAction + 'start'] = phases.onstart;
    }
    if (is.function(phases.onmove)) {
      this.events[onAction + 'move'] = phases.onmove;
    }
    if (is.function(phases.onend)) {
      this.events[onAction + 'end'] = phases.onend;
    }
    if (is.function(phases.oninertiastart)) {
      this.events[onAction + 'inertiastart'] = phases.oninertiastart;
    }

    return this;
  };

  Interactable.prototype.setPerAction = function setPerAction(action, options) {
    // for all the default per-action options
    for (var option in options) {
      // if this option exists for this action
      if (option in defaults[action]) {
        // if the option in the options arg is an object value
        if (is.object(options[option])) {
          // duplicate the object and merge
          this.options[action][option] = clone(this.options[action][option] || {});
          extend(this.options[action][option], options[option]);

          if (is.object(defaults.perAction[option]) && 'enabled' in defaults.perAction[option]) {
            this.options[action][option].enabled = options[option].enabled === false ? false : true;
          }
        } else if (is.bool(options[option]) && is.object(defaults.perAction[option])) {
          this.options[action][option].enabled = options[option];
        } else if (options[option] !== undefined) {
          // or if it's not undefined, do a plain assignment
          this.options[action][option] = options[option];
        }
      }
    }
  };

  /**
   * The default function to get an Interactables bounding rect. Can be
   * overridden using {@link Interactable.rectChecker}.
   *
   * @param {Element} [element] The element to measure.
   * @return {object} The object's bounding rectangle.
   */


  Interactable.prototype.getRect = function getRect(element) {
    element = element || this.target;

    if (is.string(this.target) && !is.element(element)) {
      element = this._context.querySelector(this.target);
    }

    return getElementRect(element);
  };

  /**
   * Returns or sets the function used to calculate the interactable's
   * element's rectangle
   *
   * @param {function} [checker] A function which returns this Interactable's
   * bounding rectangle. See {@link Interactable.getRect}
   * @return {function | object} The checker function or this Interactable
   */


  Interactable.prototype.rectChecker = function rectChecker(checker) {
    if (is.function(checker)) {
      this.getRect = checker;

      return this;
    }

    if (checker === null) {
      delete this.options.getRect;

      return this;
    }

    return this.getRect;
  };

  Interactable.prototype._backCompatOption = function _backCompatOption(optionName, newValue) {
    if (trySelector(newValue) || is.object(newValue)) {
      this.options[optionName] = newValue;

      for (var _i = 0; _i < actions.names.length; _i++) {
        var _ref;

        _ref = actions.names[_i];
        var action = _ref;

        this.options[action][optionName] = newValue;
      }

      return this;
    }

    return this.options[optionName];
  };

  /**
   * Gets or sets the origin of the Interactable's element.  The x and y
   * of the origin will be subtracted from action event coordinates.
   *
   * @param {Element | object | string} [origin] An HTML or SVG Element whose
   * rect will be used, an object eg. { x: 0, y: 0 } or string 'parent', 'self'
   * or any CSS selector
   *
   * @return {object} The current origin or this Interactable
   */


  Interactable.prototype.origin = function origin(newValue) {
    return this._backCompatOption('origin', newValue);
  };

  /**
   * Returns or sets the mouse coordinate types used to calculate the
   * movement of the pointer.
   *
   * @param {string} [newValue] Use 'client' if you will be scrolling while
   * interacting; Use 'page' if you want autoScroll to work
   * @return {string | object} The current deltaSource or this Interactable
   */


  Interactable.prototype.deltaSource = function deltaSource(newValue) {
    if (newValue === 'page' || newValue === 'client') {
      this.options.deltaSource = newValue;

      return this;
    }

    return this.options.deltaSource;
  };

  /**
   * Gets the selector context Node of the Interactable. The default is
   * `window.document`.
   *
   * @return {Node} The context Node of this Interactable
   */


  Interactable.prototype.context = function context() {
    return this._context;
  };

  Interactable.prototype.inContext = function inContext(element) {
    return this._context === element.ownerDocument || nodeContains(this._context, element);
  };

  /**
   * Calls listeners for the given InteractEvent type bound globally
   * and directly to this Interactable
   *
   * @param {InteractEvent} iEvent The InteractEvent object to be fired on this
   * Interactable
   * @return {Interactable} this Interactable
   */


  Interactable.prototype.fire = function fire(iEvent) {
    this.events.fire(iEvent);

    return this;
  };

  Interactable.prototype._onOffMultiple = function _onOffMultiple(method, eventType, listener, options) {
    if (is.string(eventType) && eventType.search(' ') !== -1) {
      eventType = eventType.trim().split(/ +/);
    }

    if (is.array(eventType)) {
      for (var _i2 = 0; _i2 < eventType.length; _i2++) {
        var _ref2;

        _ref2 = eventType[_i2];
        var type = _ref2;

        this[method](type, listener, options);
      }

      return true;
    }

    if (is.object(eventType)) {
      for (var prop in eventType) {
        this[method](prop, eventType[prop], listener);
      }

      return true;
    }
  };

  /**
   * Binds a listener for an InteractEvent, pointerEvent or DOM event.
   *
   * @param {string | array | object} eventType  The types of events to listen
   * for
   * @param {function} listener   The function event (s)
   * @param {object | boolean} [options]    options object or useCapture flag
   * for addEventListener
   * @return {object} This Interactable
   */


  Interactable.prototype.on = function on(eventType, listener, options) {
    if (this._onOffMultiple('on', eventType, listener, options)) {
      return this;
    }

    if (eventType === 'wheel') {
      eventType = wheelEvent;
    }

    if (contains(Interactable.eventTypes, eventType)) {
      this.events.on(eventType, listener);
    }
    // delegated event for selector
    else if (is.string(this.target)) {
        events.addDelegate(this.target, this._context, eventType, listener, options);
      } else {
        events.add(this.target, eventType, listener, options);
      }

    return this;
  };

  /**
   * Removes an InteractEvent, pointerEvent or DOM event listener
   *
   * @param {string | array | object} eventType The types of events that were
   * listened for
   * @param {function} listener The listener function to be removed
   * @param {object | boolean} [options] options object or useCapture flag for
   * removeEventListener
   * @return {object} This Interactable
   */


  Interactable.prototype.off = function off(eventType, listener, options) {
    if (this._onOffMultiple('off', eventType, listener, options)) {
      return this;
    }

    if (eventType === 'wheel') {
      eventType = wheelEvent;
    }

    // if it is an action event type
    if (contains(Interactable.eventTypes, eventType)) {
      this.events.off(eventType, listener);
    }
    // delegated event
    else if (is.string(this.target)) {
        events.removeDelegate(this.target, this._context, eventType, listener, options);
      }
      // remove listener from this Interatable's element
      else {
          events.remove(this.target, eventType, listener, options);
        }

    return this;
  };

  /**
   * Reset the options of this Interactable
   *
   * @param {object} options The new settings to apply
   * @return {object} This Interactable
   */


  Interactable.prototype.set = function set(options) {
    if (!is.object(options)) {
      options = {};
    }

    this.options = clone(defaults.base);

    var perActions = clone(defaults.perAction);

    for (var actionName in actions.methodDict) {
      var methodName = actions.methodDict[actionName];

      this.options[actionName] = clone(defaults[actionName]);

      this.setPerAction(actionName, perActions);

      this[methodName](options[actionName]);
    }

    for (var _i3 = 0; _i3 < Interactable.settingsMethods.length; _i3++) {
      var _ref3;

      _ref3 = Interactable.settingsMethods[_i3];
      var setting = _ref3;

      this.options[setting] = defaults.base[setting];

      if (setting in options) {
        this[setting](options[setting]);
      }
    }

    signals.fire('set', {
      options: options,
      interactable: this
    });

    return this;
  };

  /**
   * Remove this interactable from the list of interactables and remove it's
   * action capabilities and event listeners
   *
   * @return {interact}
   */


  Interactable.prototype.unset = function unset() {
    events.remove(this.target, 'all');

    if (is.string(this.target)) {
      // remove delegated events
      for (var type in events.delegatedEvents) {
        var delegated = events.delegatedEvents[type];

        if (delegated.selectors[0] === this.target && delegated.contexts[0] === this._context) {

          delegated.selectors.splice(0, 1);
          delegated.contexts.splice(0, 1);
          delegated.listeners.splice(0, 1);

          // remove the arrays if they are empty
          if (!delegated.selectors.length) {
            delegated[type] = null;
          }
        }

        events.remove(this._context, type, events.delegateListener);
        events.remove(this._context, type, events.delegateUseCapture, true);
      }
    } else {
      events.remove(this, 'all');
    }

    signals.fire('unset', { interactable: this });

    scope.interactables.splice(scope.interactables.indexOf(this), 1);

    // Stop related interactions when an Interactable is unset
    for (var _i4 = 0; _i4 < (scope.interactions || []).length; _i4++) {
      var _ref4;

      _ref4 = (scope.interactions || [])[_i4];
      var interaction = _ref4;

      if (interaction.target === this && interaction.interacting() && !interaction._ending) {
        interaction.stop();
      }
    }

    return scope.interact;
  };

  return Interactable;
}();

scope.interactables.indexOfElement = function indexOfElement(target, context) {
  context = context || scope.document;

  for (var i = 0; i < this.length; i++) {
    var interactable = this[i];

    if (interactable.target === target && interactable._context === context) {
      return i;
    }
  }
  return -1;
};

scope.interactables.get = function interactableGet(element, options, dontCheckInContext) {
  var ret = this[this.indexOfElement(element, options && options.context)];

  return ret && (is.string(element) || dontCheckInContext || ret.inContext(element)) ? ret : null;
};

scope.interactables.forEachMatch = function (element, callback) {
  for (var _i5 = 0; _i5 < this.length; _i5++) {
    var _ref5;

    _ref5 = this[_i5];
    var interactable = _ref5;

    var ret = void 0;

    if ((is.string(interactable.target)
    // target is a selector and the element matches
    ? is.element(element) && matchesSelector(element, interactable.target) :
    // target is the element
    element === interactable.target) &&
    // the element is in context
    interactable.inContext(element)) {
      ret = callback(interactable);
    }

    if (ret !== undefined) {
      return ret;
    }
  }
};

// all interact.js eventTypes
Interactable.eventTypes = scope.eventTypes = [];

Interactable.signals = signals;

Interactable.settingsMethods = ['deltaSource', 'origin', 'preventDefault', 'rectChecker'];

module.exports = Interactable;

},{"./Eventable":2,"./actions/base":6,"./defaultOptions":18,"./scope":33,"./utils/Signals":34,"./utils/arr":35,"./utils/browser":36,"./utils/clone":37,"./utils/domUtils":39,"./utils/events":40,"./utils/extend":41,"./utils/is":46,"./utils/window":52}],5:[function(require,module,exports){
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var scope = require('./scope');
var utils = require('./utils');
var events = require('./utils/events');
var browser = require('./utils/browser');
var domObjects = require('./utils/domObjects');
var finder = require('./utils/interactionFinder');
var signals = require('./utils/Signals').new();

var listeners = {};
var methodNames = ['pointerDown', 'pointerMove', 'pointerUp', 'updatePointer', 'removePointer'];

// for ignoring browser's simulated mouse events
var prevTouchTime = 0;

// all active and idle interactions
scope.interactions = [];

var Interaction = function () {
  /** */
  function Interaction(_ref) {
    var pointerType = _ref.pointerType;

    _classCallCheck(this, Interaction);

    this.target = null; // current interactable being interacted with
    this.element = null; // the target element of the interactable

    this.prepared = { // action that's ready to be fired on next move event
      name: null,
      axis: null,
      edges: null
    };

    // keep track of added pointers
    this.pointers = [];
    this.pointerIds = [];
    this.downTargets = [];
    this.downTimes = [];

    // Previous native pointer move event coordinates
    this.prevCoords = {
      page: { x: 0, y: 0 },
      client: { x: 0, y: 0 },
      timeStamp: 0
    };
    // current native pointer move event coordinates
    this.curCoords = {
      page: { x: 0, y: 0 },
      client: { x: 0, y: 0 },
      timeStamp: 0
    };

    // Starting InteractEvent pointer coordinates
    this.startCoords = {
      page: { x: 0, y: 0 },
      client: { x: 0, y: 0 },
      timeStamp: 0
    };

    // Change in coordinates and time of the pointer
    this.pointerDelta = {
      page: { x: 0, y: 0, vx: 0, vy: 0, speed: 0 },
      client: { x: 0, y: 0, vx: 0, vy: 0, speed: 0 },
      timeStamp: 0
    };

    this.downEvent = null; // pointerdown/mousedown/touchstart event
    this.downPointer = {};

    this._eventTarget = null;
    this._curEventTarget = null;

    this.prevEvent = null; // previous action event

    this.pointerIsDown = false;
    this.pointerWasMoved = false;
    this._interacting = false;
    this._ending = false;

    this.pointerType = pointerType;

    signals.fire('new', this);

    scope.interactions.push(this);
  }

  Interaction.prototype.pointerDown = function pointerDown(pointer, event, eventTarget) {
    var pointerIndex = this.updatePointer(pointer, event, true);

    signals.fire('down', {
      pointer: pointer,
      event: event,
      eventTarget: eventTarget,
      pointerIndex: pointerIndex,
      interaction: this
    });
  };

  /**
   * ```js
   * interact(target)
   *   .draggable({
   *     // disable the default drag start by down->move
   *     manualStart: true
   *   })
   *   // start dragging after the user holds the pointer down
   *   .on('hold', function (event) {
   *     var interaction = event.interaction;
   *
   *     if (!interaction.interacting()) {
   *       interaction.start({ name: 'drag' },
   *                         event.interactable,
   *                         event.currentTarget);
   *     }
   * });
   * ```
   *
   * Start an action with the given Interactable and Element as tartgets. The
   * action must be enabled for the target Interactable and an appropriate
   * number of pointers must be held down - 1 for drag/resize, 2 for gesture.
   *
   * Use it with `interactable.<action>able({ manualStart: false })` to always
   * [start actions manually](https://github.com/taye/interact.js/issues/114)
   *
   * @param {object} action   The action to be performed - drag, resize, etc.
   * @param {Interactable} target  The Interactable to target
   * @param {Element} element The DOM Element to target
   * @return {object} interact
   */


  Interaction.prototype.start = function start(action, target, element) {
    if (this.interacting() || !this.pointerIsDown || this.pointerIds.length < (action.name === 'gesture' ? 2 : 1)) {
      return;
    }

    // if this interaction had been removed after stopping
    // add it back
    if (scope.interactions.indexOf(this) === -1) {
      scope.interactions.push(this);
    }

    utils.copyAction(this.prepared, action);
    this.target = target;
    this.element = element;

    signals.fire('action-start', {
      interaction: this,
      event: this.downEvent
    });
  };

  Interaction.prototype.pointerMove = function pointerMove(pointer, event, eventTarget) {
    if (!this.simulation) {
      this.updatePointer(pointer);
      utils.setCoords(this.curCoords, this.pointers);
    }

    var duplicateMove = this.curCoords.page.x === this.prevCoords.page.x && this.curCoords.page.y === this.prevCoords.page.y && this.curCoords.client.x === this.prevCoords.client.x && this.curCoords.client.y === this.prevCoords.client.y;

    var dx = void 0;
    var dy = void 0;

    // register movement greater than pointerMoveTolerance
    if (this.pointerIsDown && !this.pointerWasMoved) {
      dx = this.curCoords.client.x - this.startCoords.client.x;
      dy = this.curCoords.client.y - this.startCoords.client.y;

      this.pointerWasMoved = utils.hypot(dx, dy) > Interaction.pointerMoveTolerance;
    }

    var signalArg = {
      pointer: pointer,
      pointerIndex: this.getPointerIndex(pointer),
      event: event,
      eventTarget: eventTarget,
      dx: dx,
      dy: dy,
      duplicate: duplicateMove,
      interaction: this,
      interactingBeforeMove: this.interacting()
    };

    if (!duplicateMove) {
      // set pointer coordinate, time changes and speeds
      utils.setCoordDeltas(this.pointerDelta, this.prevCoords, this.curCoords);
    }

    signals.fire('move', signalArg);

    if (!duplicateMove) {
      // if interacting, fire an 'action-move' signal etc
      if (this.interacting()) {
        this.doMove(signalArg);
      }

      if (this.pointerWasMoved) {
        utils.copyCoords(this.prevCoords, this.curCoords);
      }
    }
  };

  /**
   * ```js
   * interact(target)
   *   .draggable(true)
   *   .on('dragmove', function (event) {
   *     if (someCondition) {
   *       // change the snap settings
   *       event.interactable.draggable({ snap: { targets: [] }});
   *       // fire another move event with re-calculated snap
   *       event.interaction.doMove();
   *     }
   *   });
   * ```
   *
   * Force a move of the current action at the same coordinates. Useful if
   * snap/restrict has been changed and you want a movement with the new
   * settings.
   */


  Interaction.prototype.doMove = function doMove(signalArg) {
    signalArg = utils.extend({
      pointer: this.pointers[0],
      event: this.prevEvent,
      eventTarget: this._eventTarget,
      interaction: this
    }, signalArg || {});

    signals.fire('before-action-move', signalArg);

    if (!this._dontFireMove) {
      signals.fire('action-move', signalArg);
    }

    this._dontFireMove = false;
  };

  // End interact move events and stop auto-scroll unless simulation is running


  Interaction.prototype.pointerUp = function pointerUp(pointer, event, eventTarget, curEventTarget) {
    var pointerIndex = this.getPointerIndex(pointer);

    signals.fire(/cancel$/i.test(event.type) ? 'cancel' : 'up', {
      pointer: pointer,
      pointerIndex: pointerIndex,
      event: event,
      eventTarget: eventTarget,
      curEventTarget: curEventTarget,
      interaction: this
    });

    if (!this.simulation) {
      this.end(event);
    }

    this.pointerIsDown = false;
    this.removePointer(pointer, event);
  };

  /**
   * ```js
   * interact(target)
   *   .draggable(true)
   *   .on('move', function (event) {
   *     if (event.pageX > 1000) {
   *       // end the current action
   *       event.interaction.end();
   *       // stop all further listeners from being called
   *       event.stopImmediatePropagation();
   *     }
   *   });
   * ```
   *
   * Stop the current action and fire an end event. Inertial movement does
   * not happen.
   *
   * @param {PointerEvent} [event]
   */


  Interaction.prototype.end = function end(event) {
    this._ending = true;

    event = event || this.prevEvent;

    if (this.interacting()) {
      signals.fire('action-end', {
        event: event,
        interaction: this
      });
    }

    this.stop();
    this._ending = false;
  };

  Interaction.prototype.currentAction = function currentAction() {
    return this._interacting ? this.prepared.name : null;
  };

  Interaction.prototype.interacting = function interacting() {
    return this._interacting;
  };

  /** */


  Interaction.prototype.stop = function stop() {
    signals.fire('stop', { interaction: this });

    if (this._interacting) {
      signals.fire('stop-active', { interaction: this });
      signals.fire('stop-' + this.prepared.name, { interaction: this });
    }

    this.target = this.element = null;

    this._interacting = false;
    this.prepared.name = this.prevEvent = null;
  };

  Interaction.prototype.getPointerIndex = function getPointerIndex(pointer) {
    // mouse and pen interactions may have only one pointer
    if (this.pointerType === 'mouse' || this.pointerType === 'pen') {
      return 0;
    }

    return this.pointerIds.indexOf(utils.getPointerId(pointer));
  };

  Interaction.prototype.updatePointer = function updatePointer(pointer, event) {
    var down = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : event && /(down|start)$/i.test(event.type);

    var id = utils.getPointerId(pointer);
    var index = this.getPointerIndex(pointer);

    if (index === -1) {
      index = this.pointerIds.length;
      this.pointerIds[index] = id;
    }

    if (down) {
      signals.fire('update-pointer-down', {
        pointer: pointer,
        event: event,
        down: down,
        pointerId: id,
        pointerIndex: index,
        interaction: this
      });
    }

    this.pointers[index] = pointer;

    return index;
  };

  Interaction.prototype.removePointer = function removePointer(pointer, event) {
    var index = this.getPointerIndex(pointer);

    if (index === -1) {
      return;
    }

    signals.fire('remove-pointer', {
      pointer: pointer,
      event: event,
      pointerIndex: index,
      interaction: this
    });

    this.pointers.splice(index, 1);
    this.pointerIds.splice(index, 1);
    this.downTargets.splice(index, 1);
    this.downTimes.splice(index, 1);
  };

  Interaction.prototype._updateEventTargets = function _updateEventTargets(target, currentTarget) {
    this._eventTarget = target;
    this._curEventTarget = currentTarget;
  };

  return Interaction;
}();

for (var _i = 0; _i < methodNames.length; _i++) {
  var method = methodNames[_i];
  listeners[method] = doOnInteractions(method);
}

function doOnInteractions(method) {
  return function (event) {
    var pointerType = utils.getPointerType(event);

    var _utils$getEventTarget = utils.getEventTargets(event),
        eventTarget = _utils$getEventTarget[0],
        curEventTarget = _utils$getEventTarget[1];

    var matches = []; // [ [pointer, interaction], ...]

    if (browser.supportsTouch && /touch/.test(event.type)) {
      prevTouchTime = new Date().getTime();

      for (var _i2 = 0; _i2 < event.changedTouches.length; _i2++) {
        var _ref2;

        _ref2 = event.changedTouches[_i2];
        var changedTouch = _ref2;

        var pointer = changedTouch;
        var interaction = finder.search(pointer, event.type, eventTarget);

        matches.push([pointer, interaction || new Interaction({ pointerType: pointerType })]);
      }
    } else {
      var invalidPointer = false;

      if (!browser.supportsPointerEvent && /mouse/.test(event.type)) {
        // ignore mouse events while touch interactions are active
        for (var i = 0; i < scope.interactions.length && !invalidPointer; i++) {
          invalidPointer = scope.interactions[i].pointerType !== 'mouse' && scope.interactions[i].pointerIsDown;
        }

        // try to ignore mouse events that are simulated by the browser
        // after a touch event
        invalidPointer = invalidPointer || new Date().getTime() - prevTouchTime < 500
        // on iOS and Firefox Mobile, MouseEvent.timeStamp is zero if simulated
        || event.timeStamp === 0;
      }

      if (!invalidPointer) {
        var _interaction = finder.search(event, event.type, eventTarget);

        if (!_interaction) {
          _interaction = new Interaction({ pointerType: pointerType });
        }

        matches.push([event, _interaction]);
      }
    }

    for (var _i3 = 0; _i3 < matches.length; _i3++) {
      var _ref3 = matches[_i3];
      var _pointer = _ref3[0];
      var _interaction2 = _ref3[1];

      _interaction2._updateEventTargets(eventTarget, curEventTarget);
      _interaction2[method](_pointer, event, eventTarget, curEventTarget);
    }
  };
}

function endAll(event) {
  for (var _i4 = 0; _i4 < scope.interactions.length; _i4++) {
    var _ref4;

    _ref4 = scope.interactions[_i4];
    var interaction = _ref4;

    interaction.end(event);
    signals.fire('endall', { event: event, interaction: interaction });
  }
}

var docEvents = {/* 'eventType': listenerFunc */};
var pEventTypes = browser.pEventTypes;

if (domObjects.PointerEvent) {
  docEvents[pEventTypes.down] = listeners.pointerDown;
  docEvents[pEventTypes.move] = listeners.pointerMove;
  docEvents[pEventTypes.up] = listeners.pointerUp;
  docEvents[pEventTypes.cancel] = listeners.pointerUp;
} else {
  docEvents.mousedown = listeners.pointerDown;
  docEvents.mousemove = listeners.pointerMove;
  docEvents.mouseup = listeners.pointerUp;

  docEvents.touchstart = listeners.pointerDown;
  docEvents.touchmove = listeners.pointerMove;
  docEvents.touchend = listeners.pointerUp;
  docEvents.touchcancel = listeners.pointerUp;
}

docEvents.blur = endAll;

function onDocSignal(_ref5, signalName) {
  var doc = _ref5.doc;

  var eventMethod = signalName.indexOf('add') === 0 ? events.add : events.remove;

  // delegate event listener
  for (var eventType in scope.delegatedEvents) {
    eventMethod(doc, eventType, events.delegateListener);
    eventMethod(doc, eventType, events.delegateUseCapture, true);
  }

  for (var _eventType in docEvents) {
    eventMethod(doc, _eventType, docEvents[_eventType], browser.isIOS ? { passive: false } : undefined);
  }
}

signals.on('update-pointer-down', function (_ref6) {
  var interaction = _ref6.interaction,
      pointer = _ref6.pointer,
      pointerId = _ref6.pointerId,
      pointerIndex = _ref6.pointerIndex,
      event = _ref6.event,
      eventTarget = _ref6.eventTarget,
      down = _ref6.down;

  interaction.pointerIds[pointerIndex] = pointerId;
  interaction.pointers[pointerIndex] = pointer;

  if (down) {
    interaction.pointerIsDown = true;
  }

  if (!interaction.interacting()) {
    utils.setCoords(interaction.startCoords, interaction.pointers);

    utils.copyCoords(interaction.curCoords, interaction.startCoords);
    utils.copyCoords(interaction.prevCoords, interaction.startCoords);

    interaction.downEvent = event;
    interaction.downTimes[pointerIndex] = interaction.curCoords.timeStamp;
    interaction.downTargets[pointerIndex] = eventTarget || event && utils.getEventTargets(event)[0];
    interaction.pointerWasMoved = false;

    utils.pointerExtend(interaction.downPointer, pointer);
  }
});

scope.signals.on('add-document', onDocSignal);
scope.signals.on('remove-document', onDocSignal);

Interaction.pointerMoveTolerance = 1;
Interaction.doOnInteractions = doOnInteractions;
Interaction.endAll = endAll;
Interaction.signals = signals;
Interaction.docEvents = docEvents;

scope.endAllInteractions = endAll;

module.exports = Interaction;

},{"./scope":33,"./utils":44,"./utils/Signals":34,"./utils/browser":36,"./utils/domObjects":38,"./utils/events":40,"./utils/interactionFinder":45}],6:[function(require,module,exports){
'use strict';

var Interaction = require('../Interaction');
var InteractEvent = require('../InteractEvent');

var actions = {
  firePrepared: firePrepared,
  names: [],
  methodDict: {}
};

Interaction.signals.on('action-start', function (_ref) {
  var interaction = _ref.interaction,
      event = _ref.event;

  interaction._interacting = true;
  firePrepared(interaction, event, 'start');
});

Interaction.signals.on('action-move', function (_ref2) {
  var interaction = _ref2.interaction,
      event = _ref2.event,
      preEnd = _ref2.preEnd;

  firePrepared(interaction, event, 'move', preEnd);

  // if the action was ended in a listener
  if (!interaction.interacting()) {
    return false;
  }
});

Interaction.signals.on('action-end', function (_ref3) {
  var interaction = _ref3.interaction,
      event = _ref3.event;

  firePrepared(interaction, event, 'end');
});

function firePrepared(interaction, event, phase, preEnd) {
  var actionName = interaction.prepared.name;

  var newEvent = new InteractEvent(interaction, event, actionName, phase, interaction.element, null, preEnd);

  interaction.target.fire(newEvent);
  interaction.prevEvent = newEvent;
}

module.exports = actions;

},{"../InteractEvent":3,"../Interaction":5}],7:[function(require,module,exports){
'use strict';

var actions = require('./base');
var utils = require('../utils');
var InteractEvent = require('../InteractEvent');
/** @lends Interactable */
var Interactable = require('../Interactable');
var Interaction = require('../Interaction');
var defaultOptions = require('../defaultOptions');

var drag = {
  defaults: {
    enabled: false,
    mouseButtons: null,

    origin: null,
    snap: null,
    restrict: null,
    inertia: null,
    autoScroll: null,

    startAxis: 'xy',
    lockAxis: 'xy'
  },

  checker: function checker(pointer, event, interactable) {
    var dragOptions = interactable.options.drag;

    return dragOptions.enabled ? { name: 'drag', axis: dragOptions.lockAxis === 'start' ? dragOptions.startAxis : dragOptions.lockAxis } : null;
  },

  getCursor: function getCursor() {
    return 'move';
  }
};

Interaction.signals.on('before-action-move', function (_ref) {
  var interaction = _ref.interaction;

  if (interaction.prepared.name !== 'drag') {
    return;
  }

  var axis = interaction.prepared.axis;

  if (axis === 'x') {
    interaction.curCoords.page.y = interaction.startCoords.page.y;
    interaction.curCoords.client.y = interaction.startCoords.client.y;

    interaction.pointerDelta.page.speed = Math.abs(interaction.pointerDelta.page.vx);
    interaction.pointerDelta.client.speed = Math.abs(interaction.pointerDelta.client.vx);
    interaction.pointerDelta.client.vy = 0;
    interaction.pointerDelta.page.vy = 0;
  } else if (axis === 'y') {
    interaction.curCoords.page.x = interaction.startCoords.page.x;
    interaction.curCoords.client.x = interaction.startCoords.client.x;

    interaction.pointerDelta.page.speed = Math.abs(interaction.pointerDelta.page.vy);
    interaction.pointerDelta.client.speed = Math.abs(interaction.pointerDelta.client.vy);
    interaction.pointerDelta.client.vx = 0;
    interaction.pointerDelta.page.vx = 0;
  }
});

// dragmove
InteractEvent.signals.on('new', function (_ref2) {
  var iEvent = _ref2.iEvent,
      interaction = _ref2.interaction;

  if (iEvent.type !== 'dragmove') {
    return;
  }

  var axis = interaction.prepared.axis;

  if (axis === 'x') {
    iEvent.pageY = interaction.startCoords.page.y;
    iEvent.clientY = interaction.startCoords.client.y;
    iEvent.dy = 0;
  } else if (axis === 'y') {
    iEvent.pageX = interaction.startCoords.page.x;
    iEvent.clientX = interaction.startCoords.client.x;
    iEvent.dx = 0;
  }
});

/**
 * ```js
 * interact(element).draggable({
 *     onstart: function (event) {},
 *     onmove : function (event) {},
 *     onend  : function (event) {},
 *
 *     // the axis in which the first movement must be
 *     // for the drag sequence to start
 *     // 'xy' by default - any direction
 *     startAxis: 'x' || 'y' || 'xy',
 *
 *     // 'xy' by default - don't restrict to one axis (move in any direction)
 *     // 'x' or 'y' to restrict movement to either axis
 *     // 'start' to restrict movement to the axis the drag started in
 *     lockAxis: 'x' || 'y' || 'xy' || 'start',
 *
 *     // max number of drags that can happen concurrently
 *     // with elements of this Interactable. Infinity by default
 *     max: Infinity,
 *
 *     // max number of drags that can target the same element+Interactable
 *     // 1 by default
 *     maxPerElement: 2
 * });
 *
 * var isDraggable = interact('element').draggable(); // true
 * ```
 *
 * Get or set whether drag actions can be performed on the target
 *
 * @param {boolean | object} [options] true/false or An object with event
 * listeners to be fired on drag events (object makes the Interactable
 * draggable)
 * @return {boolean | Interactable} boolean indicating if this can be the
 * target of drag events, or this Interctable
 */
Interactable.prototype.draggable = function (options) {
  if (utils.is.object(options)) {
    this.options.drag.enabled = options.enabled === false ? false : true;
    this.setPerAction('drag', options);
    this.setOnEvents('drag', options);

    if (/^(xy|x|y|start)$/.test(options.lockAxis)) {
      this.options.drag.lockAxis = options.lockAxis;
    }
    if (/^(xy|x|y)$/.test(options.startAxis)) {
      this.options.drag.startAxis = options.startAxis;
    }

    return this;
  }

  if (utils.is.bool(options)) {
    this.options.drag.enabled = options;

    if (!options) {
      this.ondragstart = this.ondragstart = this.ondragend = null;
    }

    return this;
  }

  return this.options.drag;
};

actions.drag = drag;
actions.names.push('drag');
utils.merge(Interactable.eventTypes, ['dragstart', 'dragmove', 'draginertiastart', 'draginertiaresume', 'dragend']);
actions.methodDict.drag = 'draggable';

defaultOptions.drag = drag.defaults;

module.exports = drag;

},{"../InteractEvent":3,"../Interactable":4,"../Interaction":5,"../defaultOptions":18,"../utils":44,"./base":6}],8:[function(require,module,exports){
'use strict';

var actions = require('./base');
var utils = require('../utils');
var scope = require('../scope');
/** @lends module:interact */
var interact = require('../interact');
var InteractEvent = require('../InteractEvent');
/** @lends Interactable */
var Interactable = require('../Interactable');
var Interaction = require('../Interaction');
var defaultOptions = require('../defaultOptions');

var drop = {
  defaults: {
    enabled: false,
    accept: null,
    overlap: 'pointer'
  }
};

var dynamicDrop = false;

Interaction.signals.on('action-start', function (_ref) {
  var interaction = _ref.interaction,
      event = _ref.event;

  if (interaction.prepared.name !== 'drag') {
    return;
  }

  // reset active dropzones
  interaction.activeDrops.dropzones = [];
  interaction.activeDrops.elements = [];
  interaction.activeDrops.rects = [];

  interaction.dropEvents = null;

  if (!interaction.dynamicDrop) {
    setActiveDrops(interaction.activeDrops, interaction.element);
  }

  var dragEvent = interaction.prevEvent;
  var dropEvents = getDropEvents(interaction, event, dragEvent);

  if (dropEvents.activate) {
    fireActiveDrops(interaction.activeDrops, dropEvents.activate);
  }
});

InteractEvent.signals.on('new', function (_ref2) {
  var interaction = _ref2.interaction,
      iEvent = _ref2.iEvent,
      event = _ref2.event;

  if (iEvent.type !== 'dragmove' && iEvent.type !== 'dragend') {
    return;
  }

  var draggableElement = interaction.element;
  var dragEvent = iEvent;
  var dropResult = getDrop(dragEvent, event, draggableElement);

  interaction.dropTarget = dropResult.dropzone;
  interaction.dropElement = dropResult.element;

  interaction.dropEvents = getDropEvents(interaction, event, dragEvent);
});

Interaction.signals.on('action-move', function (_ref3) {
  var interaction = _ref3.interaction;

  if (interaction.prepared.name !== 'drag') {
    return;
  }

  fireDropEvents(interaction, interaction.dropEvents);
});

Interaction.signals.on('action-end', function (_ref4) {
  var interaction = _ref4.interaction;

  if (interaction.prepared.name === 'drag') {
    fireDropEvents(interaction, interaction.dropEvents);
  }
});

Interaction.signals.on('stop-drag', function (_ref5) {
  var interaction = _ref5.interaction;

  interaction.activeDrops = {
    dropzones: null,
    elements: null,
    rects: null
  };

  interaction.dropEvents = null;
});

function collectDrops(activeDrops, element) {
  var drops = [];
  var elements = [];

  // collect all dropzones and their elements which qualify for a drop
  for (var _i = 0; _i < scope.interactables.length; _i++) {
    var _ref6;

    _ref6 = scope.interactables[_i];
    var current = _ref6;

    if (!current.options.drop.enabled) {
      continue;
    }

    var accept = current.options.drop.accept;

    // test the draggable element against the dropzone's accept setting
    if (utils.is.element(accept) && accept !== element || utils.is.string(accept) && !utils.matchesSelector(element, accept)) {

      continue;
    }

    // query for new elements if necessary
    var dropElements = utils.is.string(current.target) ? current._context.querySelectorAll(current.target) : [current.target];

    for (var _i2 = 0; _i2 < dropElements.length; _i2++) {
      var _ref7;

      _ref7 = dropElements[_i2];
      var currentElement = _ref7;

      if (currentElement !== element) {
        drops.push(current);
        elements.push(currentElement);
      }
    }
  }

  return {
    elements: elements,
    dropzones: drops
  };
}

function fireActiveDrops(activeDrops, event) {
  var prevElement = void 0;

  // loop through all active dropzones and trigger event
  for (var i = 0; i < activeDrops.dropzones.length; i++) {
    var current = activeDrops.dropzones[i];
    var currentElement = activeDrops.elements[i];

    // prevent trigger of duplicate events on same element
    if (currentElement !== prevElement) {
      // set current element as event target
      event.target = currentElement;
      current.fire(event);
    }
    prevElement = currentElement;
  }
}

// Collect a new set of possible drops and save them in activeDrops.
// setActiveDrops should always be called when a drag has just started or a
// drag event happens while dynamicDrop is true
function setActiveDrops(activeDrops, dragElement) {
  // get dropzones and their elements that could receive the draggable
  var possibleDrops = collectDrops(activeDrops, dragElement);

  activeDrops.dropzones = possibleDrops.dropzones;
  activeDrops.elements = possibleDrops.elements;
  activeDrops.rects = [];

  for (var i = 0; i < activeDrops.dropzones.length; i++) {
    activeDrops.rects[i] = activeDrops.dropzones[i].getRect(activeDrops.elements[i]);
  }
}

function getDrop(dragEvent, event, dragElement) {
  var interaction = dragEvent.interaction;
  var validDrops = [];

  if (dynamicDrop) {
    setActiveDrops(interaction.activeDrops, dragElement);
  }

  // collect all dropzones and their elements which qualify for a drop
  for (var j = 0; j < interaction.activeDrops.dropzones.length; j++) {
    var current = interaction.activeDrops.dropzones[j];
    var currentElement = interaction.activeDrops.elements[j];
    var rect = interaction.activeDrops.rects[j];

    validDrops.push(current.dropCheck(dragEvent, event, interaction.target, dragElement, currentElement, rect) ? currentElement : null);
  }

  // get the most appropriate dropzone based on DOM depth and order
  var dropIndex = utils.indexOfDeepestElement(validDrops);

  return {
    dropzone: interaction.activeDrops.dropzones[dropIndex] || null,
    element: interaction.activeDrops.elements[dropIndex] || null
  };
}

function getDropEvents(interaction, pointerEvent, dragEvent) {
  var dropEvents = {
    enter: null,
    leave: null,
    activate: null,
    deactivate: null,
    move: null,
    drop: null
  };

  var tmpl = {
    dragEvent: dragEvent,
    interaction: interaction,
    target: interaction.dropElement,
    dropzone: interaction.dropTarget,
    relatedTarget: dragEvent.target,
    draggable: dragEvent.interactable,
    timeStamp: dragEvent.timeStamp
  };

  if (interaction.dropElement !== interaction.prevDropElement) {
    // if there was a prevDropTarget, create a dragleave event
    if (interaction.prevDropTarget) {
      dropEvents.leave = utils.extend({ type: 'dragleave' }, tmpl);

      dragEvent.dragLeave = dropEvents.leave.target = interaction.prevDropElement;
      dragEvent.prevDropzone = dropEvents.leave.dropzone = interaction.prevDropTarget;
    }
    // if the dropTarget is not null, create a dragenter event
    if (interaction.dropTarget) {
      dropEvents.enter = {
        dragEvent: dragEvent,
        interaction: interaction,
        target: interaction.dropElement,
        dropzone: interaction.dropTarget,
        relatedTarget: dragEvent.target,
        draggable: dragEvent.interactable,
        timeStamp: dragEvent.timeStamp,
        type: 'dragenter'
      };

      dragEvent.dragEnter = interaction.dropElement;
      dragEvent.dropzone = interaction.dropTarget;
    }
  }

  if (dragEvent.type === 'dragend' && interaction.dropTarget) {
    dropEvents.drop = utils.extend({ type: 'drop' }, tmpl);

    dragEvent.dropzone = interaction.dropTarget;
    dragEvent.relatedTarget = interaction.dropElement;
  }
  if (dragEvent.type === 'dragstart') {
    dropEvents.activate = utils.extend({ type: 'dropactivate' }, tmpl);

    dropEvents.activate.target = null;
    dropEvents.activate.dropzone = null;
  }
  if (dragEvent.type === 'dragend') {
    dropEvents.deactivate = utils.extend({ type: 'dropdeactivate' }, tmpl);

    dropEvents.deactivate.target = null;
    dropEvents.deactivate.dropzone = null;
  }
  if (dragEvent.type === 'dragmove' && interaction.dropTarget) {
    dropEvents.move = utils.extend({
      dragmove: dragEvent,
      type: 'dropmove'
    }, tmpl);

    dragEvent.dropzone = interaction.dropTarget;
  }

  return dropEvents;
}

function fireDropEvents(interaction, dropEvents) {
  var activeDrops = interaction.activeDrops,
      prevDropTarget = interaction.prevDropTarget,
      dropTarget = interaction.dropTarget,
      dropElement = interaction.dropElement;


  if (dropEvents.leave) {
    prevDropTarget.fire(dropEvents.leave);
  }
  if (dropEvents.move) {
    dropTarget.fire(dropEvents.move);
  }
  if (dropEvents.enter) {
    dropTarget.fire(dropEvents.enter);
  }
  if (dropEvents.drop) {
    dropTarget.fire(dropEvents.drop);
  }
  if (dropEvents.deactivate) {
    fireActiveDrops(activeDrops, dropEvents.deactivate);
  }

  interaction.prevDropTarget = dropTarget;
  interaction.prevDropElement = dropElement;
}

/**
 * ```js
 * interact(target)
 * .dropChecker(function(dragEvent,         // related dragmove or dragend event
 *                       event,             // TouchEvent/PointerEvent/MouseEvent
 *                       dropped,           // bool result of the default checker
 *                       dropzone,          // dropzone Interactable
 *                       dropElement,       // dropzone elemnt
 *                       draggable,         // draggable Interactable
 *                       draggableElement) {// draggable element
 *
 *   return dropped && event.target.hasAttribute('allow-drop');
 * }
 * ```
 *
 * ```js
 * interact('.drop').dropzone({
 *   accept: '.can-drop' || document.getElementById('single-drop'),
 *   overlap: 'pointer' || 'center' || zeroToOne
 * }
 * ```
 *
 * Returns or sets whether draggables can be dropped onto this target to
 * trigger drop events
 *
 * Dropzones can receive the following events:
 *  - `dropactivate` and `dropdeactivate` when an acceptable drag starts and ends
 *  - `dragenter` and `dragleave` when a draggable enters and leaves the dropzone
 *  - `dragmove` when a draggable that has entered the dropzone is moved
 *  - `drop` when a draggable is dropped into this dropzone
 *
 * Use the `accept` option to allow only elements that match the given CSS
 * selector or element. The value can be:
 *
 *  - **an Element** - only that element can be dropped into this dropzone.
 *  - **a string**, - the element being dragged must match it as a CSS selector.
 *  - **`null`** - accept options is cleared - it accepts any element.
 *
 * Use the `overlap` option to set how drops are checked for. The allowed
 * values are:
 *
 *   - `'pointer'`, the pointer must be over the dropzone (default)
 *   - `'center'`, the draggable element's center must be over the dropzone
 *   - a number from 0-1 which is the `(intersection area) / (draggable area)`.
 *   e.g. `0.5` for drop to happen when half of the area of the draggable is
 *   over the dropzone
 *
 * Use the `checker` option to specify a function to check if a dragged element
 * is over this Interactable.
 *
 * @param {boolean | object | null} [options] The new options to be set.
 * @return {boolean | Interactable} The current setting or this Interactable
 */
Interactable.prototype.dropzone = function (options) {
  if (utils.is.object(options)) {
    this.options.drop.enabled = options.enabled === false ? false : true;

    if (utils.is.function(options.ondrop)) {
      this.events.ondrop = options.ondrop;
    }
    if (utils.is.function(options.ondropactivate)) {
      this.events.ondropactivate = options.ondropactivate;
    }
    if (utils.is.function(options.ondropdeactivate)) {
      this.events.ondropdeactivate = options.ondropdeactivate;
    }
    if (utils.is.function(options.ondragenter)) {
      this.events.ondragenter = options.ondragenter;
    }
    if (utils.is.function(options.ondragleave)) {
      this.events.ondragleave = options.ondragleave;
    }
    if (utils.is.function(options.ondropmove)) {
      this.events.ondropmove = options.ondropmove;
    }

    if (/^(pointer|center)$/.test(options.overlap)) {
      this.options.drop.overlap = options.overlap;
    } else if (utils.is.number(options.overlap)) {
      this.options.drop.overlap = Math.max(Math.min(1, options.overlap), 0);
    }
    if ('accept' in options) {
      this.options.drop.accept = options.accept;
    }
    if ('checker' in options) {
      this.options.drop.checker = options.checker;
    }

    return this;
  }

  if (utils.is.bool(options)) {
    this.options.drop.enabled = options;

    if (!options) {
      this.ondragenter = this.ondragleave = this.ondrop = this.ondropactivate = this.ondropdeactivate = null;
    }

    return this;
  }

  return this.options.drop;
};

Interactable.prototype.dropCheck = function (dragEvent, event, draggable, draggableElement, dropElement, rect) {
  var dropped = false;

  // if the dropzone has no rect (eg. display: none)
  // call the custom dropChecker or just return false
  if (!(rect = rect || this.getRect(dropElement))) {
    return this.options.drop.checker ? this.options.drop.checker(dragEvent, event, dropped, this, dropElement, draggable, draggableElement) : false;
  }

  var dropOverlap = this.options.drop.overlap;

  if (dropOverlap === 'pointer') {
    var origin = utils.getOriginXY(draggable, draggableElement, 'drag');
    var page = utils.getPageXY(dragEvent);

    page.x += origin.x;
    page.y += origin.y;

    var horizontal = page.x > rect.left && page.x < rect.right;
    var vertical = page.y > rect.top && page.y < rect.bottom;

    dropped = horizontal && vertical;
  }

  var dragRect = draggable.getRect(draggableElement);

  if (dragRect && dropOverlap === 'center') {
    var cx = dragRect.left + dragRect.width / 2;
    var cy = dragRect.top + dragRect.height / 2;

    dropped = cx >= rect.left && cx <= rect.right && cy >= rect.top && cy <= rect.bottom;
  }

  if (dragRect && utils.is.number(dropOverlap)) {
    var overlapArea = Math.max(0, Math.min(rect.right, dragRect.right) - Math.max(rect.left, dragRect.left)) * Math.max(0, Math.min(rect.bottom, dragRect.bottom) - Math.max(rect.top, dragRect.top));

    var overlapRatio = overlapArea / (dragRect.width * dragRect.height);

    dropped = overlapRatio >= dropOverlap;
  }

  if (this.options.drop.checker) {
    dropped = this.options.drop.checker(dragEvent, event, dropped, this, dropElement, draggable, draggableElement);
  }

  return dropped;
};

Interactable.signals.on('unset', function (_ref8) {
  var interactable = _ref8.interactable;

  interactable.dropzone(false);
});

Interactable.settingsMethods.push('dropChecker');

Interaction.signals.on('new', function (interaction) {
  interaction.dropTarget = null; // the dropzone a drag target might be dropped into
  interaction.dropElement = null; // the element at the time of checking
  interaction.prevDropTarget = null; // the dropzone that was recently dragged away from
  interaction.prevDropElement = null; // the element at the time of checking
  interaction.dropEvents = null; // the dropEvents related to the current drag event

  interaction.activeDrops = {
    dropzones: [], // the dropzones that are mentioned below
    elements: [], // elements of dropzones that accept the target draggable
    rects: [] // the rects of the elements mentioned above
  };
});

Interaction.signals.on('stop', function (_ref9) {
  var interaction = _ref9.interaction;

  interaction.dropTarget = interaction.dropElement = interaction.prevDropTarget = interaction.prevDropElement = null;
});

/**
 * Returns or sets whether the dimensions of dropzone elements are calculated
 * on every dragmove or only on dragstart for the default dropChecker
 *
 * @param {boolean} [newValue] True to check on each move. False to check only
 * before start
 * @return {boolean | interact} The current setting or interact
 */
interact.dynamicDrop = function (newValue) {
  if (utils.is.bool(newValue)) {
    //if (dragging && dynamicDrop !== newValue && !newValue) {
    //calcRects(dropzones);
    //}

    dynamicDrop = newValue;

    return interact;
  }
  return dynamicDrop;
};

utils.merge(Interactable.eventTypes, ['dragenter', 'dragleave', 'dropactivate', 'dropdeactivate', 'dropmove', 'drop']);
actions.methodDict.drop = 'dropzone';

defaultOptions.drop = drop.defaults;

module.exports = drop;

},{"../InteractEvent":3,"../Interactable":4,"../Interaction":5,"../defaultOptions":18,"../interact":21,"../scope":33,"../utils":44,"./base":6}],9:[function(require,module,exports){
'use strict';

var actions = require('./base');
var utils = require('../utils');
var InteractEvent = require('../InteractEvent');
var Interactable = require('../Interactable');
var Interaction = require('../Interaction');
var defaultOptions = require('../defaultOptions');

var gesture = {
  defaults: {
    enabled: false,
    origin: null,
    restrict: null
  },

  checker: function checker(pointer, event, interactable, element, interaction) {
    if (interaction.pointerIds.length >= 2) {
      return { name: 'gesture' };
    }

    return null;
  },

  getCursor: function getCursor() {
    return '';
  }
};

InteractEvent.signals.on('new', function (_ref) {
  var iEvent = _ref.iEvent,
      interaction = _ref.interaction;

  if (iEvent.type !== 'gesturestart') {
    return;
  }
  iEvent.ds = 0;

  interaction.gesture.startDistance = interaction.gesture.prevDistance = iEvent.distance;
  interaction.gesture.startAngle = interaction.gesture.prevAngle = iEvent.angle;
  interaction.gesture.scale = 1;
});

InteractEvent.signals.on('new', function (_ref2) {
  var iEvent = _ref2.iEvent,
      interaction = _ref2.interaction;

  if (iEvent.type !== 'gesturemove') {
    return;
  }

  iEvent.ds = iEvent.scale - interaction.gesture.scale;

  interaction.target.fire(iEvent);

  interaction.gesture.prevAngle = iEvent.angle;
  interaction.gesture.prevDistance = iEvent.distance;

  if (iEvent.scale !== Infinity && iEvent.scale !== null && iEvent.scale !== undefined && !isNaN(iEvent.scale)) {

    interaction.gesture.scale = iEvent.scale;
  }
});

/**
 * ```js
 * interact(element).gesturable({
 *     onstart: function (event) {},
 *     onmove : function (event) {},
 *     onend  : function (event) {},
 *
 *     // limit multiple gestures.
 *     // See the explanation in {@link Interactable.draggable} example
 *     max: Infinity,
 *     maxPerElement: 1,
 * });
 *
 * var isGestureable = interact(element).gesturable();
 * ```
 *
 * Gets or sets whether multitouch gestures can be performed on the target
 *
 * @param {boolean | object} [options] true/false or An object with event
 * listeners to be fired on gesture events (makes the Interactable gesturable)
 * @return {boolean | Interactable} A boolean indicating if this can be the
 * target of gesture events, or this Interactable
 */
Interactable.prototype.gesturable = function (options) {
  if (utils.is.object(options)) {
    this.options.gesture.enabled = options.enabled === false ? false : true;
    this.setPerAction('gesture', options);
    this.setOnEvents('gesture', options);

    return this;
  }

  if (utils.is.bool(options)) {
    this.options.gesture.enabled = options;

    if (!options) {
      this.ongesturestart = this.ongesturestart = this.ongestureend = null;
    }

    return this;
  }

  return this.options.gesture;
};

InteractEvent.signals.on('set-delta', function (_ref3) {
  var interaction = _ref3.interaction,
      iEvent = _ref3.iEvent,
      action = _ref3.action,
      event = _ref3.event,
      starting = _ref3.starting,
      ending = _ref3.ending,
      deltaSource = _ref3.deltaSource;

  if (action !== 'gesture') {
    return;
  }

  var pointers = interaction.pointers;

  iEvent.touches = [pointers[0], pointers[1]];

  if (starting) {
    iEvent.distance = utils.touchDistance(pointers, deltaSource);
    iEvent.box = utils.touchBBox(pointers);
    iEvent.scale = 1;
    iEvent.ds = 0;
    iEvent.angle = utils.touchAngle(pointers, undefined, deltaSource);
    iEvent.da = 0;
  } else if (ending || event instanceof InteractEvent) {
    iEvent.distance = interaction.prevEvent.distance;
    iEvent.box = interaction.prevEvent.box;
    iEvent.scale = interaction.prevEvent.scale;
    iEvent.ds = iEvent.scale - 1;
    iEvent.angle = interaction.prevEvent.angle;
    iEvent.da = iEvent.angle - interaction.gesture.startAngle;
  } else {
    iEvent.distance = utils.touchDistance(pointers, deltaSource);
    iEvent.box = utils.touchBBox(pointers);
    iEvent.scale = iEvent.distance / interaction.gesture.startDistance;
    iEvent.angle = utils.touchAngle(pointers, interaction.gesture.prevAngle, deltaSource);

    iEvent.ds = iEvent.scale - interaction.gesture.prevScale;
    iEvent.da = iEvent.angle - interaction.gesture.prevAngle;
  }
});

Interaction.signals.on('new', function (interaction) {
  interaction.gesture = {
    start: { x: 0, y: 0 },

    startDistance: 0, // distance between two touches of touchStart
    prevDistance: 0,
    distance: 0,

    scale: 1, // gesture.distance / gesture.startDistance

    startAngle: 0, // angle of line joining two touches
    prevAngle: 0 // angle of the previous gesture event
  };
});

actions.gesture = gesture;
actions.names.push('gesture');
utils.merge(Interactable.eventTypes, ['gesturestart', 'gesturemove', 'gestureend']);
actions.methodDict.gesture = 'gesturable';

defaultOptions.gesture = gesture.defaults;

module.exports = gesture;

},{"../InteractEvent":3,"../Interactable":4,"../Interaction":5,"../defaultOptions":18,"../utils":44,"./base":6}],10:[function(require,module,exports){
'use strict';

var actions = require('./base');
var utils = require('../utils');
var browser = require('../utils/browser');
var InteractEvent = require('../InteractEvent');
/** @lends Interactable */
var Interactable = require('../Interactable');
var Interaction = require('../Interaction');
var defaultOptions = require('../defaultOptions');

// Less Precision with touch input
var defaultMargin = browser.supportsTouch || browser.supportsPointerEvent ? 20 : 10;

var resize = {
  defaults: {
    enabled: false,
    mouseButtons: null,

    origin: null,
    snap: null,
    restrict: null,
    inertia: null,
    autoScroll: null,

    square: false,
    preserveAspectRatio: false,
    axis: 'xy',

    // use default margin
    margin: NaN,

    // object with props left, right, top, bottom which are
    // true/false values to resize when the pointer is over that edge,
    // CSS selectors to match the handles for each direction
    // or the Elements for each handle
    edges: null,

    // a value of 'none' will limit the resize rect to a minimum of 0x0
    // 'negate' will alow the rect to have negative width/height
    // 'reposition' will keep the width/height positive by swapping
    // the top and bottom edges and/or swapping the left and right edges
    invert: 'none'
  },

  checker: function checker(pointer, event, interactable, element, interaction, rect) {
    if (!rect) {
      return null;
    }

    var page = utils.extend({}, interaction.curCoords.page);
    var options = interactable.options;

    if (options.resize.enabled) {
      var resizeOptions = options.resize;
      var resizeEdges = { left: false, right: false, top: false, bottom: false };

      // if using resize.edges
      if (utils.is.object(resizeOptions.edges)) {
        for (var edge in resizeEdges) {
          resizeEdges[edge] = checkResizeEdge(edge, resizeOptions.edges[edge], page, interaction._eventTarget, element, rect, resizeOptions.margin || defaultMargin);
        }

        resizeEdges.left = resizeEdges.left && !resizeEdges.right;
        resizeEdges.top = resizeEdges.top && !resizeEdges.bottom;

        if (resizeEdges.left || resizeEdges.right || resizeEdges.top || resizeEdges.bottom) {
          return {
            name: 'resize',
            edges: resizeEdges
          };
        }
      } else {
        var right = options.resize.axis !== 'y' && page.x > rect.right - defaultMargin;
        var bottom = options.resize.axis !== 'x' && page.y > rect.bottom - defaultMargin;

        if (right || bottom) {
          return {
            name: 'resize',
            axes: (right ? 'x' : '') + (bottom ? 'y' : '')
          };
        }
      }
    }

    return null;
  },

  cursors: browser.isIe9 ? {
    x: 'e-resize',
    y: 's-resize',
    xy: 'se-resize',

    top: 'n-resize',
    left: 'w-resize',
    bottom: 's-resize',
    right: 'e-resize',
    topleft: 'se-resize',
    bottomright: 'se-resize',
    topright: 'ne-resize',
    bottomleft: 'ne-resize'
  } : {
    x: 'ew-resize',
    y: 'ns-resize',
    xy: 'nwse-resize',

    top: 'ns-resize',
    left: 'ew-resize',
    bottom: 'ns-resize',
    right: 'ew-resize',
    topleft: 'nwse-resize',
    bottomright: 'nwse-resize',
    topright: 'nesw-resize',
    bottomleft: 'nesw-resize'
  },

  getCursor: function getCursor(action) {
    if (action.axis) {
      return resize.cursors[action.name + action.axis];
    } else if (action.edges) {
      var cursorKey = '';
      var edgeNames = ['top', 'bottom', 'left', 'right'];

      for (var i = 0; i < 4; i++) {
        if (action.edges[edgeNames[i]]) {
          cursorKey += edgeNames[i];
        }
      }

      return resize.cursors[cursorKey];
    }
  }
};

// resizestart
InteractEvent.signals.on('new', function (_ref) {
  var iEvent = _ref.iEvent,
      interaction = _ref.interaction;

  if (iEvent.type !== 'resizestart' || !interaction.prepared.edges) {
    return;
  }

  var startRect = interaction.target.getRect(interaction.element);
  var resizeOptions = interaction.target.options.resize;

  /*
   * When using the `resizable.square` or `resizable.preserveAspectRatio` options, resizing from one edge
   * will affect another. E.g. with `resizable.square`, resizing to make the right edge larger will make
   * the bottom edge larger by the same amount. We call these 'linked' edges. Any linked edges will depend
   * on the active edges and the edge being interacted with.
   */
  if (resizeOptions.square || resizeOptions.preserveAspectRatio) {
    var linkedEdges = utils.extend({}, interaction.prepared.edges);

    linkedEdges.top = linkedEdges.top || linkedEdges.left && !linkedEdges.bottom;
    linkedEdges.left = linkedEdges.left || linkedEdges.top && !linkedEdges.right;
    linkedEdges.bottom = linkedEdges.bottom || linkedEdges.right && !linkedEdges.top;
    linkedEdges.right = linkedEdges.right || linkedEdges.bottom && !linkedEdges.left;

    interaction.prepared._linkedEdges = linkedEdges;
  } else {
    interaction.prepared._linkedEdges = null;
  }

  // if using `resizable.preserveAspectRatio` option, record aspect ratio at the start of the resize
  if (resizeOptions.preserveAspectRatio) {
    interaction.resizeStartAspectRatio = startRect.width / startRect.height;
  }

  interaction.resizeRects = {
    start: startRect,
    current: utils.extend({}, startRect),
    inverted: utils.extend({}, startRect),
    previous: utils.extend({}, startRect),
    delta: {
      left: 0, right: 0, width: 0,
      top: 0, bottom: 0, height: 0
    }
  };

  iEvent.rect = interaction.resizeRects.inverted;
  iEvent.deltaRect = interaction.resizeRects.delta;
});

// resizemove
InteractEvent.signals.on('new', function (_ref2) {
  var iEvent = _ref2.iEvent,
      phase = _ref2.phase,
      interaction = _ref2.interaction;

  if (phase !== 'move' || !interaction.prepared.edges) {
    return;
  }

  var resizeOptions = interaction.target.options.resize;
  var invert = resizeOptions.invert;
  var invertible = invert === 'reposition' || invert === 'negate';

  var edges = interaction.prepared.edges;

  var start = interaction.resizeRects.start;
  var current = interaction.resizeRects.current;
  var inverted = interaction.resizeRects.inverted;
  var delta = interaction.resizeRects.delta;
  var previous = utils.extend(interaction.resizeRects.previous, inverted);
  var originalEdges = edges;

  var dx = iEvent.dx;
  var dy = iEvent.dy;

  if (resizeOptions.preserveAspectRatio || resizeOptions.square) {
    // `resize.preserveAspectRatio` takes precedence over `resize.square`
    var startAspectRatio = resizeOptions.preserveAspectRatio ? interaction.resizeStartAspectRatio : 1;

    edges = interaction.prepared._linkedEdges;

    if (originalEdges.left && originalEdges.bottom || originalEdges.right && originalEdges.top) {
      dy = -dx / startAspectRatio;
    } else if (originalEdges.left || originalEdges.right) {
      dy = dx / startAspectRatio;
    } else if (originalEdges.top || originalEdges.bottom) {
      dx = dy * startAspectRatio;
    }
  }

  // update the 'current' rect without modifications
  if (edges.top) {
    current.top += dy;
  }
  if (edges.bottom) {
    current.bottom += dy;
  }
  if (edges.left) {
    current.left += dx;
  }
  if (edges.right) {
    current.right += dx;
  }

  if (invertible) {
    // if invertible, copy the current rect
    utils.extend(inverted, current);

    if (invert === 'reposition') {
      // swap edge values if necessary to keep width/height positive
      var swap = void 0;

      if (inverted.top > inverted.bottom) {
        swap = inverted.top;

        inverted.top = inverted.bottom;
        inverted.bottom = swap;
      }
      if (inverted.left > inverted.right) {
        swap = inverted.left;

        inverted.left = inverted.right;
        inverted.right = swap;
      }
    }
  } else {
    // if not invertible, restrict to minimum of 0x0 rect
    inverted.top = Math.min(current.top, start.bottom);
    inverted.bottom = Math.max(current.bottom, start.top);
    inverted.left = Math.min(current.left, start.right);
    inverted.right = Math.max(current.right, start.left);
  }

  inverted.width = inverted.right - inverted.left;
  inverted.height = inverted.bottom - inverted.top;

  for (var edge in inverted) {
    delta[edge] = inverted[edge] - previous[edge];
  }

  iEvent.edges = interaction.prepared.edges;
  iEvent.rect = inverted;
  iEvent.deltaRect = delta;
});

/**
 * ```js
 * interact(element).resizable({
 *   onstart: function (event) {},
 *   onmove : function (event) {},
 *   onend  : function (event) {},
 *
 *   edges: {
 *     top   : true,       // Use pointer coords to check for resize.
 *     left  : false,      // Disable resizing from left edge.
 *     bottom: '.resize-s',// Resize if pointer target matches selector
 *     right : handleEl    // Resize if pointer target is the given Element
 *   },
 *
 *     // Width and height can be adjusted independently. When `true`, width and
 *     // height are adjusted at a 1:1 ratio.
 *     square: false,
 *
 *     // Width and height can be adjusted independently. When `true`, width and
 *     // height maintain the aspect ratio they had when resizing started.
 *     preserveAspectRatio: false,
 *
 *   // a value of 'none' will limit the resize rect to a minimum of 0x0
 *   // 'negate' will allow the rect to have negative width/height
 *   // 'reposition' will keep the width/height positive by swapping
 *   // the top and bottom edges and/or swapping the left and right edges
 *   invert: 'none' || 'negate' || 'reposition'
 *
 *   // limit multiple resizes.
 *   // See the explanation in the {@link Interactable.draggable} example
 *   max: Infinity,
 *   maxPerElement: 1,
 * });
 *
 * var isResizeable = interact(element).resizable();
 * ```
 *
 * Gets or sets whether resize actions can be performed on the target
 *
 * @param {boolean | object} [options] true/false or An object with event
 * listeners to be fired on resize events (object makes the Interactable
 * resizable)
 * @return {boolean | Interactable} A boolean indicating if this can be the
 * target of resize elements, or this Interactable
 */
Interactable.prototype.resizable = function (options) {
  if (utils.is.object(options)) {
    this.options.resize.enabled = options.enabled === false ? false : true;
    this.setPerAction('resize', options);
    this.setOnEvents('resize', options);

    if (/^x$|^y$|^xy$/.test(options.axis)) {
      this.options.resize.axis = options.axis;
    } else if (options.axis === null) {
      this.options.resize.axis = defaultOptions.resize.axis;
    }

    if (utils.is.bool(options.preserveAspectRatio)) {
      this.options.resize.preserveAspectRatio = options.preserveAspectRatio;
    } else if (utils.is.bool(options.square)) {
      this.options.resize.square = options.square;
    }

    return this;
  }
  if (utils.is.bool(options)) {
    this.options.resize.enabled = options;

    if (!options) {
      this.onresizestart = this.onresizestart = this.onresizeend = null;
    }

    return this;
  }
  return this.options.resize;
};

function checkResizeEdge(name, value, page, element, interactableElement, rect, margin) {
  // false, '', undefined, null
  if (!value) {
    return false;
  }

  // true value, use pointer coords and element rect
  if (value === true) {
    // if dimensions are negative, "switch" edges
    var width = utils.is.number(rect.width) ? rect.width : rect.right - rect.left;
    var height = utils.is.number(rect.height) ? rect.height : rect.bottom - rect.top;

    if (width < 0) {
      if (name === 'left') {
        name = 'right';
      } else if (name === 'right') {
        name = 'left';
      }
    }
    if (height < 0) {
      if (name === 'top') {
        name = 'bottom';
      } else if (name === 'bottom') {
        name = 'top';
      }
    }

    if (name === 'left') {
      return page.x < (width >= 0 ? rect.left : rect.right) + margin;
    }
    if (name === 'top') {
      return page.y < (height >= 0 ? rect.top : rect.bottom) + margin;
    }

    if (name === 'right') {
      return page.x > (width >= 0 ? rect.right : rect.left) - margin;
    }
    if (name === 'bottom') {
      return page.y > (height >= 0 ? rect.bottom : rect.top) - margin;
    }
  }

  // the remaining checks require an element
  if (!utils.is.element(element)) {
    return false;
  }

  return utils.is.element(value)
  // the value is an element to use as a resize handle
  ? value === element
  // otherwise check if element matches value as selector
  : utils.matchesUpTo(element, value, interactableElement);
}

Interaction.signals.on('new', function (interaction) {
  interaction.resizeAxes = 'xy';
});

InteractEvent.signals.on('set-delta', function (_ref3) {
  var interaction = _ref3.interaction,
      iEvent = _ref3.iEvent,
      action = _ref3.action;

  if (action !== 'resize' || !interaction.resizeAxes) {
    return;
  }

  var options = interaction.target.options;

  if (options.resize.square) {
    if (interaction.resizeAxes === 'y') {
      iEvent.dx = iEvent.dy;
    } else {
      iEvent.dy = iEvent.dx;
    }
    iEvent.axes = 'xy';
  } else {
    iEvent.axes = interaction.resizeAxes;

    if (interaction.resizeAxes === 'x') {
      iEvent.dy = 0;
    } else if (interaction.resizeAxes === 'y') {
      iEvent.dx = 0;
    }
  }
});

actions.resize = resize;
actions.names.push('resize');
utils.merge(Interactable.eventTypes, ['resizestart', 'resizemove', 'resizeinertiastart', 'resizeinertiaresume', 'resizeend']);
actions.methodDict.resize = 'resizable';

defaultOptions.resize = resize.defaults;

module.exports = resize;

},{"../InteractEvent":3,"../Interactable":4,"../Interaction":5,"../defaultOptions":18,"../utils":44,"../utils/browser":36,"./base":6}],11:[function(require,module,exports){
'use strict';

var raf = require('./utils/raf');
var getWindow = require('./utils/window').getWindow;
var is = require('./utils/is');
var domUtils = require('./utils/domUtils');
var Interaction = require('./Interaction');
var defaultOptions = require('./defaultOptions');

var autoScroll = {
  defaults: {
    enabled: false,
    container: null, // the item that is scrolled (Window or HTMLElement)
    margin: 60,
    speed: 300 // the scroll speed in pixels per second
  },

  interaction: null,
  i: null, // the handle returned by window.setInterval
  x: 0, y: 0, // Direction each pulse is to scroll in

  isScrolling: false,
  prevTime: 0,

  start: function start(interaction) {
    autoScroll.isScrolling = true;
    raf.cancel(autoScroll.i);

    autoScroll.interaction = interaction;
    autoScroll.prevTime = new Date().getTime();
    autoScroll.i = raf.request(autoScroll.scroll);
  },

  stop: function stop() {
    autoScroll.isScrolling = false;
    raf.cancel(autoScroll.i);
  },

  // scroll the window by the values in scroll.x/y
  scroll: function scroll() {
    var options = autoScroll.interaction.target.options[autoScroll.interaction.prepared.name].autoScroll;
    var container = options.container || getWindow(autoScroll.interaction.element);
    var now = new Date().getTime();
    // change in time in seconds
    var dt = (now - autoScroll.prevTime) / 1000;
    // displacement
    var s = options.speed * dt;

    if (s >= 1) {
      if (is.window(container)) {
        container.scrollBy(autoScroll.x * s, autoScroll.y * s);
      } else if (container) {
        container.scrollLeft += autoScroll.x * s;
        container.scrollTop += autoScroll.y * s;
      }

      autoScroll.prevTime = now;
    }

    if (autoScroll.isScrolling) {
      raf.cancel(autoScroll.i);
      autoScroll.i = raf.request(autoScroll.scroll);
    }
  },
  check: function check(interactable, actionName) {
    var options = interactable.options;

    return options[actionName].autoScroll && options[actionName].autoScroll.enabled;
  },
  onInteractionMove: function onInteractionMove(_ref) {
    var interaction = _ref.interaction,
        pointer = _ref.pointer;

    if (!(interaction.interacting() && autoScroll.check(interaction.target, interaction.prepared.name))) {
      return;
    }

    if (interaction.simulation) {
      autoScroll.x = autoScroll.y = 0;
      return;
    }

    var top = void 0;
    var right = void 0;
    var bottom = void 0;
    var left = void 0;

    var options = interaction.target.options[interaction.prepared.name].autoScroll;
    var container = options.container || getWindow(interaction.element);

    if (is.window(container)) {
      left = pointer.clientX < autoScroll.margin;
      top = pointer.clientY < autoScroll.margin;
      right = pointer.clientX > container.innerWidth - autoScroll.margin;
      bottom = pointer.clientY > container.innerHeight - autoScroll.margin;
    } else {
      var rect = domUtils.getElementClientRect(container);

      left = pointer.clientX < rect.left + autoScroll.margin;
      top = pointer.clientY < rect.top + autoScroll.margin;
      right = pointer.clientX > rect.right - autoScroll.margin;
      bottom = pointer.clientY > rect.bottom - autoScroll.margin;
    }

    autoScroll.x = right ? 1 : left ? -1 : 0;
    autoScroll.y = bottom ? 1 : top ? -1 : 0;

    if (!autoScroll.isScrolling) {
      // set the autoScroll properties to those of the target
      autoScroll.margin = options.margin;
      autoScroll.speed = options.speed;

      autoScroll.start(interaction);
    }
  }
};

Interaction.signals.on('stop-active', function () {
  autoScroll.stop();
});

Interaction.signals.on('action-move', autoScroll.onInteractionMove);

defaultOptions.perAction.autoScroll = autoScroll.defaults;

module.exports = autoScroll;

},{"./Interaction":5,"./defaultOptions":18,"./utils/domUtils":39,"./utils/is":46,"./utils/raf":50,"./utils/window":52}],12:[function(require,module,exports){
'use strict';

/** @lends Interactable */
var Interactable = require('../Interactable');
var actions = require('../actions/base');
var is = require('../utils/is');
var domUtils = require('../utils/domUtils');

var _require = require('../utils'),
    warnOnce = _require.warnOnce;

Interactable.prototype.getAction = function (pointer, event, interaction, element) {
  var action = this.defaultActionChecker(pointer, event, interaction, element);

  if (this.options.actionChecker) {
    return this.options.actionChecker(pointer, event, action, this, element, interaction);
  }

  return action;
};

/**
 * ```js
 * interact(element, { ignoreFrom: document.getElementById('no-action') });
 * // or
 * interact(element).ignoreFrom('input, textarea, a');
 * ```
 * @deprecated
 * If the target of the `mousedown`, `pointerdown` or `touchstart` event or any
 * of it's parents match the given CSS selector or Element, no
 * drag/resize/gesture is started.
 *
 * Don't use this method. Instead set the `ignoreFrom` option for each action
 * or for `pointerEvents`
 *
 * @example
 * interact(targett)
 *   .draggable({
 *     ignoreFrom: 'input, textarea, a[href]'',
 *   })
 *   .pointerEvents({
 *     ignoreFrom: '[no-pointer]',
 *   });
 *
 * @param {string | Element | null} [newValue] a CSS selector string, an
 * Element or `null` to not ignore any elements
 * @return {string | Element | object} The current ignoreFrom value or this
 * Interactable
 */
Interactable.prototype.ignoreFrom = warnOnce(function (newValue) {
  return this._backCompatOption('ignoreFrom', newValue);
}, 'Interactable.ignoreForm() has been deprecated. Use Interactble.draggable({ignoreFrom: newValue}).');

/**
 * ```js
 *
 * @deprecated
 * A drag/resize/gesture is started only If the target of the `mousedown`,
 * `pointerdown` or `touchstart` event or any of it's parents match the given
 * CSS selector or Element.
 *
 * Don't use this method. Instead set the `allowFrom` option for each action
 * or for `pointerEvents`
 *
 * @example
 * interact(targett)
 *   .resizable({
 *     allowFrom: '.resize-handle',
 *   .pointerEvents({
 *     allowFrom: '.handle',,
 *   });
 *
 * @param {string | Element | null} [newValue] a CSS selector string, an
 * Element or `null` to allow from any element
 * @return {string | Element | object} The current allowFrom value or this
 * Interactable
 */
Interactable.prototype.allowFrom = warnOnce(function (newValue) {
  return this._backCompatOption('allowFrom', newValue);
}, 'Interactable.allowForm() has been deprecated. Use Interactble.draggable({allowFrom: newValue}).');

Interactable.prototype.testIgnore = function (ignoreFrom, interactableElement, element) {
  if (!ignoreFrom || !is.element(element)) {
    return false;
  }

  if (is.string(ignoreFrom)) {
    return domUtils.matchesUpTo(element, ignoreFrom, interactableElement);
  } else if (is.element(ignoreFrom)) {
    return domUtils.nodeContains(ignoreFrom, element);
  }

  return false;
};

Interactable.prototype.testAllow = function (allowFrom, interactableElement, element) {
  if (!allowFrom) {
    return true;
  }

  if (!is.element(element)) {
    return false;
  }

  if (is.string(allowFrom)) {
    return domUtils.matchesUpTo(element, allowFrom, interactableElement);
  } else if (is.element(allowFrom)) {
    return domUtils.nodeContains(allowFrom, element);
  }

  return false;
};

Interactable.prototype.testIgnoreAllow = function (options, interactableElement, eventTarget) {
  return !this.testIgnore(options.ignoreFrom, interactableElement, eventTarget) && this.testAllow(options.allowFrom, interactableElement, eventTarget);
};

/**
 * ```js
 * interact('.resize-drag')
 *   .resizable(true)
 *   .draggable(true)
 *   .actionChecker(function (pointer, event, action, interactable, element, interaction) {
 *
 *   if (interact.matchesSelector(event.target, '.drag-handle') {
 *     // force drag with handle target
 *     action.name = drag;
 *   }
 *   else {
 *     // resize from the top and right edges
 *     action.name  = 'resize';
 *     action.edges = { top: true, right: true };
 *   }
 *
 *   return action;
 * });
 * ```
 *
 * Gets or sets the function used to check action to be performed on
 * pointerDown
 *
 * @param {function | null} [checker] A function which takes a pointer event,
 * defaultAction string, interactable, element and interaction as parameters
 * and returns an object with name property 'drag' 'resize' or 'gesture' and
 * optionally an `edges` object with boolean 'top', 'left', 'bottom' and right
 * props.
 * @return {Function | Interactable} The checker function or this Interactable
 */
Interactable.prototype.actionChecker = function (checker) {
  if (is.function(checker)) {
    this.options.actionChecker = checker;

    return this;
  }

  if (checker === null) {
    delete this.options.actionChecker;

    return this;
  }

  return this.options.actionChecker;
};

/**
 * Returns or sets whether the the cursor should be changed depending on the
 * action that would be performed if the mouse were pressed and dragged.
 *
 * @param {boolean} [newValue]
 * @return {boolean | Interactable} The current setting or this Interactable
 */
Interactable.prototype.styleCursor = function (newValue) {
  if (is.bool(newValue)) {
    this.options.styleCursor = newValue;

    return this;
  }

  if (newValue === null) {
    delete this.options.styleCursor;

    return this;
  }

  return this.options.styleCursor;
};

Interactable.prototype.defaultActionChecker = function (pointer, event, interaction, element) {
  var rect = this.getRect(element);
  var buttons = event.buttons || {
    0: 1,
    1: 4,
    3: 8,
    4: 16
  }[event.button];
  var action = null;

  for (var _i = 0; _i < actions.names.length; _i++) {
    var _ref;

    _ref = actions.names[_i];
    var actionName = _ref;

    // check mouseButton setting if the pointer is down
    if (interaction.pointerIsDown && /mouse|pointer/.test(interaction.pointerType) && (buttons & this.options[actionName].mouseButtons) === 0) {
      continue;
    }

    action = actions[actionName].checker(pointer, event, this, element, interaction, rect);

    if (action) {
      return action;
    }
  }
};

},{"../Interactable":4,"../actions/base":6,"../utils":44,"../utils/domUtils":39,"../utils/is":46}],13:[function(require,module,exports){
'use strict';

var interact = require('../interact');
var Interactable = require('../Interactable');
var Interaction = require('../Interaction');
var actions = require('../actions/base');
var defaultOptions = require('../defaultOptions');
var scope = require('../scope');
var utils = require('../utils');
var signals = require('../utils/Signals').new();

require('./InteractableMethods');

var autoStart = {
  signals: signals,
  withinInteractionLimit: withinInteractionLimit,
  // Allow this many interactions to happen simultaneously
  maxInteractions: Infinity,
  defaults: {
    perAction: {
      manualStart: false,
      max: Infinity,
      maxPerElement: 1,
      allowFrom: null,
      ignoreFrom: null,

      // only allow left button by default
      // see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons#Return_value
      mouseButtons: 1
    }
  },
  setActionDefaults: function setActionDefaults(action) {
    utils.extend(action.defaults, autoStart.defaults.perAction);
  },
  validateAction: validateAction
};

// set cursor style on mousedown
Interaction.signals.on('down', function (_ref) {
  var interaction = _ref.interaction,
      pointer = _ref.pointer,
      event = _ref.event,
      eventTarget = _ref.eventTarget;

  if (interaction.interacting()) {
    return;
  }

  var actionInfo = getActionInfo(interaction, pointer, event, eventTarget);
  prepare(interaction, actionInfo);
});

// set cursor style on mousemove
Interaction.signals.on('move', function (_ref2) {
  var interaction = _ref2.interaction,
      pointer = _ref2.pointer,
      event = _ref2.event,
      eventTarget = _ref2.eventTarget;

  if (interaction.pointerType !== 'mouse' || interaction.pointerIsDown || interaction.interacting()) {
    return;
  }

  var actionInfo = getActionInfo(interaction, pointer, event, eventTarget);
  prepare(interaction, actionInfo);
});

Interaction.signals.on('move', function (arg) {
  var interaction = arg.interaction,
      event = arg.event;


  if (!interaction.pointerIsDown || interaction.interacting() || !interaction.pointerWasMoved || !interaction.prepared.name) {
    return;
  }

  signals.fire('before-start', arg);

  var target = interaction.target;

  if (interaction.prepared.name && target) {
    // check manualStart and interaction limit
    if (target.options[interaction.prepared.name].manualStart || !withinInteractionLimit(target, interaction.element, interaction.prepared)) {
      interaction.stop(event);
    } else {
      interaction.start(interaction.prepared, target, interaction.element);
    }
  }
});

// Check if the current target supports the action.
// If so, return the validated action. Otherwise, return null
function validateAction(action, interactable, element, eventTarget) {
  if (utils.is.object(action) && interactable.testIgnoreAllow(interactable.options[action.name], element, eventTarget) && interactable.options[action.name].enabled && withinInteractionLimit(interactable, element, action)) {
    return action;
  }

  return null;
}

function validateSelector(interaction, pointer, event, matches, matchElements, eventTarget) {
  for (var i = 0, len = matches.length; i < len; i++) {
    var match = matches[i];
    var matchElement = matchElements[i];
    var action = validateAction(match.getAction(pointer, event, interaction, matchElement), match, matchElement, eventTarget);

    if (action) {
      return {
        action: action,
        target: match,
        element: matchElement
      };
    }
  }

  return {};
}

function getActionInfo(interaction, pointer, event, eventTarget) {
  var matches = [];
  var matchElements = [];

  var element = eventTarget;

  function pushMatches(interactable) {
    matches.push(interactable);
    matchElements.push(element);
  }

  while (utils.is.element(element)) {
    matches = [];
    matchElements = [];

    scope.interactables.forEachMatch(element, pushMatches);

    var actionInfo = validateSelector(interaction, pointer, event, matches, matchElements, eventTarget);

    if (actionInfo.action && !actionInfo.target.options[actionInfo.action.name].manualStart) {
      return actionInfo;
    }

    element = utils.parentNode(element);
  }

  return {};
}

function prepare(interaction, _ref3) {
  var action = _ref3.action,
      target = _ref3.target,
      element = _ref3.element;

  action = action || {};

  if (interaction.target && interaction.target.options.styleCursor) {
    interaction.target._doc.documentElement.style.cursor = '';
  }

  interaction.target = target;
  interaction.element = element;
  utils.copyAction(interaction.prepared, action);

  if (target && target.options.styleCursor) {
    var cursor = action ? actions[action.name].getCursor(action) : '';
    interaction.target._doc.documentElement.style.cursor = cursor;
  }

  signals.fire('prepared', { interaction: interaction });
}

Interaction.signals.on('stop', function (_ref4) {
  var interaction = _ref4.interaction;

  var target = interaction.target;

  if (target && target.options.styleCursor) {
    target._doc.documentElement.style.cursor = '';
  }
});

function withinInteractionLimit(interactable, element, action) {
  var options = interactable.options;
  var maxActions = options[action.name].max;
  var maxPerElement = options[action.name].maxPerElement;
  var activeInteractions = 0;
  var targetCount = 0;
  var targetElementCount = 0;

  // no actions if any of these values == 0
  if (!(maxActions && maxPerElement && autoStart.maxInteractions)) {
    return;
  }

  for (var _i = 0; _i < scope.interactions.length; _i++) {
    var _ref5;

    _ref5 = scope.interactions[_i];
    var interaction = _ref5;

    var otherAction = interaction.prepared.name;

    if (!interaction.interacting()) {
      continue;
    }

    activeInteractions++;

    if (activeInteractions >= autoStart.maxInteractions) {
      return false;
    }

    if (interaction.target !== interactable) {
      continue;
    }

    targetCount += otherAction === action.name | 0;

    if (targetCount >= maxActions) {
      return false;
    }

    if (interaction.element === element) {
      targetElementCount++;

      if (otherAction !== action.name || targetElementCount >= maxPerElement) {
        return false;
      }
    }
  }

  return autoStart.maxInteractions > 0;
}

/**
 * Returns or sets the maximum number of concurrent interactions allowed.  By
 * default only 1 interaction is allowed at a time (for backwards
 * compatibility). To allow multiple interactions on the same Interactables and
 * elements, you need to enable it in the draggable, resizable and gesturable
 * `'max'` and `'maxPerElement'` options.
 *
 * @alias module:interact.maxInteractions
 *
 * @param {number} [newValue] Any number. newValue <= 0 means no interactions.
 */
interact.maxInteractions = function (newValue) {
  if (utils.is.number(newValue)) {
    autoStart.maxInteractions = newValue;

    return interact;
  }

  return autoStart.maxInteractions;
};

Interactable.settingsMethods.push('styleCursor');
Interactable.settingsMethods.push('actionChecker');
Interactable.settingsMethods.push('ignoreFrom');
Interactable.settingsMethods.push('allowFrom');

defaultOptions.base.actionChecker = null;
defaultOptions.base.styleCursor = true;

utils.extend(defaultOptions.perAction, autoStart.defaults.perAction);

module.exports = autoStart;

},{"../Interactable":4,"../Interaction":5,"../actions/base":6,"../defaultOptions":18,"../interact":21,"../scope":33,"../utils":44,"../utils/Signals":34,"./InteractableMethods":12}],14:[function(require,module,exports){
'use strict';

var autoStart = require('./base');
var scope = require('../scope');
var is = require('../utils/is');

var _require = require('../utils/domUtils'),
    parentNode = _require.parentNode;

autoStart.setActionDefaults(require('../actions/drag'));

autoStart.signals.on('before-start', function (_ref) {
  var interaction = _ref.interaction,
      eventTarget = _ref.eventTarget,
      dx = _ref.dx,
      dy = _ref.dy;

  if (interaction.prepared.name !== 'drag') {
    return;
  }

  // check if a drag is in the correct axis
  var absX = Math.abs(dx);
  var absY = Math.abs(dy);
  var targetOptions = interaction.target.options.drag;
  var startAxis = targetOptions.startAxis;
  var currentAxis = absX > absY ? 'x' : absX < absY ? 'y' : 'xy';

  interaction.prepared.axis = targetOptions.lockAxis === 'start' ? currentAxis[0] // always lock to one axis even if currentAxis === 'xy'
  : targetOptions.lockAxis;

  // if the movement isn't in the startAxis of the interactable
  if (currentAxis !== 'xy' && startAxis !== 'xy' && startAxis !== currentAxis) {
    // cancel the prepared action
    interaction.prepared.name = null;

    // then try to get a drag from another ineractable
    var element = eventTarget;

    var getDraggable = function getDraggable(interactable) {
      if (interactable === interaction.target) {
        return;
      }

      var options = interaction.target.options.drag;

      if (!options.manualStart && interactable.testIgnoreAllow(options, element, eventTarget)) {

        var action = interactable.getAction(interaction.downPointer, interaction.downEvent, interaction, element);

        if (action && action.name === 'drag' && checkStartAxis(currentAxis, interactable) && autoStart.validateAction(action, interactable, element, eventTarget)) {

          return interactable;
        }
      }
    };

    // check all interactables
    while (is.element(element)) {
      var interactable = scope.interactables.forEachMatch(element, getDraggable);

      if (interactable) {
        interaction.prepared.name = 'drag';
        interaction.target = interactable;
        interaction.element = element;
        break;
      }

      element = parentNode(element);
    }
  }
});

function checkStartAxis(startAxis, interactable) {
  if (!interactable) {
    return false;
  }

  var thisAxis = interactable.options.drag.startAxis;

  return startAxis === 'xy' || thisAxis === 'xy' || thisAxis === startAxis;
}

},{"../actions/drag":7,"../scope":33,"../utils/domUtils":39,"../utils/is":46,"./base":13}],15:[function(require,module,exports){
'use strict';

require('./base').setActionDefaults(require('../actions/gesture'));

},{"../actions/gesture":9,"./base":13}],16:[function(require,module,exports){
'use strict';

var autoStart = require('./base');
var Interaction = require('../Interaction');

autoStart.defaults.perAction.hold = 0;
autoStart.defaults.perAction.delay = 0;

Interaction.signals.on('new', function (interaction) {
  interaction.autoStartHoldTimer = null;
});

autoStart.signals.on('prepared', function (_ref) {
  var interaction = _ref.interaction;

  var hold = getHoldDuration(interaction);

  if (hold > 0) {
    interaction.autoStartHoldTimer = setTimeout(function () {
      interaction.start(interaction.prepared, interaction.target, interaction.element);
    }, hold);
  }
});

Interaction.signals.on('move', function (_ref2) {
  var interaction = _ref2.interaction,
      duplicate = _ref2.duplicate;

  if (interaction.pointerWasMoved && !duplicate) {
    clearTimeout(interaction.autoStartHoldTimer);
  }
});

// prevent regular down->move autoStart
autoStart.signals.on('before-start', function (_ref3) {
  var interaction = _ref3.interaction;

  var hold = getHoldDuration(interaction);

  if (hold > 0) {
    interaction.prepared.name = null;
  }
});

function getHoldDuration(interaction) {
  var actionName = interaction.prepared && interaction.prepared.name;

  if (!actionName) {
    return null;
  }

  var options = interaction.target.options;

  return options[actionName].hold || options[actionName].delay;
}

module.exports = {
  getHoldDuration: getHoldDuration
};

},{"../Interaction":5,"./base":13}],17:[function(require,module,exports){
'use strict';

require('./base').setActionDefaults(require('../actions/resize'));

},{"../actions/resize":10,"./base":13}],18:[function(require,module,exports){
'use strict';

module.exports = {
  base: {
    accept: null,
    preventDefault: 'auto',
    deltaSource: 'page'
  },

  perAction: {
    origin: { x: 0, y: 0 },

    inertia: {
      enabled: false,
      resistance: 10, // the lambda in exponential decay
      minSpeed: 100, // target speed must be above this for inertia to start
      endSpeed: 10, // the speed at which inertia is slow enough to stop
      allowResume: true, // allow resuming an action in inertia phase
      smoothEndDuration: 300 // animate to snap/restrict endOnly if there's no inertia
    }
  }
};

},{}],19:[function(require,module,exports){
'use strict';

/* browser entry point */

// inertia
require('./inertia');

// modifiers
require('./modifiers/snap');
require('./modifiers/restrict');

// pointerEvents
require('./pointerEvents/base');
require('./pointerEvents/holdRepeat');
require('./pointerEvents/interactableTargets');

// autoStart hold
require('./autoStart/hold');

// actions
require('./actions/gesture');
require('./actions/resize');
require('./actions/drag');
require('./actions/drop');

// load these modifiers after resize is loaded
require('./modifiers/snapSize');
require('./modifiers/restrictEdges');
require('./modifiers/restrictSize');

// autoStart actions
require('./autoStart/gesture');
require('./autoStart/resize');
require('./autoStart/drag');

// Interactable preventDefault setting
require('./interactablePreventDefault.js');

// autoScroll
require('./autoScroll');

// export interact
module.exports = require('./interact');

},{"./actions/drag":7,"./actions/drop":8,"./actions/gesture":9,"./actions/resize":10,"./autoScroll":11,"./autoStart/drag":14,"./autoStart/gesture":15,"./autoStart/hold":16,"./autoStart/resize":17,"./inertia":20,"./interact":21,"./interactablePreventDefault.js":22,"./modifiers/restrict":24,"./modifiers/restrictEdges":25,"./modifiers/restrictSize":26,"./modifiers/snap":27,"./modifiers/snapSize":28,"./pointerEvents/base":30,"./pointerEvents/holdRepeat":31,"./pointerEvents/interactableTargets":32}],20:[function(require,module,exports){
'use strict';

var InteractEvent = require('./InteractEvent');
var Interaction = require('./Interaction');
var modifiers = require('./modifiers/base');
var utils = require('./utils');
var animationFrame = require('./utils/raf');

Interaction.signals.on('new', function (interaction) {
  interaction.inertiaStatus = {
    active: false,
    smoothEnd: false,
    allowResume: false,

    startEvent: null,
    upCoords: {},

    xe: 0, ye: 0,
    sx: 0, sy: 0,

    t0: 0,
    vx0: 0, vys: 0,
    duration: 0,

    lambda_v0: 0,
    one_ve_v0: 0,
    i: null
  };

  interaction.boundInertiaFrame = function () {
    return inertiaFrame.apply(interaction);
  };
  interaction.boundSmoothEndFrame = function () {
    return smoothEndFrame.apply(interaction);
  };
});

Interaction.signals.on('down', function (_ref) {
  var interaction = _ref.interaction,
      event = _ref.event,
      pointer = _ref.pointer,
      eventTarget = _ref.eventTarget;

  var status = interaction.inertiaStatus;

  // Check if the down event hits the current inertia target
  if (status.active) {
    var element = eventTarget;

    // climb up the DOM tree from the event target
    while (utils.is.element(element)) {

      // if interaction element is the current inertia target element
      if (element === interaction.element) {
        // stop inertia
        animationFrame.cancel(status.i);
        status.active = false;
        interaction.simulation = null;

        // update pointers to the down event's coordinates
        interaction.updatePointer(pointer);
        utils.setCoords(interaction.curCoords, interaction.pointers);

        // fire appropriate signals
        var signalArg = { interaction: interaction };
        Interaction.signals.fire('before-action-move', signalArg);
        Interaction.signals.fire('action-resume', signalArg);

        // fire a reume event
        var resumeEvent = new InteractEvent(interaction, event, interaction.prepared.name, 'inertiaresume', interaction.element);

        interaction.target.fire(resumeEvent);
        interaction.prevEvent = resumeEvent;
        modifiers.resetStatuses(interaction.modifierStatuses);

        utils.copyCoords(interaction.prevCoords, interaction.curCoords);
        break;
      }

      element = utils.parentNode(element);
    }
  }
});

Interaction.signals.on('up', function (_ref2) {
  var interaction = _ref2.interaction,
      event = _ref2.event;

  var status = interaction.inertiaStatus;

  if (!interaction.interacting() || status.active) {
    return;
  }

  var target = interaction.target;
  var options = target && target.options;
  var inertiaOptions = options && interaction.prepared.name && options[interaction.prepared.name].inertia;

  var now = new Date().getTime();
  var statuses = {};
  var page = utils.extend({}, interaction.curCoords.page);
  var pointerSpeed = interaction.pointerDelta.client.speed;

  var smoothEnd = false;
  var modifierResult = void 0;

  // check if inertia should be started
  var inertiaPossible = inertiaOptions && inertiaOptions.enabled && interaction.prepared.name !== 'gesture' && event !== status.startEvent;

  var inertia = inertiaPossible && now - interaction.curCoords.timeStamp < 50 && pointerSpeed > inertiaOptions.minSpeed && pointerSpeed > inertiaOptions.endSpeed;

  var modifierArg = {
    interaction: interaction,
    pageCoords: page,
    statuses: statuses,
    preEnd: true,
    requireEndOnly: true
  };

  // smoothEnd
  if (inertiaPossible && !inertia) {
    modifiers.resetStatuses(statuses);

    modifierResult = modifiers.setAll(modifierArg);

    if (modifierResult.shouldMove && modifierResult.locked) {
      smoothEnd = true;
    }
  }

  if (!(inertia || smoothEnd)) {
    return;
  }

  utils.copyCoords(status.upCoords, interaction.curCoords);

  interaction.pointers[0] = status.startEvent = new InteractEvent(interaction, event, interaction.prepared.name, 'inertiastart', interaction.element);

  status.t0 = now;

  status.active = true;
  status.allowResume = inertiaOptions.allowResume;
  interaction.simulation = status;

  target.fire(status.startEvent);

  if (inertia) {
    status.vx0 = interaction.pointerDelta.client.vx;
    status.vy0 = interaction.pointerDelta.client.vy;
    status.v0 = pointerSpeed;

    calcInertia(interaction, status);

    utils.extend(page, interaction.curCoords.page);

    page.x += status.xe;
    page.y += status.ye;

    modifiers.resetStatuses(statuses);

    modifierResult = modifiers.setAll(modifierArg);

    status.modifiedXe += modifierResult.dx;
    status.modifiedYe += modifierResult.dy;

    status.i = animationFrame.request(interaction.boundInertiaFrame);
  } else {
    status.smoothEnd = true;
    status.xe = modifierResult.dx;
    status.ye = modifierResult.dy;

    status.sx = status.sy = 0;

    status.i = animationFrame.request(interaction.boundSmoothEndFrame);
  }
});

Interaction.signals.on('stop-active', function (_ref3) {
  var interaction = _ref3.interaction;

  var status = interaction.inertiaStatus;

  if (status.active) {
    animationFrame.cancel(status.i);
    status.active = false;
    interaction.simulation = null;
  }
});

function calcInertia(interaction, status) {
  var inertiaOptions = interaction.target.options[interaction.prepared.name].inertia;
  var lambda = inertiaOptions.resistance;
  var inertiaDur = -Math.log(inertiaOptions.endSpeed / status.v0) / lambda;

  status.x0 = interaction.prevEvent.pageX;
  status.y0 = interaction.prevEvent.pageY;
  status.t0 = status.startEvent.timeStamp / 1000;
  status.sx = status.sy = 0;

  status.modifiedXe = status.xe = (status.vx0 - inertiaDur) / lambda;
  status.modifiedYe = status.ye = (status.vy0 - inertiaDur) / lambda;
  status.te = inertiaDur;

  status.lambda_v0 = lambda / status.v0;
  status.one_ve_v0 = 1 - inertiaOptions.endSpeed / status.v0;
}

function inertiaFrame() {
  updateInertiaCoords(this);
  utils.setCoordDeltas(this.pointerDelta, this.prevCoords, this.curCoords);

  var status = this.inertiaStatus;
  var options = this.target.options[this.prepared.name].inertia;
  var lambda = options.resistance;
  var t = new Date().getTime() / 1000 - status.t0;

  if (t < status.te) {

    var progress = 1 - (Math.exp(-lambda * t) - status.lambda_v0) / status.one_ve_v0;

    if (status.modifiedXe === status.xe && status.modifiedYe === status.ye) {
      status.sx = status.xe * progress;
      status.sy = status.ye * progress;
    } else {
      var quadPoint = utils.getQuadraticCurvePoint(0, 0, status.xe, status.ye, status.modifiedXe, status.modifiedYe, progress);

      status.sx = quadPoint.x;
      status.sy = quadPoint.y;
    }

    this.doMove();

    status.i = animationFrame.request(this.boundInertiaFrame);
  } else {
    status.sx = status.modifiedXe;
    status.sy = status.modifiedYe;

    this.doMove();
    this.end(status.startEvent);
    status.active = false;
    this.simulation = null;
  }

  utils.copyCoords(this.prevCoords, this.curCoords);
}

function smoothEndFrame() {
  updateInertiaCoords(this);

  var status = this.inertiaStatus;
  var t = new Date().getTime() - status.t0;
  var duration = this.target.options[this.prepared.name].inertia.smoothEndDuration;

  if (t < duration) {
    status.sx = utils.easeOutQuad(t, 0, status.xe, duration);
    status.sy = utils.easeOutQuad(t, 0, status.ye, duration);

    this.pointerMove(status.startEvent, status.startEvent);

    status.i = animationFrame.request(this.boundSmoothEndFrame);
  } else {
    status.sx = status.xe;
    status.sy = status.ye;

    this.pointerMove(status.startEvent, status.startEvent);
    this.end(status.startEvent);

    status.smoothEnd = status.active = false;
    this.simulation = null;
  }
}

function updateInertiaCoords(interaction) {
  var status = interaction.inertiaStatus;

  // return if inertia isn't running
  if (!status.active) {
    return;
  }

  var pageUp = status.upCoords.page;
  var clientUp = status.upCoords.client;

  utils.setCoords(interaction.curCoords, [{
    pageX: pageUp.x + status.sx,
    pageY: pageUp.y + status.sy,
    clientX: clientUp.x + status.sx,
    clientY: clientUp.y + status.sy
  }]);
}

},{"./InteractEvent":3,"./Interaction":5,"./modifiers/base":23,"./utils":44,"./utils/raf":50}],21:[function(require,module,exports){
'use strict';

/** @module interact */

var browser = require('./utils/browser');
var events = require('./utils/events');
var utils = require('./utils');
var scope = require('./scope');
var Interactable = require('./Interactable');
var Interaction = require('./Interaction');

var globalEvents = {};

/**
 * ```js
 * interact('#draggable').draggable(true);
 *
 * var rectables = interact('rect');
 * rectables
 *   .gesturable(true)
 *   .on('gesturemove', function (event) {
 *       // ...
 *   });
 * ```
 *
 * The methods of this variable can be used to set elements as interactables
 * and also to change various default settings.
 *
 * Calling it as a function and passing an element or a valid CSS selector
 * string returns an Interactable object which has various methods to configure
 * it.
 *
 * @global
 *
 * @param {Element | string} element The HTML or SVG Element to interact with
 * or CSS selector
 * @return {Interactable}
 */
function interact(element, options) {
  var interactable = scope.interactables.get(element, options);

  if (!interactable) {
    interactable = new Interactable(element, options);
    interactable.events.global = globalEvents;
  }

  return interactable;
}

/**
 * Check if an element or selector has been set with the {@link interact}
 * function
 *
 * @alias module:interact.isSet
 *
 * @param {Element} element The Element being searched for
 * @return {boolean} Indicates if the element or CSS selector was previously
 * passed to interact
*/
interact.isSet = function (element, options) {
  return scope.interactables.indexOfElement(element, options && options.context) !== -1;
};

/**
 * Add a global listener for an InteractEvent or adds a DOM event to `document`
 *
 * @alias module:interact.on
 *
 * @param {string | array | object} type The types of events to listen for
 * @param {function} listener The function event (s)
 * @param {object | boolean} [options] object or useCapture flag for
 * addEventListener
 * @return {object} interact
 */
interact.on = function (type, listener, options) {
  if (utils.is.string(type) && type.search(' ') !== -1) {
    type = type.trim().split(/ +/);
  }

  if (utils.is.array(type)) {
    for (var _i = 0; _i < type.length; _i++) {
      var _ref;

      _ref = type[_i];
      var eventType = _ref;

      interact.on(eventType, listener, options);
    }

    return interact;
  }

  if (utils.is.object(type)) {
    for (var prop in type) {
      interact.on(prop, type[prop], listener);
    }

    return interact;
  }

  // if it is an InteractEvent type, add listener to globalEvents
  if (utils.contains(Interactable.eventTypes, type)) {
    // if this type of event was never bound
    if (!globalEvents[type]) {
      globalEvents[type] = [listener];
    } else {
      globalEvents[type].push(listener);
    }
  }
  // If non InteractEvent type, addEventListener to document
  else {
      events.add(scope.document, type, listener, { options: options });
    }

  return interact;
};

/**
 * Removes a global InteractEvent listener or DOM event from `document`
 *
 * @alias module:interact.off
 *
 * @param {string | array | object} type The types of events that were listened
 * for
 * @param {function} listener The listener function to be removed
 * @param {object | boolean} options [options] object or useCapture flag for
 * removeEventListener
 * @return {object} interact
 */
interact.off = function (type, listener, options) {
  if (utils.is.string(type) && type.search(' ') !== -1) {
    type = type.trim().split(/ +/);
  }

  if (utils.is.array(type)) {
    for (var _i2 = 0; _i2 < type.length; _i2++) {
      var _ref2;

      _ref2 = type[_i2];
      var eventType = _ref2;

      interact.off(eventType, listener, options);
    }

    return interact;
  }

  if (utils.is.object(type)) {
    for (var prop in type) {
      interact.off(prop, type[prop], listener);
    }

    return interact;
  }

  if (!utils.contains(Interactable.eventTypes, type)) {
    events.remove(scope.document, type, listener, options);
  } else {
    var index = void 0;

    if (type in globalEvents && (index = globalEvents[type].indexOf(listener)) !== -1) {
      globalEvents[type].splice(index, 1);
    }
  }

  return interact;
};

/**
 * Returns an object which exposes internal data

 * @alias module:interact.debug
 *
 * @return {object} An object with properties that outline the current state
 * and expose internal functions and variables
 */
interact.debug = function () {
  return scope;
};

// expose the functions used to calculate multi-touch properties
interact.getPointerAverage = utils.pointerAverage;
interact.getTouchBBox = utils.touchBBox;
interact.getTouchDistance = utils.touchDistance;
interact.getTouchAngle = utils.touchAngle;

interact.getElementRect = utils.getElementRect;
interact.getElementClientRect = utils.getElementClientRect;
interact.matchesSelector = utils.matchesSelector;
interact.closest = utils.closest;

/**
 * @alias module:interact.supportsTouch
 *
 * @return {boolean} Whether or not the browser supports touch input
 */
interact.supportsTouch = function () {
  return browser.supportsTouch;
};

/**
 * @alias module:interact.supportsPointerEvent
 *
 * @return {boolean} Whether or not the browser supports PointerEvents
 */
interact.supportsPointerEvent = function () {
  return browser.supportsPointerEvent;
};

/**
 * Cancels all interactions (end events are not fired)
 *
 * @alias module:interact.stop
 *
 * @param {Event} event An event on which to call preventDefault()
 * @return {object} interact
 */
interact.stop = function (event) {
  for (var i = scope.interactions.length - 1; i >= 0; i--) {
    scope.interactions[i].stop(event);
  }

  return interact;
};

/**
 * Returns or sets the distance the pointer must be moved before an action
 * sequence occurs. This also affects tolerance for tap events.
 *
 * @alias module:interact.pointerMoveTolerance
 *
 * @param {number} [newValue] The movement from the start position must be greater than this value
 * @return {interact | number}
 */
interact.pointerMoveTolerance = function (newValue) {
  if (utils.is.number(newValue)) {
    Interaction.pointerMoveTolerance = newValue;

    return interact;
  }

  return Interaction.pointerMoveTolerance;
};

interact.addDocument = scope.addDocument;
interact.removeDocument = scope.removeDocument;

scope.interact = interact;

module.exports = interact;

},{"./Interactable":4,"./Interaction":5,"./scope":33,"./utils":44,"./utils/browser":36,"./utils/events":40}],22:[function(require,module,exports){
'use strict';

var Interactable = require('./Interactable');
var Interaction = require('./Interaction');
var scope = require('./scope');
var is = require('./utils/is');
var events = require('./utils/events');
var browser = require('./utils/browser');

var _require = require('./utils/domUtils'),
    nodeContains = _require.nodeContains,
    matchesSelector = _require.matchesSelector;

/**
 * Returns or sets whether to prevent the browser's default behaviour in
 * response to pointer events. Can be set to:
 *  - `'always'` to always prevent
 *  - `'never'` to never prevent
 *  - `'auto'` to let interact.js try to determine what would be best
 *
 * @param {string} [newValue] `true`, `false` or `'auto'`
 * @return {string | Interactable} The current setting or this Interactable
 */


Interactable.prototype.preventDefault = function (newValue) {
  if (/^(always|never|auto)$/.test(newValue)) {
    this.options.preventDefault = newValue;
    return this;
  }

  if (is.bool(newValue)) {
    this.options.preventDefault = newValue ? 'always' : 'never';
    return this;
  }

  return this.options.preventDefault;
};

Interactable.prototype.checkAndPreventDefault = function (event) {
  var setting = this.options.preventDefault;

  if (setting === 'never') {
    return;
  }

  if (setting === 'always') {
    event.preventDefault();
    return;
  }

  // setting === 'auto'

  // don't preventDefault of touch{start,move} events if the browser supports passive
  // events listeners. CSS touch-action and user-selecct should be used instead
  if (events.supportsPassive && /^touch(start|move)$/.test(event.type) && !browser.isIOS) {
    return;
  }

  // don't preventDefault of pointerdown events
  if (/^(mouse|pointer|touch)*(down|start)/i.test(event.type)) {
    return;
  }

  // don't preventDefault on editable elements
  if (is.element(event.target) && matchesSelector(event.target, 'input,select,textarea,[contenteditable=true],[contenteditable=true] *')) {
    return;
  }

  event.preventDefault();
};

function onInteractionEvent(_ref) {
  var interaction = _ref.interaction,
      event = _ref.event;

  if (interaction.target) {
    interaction.target.checkAndPreventDefault(event);
  }
}

var _arr = ['down', 'move', 'up', 'cancel'];
for (var _i = 0; _i < _arr.length; _i++) {
  var eventSignal = _arr[_i];
  Interaction.signals.on(eventSignal, onInteractionEvent);
}

// prevent native HTML5 drag on interact.js target elements
Interaction.docEvents.dragstart = function preventNativeDrag(event) {
  for (var _i2 = 0; _i2 < scope.interactions.length; _i2++) {
    var _ref2;

    _ref2 = scope.interactions[_i2];
    var interaction = _ref2;


    if (interaction.element && (interaction.element === event.target || nodeContains(interaction.element, event.target))) {

      interaction.target.checkAndPreventDefault(event);
      return;
    }
  }
};

},{"./Interactable":4,"./Interaction":5,"./scope":33,"./utils/browser":36,"./utils/domUtils":39,"./utils/events":40,"./utils/is":46}],23:[function(require,module,exports){
'use strict';

var InteractEvent = require('../InteractEvent');
var Interaction = require('../Interaction');
var extend = require('../utils/extend');

var modifiers = {
  names: [],

  setOffsets: function setOffsets(arg) {
    var interaction = arg.interaction,
        page = arg.pageCoords;
    var target = interaction.target,
        element = interaction.element,
        startOffset = interaction.startOffset;

    var rect = target.getRect(element);

    if (rect) {
      startOffset.left = page.x - rect.left;
      startOffset.top = page.y - rect.top;

      startOffset.right = rect.right - page.x;
      startOffset.bottom = rect.bottom - page.y;

      if (!('width' in rect)) {
        rect.width = rect.right - rect.left;
      }
      if (!('height' in rect)) {
        rect.height = rect.bottom - rect.top;
      }
    } else {
      startOffset.left = startOffset.top = startOffset.right = startOffset.bottom = 0;
    }

    arg.rect = rect;
    arg.interactable = target;
    arg.element = element;

    for (var _i = 0; _i < modifiers.names.length; _i++) {
      var _ref;

      _ref = modifiers.names[_i];
      var modifierName = _ref;

      arg.options = target.options[interaction.prepared.name][modifierName];

      if (!arg.options) {
        continue;
      }

      interaction.modifierOffsets[modifierName] = modifiers[modifierName].setOffset(arg);
    }
  },

  setAll: function setAll(arg) {
    var interaction = arg.interaction,
        statuses = arg.statuses,
        preEnd = arg.preEnd,
        requireEndOnly = arg.requireEndOnly;

    var result = {
      dx: 0,
      dy: 0,
      changed: false,
      locked: false,
      shouldMove: true
    };

    arg.modifiedCoords = extend({}, arg.pageCoords);

    for (var _i2 = 0; _i2 < modifiers.names.length; _i2++) {
      var _ref2;

      _ref2 = modifiers.names[_i2];
      var modifierName = _ref2;

      var modifier = modifiers[modifierName];
      var options = interaction.target.options[interaction.prepared.name][modifierName];

      if (!shouldDo(options, preEnd, requireEndOnly)) {
        continue;
      }

      arg.status = arg.status = statuses[modifierName];
      arg.options = options;
      arg.offset = arg.interaction.modifierOffsets[modifierName];

      modifier.set(arg);

      if (arg.status.locked) {
        arg.modifiedCoords.x += arg.status.dx;
        arg.modifiedCoords.y += arg.status.dy;

        result.dx += arg.status.dx;
        result.dy += arg.status.dy;

        result.locked = true;
      }
    }

    // a move should be fired if:
    //  - there are no modifiers enabled,
    //  - no modifiers are "locked" i.e. have changed the pointer's coordinates, or
    //  - the locked coords have changed since the last pointer move
    result.shouldMove = !arg.status || !result.locked || arg.status.changed;

    return result;
  },

  resetStatuses: function resetStatuses(statuses) {
    for (var _i3 = 0; _i3 < modifiers.names.length; _i3++) {
      var _ref3;

      _ref3 = modifiers.names[_i3];
      var modifierName = _ref3;

      var status = statuses[modifierName] || {};

      status.dx = status.dy = 0;
      status.modifiedX = status.modifiedY = NaN;
      status.locked = false;
      status.changed = true;

      statuses[modifierName] = status;
    }

    return statuses;
  },

  start: function start(_ref4, signalName) {
    var interaction = _ref4.interaction;

    var arg = {
      interaction: interaction,
      pageCoords: (signalName === 'action-resume' ? interaction.curCoords : interaction.startCoords).page,
      startOffset: interaction.startOffset,
      statuses: interaction.modifierStatuses,
      preEnd: false,
      requireEndOnly: false
    };

    modifiers.setOffsets(arg);
    modifiers.resetStatuses(arg.statuses);

    arg.pageCoords = extend({}, interaction.startCoords.page);
    interaction.modifierResult = modifiers.setAll(arg);
  },

  beforeMove: function beforeMove(_ref5) {
    var interaction = _ref5.interaction,
        preEnd = _ref5.preEnd,
        interactingBeforeMove = _ref5.interactingBeforeMove;

    var modifierResult = modifiers.setAll({
      interaction: interaction,
      preEnd: preEnd,
      pageCoords: interaction.curCoords.page,
      statuses: interaction.modifierStatuses,
      requireEndOnly: false
    });

    // don't fire an action move if a modifier would keep the event in the same
    // cordinates as before
    if (!modifierResult.shouldMove && interactingBeforeMove) {
      interaction._dontFireMove = true;
    }

    interaction.modifierResult = modifierResult;
  },

  end: function end(_ref6) {
    var interaction = _ref6.interaction,
        event = _ref6.event;

    for (var _i4 = 0; _i4 < modifiers.names.length; _i4++) {
      var _ref7;

      _ref7 = modifiers.names[_i4];
      var modifierName = _ref7;

      var options = interaction.target.options[interaction.prepared.name][modifierName];

      // if the endOnly option is true for any modifier
      if (shouldDo(options, true, true)) {
        // fire a move event at the modified coordinates
        interaction.doMove({ event: event, preEnd: true });
        break;
      }
    }
  },

  setXY: function setXY(arg) {
    var iEvent = arg.iEvent,
        interaction = arg.interaction;

    var modifierArg = extend({}, arg);

    for (var i = 0; i < modifiers.names.length; i++) {
      var modifierName = modifiers.names[i];
      modifierArg.options = interaction.target.options[interaction.prepared.name][modifierName];

      if (!modifierArg.options) {
        continue;
      }

      var modifier = modifiers[modifierName];

      modifierArg.status = interaction.modifierStatuses[modifierName];

      iEvent[modifierName] = modifier.modifyCoords(modifierArg);
    }
  }
};

Interaction.signals.on('new', function (interaction) {
  interaction.startOffset = { left: 0, right: 0, top: 0, bottom: 0 };
  interaction.modifierOffsets = {};
  interaction.modifierStatuses = modifiers.resetStatuses({});
  interaction.modifierResult = null;
});

Interaction.signals.on('action-start', modifiers.start);
Interaction.signals.on('action-resume', modifiers.start);
Interaction.signals.on('before-action-move', modifiers.beforeMove);
Interaction.signals.on('action-end', modifiers.end);

InteractEvent.signals.on('set-xy', modifiers.setXY);

function shouldDo(options, preEnd, requireEndOnly) {
  return options && options.enabled && (preEnd || !options.endOnly) && (!requireEndOnly || options.endOnly);
}

module.exports = modifiers;

},{"../InteractEvent":3,"../Interaction":5,"../utils/extend":41}],24:[function(require,module,exports){
'use strict';

var modifiers = require('./base');
var utils = require('../utils');
var defaultOptions = require('../defaultOptions');

var restrict = {
  defaults: {
    enabled: false,
    endOnly: false,
    restriction: null,
    elementRect: null
  },

  setOffset: function setOffset(_ref) {
    var rect = _ref.rect,
        startOffset = _ref.startOffset,
        options = _ref.options;

    var elementRect = options && options.elementRect;
    var offset = {};

    if (rect && elementRect) {
      offset.left = startOffset.left - rect.width * elementRect.left;
      offset.top = startOffset.top - rect.height * elementRect.top;

      offset.right = startOffset.right - rect.width * (1 - elementRect.right);
      offset.bottom = startOffset.bottom - rect.height * (1 - elementRect.bottom);
    } else {
      offset.left = offset.top = offset.right = offset.bottom = 0;
    }

    return offset;
  },

  set: function set(_ref2) {
    var modifiedCoords = _ref2.modifiedCoords,
        interaction = _ref2.interaction,
        status = _ref2.status,
        options = _ref2.options;

    if (!options) {
      return status;
    }

    var page = status.useStatusXY ? { x: status.x, y: status.y } : utils.extend({}, modifiedCoords);

    var restriction = getRestrictionRect(options.restriction, interaction, page);

    if (!restriction) {
      return status;
    }

    status.dx = 0;
    status.dy = 0;
    status.locked = false;

    var rect = restriction;
    var modifiedX = page.x;
    var modifiedY = page.y;

    var offset = interaction.modifierOffsets.restrict;

    // object is assumed to have
    // x, y, width, height or
    // left, top, right, bottom
    if ('x' in restriction && 'y' in restriction) {
      modifiedX = Math.max(Math.min(rect.x + rect.width - offset.right, page.x), rect.x + offset.left);
      modifiedY = Math.max(Math.min(rect.y + rect.height - offset.bottom, page.y), rect.y + offset.top);
    } else {
      modifiedX = Math.max(Math.min(rect.right - offset.right, page.x), rect.left + offset.left);
      modifiedY = Math.max(Math.min(rect.bottom - offset.bottom, page.y), rect.top + offset.top);
    }

    status.dx = modifiedX - page.x;
    status.dy = modifiedY - page.y;

    status.changed = status.modifiedX !== modifiedX || status.modifiedY !== modifiedY;
    status.locked = !!(status.dx || status.dy);

    status.modifiedX = modifiedX;
    status.modifiedY = modifiedY;
  },

  modifyCoords: function modifyCoords(_ref3) {
    var page = _ref3.page,
        client = _ref3.client,
        status = _ref3.status,
        phase = _ref3.phase,
        options = _ref3.options;

    var elementRect = options && options.elementRect;

    if (options && options.enabled && !(phase === 'start' && elementRect && status.locked)) {

      if (status.locked) {
        page.x += status.dx;
        page.y += status.dy;
        client.x += status.dx;
        client.y += status.dy;

        return {
          dx: status.dx,
          dy: status.dy
        };
      }
    }
  },

  getRestrictionRect: getRestrictionRect
};

function getRestrictionRect(value, interaction, page) {
  if (utils.is.function(value)) {
    return utils.resolveRectLike(value, interaction.target, interaction.element, [page.x, page.y, interaction]);
  } else {
    return utils.resolveRectLike(value, interaction.target, interaction.element);
  }
}

modifiers.restrict = restrict;
modifiers.names.push('restrict');

defaultOptions.perAction.restrict = restrict.defaults;

module.exports = restrict;

},{"../defaultOptions":18,"../utils":44,"./base":23}],25:[function(require,module,exports){
'use strict';

// This module adds the options.resize.restrictEdges setting which sets min and
// max for the top, left, bottom and right edges of the target being resized.
//
// interact(target).resize({
//   edges: { top: true, left: true },
//   restrictEdges: {
//     inner: { top: 200, left: 200, right: 400, bottom: 400 },
//     outer: { top:   0, left:   0, right: 600, bottom: 600 },
//   },
// });

var modifiers = require('./base');
var utils = require('../utils');
var rectUtils = require('../utils/rect');
var defaultOptions = require('../defaultOptions');
var resize = require('../actions/resize');

var _require = require('./restrict'),
    getRestrictionRect = _require.getRestrictionRect;

var noInner = { top: +Infinity, left: +Infinity, bottom: -Infinity, right: -Infinity };
var noOuter = { top: -Infinity, left: -Infinity, bottom: +Infinity, right: +Infinity };

var restrictEdges = {
  defaults: {
    enabled: false,
    endOnly: false,
    min: null,
    max: null,
    offset: null
  },

  setOffset: function setOffset(_ref) {
    var interaction = _ref.interaction,
        startOffset = _ref.startOffset,
        options = _ref.options;

    if (!options) {
      return utils.extend({}, startOffset);
    }

    var offset = getRestrictionRect(options.offset, interaction, interaction.startCoords.page);

    if (offset) {
      return {
        top: startOffset.top + offset.y,
        left: startOffset.left + offset.x,
        bottom: startOffset.bottom + offset.y,
        right: startOffset.right + offset.x
      };
    }

    return startOffset;
  },

  set: function set(_ref2) {
    var modifiedCoords = _ref2.modifiedCoords,
        interaction = _ref2.interaction,
        status = _ref2.status,
        offset = _ref2.offset,
        options = _ref2.options;

    var edges = interaction.prepared.linkedEdges || interaction.prepared.edges;

    if (!interaction.interacting() || !edges) {
      return;
    }

    var page = status.useStatusXY ? { x: status.x, y: status.y } : utils.extend({}, modifiedCoords);
    var inner = rectUtils.xywhToTlbr(getRestrictionRect(options.inner, interaction, page)) || noInner;
    var outer = rectUtils.xywhToTlbr(getRestrictionRect(options.outer, interaction, page)) || noOuter;

    var modifiedX = page.x;
    var modifiedY = page.y;

    status.dx = 0;
    status.dy = 0;
    status.locked = false;

    if (edges.top) {
      modifiedY = Math.min(Math.max(outer.top + offset.top, page.y), inner.top + offset.top);
    } else if (edges.bottom) {
      modifiedY = Math.max(Math.min(outer.bottom - offset.bottom, page.y), inner.bottom - offset.bottom);
    }
    if (edges.left) {
      modifiedX = Math.min(Math.max(outer.left + offset.left, page.x), inner.left + offset.left);
    } else if (edges.right) {
      modifiedX = Math.max(Math.min(outer.right - offset.right, page.x), inner.right - offset.right);
    }

    status.dx = modifiedX - page.x;
    status.dy = modifiedY - page.y;

    status.changed = status.modifiedX !== modifiedX || status.modifiedY !== modifiedY;
    status.locked = !!(status.dx || status.dy);

    status.modifiedX = modifiedX;
    status.modifiedY = modifiedY;
  },

  modifyCoords: function modifyCoords(_ref3) {
    var page = _ref3.page,
        client = _ref3.client,
        status = _ref3.status,
        phase = _ref3.phase,
        options = _ref3.options;

    if (options && options.enabled && !(phase === 'start' && status.locked)) {

      if (status.locked) {
        page.x += status.dx;
        page.y += status.dy;
        client.x += status.dx;
        client.y += status.dy;

        return {
          dx: status.dx,
          dy: status.dy
        };
      }
    }
  },

  noInner: noInner,
  noOuter: noOuter,
  getRestrictionRect: getRestrictionRect
};

modifiers.restrictEdges = restrictEdges;
modifiers.names.push('restrictEdges');

defaultOptions.perAction.restrictEdges = restrictEdges.defaults;
resize.defaults.restrictEdges = restrictEdges.defaults;

module.exports = restrictEdges;

},{"../actions/resize":10,"../defaultOptions":18,"../utils":44,"../utils/rect":51,"./base":23,"./restrict":24}],26:[function(require,module,exports){
'use strict';

// This module adds the options.resize.restrictSize setting which sets min and
// max width and height for the target being resized.
//
// interact(target).resize({
//   edges: { top: true, left: true },
//   restrictSize: {
//     min: { width: -600, height: -600 },
//     max: { width:  600, height:  600 },
//   },
// });

var modifiers = require('./base');
var restrictEdges = require('./restrictEdges');
var utils = require('../utils');
var rectUtils = require('../utils/rect');
var defaultOptions = require('../defaultOptions');
var resize = require('../actions/resize');

var noMin = { width: -Infinity, height: -Infinity };
var noMax = { width: +Infinity, height: +Infinity };

var restrictSize = {
  defaults: {
    enabled: false,
    endOnly: false,
    min: null,
    max: null
  },

  setOffset: function setOffset(_ref) {
    var interaction = _ref.interaction;

    return interaction.startOffset;
  },

  set: function set(arg) {
    var interaction = arg.interaction,
        options = arg.options;

    var edges = interaction.prepared.linkedEdges || interaction.prepared.edges;

    if (!interaction.interacting() || !edges) {
      return;
    }

    var rect = rectUtils.xywhToTlbr(interaction.resizeRects.inverted);

    var minSize = rectUtils.tlbrToXywh(restrictEdges.getRestrictionRect(options.min, interaction)) || noMin;
    var maxSize = rectUtils.tlbrToXywh(restrictEdges.getRestrictionRect(options.max, interaction)) || noMax;

    arg.options = {
      enabled: options.enabled,
      endOnly: options.endOnly,
      inner: utils.extend({}, restrictEdges.noInner),
      outer: utils.extend({}, restrictEdges.noOuter)
    };

    if (edges.top) {
      arg.options.inner.top = rect.bottom - minSize.height;
      arg.options.outer.top = rect.bottom - maxSize.height;
    } else if (edges.bottom) {
      arg.options.inner.bottom = rect.top + minSize.height;
      arg.options.outer.bottom = rect.top + maxSize.height;
    }
    if (edges.left) {
      arg.options.inner.left = rect.right - minSize.width;
      arg.options.outer.left = rect.right - maxSize.width;
    } else if (edges.right) {
      arg.options.inner.right = rect.left + minSize.width;
      arg.options.outer.right = rect.left + maxSize.width;
    }

    restrictEdges.set(arg);
  },

  modifyCoords: restrictEdges.modifyCoords
};

modifiers.restrictSize = restrictSize;
modifiers.names.push('restrictSize');

defaultOptions.perAction.restrictSize = restrictSize.defaults;
resize.defaults.restrictSize = restrictSize.defaults;

module.exports = restrictSize;

},{"../actions/resize":10,"../defaultOptions":18,"../utils":44,"../utils/rect":51,"./base":23,"./restrictEdges":25}],27:[function(require,module,exports){
'use strict';

var modifiers = require('./base');
var interact = require('../interact');
var utils = require('../utils');
var defaultOptions = require('../defaultOptions');

var snap = {
  defaults: {
    enabled: false,
    endOnly: false,
    range: Infinity,
    targets: null,
    offsets: null,

    relativePoints: null
  },

  setOffset: function setOffset(_ref) {
    var interaction = _ref.interaction,
        interactable = _ref.interactable,
        element = _ref.element,
        rect = _ref.rect,
        startOffset = _ref.startOffset,
        options = _ref.options;

    var offsets = [];
    var optionsOrigin = utils.rectToXY(utils.resolveRectLike(options.origin));
    var origin = optionsOrigin || utils.getOriginXY(interactable, element, interaction.prepared.name);
    options = options || interactable.options[interaction.prepared.name].snap || {};

    var snapOffset = void 0;

    if (options.offset === 'startCoords') {
      snapOffset = {
        x: interaction.startCoords.page.x - origin.x,
        y: interaction.startCoords.page.y - origin.y
      };
    } else {
      var offsetRect = utils.resolveRectLike(options.offset, interactable, element, [interaction]);

      snapOffset = utils.rectToXY(offsetRect) || { x: 0, y: 0 };
    }

    if (rect && options.relativePoints && options.relativePoints.length) {
      for (var _i = 0; _i < options.relativePoints.length; _i++) {
        var _ref3;

        _ref3 = options.relativePoints[_i];
        var _ref2 = _ref3;
        var relativeX = _ref2.x;
        var relativeY = _ref2.y;

        offsets.push({
          x: startOffset.left - rect.width * relativeX + snapOffset.x,
          y: startOffset.top - rect.height * relativeY + snapOffset.y
        });
      }
    } else {
      offsets.push(snapOffset);
    }

    return offsets;
  },

  set: function set(_ref4) {
    var interaction = _ref4.interaction,
        modifiedCoords = _ref4.modifiedCoords,
        status = _ref4.status,
        options = _ref4.options,
        offsets = _ref4.offset;

    var targets = [];
    var target = void 0;
    var page = void 0;
    var i = void 0;

    if (status.useStatusXY) {
      page = { x: status.x, y: status.y };
    } else {
      var origin = utils.getOriginXY(interaction.target, interaction.element, interaction.prepared.name);

      page = utils.extend({}, modifiedCoords);

      page.x -= origin.x;
      page.y -= origin.y;
    }

    status.realX = page.x;
    status.realY = page.y;

    var len = options.targets ? options.targets.length : 0;

    for (var _i2 = 0; _i2 < offsets.length; _i2++) {
      var _ref6;

      _ref6 = offsets[_i2];
      var _ref5 = _ref6;
      var offsetX = _ref5.x;
      var offsetY = _ref5.y;

      var relativeX = page.x - offsetX;
      var relativeY = page.y - offsetY;

      for (var _i3 = 0; _i3 < (options.targets || []).length; _i3++) {
        var _ref7;

        _ref7 = (options.targets || [])[_i3];
        var snapTarget = _ref7;

        if (utils.is.function(snapTarget)) {
          target = snapTarget(relativeX, relativeY, interaction);
        } else {
          target = snapTarget;
        }

        if (!target) {
          continue;
        }

        targets.push({
          x: utils.is.number(target.x) ? target.x + offsetX : relativeX,
          y: utils.is.number(target.y) ? target.y + offsetY : relativeY,

          range: utils.is.number(target.range) ? target.range : options.range
        });
      }
    }

    var closest = {
      target: null,
      inRange: false,
      distance: 0,
      range: 0,
      dx: 0,
      dy: 0
    };

    for (i = 0, len = targets.length; i < len; i++) {
      target = targets[i];

      var range = target.range;
      var dx = target.x - page.x;
      var dy = target.y - page.y;
      var distance = utils.hypot(dx, dy);
      var inRange = distance <= range;

      // Infinite targets count as being out of range
      // compared to non infinite ones that are in range
      if (range === Infinity && closest.inRange && closest.range !== Infinity) {
        inRange = false;
      }

      if (!closest.target || (inRange
      // is the closest target in range?
      ? closest.inRange && range !== Infinity
      // the pointer is relatively deeper in this target
      ? distance / range < closest.distance / closest.range
      // this target has Infinite range and the closest doesn't
      : range === Infinity && closest.range !== Infinity ||
      // OR this target is closer that the previous closest
      distance < closest.distance :
      // The other is not in range and the pointer is closer to this target
      !closest.inRange && distance < closest.distance)) {

        closest.target = target;
        closest.distance = distance;
        closest.range = range;
        closest.inRange = inRange;
        closest.dx = dx;
        closest.dy = dy;

        status.range = range;
      }
    }

    var snapChanged = void 0;

    if (closest.target) {
      snapChanged = status.modifiedX !== closest.target.x || status.modifiedY !== closest.target.y;

      status.modifiedX = closest.target.x;
      status.modifiedY = closest.target.y;
    } else {
      snapChanged = true;

      status.modifiedX = NaN;
      status.modifiedY = NaN;
    }

    status.dx = closest.dx;
    status.dy = closest.dy;

    status.changed = snapChanged || closest.inRange && !status.locked;
    status.locked = closest.inRange;
  },

  modifyCoords: function modifyCoords(_ref8) {
    var page = _ref8.page,
        client = _ref8.client,
        status = _ref8.status,
        phase = _ref8.phase,
        options = _ref8.options;

    var relativePoints = options && options.relativePoints;

    if (options && options.enabled && !(phase === 'start' && relativePoints && relativePoints.length)) {

      if (status.locked) {
        page.x += status.dx;
        page.y += status.dy;
        client.x += status.dx;
        client.y += status.dy;
      }

      return {
        range: status.range,
        locked: status.locked,
        x: status.modifiedX,
        y: status.modifiedY,
        realX: status.realX,
        realY: status.realY,
        dx: status.dx,
        dy: status.dy
      };
    }
  }
};

interact.createSnapGrid = function (grid) {
  return function (x, y) {
    var limits = grid.limits || {
      left: -Infinity,
      right: Infinity,
      top: -Infinity,
      bottom: Infinity
    };
    var offsetX = 0;
    var offsetY = 0;

    if (utils.is.object(grid.offset)) {
      offsetX = grid.offset.x;
      offsetY = grid.offset.y;
    }

    var gridx = Math.round((x - offsetX) / grid.x);
    var gridy = Math.round((y - offsetY) / grid.y);

    var newX = Math.max(limits.left, Math.min(limits.right, gridx * grid.x + offsetX));
    var newY = Math.max(limits.top, Math.min(limits.bottom, gridy * grid.y + offsetY));

    return {
      x: newX,
      y: newY,
      range: grid.range
    };
  };
};

modifiers.snap = snap;
modifiers.names.push('snap');

defaultOptions.perAction.snap = snap.defaults;

module.exports = snap;

},{"../defaultOptions":18,"../interact":21,"../utils":44,"./base":23}],28:[function(require,module,exports){
'use strict';

// This module allows snapping of the size of targets during resize
// interactions.

var modifiers = require('./base');
var snap = require('./snap');
var defaultOptions = require('../defaultOptions');
var resize = require('../actions/resize');
var utils = require('../utils/');

var snapSize = {
  defaults: {
    enabled: false,
    endOnly: false,
    range: Infinity,
    targets: null,
    offsets: null
  },

  setOffset: function setOffset(arg) {
    var interaction = arg.interaction,
        options = arg.options;

    var edges = interaction.prepared.edges;

    if (!edges) {
      return;
    }

    arg.options = {
      relativePoints: [{
        x: edges.left ? 0 : 1,
        y: edges.top ? 0 : 1
      }],
      origin: { x: 0, y: 0 },
      offset: 'self',
      range: options.range
    };

    var offsets = snap.setOffset(arg);
    arg.options = options;

    return offsets;
  },

  set: function set(arg) {
    var interaction = arg.interaction,
        options = arg.options,
        offset = arg.offset,
        modifiedCoords = arg.modifiedCoords;

    var page = utils.extend({}, modifiedCoords);
    var relativeX = page.x - offset[0].x;
    var relativeY = page.y - offset[0].y;

    arg.options = utils.extend({}, options);
    arg.options.targets = [];

    for (var _i = 0; _i < (options.targets || []).length; _i++) {
      var _ref;

      _ref = (options.targets || [])[_i];
      var snapTarget = _ref;

      var target = void 0;

      if (utils.is.function(snapTarget)) {
        target = snapTarget(relativeX, relativeY, interaction);
      } else {
        target = snapTarget;
      }

      if (!target) {
        continue;
      }

      if ('width' in target && 'height' in target) {
        target.x = target.width;
        target.y = target.height;
      }

      arg.options.targets.push(target);
    }

    snap.set(arg);
  },

  modifyCoords: function modifyCoords(arg) {
    var options = arg.options;


    arg.options = utils.extend({}, options);
    arg.options.enabled = options.enabled;
    arg.options.relativePoints = [null];

    snap.modifyCoords(arg);
  }
};

modifiers.snapSize = snapSize;
modifiers.names.push('snapSize');

defaultOptions.perAction.snapSize = snapSize.defaults;
resize.defaults.snapSize = snapSize.defaults;

module.exports = snapSize;

},{"../actions/resize":10,"../defaultOptions":18,"../utils/":44,"./base":23,"./snap":27}],29:[function(require,module,exports){
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pointerUtils = require('../utils/pointerUtils');

module.exports = function () {
  /** */
  function PointerEvent(type, pointer, event, eventTarget, interaction) {
    _classCallCheck(this, PointerEvent);

    pointerUtils.pointerExtend(this, event);

    if (event !== pointer) {
      pointerUtils.pointerExtend(this, pointer);
    }

    this.interaction = interaction;

    this.timeStamp = new Date().getTime();
    this.originalEvent = event;
    this.type = type;
    this.pointerId = pointerUtils.getPointerId(pointer);
    this.pointerType = pointerUtils.getPointerType(pointer);
    this.target = eventTarget;
    this.currentTarget = null;

    if (type === 'tap') {
      var pointerIndex = interaction.getPointerIndex(pointer);
      this.dt = this.timeStamp - interaction.downTimes[pointerIndex];

      var interval = this.timeStamp - interaction.tapTime;

      this.double = !!(interaction.prevTap && interaction.prevTap.type !== 'doubletap' && interaction.prevTap.target === this.target && interval < 500);
    } else if (type === 'doubletap') {
      this.dt = pointer.timeStamp - interaction.tapTime;
    }
  }

  PointerEvent.prototype.subtractOrigin = function subtractOrigin(_ref) {
    var originX = _ref.x,
        originY = _ref.y;

    this.pageX -= originX;
    this.pageY -= originY;
    this.clientX -= originX;
    this.clientY -= originY;

    return this;
  };

  PointerEvent.prototype.addOrigin = function addOrigin(_ref2) {
    var originX = _ref2.x,
        originY = _ref2.y;

    this.pageX += originX;
    this.pageY += originY;
    this.clientX += originX;
    this.clientY += originY;

    return this;
  };

  /** */


  PointerEvent.prototype.preventDefault = function preventDefault() {
    this.originalEvent.preventDefault();
  };

  /** */


  PointerEvent.prototype.stopPropagation = function stopPropagation() {
    this.propagationStopped = true;
  };

  /** */


  PointerEvent.prototype.stopImmediatePropagation = function stopImmediatePropagation() {
    this.immediatePropagationStopped = this.propagationStopped = true;
  };

  return PointerEvent;
}();

},{"../utils/pointerUtils":49}],30:[function(require,module,exports){
'use strict';

var PointerEvent = require('./PointerEvent');
var Interaction = require('../Interaction');
var utils = require('../utils');
var defaults = require('../defaultOptions');
var signals = require('../utils/Signals').new();

var simpleSignals = ['down', 'up', 'cancel'];
var simpleEvents = ['down', 'up', 'cancel'];

var pointerEvents = {
  PointerEvent: PointerEvent,
  fire: fire,
  collectEventTargets: collectEventTargets,
  signals: signals,
  defaults: {
    holdDuration: 600,
    ignoreFrom: null,
    allowFrom: null,
    origin: { x: 0, y: 0 }
  },
  types: ['down', 'move', 'up', 'cancel', 'tap', 'doubletap', 'hold']
};

function fire(arg) {
  var interaction = arg.interaction,
      pointer = arg.pointer,
      event = arg.event,
      eventTarget = arg.eventTarget,
      _arg$type = arg.type,
      type = _arg$type === undefined ? arg.pointerEvent.type : _arg$type,
      _arg$targets = arg.targets,
      targets = _arg$targets === undefined ? collectEventTargets(arg) : _arg$targets,
      _arg$pointerEvent = arg.pointerEvent,
      pointerEvent = _arg$pointerEvent === undefined ? new PointerEvent(type, pointer, event, eventTarget, interaction) : _arg$pointerEvent;


  var signalArg = {
    interaction: interaction,
    pointer: pointer,
    event: event,
    eventTarget: eventTarget,
    targets: targets,
    type: type,
    pointerEvent: pointerEvent
  };

  for (var i = 0; i < targets.length; i++) {
    var target = targets[i];

    for (var prop in target.props || {}) {
      pointerEvent[prop] = target.props[prop];
    }

    var origin = utils.getOriginXY(target.eventable, target.element);

    pointerEvent.subtractOrigin(origin);
    pointerEvent.eventable = target.eventable;
    pointerEvent.currentTarget = target.element;

    target.eventable.fire(pointerEvent);

    pointerEvent.addOrigin(origin);

    if (pointerEvent.immediatePropagationStopped || pointerEvent.propagationStopped && i + 1 < targets.length && targets[i + 1].element !== pointerEvent.currentTarget) {
      break;
    }
  }

  signals.fire('fired', signalArg);

  if (type === 'tap') {
    // if pointerEvent should make a double tap, create and fire a doubletap
    // PointerEvent and use that as the prevTap
    var prevTap = pointerEvent.double ? fire({
      interaction: interaction, pointer: pointer, event: event, eventTarget: eventTarget,
      type: 'doubletap'
    }) : pointerEvent;

    interaction.prevTap = prevTap;
    interaction.tapTime = prevTap.timeStamp;
  }

  return pointerEvent;
}

function collectEventTargets(_ref) {
  var interaction = _ref.interaction,
      pointer = _ref.pointer,
      event = _ref.event,
      eventTarget = _ref.eventTarget,
      type = _ref.type;

  var pointerIndex = interaction.getPointerIndex(pointer);

  // do not fire a tap event if the pointer was moved before being lifted
  if (type === 'tap' && (interaction.pointerWasMoved
  // or if the pointerup target is different to the pointerdown target
  || !(interaction.downTargets[pointerIndex] && interaction.downTargets[pointerIndex] === eventTarget))) {
    return [];
  }

  var path = utils.getPath(eventTarget);
  var signalArg = {
    interaction: interaction,
    pointer: pointer,
    event: event,
    eventTarget: eventTarget,
    type: type,
    path: path,
    targets: [],
    element: null
  };

  for (var _i = 0; _i < path.length; _i++) {
    var _ref2;

    _ref2 = path[_i];
    var element = _ref2;

    signalArg.element = element;

    signals.fire('collect-targets', signalArg);
  }

  if (type === 'hold') {
    signalArg.targets = signalArg.targets.filter(function (target) {
      return target.eventable.options.holdDuration === interaction.holdTimers[pointerIndex].duration;
    });
  }

  return signalArg.targets;
}

Interaction.signals.on('update-pointer-down', function (_ref3) {
  var interaction = _ref3.interaction,
      pointerIndex = _ref3.pointerIndex;

  interaction.holdTimers[pointerIndex] = { duration: Infinity, timeout: null };
});

Interaction.signals.on('remove-pointer', function (_ref4) {
  var interaction = _ref4.interaction,
      pointerIndex = _ref4.pointerIndex;

  interaction.holdTimers.splice(pointerIndex, 1);
});

Interaction.signals.on('move', function (_ref5) {
  var interaction = _ref5.interaction,
      pointer = _ref5.pointer,
      event = _ref5.event,
      eventTarget = _ref5.eventTarget,
      duplicateMove = _ref5.duplicateMove;

  var pointerIndex = interaction.getPointerIndex(pointer);

  if (!duplicateMove && (!interaction.pointerIsDown || interaction.pointerWasMoved)) {
    if (interaction.pointerIsDown) {
      clearTimeout(interaction.holdTimers[pointerIndex].timeout);
    }

    fire({
      interaction: interaction, pointer: pointer, event: event, eventTarget: eventTarget,
      type: 'move'
    });
  }
});

Interaction.signals.on('down', function (_ref6) {
  var interaction = _ref6.interaction,
      pointer = _ref6.pointer,
      event = _ref6.event,
      eventTarget = _ref6.eventTarget,
      pointerIndex = _ref6.pointerIndex;

  var timer = interaction.holdTimers[pointerIndex];
  var path = utils.getPath(eventTarget);
  var signalArg = {
    interaction: interaction,
    pointer: pointer,
    event: event,
    eventTarget: eventTarget,
    type: 'hold',
    targets: [],
    path: path,
    element: null
  };

  for (var _i2 = 0; _i2 < path.length; _i2++) {
    var _ref7;

    _ref7 = path[_i2];
    var element = _ref7;

    signalArg.element = element;

    signals.fire('collect-targets', signalArg);
  }

  if (!signalArg.targets.length) {
    return;
  }

  var minDuration = Infinity;

  for (var _i3 = 0; _i3 < signalArg.targets.length; _i3++) {
    var _ref8;

    _ref8 = signalArg.targets[_i3];
    var target = _ref8;

    var holdDuration = target.eventable.options.holdDuration;

    if (holdDuration < minDuration) {
      minDuration = holdDuration;
    }
  }

  timer.duration = minDuration;
  timer.timeout = setTimeout(function () {
    fire({
      interaction: interaction,
      eventTarget: eventTarget,
      pointer: pointer,
      event: event,
      type: 'hold'
    });
  }, minDuration);
});

Interaction.signals.on('up', function (_ref9) {
  var interaction = _ref9.interaction,
      pointer = _ref9.pointer,
      event = _ref9.event,
      eventTarget = _ref9.eventTarget;

  if (!interaction.pointerWasMoved) {
    fire({ interaction: interaction, eventTarget: eventTarget, pointer: pointer, event: event, type: 'tap' });
  }
});

var _arr = ['up', 'cancel'];
for (var _i4 = 0; _i4 < _arr.length; _i4++) {
  var signalName = _arr[_i4];
  Interaction.signals.on(signalName, function (_ref11) {
    var interaction = _ref11.interaction,
        pointerIndex = _ref11.pointerIndex;

    if (interaction.holdTimers[pointerIndex]) {
      clearTimeout(interaction.holdTimers[pointerIndex].timeout);
    }
  });
}

function createSignalListener(type) {
  return function (_ref10) {
    var interaction = _ref10.interaction,
        pointer = _ref10.pointer,
        event = _ref10.event,
        eventTarget = _ref10.eventTarget;

    fire({ interaction: interaction, eventTarget: eventTarget, pointer: pointer, event: event, type: type });
  };
}

for (var i = 0; i < simpleSignals.length; i++) {
  Interaction.signals.on(simpleSignals[i], createSignalListener(simpleEvents[i]));
}

Interaction.signals.on('new', function (interaction) {
  interaction.prevTap = null; // the most recent tap event on this interaction
  interaction.tapTime = 0; // time of the most recent tap event
  interaction.holdTimers = []; // [{ duration, timeout }]
});

defaults.pointerEvents = pointerEvents.defaults;
module.exports = pointerEvents;

},{"../Interaction":5,"../defaultOptions":18,"../utils":44,"../utils/Signals":34,"./PointerEvent":29}],31:[function(require,module,exports){
'use strict';

var pointerEvents = require('./base');
var Interaction = require('../Interaction');

pointerEvents.signals.on('new', onNew);
pointerEvents.signals.on('fired', onFired);

var _arr = ['move', 'up', 'cancel', 'endall'];
for (var _i = 0; _i < _arr.length; _i++) {
  var signal = _arr[_i];
  Interaction.signals.on(signal, endHoldRepeat);
}

function onNew(_ref) {
  var pointerEvent = _ref.pointerEvent;

  if (pointerEvent.type !== 'hold') {
    return;
  }

  pointerEvent.count = (pointerEvent.count || 0) + 1;
}

function onFired(_ref2) {
  var interaction = _ref2.interaction,
      pointerEvent = _ref2.pointerEvent,
      eventTarget = _ref2.eventTarget,
      targets = _ref2.targets;

  if (pointerEvent.type !== 'hold' || !targets.length) {
    return;
  }

  // get the repeat interval from the first eventable
  var interval = targets[0].eventable.options.holdRepeatInterval;

  // don't repeat if the interval is 0 or less
  if (interval <= 0) {
    return;
  }

  // set a timeout to fire the holdrepeat event
  interaction.holdIntervalHandle = setTimeout(function () {
    pointerEvents.fire({
      interaction: interaction,
      eventTarget: eventTarget,
      type: 'hold',
      pointer: pointerEvent,
      event: pointerEvent
    });
  }, interval);
}

function endHoldRepeat(_ref3) {
  var interaction = _ref3.interaction;

  // set the interaction's holdStopTime property
  // to stop further holdRepeat events
  if (interaction.holdIntervalHandle) {
    clearInterval(interaction.holdIntervalHandle);
    interaction.holdIntervalHandle = null;
  }
}

// don't repeat by default
pointerEvents.defaults.holdRepeatInterval = 0;
pointerEvents.types.push('holdrepeat');

module.exports = {
  onNew: onNew,
  onFired: onFired,
  endHoldRepeat: endHoldRepeat
};

},{"../Interaction":5,"./base":30}],32:[function(require,module,exports){
'use strict';

var pointerEvents = require('./base');
var Interactable = require('../Interactable');
var is = require('../utils/is');
var scope = require('../scope');
var extend = require('../utils/extend');

var _require = require('../utils/arr'),
    merge = _require.merge;

pointerEvents.signals.on('collect-targets', function (_ref) {
  var targets = _ref.targets,
      element = _ref.element,
      type = _ref.type,
      eventTarget = _ref.eventTarget;

  scope.interactables.forEachMatch(element, function (interactable) {
    var eventable = interactable.events;
    var options = eventable.options;

    if (eventable[type] && is.element(element) && interactable.testIgnoreAllow(options, element, eventTarget)) {

      targets.push({
        element: element,
        eventable: eventable,
        props: { interactable: interactable }
      });
    }
  });
});

Interactable.signals.on('new', function (_ref2) {
  var interactable = _ref2.interactable;

  interactable.events.getRect = function (element) {
    return interactable.getRect(element);
  };
});

Interactable.signals.on('set', function (_ref3) {
  var interactable = _ref3.interactable,
      options = _ref3.options;

  extend(interactable.events.options, pointerEvents.defaults);
  extend(interactable.events.options, options);
});

merge(Interactable.eventTypes, pointerEvents.types);

Interactable.prototype.pointerEvents = function (options) {
  extend(this.events.options, options);

  return this;
};

var __backCompatOption = Interactable.prototype._backCompatOption;

Interactable.prototype._backCompatOption = function (optionName, newValue) {
  var ret = __backCompatOption.call(this, optionName, newValue);

  if (ret === this) {
    this.events.options[optionName] = newValue;
  }

  return ret;
};

Interactable.settingsMethods.push('pointerEvents');

},{"../Interactable":4,"../scope":33,"../utils/arr":35,"../utils/extend":41,"../utils/is":46,"./base":30}],33:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var events = require('./utils/events');
var signals = require('./utils/Signals').new();

var _require = require('./utils/window'),
    getWindow = _require.getWindow;

var scope = {
  signals: signals,
  events: events,
  utils: utils,

  // main document
  document: require('./utils/domObjects').document,
  // all documents being listened to
  documents: [],

  addDocument: function addDocument(doc, win) {
    // do nothing if document is already known
    if (utils.contains(scope.documents, doc)) {
      return false;
    }

    win = win || getWindow(doc);

    scope.documents.push(doc);
    events.documents.push(doc);

    // don't add an unload event for the main document
    // so that the page may be cached in browser history
    if (doc !== scope.document) {
      events.add(win, 'unload', scope.onWindowUnload);
    }

    signals.fire('add-document', { doc: doc, win: win });
  },

  removeDocument: function removeDocument(doc, win) {
    var index = scope.documents.indexOf(doc);

    win = win || getWindow(doc);

    events.remove(win, 'unload', scope.onWindowUnload);

    scope.documents.splice(index, 1);
    events.documents.splice(index, 1);

    signals.fire('remove-document', { win: win, doc: doc });
  },

  onWindowUnload: function onWindowUnload() {
    scope.removeDocument(this.document, this);
  }
};

module.exports = scope;

},{"./utils":44,"./utils/Signals":34,"./utils/domObjects":38,"./utils/events":40,"./utils/window":52}],34:[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Signals = function () {
  function Signals() {
    _classCallCheck(this, Signals);

    this.listeners = {
      // signalName: [listeners],
    };
  }

  Signals.prototype.on = function on(name, listener) {
    if (!this.listeners[name]) {
      this.listeners[name] = [listener];
      return;
    }

    this.listeners[name].push(listener);
  };

  Signals.prototype.off = function off(name, listener) {
    if (!this.listeners[name]) {
      return;
    }

    var index = this.listeners[name].indexOf(listener);

    if (index !== -1) {
      this.listeners[name].splice(index, 1);
    }
  };

  Signals.prototype.fire = function fire(name, arg) {
    var targetListeners = this.listeners[name];

    if (!targetListeners) {
      return;
    }

    for (var _i = 0; _i < targetListeners.length; _i++) {
      var _ref;

      _ref = targetListeners[_i];
      var listener = _ref;

      if (listener(arg, name) === false) {
        return;
      }
    }
  };

  return Signals;
}();

Signals.new = function () {
  return new Signals();
};

module.exports = Signals;

},{}],35:[function(require,module,exports){
"use strict";

function contains(array, target) {
  return array.indexOf(target) !== -1;
}

function merge(target, source) {
  for (var _i = 0; _i < source.length; _i++) {
    var _ref;

    _ref = source[_i];
    var item = _ref;

    target.push(item);
  }

  return target;
}

module.exports = {
  contains: contains,
  merge: merge
};

},{}],36:[function(require,module,exports){
'use strict';

var _require = require('./window'),
    window = _require.window;

var is = require('./is');
var domObjects = require('./domObjects');

var Element = domObjects.Element;
var navigator = window.navigator;

var browser = {
  // Does the browser support touch input?
  supportsTouch: !!('ontouchstart' in window || is.function(window.DocumentTouch) && domObjects.document instanceof window.DocumentTouch),

  // Does the browser support PointerEvents
  supportsPointerEvent: !!domObjects.PointerEvent,

  isIOS: /iP(hone|od|ad)/.test(navigator.platform),

  // scrolling doesn't change the result of getClientRects on iOS 7
  isIOS7: /iP(hone|od|ad)/.test(navigator.platform) && /OS 7[^\d]/.test(navigator.appVersion),

  isIe9: /MSIE 9/.test(navigator.userAgent),

  // prefix matchesSelector
  prefixedMatchesSelector: 'matches' in Element.prototype ? 'matches' : 'webkitMatchesSelector' in Element.prototype ? 'webkitMatchesSelector' : 'mozMatchesSelector' in Element.prototype ? 'mozMatchesSelector' : 'oMatchesSelector' in Element.prototype ? 'oMatchesSelector' : 'msMatchesSelector',

  pEventTypes: domObjects.PointerEvent ? domObjects.PointerEvent === window.MSPointerEvent ? {
    up: 'MSPointerUp',
    down: 'MSPointerDown',
    over: 'mouseover',
    out: 'mouseout',
    move: 'MSPointerMove',
    cancel: 'MSPointerCancel'
  } : {
    up: 'pointerup',
    down: 'pointerdown',
    over: 'pointerover',
    out: 'pointerout',
    move: 'pointermove',
    cancel: 'pointercancel'
  } : null,

  // because Webkit and Opera still use 'mousewheel' event type
  wheelEvent: 'onmousewheel' in domObjects.document ? 'mousewheel' : 'wheel'

};

// Opera Mobile must be handled differently
browser.isOperaMobile = navigator.appName === 'Opera' && browser.supportsTouch && navigator.userAgent.match('Presto');

module.exports = browser;

},{"./domObjects":38,"./is":46,"./window":52}],37:[function(require,module,exports){
'use strict';

var is = require('./is');

module.exports = function clone(source) {
  var dest = {};
  for (var prop in source) {
    if (is.plainObject(source[prop])) {
      dest[prop] = clone(source[prop]);
    } else {
      dest[prop] = source[prop];
    }
  }
  return dest;
};

},{"./is":46}],38:[function(require,module,exports){
'use strict';

var domObjects = {};
var win = require('./window').window;

function blank() {}

domObjects.document = win.document;
domObjects.DocumentFragment = win.DocumentFragment || blank;
domObjects.SVGElement = win.SVGElement || blank;
domObjects.SVGSVGElement = win.SVGSVGElement || blank;
domObjects.SVGElementInstance = win.SVGElementInstance || blank;
domObjects.Element = win.Element || blank;
domObjects.HTMLElement = win.HTMLElement || domObjects.Element;

domObjects.Event = win.Event;
domObjects.Touch = win.Touch || blank;
domObjects.PointerEvent = win.PointerEvent || win.MSPointerEvent;

module.exports = domObjects;

},{"./window":52}],39:[function(require,module,exports){
'use strict';

var win = require('./window');
var browser = require('./browser');
var is = require('./is');
var domObjects = require('./domObjects');

var domUtils = {
  nodeContains: function nodeContains(parent, child) {
    while (child) {
      if (child === parent) {
        return true;
      }

      child = child.parentNode;
    }

    return false;
  },

  closest: function closest(element, selector) {
    while (is.element(element)) {
      if (domUtils.matchesSelector(element, selector)) {
        return element;
      }

      element = domUtils.parentNode(element);
    }

    return null;
  },

  parentNode: function parentNode(node) {
    var parent = node.parentNode;

    if (is.docFrag(parent)) {
      // skip past #shado-root fragments
      while ((parent = parent.host) && is.docFrag(parent)) {
        continue;
      }

      return parent;
    }

    return parent;
  },

  matchesSelector: function matchesSelector(element, selector) {
    // remove /deep/ from selectors if shadowDOM polyfill is used
    if (win.window !== win.realWindow) {
      selector = selector.replace(/\/deep\//g, ' ');
    }

    return element[browser.prefixedMatchesSelector](selector);
  },

  // Test for the element that's "above" all other qualifiers
  indexOfDeepestElement: function indexOfDeepestElement(elements) {
    var deepestZoneParents = [];
    var dropzoneParents = [];
    var dropzone = void 0;
    var deepestZone = elements[0];
    var index = deepestZone ? 0 : -1;
    var parent = void 0;
    var child = void 0;
    var i = void 0;
    var n = void 0;

    for (i = 1; i < elements.length; i++) {
      dropzone = elements[i];

      // an element might belong to multiple selector dropzones
      if (!dropzone || dropzone === deepestZone) {
        continue;
      }

      if (!deepestZone) {
        deepestZone = dropzone;
        index = i;
        continue;
      }

      // check if the deepest or current are document.documentElement or document.rootElement
      // - if the current dropzone is, do nothing and continue
      if (dropzone.parentNode === dropzone.ownerDocument) {
        continue;
      }
      // - if deepest is, update with the current dropzone and continue to next
      else if (deepestZone.parentNode === dropzone.ownerDocument) {
          deepestZone = dropzone;
          index = i;
          continue;
        }

      if (!deepestZoneParents.length) {
        parent = deepestZone;
        while (parent.parentNode && parent.parentNode !== parent.ownerDocument) {
          deepestZoneParents.unshift(parent);
          parent = parent.parentNode;
        }
      }

      // if this element is an svg element and the current deepest is
      // an HTMLElement
      if (deepestZone instanceof domObjects.HTMLElement && dropzone instanceof domObjects.SVGElement && !(dropzone instanceof domObjects.SVGSVGElement)) {

        if (dropzone === deepestZone.parentNode) {
          continue;
        }

        parent = dropzone.ownerSVGElement;
      } else {
        parent = dropzone;
      }

      dropzoneParents = [];

      while (parent.parentNode !== parent.ownerDocument) {
        dropzoneParents.unshift(parent);
        parent = parent.parentNode;
      }

      n = 0;

      // get (position of last common ancestor) + 1
      while (dropzoneParents[n] && dropzoneParents[n] === deepestZoneParents[n]) {
        n++;
      }

      var parents = [dropzoneParents[n - 1], dropzoneParents[n], deepestZoneParents[n]];

      child = parents[0].lastChild;

      while (child) {
        if (child === parents[1]) {
          deepestZone = dropzone;
          index = i;
          deepestZoneParents = [];

          break;
        } else if (child === parents[2]) {
          break;
        }

        child = child.previousSibling;
      }
    }

    return index;
  },

  matchesUpTo: function matchesUpTo(element, selector, limit) {
    while (is.element(element)) {
      if (domUtils.matchesSelector(element, selector)) {
        return true;
      }

      element = domUtils.parentNode(element);

      if (element === limit) {
        return domUtils.matchesSelector(element, selector);
      }
    }

    return false;
  },

  getActualElement: function getActualElement(element) {
    return element instanceof domObjects.SVGElementInstance ? element.correspondingUseElement : element;
  },

  getScrollXY: function getScrollXY(relevantWindow) {
    relevantWindow = relevantWindow || win.window;
    return {
      x: relevantWindow.scrollX || relevantWindow.document.documentElement.scrollLeft,
      y: relevantWindow.scrollY || relevantWindow.document.documentElement.scrollTop
    };
  },

  getElementClientRect: function getElementClientRect(element) {
    var clientRect = element instanceof domObjects.SVGElement ? element.getBoundingClientRect() : element.getClientRects()[0];

    return clientRect && {
      left: clientRect.left,
      right: clientRect.right,
      top: clientRect.top,
      bottom: clientRect.bottom,
      width: clientRect.width || clientRect.right - clientRect.left,
      height: clientRect.height || clientRect.bottom - clientRect.top
    };
  },

  getElementRect: function getElementRect(element) {
    var clientRect = domUtils.getElementClientRect(element);

    if (!browser.isIOS7 && clientRect) {
      var scroll = domUtils.getScrollXY(win.getWindow(element));

      clientRect.left += scroll.x;
      clientRect.right += scroll.x;
      clientRect.top += scroll.y;
      clientRect.bottom += scroll.y;
    }

    return clientRect;
  },

  getPath: function getPath(element) {
    var path = [];

    while (element) {
      path.push(element);
      element = domUtils.parentNode(element);
    }

    return path;
  },

  trySelector: function trySelector(value) {
    if (!is.string(value)) {
      return false;
    }

    // an exception will be raised if it is invalid
    domObjects.document.querySelector(value);
    return true;
  }
};

module.exports = domUtils;

},{"./browser":36,"./domObjects":38,"./is":46,"./window":52}],40:[function(require,module,exports){
'use strict';

var is = require('./is');
var domUtils = require('./domUtils');
var pointerUtils = require('./pointerUtils');
var pExtend = require('./pointerExtend');

var _require = require('./window'),
    window = _require.window;

var _require2 = require('./arr'),
    contains = _require2.contains;

var elements = [];
var targets = [];

// {
//   type: {
//     selectors: ['selector', ...],
//     contexts : [document, ...],
//     listeners: [[listener, capture, passive], ...]
//   }
//  }
var delegatedEvents = {};
var documents = [];

var supportsOptions = function () {
  var supported = false;

  window.document.createElement('div').addEventListener('test', null, {
    get capture() {
      supported = true;
    }
  });

  return supported;
}();

function add(element, type, listener, optionalArg) {
  var options = getOptions(optionalArg);
  var elementIndex = elements.indexOf(element);
  var target = targets[elementIndex];

  if (!target) {
    target = {
      events: {},
      typeCount: 0
    };

    elementIndex = elements.push(element) - 1;
    targets.push(target);
  }

  if (!target.events[type]) {
    target.events[type] = [];
    target.typeCount++;
  }

  if (!contains(target.events[type], listener)) {
    element.addEventListener(type, listener, supportsOptions ? options : !!options.capture);
    target.events[type].push(listener);
  }
}

function remove(element, type, listener, optionalArg) {
  var options = getOptions(optionalArg);
  var elementIndex = elements.indexOf(element);
  var target = targets[elementIndex];

  if (!target || !target.events) {
    return;
  }

  if (type === 'all') {
    for (type in target.events) {
      if (target.events.hasOwnProperty(type)) {
        remove(element, type, 'all');
      }
    }
    return;
  }

  if (target.events[type]) {
    var len = target.events[type].length;

    if (listener === 'all') {
      for (var i = 0; i < len; i++) {
        remove(element, type, target.events[type][i], options);
      }
      return;
    } else {
      for (var _i = 0; _i < len; _i++) {
        if (target.events[type][_i] === listener) {
          element.removeEventListener('on' + type, listener, supportsOptions ? options : !!options.capture);
          target.events[type].splice(_i, 1);

          break;
        }
      }
    }

    if (target.events[type] && target.events[type].length === 0) {
      target.events[type] = null;
      target.typeCount--;
    }
  }

  if (!target.typeCount) {
    targets.splice(elementIndex, 1);
    elements.splice(elementIndex, 1);
  }
}

function addDelegate(selector, context, type, listener, optionalArg) {
  var options = getOptions(optionalArg);
  if (!delegatedEvents[type]) {
    delegatedEvents[type] = {
      selectors: [],
      contexts: [],
      listeners: []
    };

    // add delegate listener functions
    for (var _i2 = 0; _i2 < documents.length; _i2++) {
      var doc = documents[_i2];
      add(doc, type, delegateListener);
      add(doc, type, delegateUseCapture, true);
    }
  }

  var delegated = delegatedEvents[type];
  var index = void 0;

  for (index = delegated.selectors.length - 1; index >= 0; index--) {
    if (delegated.selectors[index] === selector && delegated.contexts[index] === context) {
      break;
    }
  }

  if (index === -1) {
    index = delegated.selectors.length;

    delegated.selectors.push(selector);
    delegated.contexts.push(context);
    delegated.listeners.push([]);
  }

  // keep listener and capture and passive flags
  delegated.listeners[index].push([listener, !!options.capture, options.passive]);
}

function removeDelegate(selector, context, type, listener, optionalArg) {
  var options = getOptions(optionalArg);
  var delegated = delegatedEvents[type];
  var matchFound = false;
  var index = void 0;

  if (!delegated) {
    return;
  }

  // count from last index of delegated to 0
  for (index = delegated.selectors.length - 1; index >= 0; index--) {
    // look for matching selector and context Node
    if (delegated.selectors[index] === selector && delegated.contexts[index] === context) {

      var listeners = delegated.listeners[index];

      // each item of the listeners array is an array: [function, capture, passive]
      for (var i = listeners.length - 1; i >= 0; i--) {
        var _listeners$i = listeners[i],
            fn = _listeners$i[0],
            capture = _listeners$i[1],
            passive = _listeners$i[2];

        // check if the listener functions and capture and passive flags match

        if (fn === listener && capture === !!options.capture && passive === options.passive) {
          // remove the listener from the array of listeners
          listeners.splice(i, 1);

          // if all listeners for this interactable have been removed
          // remove the interactable from the delegated arrays
          if (!listeners.length) {
            delegated.selectors.splice(index, 1);
            delegated.contexts.splice(index, 1);
            delegated.listeners.splice(index, 1);

            // remove delegate function from context
            remove(context, type, delegateListener);
            remove(context, type, delegateUseCapture, true);

            // remove the arrays if they are empty
            if (!delegated.selectors.length) {
              delegatedEvents[type] = null;
            }
          }

          // only remove one listener
          matchFound = true;
          break;
        }
      }

      if (matchFound) {
        break;
      }
    }
  }
}

// bound to the interactable context when a DOM event
// listener is added to a selector interactable
function delegateListener(event, optionalArg) {
  var options = getOptions(optionalArg);
  var fakeEvent = {};
  var delegated = delegatedEvents[event.type];

  var _pointerUtils$getEven = pointerUtils.getEventTargets(event),
      eventTarget = _pointerUtils$getEven[0];

  var element = eventTarget;

  // duplicate the event so that currentTarget can be changed
  pExtend(fakeEvent, event);

  fakeEvent.originalEvent = event;
  fakeEvent.preventDefault = preventOriginalDefault;

  // climb up document tree looking for selector matches
  while (is.element(element)) {
    for (var i = 0; i < delegated.selectors.length; i++) {
      var selector = delegated.selectors[i];
      var context = delegated.contexts[i];

      if (domUtils.matchesSelector(element, selector) && domUtils.nodeContains(context, eventTarget) && domUtils.nodeContains(context, element)) {

        var listeners = delegated.listeners[i];

        fakeEvent.currentTarget = element;

        for (var j = 0; j < listeners.length; j++) {
          var _listeners$j = listeners[j],
              fn = _listeners$j[0],
              capture = _listeners$j[1],
              passive = _listeners$j[2];


          if (capture === !!options.capture && passive === options.passive) {
            fn(fakeEvent);
          }
        }
      }
    }

    element = domUtils.parentNode(element);
  }
}

function delegateUseCapture(event) {
  return delegateListener.call(this, event, true);
}

function preventOriginalDefault() {
  this.originalEvent.preventDefault();
}

function getOptions(param) {
  return is.object(param) ? param : { capture: param };
}

module.exports = {
  add: add,
  remove: remove,

  addDelegate: addDelegate,
  removeDelegate: removeDelegate,

  delegateListener: delegateListener,
  delegateUseCapture: delegateUseCapture,
  delegatedEvents: delegatedEvents,
  documents: documents,

  supportsOptions: supportsOptions,

  _elements: elements,
  _targets: targets
};

},{"./arr":35,"./domUtils":39,"./is":46,"./pointerExtend":48,"./pointerUtils":49,"./window":52}],41:[function(require,module,exports){
"use strict";

module.exports = function extend(dest, source) {
  for (var prop in source) {
    dest[prop] = source[prop];
  }
  return dest;
};

},{}],42:[function(require,module,exports){
'use strict';

var _require = require('./rect'),
    resolveRectLike = _require.resolveRectLike,
    rectToXY = _require.rectToXY;

module.exports = function (target, element, action) {
  var actionOptions = target.options[action];
  var actionOrigin = actionOptions && actionOptions.origin;
  var origin = actionOrigin || target.options.origin;

  var originRect = resolveRectLike(origin, target, element, [target && element]);

  return rectToXY(originRect) || { x: 0, y: 0 };
};

},{"./rect":51}],43:[function(require,module,exports){
"use strict";

module.exports = function (x, y) {
  return Math.sqrt(x * x + y * y);
};

},{}],44:[function(require,module,exports){
'use strict';

var extend = require('./extend');
var win = require('./window');

var utils = {
  warnOnce: function warnOnce(method, message) {
    var warned = false;

    return function () {
      if (!warned) {
        win.window.console.warn(message);
        warned = true;
      }

      return method.apply(this, arguments);
    };
  },

  // http://stackoverflow.com/a/5634528/2280888
  _getQBezierValue: function _getQBezierValue(t, p1, p2, p3) {
    var iT = 1 - t;
    return iT * iT * p1 + 2 * iT * t * p2 + t * t * p3;
  },

  getQuadraticCurvePoint: function getQuadraticCurvePoint(startX, startY, cpX, cpY, endX, endY, position) {
    return {
      x: utils._getQBezierValue(position, startX, cpX, endX),
      y: utils._getQBezierValue(position, startY, cpY, endY)
    };
  },

  // http://gizma.com/easing/
  easeOutQuad: function easeOutQuad(t, b, c, d) {
    t /= d;
    return -c * t * (t - 2) + b;
  },

  copyAction: function copyAction(dest, src) {
    dest.name = src.name;
    dest.axis = src.axis;
    dest.edges = src.edges;

    return dest;
  },

  is: require('./is'),
  extend: extend,
  hypot: require('./hypot'),
  getOriginXY: require('./getOriginXY')
};

extend(utils, require('./arr'));
extend(utils, require('./domUtils'));
extend(utils, require('./pointerUtils'));
extend(utils, require('./rect'));

module.exports = utils;

},{"./arr":35,"./domUtils":39,"./extend":41,"./getOriginXY":42,"./hypot":43,"./is":46,"./pointerUtils":49,"./rect":51,"./window":52}],45:[function(require,module,exports){
'use strict';

var scope = require('../scope');
var utils = require('./index');

var finder = {
  methodOrder: ['simulationResume', 'mouseOrPen', 'hasPointer', 'idle'],

  search: function search(pointer, eventType, eventTarget) {
    var pointerType = utils.getPointerType(pointer);
    var pointerId = utils.getPointerId(pointer);
    var details = { pointer: pointer, pointerId: pointerId, pointerType: pointerType, eventType: eventType, eventTarget: eventTarget };

    for (var _i = 0; _i < finder.methodOrder.length; _i++) {
      var _ref;

      _ref = finder.methodOrder[_i];
      var method = _ref;

      var interaction = finder[method](details);

      if (interaction) {
        return interaction;
      }
    }
  },

  // try to resume simulation with a new pointer
  simulationResume: function simulationResume(_ref2) {
    var pointerType = _ref2.pointerType,
        eventType = _ref2.eventType,
        eventTarget = _ref2.eventTarget;

    if (!/down|start/i.test(eventType)) {
      return null;
    }

    for (var _i2 = 0; _i2 < scope.interactions.length; _i2++) {
      var _ref3;

      _ref3 = scope.interactions[_i2];
      var interaction = _ref3;

      var element = eventTarget;

      if (interaction.simulation && interaction.simulation.allowResume && interaction.pointerType === pointerType) {
        while (element) {
          // if the element is the interaction element
          if (element === interaction.element) {
            return interaction;
          }
          element = utils.parentNode(element);
        }
      }
    }

    return null;
  },

  // if it's a mouse or pen interaction
  mouseOrPen: function mouseOrPen(_ref4) {
    var pointerId = _ref4.pointerId,
        pointerType = _ref4.pointerType,
        eventType = _ref4.eventType;

    if (pointerType !== 'mouse' && pointerType !== 'pen') {
      return null;
    }

    var firstNonActive = void 0;

    for (var _i3 = 0; _i3 < scope.interactions.length; _i3++) {
      var _ref5;

      _ref5 = scope.interactions[_i3];
      var interaction = _ref5;

      if (interaction.pointerType === pointerType) {
        // if it's a down event, skip interactions with running simulations
        if (interaction.simulation && !utils.contains(interaction.pointerIds, pointerId)) {
          continue;
        }

        // if the interaction is active, return it immediately
        if (interaction.interacting()) {
          return interaction;
        }
        // otherwise save it and look for another active interaction
        else if (!firstNonActive) {
            firstNonActive = interaction;
          }
      }
    }

    // if no active mouse interaction was found use the first inactive mouse
    // interaction
    if (firstNonActive) {
      return firstNonActive;
    }

    // find any mouse or pen interaction.
    // ignore the interaction if the eventType is a *down, and a simulation
    // is active
    for (var _i4 = 0; _i4 < scope.interactions.length; _i4++) {
      var _ref6;

      _ref6 = scope.interactions[_i4];
      var _interaction = _ref6;

      if (_interaction.pointerType === pointerType && !(/down/i.test(eventType) && _interaction.simulation)) {
        return _interaction;
      }
    }

    return null;
  },

  // get interaction that has this pointer
  hasPointer: function hasPointer(_ref7) {
    var pointerId = _ref7.pointerId;

    for (var _i5 = 0; _i5 < scope.interactions.length; _i5++) {
      var _ref8;

      _ref8 = scope.interactions[_i5];
      var interaction = _ref8;

      if (utils.contains(interaction.pointerIds, pointerId)) {
        return interaction;
      }
    }
  },

  // get first idle interaction with a matching pointerType
  idle: function idle(_ref9) {
    var pointerType = _ref9.pointerType;

    for (var _i6 = 0; _i6 < scope.interactions.length; _i6++) {
      var _ref10;

      _ref10 = scope.interactions[_i6];
      var interaction = _ref10;

      // if there's already a pointer held down
      if (interaction.pointerIds.length === 1) {
        var target = interaction.target;
        // don't add this pointer if there is a target interactable and it
        // isn't gesturable
        if (target && !target.options.gesture.enabled) {
          continue;
        }
      }
      // maximum of 2 pointers per interaction
      else if (interaction.pointerIds.length >= 2) {
          continue;
        }

      if (!interaction.interacting() && pointerType === interaction.pointerType) {
        return interaction;
      }
    }

    return null;
  }
};

module.exports = finder;

},{"../scope":33,"./index":44}],46:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var win = require('./window');
var isWindow = require('./isWindow');

var is = {
  array: function array() {},

  window: function window(thing) {
    return thing === win.window || isWindow(thing);
  },

  docFrag: function docFrag(thing) {
    return is.object(thing) && thing.nodeType === 11;
  },

  object: function object(thing) {
    return !!thing && (typeof thing === 'undefined' ? 'undefined' : _typeof(thing)) === 'object';
  },

  function: function _function(thing) {
    return typeof thing === 'function';
  },

  number: function number(thing) {
    return typeof thing === 'number';
  },

  bool: function bool(thing) {
    return typeof thing === 'boolean';
  },

  string: function string(thing) {
    return typeof thing === 'string';
  },

  element: function element(thing) {
    if (!thing || (typeof thing === 'undefined' ? 'undefined' : _typeof(thing)) !== 'object') {
      return false;
    }

    var _window = win.getWindow(thing) || win.window;

    return (/object|function/.test(_typeof(_window.Element)) ? thing instanceof _window.Element //DOM2
      : thing.nodeType === 1 && typeof thing.nodeName === 'string'
    );
  },

  plainObject: function plainObject(thing) {
    return is.object(thing) && thing.constructor.name === 'Object';
  }
};

is.array = function (thing) {
  return is.object(thing) && typeof thing.length !== 'undefined' && is.function(thing.splice);
};

module.exports = is;

},{"./isWindow":47,"./window":52}],47:[function(require,module,exports){
"use strict";

module.exports = function (thing) {
  return !!(thing && thing.Window) && thing instanceof thing.Window;
};

},{}],48:[function(require,module,exports){
'use strict';

function pointerExtend(dest, source) {
  for (var prop in source) {
    var prefixedPropREs = module.exports.prefixedPropREs;
    var deprecated = false;

    // skip deprecated prefixed properties
    for (var vendor in prefixedPropREs) {
      if (prop.indexOf(vendor) === 0 && prefixedPropREs[vendor].test(prop)) {
        deprecated = true;
        break;
      }
    }

    if (!deprecated && typeof source[prop] !== 'function') {
      dest[prop] = source[prop];
    }
  }
  return dest;
}

pointerExtend.prefixedPropREs = {
  webkit: /(Movement[XY]|Radius[XY]|RotationAngle|Force)$/
};

module.exports = pointerExtend;

},{}],49:[function(require,module,exports){
'use strict';

var hypot = require('./hypot');
var browser = require('./browser');
var dom = require('./domObjects');
var domUtils = require('./domUtils');
var domObjects = require('./domObjects');
var is = require('./is');
var pointerExtend = require('./pointerExtend');

var pointerUtils = {
  copyCoords: function copyCoords(dest, src) {
    dest.page = dest.page || {};
    dest.page.x = src.page.x;
    dest.page.y = src.page.y;

    dest.client = dest.client || {};
    dest.client.x = src.client.x;
    dest.client.y = src.client.y;

    dest.timeStamp = src.timeStamp;
  },

  setCoordDeltas: function setCoordDeltas(targetObj, prev, cur) {
    targetObj.page.x = cur.page.x - prev.page.x;
    targetObj.page.y = cur.page.y - prev.page.y;
    targetObj.client.x = cur.client.x - prev.client.x;
    targetObj.client.y = cur.client.y - prev.client.y;
    targetObj.timeStamp = cur.timeStamp - prev.timeStamp;

    // set pointer velocity
    var dt = Math.max(targetObj.timeStamp / 1000, 0.001);

    targetObj.page.speed = hypot(targetObj.page.x, targetObj.page.y) / dt;
    targetObj.page.vx = targetObj.page.x / dt;
    targetObj.page.vy = targetObj.page.y / dt;

    targetObj.client.speed = hypot(targetObj.client.x, targetObj.page.y) / dt;
    targetObj.client.vx = targetObj.client.x / dt;
    targetObj.client.vy = targetObj.client.y / dt;
  },

  isNativePointer: function isNativePointer(pointer) {
    return pointer instanceof dom.Event || pointer instanceof dom.Touch;
  },

  // Get specified X/Y coords for mouse or event.touches[0]
  getXY: function getXY(type, pointer, xy) {
    xy = xy || {};
    type = type || 'page';

    xy.x = pointer[type + 'X'];
    xy.y = pointer[type + 'Y'];

    return xy;
  },

  getPageXY: function getPageXY(pointer, page) {
    page = page || {};

    // Opera Mobile handles the viewport and scrolling oddly
    if (browser.isOperaMobile && pointerUtils.isNativePointer(pointer)) {
      pointerUtils.getXY('screen', pointer, page);

      page.x += window.scrollX;
      page.y += window.scrollY;
    } else {
      pointerUtils.getXY('page', pointer, page);
    }

    return page;
  },

  getClientXY: function getClientXY(pointer, client) {
    client = client || {};

    if (browser.isOperaMobile && pointerUtils.isNativePointer(pointer)) {
      // Opera Mobile handles the viewport and scrolling oddly
      pointerUtils.getXY('screen', pointer, client);
    } else {
      pointerUtils.getXY('client', pointer, client);
    }

    return client;
  },

  getPointerId: function getPointerId(pointer) {
    return is.number(pointer.pointerId) ? pointer.pointerId : pointer.identifier;
  },

  setCoords: function setCoords(targetObj, pointers, timeStamp) {
    var pointer = pointers.length > 1 ? pointerUtils.pointerAverage(pointers) : pointers[0];

    var tmpXY = {};

    pointerUtils.getPageXY(pointer, tmpXY);
    targetObj.page.x = tmpXY.x;
    targetObj.page.y = tmpXY.y;

    pointerUtils.getClientXY(pointer, tmpXY);
    targetObj.client.x = tmpXY.x;
    targetObj.client.y = tmpXY.y;

    targetObj.timeStamp = is.number(timeStamp) ? timeStamp : new Date().getTime();
  },

  pointerExtend: pointerExtend,

  getTouchPair: function getTouchPair(event) {
    var touches = [];

    // array of touches is supplied
    if (is.array(event)) {
      touches[0] = event[0];
      touches[1] = event[1];
    }
    // an event
    else {
        if (event.type === 'touchend') {
          if (event.touches.length === 1) {
            touches[0] = event.touches[0];
            touches[1] = event.changedTouches[0];
          } else if (event.touches.length === 0) {
            touches[0] = event.changedTouches[0];
            touches[1] = event.changedTouches[1];
          }
        } else {
          touches[0] = event.touches[0];
          touches[1] = event.touches[1];
        }
      }

    return touches;
  },

  pointerAverage: function pointerAverage(pointers) {
    var average = {
      pageX: 0,
      pageY: 0,
      clientX: 0,
      clientY: 0,
      screenX: 0,
      screenY: 0
    };

    for (var _i = 0; _i < pointers.length; _i++) {
      var _ref;

      _ref = pointers[_i];
      var pointer = _ref;

      for (var _prop in average) {
        average[_prop] += pointer[_prop];
      }
    }
    for (var prop in average) {
      average[prop] /= pointers.length;
    }

    return average;
  },

  touchBBox: function touchBBox(event) {
    if (!event.length && !(event.touches && event.touches.length > 1)) {
      return;
    }

    var touches = pointerUtils.getTouchPair(event);
    var minX = Math.min(touches[0].pageX, touches[1].pageX);
    var minY = Math.min(touches[0].pageY, touches[1].pageY);
    var maxX = Math.max(touches[0].pageX, touches[1].pageX);
    var maxY = Math.max(touches[0].pageY, touches[1].pageY);

    return {
      x: minX,
      y: minY,
      left: minX,
      top: minY,
      width: maxX - minX,
      height: maxY - minY
    };
  },

  touchDistance: function touchDistance(event, deltaSource) {
    var sourceX = deltaSource + 'X';
    var sourceY = deltaSource + 'Y';
    var touches = pointerUtils.getTouchPair(event);

    var dx = touches[0][sourceX] - touches[1][sourceX];
    var dy = touches[0][sourceY] - touches[1][sourceY];

    return hypot(dx, dy);
  },

  touchAngle: function touchAngle(event, prevAngle, deltaSource) {
    var sourceX = deltaSource + 'X';
    var sourceY = deltaSource + 'Y';
    var touches = pointerUtils.getTouchPair(event);
    var dx = touches[1][sourceX] - touches[0][sourceX];
    var dy = touches[1][sourceY] - touches[0][sourceY];
    var angle = 180 * Math.atan2(dy, dx) / Math.PI;

    return angle;
  },

  getPointerType: function getPointerType(pointer) {
    return is.string(pointer.pointerType) ? pointer.pointerType : is.number(pointer.pointerType) ? [undefined, undefined, 'touch', 'pen', 'mouse'][pointer.pointerType]
    // if the PointerEvent API isn't available, then the "pointer" must
    // be either a MouseEvent, TouchEvent, or Touch object
    : /touch/.test(pointer.type) || pointer instanceof domObjects.Touch ? 'touch' : 'mouse';
  },

  // [ event.target, event.currentTarget ]
  getEventTargets: function getEventTargets(event) {
    var path = is.function(event.composedPath) ? event.composedPath() : event.path;

    return [domUtils.getActualElement(path ? path[0] : event.target), domUtils.getActualElement(event.currentTarget)];
  }
};

module.exports = pointerUtils;

},{"./browser":36,"./domObjects":38,"./domUtils":39,"./hypot":43,"./is":46,"./pointerExtend":48}],50:[function(require,module,exports){
'use strict';

var _require = require('./window'),
    window = _require.window;

var vendors = ['ms', 'moz', 'webkit', 'o'];
var lastTime = 0;
var request = void 0;
var cancel = void 0;

for (var x = 0; x < vendors.length && !window.requestAnimationFrame; x++) {
  request = window[vendors[x] + 'RequestAnimationFrame'];
  cancel = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
}

if (!request) {
  request = function request(callback) {
    var currTime = new Date().getTime();
    var timeToCall = Math.max(0, 16 - (currTime - lastTime));
    var id = setTimeout(function () {
      callback(currTime + timeToCall);
    }, timeToCall);

    lastTime = currTime + timeToCall;
    return id;
  };
}

if (!cancel) {
  cancel = function cancel(id) {
    clearTimeout(id);
  };
}

module.exports = {
  request: request,
  cancel: cancel
};

},{"./window":52}],51:[function(require,module,exports){
'use strict';

var extend = require('./extend');
var is = require('./is');

var _require = require('./domUtils'),
    closest = _require.closest,
    parentNode = _require.parentNode,
    getElementRect = _require.getElementRect;

var rectUtils = {
  getStringOptionResult: function getStringOptionResult(value, interactable, element) {
    if (!is.string(value)) {
      return null;
    }

    if (value === 'parent') {
      value = parentNode(element);
    } else if (value === 'self') {
      value = interactable.getRect(element);
    } else {
      value = closest(element, value);
    }

    return value;
  },

  resolveRectLike: function resolveRectLike(value, interactable, element, functionArgs) {
    value = rectUtils.getStringOptionResult(value, interactable, element) || value;

    if (is.function(value)) {
      value = value.apply(null, functionArgs);
    }

    if (is.element(value)) {
      value = getElementRect(value);
    }

    return value;
  },

  rectToXY: function rectToXY(rect) {
    return rect && {
      x: 'x' in rect ? rect.x : rect.left,
      y: 'y' in rect ? rect.y : rect.top
    };
  },

  xywhToTlbr: function xywhToTlbr(rect) {
    if (rect && !('left' in rect && 'top' in rect)) {
      rect = extend({}, rect);

      rect.left = rect.x || 0;
      rect.top = rect.y || 0;
      rect.right = rect.right || rect.left + rect.width;
      rect.bottom = rect.bottom || rect.top + rect.height;
    }

    return rect;
  },

  tlbrToXywh: function tlbrToXywh(rect) {
    if (rect && !('x' in rect && 'y' in rect)) {
      rect = extend({}, rect);

      rect.x = rect.left || 0;
      rect.top = rect.top || 0;
      rect.width = rect.width || rect.right - rect.x;
      rect.height = rect.height || rect.bottom - rect.y;
    }

    return rect;
  }
};

module.exports = rectUtils;

},{"./domUtils":39,"./extend":41,"./is":46}],52:[function(require,module,exports){
'use strict';

var win = module.exports;
var isWindow = require('./isWindow');

function init(window) {
  // get wrapped window if using Shadow DOM polyfill

  win.realWindow = window;

  // create a TextNode
  var el = window.document.createTextNode('');

  // check if it's wrapped by a polyfill
  if (el.ownerDocument !== window.document && typeof window.wrap === 'function' && window.wrap(el) === el) {
    // use wrapped window
    window = window.wrap(window);
  }

  win.window = window;
}

if (typeof window === 'undefined') {
  win.window = undefined;
  win.realWindow = undefined;
} else {
  init(window);
}

win.getWindow = function getWindow(node) {
  if (isWindow(node)) {
    return node;
  }

  var rootNode = node.ownerDocument || node;

  return rootNode.defaultView || rootNode.parentWindow || win.window;
};

win.init = init;

},{"./isWindow":47}]},{},[1])(1)
});


//# sourceMappingURL=interact.js.map


/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Slider__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Range__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Handle__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createSliderWithTooltip__ = __webpack_require__(314);
/* unused harmony reexport Range */
/* unused harmony reexport Handle */
/* unused harmony reexport createSliderWithTooltip */





__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */].Range = __WEBPACK_IMPORTED_MODULE_1__Range__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */].Handle = __WEBPACK_IMPORTED_MODULE_2__Handle__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */].createSliderWithTooltip = __WEBPACK_IMPORTED_MODULE_3__createSliderWithTooltip__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */]);


/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Track__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_createSlider__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(70);




/* eslint-disable react/prop-types */







var Slider = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Slider, _React$Component);

  function Slider(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Slider);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.onEnd = function () {
      _this.setState({ dragging: false });
      _this.removeDocumentEvents();
      _this.props.onAfterChange(_this.getValue());
    };

    var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
    var value = props.value !== undefined ? props.value : defaultValue;

    _this.state = {
      value: _this.trimAlignValue(value),
      dragging: false
    };
    if (false) {
      warning(!('minimumTrackStyle' in props), 'minimumTrackStyle will be deprecate, please use trackStyle instead.');
      warning(!('maximumTrackStyle' in props), 'maximumTrackStyle will be deprecate, please use railStyle instead.');
    }
    return _this;
  }

  Slider.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        autoFocus = _props.autoFocus,
        disabled = _props.disabled;

    if (autoFocus && !disabled) {
      this.focus();
    }
  };

  Slider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!('value' in nextProps || 'min' in nextProps || 'max' in nextProps)) return;

    var prevValue = this.state.value;
    var value = nextProps.value !== undefined ? nextProps.value : prevValue;
    var nextValue = this.trimAlignValue(value, nextProps);
    if (nextValue === prevValue) return;

    this.setState({ value: nextValue });
    if (__WEBPACK_IMPORTED_MODULE_9__utils__["i" /* isValueOutOfRange */](value, nextProps)) {
      this.props.onChange(nextValue);
    }
  };

  Slider.prototype.onChange = function onChange(state) {
    var props = this.props;
    var isNotControlled = !('value' in props);
    if (isNotControlled) {
      this.setState(state);
    }

    var changedValue = state.value;
    props.onChange(changedValue);
  };

  Slider.prototype.onStart = function onStart(position) {
    this.setState({ dragging: true });
    var props = this.props;
    var prevValue = this.getValue();
    props.onBeforeChange(prevValue);

    var value = this.calcValueByPos(position);
    this.startValue = value;
    this.startPosition = position;

    if (value === prevValue) return;

    this.onChange({ value: value });
  };

  Slider.prototype.onMove = function onMove(e, position) {
    __WEBPACK_IMPORTED_MODULE_9__utils__["j" /* pauseEvent */](e);
    var oldValue = this.state.value;

    var value = this.calcValueByPos(position);
    if (value === oldValue) return;

    this.onChange({ value: value });
  };

  Slider.prototype.onKeyboard = function onKeyboard(e) {
    var valueMutator = __WEBPACK_IMPORTED_MODULE_9__utils__["d" /* getKeyboardValueMutator */](e);

    if (valueMutator) {
      __WEBPACK_IMPORTED_MODULE_9__utils__["j" /* pauseEvent */](e);
      var state = this.state;
      var oldValue = state.value;
      var mutatedValue = valueMutator(oldValue, this.props);
      var value = this.trimAlignValue(mutatedValue);
      if (value === oldValue) return;

      this.onChange({ value: value });
    }
  };

  Slider.prototype.getValue = function getValue() {
    return this.state.value;
  };

  Slider.prototype.getLowerBound = function getLowerBound() {
    return this.props.min;
  };

  Slider.prototype.getUpperBound = function getUpperBound() {
    return this.state.value;
  };

  Slider.prototype.trimAlignValue = function trimAlignValue(v) {
    var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var mergedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, nextProps);
    var val = __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* ensureValueInRange */](v, mergedProps);
    return __WEBPACK_IMPORTED_MODULE_9__utils__["b" /* ensureValuePrecision */](val, mergedProps);
  };

  Slider.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        prefixCls = _props2.prefixCls,
        vertical = _props2.vertical,
        included = _props2.included,
        disabled = _props2.disabled,
        minimumTrackStyle = _props2.minimumTrackStyle,
        trackStyle = _props2.trackStyle,
        handleStyle = _props2.handleStyle,
        tabIndex = _props2.tabIndex,
        min = _props2.min,
        max = _props2.max,
        handleGenerator = _props2.handle;
    var _state = this.state,
        value = _state.value,
        dragging = _state.dragging;

    var offset = this.calcOffset(value);
    var handle = handleGenerator({
      className: prefixCls + '-handle',
      vertical: vertical,
      offset: offset,
      value: value,
      dragging: dragging,
      disabled: disabled,
      min: min,
      max: max,
      index: 0,
      tabIndex: tabIndex,
      style: handleStyle[0] || handleStyle,
      ref: function ref(h) {
        return _this2.saveHandle(0, h);
      }
    });

    var _trackStyle = trackStyle[0] || trackStyle;
    var track = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_Track__["a" /* default */], {
      className: prefixCls + '-track',
      vertical: vertical,
      included: included,
      offset: 0,
      length: offset,
      style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, minimumTrackStyle, _trackStyle)
    });

    return { tracks: track, handles: handle };
  };

  return Slider;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Slider.propTypes = {
  defaultValue: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  value: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  tabIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__common_createSlider__["a" /* default */])(Slider));

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(271), __esModule: true };

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(272);
module.exports = __webpack_require__(11).Object.assign;


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(18);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(274) });


/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(38);
var gOPS = __webpack_require__(62);
var pIE = __webpack_require__(41);
var toObject = __webpack_require__(104);
var IObject = __webpack_require__(102);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(29)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(21);
var toLength = __webpack_require__(276);
var toAbsoluteIndex = __webpack_require__(277);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(58);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(58);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(279), __esModule: true };

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(280);
__webpack_require__(286);
module.exports = __webpack_require__(66).f('iterator');


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(281)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(105)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(58);
var defined = __webpack_require__(57);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(64);
var descriptor = __webpack_require__(37);
var setToStringTag = __webpack_require__(65);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(19)(IteratorPrototype, __webpack_require__(22)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(12);
var anObject = __webpack_require__(28);
var getKeys = __webpack_require__(38);

module.exports = __webpack_require__(13) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(10).document;
module.exports = document && document.documentElement;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(14);
var toObject = __webpack_require__(104);
var IE_PROTO = __webpack_require__(59)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(287);
var global = __webpack_require__(10);
var hide = __webpack_require__(19);
var Iterators = __webpack_require__(63);
var TO_STRING_TAG = __webpack_require__(22)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(288);
var step = __webpack_require__(289);
var Iterators = __webpack_require__(63);
var toIObject = __webpack_require__(21);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(105)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(291), __esModule: true };

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(292);
__webpack_require__(297);
__webpack_require__(298);
__webpack_require__(299);
module.exports = __webpack_require__(11).Symbol;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(10);
var has = __webpack_require__(14);
var DESCRIPTORS = __webpack_require__(13);
var $export = __webpack_require__(18);
var redefine = __webpack_require__(106);
var META = __webpack_require__(293).KEY;
var $fails = __webpack_require__(29);
var shared = __webpack_require__(60);
var setToStringTag = __webpack_require__(65);
var uid = __webpack_require__(40);
var wks = __webpack_require__(22);
var wksExt = __webpack_require__(66);
var wksDefine = __webpack_require__(67);
var enumKeys = __webpack_require__(294);
var isArray = __webpack_require__(295);
var anObject = __webpack_require__(28);
var isObject = __webpack_require__(20);
var toIObject = __webpack_require__(21);
var toPrimitive = __webpack_require__(56);
var createDesc = __webpack_require__(37);
var _create = __webpack_require__(64);
var gOPNExt = __webpack_require__(296);
var $GOPD = __webpack_require__(108);
var $DP = __webpack_require__(12);
var $keys = __webpack_require__(38);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(107).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(41).f = $propertyIsEnumerable;
  __webpack_require__(62).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(39)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(19)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(40)('meta');
var isObject = __webpack_require__(20);
var has = __webpack_require__(14);
var setDesc = __webpack_require__(12).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(29)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(38);
var gOPS = __webpack_require__(62);
var pIE = __webpack_require__(41);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(103);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(21);
var gOPN = __webpack_require__(107).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 297 */
/***/ (function(module, exports) {



/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(67)('asyncIterator');


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(67)('observable');


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(301), __esModule: true };

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(302);
module.exports = __webpack_require__(11).Object.setPrototypeOf;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(18);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(303).set });


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(20);
var anObject = __webpack_require__(28);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(98)(Function.call, __webpack_require__(108).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(305), __esModule: true };

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(306);
var $Object = __webpack_require__(11).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(18);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(64) });


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = addEventListener;

var _EventObject = __webpack_require__(308);

var _EventObject2 = _interopRequireDefault(_EventObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function addEventListener(target, eventType, callback) {
  function wrapCallback(e) {
    var ne = new _EventObject2["default"](e);
    callback.call(target, ne);
  }

  if (target.addEventListener) {
    target.addEventListener(eventType, wrapCallback, false);
    return {
      remove: function remove() {
        target.removeEventListener(eventType, wrapCallback, false);
      }
    };
  } else if (target.attachEvent) {
    target.attachEvent('on' + eventType, wrapCallback);
    return {
      remove: function remove() {
        target.detachEvent('on' + eventType, wrapCallback);
      }
    };
  }
}
module.exports = exports['default'];

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EventBaseObject = __webpack_require__(309);

var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);

var _objectAssign = __webpack_require__(31);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */

var TRUE = true;
var FALSE = false;
var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

function isNullOrUndefined(w) {
  return w === null || w === undefined;
}

var eventNormalizers = [{
  reg: /^key/,
  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
  fix: function fix(event, nativeEvent) {
    if (isNullOrUndefined(event.which)) {
      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
    }

    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
    if (event.metaKey === undefined) {
      event.metaKey = event.ctrlKey;
    }
  }
}, {
  reg: /^touch/,
  props: ['touches', 'changedTouches', 'targetTouches']
}, {
  reg: /^hashchange$/,
  props: ['newURL', 'oldURL']
}, {
  reg: /^gesturechange$/i,
  props: ['rotation', 'scale']
}, {
  reg: /^(mousewheel|DOMMouseScroll)$/,
  props: [],
  fix: function fix(event, nativeEvent) {
    var deltaX = void 0;
    var deltaY = void 0;
    var delta = void 0;
    var wheelDelta = nativeEvent.wheelDelta;
    var axis = nativeEvent.axis;
    var wheelDeltaY = nativeEvent.wheelDeltaY;
    var wheelDeltaX = nativeEvent.wheelDeltaX;
    var detail = nativeEvent.detail;

    // ie/webkit
    if (wheelDelta) {
      delta = wheelDelta / 120;
    }

    // gecko
    if (detail) {
      // press control e.detail == 1 else e.detail == 3
      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
    }

    // Gecko
    if (axis !== undefined) {
      if (axis === event.HORIZONTAL_AXIS) {
        deltaY = 0;
        deltaX = 0 - delta;
      } else if (axis === event.VERTICAL_AXIS) {
        deltaX = 0;
        deltaY = delta;
      }
    }

    // Webkit
    if (wheelDeltaY !== undefined) {
      deltaY = wheelDeltaY / 120;
    }
    if (wheelDeltaX !== undefined) {
      deltaX = -1 * wheelDeltaX / 120;
    }

    // 默认 deltaY (ie)
    if (!deltaX && !deltaY) {
      deltaY = delta;
    }

    if (deltaX !== undefined) {
      /**
       * deltaX of mousewheel event
       * @property deltaX
       * @member Event.DomEvent.Object
       */
      event.deltaX = deltaX;
    }

    if (deltaY !== undefined) {
      /**
       * deltaY of mousewheel event
       * @property deltaY
       * @member Event.DomEvent.Object
       */
      event.deltaY = deltaY;
    }

    if (delta !== undefined) {
      /**
       * delta of mousewheel event
       * @property delta
       * @member Event.DomEvent.Object
       */
      event.delta = delta;
    }
  }
}, {
  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
  fix: function fix(event, nativeEvent) {
    var eventDoc = void 0;
    var doc = void 0;
    var body = void 0;
    var target = event.target;
    var button = nativeEvent.button;

    // Calculate pageX/Y if missing and clientX/Y available
    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
      eventDoc = target.ownerDocument || document;
      doc = eventDoc.documentElement;
      body = eventDoc.body;
      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }

    // which for click: 1 === left; 2 === middle; 3 === right
    // do not use button
    if (!event.which && button !== undefined) {
      if (button & 1) {
        event.which = 1;
      } else if (button & 2) {
        event.which = 3;
      } else if (button & 4) {
        event.which = 2;
      } else {
        event.which = 0;
      }
    }

    // add relatedTarget, if necessary
    if (!event.relatedTarget && event.fromElement) {
      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
    }

    return event;
  }
}];

function retTrue() {
  return TRUE;
}

function retFalse() {
  return FALSE;
}

function DomEventObject(nativeEvent) {
  var type = nativeEvent.type;

  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

  _EventBaseObject2["default"].call(this);

  this.nativeEvent = nativeEvent;

  // in case dom event has been mark as default prevented by lower dom node
  var isDefaultPrevented = retFalse;
  if ('defaultPrevented' in nativeEvent) {
    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
  } else if ('getPreventDefault' in nativeEvent) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
  } else if ('returnValue' in nativeEvent) {
    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
  }

  this.isDefaultPrevented = isDefaultPrevented;

  var fixFns = [];
  var fixFn = void 0;
  var l = void 0;
  var prop = void 0;
  var props = commonProps.concat();

  eventNormalizers.forEach(function (normalizer) {
    if (type.match(normalizer.reg)) {
      props = props.concat(normalizer.props);
      if (normalizer.fix) {
        fixFns.push(normalizer.fix);
      }
    }
  });

  l = props.length;

  // clone properties of the original event object
  while (l) {
    prop = props[--l];
    this[prop] = nativeEvent[prop];
  }

  // fix target property, if necessary
  if (!this.target && isNative) {
    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
  }

  // check if target is a text node (safari)
  if (this.target && this.target.nodeType === 3) {
    this.target = this.target.parentNode;
  }

  l = fixFns.length;

  while (l) {
    fixFn = fixFns[--l];
    fixFn(this, nativeEvent);
  }

  this.timeStamp = nativeEvent.timeStamp || Date.now();
}

var EventBaseObjectProto = _EventBaseObject2["default"].prototype;

(0, _objectAssign2["default"])(DomEventObject.prototype, EventBaseObjectProto, {
  constructor: DomEventObject,

  preventDefault: function preventDefault() {
    var e = this.nativeEvent;

    // if preventDefault exists run it on the original event
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      // otherwise set the returnValue property of the original event to FALSE (IE)
      e.returnValue = FALSE;
    }

    EventBaseObjectProto.preventDefault.call(this);
  },
  stopPropagation: function stopPropagation() {
    var e = this.nativeEvent;

    // if stopPropagation exists run it on the original event
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      // otherwise set the cancelBubble property of the original event to TRUE (IE)
      e.cancelBubble = TRUE;
    }

    EventBaseObjectProto.stopPropagation.call(this);
  }
});

exports["default"] = DomEventObject;
module.exports = exports['default'];

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */

function returnFalse() {
  return false;
}

function returnTrue() {
  return true;
}

function EventBaseObject() {
  this.timeStamp = Date.now();
  this.target = undefined;
  this.currentTarget = undefined;
}

EventBaseObject.prototype = {
  isEventObject: 1,

  constructor: EventBaseObject,

  isDefaultPrevented: returnFalse,

  isPropagationStopped: returnFalse,

  isImmediatePropagationStopped: returnFalse,

  preventDefault: function preventDefault() {
    this.isDefaultPrevented = returnTrue;
  },
  stopPropagation: function stopPropagation() {
    this.isPropagationStopped = returnTrue;
  },
  stopImmediatePropagation: function stopImmediatePropagation() {
    this.isImmediatePropagationStopped = returnTrue;
    // fixed 1.2
    // call stopPropagation implicitly
    this.stopPropagation();
  },
  halt: function halt(immediate) {
    if (immediate) {
      this.stopImmediatePropagation();
    } else {
      this.stopPropagation();
    }
    this.preventDefault();
  }
};

exports["default"] = EventBaseObject;
module.exports = exports['default'];

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_warning__);





var calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
  __WEBPACK_IMPORTED_MODULE_3_warning___default()(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
  var points = Object.keys(marks).map(parseFloat);
  if (dots) {
    for (var i = min; i <= max; i = i + step) {
      if (points.indexOf(i) >= 0) continue;
      points.push(i);
    }
  }
  return points;
};

var Steps = function Steps(_ref) {
  var prefixCls = _ref.prefixCls,
      vertical = _ref.vertical,
      marks = _ref.marks,
      dots = _ref.dots,
      step = _ref.step,
      included = _ref.included,
      lowerBound = _ref.lowerBound,
      upperBound = _ref.upperBound,
      max = _ref.max,
      min = _ref.min,
      dotStyle = _ref.dotStyle,
      activeDotStyle = _ref.activeDotStyle;

  var range = max - min;
  var elements = calcPoints(vertical, marks, dots, step, min, max).map(function (point) {
    var _classNames;

    var offset = Math.abs(point - min) / range * 100 + '%';

    var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var style = vertical ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ bottom: offset }, dotStyle) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ left: offset }, dotStyle);
    if (isActived) {
      style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, activeDotStyle);
    }

    var pointClassName = __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, _classNames[prefixCls + '-dot'] = true, _classNames[prefixCls + '-dot-active'] = isActived, _classNames));

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: pointClassName, style: style, key: point });
  });

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: prefixCls + '-step' },
    elements
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Steps);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);




var Marks = function Marks(_ref) {
  var className = _ref.className,
      vertical = _ref.vertical,
      marks = _ref.marks,
      included = _ref.included,
      upperBound = _ref.upperBound,
      lowerBound = _ref.lowerBound,
      max = _ref.max,
      min = _ref.min;

  var marksKeys = Object.keys(marks);
  var marksCount = marksKeys.length;
  var unit = marksCount > 1 ? 100 / (marksCount - 1) : 100;
  var markWidth = unit * 0.9;

  var range = max - min;
  var elements = marksKeys.map(parseFloat).sort(function (a, b) {
    return a - b;
  }).map(function (point) {
    var _classNames;

    var markPoint = marks[point];
    var markPointIsObject = typeof markPoint === 'object' && !__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(markPoint);
    var markLabel = markPointIsObject ? markPoint.label : markPoint;
    if (!markLabel && markLabel !== 0) {
      return null;
    }

    var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var markClassName = __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, _classNames[className + '-text'] = true, _classNames[className + '-text-active'] = isActive, _classNames));

    var bottomStyle = {
      marginBottom: '-50%',
      bottom: (point - min) / range * 100 + '%'
    };

    var leftStyle = {
      width: markWidth + '%',
      marginLeft: -markWidth / 2 + '%',
      left: (point - min) / range * 100 + '%'
    };

    var style = vertical ? bottomStyle : leftStyle;
    var markStyle = markPointIsObject ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, markPoint.style) : style;
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'span',
      {
        className: markClassName,
        style: markStyle,
        key: point
      },
      markLabel
    );
  });

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: className },
    elements
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Marks);

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */

var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12, // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33, // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34, // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35, // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36, // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37, // also NUM_WEST
  /**
   * UP
   */
  UP: 38, // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39, // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40, // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45, // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46, // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63, // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91, // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186, // needs localization
  /**
   * DASH
   */
  DASH: 189, // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187, // needs localization
  /**
   * COMMA
   */
  COMMA: 188, // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190, // needs localization
  /**
   * SLASH
   */
  SLASH: 191, // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192, // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222, // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219, // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220, // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221, // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224, // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229
};

/*
 whether text and modified key is entered at the same time.
 */
KeyCode.isTextModifyingKeyEvent = function isTextModifyingKeyEvent(e) {
  var keyCode = e.keyCode;
  if (e.altKey && !e.ctrlKey || e.metaKey ||
  // Function keys don't generate text
  keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
    return false;
  }

  // The following keys are quite harmless, even in combination with
  // CTRL, ALT or SHIFT.
  switch (keyCode) {
    case KeyCode.ALT:
    case KeyCode.CAPS_LOCK:
    case KeyCode.CONTEXT_MENU:
    case KeyCode.CTRL:
    case KeyCode.DOWN:
    case KeyCode.END:
    case KeyCode.ESC:
    case KeyCode.HOME:
    case KeyCode.INSERT:
    case KeyCode.LEFT:
    case KeyCode.MAC_FF_META:
    case KeyCode.META:
    case KeyCode.NUMLOCK:
    case KeyCode.NUM_CENTER:
    case KeyCode.PAGE_DOWN:
    case KeyCode.PAGE_UP:
    case KeyCode.PAUSE:
    case KeyCode.PRINT_SCREEN:
    case KeyCode.RIGHT:
    case KeyCode.SHIFT:
    case KeyCode.UP:
    case KeyCode.WIN_KEY:
    case KeyCode.WIN_KEY_RIGHT:
      return false;
    default:
      return true;
  }
};

/*
 whether character is entered.
 */
KeyCode.isCharacterKey = function isCharacterKey(keyCode) {
  if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
    return true;
  }

  if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
    return true;
  }

  if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
    return true;
  }

  // Safari sends zero key code for non-latin characters.
  if (window.navigation.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
    return true;
  }

  switch (keyCode) {
    case KeyCode.SPACE:
    case KeyCode.QUESTION_MARK:
    case KeyCode.NUM_PLUS:
    case KeyCode.NUM_MINUS:
    case KeyCode.NUM_PERIOD:
    case KeyCode.NUM_DIVISION:
    case KeyCode.SEMICOLON:
    case KeyCode.DASH:
    case KeyCode.EQUALS:
    case KeyCode.COMMA:
    case KeyCode.PERIOD:
    case KeyCode.SLASH:
    case KeyCode.APOSTROPHE:
    case KeyCode.SINGLE_QUOTE:
    case KeyCode.OPEN_SQUARE_BRACKET:
    case KeyCode.BACKSLASH:
    case KeyCode.CLOSE_SQUARE_BRACKET:
      return true;
    default:
      return false;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (KeyCode);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shallowequal__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_Track__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_createSlider__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(70);




/* eslint-disable react/prop-types */









var Range = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Range, _React$Component);

  function Range(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Range);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.onEnd = function () {
      _this.setState({ handle: null });
      _this.removeDocumentEvents();
      _this.props.onAfterChange(_this.getValue());
    };

    var count = props.count,
        min = props.min,
        max = props.max;

    var initialValue = Array.apply(null, Array(count + 1)).map(function () {
      return min;
    });
    var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
    var value = props.value !== undefined ? props.value : defaultValue;
    var bounds = value.map(function (v, i) {
      return _this.trimAlignValue(v, i);
    });
    var recent = bounds[0] === max ? 0 : bounds.length - 1;

    _this.state = {
      handle: null,
      recent: recent,
      bounds: bounds
    };
    return _this;
  }

  Range.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    if (!('value' in nextProps || 'min' in nextProps || 'max' in nextProps)) return;
    if (this.props.min === nextProps.min && this.props.max === nextProps.max && __WEBPACK_IMPORTED_MODULE_7_shallowequal___default()(this.props.value, nextProps.value)) {
      return;
    }

    var bounds = this.state.bounds;

    var value = nextProps.value || bounds;
    var nextBounds = value.map(function (v, i) {
      return _this2.trimAlignValue(v, i, nextProps);
    });
    if (nextBounds.length === bounds.length && nextBounds.every(function (v, i) {
      return v === bounds[i];
    })) return;

    this.setState({ bounds: nextBounds });
    if (bounds.some(function (v) {
      return __WEBPACK_IMPORTED_MODULE_11__utils__["i" /* isValueOutOfRange */](v, nextProps);
    })) {
      this.props.onChange(nextBounds);
    }
  };

  Range.prototype.onChange = function onChange(state) {
    var props = this.props;
    var isNotControlled = !('value' in props);
    if (isNotControlled) {
      this.setState(state);
    } else if (state.handle !== undefined) {
      this.setState({ handle: state.handle });
    }

    var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.state, state);
    var changedValue = data.bounds;
    props.onChange(changedValue);
  };

  Range.prototype.onStart = function onStart(position) {
    var props = this.props;
    var state = this.state;
    var bounds = this.getValue();
    props.onBeforeChange(bounds);

    var value = this.calcValueByPos(position);
    this.startValue = value;
    this.startPosition = position;

    var closestBound = this.getClosestBound(value);
    var boundNeedMoving = this.getBoundNeedMoving(value, closestBound);

    this.setState({
      handle: boundNeedMoving,
      recent: boundNeedMoving
    });

    var prevValue = bounds[boundNeedMoving];
    if (value === prevValue) return;

    var nextBounds = [].concat(state.bounds);
    nextBounds[boundNeedMoving] = value;
    this.onChange({ bounds: nextBounds });
  };

  Range.prototype.onMove = function onMove(e, position) {
    __WEBPACK_IMPORTED_MODULE_11__utils__["j" /* pauseEvent */](e);
    var props = this.props;
    var state = this.state;

    var value = this.calcValueByPos(position);
    var oldValue = state.bounds[state.handle];
    if (value === oldValue) return;

    var nextBounds = [].concat(state.bounds);
    nextBounds[state.handle] = value;
    var nextHandle = state.handle;
    if (props.pushable !== false) {
      this.pushSurroundingHandles(nextBounds, nextHandle);
    } else if (props.allowCross) {
      nextBounds.sort(function (a, b) {
        return a - b;
      });
      nextHandle = nextBounds.indexOf(value);
    }
    this.onChange({
      handle: nextHandle,
      bounds: nextBounds
    });
  };

  Range.prototype.onKeyboard = function onKeyboard() {
    __WEBPACK_IMPORTED_MODULE_8_warning___default()(true, 'Keyboard support is not yet supported for ranges.');
  };

  Range.prototype.getValue = function getValue() {
    return this.state.bounds;
  };

  Range.prototype.getClosestBound = function getClosestBound(value) {
    var bounds = this.state.bounds;

    var closestBound = 0;
    for (var i = 1; i < bounds.length - 1; ++i) {
      if (value > bounds[i]) {
        closestBound = i;
      }
    }
    if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) {
      closestBound = closestBound + 1;
    }
    return closestBound;
  };

  Range.prototype.getBoundNeedMoving = function getBoundNeedMoving(value, closestBound) {
    var _state = this.state,
        bounds = _state.bounds,
        recent = _state.recent;

    var boundNeedMoving = closestBound;
    var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];

    if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) {
      boundNeedMoving = recent;
    }

    if (isAtTheSamePoint && value !== bounds[closestBound + 1]) {
      boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
    }
    return boundNeedMoving;
  };

  Range.prototype.getLowerBound = function getLowerBound() {
    return this.state.bounds[0];
  };

  Range.prototype.getUpperBound = function getUpperBound() {
    var bounds = this.state.bounds;

    return bounds[bounds.length - 1];
  };

  /**
   * Returns an array of possible slider points, taking into account both
   * `marks` and `step`. The result is cached.
   */


  Range.prototype.getPoints = function getPoints() {
    var _props = this.props,
        marks = _props.marks,
        step = _props.step,
        min = _props.min,
        max = _props.max;

    var cache = this._getPointsCache;
    if (!cache || cache.marks !== marks || cache.step !== step) {
      var pointsObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, marks);
      if (step !== null) {
        for (var point = min; point <= max; point += step) {
          pointsObject[point] = point;
        }
      }
      var points = Object.keys(pointsObject).map(parseFloat);
      points.sort(function (a, b) {
        return a - b;
      });
      this._getPointsCache = { marks: marks, step: step, points: points };
    }
    return this._getPointsCache.points;
  };

  Range.prototype.pushSurroundingHandles = function pushSurroundingHandles(bounds, handle) {
    var value = bounds[handle];
    var threshold = this.props.pushable;

    threshold = Number(threshold);

    var direction = 0;
    if (bounds[handle + 1] - value < threshold) {
      direction = +1; // push to right
    }
    if (value - bounds[handle - 1] < threshold) {
      direction = -1; // push to left
    }

    if (direction === 0) {
      return;
    }

    var nextHandle = handle + direction;
    var diffToNext = direction * (bounds[nextHandle] - value);
    if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
      // revert to original value if pushing is impossible
      bounds[handle] = bounds[nextHandle] - direction * threshold;
    }
  };

  Range.prototype.pushHandle = function pushHandle(bounds, handle, direction, amount) {
    var originalValue = bounds[handle];
    var currentValue = bounds[handle];
    while (direction * (currentValue - originalValue) < amount) {
      if (!this.pushHandleOnePoint(bounds, handle, direction)) {
        // can't push handle enough to create the needed `amount` gap, so we
        // revert its position to the original value
        bounds[handle] = originalValue;
        return false;
      }
      currentValue = bounds[handle];
    }
    // the handle was pushed enough to create the needed `amount` gap
    return true;
  };

  Range.prototype.pushHandleOnePoint = function pushHandleOnePoint(bounds, handle, direction) {
    var points = this.getPoints();
    var pointIndex = points.indexOf(bounds[handle]);
    var nextPointIndex = pointIndex + direction;
    if (nextPointIndex >= points.length || nextPointIndex < 0) {
      // reached the minimum or maximum available point, can't push anymore
      return false;
    }
    var nextHandle = handle + direction;
    var nextValue = points[nextPointIndex];
    var threshold = this.props.pushable;

    var diffToNext = direction * (bounds[nextHandle] - nextValue);
    if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
      // couldn't push next handle, so we won't push this one either
      return false;
    }
    // push the handle
    bounds[handle] = nextValue;
    return true;
  };

  Range.prototype.trimAlignValue = function trimAlignValue(v, handle) {
    var nextProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var mergedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, nextProps);
    var valInRange = __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* ensureValueInRange */](v, mergedProps);
    var valNotConflict = this.ensureValueNotConflict(handle, valInRange, mergedProps);
    return __WEBPACK_IMPORTED_MODULE_11__utils__["b" /* ensureValuePrecision */](valNotConflict, mergedProps);
  };

  Range.prototype.ensureValueNotConflict = function ensureValueNotConflict(handle, val, _ref) {
    var allowCross = _ref.allowCross,
        thershold = _ref.pushable;

    var state = this.state || {};
    var bounds = state.bounds;

    handle = handle === undefined ? state.handle : handle;
    thershold = Number(thershold);
    /* eslint-disable eqeqeq */
    if (!allowCross && handle != null && bounds !== undefined) {
      if (handle > 0 && val <= bounds[handle - 1] + thershold) {
        return bounds[handle - 1] + thershold;
      }
      if (handle < bounds.length - 1 && val >= bounds[handle + 1] - thershold) {
        return bounds[handle + 1] - thershold;
      }
    }
    /* eslint-enable eqeqeq */
    return val;
  };

  Range.prototype.render = function render() {
    var _this3 = this;

    var _state2 = this.state,
        handle = _state2.handle,
        bounds = _state2.bounds;
    var _props2 = this.props,
        prefixCls = _props2.prefixCls,
        vertical = _props2.vertical,
        included = _props2.included,
        disabled = _props2.disabled,
        min = _props2.min,
        max = _props2.max,
        handleGenerator = _props2.handle,
        trackStyle = _props2.trackStyle,
        handleStyle = _props2.handleStyle,
        tabIndex = _props2.tabIndex;


    var offsets = bounds.map(function (v) {
      return _this3.calcOffset(v);
    });

    var handleClassName = prefixCls + '-handle';
    var handles = bounds.map(function (v, i) {
      var _classNames;

      return handleGenerator({
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()((_classNames = {}, _classNames[handleClassName] = true, _classNames[handleClassName + '-' + (i + 1)] = true, _classNames)),
        vertical: vertical,
        offset: offsets[i],
        value: v,
        dragging: handle === i,
        index: i,
        tabIndex: tabIndex[i] || 0,
        min: min,
        max: max,
        disabled: disabled,
        style: handleStyle[i],
        ref: function ref(h) {
          return _this3.saveHandle(i, h);
        }
      });
    });

    var tracks = bounds.slice(0, -1).map(function (_, index) {
      var _classNames2;

      var i = index + 1;
      var trackClassName = __WEBPACK_IMPORTED_MODULE_6_classnames___default()((_classNames2 = {}, _classNames2[prefixCls + '-track'] = true, _classNames2[prefixCls + '-track-' + i] = true, _classNames2));
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_Track__["a" /* default */], {
        className: trackClassName,
        vertical: vertical,
        included: included,
        offset: offsets[i - 1],
        length: offsets[i] - offsets[i - 1],
        style: trackStyle[index],
        key: i
      });
    });

    return { tracks: tracks, handles: handles };
  };

  return Range;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Range.displayName = 'Range';
Range.propTypes = {
  defaultValue: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number),
  value: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number),
  count: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  pushable: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number]),
  allowCross: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  tabIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number)
};
Range.defaultProps = {
  count: 1,
  allowCross: true,
  pushable: false,
  tabIndex: []
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__common_createSlider__["a" /* default */])(Range));

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSliderWithTooltip;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_tooltip__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Handle__ = __webpack_require__(69);










function createSliderWithTooltip(Component) {
  var _class, _temp;

  return _temp = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ComponentWrapper, _React$Component);

    function ComponentWrapper(props) {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ComponentWrapper);

      var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

      _this.handleTooltipVisibleChange = function (index, visible) {
        _this.setState(function (prevState) {
          var _extends2;

          return {
            visibles: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, prevState.visibles, (_extends2 = {}, _extends2[index] = visible, _extends2))
          };
        });
      };

      _this.handleWithTooltip = function (_ref) {
        var value = _ref.value,
            dragging = _ref.dragging,
            index = _ref.index,
            disabled = _ref.disabled,
            restProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['value', 'dragging', 'index', 'disabled']);

        var _this$props = _this.props,
            tipFormatter = _this$props.tipFormatter,
            tipProps = _this$props.tipProps,
            handleStyle = _this$props.handleStyle;

        var _tipProps$prefixCls = tipProps.prefixCls,
            prefixCls = _tipProps$prefixCls === undefined ? 'rc-slider-tooltip' : _tipProps$prefixCls,
            _tipProps$overlay = tipProps.overlay,
            overlay = _tipProps$overlay === undefined ? tipFormatter(value) : _tipProps$overlay,
            _tipProps$placement = tipProps.placement,
            placement = _tipProps$placement === undefined ? 'top' : _tipProps$placement,
            _tipProps$visible = tipProps.visible,
            visible = _tipProps$visible === undefined ? visible || false : _tipProps$visible,
            restTooltipProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(tipProps, ['prefixCls', 'overlay', 'placement', 'visible']);

        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_rc_tooltip__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, restTooltipProps, {
            prefixCls: prefixCls,
            overlay: overlay,
            placement: placement,
            visible: !disabled && (_this.state.visibles[index] || dragging) || visible,
            key: index
          }),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Handle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, restProps, {
            style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, handleStyle[0]),
            value: value,
            onMouseEnter: function onMouseEnter() {
              return _this.handleTooltipVisibleChange(index, true);
            },
            onMouseLeave: function onMouseLeave() {
              return _this.handleTooltipVisibleChange(index, false);
            }
          }))
        );
      };

      _this.state = { visibles: {} };
      return _this;
    }

    ComponentWrapper.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.props, { handle: this.handleWithTooltip }));
    };

    return ComponentWrapper;
  }(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component), _class.propTypes = {
    tipFormatter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    handleStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object),
    tipProps: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
  }, _class.defaultProps = {
    tipFormatter: function tipFormatter(value) {
      return value;
    },

    handleStyle: [{}],
    tipProps: {}
  }, _temp;
}

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip__ = __webpack_require__(316);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Tooltip__["a" /* default */]);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_trigger__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__placements__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Content__ = __webpack_require__(344);











var Tooltip = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tooltip, _Component);

  function Tooltip() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPopupElement = function () {
      var _this$props = _this.props,
          arrowContent = _this$props.arrowContent,
          overlay = _this$props.overlay,
          prefixCls = _this$props.prefixCls,
          id = _this$props.id;

      return [__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-arrow', key: 'arrow' },
        arrowContent
      ), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Content__["a" /* default */], {
        key: 'content',
        trigger: _this.trigger,
        prefixCls: prefixCls,
        id: id,
        overlay: overlay
      })];
    }, _this.saveTrigger = function (node) {
      _this.trigger = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Tooltip.prototype.getPopupDomNode = function getPopupDomNode() {
    return this.trigger.getPopupDomNode();
  };

  Tooltip.prototype.render = function render() {
    var _props = this.props,
        overlayClassName = _props.overlayClassName,
        trigger = _props.trigger,
        mouseEnterDelay = _props.mouseEnterDelay,
        mouseLeaveDelay = _props.mouseLeaveDelay,
        overlayStyle = _props.overlayStyle,
        prefixCls = _props.prefixCls,
        children = _props.children,
        onVisibleChange = _props.onVisibleChange,
        afterVisibleChange = _props.afterVisibleChange,
        transitionName = _props.transitionName,
        animation = _props.animation,
        placement = _props.placement,
        align = _props.align,
        destroyTooltipOnHide = _props.destroyTooltipOnHide,
        defaultVisible = _props.defaultVisible,
        getTooltipContainer = _props.getTooltipContainer,
        restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'afterVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);

    var extraProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, restProps);
    if ('visible' in this.props) {
      extraProps.popupVisible = this.props.visible;
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_rc_trigger__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        popupClassName: overlayClassName,
        ref: this.saveTrigger,
        prefixCls: prefixCls,
        popup: this.getPopupElement,
        action: trigger,
        builtinPlacements: __WEBPACK_IMPORTED_MODULE_8__placements__["a" /* placements */],
        popupPlacement: placement,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltipOnHide,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
      }, extraProps),
      children
    );
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Tooltip.propTypes = {
  trigger: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  defaultVisible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  placement: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  onVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  afterVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  overlay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]).isRequired,
  overlayStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  overlayClassName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  getTooltipContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  destroyTooltipOnHide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  align: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  arrowContent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
Tooltip.defaultProps = {
  prefixCls: 'rc-tooltip',
  mouseEnterDelay: 0,
  destroyTooltipOnHide: false,
  mouseLeaveDelay: 0.1,
  align: {},
  placement: 'right',
  trigger: ['hover'],
  arrowContent: null
};


/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Popup__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_ContainerRender__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rc_util_es_Portal__ = __webpack_require__(342);














function noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument() {
  return window.document;
}

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];

var IS_REACT_16 = !!__WEBPACK_IMPORTED_MODULE_6_react_dom__["createPortal"];

var Trigger = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Trigger, _React$Component);

  function Trigger(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Trigger);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var popupVisible = void 0;
    if ('popupVisible' in props) {
      popupVisible = !!props.popupVisible;
    } else {
      popupVisible = !!props.defaultPopupVisible;
    }

    _this.prevPopupVisible = popupVisible;

    _this.state = {
      popupVisible: popupVisible
    };
    return _this;
  }

  Trigger.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    ALL_HANDLERS.forEach(function (h) {
      _this2['fire' + h] = function (e) {
        _this2.fireEvents(h, e);
      };
    });
  };

  Trigger.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  };

  Trigger.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var popupVisible = _ref.popupVisible;

    if (popupVisible !== undefined) {
      this.setState({
        popupVisible: popupVisible
      });
    }
  };

  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
    var props = this.props;
    var state = this.state;
    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
      if (prevState.popupVisible !== state.popupVisible) {
        props.afterPopupVisibleChange(state.popupVisible);
      }
    };
    if (!IS_REACT_16) {
      this.renderComponent(null, triggerAfterPopupVisibleChange);
    }

    this.prevPopupVisible = prevState.popupVisible;

    // We must listen to `mousedown` or `touchstart`, edge case:
    // https://github.com/ant-design/ant-design/issues/5804
    // https://github.com/react-component/calendar/issues/250
    // https://github.com/react-component/trigger/issues/50
    if (state.popupVisible) {
      var currentDocument = void 0;
      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
        currentDocument = props.getDocument();
        this.clickOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'mousedown', this.onDocumentClick);
      }
      // always hide on mobile
      if (!this.touchOutsideHandler) {
        currentDocument = currentDocument || props.getDocument();
        this.touchOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'touchstart', this.onDocumentClick);
      }
      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
        currentDocument = currentDocument || props.getDocument();
        this.contextMenuOutsideHandler1 = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'scroll', this.onContextMenuClose);
      }
      // close popup when trigger type contains 'onContextMenu' and window is blur.
      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
        this.contextMenuOutsideHandler2 = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'blur', this.onContextMenuClose);
      }
      return;
    }

    this.clearOutsideHandler();
  };

  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearDelayTimer();
    this.clearOutsideHandler();
  };

  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
    // for test
    if (this._component && this._component.getPopupDomNode) {
      return this._component.getPopupDomNode();
    }
    return null;
  };

  Trigger.prototype.getPopupAlign = function getPopupAlign() {
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        popupAlign = props.popupAlign,
        builtinPlacements = props.builtinPlacements;

    if (popupPlacement && builtinPlacements) {
      return Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* getAlignFromPlacement */])(builtinPlacements, popupPlacement, popupAlign);
    }
    return popupAlign;
  };

  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible) {
    this.clearDelayTimer();
    if (this.state.popupVisible !== popupVisible) {
      if (!('popupVisible' in this.props)) {
        this.setState({
          popupVisible: popupVisible
        });
      }
      this.props.onPopupVisibleChange(popupVisible);
    }
  };

  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS) {
    var _this3 = this;

    var delay = delayS * 1000;
    this.clearDelayTimer();
    if (delay) {
      this.delayTimer = setTimeout(function () {
        _this3.setPopupVisible(visible);
        _this3.clearDelayTimer();
      }, delay);
    } else {
      this.setPopupVisible(visible);
    }
  };

  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  };

  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
    if (this.clickOutsideHandler) {
      this.clickOutsideHandler.remove();
      this.clickOutsideHandler = null;
    }

    if (this.contextMenuOutsideHandler1) {
      this.contextMenuOutsideHandler1.remove();
      this.contextMenuOutsideHandler1 = null;
    }

    if (this.contextMenuOutsideHandler2) {
      this.contextMenuOutsideHandler2.remove();
      this.contextMenuOutsideHandler2 = null;
    }

    if (this.touchOutsideHandler) {
      this.touchOutsideHandler.remove();
      this.touchOutsideHandler = null;
    }
  };

  Trigger.prototype.createTwoChains = function createTwoChains(event) {
    var childPros = this.props.children.props;
    var props = this.props;
    if (childPros[event] && props[event]) {
      return this['fire' + event];
    }
    return childPros[event] || props[event];
  };

  Trigger.prototype.isClickToShow = function isClickToShow() {
    var _props = this.props,
        action = _props.action,
        showAction = _props.showAction;

    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
    var _props2 = this.props,
        action = _props2.action,
        showAction = _props2.showAction;

    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
  };

  Trigger.prototype.isClickToHide = function isClickToHide() {
    var _props3 = this.props,
        action = _props3.action,
        hideAction = _props3.hideAction;

    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
    var _props4 = this.props,
        action = _props4.action,
        showAction = _props4.showAction;

    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
  };

  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
    var _props5 = this.props,
        action = _props5.action,
        hideAction = _props5.hideAction;

    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
  };

  Trigger.prototype.isFocusToShow = function isFocusToShow() {
    var _props6 = this.props,
        action = _props6.action,
        showAction = _props6.showAction;

    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
  };

  Trigger.prototype.isBlurToHide = function isBlurToHide() {
    var _props7 = this.props,
        action = _props7.action,
        hideAction = _props7.hideAction;

    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
  };

  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
    if (this.state.popupVisible && this._component && this._component.alignInstance) {
      this._component.alignInstance.forceAlign();
    }
  };

  Trigger.prototype.fireEvents = function fireEvents(type, e) {
    var childCallback = this.props.children.props[type];
    if (childCallback) {
      childCallback(e);
    }
    var callback = this.props[type];
    if (callback) {
      callback(e);
    }
  };

  Trigger.prototype.close = function close() {
    this.setPopupVisible(false);
  };

  Trigger.prototype.render = function render() {
    var _this4 = this;

    var popupVisible = this.state.popupVisible;

    var props = this.props;
    var children = props.children;
    var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
    var newChildProps = { key: 'trigger' };

    if (this.isContextMenuToShow()) {
      newChildProps.onContextMenu = this.onContextMenu;
    } else {
      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
    }

    if (this.isClickToHide() || this.isClickToShow()) {
      newChildProps.onClick = this.onClick;
      newChildProps.onMouseDown = this.onMouseDown;
      newChildProps.onTouchStart = this.onTouchStart;
    } else {
      newChildProps.onClick = this.createTwoChains('onClick');
      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
    }
    if (this.isMouseEnterToShow()) {
      newChildProps.onMouseEnter = this.onMouseEnter;
    } else {
      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
    }
    if (this.isMouseLeaveToHide()) {
      newChildProps.onMouseLeave = this.onMouseLeave;
    } else {
      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
    }
    if (this.isFocusToShow() || this.isBlurToHide()) {
      newChildProps.onFocus = this.onFocus;
      newChildProps.onBlur = this.onBlur;
    } else {
      newChildProps.onFocus = this.createTwoChains('onFocus');
      newChildProps.onBlur = this.createTwoChains('onBlur');
    }

    var trigger = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newChildProps);

    if (!IS_REACT_16) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_rc_util_es_ContainerRender__["a" /* default */],
        {
          parent: this,
          visible: popupVisible,
          autoMount: false,
          forceRender: props.forceRender,
          getComponent: this.getComponent,
          getContainer: this.getContainer
        },
        function (_ref2) {
          var renderComponent = _ref2.renderComponent;

          _this4.renderComponent = renderComponent;
          return trigger;
        }
      );
    }

    var portal = void 0;
    // prevent unmounting after it's rendered
    if (popupVisible || this._component || props.forceRender) {
      portal = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12_rc_util_es_Portal__["a" /* default */],
        {
          key: 'portal',
          getContainer: this.getContainer,
          didUpdate: this.handlePortalUpdate
        },
        this.getComponent()
      );
    }

    return [trigger, portal];
  };

  return Trigger;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Trigger.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  action: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string)]),
  showAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  hideAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  getPopupClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  onPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  afterPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]).isRequired,
  popupStyle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupPlacement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  builtinPlacements: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  popupAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  zIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  focusDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  blurDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getDocument: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  forceRender: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  mask: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskClosable: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onPopupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  defaultPopupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  maskAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};
Trigger.defaultProps = {
  prefixCls: 'rc-trigger-popup',
  getPopupClassNameFromAlign: returnEmptyString,
  getDocument: returnDocument,
  onPopupVisibleChange: noop,
  afterPopupVisibleChange: noop,
  onPopupAlign: noop,
  popupClassName: '',
  mouseEnterDelay: 0,
  mouseLeaveDelay: 0.1,
  focusDelay: 0,
  blurDelay: 0.15,
  popupStyle: {},
  destroyPopupOnHide: false,
  popupAlign: {},
  defaultPopupVisible: false,
  mask: false,
  maskClosable: true,
  action: [],
  showAction: [],
  hideAction: []
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.onMouseEnter = function (e) {
    _this5.fireEvents('onMouseEnter', e);
    _this5.delaySetPopupVisible(true, _this5.props.mouseEnterDelay);
  };

  this.onMouseLeave = function (e) {
    _this5.fireEvents('onMouseLeave', e);
    _this5.delaySetPopupVisible(false, _this5.props.mouseLeaveDelay);
  };

  this.onPopupMouseEnter = function () {
    _this5.clearDelayTimer();
  };

  this.onPopupMouseLeave = function (e) {
    // https://github.com/react-component/trigger/pull/13
    // react bug?
    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this5._component && _this5._component.getPopupDomNode && Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__["a" /* default */])(_this5._component.getPopupDomNode(), e.relatedTarget)) {
      return;
    }
    _this5.delaySetPopupVisible(false, _this5.props.mouseLeaveDelay);
  };

  this.onFocus = function (e) {
    _this5.fireEvents('onFocus', e);
    // incase focusin and focusout
    _this5.clearDelayTimer();
    if (_this5.isFocusToShow()) {
      _this5.focusTime = Date.now();
      _this5.delaySetPopupVisible(true, _this5.props.focusDelay);
    }
  };

  this.onMouseDown = function (e) {
    _this5.fireEvents('onMouseDown', e);
    _this5.preClickTime = Date.now();
  };

  this.onTouchStart = function (e) {
    _this5.fireEvents('onTouchStart', e);
    _this5.preTouchTime = Date.now();
  };

  this.onBlur = function (e) {
    _this5.fireEvents('onBlur', e);
    _this5.clearDelayTimer();
    if (_this5.isBlurToHide()) {
      _this5.delaySetPopupVisible(false, _this5.props.blurDelay);
    }
  };

  this.onContextMenu = function (e) {
    e.preventDefault();
    _this5.fireEvents('onContextMenu', e);
    _this5.setPopupVisible(true);
  };

  this.onContextMenuClose = function () {
    if (_this5.isContextMenuToShow()) {
      _this5.close();
    }
  };

  this.onClick = function (event) {
    _this5.fireEvents('onClick', event);
    // focus will trigger click
    if (_this5.focusTime) {
      var preTime = void 0;
      if (_this5.preClickTime && _this5.preTouchTime) {
        preTime = Math.min(_this5.preClickTime, _this5.preTouchTime);
      } else if (_this5.preClickTime) {
        preTime = _this5.preClickTime;
      } else if (_this5.preTouchTime) {
        preTime = _this5.preTouchTime;
      }
      if (Math.abs(preTime - _this5.focusTime) < 20) {
        return;
      }
      _this5.focusTime = 0;
    }
    _this5.preClickTime = 0;
    _this5.preTouchTime = 0;
    event.preventDefault();
    var nextVisible = !_this5.state.popupVisible;
    if (_this5.isClickToHide() && !nextVisible || nextVisible && _this5.isClickToShow()) {
      _this5.setPopupVisible(!_this5.state.popupVisible);
    }
  };

  this.onDocumentClick = function (event) {
    if (_this5.props.mask && !_this5.props.maskClosable) {
      return;
    }
    var target = event.target;
    var root = Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this5);
    var popupNode = _this5.getPopupDomNode();
    if (!Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__["a" /* default */])(root, target) && !Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_contains__["a" /* default */])(popupNode, target)) {
      _this5.close();
    }
  };

  this.getRootDomNode = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this5);
  };

  this.getPopupClassNameFromAlign = function (align) {
    var className = [];
    var props = _this5.props;
    var popupPlacement = props.popupPlacement,
        builtinPlacements = props.builtinPlacements,
        prefixCls = props.prefixCls;

    if (popupPlacement && builtinPlacements) {
      className.push(Object(__WEBPACK_IMPORTED_MODULE_10__utils__["b" /* getPopupClassNameFromAlign */])(builtinPlacements, prefixCls, align));
    }
    if (props.getPopupClassNameFromAlign) {
      className.push(props.getPopupClassNameFromAlign(align));
    }
    return className.join(' ');
  };

  this.getComponent = function () {
    var _props8 = _this5.props,
        prefixCls = _props8.prefixCls,
        destroyPopupOnHide = _props8.destroyPopupOnHide,
        popupClassName = _props8.popupClassName,
        action = _props8.action,
        onPopupAlign = _props8.onPopupAlign,
        popupAnimation = _props8.popupAnimation,
        popupTransitionName = _props8.popupTransitionName,
        popupStyle = _props8.popupStyle,
        mask = _props8.mask,
        maskAnimation = _props8.maskAnimation,
        maskTransitionName = _props8.maskTransitionName,
        zIndex = _props8.zIndex,
        popup = _props8.popup,
        stretch = _props8.stretch;
    var state = _this5.state;


    var align = _this5.getPopupAlign();

    var mouseProps = {};
    if (_this5.isMouseEnterToShow()) {
      mouseProps.onMouseEnter = _this5.onPopupMouseEnter;
    }
    if (_this5.isMouseLeaveToHide()) {
      mouseProps.onMouseLeave = _this5.onPopupMouseLeave;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__Popup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        prefixCls: prefixCls,
        destroyPopupOnHide: destroyPopupOnHide,
        visible: state.popupVisible,
        className: popupClassName,
        action: action,
        align: align,
        onAlign: onPopupAlign,
        animation: popupAnimation,
        getClassNameFromAlign: _this5.getPopupClassNameFromAlign
      }, mouseProps, {
        stretch: stretch,
        getRootDomNode: _this5.getRootDomNode,
        style: popupStyle,
        mask: mask,
        zIndex: zIndex,
        transitionName: popupTransitionName,
        maskAnimation: maskAnimation,
        maskTransitionName: maskTransitionName,
        ref: _this5.savePopup
      }),
      typeof popup === 'function' ? popup() : popup
    );
  };

  this.getContainer = function () {
    var props = _this5.props;

    var popupContainer = document.createElement('div');
    // Make sure default popup container will never cause scrollbar appearing
    // https://github.com/react-component/trigger/issues/41
    popupContainer.style.position = 'absolute';
    popupContainer.style.top = '0';
    popupContainer.style.left = '0';
    popupContainer.style.width = '100%';
    var mountNode = props.getPopupContainer ? props.getPopupContainer(Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this5)) : props.getDocument().body;
    mountNode.appendChild(popupContainer);
    return popupContainer;
  };

  this.handlePortalUpdate = function () {
    if (_this5.prevPopupVisible !== _this5.state.popupVisible) {
      _this5.props.afterPopupVisibleChange(_this5.state.popupVisible);
    }
  };

  this.savePopup = function (node) {
    _this5._component = node;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Trigger);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
function contains(root, n) {
  var node = n;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }

  return false;
}

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_align__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_animate__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PopupInner__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(117);













var Popup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Popup, _Component);

  function Popup(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Popup);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      // Used for stretch
      stretchChecked: false,
      targetWidth: undefined,
      targetHeight: undefined
    };

    _this.savePopupRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'popupInstance');
    _this.saveAlignRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'alignInstance');
    return _this;
  }

  Popup.prototype.componentDidMount = function componentDidMount() {
    this.rootNode = this.getPopupDomNode();
    this.setStretchSize();
  };

  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
    this.setStretchSize();
  };

  // Record size if stretch needed


  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
    return __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.popupInstance);
  };

  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
    var props = this.props;
    var transitionName = props.maskTransitionName;
    var animation = props.maskAnimation;
    if (!transitionName && animation) {
      transitionName = props.prefixCls + '-' + animation;
    }
    return transitionName;
  };

  Popup.prototype.getTransitionName = function getTransitionName() {
    var props = this.props;
    var transitionName = props.transitionName;
    if (!transitionName && props.animation) {
      transitionName = props.prefixCls + '-' + props.animation;
    }
    return transitionName;
  };

  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
  };

  Popup.prototype.getPopupElement = function getPopupElement() {
    var _this2 = this;

    var savePopupRef = this.savePopupRef;
    var _state = this.state,
        stretchChecked = _state.stretchChecked,
        targetHeight = _state.targetHeight,
        targetWidth = _state.targetWidth;
    var _props = this.props,
        align = _props.align,
        visible = _props.visible,
        prefixCls = _props.prefixCls,
        style = _props.style,
        getClassNameFromAlign = _props.getClassNameFromAlign,
        destroyPopupOnHide = _props.destroyPopupOnHide,
        stretch = _props.stretch,
        children = _props.children,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave;

    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
    var hiddenClassName = prefixCls + '-hidden';

    if (!visible) {
      this.currentAlignClassName = null;
    }

    var sizeStyle = {};
    if (stretch) {
      // Stretch with target
      if (stretch.indexOf('height') !== -1) {
        sizeStyle.height = targetHeight;
      } else if (stretch.indexOf('minHeight') !== -1) {
        sizeStyle.minHeight = targetHeight;
      }
      if (stretch.indexOf('width') !== -1) {
        sizeStyle.width = targetWidth;
      } else if (stretch.indexOf('minWidth') !== -1) {
        sizeStyle.minWidth = targetWidth;
      }

      // Delay force align to makes ui smooth
      if (!stretchChecked) {
        sizeStyle.visibility = 'hidden';
        setTimeout(function () {
          _this2.alignInstance.forceAlign();
        }, 0);
      }
    }

    var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, sizeStyle, style, this.getZIndexStyle());

    var popupInnerProps = {
      className: className,
      prefixCls: prefixCls,
      ref: savePopupRef,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      style: newStyle
    };
    if (destroyPopupOnHide) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
        {
          component: '',
          exclusive: true,
          transitionAppear: true,
          transitionName: this.getTransitionName()
        },
        visible ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
          {
            target: this.getTarget,
            key: 'popup',
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            align: align,
            onAlign: this.onAlign
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              visible: true
            }, popupInnerProps),
            children
          )
        ) : null
      );
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
      {
        component: '',
        exclusive: true,
        transitionAppear: true,
        transitionName: this.getTransitionName(),
        showProp: 'xVisible'
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
        {
          target: this.getTarget,
          key: 'popup',
          ref: this.saveAlignRef,
          monitorWindowResize: true,
          xVisible: visible,
          childrenProps: { visible: 'xVisible' },
          disabled: !visible,
          align: align,
          onAlign: this.onAlign
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            hiddenClassName: hiddenClassName
          }, popupInnerProps),
          children
        )
      )
    );
  };

  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
    var style = {};
    var props = this.props;
    if (props.zIndex !== undefined) {
      style.zIndex = props.zIndex;
    }
    return style;
  };

  Popup.prototype.getMaskElement = function getMaskElement() {
    var props = this.props;
    var maskElement = void 0;
    if (props.mask) {
      var maskTransition = this.getMaskTransitionName();
      maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__["a" /* default */], {
        style: this.getZIndexStyle(),
        key: 'mask',
        className: props.prefixCls + '-mask',
        hiddenClassName: props.prefixCls + '-mask-hidden',
        visible: props.visible
      });
      if (maskTransition) {
        maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
          {
            key: 'mask',
            showProp: 'visible',
            transitionAppear: true,
            component: '',
            transitionName: maskTransition
          },
          maskElement
        );
      }
    }
    return maskElement;
  };

  Popup.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      null,
      this.getMaskElement(),
      this.getPopupElement()
    );
  };

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Popup.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  getClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getRootDomNode: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onAlign = function (popupDomNode, align) {
    var props = _this3.props;
    var currentAlignClassName = props.getClassNameFromAlign(align);
    // FIX: https://github.com/react-component/trigger/issues/56
    // FIX: https://github.com/react-component/tooltip/issues/79
    if (_this3.currentAlignClassName !== currentAlignClassName) {
      _this3.currentAlignClassName = currentAlignClassName;
      popupDomNode.className = _this3.getClassName(currentAlignClassName);
    }
    props.onAlign(popupDomNode, align);
  };

  this.setStretchSize = function () {
    var _props2 = _this3.props,
        stretch = _props2.stretch,
        getRootDomNode = _props2.getRootDomNode,
        visible = _props2.visible;
    var _state2 = _this3.state,
        stretchChecked = _state2.stretchChecked,
        targetHeight = _state2.targetHeight,
        targetWidth = _state2.targetWidth;


    if (!stretch || !visible) {
      if (stretchChecked) {
        _this3.setState({ stretchChecked: false });
      }
      return;
    }

    var $ele = getRootDomNode();
    if (!$ele) return;

    var height = $ele.offsetHeight;
    var width = $ele.offsetWidth;

    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
      _this3.setState({
        stretchChecked: true,
        targetHeight: height,
        targetWidth: width
      });
    }
  };

  this.getTarget = function () {
    return _this3.props.getRootDomNode();
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Popup);

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Align__ = __webpack_require__(321);
// export this package's api

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Align__["a" /* default */]);

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_align__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_addEventListener__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shallowequal__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__isWindow__ = __webpack_require__(330);











function buffer(fn, ms) {
  var timer = void 0;

  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function bufferFn() {
    clear();
    timer = setTimeout(fn, ms);
  }

  bufferFn.clear = clear;

  return bufferFn;
}

var Align = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Align, _Component);

  function Align() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Align);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.forceAlign = function () {
      var props = _this.props;
      if (!props.disabled) {
        var source = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(_this);
        props.onAlign(source, Object(__WEBPACK_IMPORTED_MODULE_6_dom_align__["a" /* default */])(source, props.target(), props.align));
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Align.prototype.componentDidMount = function componentDidMount() {
    var props = this.props;
    // if parent ref not attached .... use document.getElementById
    this.forceAlign();
    if (!props.disabled && props.monitorWindowResize) {
      this.startMonitorWindowResize();
    }
  };

  Align.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var reAlign = false;
    var props = this.props;

    if (!props.disabled) {
      if (prevProps.disabled || !__WEBPACK_IMPORTED_MODULE_8_shallowequal___default()(prevProps.align, props.align)) {
        reAlign = true;
      } else {
        var lastTarget = prevProps.target();
        var currentTarget = props.target();
        if (Object(__WEBPACK_IMPORTED_MODULE_9__isWindow__["a" /* default */])(lastTarget) && Object(__WEBPACK_IMPORTED_MODULE_9__isWindow__["a" /* default */])(currentTarget)) {
          reAlign = false;
        } else if (lastTarget !== currentTarget) {
          reAlign = true;
        }
      }
    }

    if (reAlign) {
      this.forceAlign();
    }

    if (props.monitorWindowResize && !props.disabled) {
      this.startMonitorWindowResize();
    } else {
      this.stopMonitorWindowResize();
    }
  };

  Align.prototype.componentWillUnmount = function componentWillUnmount() {
    this.stopMonitorWindowResize();
  };

  Align.prototype.startMonitorWindowResize = function startMonitorWindowResize() {
    if (!this.resizeHandler) {
      this.bufferMonitor = buffer(this.forceAlign, this.props.monitorBufferTime);
      this.resizeHandler = Object(__WEBPACK_IMPORTED_MODULE_7_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.bufferMonitor);
    }
  };

  Align.prototype.stopMonitorWindowResize = function stopMonitorWindowResize() {
    if (this.resizeHandler) {
      this.bufferMonitor.clear();
      this.resizeHandler.remove();
      this.resizeHandler = null;
    }
  };

  Align.prototype.render = function render() {
    var _props = this.props,
        childrenProps = _props.childrenProps,
        children = _props.children;

    var child = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(children);
    if (childrenProps) {
      var newProps = {};
      for (var prop in childrenProps) {
        if (childrenProps.hasOwnProperty(prop)) {
          newProps[prop] = this.props[childrenProps[prop]];
        }
      }
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, newProps);
    }
    return child;
  };

  return Align;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Align.propTypes = {
  childrenProps: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  align: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onAlign: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  monitorBufferTime: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  monitorWindowResize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};
Align.defaultProps = {
  target: function target() {
    return window;
  },
  onAlign: function onAlign() {},
  monitorBufferTime: 50,
  monitorWindowResize: false,
  disabled: false
};


/* harmony default export */ __webpack_exports__["a"] = (Align);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getOffsetParent__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getVisibleRectForElement__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__adjustForViewport__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getRegion__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getElFuturePos__ = __webpack_require__(328);
/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */








// http://yiminghe.iteye.com/blog/1124720

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}

function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}

function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}

function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}

function isOutOfVisibleRect(target) {
  var visibleRect = Object(__WEBPACK_IMPORTED_MODULE_2__getVisibleRectForElement__["a" /* default */])(target);
  var targetRegion = Object(__WEBPACK_IMPORTED_MODULE_4__getRegion__["a" /* default */])(target);

  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}

function flip(points, reg, map) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}

function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}

function convertOffset(str, offsetLen) {
  var n = void 0;
  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }
  return n || 0;
}

function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}

function domAlign(el, refNode, align) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var target = align.target || refNode;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  // 当前节点可以被放置的显示区域
  var visibleRect = Object(__WEBPACK_IMPORTED_MODULE_2__getVisibleRectForElement__["a" /* default */])(source);
  // 当前节点所占的区域, left/top/width/height
  var elRegion = Object(__WEBPACK_IMPORTED_MODULE_4__getRegion__["a" /* default */])(source);
  // 参照节点所占的区域, left/top/width/height
  var refNodeRegion = Object(__WEBPACK_IMPORTED_MODULE_4__getRegion__["a" /* default */])(target);
  // 将 offset 转换成数值，支持百分比
  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, refNodeRegion);
  // 当前节点将要被放置的位置
  var elFuturePos = Object(__WEBPACK_IMPORTED_MODULE_5__getElFuturePos__["a" /* default */])(elRegion, refNodeRegion, points, offset, targetOffset);
  // 当前节点将要所处的区域
  var newElRegion = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].merge(elRegion, elFuturePos);

  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target);

  // 如果可视区域不能完全放置当前节点时允许调整
  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTargetNotOutOfVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/ig, {
          l: 'r',
          r: 'l'
        });
        // 偏移量也反下
        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = Object(__WEBPACK_IMPORTED_MODULE_5__getElFuturePos__["a" /* default */])(elRegion, refNodeRegion, newPoints, newOffset, newTargetOffset);

        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }

    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/ig, {
          t: 'b',
          b: 't'
        });
        // 偏移量也反下
        var _newOffset = flipOffset(offset, 1);
        var _newTargetOffset = flipOffset(targetOffset, 1);
        var _newElFuturePos = Object(__WEBPACK_IMPORTED_MODULE_5__getElFuturePos__["a" /* default */])(elRegion, refNodeRegion, _newPoints, _newOffset, _newTargetOffset);

        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    }

    // 如果失败，重新计算当前节点将要被放置的位置
    if (fail) {
      elFuturePos = Object(__WEBPACK_IMPORTED_MODULE_5__getElFuturePos__["a" /* default */])(elRegion, refNodeRegion, points, offset, targetOffset);
      __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].mix(newElRegion, elFuturePos);
    }
    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
    // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数
    if (isStillFailX || isStillFailY) {
      points = align.points;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    }
    // 2. 只有指定了可以调整当前方向才调整
    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;

    // 确实要调整，甚至可能会调整高度宽度
    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = Object(__WEBPACK_IMPORTED_MODULE_3__adjustForViewport__["a" /* default */])(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  }

  // need judge to in case set fixed with in css on height auto element
  if (newElRegion.width !== elRegion.width) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(source, 'width', __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].width(source) + newElRegion.width - elRegion.width);
  }

  if (newElRegion.height !== elRegion.height) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(source, 'height', __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].height(source) + newElRegion.height - elRegion.height);
  }

  // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>
  __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform
  });

  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}

domAlign.__getOffsetParent = __WEBPACK_IMPORTED_MODULE_1__getOffsetParent__["a" /* default */];

domAlign.__getVisibleRectForElement = __WEBPACK_IMPORTED_MODULE_2__getVisibleRectForElement__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (domAlign);
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransformName;
/* harmony export (immutable) */ __webpack_exports__["e"] = setTransitionProperty;
/* harmony export (immutable) */ __webpack_exports__["c"] = getTransitionProperty;
/* harmony export (immutable) */ __webpack_exports__["b"] = getTransformXY;
/* harmony export (immutable) */ __webpack_exports__["d"] = setTransformXY;
var vendorPrefix = void 0;

var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};

function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }
  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';
  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }
  return vendorPrefix;
}

function getTransitionName() {
  return getVendorPrefix() ? getVendorPrefix() + 'TransitionProperty' : 'transitionProperty';
}

function getTransformName() {
  return getVendorPrefix() ? getVendorPrefix() + 'Transform' : 'transform';
}

function setTransitionProperty(node, value) {
  var name = getTransitionName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}

function setTransform(node, value) {
  var name = getTransformName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}

function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}

function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return { x: parseFloat(matrix[12] || matrix[4], 0), y: parseFloat(matrix[13] || matrix[5], 0) };
  }
  return {
    x: 0,
    y: 0
  };
}

var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;

function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var arr = void 0;
    var match2d = transform.match(matrix2d);
    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, 'matrix(' + arr.join(',') + ')');
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, 'matrix3d(' + arr.join(',') + ')');
    }
  } else {
    setTransform(node, 'translateX(' + xy.x + 'px) translateY(' + xy.y + 'px) translateZ(0)');
  }
}

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getOffsetParent__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isAncestorFixed__ = __webpack_require__(325);




/**
 * 获得元素的显示部分的区域
 */
function getVisibleRectForElement(element) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = Object(__WEBPACK_IMPORTED_MODULE_1__getOffsetParent__["a" /* default */])(element);
  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement;

  // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.
  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
    // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(el, 'overflow') !== 'visible') {
      var pos = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].offset(el);
      // add border
      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right,
      // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }
    el = Object(__WEBPACK_IMPORTED_MODULE_1__getOffsetParent__["a" /* default */])(el);
  }

  // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601
  var originalPosition = null;
  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(element, 'position');
    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }

  var scrollX = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollLeft(win);
  var scrollY = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollTop(win);
  var viewportWidth = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportWidth(win);
  var viewportHeight = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight;

  // Reset element position after calculate the visible area
  if (element.style) {
    element.style.position = originalPosition;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_2__isAncestorFixed__["a" /* default */])(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);

    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }

  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

/* harmony default export */ __webpack_exports__["a"] = (getVisibleRectForElement);

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isAncestorFixed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(23);


function isAncestorFixed(element) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(element) || element.nodeType === 9) {
    return false;
  }

  var doc = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getDocument(element);
  var body = doc.body;
  var parent = null;
  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
    var positionStyle = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].css(parent, 'position');
    if (positionStyle === 'fixed') {
      return true;
    }
  }
  return false;
}

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(23);


function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };

  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  }

  // Left edge inside and right edge outside viewport, try to resize it.
  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  }

  // Right edge outside viewport, try to move it.
  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  }

  // Top edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  }

  // Top edge inside and bottom edge outside viewport, try to resize it.
  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  }

  // Bottom edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }

  return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].mix(pos, size);
}

/* harmony default export */ __webpack_exports__["a"] = (adjustForViewport);

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(23);


function getRegion(node) {
  var offset = void 0;
  var w = void 0;
  var h = void 0;
  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].isWindow(node) && node.nodeType !== 9) {
    offset = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].offset(node);
    w = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].outerWidth(node);
    h = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].outerHeight(node);
  } else {
    var win = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindow(node);
    offset = {
      left: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollLeft(win),
      top: __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getWindowScrollTop(win)
    };
    w = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportWidth(win);
    h = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].viewportHeight(win);
  }
  offset.width = w;
  offset.height = h;
  return offset;
}

/* harmony default export */ __webpack_exports__["a"] = (getRegion);

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getAlignOffset__ = __webpack_require__(329);


function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = Object(__WEBPACK_IMPORTED_MODULE_0__getAlignOffset__["a" /* default */])(refNodeRegion, points[1]);
  var p2 = Object(__WEBPACK_IMPORTED_MODULE_0__getAlignOffset__["a" /* default */])(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];

  return {
    left: elRegion.left - diff[0] + offset[0] - targetOffset[0],
    top: elRegion.top - diff[1] + offset[1] - targetOffset[1]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getElFuturePos);

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */

function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;

  var x = region.left;
  var y = region.top;

  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }

  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }

  return {
    left: x,
    top: y
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getAlignOffset);

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isWindow;
function isWindow(obj) {
  /* eslint no-eq-null: 0 */
  /* eslint eqeqeq: 0 */
  return obj != null && obj == obj.window;
}

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AnimateChild__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util__ = __webpack_require__(115);










var defaultKey = 'rc_animate_' + Date.now();


function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["d" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                return _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else {
      if (type === 'appear') {
        if (__WEBPACK_IMPORTED_MODULE_10__util__["a" /* default */].allowAppearCallback(props)) {
          props.onAppear(key);
          props.onEnd(key, true);
        }
      } else {
        if (__WEBPACK_IMPORTED_MODULE_10__util__["a" /* default */].allowEnterCallback(props)) {
          props.onEnter(key);
          props.onEnd(key, true);
        }
      }
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_10__util__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["c" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Animate);

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(113);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(334);
var $Object = __webpack_require__(11).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(18);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(13), 'Object', { defineProperty: __webpack_require__(12).f });


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["c"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && nextChildrenPending.hasOwnProperty(child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_css_animation__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(115);











var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_9__util__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_9__util__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_9__util__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_8_css_animation__["b" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = Object(__WEBPACK_IMPORTED_MODULE_8_css_animation__["a" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["a"] = (cssAnimation);

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete EVENT_NAME_MAP.transitionend.transition;
  }

  for (var baseEventName in EVENT_NAME_MAP) {
    if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
      var baseEvents = EVENT_NAME_MAP[baseEventName];
      for (var styleName in baseEvents) {
        if (styleName in style) {
          endEvents.push(baseEvents[styleName]);
          break;
        }
      }
    }
  }
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },


  endEvents: endEvents,

  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(114);
} catch (err) {
  var index = __webpack_require__(114);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__ = __webpack_require__(116);







var PopupInner = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PopupInner, _Component);

  function PopupInner() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PopupInner);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  PopupInner.prototype.render = function render() {
    var props = this.props;
    var className = props.className;
    if (!props.visible) {
      className += ' ' + props.hiddenClassName;
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      {
        className: className,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        style: props.style
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__["a" /* default */],
        { className: props.prefixCls + '-content', visible: props.visible },
        props.children
      )
    );
  };

  return PopupInner;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

PopupInner.propTypes = {
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};


/* harmony default export */ __webpack_exports__["a"] = (PopupInner);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);








var ContainerRender = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ContainerRender, _React$Component);

  function ContainerRender() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ContainerRender);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ContainerRender.__proto__ || Object.getPrototypeOf(ContainerRender)).call.apply(_ref, [this].concat(args))), _this), _this.removeContainer = function () {
      if (_this.container) {
        __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unmountComponentAtNode(_this.container);
        _this.container.parentNode.removeChild(_this.container);
        _this.container = null;
      }
    }, _this.renderComponent = function (props, ready) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          getComponent = _this$props.getComponent,
          forceRender = _this$props.forceRender,
          getContainer = _this$props.getContainer,
          parent = _this$props.parent;

      if (visible || parent._component || forceRender) {
        if (!_this.container) {
          _this.container = getContainer();
        }
        __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
          if (ready) {
            ready.call(this);
          }
        });
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ContainerRender, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.autoDestroy) {
        this.removeContainer();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children({
        renderComponent: this.renderComponent,
        removeContainer: this.removeContainer
      });
    }
  }]);

  return ContainerRender;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ContainerRender.propTypes = {
  autoMount: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  autoDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  parent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  getComponent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  getContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired
};
ContainerRender.defaultProps = {
  autoMount: true,
  autoDestroy: true,
  forceRender: false
};
/* harmony default export */ __webpack_exports__["a"] = (ContainerRender);

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);








var Portal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Portal, _React$Component);

  function Portal() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Portal);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.createContainer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var didUpdate = this.props.didUpdate;

      if (didUpdate) {
        didUpdate(prevProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeContainer();
    }
  }, {
    key: 'createContainer',
    value: function createContainer() {
      this._container = this.props.getContainer();
      this.forceUpdate();
    }
  }, {
    key: 'removeContainer',
    value: function removeContainer() {
      if (this._container) {
        this._container.parentNode.removeChild(this._container);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this._container) {
        return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.createPortal(this.props.children, this._container);
      }
      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Portal.propTypes = {
  getContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node.isRequired,
  didUpdate: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return placements; });
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (placements);

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var Content = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Content, _React$Component);

  function Content() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Content);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Content.prototype.componentDidUpdate = function componentDidUpdate() {
    var trigger = this.props.trigger;

    if (trigger) {
      trigger.forcePopupAlign();
    }
  };

  Content.prototype.render = function render() {
    var _props = this.props,
        overlay = _props.overlay,
        prefixCls = _props.prefixCls,
        id = _props.id;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: prefixCls + '-inner', id: id },
      typeof overlay === 'function' ? overlay() : overlay
    );
  };

  return Content;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Content.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  overlay: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]).isRequired,
  id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  trigger: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (Content);

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module of mixed-in functions shared between node and client code
 */
var isObject = __webpack_require__(118);

/**
 * Expose `RequestBase`.
 */

module.exports = RequestBase;

/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */

function RequestBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in RequestBase.prototype) {
    obj[key] = RequestBase.prototype[key];
  }
  return obj;
}

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.clearTimeout = function _clearTimeout(){
  clearTimeout(this._timer);
  clearTimeout(this._responseTimeoutTimer);
  delete this._timer;
  delete this._responseTimeoutTimer;
  return this;
};

/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.parse = function parse(fn){
  this._parser = fn;
  return this;
};

/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.responseType = function(val){
  this._responseType = val;
  return this;
};

/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.serialize = function serialize(fn){
  this._serializer = fn;
  return this;
};

/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, deadline}
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.timeout = function timeout(options){
  if (!options || 'object' !== typeof options) {
    this._timeout = options;
    this._responseTimeout = 0;
    return this;
  }

  for(var option in options) {
    switch(option) {
      case 'deadline':
        this._timeout = options.deadline;
        break;
      case 'response':
        this._responseTimeout = options.response;
        break;
      default:
        console.warn("Unknown timeout option", option);
    }
  }
  return this;
};

/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @param {Function} [fn]
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.retry = function retry(count, fn){
  // Default to 1 if no count passed or true
  if (arguments.length === 0 || count === true) count = 1;
  if (count <= 0) count = 0;
  this._maxRetries = count;
  this._retries = 0;
  this._retryCallback = fn;
  return this;
};

var ERROR_CODES = [
  'ECONNRESET',
  'ETIMEDOUT',
  'EADDRINFO',
  'ESOCKETTIMEDOUT'
];

/**
 * Determine if a request should be retried.
 * (Borrowed from segmentio/superagent-retry)
 *
 * @param {Error} err
 * @param {Response} [res]
 * @returns {Boolean}
 */
RequestBase.prototype._shouldRetry = function(err, res) {
  if (!this._maxRetries || this._retries++ >= this._maxRetries) {
    return false;
  }
  if (this._retryCallback) {
    try {
      var override = this._retryCallback(err, res);
      if (override === true) return true;
      if (override === false) return false;
      // undefined falls back to defaults
    } catch(e) {
      console.error(e);
    }
  }
  if (res && res.status && res.status >= 500 && res.status != 501) return true;
  if (err) {
    if (err.code && ~ERROR_CODES.indexOf(err.code)) return true;
    // Superagent timeout
    if (err.timeout && err.code == 'ECONNABORTED') return true;
    if (err.crossDomain) return true;
  }
  return false;
};

/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */

RequestBase.prototype._retry = function() {

  this.clearTimeout();

  // node
  if (this.req) {
    this.req = null;
    this.req = this.request();
  }

  this._aborted = false;
  this.timedout = false;

  return this._end();
};

/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */

RequestBase.prototype.then = function then(resolve, reject) {
  if (!this._fullfilledPromise) {
    var self = this;
    if (this._endCalled) {
      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
    }
    this._fullfilledPromise = new Promise(function(innerResolve, innerReject) {
      self.end(function(err, res) {
        if (err) innerReject(err);
        else innerResolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
};

RequestBase.prototype['catch'] = function(cb) {
  return this.then(undefined, cb);
};

/**
 * Allow for extension
 */

RequestBase.prototype.use = function use(fn) {
  fn(this);
  return this;
};

RequestBase.prototype.ok = function(cb) {
  if ('function' !== typeof cb) throw Error("Callback required");
  this._okCallback = cb;
  return this;
};

RequestBase.prototype._isResponseOK = function(res) {
  if (!res) {
    return false;
  }

  if (this._okCallback) {
    return this._okCallback(res);
  }

  return res.status >= 200 && res.status < 300;
};

/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

RequestBase.prototype.get = function(field){
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

RequestBase.prototype.getHeader = RequestBase.prototype.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.set = function(field, val){
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */
RequestBase.prototype.unset = function(field){
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */
RequestBase.prototype.field = function(name, val) {
  // name should be either a string or an object.
  if (null === name || undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }

  if (this._data) {
    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObject(name)) {
    for (var key in name) {
      this.field(key, name[key]);
    }
    return this;
  }

  if (Array.isArray(val)) {
    for (var i in val) {
      this.field(name, val[i]);
    }
    return this;
  }

  // val should be defined now
  if (null === val || undefined === val) {
    throw new Error('.field(name, val) val can not be empty');
  }
  if ('boolean' === typeof val) {
    val = '' + val;
  }
  this._getFormData().append(name, val);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */
RequestBase.prototype.abort = function(){
  if (this._aborted) {
    return this;
  }
  this._aborted = true;
  this.xhr && this.xhr.abort(); // browser
  this.req && this.req.abort(); // node
  this.clearTimeout();
  this.emit('abort');
  return this;
};

RequestBase.prototype._auth = function(user, pass, options, base64Encoder) {
  switch (options.type) {
    case 'basic':
      this.set('Authorization', 'Basic ' + base64Encoder(user + ':' + pass));
      break;

    case 'auto':
      this.username = user;
      this.password = pass;
      break;

    case 'bearer': // usage would be .auth(accessToken, { type: 'bearer' })
      this.set('Authorization', 'Bearer ' + user);
      break;
  }
  return this;
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

RequestBase.prototype.withCredentials = function(on) {
  // This is browser-only functionality. Node side is no-op.
  if (on == undefined) on = true;
  this._withCredentials = on;
  return this;
};

/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.redirects = function(n){
  this._maxRedirects = n;
  return this;
};

/**
 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
 * Default 200MB.
 *
 * @param {Number} n
 * @return {Request} for chaining
 */
RequestBase.prototype.maxResponseSize = function(n){
  if ('number' !== typeof n) {
    throw TypeError("Invalid argument");
  }
  this._maxResponseSize = n;
  return this;
};

/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */

RequestBase.prototype.toJSON = function() {
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header,
  };
};

/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.send = function(data){
  var isObj = isObject(data);
  var type = this._header['content-type'];

  if (this._formData) {
    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObj && !this._data) {
    if (Array.isArray(data)) {
      this._data = [];
    } else if (!this._isHost(data)) {
      this._data = {};
    }
  } else if (data && this._data && this._isHost(this._data)) {
    throw Error("Can't merge these send calls");
  }

  // merge
  if (isObj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data
        ? this._data + '&' + data
        : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!isObj || this._isHost(data)) {
    return this;
  }

  // default to json
  if (!type) this.type('json');
  return this;
};

/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.sortQuery = function(sort) {
  // _sort default to true but otherwise can be a function or boolean
  this._sort = typeof sort === 'undefined' ? true : sort;
  return this;
};

/**
 * Compose querystring to append to req.url
 *
 * @api private
 */
RequestBase.prototype._finalizeQueryString = function(){
  var query = this._query.join('&');
  if (query) {
    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
  }
  this._query.length = 0; // Makes the call idempotent

  if (this._sort) {
    var index = this.url.indexOf('?');
    if (index >= 0) {
      var queryArr = this.url.substring(index + 1).split('&');
      if ('function' === typeof this._sort) {
        queryArr.sort(this._sort);
      } else {
        queryArr.sort();
      }
      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
    }
  }
};

// For backwards compat only
RequestBase.prototype._appendQueryString = function() {console.trace("Unsupported");}

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

RequestBase.prototype._timeoutError = function(reason, timeout, errno){
  if (this._aborted) {
    return;
  }
  var err = new Error(reason + timeout + 'ms exceeded');
  err.timeout = timeout;
  err.code = 'ECONNABORTED';
  err.errno = errno;
  this.timedout = true;
  this.abort();
  this.callback(err);
};

RequestBase.prototype._setTimeouts = function() {
  var self = this;

  // deadline
  if (this._timeout && !this._timer) {
    this._timer = setTimeout(function(){
      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
  }
  // response timeout
  if (this._responseTimeout && !this._responseTimeoutTimer) {
    this._responseTimeoutTimer = setTimeout(function(){
      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
  }
};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module dependencies.
 */

var utils = __webpack_require__(348);

/**
 * Expose `ResponseBase`.
 */

module.exports = ResponseBase;

/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */

function ResponseBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in ResponseBase.prototype) {
    obj[key] = ResponseBase.prototype[key];
  }
  return obj;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

ResponseBase.prototype.get = function(field) {
  return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

ResponseBase.prototype._setHeaderProperties = function(header){
    // TODO: moar!
    // TODO: make this a util

    // content-type
    var ct = header['content-type'] || '';
    this.type = utils.type(ct);

    // params
    var params = utils.params(ct);
    for (var key in params) this[key] = params[key];

    this.links = {};

    // links
    try {
        if (header.link) {
            this.links = utils.parseLinks(header.link);
        }
    } catch (err) {
        // ignore
    }
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

ResponseBase.prototype._setStatusProperties = function(status){
    var type = status / 100 | 0;

    // status / class
    this.status = this.statusCode = status;
    this.statusType = type;

    // basics
    this.info = 1 == type;
    this.ok = 2 == type;
    this.redirect = 3 == type;
    this.clientError = 4 == type;
    this.serverError = 5 == type;
    this.error = (4 == type || 5 == type)
        ? this.toError()
        : false;

    // sugar
    this.created = 201 == status;
    this.accepted = 202 == status;
    this.noContent = 204 == status;
    this.badRequest = 400 == status;
    this.unauthorized = 401 == status;
    this.notAcceptable = 406 == status;
    this.forbidden = 403 == status;
    this.notFound = 404 == status;
    this.unprocessableEntity = 422 == status;
};


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

exports.type = function(str){
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.params = function(str){
  return str.split(/ *; */).reduce(function(obj, str){
    var parts = str.split(/ *= */);
    var key = parts.shift();
    var val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.parseLinks = function(str){
  return str.split(/ *, */).reduce(function(obj, str){
    var parts = str.split(/ *; */);
    var url = parts[0].slice(1, -1);
    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
    obj[rel] = url;
    return obj;
  }, {});
};

/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */

exports.cleanHeader = function(header, changesOrigin){
  delete header['content-type'];
  delete header['content-length'];
  delete header['transfer-encoding'];
  delete header['host'];
  // secuirty
  if (changesOrigin) {
    delete header['authorization'];
    delete header['cookie'];
  }
  return header;
};


/***/ }),
/* 349 */
/***/ (function(module, exports) {

function Agent() {
  this._defaults = [];
}

["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects",
 "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert"].forEach(function(fn) {
  /** Default setting for all requests from this agent */
  Agent.prototype[fn] = function(/*varargs*/) {
    this._defaults.push({fn:fn, arguments:arguments});
    return this;
  }
});

Agent.prototype._setDefaults = function(req) {
    this._defaults.forEach(function(def) {
      req[def.fn].apply(req, def.arguments);
    });
};

module.exports = Agent;


/***/ }),
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dropzone__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_superagent__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Uploader_css__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Uploader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Uploader_css__);
var _onDrop=function _onDrop(files,url,callback){var req=__WEBPACK_IMPORTED_MODULE_3_superagent___default.a.post(url);req.attach('file',files[0]);req.end(function(err,res){if(err){console.error(err);throw err;}callback(JSON.parse(res.text).data.src);});};var Uploader=function Uploader(_ref){var uploadHandler=_ref.uploadHandler,onUpload=_ref.onUpload,className=_ref.className;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["a" /* I18n */],null,function(t,_ref2){var i18n=_ref2.i18n;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_dropzone__["a" /* default */],{onDrop:function onDrop(files){return _onDrop(files,uploadHandler,onUpload);},style:{},className:['configurator-uploader',className].join(' ')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'material-icons'},'file_download'),t('configurator.createYourOwn'));});};/* harmony default export */ __webpack_exports__["a"] = (Uploader);

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles__ = __webpack_require__(355);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint prefer-template: 0 */






var Dropzone = function (_React$Component) {
  _inherits(Dropzone, _React$Component);

  function Dropzone(props, context) {
    _classCallCheck(this, Dropzone);

    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));

    _this.renderChildren = function (children, isDragActive, isDragAccept, isDragReject) {
      if (typeof children === 'function') {
        return children(_extends({}, _this.state, {
          isDragActive: isDragActive,
          isDragAccept: isDragAccept,
          isDragReject: isDragReject
        }));
      }
      return children;
    };

    _this.composeHandlers = _this.composeHandlers.bind(_this);
    _this.onClick = _this.onClick.bind(_this);
    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
    _this.onDragEnter = _this.onDragEnter.bind(_this);
    _this.onDragLeave = _this.onDragLeave.bind(_this);
    _this.onDragOver = _this.onDragOver.bind(_this);
    _this.onDragStart = _this.onDragStart.bind(_this);
    _this.onDrop = _this.onDrop.bind(_this);
    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
    _this.onInputElementClick = _this.onInputElementClick.bind(_this);

    _this.setRef = _this.setRef.bind(_this);
    _this.setRefs = _this.setRefs.bind(_this);

    _this.isFileDialogActive = false;

    _this.state = {
      draggedFiles: [],
      acceptedFiles: [],
      rejectedFiles: []
    };
    return _this;
  }

  _createClass(Dropzone, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      this.dragTargets = [];

      if (preventDropOnDocument) {
        document.addEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* onDocumentDragOver */], false);
        document.addEventListener('drop', this.onDocumentDrop, false);
      }
      this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
      // Tried implementing addEventListener, but didn't work out
      document.body.onfocus = this.onFileDialogCancel;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      if (preventDropOnDocument) {
        document.removeEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* onDocumentDragOver */]);
        document.removeEventListener('drop', this.onDocumentDrop);
      }
      if (this.fileInputEl != null) {
        this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
      }
      // Can be replaced with removeEventListener, if addEventListener works
      if (document != null) {
        document.body.onfocus = null;
      }
    }
  }, {
    key: 'composeHandlers',
    value: function composeHandlers(handler) {
      if (this.props.disabled) {
        return null;
      }

      return handler;
    }
  }, {
    key: 'onDocumentDrop',
    value: function onDocumentDrop(evt) {
      if (this.node && this.node.contains(evt.target)) {
        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
      }
      evt.preventDefault();
      this.dragTargets = [];
    }
  }, {
    key: 'onDragStart',
    value: function onDragStart(evt) {
      if (this.props.onDragStart) {
        this.props.onDragStart.call(this, evt);
      }
    }
  }, {
    key: 'onDragEnter',
    value: function onDragEnter(evt) {
      evt.preventDefault();

      // Count the dropzone and any children that are entered.
      if (this.dragTargets.indexOf(evt.target) === -1) {
        this.dragTargets.push(evt.target);
      }

      this.setState({
        isDragActive: true, // Do not rely on files for the drag state. It doesn't work in Safari.
        draggedFiles: Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getDataTransferItems */])(evt)
      });

      if (this.props.onDragEnter) {
        this.props.onDragEnter.call(this, evt);
      }
    }
  }, {
    key: 'onDragOver',
    value: function onDragOver(evt) {
      // eslint-disable-line class-methods-use-this
      evt.preventDefault();
      evt.stopPropagation();
      try {
        // The file dialog on Chrome allows users to drag files from the dialog onto
        // the dropzone, causing the browser the crash when the file dialog is closed.
        // A drop effect of 'none' prevents the file from being dropped
        evt.dataTransfer.dropEffect = this.isFileDialogActive ? 'none' : 'copy'; // eslint-disable-line no-param-reassign
      } catch (err) {
        // continue regardless of error
      }

      if (this.props.onDragOver) {
        this.props.onDragOver.call(this, evt);
      }
      return false;
    }
  }, {
    key: 'onDragLeave',
    value: function onDragLeave(evt) {
      var _this2 = this;

      evt.preventDefault();

      // Only deactivate once the dropzone and all children have been left.
      this.dragTargets = this.dragTargets.filter(function (el) {
        return el !== evt.target && _this2.node.contains(el);
      });
      if (this.dragTargets.length > 0) {
        return;
      }

      // Clear dragging files state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      if (this.props.onDragLeave) {
        this.props.onDragLeave.call(this, evt);
      }
    }
  }, {
    key: 'onDrop',
    value: function onDrop(evt) {
      var _this3 = this;

      var _props = this.props,
          onDrop = _props.onDrop,
          onDropAccepted = _props.onDropAccepted,
          onDropRejected = _props.onDropRejected,
          multiple = _props.multiple,
          disablePreview = _props.disablePreview,
          accept = _props.accept;

      var fileList = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getDataTransferItems */])(evt);
      var acceptedFiles = [];
      var rejectedFiles = [];

      // Stop default browser behavior
      evt.preventDefault();

      // Reset the counter along with the drag on a drop.
      this.dragTargets = [];
      this.isFileDialogActive = false;

      fileList.forEach(function (file) {
        if (!disablePreview) {
          try {
            file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
          } catch (err) {
            if (false) {
              console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
            }
          }
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* fileAccepted */])(file, accept) && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* fileMatchSize */])(file, _this3.props.maxSize, _this3.props.minSize)) {
          acceptedFiles.push(file);
        } else {
          rejectedFiles.push(file);
        }
      });

      if (!multiple) {
        // if not in multi mode add any extra accepted files to rejected.
        // This will allow end users to easily ignore a multi file drop in "single" mode.
        rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
      }

      if (onDrop) {
        onDrop.call(this, acceptedFiles, rejectedFiles, evt);
      }

      if (rejectedFiles.length > 0 && onDropRejected) {
        onDropRejected.call(this, rejectedFiles, evt);
      }

      if (acceptedFiles.length > 0 && onDropAccepted) {
        onDropAccepted.call(this, acceptedFiles, evt);
      }

      // Clear files value
      this.draggedFiles = null;

      // Reset drag state
      this.setState({
        isDragActive: false,
        draggedFiles: [],
        acceptedFiles: acceptedFiles,
        rejectedFiles: rejectedFiles
      });
    }
  }, {
    key: 'onClick',
    value: function onClick(evt) {
      var _props2 = this.props,
          onClick = _props2.onClick,
          disableClick = _props2.disableClick;

      if (!disableClick) {
        evt.stopPropagation();

        if (onClick) {
          onClick.call(this, evt);
        }

        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
        // this is so react can handle state changes in the onClick prop above above
        // see: https://github.com/react-dropzone/react-dropzone/issues/450
        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* isIeOrEdge */])()) {
          setTimeout(this.open.bind(this), 0);
        } else {
          this.open();
        }
      }
    }
  }, {
    key: 'onInputElementClick',
    value: function onInputElementClick(evt) {
      evt.stopPropagation();
      if (this.props.inputProps && this.props.inputProps.onClick) {
        this.props.inputProps.onClick();
      }
    }
  }, {
    key: 'onFileDialogCancel',
    value: function onFileDialogCancel() {
      var _this4 = this;

      // timeout will not recognize context of this method
      var onFileDialogCancel = this.props.onFileDialogCancel;
      // execute the timeout only if the FileDialog is opened in the browser

      if (this.isFileDialogActive) {
        setTimeout(function () {
          if (_this4.fileInputEl != null) {
            // Returns an object as FileList
            var files = _this4.fileInputEl.files;


            if (!files.length) {
              _this4.isFileDialogActive = false;
            }
          }

          if (typeof onFileDialogCancel === 'function') {
            onFileDialogCancel();
          }
        }, 300);
      }
    }
  }, {
    key: 'setRef',
    value: function setRef(ref) {
      this.node = ref;
    }
  }, {
    key: 'setRefs',
    value: function setRefs(ref) {
      this.fileInputEl = ref;
    }
    /**
     * Open system file upload dialog.
     *
     * @public
     */

  }, {
    key: 'open',
    value: function open() {
      this.isFileDialogActive = true;
      this.fileInputEl.value = null;
      this.fileInputEl.click();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          accept = _props3.accept,
          acceptClassName = _props3.acceptClassName,
          activeClassName = _props3.activeClassName,
          children = _props3.children,
          disabled = _props3.disabled,
          disabledClassName = _props3.disabledClassName,
          inputProps = _props3.inputProps,
          multiple = _props3.multiple,
          name = _props3.name,
          rejectClassName = _props3.rejectClassName,
          rest = _objectWithoutProperties(_props3, ['accept', 'acceptClassName', 'activeClassName', 'children', 'disabled', 'disabledClassName', 'inputProps', 'multiple', 'name', 'rejectClassName']);

      var acceptStyle = rest.acceptStyle,
          activeStyle = rest.activeStyle,
          _rest$className = rest.className,
          className = _rest$className === undefined ? '' : _rest$className,
          disabledStyle = rest.disabledStyle,
          rejectStyle = rest.rejectStyle,
          style = rest.style,
          props = _objectWithoutProperties(rest, ['acceptStyle', 'activeStyle', 'className', 'disabledStyle', 'rejectStyle', 'style']);

      var _state = this.state,
          isDragActive = _state.isDragActive,
          draggedFiles = _state.draggedFiles;

      var filesCount = draggedFiles.length;
      var isMultipleAllowed = multiple || filesCount <= 1;
      var isDragAccept = filesCount > 0 && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* allFilesAccepted */])(draggedFiles, this.props.accept);
      var isDragReject = filesCount > 0 && (!isDragAccept || !isMultipleAllowed);
      var noStyles = !className && !style && !activeStyle && !acceptStyle && !rejectStyle && !disabledStyle;

      if (isDragActive && activeClassName) {
        className += ' ' + activeClassName;
      }
      if (isDragAccept && acceptClassName) {
        className += ' ' + acceptClassName;
      }
      if (isDragReject && rejectClassName) {
        className += ' ' + rejectClassName;
      }
      if (disabled && disabledClassName) {
        className += ' ' + disabledClassName;
      }

      if (noStyles) {
        style = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].default;
        activeStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].active;
        acceptStyle = style.active;
        rejectStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].rejected;
        disabledStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].disabled;
      }

      var appliedStyle = _extends({}, style);
      if (activeStyle && isDragActive) {
        appliedStyle = _extends({}, style, activeStyle);
      }
      if (acceptStyle && isDragAccept) {
        appliedStyle = _extends({}, appliedStyle, acceptStyle);
      }
      if (rejectStyle && isDragReject) {
        appliedStyle = _extends({}, appliedStyle, rejectStyle);
      }
      if (disabledStyle && disabled) {
        appliedStyle = _extends({}, style, disabledStyle);
      }

      var inputAttributes = {
        accept: accept,
        disabled: disabled,
        type: 'file',
        style: { display: 'none' },
        multiple: __WEBPACK_IMPORTED_MODULE_2__utils__["g" /* supportMultiple */] && multiple,
        ref: this.setRefs,
        onChange: this.onDrop,
        autoComplete: 'off'
      };

      if (name && name.length) {
        inputAttributes.name = name;
      }

      // Destructure custom props away from props used for the div element

      var acceptedFiles = props.acceptedFiles,
          preventDropOnDocument = props.preventDropOnDocument,
          disablePreview = props.disablePreview,
          disableClick = props.disableClick,
          onDropAccepted = props.onDropAccepted,
          onDropRejected = props.onDropRejected,
          onFileDialogCancel = props.onFileDialogCancel,
          maxSize = props.maxSize,
          minSize = props.minSize,
          divProps = _objectWithoutProperties(props, ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({
          className: className,
          style: appliedStyle
        }, divProps /* expand user provided props first so event handlers are never overridden */, {
          onClick: this.composeHandlers(this.onClick),
          onDragStart: this.composeHandlers(this.onDragStart),
          onDragEnter: this.composeHandlers(this.onDragEnter),
          onDragOver: this.composeHandlers(this.onDragOver),
          onDragLeave: this.composeHandlers(this.onDragLeave),
          onDrop: this.composeHandlers(this.onDrop),
          ref: this.setRef,
          'aria-disabled': disabled
        }),
        this.renderChildren(children, isDragActive, isDragAccept, isDragReject),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
      );
    }
  }]);

  return Dropzone;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Dropzone);

Dropzone.propTypes = {
  /**
   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Contents of the dropzone
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),

  /**
   * Disallow clicking on the dropzone container to open file dialog
   */
  disableClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Enable/disable the dropzone entirely
   */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Enable/disable preview generation
   */
  disablePreview: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Pass additional attributes to the `<input type="file"/>` tag
   */
  inputProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Allow dropping multiple files
   */
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * `name` attribute for the input tag
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Minimum file size (in bytes)
   */
  minSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * className
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drag is active
   */
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drop will be accepted
   */
  acceptClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drop will be rejected
   */
  rejectClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when dropzone is disabled
   */
  disabledClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * CSS styles to apply
   */
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drag is active
   */
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be accepted
   */
  acceptStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be rejected
   */
  rejectStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when dropzone is disabled
   */
  disabledStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * onClick callback
   * @param {Event} event
   */
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDrop callback
   */
  onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropAccepted callback
   */
  onDropAccepted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropRejected callback
   */
  onDropRejected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragStart callback
   */
  onDragStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragEnter callback
   */
  onDragEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragOver callback
   */
  onDragOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragLeave callback
   */
  onDragLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Provide a callback on clicking the cancel button of the file dialog
   */
  onFileDialogCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

Dropzone.defaultProps = {
  preventDropOnDocument: true,
  disabled: false,
  disablePreview: false,
  disableClick: false,
  multiple: true,
  maxSize: Infinity,
  minSize: 0
};

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportMultiple; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getDataTransferItems;
/* harmony export (immutable) */ __webpack_exports__["b"] = fileAccepted;
/* harmony export (immutable) */ __webpack_exports__["c"] = fileMatchSize;
/* harmony export (immutable) */ __webpack_exports__["a"] = allFilesAccepted;
/* harmony export (immutable) */ __webpack_exports__["f"] = onDocumentDragOver;
/* harmony export (immutable) */ __webpack_exports__["e"] = isIeOrEdge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_attr_accept__);


var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;

function getDataTransferItems(event) {
  var dataTransferItemsList = [];
  if (event.dataTransfer) {
    var dt = event.dataTransfer;
    if (dt.files && dt.files.length) {
      dataTransferItemsList = dt.files;
    } else if (dt.items && dt.items.length) {
      // During the drag even the dataTransfer.files is null
      // but Chrome implements some drag store, which is accesible via dataTransfer.items
      dataTransferItemsList = dt.items;
    }
  } else if (event.target && event.target.files) {
    dataTransferItemsList = event.target.files;
  }
  // Convert from DataTransferItemsList to the native Array
  return Array.prototype.slice.call(dataTransferItemsList);
}

// Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted
function fileAccepted(file, accept) {
  return file.type === 'application/x-moz-file' || __WEBPACK_IMPORTED_MODULE_0_attr_accept___default()(file, accept);
}

function fileMatchSize(file, maxSize, minSize) {
  return file.size <= maxSize && file.size >= minSize;
}

function allFilesAccepted(files, accept) {
  return files.every(function (file) {
    return fileAccepted(file, accept);
  });
}

// allow the entire document to be a drag target
function onDocumentDragOver(evt) {
  evt.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;

  return isIe(userAgent) || isEdge(userAgent);
}

/***/ }),
/* 354 */
/***/ (function(module, exports) {

module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={i:e,l:!1,exports:{}};return t[e].call(o.exports,o,o.exports,n),o.l=!0,o.exports}var r={};return n.m=t,n.c=r,n.d=function(t,r,e){n.o(t,r)||Object.defineProperty(t,r,{configurable:!1,enumerable:!0,get:e})},n.n=function(t){var r=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(r,"a",r),r},n.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},n.p="",n(n.s=13)}([function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n){var r=t.exports={version:"2.5.0"};"number"==typeof __e&&(__e=r)},function(t,n,r){t.exports=!r(4)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(32)("wks"),o=r(9),i=r(0).Symbol,u="function"==typeof i;(t.exports=function(t){return e[t]||(e[t]=u&&i[t]||(u?i:o)("Symbol."+t))}).store=e},function(t,n,r){var e=r(0),o=r(2),i=r(8),u=r(22),c=r(10),f=function(t,n,r){var a,s,p,l,v=t&f.F,y=t&f.G,h=t&f.S,d=t&f.P,x=t&f.B,g=y?e:h?e[n]||(e[n]={}):(e[n]||{}).prototype,m=y?o:o[n]||(o[n]={}),b=m.prototype||(m.prototype={});y&&(r=n);for(a in r)s=!v&&g&&void 0!==g[a],p=(s?g:r)[a],l=x&&s?c(p,e):d&&"function"==typeof p?c(Function.call,p):p,g&&u(g,a,p,t&f.U),m[a]!=p&&i(m,a,l),d&&b[a]!=p&&(b[a]=p)};e.core=o,f.F=1,f.G=2,f.S=4,f.P=8,f.B=16,f.W=32,f.U=64,f.R=128,t.exports=f},function(t,n,r){var e=r(16),o=r(21);t.exports=r(3)?function(t,n,r){return e.f(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(24);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){var e=r(28),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";n.__esModule=!0,n.default=function(t,n){if(t&&n){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):/\/\*$/.test(n)?i===n.replace(/\/.*$/,""):o===n})}return!0},r(14),r(34)},function(t,n,r){r(15),t.exports=r(2).Array.some},function(t,n,r){"use strict";var e=r(7),o=r(25)(3);e(e.P+e.F*!r(33)([].some,!0),"Array",{some:function(t){return o(this,t,arguments[1])}})},function(t,n,r){var e=r(17),o=r(18),i=r(20),u=Object.defineProperty;n.f=r(3)?Object.defineProperty:function(t,n,r){if(e(t),n=i(n,!0),e(r),o)try{return u(t,n,r)}catch(t){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return"value"in r&&(t[n]=r.value),t}},function(t,n,r){var e=r(1);t.exports=function(t){if(!e(t))throw TypeError(t+" is not an object!");return t}},function(t,n,r){t.exports=!r(3)&&!r(4)(function(){return 7!=Object.defineProperty(r(19)("div"),"a",{get:function(){return 7}}).a})},function(t,n,r){var e=r(1),o=r(0).document,i=e(o)&&e(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,n,r){var e=r(1);t.exports=function(t,n){if(!e(t))return t;var r,o;if(n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;if("function"==typeof(r=t.valueOf)&&!e(o=r.call(t)))return o;if(!n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(0),o=r(8),i=r(23),u=r(9)("src"),c=Function.toString,f=(""+c).split("toString");r(2).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,c){var a="function"==typeof r;a&&(i(r,"name")||o(r,"name",n)),t[n]!==r&&(a&&(i(r,u)||o(r,u,t[n]?""+t[n]:f.join(String(n)))),t===e?t[n]=r:c?t[n]?t[n]=r:o(t,n,r):(delete t[n],o(t,n,r)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[u]||c.call(this)})},function(t,n){var r={}.hasOwnProperty;t.exports=function(t,n){return r.call(t,n)}},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n,r){var e=r(10),o=r(26),i=r(27),u=r(12),c=r(29);t.exports=function(t,n){var r=1==t,f=2==t,a=3==t,s=4==t,p=6==t,l=5==t||p,v=n||c;return function(n,c,y){for(var h,d,x=i(n),g=o(x),m=e(c,y,3),b=u(g.length),_=0,w=r?v(n,b):f?v(n,0):void 0;b>_;_++)if((l||_ in g)&&(h=g[_],d=m(h,_,x),t))if(r)w[_]=d;else if(d)switch(t){case 3:return!0;case 5:return h;case 6:return _;case 2:w.push(h)}else if(s)return!1;return p?-1:a||s?s:w}}},function(t,n,r){var e=r(5);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==e(t)?t.split(""):Object(t)}},function(t,n,r){var e=r(11);t.exports=function(t){return Object(e(t))}},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(30);t.exports=function(t,n){return new(e(t))(n)}},function(t,n,r){var e=r(1),o=r(31),i=r(6)("species");t.exports=function(t){var n;return o(t)&&(n=t.constructor,"function"!=typeof n||n!==Array&&!o(n.prototype)||(n=void 0),e(n)&&null===(n=n[i])&&(n=void 0)),void 0===n?Array:n}},function(t,n,r){var e=r(5);t.exports=Array.isArray||function(t){return"Array"==e(t)}},function(t,n,r){var e=r(0),o=e["__core-js_shared__"]||(e["__core-js_shared__"]={});t.exports=function(t){return o[t]||(o[t]={})}},function(t,n,r){"use strict";var e=r(4);t.exports=function(t,n){return!!t&&e(function(){n?t.call(null,function(){},1):t.call(null)})}},function(t,n,r){r(35),t.exports=r(2).String.endsWith},function(t,n,r){"use strict";var e=r(7),o=r(12),i=r(36),u="".endsWith;e(e.P+e.F*r(38)("endsWith"),"String",{endsWith:function(t){var n=i(this,t,"endsWith"),r=arguments.length>1?arguments[1]:void 0,e=o(n.length),c=void 0===r?e:Math.min(o(r),e),f=String(t);return u?u.call(n,f,c):n.slice(c-f.length,c)===f}})},function(t,n,r){var e=r(37),o=r(11);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){var e=r(1),o=r(5),i=r(6)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n,r){var e=r(6)("match");t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(r){try{return n[e]=!1,!"/./"[t](n)}catch(t){}}return!0}}]);

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  rejected: {
    borderStyle: 'solid',
    borderColor: '#c66',
    backgroundColor: '#eee'
  },
  disabled: {
    opacity: 0.5
  },
  active: {
    borderStyle: 'solid',
    borderColor: '#6c6',
    backgroundColor: '#eee'
  },
  default: {
    width: 200,
    height: 200,
    borderWidth: 2,
    borderColor: '#666',
    borderStyle: 'dashed',
    borderRadius: 5
  }
});

/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./H48103-guides.png": 121,
	"./H48103.png": 359,
	"./H48104-guides.png": 122,
	"./H48104.png": 360
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 358;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/H48103.2c5dcee1.png";

/***/ }),
/* 360 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./H48103-guides.png": 121,
	"./H48104-guides.png": 122
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 361;

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_i18next__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_superagent__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Notification__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form_css__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Form_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Form=function(_Component){_inherits(Form,_Component);function Form(props){_classCallCheck(this,Form);var _this=_possibleConstructorReturn(this,(Form.__proto__||Object.getPrototypeOf(Form)).call(this,props));_this.state={success:null};return _this;}_createClass(Form,[{key:'sendForm',value:function sendForm(e){var _this2=this;var req=__WEBPACK_IMPORTED_MODULE_2_superagent___default.a.post(this.props.sendTo);var config=this.props.config;config.data.email=e.target.email.value;req.set('Content-Type','application/json');req.set('Accept','application/json');req.send(JSON.stringify(config));req.end(function(err,res){if(err){console.error(err);console.log(res);_this2.setState({success:false});}else if(JSON.parse(res.text).code===200){_this2.setState({success:true},function(){setTimeout(_this2.props.close,3000);});}});e.preventDefault();}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_i18next__["a" /* I18n */],null,function(t,_ref){var i18n=_ref.i18n;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'configurator-overlay',onClick:_this3.props.close,key:'editor-overlay'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'configurator-form configurator-modal',key:'editor-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'configurator-controls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'configurator-red-button',onClick:_this3.props.close},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'material-icons'},'close'))),_this3.props.children,_this3.state.success!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Notification__["a" /* default */],{type:_this3.state.success?'success':'error',dismiss:function dismiss(){return _this3.setState({success:null});}},t('configurator.form.'+(_this3.state.success?'success':'error'))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:_this3.sendForm.bind(_this3)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'email',type:'email',required:true,placeholder:'e-mail'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'configurator-red-button'},t('configurator.form.send'))))];});}}]);return Form;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Form);

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Notification_css__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Notification_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Notification_css__);
var Notification=function Notification(_ref){var type=_ref.type,children=_ref.children,dismiss=_ref.dismiss;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:['notification','notification-'+type].join(' ')},children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'material-icons',onClick:dismiss},'close'));};/* harmony default export */ __webpack_exports__["a"] = (Notification);

/***/ }),
/* 364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/background.75408b4c.jpg";

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.a64c8ee7.png";

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.7dbea8fd.png";

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.40768741.png";

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.f15873ac.png";

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.fa8cd82e.png";

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.7c9389ca.png";

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.bb1720c5.png";

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.123411ec.png";

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.cc611755.png";

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.727c2367.png";

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.108c18f7.png";

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.1b8adc32.png";

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.c32ec1b3.png";

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.372f442a.png";

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.166d00ca.png";

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.297861cc.png";

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.e07c2967.png";

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.00f050ef.png";

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0019.447b4438.png";

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0020.bb5ea689.png";

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0021.54f3a9f8.png";

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0022.558ffc2b.png";

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0023.7e20f67a.png";

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0024.8850483d.png";

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0025.836c35f1.png";

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0026.e4378022.png";

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0027.4de09782.png";

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0028.799f8921.png";

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0029.450f0baf.png";

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0030.64380da5.png";

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0031.e182cfb9.png";

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0032.8a988b44.png";

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0033.6d4ec4de.png";

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0034.31974989.png";

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0035.7bb467fe.png";

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0036.2e61be6e.png";

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0037.821c7fca.png";

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0038.a1c0cecf.png";

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0039.c2810fb9.png";

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0040.16ca2cbd.png";

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0041.51bd9c5c.png";

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0042.5c6604d0.png";

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0043.39bdbbf9.png";

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0044.e7278b67.png";

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0045.35b93a89.png";

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0046.4a858d57.png";

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0047.3a894cd7.png";

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0048.7231ba2a.png";

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.c85b2f52.png";

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.215eb05a.png";

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.3c9a61c1.png";

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.4923f348.png";

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.1439bb53.png";

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.3905008a.png";

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.888a5bb8.png";

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.584cca41.png";

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.bc2e9d48.png";

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.ef75300d.png";

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.5a269ce8.png";

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.e93542e8.png";

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.1ebd52bd.png";

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.8b7f5ea9.png";

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.20b22c04.png";

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.82973b08.png";

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.6591c305.png";

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.46aedb3b.png";

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0019.370ca929.png";

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0020.db060a33.png";

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0021.ad615035.png";

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0022.43933ad2.png";

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0023.ab6fb297.png";

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0024.f8b45c4c.png";

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0025.00813912.png";

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0026.4af0f58d.png";

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0027.f4623b29.png";

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0028.a58a7954.png";

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0029.ace05eeb.png";

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0030.c52e773c.png";

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0031.2c0726b3.png";

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0032.983e2a1a.png";

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0033.91c29d58.png";

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0034.b1a75edb.png";

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0035.7e1118d7.png";

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0036.d58f72ee.png";

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0037.bb23d0a0.png";

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0038.30e47a94.png";

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0039.52aa0b54.png";

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0040.03bc65c3.png";

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0041.c35edf42.png";

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0042.9a29dd10.png";

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0043.04adc44a.png";

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0044.0e2b899c.png";

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0045.efe29f92.png";

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0046.f9e00d0d.png";

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0047.54fab2ae.png";

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0048.0f1e2fd7.png";

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.775b7937.png";

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.90bce5f9.png";

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.34c7ff40.png";

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.c2adabfb.png";

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.b48a5f52.png";

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.8c6bb8ab.png";

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.3408e47b.png";

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.473d26a4.png";

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.c542fdbf.png";

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.3218ae37.png";

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.cf80ff33.png";

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.1c727e68.png";

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.3b9efb2a.png";

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.68b262fd.png";

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.bf453c96.png";

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.b7de98d1.png";

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.fae3f143.png";

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.049ec4d2.png";

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0019.642148d1.png";

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0020.7d1cf5cf.png";

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0021.8dadc450.png";

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0022.55c1fdbd.png";

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0023.98f8d794.png";

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0024.01673f75.png";

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0025.cb1f0e02.png";

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0026.a28254c7.png";

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0027.e9be0bc8.png";

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0028.116ffcfa.png";

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0029.159a1e3e.png";

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0030.7d2bb6ef.png";

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0031.0b452a08.png";

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0032.3c10805c.png";

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0033.18c2e0f3.png";

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0034.b0ed6f65.png";

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0035.97aa8184.png";

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0036.116948ea.png";

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0037.6aa4d773.png";

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0038.a912a774.png";

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0039.01f52ec7.png";

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0040.e718e9cd.png";

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0041.ad677702.png";

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0042.aa1ec69b.png";

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0043.bb9376b3.png";

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0044.1e7308fc.png";

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0045.ecfffbbc.png";

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0046.b0554277.png";

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0047.3f96f515.png";

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0048.a93fddc5.png";

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.024c2639.png";

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.62fffae4.png";

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.11b59ae4.png";

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.5f2ad994.png";

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.1be142b2.png";

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.70262552.png";

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.367150af.png";

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.d3880e45.png";

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.c3e3b493.png";

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.8a252438.png";

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.10c2f5f8.png";

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.cdcecd7d.png";

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.03d34433.png";

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.abf0326b.png";

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.c24ffabb.png";

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.64c6e040.png";

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.4476ad15.png";

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.eeb99bff.png";

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0019.9162260c.png";

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0020.b02af8a8.png";

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0021.a9f176a4.png";

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0022.7db64288.png";

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0023.9f84ba45.png";

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0024.1dd050ec.png";

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0025.a3984ef2.png";

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0026.596c9d30.png";

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0027.4c163cdd.png";

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0028.aa0fd710.png";

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0029.76c1bf8e.png";

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0030.80232d15.png";

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0031.7c56188b.png";

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0032.7d5ed4f0.png";

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0033.cdf8bb6e.png";

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0034.378b18b2.png";

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0035.4956de2a.png";

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0036.b75be87e.png";

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0037.b62ebe6b.png";

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0038.c45ff686.png";

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0039.8726bac4.png";

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0040.1697faf8.png";

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0041.1a022726.png";

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0042.250e494e.png";

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0043.e1686b07.png";

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0044.6874b4f5.png";

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0045.b216976e.png";

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0046.3b9bbcb2.png";

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0047.611f2c94.png";

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0048.1a407992.png";

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.a64c8ee7.png";

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.7dbea8fd.png";

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.40768741.png";

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.f15873ac.png";

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.fa8cd82e.png";

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.7c9389ca.png";

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.bb1720c5.png";

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.123411ec.png";

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.cc611755.png";

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.727c2367.png";

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.108c18f7.png";

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.1b8adc32.png";

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.c32ec1b3.png";

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.372f442a.png";

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.166d00ca.png";

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.297861cc.png";

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.e07c2967.png";

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.00f050ef.png";

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0019.447b4438.png";

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0020.bb5ea689.png";

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0021.54f3a9f8.png";

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0022.558ffc2b.png";

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0023.7e20f67a.png";

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0024.8850483d.png";

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0025.836c35f1.png";

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0026.e4378022.png";

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0027.4de09782.png";

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0028.799f8921.png";

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0029.450f0baf.png";

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0030.64380da5.png";

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0031.e182cfb9.png";

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0032.8a988b44.png";

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0033.6d4ec4de.png";

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0034.31974989.png";

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0035.7bb467fe.png";

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0036.2e61be6e.png";

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0037.821c7fca.png";

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0038.a1c0cecf.png";

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0039.c2810fb9.png";

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0040.16ca2cbd.png";

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0041.51bd9c5c.png";

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0042.5c6604d0.png";

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0043.39bdbbf9.png";

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0044.e7278b67.png";

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0045.35b93a89.png";

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0046.4a858d57.png";

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0047.3a894cd7.png";

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0048.7231ba2a.png";

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.4575fcaa.png";

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.f54e2e4f.png";

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.881930f8.png";

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.bb7903d6.png";

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.fe790ca9.png";

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.507c1bec.png";

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.1c6ed274.png";

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.8ad124ac.png";

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.04103a1f.png";

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.f6e6a4a3.png";

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.bd6e1081.png";

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.52fb55cc.png";

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.49f92452.png";

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.c8580d7e.png";

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.9fddf8a2.png";

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.3f9646a6.png";

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.bc75a803.png";

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.05e61f0f.png";

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0019.be02d120.png";

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0020.f08e8b15.png";

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0021.a9d0764e.png";

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0022.c368f06d.png";

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0023.9d6956fe.png";

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0024.f9eb3e2e.png";

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0025.a6695ec8.png";

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0026.9497062f.png";

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0027.3bb15c84.png";

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0028.36247b8e.png";

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0029.a94bb21c.png";

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0030.3a83e188.png";

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0031.75c82ca0.png";

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0032.b67206ca.png";

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0033.900dd569.png";

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0034.80af0e49.png";

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0035.23d4f2fd.png";

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0036.e198aba1.png";

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0037.34b0d672.png";

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0038.444fca9c.png";

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0039.29ec3c3b.png";

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0040.9f3dd9bb.png";

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0041.6de0aba4.png";

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0042.ab974cc3.png";

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0043.211138f0.png";

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0044.34a54b8a.png";

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0045.45a8115c.png";

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0046.303eddfd.png";

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0047.263e08b8.png";

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0048.b05adda2.png";

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.775b7937.png";

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.90bce5f9.png";

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.34c7ff40.png";

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.c2adabfb.png";

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.b48a5f52.png";

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.8c6bb8ab.png";

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.3408e47b.png";

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.473d26a4.png";

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.c542fdbf.png";

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.3218ae37.png";

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.cf80ff33.png";

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.1c727e68.png";

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.3b9efb2a.png";

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.68b262fd.png";

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.bf453c96.png";

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.b7de98d1.png";

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.fae3f143.png";

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.049ec4d2.png";

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0019.642148d1.png";

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0020.7d1cf5cf.png";

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0021.8dadc450.png";

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0022.55c1fdbd.png";

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0023.98f8d794.png";

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0024.01673f75.png";

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0025.cb1f0e02.png";

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0026.a28254c7.png";

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0027.e9be0bc8.png";

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0028.116ffcfa.png";

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0029.159a1e3e.png";

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0030.7d2bb6ef.png";

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0031.0b452a08.png";

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0032.3c10805c.png";

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0033.18c2e0f3.png";

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0034.b0ed6f65.png";

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0035.97aa8184.png";

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0036.116948ea.png";

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0037.6aa4d773.png";

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0038.a912a774.png";

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0039.01f52ec7.png";

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0040.e718e9cd.png";

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0041.ad677702.png";

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0042.aa1ec69b.png";

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0043.bb9376b3.png";

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0044.1e7308fc.png";

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0045.ecfffbbc.png";

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0046.b0554277.png";

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0047.3f96f515.png";

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0048.a93fddc5.png";

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.54695344.png";

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.db93ad05.png";

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.5656d701.png";

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.83f67b28.png";

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.0302c971.png";

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.b2377ee0.png";

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.d42eb5e6.png";

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.be008415.png";

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.dffe46fe.png";

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.739166ae.png";

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.6dd97aa7.png";

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.49670141.png";

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.a02ee63d.png";

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.84013e1b.png";

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.7a554286.png";

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.792e4698.png";

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.62972c01.png";

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.79718f32.png";

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0019.eb84c59e.png";

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0020.c86d21e5.png";

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0021.a1fefbba.png";

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0022.c34a005c.png";

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0023.841442ff.png";

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0024.2eb0b6f8.png";

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0025.5cac20b5.png";

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0026.e2bbd960.png";

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0027.278f0afd.png";

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0028.f9e29add.png";

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0029.6e0dde56.png";

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0030.d0a96d3b.png";

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0031.5b6269e3.png";

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0032.083b934d.png";

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0033.ad584f59.png";

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0034.70d0010a.png";

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0035.40f9adf5.png";

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0036.e415112a.png";

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0037.b399348f.png";

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0038.0903c492.png";

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0039.67d20273.png";

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0040.564e766b.png";

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0041.0b89126e.png";

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0042.635018f7.png";

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0043.f33cdce0.png";

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0044.38caaa75.png";

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0045.be73ab1e.png";

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0046.d161a75e.png";

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0047.c8304f6c.png";

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0048.0a7dc12c.png";

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.ab66863b.png";

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.dfc176fd.png";

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.f2fcfa2e.png";

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.720cea40.png";

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.388061ab.png";

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.a1511084.png";

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.586f9ca2.png";

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.f1c126b3.png";

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.3be6f308.png";

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.f6d018dd.png";

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.c3bd40d3.png";

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.7e1054b9.png";

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.d89b4865.png";

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.17f6a143.png";

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.5519a116.png";

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.444010f2.png";

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.5c9995f6.png";

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.288a7385.png";

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.7c0fbc5d.png";

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0019.0a1b62be.png";

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0020.d602045f.png";

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0021.fd38aac7.png";

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0022.2ee7fda7.png";

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0023.37cb9cde.png";

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0024.14498f17.png";

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0025.dc13286a.png";

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0026.37b9ba56.png";

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0027.17545171.png";

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0028.fc73bd89.png";

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0029.56096b50.png";

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0030.9658f524.png";

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0031.93381658.png";

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0032.3144337f.png";

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0033.d2831872.png";

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0034.afe38576.png";

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0035.b6a3d9c6.png";

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0036.5f978084.png";

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0037.1d631bac.png";

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0038.a46d910a.png";

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0039.dfbf74b2.png";

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0040.69702696.png";

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0041.c1009d73.png";

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0042.f9e5b5ad.png";

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0043.41352afb.png";

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0044.387a2c49.png";

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0045.e5171666.png";

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0046.7b258d7a.png";

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0047.a24eb607.png";

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0048.44d72b0d.png";

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.42482ae8.png";

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.ad005a2b.png";

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.c816d1aa.png";

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.943e62f5.png";

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.cc29ba4a.png";

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.a68776b2.png";

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.ff80eb13.png";

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.e91b940f.png";

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.2c06e916.png";

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.d191d7da.png";

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.73f06977.png";

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.f51d8dba.png";

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.69f711c8.png";

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.e196d386.png";

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.a7d89e1b.png";

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.f02f3467.png";

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.9e1cc533.png";

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.a5ff46cd.png";

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.954e5f82.png";

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.e4bfe88e.png";

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.e53640d4.png";

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.616d334e.png";

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.0305d84b.png";

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.e0d09cb0.png";

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.a36f2337.png";

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.a974c97e.png";

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.9db46e6e.png";

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.c9c4037f.png";

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0019.039b9054.png";

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0020.31984b49.png";

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0021.7329cd55.png";

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0022.b5eb0067.png";

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0023.c71dd30a.png";

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0024.3098a651.png";

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0025.2dd4f217.png";

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0026.462d3a89.png";

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0027.2f86b4ca.png";

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0028.e5c8d22b.png";

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0029.f6921d90.png";

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0030.aa916357.png";

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0031.9df3b6d2.png";

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0032.a5b1f4ee.png";

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0033.790bf6bb.png";

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0034.7f9d3ad7.png";

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0035.e13b1eba.png";

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0036.21132c0e.png";

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0037.4e08b4fe.png";

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0038.0c050c70.png";

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.6613ecea.png";

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.7fab0a09.png";

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.0a4e4c49.png";

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.fe5bf0e8.png";

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.2f40880f.png";

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.14d47c70.png";

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.7b070649.png";

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.70b07565.png";

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.4a0b9954.png";

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.551d5896.png";

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.32c75d2e.png";

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.002cb085.png";

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.19f096da.png";

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.f138b086.png";

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.092f0c19.png";

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.b11a719a.png";

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.107b87e8.png";

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.fdfd80e6.png";

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0019.43d6c09e.png";

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0020.98ffe7b0.png";

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0021.2592c2a2.png";

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0022.06533205.png";

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0023.95b678b2.png";

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0024.47c1f59b.png";

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0025.fdee20e5.png";

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0026.f2ca4746.png";

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0027.577239fc.png";

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0028.2241a13a.png";

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0029.ecb52965.png";

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0030.debaf1a4.png";

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0031.e2cb190e.png";

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0032.d819e27c.png";

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0033.7901f8ad.png";

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0034.e7e995e3.png";

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0035.a233d3b9.png";

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0036.92ea5fb0.png";

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0037.0e009b6d.png";

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0038.4f57bded.png";

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.c01c7686.png";

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.7c975169.png";

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.0027210e.png";

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.5dea9fe1.png";

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.ab5ff790.png";

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.67051126.png";

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.39b5ff4d.png";

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.a8be3fa0.png";

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.b43bf521.png";

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.8bcc4056.png";

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.666a7b2d.png";

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.48c0b666.png";

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.627bccf1.png";

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.b98a6872.png";

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.b36f3834.png";

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.ec2ffc57.png";

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.ac42dcb3.png";

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.7ebf9f04.png";

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.07bf6258.png";

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.42d9844d.png";

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.acbe0878.png";

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.18f19885.png";

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.ac1a2ae4.png";

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.5d896ae2.png";

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.aef36793.png";

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.18a6b59c.png";

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.646d9528.png";

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.8f0af34f.png";

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.7f315105.png";

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.8e93b156.png";

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.7bb2a2fe.png";

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.b6d8b98f.png";

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.2907fc2a.png";

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.e1c63396.png";

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.9b201be1.png";

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.86400a7b.png";

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.1c5f7d76.png";

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.418b1e68.png";

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.c2742f72.png";

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.3567ff77.png";

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.73057c2a.png";

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.c2428649.png";

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.6db61465.png";

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.e8e0ed78.png";

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.743a8d44.png";

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.a8a195c0.png";

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.be8df1a2.png";

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.67c6ebb3.png";

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.2342e04c.png";

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.91eb8aa3.png";

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.53e8eee3.png";

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.11b8413e.png";

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.3f62b909.png";

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.26868cad.png";

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.1eb6a30b.png";

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.1ad7c948.png";

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.ea6d74fd.png";

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.5ad56864.png";

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.c95bb569.png";

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.910ad57a.png";

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.95c63629.png";

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.e8657516.png";

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.13e2db53.png";

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.e999dbc9.png";

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.d4e8f8dd.png";

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.cb8c0654.png";

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.d03fa7ae.png";

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.2f0ff495.png";

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.72a10eb3.png";

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.bce0759a.png";

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.772c17ed.png";

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.45e7f08f.png";

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.17bc4851.png";

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.4e6c307f.png";

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.0696b2d0.png";

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.cc973b12.png";

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.5c46af0d.png";

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.a414e2d5.png";

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.8961a274.png";

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.7a882655.png";

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.0c7b003e.png";

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.5114de68.png";

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.e73a8f7b.png";

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.53fa5ea9.png";

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.bf1be41f.png";

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.35ad9801.png";

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.794786ce.png";

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.fce50d9d.png";

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.c0723e13.png";

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.c1cabc7e.png";

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.44b9e576.png";

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.26d4f814.png";

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.ec5b6f63.png";

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.82dd788c.png";

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.568bb006.png";

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.e74e9cc1.png";

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.5dd8c297.png";

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.797aedf5.png";

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.4b4db585.png";

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.4788918a.png";

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.1a488476.png";

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.b4b78370.png";

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.c5f16ebc.png";

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.3dcf2677.png";

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.3812d2d2.png";

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.984aa1b4.png";

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.c02e847b.png";

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.87d285b5.png";

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.c480f57a.png";

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.574323b5.png";

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.d974f744.png";

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.25c23c8c.png";

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.fef65165.png";

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.698cd6ea.png";

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.d9faf6ce.png";

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.9ad7137b.png";

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.a1a5735e.png";

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.7f678bb9.png";

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.90894df9.png";

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.34787d9d.png";

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.5f55ccac.png";

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.33a2ad09.png";

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.067a99ce.png";

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.426a4720.png";

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.1b82d12f.png";

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.abaf3173.png";

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.07179518.png";

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.b85c1ed7.png";

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.3789f9ab.png";

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.ed8e63cb.png";

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.9dc640d7.png";

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.0f5525fe.png";

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.8db3187e.png";

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.b8c7335b.png";

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.265380d7.png";

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.98a38b83.png";

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.7ed5f752.png";

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.12a58bd2.png";

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.9f37d5bd.png";

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.1bfda4d2.png";

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.f5ac03df.png";

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.82ddca0b.png";

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.8b073487.png";

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.7f5163d3.png";

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.f046c613.png";

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.8da09f9e.png";

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.0f9420e1.png";

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.fa14f6df.png";

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.bc142edd.png";

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.2070bd28.png";

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.76ff316f.png";

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.d3793881.png";

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.791d004a.png";

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.ab141854.png";

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.b4105e28.png";

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.017abc84.png";

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.fae77ab9.png";

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.6c32fa8e.png";

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.56e5a8e3.png";

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.5d86bb98.png";

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.8468ff6a.png";

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.7bd91ca7.png";

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.ad3f7090.png";

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.096491d7.png";

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.55953da1.png";

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.64126c75.png";

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.e668fbb9.png";

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.1c0c72bc.png";

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.d1511fec.png";

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.cf84b8b2.png";

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.beec8dd3.png";

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.4ea994b3.png";

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.fb8308db.png";

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.e0eadd0e.png";

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.cd6c672f.png";

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.4364ae8d.png";

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.05a22c8b.png";

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.75a6b2d5.png";

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.9d43cb76.png";

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.7188806b.png";

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.40d0c5fa.png";

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.7c433dc5.png";

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.e50dd341.png";

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.ad51d287.png";

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.cba7d2fe.png";

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.ec950591.png";

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.774d7f03.png";

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.4c7b2856.png";

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.c1a53798.png";

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.039b62c1.png";

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.d504c3f5.png";

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.5b89f00e.png";

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.d876ca29.png";

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.61089d73.png";

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.4719de97.png";

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.d588ae5b.png";

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.456f118d.png";

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.c09720c5.png";

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.ff28078b.png";

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.ca0ee7e5.png";

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.8de1460a.png";

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.45bb5eeb.png";

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.b5728eb1.png";

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.4d40c3fd.png";

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.8bac830d.png";

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.6f632414.png";

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.f65bcbab.png";

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.6e362565.png";

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.451e81cd.png";

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.809866e4.png";

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.eb6290d4.png";

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.19dfe2ad.png";

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.a70222f2.png";

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.7bca8f41.png";

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.017b9a4f.png";

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.6db4cef6.png";

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.c4c1ba31.png";

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.dd6950cf.png";

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.151925f3.png";

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.1f16c9b6.png";

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.9de978bc.png";

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.7a6b9fe2.png";

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.9cd9c915.png";

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.39dd64d2.png";

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.f3df8d42.png";

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.e88bc9d8.png";

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.e27aaeb0.png";

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.67e94b0d.png";

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.ce1c3ca2.png";

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.8935a3f8.png";

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.4b9c64e4.png";

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.a9866c9a.png";

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.f321a91f.png";

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.0d58c900.png";

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.3c46ef05.png";

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.409551be.png";

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.119539b1.png";

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.d60b956c.png";

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.dbb665f0.png";

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.550e4ab2.png";

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.742d6d89.png";

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.beade223.png";

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.81082d6b.png";

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.e41fea15.png";

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.013b0a0c.png";

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.85510a75.png";

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.0ae09a02.png";

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.44216f74.png";

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.05d6ef6a.png";

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.e350c6f1.png";

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.9e833681.png";

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.ec36cb58.png";

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.93ecf804.png";

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.32f233a3.png";

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.4df21753.png";

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.3685ae8b.png";

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.8fa33591.png";

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.d035375e.png";

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.f7569b02.png";

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.6e8a8ef8.png";

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.e0aabd14.png";

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.69836e2d.png";

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.486f6419.png";

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.4db0ec12.png";

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.7c682d78.png";

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.d11629e9.png";

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.edff742f.png";

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.974c55c5.png";

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.a509f03a.png";

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.381374d3.png";

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.ca137ed1.png";

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.b5a95987.png";

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.1b136996.png";

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.a76c89e6.png";

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.8107cd1f.png";

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.81232b41.png";

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.2c6c1f60.png";

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.f1e18c7d.png";

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.ff4d7739.png";

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.8c05ba22.png";

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.176143af.png";

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.947e0791.png";

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.75252e49.png";

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.deafe85c.png";

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.ade9aa70.png";

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.1c83087b.png";

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.69cc3e7b.png";

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.e606a14c.png";

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.99aa06cb.png";

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.1e788821.png";

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.2d93399a.png";

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.d0bab524.png";

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.82a80565.png";

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.78aec53e.png";

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.58553e18.png";

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.4ad6e3e7.png";

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.e05aaf5d.png";

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.13b9d5e6.png";

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.3c9521e1.png";

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.e94f7962.png";

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.6e419f9c.png";

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.646200fb.png";

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.85ff684d.png";

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.3a691708.png";

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.2220a736.png";

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.b70e2b3f.png";

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.52088213.png";

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.0446a870.png";

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.1e9fb2e8.png";

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.e53e3ccf.png";

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.0756db9d.png";

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.20ccdcec.png";

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.f9b41ff3.png";

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.6a5c3d72.png";

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.69311b73.png";

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.dea59d88.png";

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.919f3185.png";

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.0d47a691.png";

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.e90196c6.png";

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.053ceb7b.png";

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.6469a4f9.png";

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.9388a6c8.png";

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.e3768881.png";

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.f1c7c74b.png";

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.59dedb08.png";

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.420aa69a.png";

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.b0eefb0e.png";

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.67d5f968.png";

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.02be072a.png";

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.2664e5db.png";

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.36311307.png";

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.ab639b3a.png";

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.f73e7313.png";

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.2ef285ec.png";

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.b35f9f7e.png";

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.b777864e.png";

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.023dd213.png";

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.a86586f3.png";

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.4890f703.png";

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.e868472f.png";

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.9b9be006.png";

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.6b7388b6.png";

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.0cc9945d.png";

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.395debdc.png";

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.b4d1d854.png";

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.c2f72f33.png";

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.69665b1d.png";

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.5982d525.png";

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.f4167ef1.png";

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.33b94090.png";

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.ce4d3873.png";

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.8bbd3fee.png";

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.80021dc0.png";

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.6ed7a63a.png";

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.d5cc64ce.png";

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.ec4857ce.png";

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.06657cc4.png";

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.b9c15ad0.png";

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.440dc1bb.png";

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.52b7fad2.png";

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.0f3d52a0.png";

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.d635feef.png";

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.637987b6.png";

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.d75ab1cf.png";

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.828eebbb.png";

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.1b991c5c.png";

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.2176a4ca.png";

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.d7be3949.png";

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.21f12790.png";

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.5186c787.png";

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.372fd371.png";

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.427e7179.png";

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.b05224a3.png";

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.7e3b1625.png";

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.861e8dda.png";

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.6a9e1c0c.png";

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.d784d8e6.png";

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.c0824049.png";

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.e9ffb06f.png";

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.d3e825cf.png";

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.29648a93.png";

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.2974f368.png";

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.acbcf57f.png";

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.e4fec060.png";

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.143c3d9c.png";

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.1ee79054.png";

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.f5cdc359.png";

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.f60ad3ce.png";

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.a8a8aca1.png";

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.8a24501b.png";

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.f1cc4034.png";

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.10357777.png";

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.85c02fa5.png";

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.bf2aebd2.png";

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.7bb80de1.png";

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.5df25528.png";

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.90166040.png";

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.a0cd9c0c.png";

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.8ca790aa.png";

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.f562f9bf.png";

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.f61232b7.png";

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.c76ca857.png";

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.48147f81.png";

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.dbd6d162.png";

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.f1a3753f.png";

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.3a0f8433.png";

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.0c82b52f.png";

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.845492ce.png";

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.8bf27148.png";

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.e76f703e.png";

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.008edbe2.png";

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.eea442b5.png";

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.4c559c75.png";

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.2bce7006.png";

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.a0a954b3.png";

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.fe5a443c.png";

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.ad36842e.png";

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.cd1299d9.png";

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.b934f420.png";

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.e7da85bc.png";

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.d3612995.png";

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.905a4729.png";

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.84d7dc09.png";

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.6d6dc67d.png";

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.c21c2061.png";

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.53447e6d.png";

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.cf5ff31e.png";

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.43a59c8a.png";

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.aafc6df8.png";

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.39a48e03.png";

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.2e7262ef.png";

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.3a472289.png";

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.397a25cc.png";

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.323463a7.png";

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.842243d4.png";

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.8356dda7.png";

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.09109f46.png";

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.3eb3a7b7.png";

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.8e7f5422.png";

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.5ecc5154.png";

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.558a0b30.png";

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.7b969984.png";

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.57ec2b65.png";

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.a839a751.png";

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.8c4e164f.png";

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.3c00c7e4.png";

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.4e81bd49.png";

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.3c4a74d9.png";

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.4096d77a.png";

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.9ed21e6a.png";

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.ae350865.png";

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.6224709c.png";

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.63bfb973.png";

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.1221b3e8.png";

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.7da4b7cc.png";

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.af4abe62.png";

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.8364d0c4.png";

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.6b34a181.png";

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.146f947a.png";

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.e9915cb0.png";

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.d82a84dc.png";

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.b332cf0b.png";

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.32f93856.png";

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.17f69472.png";

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.d63fdf3e.png";

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.9ba59f76.png";

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.9d8a9ce0.png";

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.8aa11105.png";

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.f3a7d054.png";

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.c07f9bed.png";

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.f5cd2c2e.png";

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.2b72e483.png";

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.7126b923.png";

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.91550f31.png";

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.722a517f.png";

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.0b0e5a63.png";

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.b519826c.png";

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.14fce0ad.png";

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.8a360156.png";

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.72c8f06b.png";

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.6f9e9c6c.png";

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.2c1287cc.png";

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.6e77e476.png";

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.79a095c9.png";

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.ba964de4.png";

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.f742d580.png";

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.31581227.png";

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.ddb19b6f.png";

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.77a58e68.png";

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.fc1a31c7.png";

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.d3bc7bb0.png";

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.a5278234.png";

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.d0df9182.png";

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.fd385ae0.png";

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.1ed8bad8.png";

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.900c2925.png";

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.8a0dead0.png";

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.f9b045df.png";

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.1f9fe1d8.png";

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.0d6cc83f.png";

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.69195309.png";

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.1f34a396.png";

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.27a040f8.png";

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.db82a4eb.png";

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.d760dccc.png";

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.7e45dd5d.png";

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.6320ef36.png";

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.aaecec07.png";

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.7f04d4f2.png";

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.a9c52803.png";

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.d54562fe.png";

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.c7eec43d.png";

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.3ec5b151.png";

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.561d23f0.png";

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.506efb04.png";

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.f0109e85.png";

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.bf356b41.png";

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.18900695.png";

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.1949a8ad.png";

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.ba498565.png";

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.fb9cf579.png";

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.c5d94a94.png";

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.d85e10fb.png";

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.ccdfa5bb.png";

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.3f6c5818.png";

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.6aa1c765.png";

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.384f322e.png";

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.0867bb38.png";

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.027533dc.png";

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.33f98f15.png";

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.3ffce7ba.png";

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.d9e39fd9.png";

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.530b6c38.png";

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.109c8e24.png";

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.e5dca559.png";

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.66926f18.png";

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.5001924b.png";

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.0e71671c.png";

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.8574a34b.png";

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.5f89a4d4.png";

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.d1b32b16.png";

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.1b47de84.png";

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.0a7e6669.png";

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.5923b0f0.png";

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.46512f0e.png";

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.180d7ec4.png";

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.5c52c27d.png";

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.d85c4508.png";

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.c5b09489.png";

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.49047e87.png";

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.c15e302b.png";

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.de9863f2.png";

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.e22e7cf5.png";

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.26228654.png";

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.309fb3f4.png";

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.f2f5c43d.png";

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.895e8e26.png";

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.b131d39f.png";

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.be4b2b10.png";

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.5bb17c36.png";

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.4555af83.png";

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.7a499c94.png";

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.55f19086.png";

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.9915e970.png";

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.b2724e1d.png";

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.cbe91372.png";

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.0089639a.png";

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.e1656a58.png";

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.0bc3d75f.png";

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.9e173f52.png";

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.c913422d.png";

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.2b3ab4c0.png";

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.1a69e09e.png";

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.cba78f10.png";

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.56a51d88.png";

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.1aae6133.png";

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.f7de7aa8.png";

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.3aea5cf0.png";

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.a007a9ef.png";

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.8beb2eac.png";

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.08e01123.png";

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.a912eeb7.png";

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.9017314b.png";

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.76cec4ff.png";

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.a4408141.png";

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.8bc652d0.png";

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.062dc828.png";

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.1882fe18.png";

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.d44e6758.png";

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.3e88e8a7.png";

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.dee4c4f3.png";

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.987891ec.png";

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.edbfdb07.png";

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.b090c7c7.png";

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.4d6d1067.png";

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.8dc1b48a.png";

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.fadd062f.png";

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.bf6b68f7.png";

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.b39c48bc.png";

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.b9204f63.png";

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.9e8936eb.png";

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.206214c7.png";

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.e8b7ba45.png";

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.1c245d0f.png";

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.b02278a9.png";

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.602e12d3.png";

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.ac49a798.png";

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.fc657d18.png";

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.833bf90b.png";

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.2760b11b.png";

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.e6a03ea8.png";

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.72bdcfe6.png";

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.f2c5bdd8.png";

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.03b5aa6c.png";

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.6c2e20b3.png";

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.f0d6de6b.png";

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.08df0b34.png";

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.7fc846af.png";

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.c2727b1d.png";

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.5851d73a.png";

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.bd81f74f.png";

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.6b852079.png";

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.16f468ba.png";

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.4a290127.png";

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.4ab62d15.png";

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.c14a22f2.png";

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.7bd4ce9d.png";

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.ebdd170d.png";

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.af6f97ae.png";

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.ba9f5d42.png";

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.521dab8b.png";

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.8f43dbfe.png";

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.9a68c85e.png";

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.33776bba.png";

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.85aa511d.png";

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.c1b5886f.png";

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.769579e0.png";

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.0dcb0a48.png";

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.f2b41111.png";

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.5b8c43ae.png";

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.0eaed86f.png";

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.3fba0aa5.png";

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.9fde8482.png";

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.9341ecc4.png";

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.9a5185cc.png";

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.e03dbd01.png";

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.fe72c5a9.png";

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.ae595e64.png";

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.ebbc54e6.png";

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.76670add.png";

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.bb2eba39.png";

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.81186330.png";

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.10c7cb33.png";

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.be211b13.png";

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.7dc0ebcd.png";

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.fa35ed9e.png";

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.76ba9bff.png";

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.b351fc29.png";

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.5c9bff29.png";

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.66afb239.png";

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.bb31f5cb.png";

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.11d32fd2.png";

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.7db50879.png";

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.7eaa3536.png";

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.5cde3afb.png";

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.6e74fd0c.png";

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.4683dbde.png";

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.43bf80c9.png";

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.53aea016.png";

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.3b15a42b.png";

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.080894c0.png";

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.7c52ee12.png";

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.213d59e2.png";

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.3a368d18.png";

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.124be68d.png";

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.ce8c405a.png";

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.e0934f80.png";

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.6a863618.png";

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.33401006.png";

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.10401802.png";

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.010aa8e7.png";

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.21875f0c.png";

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.1b7213b5.png";

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.64b8881b.png";

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.dd6c053d.png";

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.df266330.png";

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.b8b8ffc6.png";

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.782ee207.png";

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.2ef73717.png";

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.5b9dc109.png";

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.1761a58d.png";

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.7b01dc26.png";

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.da55e019.png";

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.7651d777.png";

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.9f2a471c.png";

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.6ee1d8c0.png";

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.ef19fc96.png";

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.04049835.png";

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.02d8fd65.png";

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.eb78006d.png";

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.5ac19d5e.png";

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.7e89c1e0.png";

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0019.d5b59528.png";

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0020.e11f1931.png";

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0021.31ba7ba3.png";

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0022.9858f8a5.png";

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0023.f0614213.png";

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0024.ff4a9ce7.png";

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0025.3c79cdbd.png";

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0026.a08bb224.png";

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0027.c56f2562.png";

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0028.b374e832.png";

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0029.0d9e8bbb.png";

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0030.349bc378.png";

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0031.a12bc80e.png";

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0032.83f2b95e.png";

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0033.067acacc.png";

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0034.90195255.png";

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0035.257396c7.png";

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0036.c656e4c2.png";

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0037.0565901d.png";

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0038.f9fe2525.png";

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0039.1e435df9.png";

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0040.cbcc926e.png";

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0041.b2b7b27e.png";

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0042.314078ce.png";

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0043.74f15131.png";

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0044.3d0bb8d4.png";

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0045.6bd0b530.png";

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0046.3dabeb5c.png";

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0047.89777d96.png";

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0048.2e440422.png";

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.08a84eda.png";

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.208548b0.png";

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.d9141717.png";

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.2ccef2b6.png";

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.5a9f67fc.png";

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.6bceab4d.png";

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.3a5e0ba6.png";

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.d07a5b0d.png";

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.0b8494af.png";

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.8a2bc862.png";

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.7ed67cca.png";

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.a2e04f8b.png";

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.23e48e3d.png";

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.18e61f5f.png";

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.5b685a7f.png";

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.581e464d.png";

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.3e695029.png";

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.36218a8f.png";

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.ad73a1e7.png";

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0019.1c9a4a8a.png";

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0020.541c42b2.png";

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0021.0d73817e.png";

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0022.fcad1c1d.png";

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0023.f057bb3b.png";

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0024.2c28ba1d.png";

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0025.be0081f8.png";

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0026.407c8bd9.png";

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0027.3a81ba36.png";

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0028.08e7a7cf.png";

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0029.9ca4b150.png";

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0030.6c5d9e3c.png";

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0031.fa641fba.png";

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0032.ac17ee67.png";

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0033.b0224641.png";

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0034.bf7cc649.png";

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0035.9e440e5a.png";

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0036.f95bf656.png";

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0037.8472ea94.png";

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0038.48eb558e.png";

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0039.56f80d77.png";

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0040.51a3fdd2.png";

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0041.e02cafe1.png";

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0042.ee91bd41.png";

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0043.c731cfc7.png";

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0044.5cf8c0d2.png";

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0045.41bd93c4.png";

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0046.c0e91555.png";

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0047.1a55d2ed.png";

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0048.58fe3096.png";

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.5c66786e.png";

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.dc036e1b.png";

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.2fc50e4b.png";

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.fef00f7c.png";

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.6f708323.png";

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.4e39668d.png";

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.de069ca3.png";

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.9a65961e.png";

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.e97883c1.png";

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.978ef33e.png";

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.ae8679b1.png";

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.777de610.png";

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.8bb99edf.png";

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.75ef17fa.png";

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.5b5800e5.png";

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.ae898875.png";

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.54368a2e.png";

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.e546efa6.png";

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.29f2d782.png";

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.73c90720.png";

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.d2d15e1c.png";

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.656cbad2.png";

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.3b9fb30f.png";

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.db18aa76.png";

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.dc46863f.png";

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.22427073.png";

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.e3f325ac.png";

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.01ead641.png";

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0019.acde895e.png";

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0020.ebb8c58f.png";

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0021.14c01275.png";

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0022.097b95e6.png";

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0023.ea565c96.png";

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0024.b7fc422b.png";

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0025.e0ef884a.png";

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0026.44e9ca57.png";

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0027.badfd927.png";

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0028.27ec52cb.png";

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0029.67ed6d4c.png";

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0030.1caebaf6.png";

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0031.88b1135c.png";

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0032.390feed0.png";

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0033.0f71872a.png";

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0034.2e481005.png";

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0035.cc8c72f9.png";

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0036.54466bea.png";

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0037.c4fd4693.png";

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0038.ed80818f.png";

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.1683e581.png";

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.baf506b8.png";

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.8d23b80a.png";

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.8be100e2.png";

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.d7de611f.png";

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.4d762769.png";

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.9e5294d3.png";

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.82e79197.png";

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.5f7c489e.png";

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.0f8e17cf.png";

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.6e04ac07.png";

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.3ab74d93.png";

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.567360a8.png";

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.8820e5a0.png";

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.a0cab187.png";

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.9f6e77c9.png";

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.e6a4c044.png";

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.33ac115d.png";

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0019.88defad5.png";

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0020.eed4f6ba.png";

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0021.8fdb2dfc.png";

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0022.85df87cc.png";

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0023.d9566069.png";

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0024.b8cef7aa.png";

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0025.45536530.png";

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0026.56c586f3.png";

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0027.98db20d1.png";

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0028.11e899b2.png";

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0029.0cebe75a.png";

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0030.d56e2530.png";

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0031.019ec48c.png";

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0032.72927a49.png";

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0033.d57f2217.png";

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0034.d5429cd0.png";

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0035.c17716f4.png";

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0036.a81126df.png";

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0037.8774d5c6.png";

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0038.5b93e71d.png";

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.0c0dcc56.png";

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.be5573e2.png";

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.4a5601c8.png";

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.896eb3ea.png";

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.f95b7ee6.png";

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.014a9eca.png";

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.28e56d90.png";

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.a06764c4.png";

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.4da6c386.png";

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.ddf4dcce.png";

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.bcc6f3aa.png";

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.175eee80.png";

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.6138e394.png";

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.37b5b5ff.png";

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.49cb18f2.png";

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.3de17089.png";

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.f355681b.png";

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.716ce29e.png";

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.251c4275.png";

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.ae83217c.png";

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.99813d2c.png";

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.a2eae227.png";

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.6bb28a2d.png";

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.52bdba55.png";

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.2320d106.png";

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.b9c384c3.png";

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.727334be.png";

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.89a5af19.png";

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.f1d882f7.png";

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.27676335.png";

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.280e9e7e.png";

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.8acb8847.png";

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.b63fbe3d.png";

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.b5af6c46.png";

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.8ddedd9c.png";

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.3a74ba0e.png";

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.c5c24f75.png";

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.cbef6faf.png";

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.7e8f0c9a.png";

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.05c4a200.png";

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.bbeda92e.png";

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.239140a2.png";

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.e995cc56.png";

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.683ed78d.png";

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.84343c3d.png";

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.62b71b77.png";

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.defe69fe.png";

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.367aa2c5.png";

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.07da80c0.png";

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.24043430.png";

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.977f4faf.png";

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.fd6b4fc0.png";

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.d1144339.png";

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.6f7a9110.png";

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.8d47a7f8.png";

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.e282854b.png";

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.52f0b6d1.png";

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.095baabe.png";

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.1515dc35.png";

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.4cdcd750.png";

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.8273a4d7.png";

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.1cd8d6e3.png";

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.bc79fe12.png";

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.89e5de09.png";

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.1dd7165b.png";

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.4f293db4.png";

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.a929a18d.png";

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.cf84c97c.png";

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.b4f1d9cc.png";

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.19bd81df.png";

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.af124cef.png";

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.5d42fb1a.png";

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.928247df.png";

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.c8ec5e27.png";

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.9dfe353a.png";

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.20c3affd.png";

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.c4c875b3.png";

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.dba4ed08.png";

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.ee721ac9.png";

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.a7361641.png";

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.27f30bc2.png";

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.af83cb1f.png";

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.b49633ad.png";

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.d56681f5.png";

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.d72c785b.png";

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.6e73a4d3.png";

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.1b11c66e.png";

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.52ed2ffa.png";

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.3970290d.png";

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.fd790729.png";

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.8ae61714.png";

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.1cbbb5a6.png";

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.ac0df05a.png";

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.9629f6c0.png";

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.497ed3f5.png";

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.782692ad.png";

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.bedd6e2a.png";

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.ff501a49.png";

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.e0ecf4ce.png";

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.00321e63.png";

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.39c7c07a.png";

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.14e7dc23.png";

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.da70d2ec.png";

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.37cb7a63.png";

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.775b5234.png";

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.d0b29b82.png";

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.f0bb7b70.png";

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.7e64ef5d.png";

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.58cf2eed.png";

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.f9048ed9.png";

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.1dd168f7.png";

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.99791d82.png";

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.0539ee60.png";

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.c2db94d8.png";

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.fe1e7161.png";

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.385150a8.png";

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.60aaa43a.png";

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.3993d31e.png";

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.9cf3c3c8.png";

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.cc5aa3d8.png";

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.b5161a96.png";

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.d738e41a.png";

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.f1e01afd.png";

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.291841ca.png";

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.9c00c2bb.png";

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.d73bbb6b.png";

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.76ecc8d9.png";

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.5869f345.png";

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.6ae7d98a.png";

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.7bbd8ca9.png";

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.140e6ba2.png";

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.6e26716f.png";

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.2e49646c.png";

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.9f352d3b.png";

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.87de924c.png";

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.33a6b109.png";

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.47121b88.png";

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.e9f02c57.png";

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.dd103cdf.png";

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.14654f64.png";

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.86888669.png";

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.7fd6397e.png";

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.ce7c361e.png";

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.8af53e1e.png";

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.c836cb11.png";

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.8e7b40cf.png";

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.d7d35ece.png";

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.4ecc9391.png";

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.dd62f08a.png";

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.4bd36bec.png";

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.900958a8.png";

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.43f0209b.png";

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.e1d8aa10.png";

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.9a791a33.png";

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.eaa63492.png";

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.85cc332a.png";

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.9077a4c0.png";

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.c130d96b.png";

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.b5521ca1.png";

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.4b63ae98.png";

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.2a8ee08c.png";

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.482ceaea.png";

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.cd14ca9f.png";

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.b97a318e.png";

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.5c59ec87.png";

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.11504a7f.png";

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.cb8d38fb.png";

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.35eb9e47.png";

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.d78a4829.png";

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.acdcecdb.png";

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.4e360fa6.png";

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.8c584b04.png";

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.3bb2994e.png";

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.b0807046.png";

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.c49e70f9.png";

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.920cd933.png";

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.3e0d968a.png";

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.177bcc6a.png";

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.cc6c6439.png";

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.3c59784f.png";

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.0c323f56.png";

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.f43c496e.png";

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.d5047106.png";

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.6c6ffc0b.png";

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.5b1cd9ed.png";

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.1c116e92.png";

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.977c13e2.png";

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.56e62925.png";

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.a648c496.png";

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.0af13a1f.png";

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.6e08f7d5.png";

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.0ada9386.png";

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.08ecdc4c.png";

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.7617e9bb.png";

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.e6316e95.png";

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.3ff2f021.png";

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.cb873f11.png";

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.ac77dc58.png";

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.294c1046.png";

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.943b04b2.png";

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.b5b6e10e.png";

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.2548adb0.png";

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.df2cd49f.png";

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.6e065300.png";

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.b2bea7da.png";

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.3c83c682.png";

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.2b287700.png";

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.0ccbb359.png";

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.9c2a4643.png";

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.5f7b574c.png";

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.6a1d68b7.png";

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.422b0aae.png";

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.4ef8c337.png";

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.9dbdff09.png";

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.4b681650.png";

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.77676fe3.png";

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.cefe3fb8.png";

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.d03412d7.png";

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.ad42774e.png";

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.30ebe797.png";

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.3744e629.png";

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.c384e449.png";

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.a993dacf.png";

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.74eef1e0.png";

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.57946c86.png";

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.5472fb2e.png";

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.bb657198.png";

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.9668e71e.png";

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.eb1bfa7a.png";

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.0e47bff7.png";

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.fb613f14.png";

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.d4bcdd4e.png";

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.8c389bd1.png";

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.85c7c9c4.png";

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.fb704057.png";

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.cd231600.png";

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.d7d20186.png";

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.3adaaadc.png";

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.7a41a051.png";

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.ba5621ae.png";

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.b1922c10.png";

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.32ac34ca.png";

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.4ba06d4b.png";

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.e72426aa.png";

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.2343f970.png";

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.34f45b27.png";

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.ce3faddc.png";

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.d156e4fe.png";

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.9c85ef74.png";

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.c10f59ec.png";

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.ec900e7d.png";

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.6f83481f.png";

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.4d20482c.png";

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.0ccec9a7.png";

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.32c80026.png";

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.6ca52bc1.png";

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.bcd1afc5.png";

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.c5f60750.png";

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.37ee7f1a.png";

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.415ac8b6.png";

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.b06bd72f.png";

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.5234334e.png";

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.a91fa133.png";

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.6728e046.png";

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.2fd8b026.png";

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.121ab771.png";

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.dde72bda.png";

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.a24f064f.png";

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.b0c52fb7.png";

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.76183550.png";

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.48efc226.png";

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.b4a154b1.png";

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.3b1ff92d.png";

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.2947f113.png";

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.b2a8beff.png";

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.6ea47f5c.png";

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.f3940fc7.png";

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.60824ecc.png";

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.dba579f2.png";

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.5d70f483.png";

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.03844d94.png";

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.3a6aa130.png";

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.d112cb98.png";

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.bcb37451.png";

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.364385b3.png";

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.499c73b0.png";

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.74e73fce.png";

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.3a039eeb.png";

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.cdaca41f.png";

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.ac577edd.png";

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.0df601f7.png";

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.0681e1ad.png";

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.abb53293.png";

/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.66d2dd09.png";

/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.c5d1fb4b.png";

/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.542227a0.png";

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.bec986fa.png";

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.07e946c0.png";

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.9ee8b9b0.png";

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.ab88d822.png";

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.59f38189.png";

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.8b862145.png";

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.05b7bf56.png";

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.60ac9acc.png";

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.fb6fe4b4.png";

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.5ff32655.png";

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.a3e91727.png";

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.4f59a026.png";

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.471029f0.png";

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.93e1d2ee.png";

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.a1fecc7a.png";

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.65a07e02.png";

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.9f655700.png";

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.2db5a1c8.png";

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.eb6207e4.png";

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.8e3c1e71.png";

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.38acc346.png";

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.d0207114.png";

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.8afefd4d.png";

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.32c08b61.png";

/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.7d211e5c.png";

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.cc09ee6a.png";

/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.3a01d715.png";

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.24c10f2f.png";

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.06e20aca.png";

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.dbda0cba.png";

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.3b17a9cf.png";

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.55cd2704.png";

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.f94cb81a.png";

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.8a329d0c.png";

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.3c255b82.png";

/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.30e95e08.png";

/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.86952fc2.png";

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.44c417a1.png";

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.381819b5.png";

/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.f584b390.png";

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.21d19c96.png";

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.f7f69678.png";

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.be2ae7f2.png";

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.2e13b164.png";

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.a1060ab2.png";

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.eb7f9d76.png";

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.68725470.png";

/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.22604d1b.png";

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.83cad8cd.png";

/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.59388592.png";

/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.d342d171.png";

/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.f946ed3f.png";

/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.94fc7708.png";

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.ea5b345e.png";

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.35e4d13a.png";

/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.759f98a7.png";

/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.25f7dea8.png";

/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.f33cb3c0.png";

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.e33bde89.png";

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.ac1f56d7.png";

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.df0598df.png";

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.8dc6458b.png";

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.5759c501.png";

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.955a7e8d.png";

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.2278d512.png";

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.4fe8d496.png";

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.8728bb8f.png";

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.3669b804.png";

/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.481bc9d0.png";

/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.5eb91ee6.png";

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.f2684ab6.png";

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.be2ae344.png";

/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.c85c4cb0.png";

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.8472fdd9.png";

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.964df13c.png";

/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.c8f60373.png";

/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.98cf8cb9.png";

/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.63bbe227.png";

/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.12d6dcce.png";

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.5217a746.png";

/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.4aac20d4.png";

/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.39080640.png";

/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.340d17d5.png";

/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.33ea57a4.png";

/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.2029832b.png";

/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.82805d95.png";

/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.c23e9e93.png";

/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.402df42f.png";

/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.958cac65.png";

/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.64587827.png";

/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.75eb3a8b.png";

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.11a1fb86.png";

/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.8f8b00d8.png";

/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.78bf206a.png";

/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.7977d745.png";

/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.c2c4c8f6.png";

/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.2e3b7c76.png";

/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.75697d38.png";

/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.3e9c9b2c.png";

/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.b28435f5.png";

/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.715e69ed.png";

/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.2d2d79d2.png";

/***/ }),
/* 2151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.bc412400.png";

/***/ }),
/* 2152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.e2b3cf76.png";

/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.a6a57cf9.png";

/***/ }),
/* 2154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.0f5083e2.png";

/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.d7af0ce5.png";

/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.92e237b5.png";

/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.4a0dc161.png";

/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.500f1f58.png";

/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.9409d1b4.png";

/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.d319bb41.png";

/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.d92d27c4.png";

/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.d1c10efa.png";

/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.f0cc7368.png";

/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.6304b52a.png";

/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.41ccd913.png";

/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.f254c619.png";

/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.2bf18364.png";

/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.33902f07.png";

/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.89bc78bf.png";

/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.ab6643b8.png";

/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.2b4a9171.png";

/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.2c9bfca3.png";

/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.53298c33.png";

/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.ee0522b0.png";

/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.2f469d29.png";

/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.97b2cffe.png";

/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.db06dc98.png";

/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.333af5e3.png";

/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.8e141cd0.png";

/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.31afbd62.png";

/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.b7b9de8c.png";

/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.22e89131.png";

/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.66c2ddf9.png";

/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.3a84b201.png";

/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.f445a2ef.png";

/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.b59befd0.png";

/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.858b6c78.png";

/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.1799f79f.png";

/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.826d0d5b.png";

/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.9813092a.png";

/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.0e1bac28.png";

/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.d07e267a.png";

/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.f7d7b4b1.png";

/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.b6311a4d.png";

/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.cdee7a1e.png";

/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.7cdcb6ea.png";

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.bf8696e3.png";

/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.4f569a0f.png";

/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.9254899b.png";

/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.69cc04ac.png";

/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.9611b6fa.png";

/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.ddbefaa7.png";

/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.74eb7740.png";

/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.afe29bee.png";

/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.c21bd7e3.png";

/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.d2c1828c.png";

/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.a1b739b1.png";

/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.a5f4e3a7.png";

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.56407622.png";

/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.122401ee.png";

/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.5b942bdf.png";

/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.dbf37988.png";

/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.cade0fb4.png";

/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.305080c4.png";

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.c48381a7.png";

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.df825754.png";

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.cbaa695a.png";

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.376e12a3.png";

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.12af032f.png";

/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.f8c279ed.png";

/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.2fd3c630.png";

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.09965694.png";

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.f41bbed5.png";

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.db2fea02.png";

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.b684cdb9.png";

/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.b25b41d8.png";

/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.60afd54b.png";

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.18ca1cb7.png";

/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.cccc1b62.png";

/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.2174d318.png";

/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.0a034a77.png";

/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.b7e46d76.png";

/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.db30576e.png";

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.9b92aad8.png";

/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.51347ce0.png";

/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.5f9855ae.png";

/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.c6bf16d3.png";

/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.fb18ef6e.png";

/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.ae151ccf.png";

/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.c5dafec8.png";

/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.0db24858.png";

/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.75cf95ee.png";

/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.c0478440.png";

/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.78ecaf03.png";

/***/ }),
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.edc051c3.png";

/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.9c1e17a6.png";

/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.03cccee3.png";

/***/ }),
/* 2248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.0593f5ac.png";

/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.c100ab12.png";

/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.77a66064.png";

/***/ }),
/* 2251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.461b9340.png";

/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.e6a666f4.png";

/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.8f3a92e5.png";

/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.903a8b3b.png";

/***/ }),
/* 2255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.feeebbfd.png";

/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.2686192c.png";

/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.9bd031ac.png";

/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.16cbe40f.png";

/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.033d9f90.png";

/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.27dce0f9.png";

/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.9d052173.png";

/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.667d292e.png";

/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.07e983b3.png";

/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.bab466b1.png";

/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.5b551b41.png";

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.e7fb5d43.png";

/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.5774bed1.png";

/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.6b9c8493.png";

/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.31f2c308.png";

/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.0404880e.png";

/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.5a49ee5b.png";

/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.357e310a.png";

/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.9863deb1.png";

/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.a4e7e170.png";

/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.f7bd2b54.png";

/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.7c8db413.png";

/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.3dd3f87e.png";

/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.ecba8e36.png";

/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.78e21923.png";

/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.cab4f8bf.png";

/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.2fa6a400.png";

/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.9807e4a5.png";

/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.51932546.png";

/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.e34d0905.png";

/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.b87977e4.png";

/***/ }),
/* 2286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.5f0aa72f.png";

/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.f9de1abf.png";

/***/ }),
/* 2288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.89052666.png";

/***/ }),
/* 2289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.e36bb63f.png";

/***/ }),
/* 2290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.14ec0fd9.png";

/***/ }),
/* 2291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.2ebafe8e.png";

/***/ }),
/* 2292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.410e4aa4.png";

/***/ }),
/* 2293 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.92b0d35e.png";

/***/ }),
/* 2294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.a60b2fa2.png";

/***/ }),
/* 2295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.5b073890.png";

/***/ }),
/* 2296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.e1786151.png";

/***/ }),
/* 2297 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.0ebad427.png";

/***/ }),
/* 2298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.8f3e2556.png";

/***/ }),
/* 2299 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.28bafd17.png";

/***/ }),
/* 2300 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.19269fa5.png";

/***/ }),
/* 2301 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.7066b926.png";

/***/ }),
/* 2302 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.804099cb.png";

/***/ }),
/* 2303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.ff4548ec.png";

/***/ }),
/* 2304 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.07aeea9a.png";

/***/ }),
/* 2305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.6427bdde.png";

/***/ }),
/* 2306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.a0927613.png";

/***/ }),
/* 2307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.a95d2f22.png";

/***/ }),
/* 2308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.996a778d.png";

/***/ }),
/* 2309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.aae2db64.png";

/***/ }),
/* 2310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.e549d25c.png";

/***/ }),
/* 2311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.abe4ab02.png";

/***/ }),
/* 2312 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.da068deb.png";

/***/ }),
/* 2313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.fd049fdd.png";

/***/ }),
/* 2314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.601c3f89.png";

/***/ }),
/* 2315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.06a3aa63.png";

/***/ }),
/* 2316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.5782a71d.png";

/***/ }),
/* 2317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.4308dd52.png";

/***/ }),
/* 2318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.b9e196f1.png";

/***/ }),
/* 2319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.fb49908e.png";

/***/ }),
/* 2320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.1c1131b1.png";

/***/ }),
/* 2321 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.499137c0.png";

/***/ }),
/* 2322 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.f87d2143.png";

/***/ }),
/* 2323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.e1da3d44.png";

/***/ }),
/* 2324 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.aea56c52.png";

/***/ }),
/* 2325 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.af0c17ad.png";

/***/ }),
/* 2326 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.29a934e1.png";

/***/ }),
/* 2327 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.41b7b9c4.png";

/***/ }),
/* 2328 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.5f79e1b7.png";

/***/ }),
/* 2329 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.5553a936.png";

/***/ }),
/* 2330 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.5bb2ab90.png";

/***/ }),
/* 2331 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.bb1f2185.png";

/***/ }),
/* 2332 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.98868ccf.png";

/***/ }),
/* 2333 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.f6454633.png";

/***/ }),
/* 2334 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.8ae60f27.png";

/***/ }),
/* 2335 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.3e6aa638.png";

/***/ }),
/* 2336 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.493e973b.png";

/***/ }),
/* 2337 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.b6da5c62.png";

/***/ }),
/* 2338 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.b1d27e1c.png";

/***/ }),
/* 2339 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.5ef801e9.png";

/***/ }),
/* 2340 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.e529ebc0.png";

/***/ }),
/* 2341 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.8899be30.png";

/***/ }),
/* 2342 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.84a473be.png";

/***/ }),
/* 2343 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.bf12155f.png";

/***/ }),
/* 2344 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.ca25d9ab.png";

/***/ }),
/* 2345 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.519ed014.png";

/***/ }),
/* 2346 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.6b53cf0a.png";

/***/ }),
/* 2347 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.1e075049.png";

/***/ }),
/* 2348 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.32b93e6d.png";

/***/ }),
/* 2349 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.2f61e621.png";

/***/ }),
/* 2350 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.e362a998.png";

/***/ }),
/* 2351 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.fb615ffa.png";

/***/ }),
/* 2352 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.0764d2fc.png";

/***/ }),
/* 2353 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.90a457a2.png";

/***/ }),
/* 2354 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.c1b75644.png";

/***/ }),
/* 2355 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.d7e3b9cf.png";

/***/ }),
/* 2356 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.b4692d97.png";

/***/ }),
/* 2357 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.7107ef79.png";

/***/ }),
/* 2358 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.327f48d8.png";

/***/ }),
/* 2359 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.34e32bbc.png";

/***/ }),
/* 2360 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.5c2ba788.png";

/***/ }),
/* 2361 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.57221e50.png";

/***/ }),
/* 2362 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.6eb7b729.png";

/***/ }),
/* 2363 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.45484d8c.png";

/***/ }),
/* 2364 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.0d16b5c5.png";

/***/ }),
/* 2365 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.a8573969.png";

/***/ }),
/* 2366 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.50fe9c73.png";

/***/ }),
/* 2367 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.a835579c.png";

/***/ }),
/* 2368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.51fca62f.png";

/***/ }),
/* 2369 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.d5b231ab.png";

/***/ }),
/* 2370 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.b8e0db0c.png";

/***/ }),
/* 2371 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.45680663.png";

/***/ }),
/* 2372 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.fd18139f.png";

/***/ }),
/* 2373 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.92eab61b.png";

/***/ }),
/* 2374 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.b495fc15.png";

/***/ }),
/* 2375 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.5e18e8e7.png";

/***/ }),
/* 2376 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.73a990bd.png";

/***/ }),
/* 2377 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.114c437b.png";

/***/ }),
/* 2378 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.b3a2d672.png";

/***/ }),
/* 2379 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.2e50ee8a.png";

/***/ }),
/* 2380 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.40cd02ad.png";

/***/ }),
/* 2381 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.42f7db4d.png";

/***/ }),
/* 2382 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.ba96fddf.png";

/***/ }),
/* 2383 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.6857e36d.png";

/***/ }),
/* 2384 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.bd94f905.png";

/***/ }),
/* 2385 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.4db11437.png";

/***/ }),
/* 2386 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.ac47c575.png";

/***/ }),
/* 2387 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.600de9d2.png";

/***/ }),
/* 2388 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.5565f62e.png";

/***/ }),
/* 2389 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.823b893b.png";

/***/ }),
/* 2390 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.375c66cd.png";

/***/ }),
/* 2391 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.51f573a2.png";

/***/ }),
/* 2392 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.b9871703.png";

/***/ }),
/* 2393 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.4384050a.png";

/***/ }),
/* 2394 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.779dd04e.png";

/***/ }),
/* 2395 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.58348ecf.png";

/***/ }),
/* 2396 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.bdf77bd4.png";

/***/ }),
/* 2397 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.e38d90bc.png";

/***/ }),
/* 2398 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.81098c59.png";

/***/ }),
/* 2399 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.9437f8b3.png";

/***/ }),
/* 2400 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.84fcc6da.png";

/***/ }),
/* 2401 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.a3690c3c.png";

/***/ }),
/* 2402 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.8ad3b488.png";

/***/ }),
/* 2403 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.aa4b4ca7.png";

/***/ }),
/* 2404 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.f61b014a.png";

/***/ }),
/* 2405 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.e782e3d9.png";

/***/ }),
/* 2406 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.a648706b.png";

/***/ }),
/* 2407 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.aee354f4.png";

/***/ }),
/* 2408 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.cdf19a93.png";

/***/ }),
/* 2409 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.4ceaf338.png";

/***/ }),
/* 2410 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.c4eefced.png";

/***/ }),
/* 2411 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.73af3a3a.png";

/***/ }),
/* 2412 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.f89a4a82.png";

/***/ }),
/* 2413 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.b8c7fbdf.png";

/***/ }),
/* 2414 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.630bfcd3.png";

/***/ }),
/* 2415 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.c7346918.png";

/***/ }),
/* 2416 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.8356f7f1.png";

/***/ }),
/* 2417 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.2a01aaff.png";

/***/ }),
/* 2418 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.99a69cb5.png";

/***/ }),
/* 2419 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.253285c9.png";

/***/ }),
/* 2420 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.a4984f45.png";

/***/ }),
/* 2421 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.67c89ad0.png";

/***/ }),
/* 2422 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.9edcb4d2.png";

/***/ }),
/* 2423 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.3be46939.png";

/***/ }),
/* 2424 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.01bc6dbf.png";

/***/ }),
/* 2425 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.a8a32622.png";

/***/ }),
/* 2426 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.0335df90.png";

/***/ }),
/* 2427 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.7030706c.png";

/***/ }),
/* 2428 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.4c6d4b28.png";

/***/ }),
/* 2429 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.fa2d54e1.png";

/***/ }),
/* 2430 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.bb33e1b0.png";

/***/ }),
/* 2431 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.46e678f5.png";

/***/ }),
/* 2432 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.db755f62.png";

/***/ }),
/* 2433 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.446dd1b7.png";

/***/ }),
/* 2434 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.20d615dd.png";

/***/ }),
/* 2435 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.68fef414.png";

/***/ }),
/* 2436 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.d5d76764.png";

/***/ }),
/* 2437 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.89c85f84.png";

/***/ }),
/* 2438 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.a93d9d9a.png";

/***/ }),
/* 2439 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.68720ce2.png";

/***/ }),
/* 2440 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.8fa30dbc.png";

/***/ }),
/* 2441 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.0c424713.png";

/***/ }),
/* 2442 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.26a666e1.png";

/***/ }),
/* 2443 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.b8f4c0fb.png";

/***/ }),
/* 2444 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.af581780.png";

/***/ }),
/* 2445 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.eaec4ae6.png";

/***/ }),
/* 2446 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.a561c1d2.png";

/***/ }),
/* 2447 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.9136442d.png";

/***/ }),
/* 2448 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.754926c9.png";

/***/ }),
/* 2449 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.33a2284c.png";

/***/ }),
/* 2450 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.4cdad95e.png";

/***/ }),
/* 2451 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.13fcc294.png";

/***/ }),
/* 2452 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.208c177e.png";

/***/ }),
/* 2453 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.176ecc36.png";

/***/ }),
/* 2454 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.0bd2819a.png";

/***/ }),
/* 2455 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0019.6e7aebc7.png";

/***/ }),
/* 2456 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0020.6d61746f.png";

/***/ }),
/* 2457 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0021.6f018b25.png";

/***/ }),
/* 2458 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0022.535e247c.png";

/***/ }),
/* 2459 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0023.057c5a36.png";

/***/ }),
/* 2460 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0024.db11055a.png";

/***/ }),
/* 2461 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0025.2202dd70.png";

/***/ }),
/* 2462 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0026.ec8dd529.png";

/***/ }),
/* 2463 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0027.95ebf105.png";

/***/ }),
/* 2464 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0028.e3fe9b28.png";

/***/ }),
/* 2465 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0029.3713f7f8.png";

/***/ }),
/* 2466 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0030.1552b335.png";

/***/ }),
/* 2467 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0031.efdfeb7f.png";

/***/ }),
/* 2468 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0032.3a83cd96.png";

/***/ }),
/* 2469 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0033.b47de19a.png";

/***/ }),
/* 2470 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0034.329d100f.png";

/***/ }),
/* 2471 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0035.396d2087.png";

/***/ }),
/* 2472 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0036.d90e1615.png";

/***/ }),
/* 2473 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0037.dfb9f610.png";

/***/ }),
/* 2474 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0038.acde30b6.png";

/***/ }),
/* 2475 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0039.cfd7a43b.png";

/***/ }),
/* 2476 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0040.00cee3b9.png";

/***/ }),
/* 2477 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0041.281b79ff.png";

/***/ }),
/* 2478 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0042.9586e72d.png";

/***/ }),
/* 2479 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0043.71dbd013.png";

/***/ }),
/* 2480 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0044.bce76775.png";

/***/ }),
/* 2481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0045.caadb749.png";

/***/ }),
/* 2482 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0046.c406f2d0.png";

/***/ }),
/* 2483 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0047.7da3154f.png";

/***/ }),
/* 2484 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0048.572c44cf.png";

/***/ }),
/* 2485 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.ac2f7fe1.png";

/***/ }),
/* 2486 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.dfc176fd.png";

/***/ }),
/* 2487 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.f2fcfa2e.png";

/***/ }),
/* 2488 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.720cea40.png";

/***/ }),
/* 2489 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.388061ab.png";

/***/ }),
/* 2490 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.a1511084.png";

/***/ }),
/* 2491 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.586f9ca2.png";

/***/ }),
/* 2492 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.f1c126b3.png";

/***/ }),
/* 2493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.3be6f308.png";

/***/ }),
/* 2494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.f6d018dd.png";

/***/ }),
/* 2495 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.c3bd40d3.png";

/***/ }),
/* 2496 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.7e1054b9.png";

/***/ }),
/* 2497 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.d89b4865.png";

/***/ }),
/* 2498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.17f6a143.png";

/***/ }),
/* 2499 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.5519a116.png";

/***/ }),
/* 2500 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.444010f2.png";

/***/ }),
/* 2501 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.5c9995f6.png";

/***/ }),
/* 2502 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.288a7385.png";

/***/ }),
/* 2503 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.7c0fbc5d.png";

/***/ }),
/* 2504 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0019.0a1b62be.png";

/***/ }),
/* 2505 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0020.d602045f.png";

/***/ }),
/* 2506 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0021.fd38aac7.png";

/***/ }),
/* 2507 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0022.2ee7fda7.png";

/***/ }),
/* 2508 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0023.37cb9cde.png";

/***/ }),
/* 2509 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0024.14498f17.png";

/***/ }),
/* 2510 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0025.dc13286a.png";

/***/ }),
/* 2511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0026.37b9ba56.png";

/***/ }),
/* 2512 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0027.17545171.png";

/***/ }),
/* 2513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0028.fc73bd89.png";

/***/ }),
/* 2514 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0029.56096b50.png";

/***/ }),
/* 2515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0030.9658f524.png";

/***/ }),
/* 2516 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0031.93381658.png";

/***/ }),
/* 2517 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0032.3144337f.png";

/***/ }),
/* 2518 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0033.d2831872.png";

/***/ }),
/* 2519 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0034.afe38576.png";

/***/ }),
/* 2520 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0035.b6a3d9c6.png";

/***/ }),
/* 2521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0036.5f978084.png";

/***/ }),
/* 2522 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0037.1d631bac.png";

/***/ }),
/* 2523 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0038.a46d910a.png";

/***/ }),
/* 2524 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0039.dfbf74b2.png";

/***/ }),
/* 2525 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0040.69702696.png";

/***/ }),
/* 2526 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0041.c1009d73.png";

/***/ }),
/* 2527 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0042.f9e5b5ad.png";

/***/ }),
/* 2528 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0043.41352afb.png";

/***/ }),
/* 2529 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0044.387a2c49.png";

/***/ }),
/* 2530 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0045.e5171666.png";

/***/ }),
/* 2531 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0046.7b258d7a.png";

/***/ }),
/* 2532 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0047.a24eb607.png";

/***/ }),
/* 2533 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0048.44d72b0d.png";

/***/ }),
/* 2534 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.dddacf0f.png";

/***/ }),
/* 2535 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.f2932b46.png";

/***/ }),
/* 2536 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.211fa5db.png";

/***/ }),
/* 2537 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.86350663.png";

/***/ }),
/* 2538 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.4a128e96.png";

/***/ }),
/* 2539 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.a482af21.png";

/***/ }),
/* 2540 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.ff8bd56c.png";

/***/ }),
/* 2541 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.6fedb461.png";

/***/ }),
/* 2542 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.f9a4bed6.png";

/***/ }),
/* 2543 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.aea6e20f.png";

/***/ }),
/* 2544 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.c47f4620.png";

/***/ }),
/* 2545 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.9ed1bccd.png";

/***/ }),
/* 2546 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.e1dab880.png";

/***/ }),
/* 2547 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.05c0ad87.png";

/***/ }),
/* 2548 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.4e31e1a6.png";

/***/ }),
/* 2549 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.97341453.png";

/***/ }),
/* 2550 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.63a0a189.png";

/***/ }),
/* 2551 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.7c28f157.png";

/***/ }),
/* 2552 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0019.abc98b43.png";

/***/ }),
/* 2553 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0020.4cfa7991.png";

/***/ }),
/* 2554 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0021.3aa02973.png";

/***/ }),
/* 2555 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0022.d924d2f5.png";

/***/ }),
/* 2556 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0023.8da49111.png";

/***/ }),
/* 2557 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0024.c2048f7f.png";

/***/ }),
/* 2558 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0025.8487eda9.png";

/***/ }),
/* 2559 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0026.2f9ac902.png";

/***/ }),
/* 2560 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0027.51161896.png";

/***/ }),
/* 2561 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0028.325eee92.png";

/***/ }),
/* 2562 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0029.81ef7f5a.png";

/***/ }),
/* 2563 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0030.5293762b.png";

/***/ }),
/* 2564 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0031.c533deb1.png";

/***/ }),
/* 2565 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0032.1a6e0061.png";

/***/ }),
/* 2566 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0033.731abfc8.png";

/***/ }),
/* 2567 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0034.c6a3dcb5.png";

/***/ }),
/* 2568 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0035.5b52a28c.png";

/***/ }),
/* 2569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0036.bf85d0e5.png";

/***/ }),
/* 2570 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0037.65a536e9.png";

/***/ }),
/* 2571 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0038.fdd7bc12.png";

/***/ }),
/* 2572 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0039.06636937.png";

/***/ }),
/* 2573 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0040.0e6a1816.png";

/***/ }),
/* 2574 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0041.3d31f7c0.png";

/***/ }),
/* 2575 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0042.33ba8f29.png";

/***/ }),
/* 2576 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0043.63a30e2f.png";

/***/ }),
/* 2577 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0044.bce375a6.png";

/***/ }),
/* 2578 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0045.2075f508.png";

/***/ }),
/* 2579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0046.c3d2bac3.png";

/***/ }),
/* 2580 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0047.e3bb09a8.png";

/***/ }),
/* 2581 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0048.c31f5d41.png";

/***/ }),
/* 2582 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.2015b44b.png";

/***/ }),
/* 2583 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.208548b0.png";

/***/ }),
/* 2584 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.d9141717.png";

/***/ }),
/* 2585 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.2ccef2b6.png";

/***/ }),
/* 2586 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.5a9f67fc.png";

/***/ }),
/* 2587 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.6bceab4d.png";

/***/ }),
/* 2588 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.3a5e0ba6.png";

/***/ }),
/* 2589 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.d07a5b0d.png";

/***/ }),
/* 2590 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.0b8494af.png";

/***/ }),
/* 2591 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.8a2bc862.png";

/***/ }),
/* 2592 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.7ed67cca.png";

/***/ }),
/* 2593 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.a2e04f8b.png";

/***/ }),
/* 2594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.23e48e3d.png";

/***/ }),
/* 2595 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.18e61f5f.png";

/***/ }),
/* 2596 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.5b685a7f.png";

/***/ }),
/* 2597 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.581e464d.png";

/***/ }),
/* 2598 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.3e695029.png";

/***/ }),
/* 2599 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.36218a8f.png";

/***/ }),
/* 2600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.ad73a1e7.png";

/***/ }),
/* 2601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0019.1c9a4a8a.png";

/***/ }),
/* 2602 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0020.541c42b2.png";

/***/ }),
/* 2603 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0021.0d73817e.png";

/***/ }),
/* 2604 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0022.fcad1c1d.png";

/***/ }),
/* 2605 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0023.f057bb3b.png";

/***/ }),
/* 2606 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0024.2c28ba1d.png";

/***/ }),
/* 2607 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0025.be0081f8.png";

/***/ }),
/* 2608 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0026.407c8bd9.png";

/***/ }),
/* 2609 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0027.3a81ba36.png";

/***/ }),
/* 2610 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0028.08e7a7cf.png";

/***/ }),
/* 2611 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0029.9ca4b150.png";

/***/ }),
/* 2612 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0030.6c5d9e3c.png";

/***/ }),
/* 2613 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0031.fa641fba.png";

/***/ }),
/* 2614 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0032.ac17ee67.png";

/***/ }),
/* 2615 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0033.b0224641.png";

/***/ }),
/* 2616 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0034.bf7cc649.png";

/***/ }),
/* 2617 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0035.9e440e5a.png";

/***/ }),
/* 2618 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0036.f95bf656.png";

/***/ }),
/* 2619 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0037.8472ea94.png";

/***/ }),
/* 2620 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0038.48eb558e.png";

/***/ }),
/* 2621 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0039.56f80d77.png";

/***/ }),
/* 2622 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0040.51a3fdd2.png";

/***/ }),
/* 2623 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0041.e02cafe1.png";

/***/ }),
/* 2624 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0042.ee91bd41.png";

/***/ }),
/* 2625 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0043.c731cfc7.png";

/***/ }),
/* 2626 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0044.5cf8c0d2.png";

/***/ }),
/* 2627 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0045.41bd93c4.png";

/***/ }),
/* 2628 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0046.c0e91555.png";

/***/ }),
/* 2629 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0047.1a55d2ed.png";

/***/ }),
/* 2630 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0048.58fe3096.png";

/***/ }),
/* 2631 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0001.26e8daef.png";

/***/ }),
/* 2632 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0002.9f3c4cb3.png";

/***/ }),
/* 2633 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0003.c12995d8.png";

/***/ }),
/* 2634 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0004.4d8a6755.png";

/***/ }),
/* 2635 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0005.855ba967.png";

/***/ }),
/* 2636 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0006.840ff42c.png";

/***/ }),
/* 2637 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0007.0b7b7f8f.png";

/***/ }),
/* 2638 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0008.09a5b2b2.png";

/***/ }),
/* 2639 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0009.836d9254.png";

/***/ }),
/* 2640 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0010.3ac2da62.png";

/***/ }),
/* 2641 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0011.4e74453c.png";

/***/ }),
/* 2642 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0012.cd36f244.png";

/***/ }),
/* 2643 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0013.6a6aee87.png";

/***/ }),
/* 2644 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0014.31082d4d.png";

/***/ }),
/* 2645 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0015.f80f3aaa.png";

/***/ }),
/* 2646 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0016.c8c756c9.png";

/***/ }),
/* 2647 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0017.ed82b64d.png";

/***/ }),
/* 2648 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0018.1fa73ce7.png";

/***/ }),
/* 2649 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0019.a46f1789.png";

/***/ }),
/* 2650 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0020.10d06976.png";

/***/ }),
/* 2651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0021.a699a63e.png";

/***/ }),
/* 2652 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0022.99b0f291.png";

/***/ }),
/* 2653 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0023.309f7c50.png";

/***/ }),
/* 2654 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0024.45574311.png";

/***/ }),
/* 2655 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0025.c9a68d7c.png";

/***/ }),
/* 2656 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0026.b3f2e7d2.png";

/***/ }),
/* 2657 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0027.5b5395f5.png";

/***/ }),
/* 2658 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0028.af818f86.png";

/***/ }),
/* 2659 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0029.2fb9f9ba.png";

/***/ }),
/* 2660 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0030.d4c6f155.png";

/***/ }),
/* 2661 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0031.0d26291d.png";

/***/ }),
/* 2662 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0032.993694f7.png";

/***/ }),
/* 2663 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0033.191499ee.png";

/***/ }),
/* 2664 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0034.ad3ee451.png";

/***/ }),
/* 2665 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0035.dadff5f9.png";

/***/ }),
/* 2666 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0036.4ae22907.png";

/***/ }),
/* 2667 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0037.94a70ae6.png";

/***/ }),
/* 2668 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0038.86417369.png";

/***/ }),
/* 2669 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0039.9d8f4dbf.png";

/***/ }),
/* 2670 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0040.706251c2.png";

/***/ }),
/* 2671 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0041.ef35f129.png";

/***/ }),
/* 2672 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0042.ff6d8959.png";

/***/ }),
/* 2673 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0043.ba467d92.png";

/***/ }),
/* 2674 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0044.ee0532da.png";

/***/ }),
/* 2675 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0045.cfb9936c.png";

/***/ }),
/* 2676 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0046.be390aa9.png";

/***/ }),
/* 2677 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0047.87632f34.png";

/***/ }),
/* 2678 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/0048.2ef989b4.png";

/***/ }),
/* 2679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AluKHeader__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_regions_json__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_regions_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_regions_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_home_handle_picture_jpg__ = __webpack_require__(2680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_home_handle_picture_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_home_handle_picture_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RegionPicker_css__ = __webpack_require__(2681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RegionPicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__RegionPicker_css__);
var _this=this;// This is a fallback component. It should not be used as Alu K
// directly points at routes with regions
var RegionPicker=function RegionPicker(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["a" /* I18n */],null,function(t,_ref){var i18n=_ref.i18n;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AluKHeader__["a" /* default */],{key:'aluk-header'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__assets_images_home_handle_picture_jpg___default.a,alt:'Alu K',key:'splashImage',className:'splash'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'region-picker',key:'regions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,t('regionPicker.chooseArea')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'continents'},__WEBPACK_IMPORTED_MODULE_4__config_regions_json___default.a.map(function(_ref2){var continent=_ref2.continent,countries=_ref2.countries;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'continent',key:continent},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,continent),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,countries.map(function(country){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:country.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/'+country.id,onClick:function onClick(){return _this.setRegion(country);}},country.name));})));})))];});};/* harmony default export */ __webpack_exports__["a"] = (RegionPicker);

/***/ }),
/* 2680 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/home-handle-picture.e9dc8b5b.jpg";

/***/ }),
/* 2681 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_i18next__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AluKHeader__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_videos_aluk_mp4__ = __webpack_require__(2683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_videos_aluk_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_videos_aluk_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_regions__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_regions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config_regions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_i18n__ = __webpack_require__(33);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Video=function(_React$Component){_inherits(Video,_React$Component);function Video(props){_classCallCheck(this,Video);// Init from parent
var _this=_possibleConstructorReturn(this,(Video.__proto__||Object.getPrototypeOf(Video)).call(this,props));_this.handles=props.handles;_this.region=props.region;// Or standalone call (first step before configurator)
if(typeof props.match!=='undefined'){// Init i18n
var region=props.match.params.region;_this.region=region;var lang=void 0;__WEBPACK_IMPORTED_MODULE_5__config_regions___default.a.forEach(function(continent){var r=continent.countries.find(function(c){return c.id===region;});if(typeof r!=='undefined'){lang=r.lang;_this.handles=__webpack_require__(55)("./"+r.colorSet+'.json');}});__WEBPACK_IMPORTED_MODULE_6__config_i18n__["a" /* default */].changeLanguage(lang);}return _this;}_createClass(Video,[{key:'render',value:function render(){var match=this.props.match;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_i18next__["a" /* I18n */],null,function(t,_ref){var i18n=_ref.i18n;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AluKHeader__["a" /* default */],{key:'aluk-header'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{key:'bg-video',preload:'auto',playsInline:true,autoPlay:true,muted:true,loop:true,style:{maxWidth:'100%',maxHeight:'60%',marginLeft:'50%',transform:'translateX(-50%)'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_4__assets_videos_aluk_mp4___default.a,type:'video/mp4'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{key:'to-handle-picker-link',to:'/'+match.params.region+'/novae',className:'configurator-red-button center-block'},t('configurator.configureNow'))];})];}}]);return Video;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Video);/*
const Video = ({ match }) => (
  <I18n>
    {(t, { i18n }) => [
      <AluKHeader key='aluk-header' />,
      <video
        key='bg-video'
        preload='auto'
        playsInline
        autoPlay
        muted
        loop
        style={{
          maxWidth: '100%',
          maxHeight: '60%',
          marginLeft: '50%',
          transform: 'translateX(-50%)'
        }}
      >
        <source src={backGroundVideo} type='video/mp4' />
      </video>,
      <Link
        key='to-handle-picker-link'
        to={'/' + match.params.region + '/novae'}
        className='configurator-red-button center-block'
      >
        {t('configurator.configureNow')}
      </Link>
    ]}
  </I18n>
)
*/

/***/ }),
/* 2683 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aluk.5e4c41f3.mp4";

/***/ }),
/* 2684 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.bc15f8e8.js